import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any; }
  /** Represents untyped JSON */
  JSON: { input: any; output: any; }
};

export type AccountInvitationByToken = {
  __typename?: 'AccountInvitationByToken';
  activationType: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  expired: Scalars['Boolean']['output'];
  firmName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  languageCode: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  requiresAgreement: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
};

export type AccountInvitationByTokenPayload = {
  __typename?: 'AccountInvitationByTokenPayload';
  errs: Array<Scalars['String']['output']>;
  invitation: Maybe<AccountInvitationByToken>;
};

/** Autogenerated input type of AddComment */
export type AddCommentInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commentKind: CommentKindEnum;
  itemKind: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  targetId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddComment. */
export type AddCommentPayload = {
  __typename?: 'AddCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  commentBase: Maybe<CommentBase>;
  errors: Array<Scalars['String']['output']>;
};

export type Address = {
  __typename?: 'Address';
  address: Scalars['String']['output'];
  building: Scalars['String']['output'];
  country: Maybe<Country>;
  countryId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
  state: Maybe<State>;
  stateId: Maybe<Scalars['ID']['output']>;
  zipCode: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  address: Scalars['String']['input'];
  building?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  stateId?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  adminUserGroups: Maybe<Array<AdminUserGroup>>;
  email: Scalars['String']['output'];
  employee: Maybe<Employee>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** The connection type for AdminUser. */
export type AdminUserConnection = {
  __typename?: 'AdminUserConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AdminUserEdge>>>;
  /** A list of nodes. */
  nodes: Array<AdminUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminUserEdge = {
  __typename?: 'AdminUserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<AdminUser>;
};

export type AdminUserGroup = {
  __typename?: 'AdminUserGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Announcement = {
  __typename?: 'Announcement';
  applicantUser: AdminUser;
  applicantUserId: Scalars['Int']['output'];
  attachments: Array<Attachment>;
  body: Scalars['String']['output'];
  confirmationDeadline: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdUserId: Scalars['Int']['output'];
  deletedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayFrom: Scalars['ISO8601DateTime']['output'];
  displayTo: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  priority: AnnouncementPriorityEnum;
  remindThresholdDays: Scalars['Int']['output'];
  sendTargetMemo: Maybe<Scalars['String']['output']>;
  status: AnnouncementStatusEnum;
  supplierConditionKind: Scalars['Int']['output'];
  supplierUserInfoConditionKind: Scalars['Int']['output'];
  tenantId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum AnnouncementPriorityEnum {
  ANormal = 'a_normal',
  BHigh = 'b_high'
}

export enum AnnouncementStatusEnum {
  ADraft = 'a_draft',
  BPublished = 'b_published',
  CPublishEnd = 'c_publish_end'
}

export type Answer = {
  __typename?: 'Answer';
  answerExcelAttachments: Array<AnswerExcelAttachment>;
  answerFacilityCosts: Array<AnswerFacilityCost>;
  answerInquiries: Array<AnswerInquiry>;
  answerItems: Array<AnswerItem>;
  answerOriginalFiles: Array<AnswerOriginalFile>;
  answerPrices: Array<AnswerPrice>;
  answerSupplyChainItemDetails: Array<AnswerSupplyChainItemDetail>;
  attachments: Array<Attachment>;
  currency: Maybe<Currency>;
  currencyExchangeNote: Maybe<Scalars['String']['output']>;
  currencyId: Scalars['ID']['output'];
  dayType: Maybe<Scalars['String']['output']>;
  /** 辞退理由。辞退の回答のときだけ入る（備考は memo） */
  declineReason: Maybe<Scalars['String']['output']>;
  expirationDate: Maybe<Scalars['String']['output']>;
  expiredAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  facilityCost: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  inputKind: Scalars['String']['output'];
  isDirect: Scalars['Boolean']['output'];
  isFileAnswer: Scalars['Boolean']['output'];
  isSupplierFileAnswer: Scalars['Boolean']['output'];
  memo: Maybe<Scalars['String']['output']>;
  quotationContext: Maybe<QuotationContext>;
  quotationCopiedFrom: Maybe<Quotation>;
  quotationNo: Maybe<Scalars['String']['output']>;
  quotationRequest: QuotationRequest;
  status: Scalars['String']['output'];
  statusLabel: Scalars['String']['output'];
  supplierAccount: Maybe<SupplierAccount>;
  supplierCorporationAttachments: Array<Attachment>;
  supplierUser: Maybe<SupplierUser>;
  wholesalerKnowledges: Array<WholesalerKnowledge>;
};

/** Autogenerated input type of AnswerByAttachmentFile */
export type AnswerByAttachmentFileInput = {
  answerInquiries: Array<CommonAnswerInquiryInput>;
  attachment: CommonAttachmentInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  quotationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of AnswerByAttachmentFile. */
export type AnswerByAttachmentFilePayload = {
  __typename?: 'AnswerByAttachmentFilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  quotation: Quotation;
};

/** Autogenerated input type of AnswerByFile */
export type AnswerByFileInput = {
  answerByFileInput: CommonAnswerByFileInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AnswerByFile. */
export type AnswerByFilePayload = {
  __typename?: 'AnswerByFilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
  isSuccess: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AnswerCalc */
export type AnswerCalcInput = {
  answerCalcInput: CommonAnswerCalcInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AnswerCalc. */
export type AnswerCalcPayload = {
  __typename?: 'AnswerCalcPayload';
  answerCalcResult: CommonAnswerCalcResult;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type AnswerExcelAttachment = {
  __typename?: 'AnswerExcelAttachment';
  attachment: Maybe<Attachment>;
  id: Maybe<Scalars['ID']['output']>;
  quotationItemId: Maybe<Scalars['ID']['output']>;
  resultMessage: Maybe<Scalars['String']['output']>;
  supplierCorporationAttachment: Maybe<Attachment>;
};

/** Autogenerated input type of AnswerExcelImportV2 */
export type AnswerExcelImportV2Input = {
  attachments: Array<CommonAttachmentInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  quotationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of AnswerExcelImportV2. */
export type AnswerExcelImportV2Payload = {
  __typename?: 'AnswerExcelImportV2Payload';
  answerExcelResult: Maybe<AnswerExcelResultV2>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  warnings: Array<Scalars['String']['output']>;
};

export type AnswerExcelItemToAnswerV2 = {
  __typename?: 'AnswerExcelItemToAnswerV2';
  answerPrice: Maybe<AnswerPriceExcelResultV2>;
  childAnswerPrices: Array<AnswerPriceExcelResultV2>;
  isDuplicate: Scalars['Boolean']['output'];
  quantity: Scalars['Float']['output'];
  quantityGroup: Scalars['String']['output'];
  quotationItem: QuotationItemV2;
  quotationItemAssemblyEntity: Maybe<QuotationItemAssemblyEntity>;
  rootQuotationItemId: Scalars['ID']['output'];
  seq: Scalars['Int']['output'];
  totalQuantityOnBranch: Scalars['Float']['output'];
};

/** Autogenerated input type of AnswerExcelMultipleImport */
export type AnswerExcelMultipleImportInput = {
  attachments: Array<CommonAttachmentInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isValidateOnly?: InputMaybe<Scalars['Boolean']['input']>;
  referenceAttachments?: InputMaybe<Array<CommonAttachmentInput>>;
  tenantId: Scalars['ID']['input'];
};

/** Autogenerated return type of AnswerExcelMultipleImport. */
export type AnswerExcelMultipleImportPayload = {
  __typename?: 'AnswerExcelMultipleImportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  results: Array<AnswerExcelMultipleImportResult>;
};

export type AnswerExcelMultipleImportResult = {
  __typename?: 'AnswerExcelMultipleImportResult';
  attachmentIndex: Maybe<Scalars['Int']['output']>;
  errors: Array<Scalars['String']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  itemToAnswer: Maybe<Array<AnswerExcelItemToAnswerV2>>;
  quotationUid: Maybe<Scalars['String']['output']>;
  warnings: Array<Scalars['String']['output']>;
};

export type AnswerExcelResultAnswerV2 = {
  __typename?: 'AnswerExcelResultAnswerV2';
  answerFacilityCosts: Array<AnswerFacilityCost>;
  answerItems: Array<AnswerItem>;
  currencyExchangeNote: Maybe<Scalars['String']['output']>;
  currencyId: Maybe<Scalars['ID']['output']>;
  dayType: Maybe<Scalars['String']['output']>;
  expirationDate: Maybe<Scalars['String']['output']>;
  facilityCost: Maybe<Scalars['Float']['output']>;
  memo: Maybe<Scalars['String']['output']>;
  quotationContext: QuotationContext;
  quotationNo: Maybe<Scalars['String']['output']>;
};

export type AnswerExcelResultV2 = {
  __typename?: 'AnswerExcelResultV2';
  answer: AnswerExcelResultAnswerV2;
  itemToAnswer: Array<AnswerExcelItemToAnswerV2>;
  quotationCopiedFrom: Maybe<Quotation>;
};

export type AnswerFacilityCost = {
  __typename?: 'AnswerFacilityCost';
  amortizationCost: Maybe<Scalars['Float']['output']>;
  amortizationNumber: Maybe<Scalars['Int']['output']>;
  amortizationNumberPerPeriod: Maybe<Scalars['Int']['output']>;
  amortizationPeriod: Maybe<Scalars['String']['output']>;
  amortizationPeriodAsNum: Maybe<Scalars['Int']['output']>;
  amortizationPeriodAsYear: Maybe<Scalars['Int']['output']>;
  answerProcessingCostId: Maybe<Scalars['ID']['output']>;
  cavity: Maybe<Scalars['Int']['output']>;
  facilityCost: Scalars['Float']['output'];
  facilityKind: FacilityKind;
  facilityUnitPrice: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isLend: Maybe<Scalars['Boolean']['output']>;
  leadTime: Maybe<Scalars['String']['output']>;
  maker: Maybe<Scalars['String']['output']>;
  memo: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parts: Array<Part>;
  paymentTimingKind: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['Float']['output']>;
  quotationItems: Array<QuotationItemV2>;
  recuttingCount: Maybe<Scalars['Int']['output']>;
  spec: Maybe<Scalars['String']['output']>;
};

export type AnswerFormat = {
  __typename?: 'AnswerFormat';
  answerMethod: Scalars['String']['output'];
  calculationKind: Scalars['String']['output'];
  facilityKinds: Array<FacilityKind>;
  id: Scalars['ID']['output'];
  isAnswerByFile: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  isSetScrapName: Scalars['Boolean']['output'];
  isUseAdjustment: Scalars['Boolean']['output'];
  isUseAnswerByItem: Scalars['Boolean']['output'];
  isUseCostForWeight: Scalars['Boolean']['output'];
  isUseCurrencyExchangeNote: Scalars['Boolean']['output'];
  isUseDefectCost: Scalars['Boolean']['output'];
  isUseDefectRate: Scalars['Boolean']['output'];
  isUseDeliveryBoxInformation: Scalars['Boolean']['output'];
  isUseDeliveryCost: Scalars['Boolean']['output'];
  isUseDeliveryDay: Scalars['Boolean']['output'];
  isUseDeliveryForm: Scalars['Boolean']['output'];
  isUseDepreciation: Scalars['Boolean']['output'];
  isUseEquipmentDeliveryDay: Scalars['Boolean']['output'];
  isUseGanttForDeliveryDay: Scalars['Boolean']['output'];
  isUseInitialDeliveryDay: Scalars['Boolean']['output'];
  isUseInternalPartSubtotal: Scalars['Boolean']['output'];
  isUseManagementCost: Scalars['Boolean']['output'];
  isUseMaterialCost: Scalars['Boolean']['output'];
  isUseMaterialCostAdjustment: Scalars['Boolean']['output'];
  isUseMaterialCostBasePrice: Scalars['Boolean']['output'];
  isUseMaterialCostCavity: Scalars['Boolean']['output'];
  isUseMaterialCostDetail: Scalars['Boolean']['output'];
  isUseMaterialCostHeight: Scalars['Boolean']['output'];
  isUseMaterialCostMeasure: Scalars['Boolean']['output'];
  isUseMaterialCostMemo: Scalars['Boolean']['output'];
  isUseMaterialCostProcurementKind: Scalars['Boolean']['output'];
  isUseMaterialCostThickness: Scalars['Boolean']['output'];
  isUseMaterialCostWeightAfterProcess: Scalars['Boolean']['output'];
  isUseMaterialCostWeightBeforeProcess: Scalars['Boolean']['output'];
  isUseMaterialCostWidth: Scalars['Boolean']['output'];
  isUseMaterialDeliveryDay: Scalars['Boolean']['output'];
  isUseMaterialManagementCost: Scalars['Boolean']['output'];
  isUseMaterialManagementRate: Scalars['Boolean']['output'];
  isUseMaterialScrap: Scalars['Boolean']['output'];
  isUseMaterialSize: Scalars['Boolean']['output'];
  isUseMinimumOrderQuantity: Scalars['Boolean']['output'];
  isUseMoldDeliveryDay: Scalars['Boolean']['output'];
  isUseOutSourcePartManagementRate: Scalars['Boolean']['output'];
  isUseOutSourcePartSubtotal: Scalars['Boolean']['output'];
  isUsePackingBoxInformation: Scalars['Boolean']['output'];
  isUsePackingCost: Scalars['Boolean']['output'];
  isUsePaidSupplyPartSubtotal: Scalars['Boolean']['output'];
  isUsePartsCost: Scalars['Boolean']['output'];
  isUsePartsCostDetail: Scalars['Boolean']['output'];
  isUsePartsCostMemo: Scalars['Boolean']['output'];
  isUsePartsCostPartName: Scalars['Boolean']['output'];
  isUsePartsCostPartNo: Scalars['Boolean']['output'];
  isUsePartsCostPartSpec: Scalars['Boolean']['output'];
  isUsePartsCostPartsCount: Scalars['Boolean']['output'];
  isUsePartsCostPartsUnitPrice: Scalars['Boolean']['output'];
  isUsePartsCostProcurementKind: Scalars['Boolean']['output'];
  isUsePartsCostProductionPlace: Scalars['Boolean']['output'];
  isUsePartsCostQuantity: Scalars['Boolean']['output'];
  isUsePriceEffectiveDate: Scalars['Boolean']['output'];
  isUseProcessingCost: Scalars['Boolean']['output'];
  isUseProcessingCostDetail: Scalars['Boolean']['output'];
  isUseProcessingCostEquipmentName: Scalars['Boolean']['output'];
  isUseProcessingCostMemo: Scalars['Boolean']['output'];
  isUseProcessingCostProcessingCostSubtotal: Scalars['Boolean']['output'];
  isUseProcessingCostProcessingRate: Scalars['Boolean']['output'];
  isUseProcessingCostProcessingTimeHour: Scalars['Boolean']['output'];
  isUseProcessingCostProcessingTimeMinute: Scalars['Boolean']['output'];
  isUseProcessingCostProcessingTimeSecond: Scalars['Boolean']['output'];
  isUseProcessingCostProcessingTimes: Scalars['Boolean']['output'];
  isUseProcessingCostProductionLot: Scalars['Boolean']['output'];
  isUseProcessingCostSetupCostSubtotal: Scalars['Boolean']['output'];
  isUseProcessingCostSetupRate: Scalars['Boolean']['output'];
  isUseProcessingCostSetupTimeHour: Scalars['Boolean']['output'];
  isUseProcessingCostSetupTimeMinute: Scalars['Boolean']['output'];
  isUseProcessingCostSetupTimeSecond: Scalars['Boolean']['output'];
  isUseProcessingHeadcount: Scalars['Boolean']['output'];
  isUseProcessingManagementCost: Scalars['Boolean']['output'];
  isUseProcessingManagementRate: Scalars['Boolean']['output'];
  isUseProcessingWeight: Scalars['Boolean']['output'];
  isUseProfit: Scalars['Boolean']['output'];
  isUseProfitRate: Scalars['Boolean']['output'];
  isUseQuantityPerDeliveryForm: Scalars['Boolean']['output'];
  isUseSetupInformation: Scalars['Boolean']['output'];
  isUseSubsidiaryMaterialCost: Scalars['Boolean']['output'];
  isUseSubsidiaryMaterialCostDetail: Scalars['Boolean']['output'];
  isUseSurfaceProcessingCost: Scalars['Boolean']['output'];
  isUseTrialDeliveryDay: Scalars['Boolean']['output'];
  isUseWholesalerKnowledge: Scalars['Boolean']['output'];
  makerActualPartNameHelperTxt: Maybe<Scalars['String']['output']>;
  materialCostPriceTenantUnit: Maybe<TenantUnit>;
  materialCostWeightTenantUnit: Maybe<TenantUnit>;
  memo: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  priceRegistrationFormatId: Maybe<Scalars['ID']['output']>;
  processingCostRateKind: Maybe<Scalars['String']['output']>;
  processingCostWeightTenantUnit: Maybe<TenantUnit>;
  scrap1Name: Maybe<Scalars['String']['output']>;
  scrap2Name: Maybe<Scalars['String']['output']>;
  specialProcessingDetailFormatsList: Array<CommonSpecialProcessingDetailFormat>;
  useMakerActualPartName: Scalars['String']['output'];
};

export type AnswerInquiry = {
  __typename?: 'AnswerInquiry';
  answerValueBoolean: Maybe<Scalars['Boolean']['output']>;
  answerValueNumber: Maybe<Scalars['Float']['output']>;
  answerValueString: Maybe<Scalars['String']['output']>;
  attachment: Maybe<Attachment>;
  id: Scalars['ID']['output'];
  quotationInquiry: QuotationInquiry;
  supplierCorporationAttachment: Maybe<Attachment>;
};

export type AnswerItem = {
  __typename?: 'AnswerItem';
  deliveryForm: Maybe<Scalars['String']['output']>;
  minimumOrderQuantity: Maybe<Scalars['String']['output']>;
  originLocation: Maybe<Scalars['String']['output']>;
  priceEffectiveFrom: Maybe<Scalars['ISO8601Date']['output']>;
  priceEffectiveTo: Maybe<Scalars['ISO8601Date']['output']>;
  quantityPerDeliveryForm: Maybe<Scalars['String']['output']>;
  quotationItemId: Scalars['ID']['output'];
  specMemo: Maybe<Scalars['String']['output']>;
};

export type AnswerMaterialCost = {
  __typename?: 'AnswerMaterialCost';
  adjustment: Maybe<Scalars['Float']['output']>;
  adjustmentCost: Maybe<Scalars['Float']['output']>;
  adjustmentCostMemo: Maybe<Scalars['String']['output']>;
  answerPrice: AnswerPrice;
  baseMaterialCode: Maybe<Scalars['String']['output']>;
  basePrice: Maybe<Scalars['Float']['output']>;
  blendBaseUnitCost: Maybe<Scalars['Float']['output']>;
  blendOtherMaterialName: Maybe<Scalars['String']['output']>;
  blendOtherMaterialRatio: Maybe<Scalars['Float']['output']>;
  blendOtherMaterialUnitCost: Maybe<Scalars['Float']['output']>;
  blendPrimaryMaterialName: Maybe<Scalars['String']['output']>;
  blendPrimaryMaterialRatio: Maybe<Scalars['Float']['output']>;
  blendPrimaryMaterialUnitCost: Maybe<Scalars['Float']['output']>;
  blendSecondaryMaterialName: Maybe<Scalars['String']['output']>;
  blendSecondaryMaterialRatio: Maybe<Scalars['Float']['output']>;
  blendSecondaryMaterialUnitCost: Maybe<Scalars['Float']['output']>;
  blendUnitCostMarkupRatio: Maybe<Scalars['Float']['output']>;
  cavity: Maybe<Scalars['Int']['output']>;
  height: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  lossGateCost: Maybe<Scalars['Float']['output']>;
  lossGateUnitUsage: Maybe<Scalars['Float']['output']>;
  lossOtherCost: Maybe<Scalars['Float']['output']>;
  lossOtherMemo: Maybe<Scalars['String']['output']>;
  lossOtherUnitUsage: Maybe<Scalars['Float']['output']>;
  lossPurgeCost: Maybe<Scalars['Float']['output']>;
  lossPurgeLotCount: Maybe<Scalars['Int']['output']>;
  lossPurgeTotalWeight: Maybe<Scalars['Float']['output']>;
  lossPurgeUnitUsage: Maybe<Scalars['Float']['output']>;
  lossRunnerCost: Maybe<Scalars['Float']['output']>;
  lossRunnerUnitUsage: Maybe<Scalars['Float']['output']>;
  lossTotalCost: Maybe<Scalars['Float']['output']>;
  lossTotalUnitUsage: Maybe<Scalars['Float']['output']>;
  materialCost: Scalars['Float']['output'];
  materialCostPerQty: Maybe<Scalars['Float']['output']>;
  materialCostSubtotal: Maybe<Scalars['Float']['output']>;
  materialCostSubtotalPerQty: Maybe<Scalars['Float']['output']>;
  materialName: Scalars['String']['output'];
  measure: Maybe<Scalars['String']['output']>;
  memo: Maybe<Scalars['String']['output']>;
  priceTenantUnit: Maybe<TenantUnit>;
  procurementKind: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['Float']['output']>;
  scrap1Name: Maybe<Scalars['String']['output']>;
  scrap1Subtotal: Maybe<Scalars['Float']['output']>;
  scrap1SubtotalPerQty: Maybe<Scalars['Float']['output']>;
  scrap1UnitPrice: Maybe<Scalars['Float']['output']>;
  scrap1Weight: Maybe<Scalars['Float']['output']>;
  scrap2Name: Maybe<Scalars['String']['output']>;
  scrap2Subtotal: Maybe<Scalars['Float']['output']>;
  scrap2SubtotalPerQty: Maybe<Scalars['Float']['output']>;
  scrap2UnitPrice: Maybe<Scalars['Float']['output']>;
  scrap2Weight: Maybe<Scalars['Float']['output']>;
  scrapValueSubtotal: Maybe<Scalars['Float']['output']>;
  scrapValueSubtotalPerQty: Maybe<Scalars['Float']['output']>;
  seqNo: Scalars['Int']['output'];
  thickness: Maybe<Scalars['Float']['output']>;
  trialShotCost: Maybe<Scalars['Float']['output']>;
  trialShotUnitUsage: Maybe<Scalars['Float']['output']>;
  weightAfterProcess: Maybe<Scalars['Float']['output']>;
  weightBeforeProcess: Maybe<Scalars['Float']['output']>;
  weightTenantUnit: Maybe<TenantUnit>;
  width: Maybe<Scalars['Float']['output']>;
};

export type AnswerOriginalFile = {
  __typename?: 'AnswerOriginalFile';
  attachment: Maybe<Attachment>;
  supplierCorporationAttachment: Maybe<Attachment>;
};

export type AnswerPartsCost = {
  __typename?: 'AnswerPartsCost';
  answerPrice: AnswerPrice;
  id: Scalars['ID']['output'];
  memo: Maybe<Scalars['String']['output']>;
  part: Maybe<Part>;
  partName: Maybe<Scalars['String']['output']>;
  partNo: Maybe<Scalars['String']['output']>;
  partSpec: Maybe<Scalars['String']['output']>;
  partsCost: Scalars['Float']['output'];
  partsCount: Maybe<Scalars['Int']['output']>;
  partsUnitPrice: Maybe<Scalars['Float']['output']>;
  procurementKind: Maybe<Scalars['String']['output']>;
  productionPlace: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['Float']['output']>;
  seqNo: Scalars['Int']['output'];
};

export type AnswerPrice = {
  __typename?: 'AnswerPrice';
  adjustment: Maybe<Scalars['Float']['output']>;
  amountExcludingTax: Maybe<Scalars['String']['output']>;
  /** 内税のときだけ返す税込の総額（開き直したとき、入力した税込の金額に戻す用）。内税以外・未回答は null */
  amountIncludingTax: Maybe<Scalars['String']['output']>;
  answer: Answer;
  answerMaterialCosts: Array<AnswerMaterialCost>;
  answerPartsCosts: Array<AnswerPartsCost>;
  answerProcessingCosts: Array<AnswerProcessingCost>;
  answerSpecialProcessingCosts: Array<CommonAnswerSpecialProcessingCost>;
  answerSubsidiaryMaterialCosts: Array<CommonAnswerSubsidiaryMaterialCost>;
  answerSupplySubparts: Array<CommonAnswerSupplySubpart>;
  answerSurfaceProcessingCosts: Array<CommonAnswerSpecialProcessingCost>;
  boxCount: Maybe<Scalars['Int']['output']>;
  defectCost: Maybe<Scalars['Float']['output']>;
  defectRate: Maybe<Scalars['Float']['output']>;
  deliveryCost: Maybe<Scalars['Float']['output']>;
  deliveryCostPerBox: Maybe<Scalars['Float']['output']>;
  deliveryDay: Maybe<Scalars['Int']['output']>;
  depreciation: Maybe<Scalars['Float']['output']>;
  designCost: Maybe<Scalars['Float']['output']>;
  equipmentDeliveryDay: Maybe<Scalars['Int']['output']>;
  equipmentDeliveryStartDay: Maybe<Scalars['Int']['output']>;
  facilityCost: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  initialDeliveryDay: Maybe<Scalars['Int']['output']>;
  internalPartSubtotal: Maybe<Scalars['Float']['output']>;
  isDeclined: Scalars['Boolean']['output'];
  jigManagementCost: Maybe<Scalars['Float']['output']>;
  managementCost: Maybe<Scalars['Float']['output']>;
  materialCost: Maybe<Scalars['Float']['output']>;
  materialDeliveryDay: Maybe<Scalars['Int']['output']>;
  materialDeliveryStartDay: Maybe<Scalars['Int']['output']>;
  materialManagementCost: Maybe<Scalars['Float']['output']>;
  materialManagementRate: Maybe<Scalars['Float']['output']>;
  moldDeliveryDay: Maybe<Scalars['Int']['output']>;
  moldDeliveryStartDay: Maybe<Scalars['Int']['output']>;
  outSourcePartManagementRate: Maybe<Scalars['Float']['output']>;
  outSourcePartSubtotal: Maybe<Scalars['Float']['output']>;
  packingCost: Maybe<Scalars['Float']['output']>;
  packingCostPerBox: Maybe<Scalars['Float']['output']>;
  paidSupplyPartSubtotal: Maybe<Scalars['Float']['output']>;
  partsCost: Maybe<Scalars['Float']['output']>;
  priceBasis: Scalars['String']['output'];
  processingCost: Maybe<Scalars['Float']['output']>;
  processingManagementCost: Maybe<Scalars['Float']['output']>;
  processingManagementRate: Maybe<Scalars['Float']['output']>;
  profit: Maybe<Scalars['Float']['output']>;
  profitRate: Maybe<Scalars['Float']['output']>;
  propertyRentCost: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Float']['output'];
  quantityFrom: Scalars['Float']['output'];
  quantityInOneBox: Maybe<Scalars['Int']['output']>;
  quantityTo: Maybe<Scalars['Float']['output']>;
  quotationItemChildStructId: Maybe<Scalars['ID']['output']>;
  quotationItemId: Scalars['ID']['output'];
  subsidiaryMaterialCost: Maybe<Scalars['Float']['output']>;
  subsidiaryMaterialManagementCost: Maybe<Scalars['Float']['output']>;
  subsidiaryMaterialManagementRate: Maybe<Scalars['Float']['output']>;
  surfaceProcessingCost: Maybe<Scalars['Float']['output']>;
  /** 税区分 0外税 1内税 2非課税 3不課税 */
  taxType: Scalars['Int']['output'];
  trialDeliveryDay: Maybe<Scalars['Int']['output']>;
  trialDeliveryStartDay: Maybe<Scalars['Int']['output']>;
  unitPrice: Maybe<Scalars['Float']['output']>;
};

export type AnswerPriceExcelResultV2 = {
  __typename?: 'AnswerPriceExcelResultV2';
  adjustment: Maybe<Scalars['Float']['output']>;
  answerMaterialCosts: Array<AnswerMaterialCost>;
  answerPartsCosts: Array<AnswerPartsCost>;
  answerProcessingCosts: Array<AnswerProcessingCost>;
  answerSpecialProcessingCosts: Array<CommonAnswerSpecialProcessingCost>;
  answerSubsidiaryMaterialCosts: Array<CommonAnswerSubsidiaryMaterialCost>;
  boxCount: Maybe<Scalars['Int']['output']>;
  defectCost: Maybe<Scalars['Float']['output']>;
  defectRate: Maybe<Scalars['Float']['output']>;
  deliveryCost: Maybe<Scalars['Float']['output']>;
  deliveryCostPerBox: Maybe<Scalars['Float']['output']>;
  deliveryDay: Maybe<Scalars['Int']['output']>;
  depreciation: Maybe<Scalars['Float']['output']>;
  designCost: Maybe<Scalars['Float']['output']>;
  equipmentDeliveryDay: Maybe<Scalars['Int']['output']>;
  equipmentDeliveryStartDay: Maybe<Scalars['Int']['output']>;
  facilityCost: Maybe<Scalars['Float']['output']>;
  initialDeliveryDay: Maybe<Scalars['Int']['output']>;
  internalPartSubtotal: Maybe<Scalars['Float']['output']>;
  jigManagementCost: Maybe<Scalars['Float']['output']>;
  managementCost: Maybe<Scalars['Float']['output']>;
  materialCost: Maybe<Scalars['Float']['output']>;
  materialDeliveryDay: Maybe<Scalars['Int']['output']>;
  materialDeliveryStartDay: Maybe<Scalars['Int']['output']>;
  materialManagementCost: Maybe<Scalars['Float']['output']>;
  materialManagementRate: Maybe<Scalars['Float']['output']>;
  moldDeliveryDay: Maybe<Scalars['Int']['output']>;
  moldDeliveryStartDay: Maybe<Scalars['Int']['output']>;
  outSourcePartManagementRate: Maybe<Scalars['Float']['output']>;
  outSourcePartSubtotal: Maybe<Scalars['Float']['output']>;
  packingCost: Maybe<Scalars['Float']['output']>;
  packingCostPerBox: Maybe<Scalars['Float']['output']>;
  paidSupplyPartSubtotal: Maybe<Scalars['Float']['output']>;
  partId: Maybe<Scalars['ID']['output']>;
  partRelatedFacilityCost: Maybe<Scalars['Float']['output']>;
  partsCost: Maybe<Scalars['Float']['output']>;
  processingCost: Maybe<Scalars['Float']['output']>;
  processingManagementCost: Maybe<Scalars['Float']['output']>;
  processingManagementRate: Maybe<Scalars['Float']['output']>;
  profit: Maybe<Scalars['Float']['output']>;
  profitRate: Maybe<Scalars['Float']['output']>;
  propertyRentCost: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Float']['output'];
  quantityInOneBox: Maybe<Scalars['Int']['output']>;
  quotationItemChildStructId: Maybe<Scalars['ID']['output']>;
  quotationItemId: Scalars['ID']['output'];
  subsidiaryMaterialCost: Maybe<Scalars['Float']['output']>;
  subsidiaryMaterialManagementCost: Maybe<Scalars['Float']['output']>;
  subsidiaryMaterialManagementRate: Maybe<Scalars['Float']['output']>;
  surfaceProcessingCost: Maybe<Scalars['Float']['output']>;
  trialDeliveryDay: Maybe<Scalars['Int']['output']>;
  trialDeliveryStartDay: Maybe<Scalars['Int']['output']>;
  unitPrice: Maybe<Scalars['Float']['output']>;
};

export type AnswerProcessingCost = {
  __typename?: 'AnswerProcessingCost';
  answerFacilityCost: Maybe<AnswerFacilityCost>;
  answerPrice: AnswerPrice;
  costForWeight: Maybe<Scalars['Float']['output']>;
  equipmentName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  memo: Maybe<Scalars['String']['output']>;
  partCostRatio: Maybe<Scalars['Float']['output']>;
  processName: Scalars['String']['output'];
  processOutsourcingKind: Maybe<Scalars['String']['output']>;
  processingCost: Scalars['Float']['output'];
  processingCostPerLot: Maybe<Scalars['Float']['output']>;
  processingCostSubtotal: Maybe<Scalars['Float']['output']>;
  processingCostSubtotalPerLot: Maybe<Scalars['Float']['output']>;
  processingHeadcount: Maybe<Scalars['Int']['output']>;
  processingRate: Maybe<Scalars['Float']['output']>;
  processingTimeHour: Maybe<Scalars['Float']['output']>;
  processingTimeMinute: Maybe<Scalars['Float']['output']>;
  processingTimeSecond: Maybe<Scalars['Float']['output']>;
  processingTimes: Maybe<Scalars['Int']['output']>;
  processingWeight: Maybe<Scalars['Float']['output']>;
  productionLot: Maybe<Scalars['Int']['output']>;
  rateKind: Maybe<Scalars['String']['output']>;
  seqNo: Scalars['Int']['output'];
  setupCostSubtotal: Maybe<Scalars['Float']['output']>;
  setupCostSubtotalPerLot: Maybe<Scalars['Float']['output']>;
  setupRate: Maybe<Scalars['Float']['output']>;
  setupTimeHour: Maybe<Scalars['Float']['output']>;
  setupTimeMinute: Maybe<Scalars['Float']['output']>;
  setupTimeSecond: Maybe<Scalars['Float']['output']>;
  weightTenantUnit: Maybe<TenantUnit>;
};

export type AnswerSupplyChainItemDetail = {
  __typename?: 'AnswerSupplyChainItemDetail';
  address: Maybe<Address>;
  answerId: Maybe<Scalars['ID']['output']>;
  factoryName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  isAlternative: Maybe<Scalars['Boolean']['output']>;
  isNew: Maybe<Scalars['Boolean']['output']>;
  note: Maybe<Scalars['String']['output']>;
  partSupplyChainItemId: Maybe<Scalars['ID']['output']>;
  processName: Maybe<Scalars['String']['output']>;
  quotationItemId: Maybe<Scalars['ID']['output']>;
  supplierName: Maybe<Scalars['String']['output']>;
  tenantId: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of AnswerToGeneralEnquete */
export type AnswerToGeneralEnqueteInput = {
  answers: Array<EnqueteQuestionAnswerInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enqueteAnswerId: Scalars['ID']['input'];
  mode: EnqueteAnswerModeEnum;
};

/** Autogenerated return type of AnswerToGeneralEnquete. */
export type AnswerToGeneralEnquetePayload = {
  __typename?: 'AnswerToGeneralEnquetePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  enqueteAnswer: Maybe<EnqueteAnswer>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of AnswerUpdateV2 */
export type AnswerUpdateV2Input = {
  answer: CommonAnswerInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AnswerUpdateV2. */
export type AnswerUpdateV2Payload = {
  __typename?: 'AnswerUpdateV2Payload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
  quotation: Quotation;
};

export type AnswerUpsertChildFormError = {
  __typename?: 'AnswerUpsertChildFormError';
  errors: Array<InputFormError>;
  structId: Scalars['ID']['output'];
};

/** Autogenerated input type of AnswerUpsert */
export type AnswerUpsertInput = {
  answer: CommonAnswerUpsertInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AnswerUpsert. */
export type AnswerUpsertPayload = {
  __typename?: 'AnswerUpsertPayload';
  childErrors: Maybe<Array<AnswerUpsertChildFormError>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<InputFormError>>;
  isCanBeAnswered: Scalars['Boolean']['output'];
  isSuccess: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AnswerUpsertValidate */
export type AnswerUpsertValidateInput = {
  answer: CommonAnswerUpsertInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AnswerUpsertValidate. */
export type AnswerUpsertValidatePayload = {
  __typename?: 'AnswerUpsertValidatePayload';
  childErrors: Maybe<Array<AnswerUpsertChildFormError>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<InputFormError>>;
  isCanBeAnswered: Scalars['Boolean']['output'];
  isSuccess: Scalars['Boolean']['output'];
};

export type ApplicationFormat = {
  __typename?: 'ApplicationFormat';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  isSendSelectionMail: Scalars['Boolean']['output'];
  isUseAssumedExchangeRateCny: Scalars['Boolean']['output'];
  isUseAssumedExchangeRateUsd: Scalars['Boolean']['output'];
  isUseCostBearingDolly: Scalars['Boolean']['output'];
  isUseCostBearingInitialCost: Scalars['Boolean']['output'];
  isUseDeliverySite: Scalars['Boolean']['output'];
  isUseDesignAttachment: Scalars['Boolean']['output'];
  isUseFigureNumber: Scalars['Boolean']['output'];
  isUseIsNew: Scalars['Boolean']['output'];
  isUseItemPropInfo: Scalars['Boolean']['output'];
  isUseMaker: Scalars['Boolean']['output'];
  isUseMassProductionCategory: Scalars['Boolean']['output'];
  isUseMaterialPriceReferenceDate: Scalars['Boolean']['output'];
  isUseMaterialSupplyPresence: Scalars['Boolean']['output'];
  isUsePartSupplyPresence: Scalars['Boolean']['output'];
  isUsePaymentInstallmentInitialCost: Scalars['Boolean']['output'];
  isUsePaymentMethod: Scalars['Boolean']['output'];
  isUseQcIncoterms: Scalars['Boolean']['output'];
  isUseQcRuleOfCurrencyRateChange: Scalars['Boolean']['output'];
  isUseQcRuleOfMarketChange: Scalars['Boolean']['output'];
  isUseQuotationContext: Scalars['Boolean']['output'];
  isUseReceiver: Scalars['Boolean']['output'];
  isUseRequestProcess: Scalars['Boolean']['output'];
  isUseSpecAttachment: Scalars['Boolean']['output'];
  itemProps: Array<ItemProp>;
  memo: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  productScheduleSettings: Array<ProductScheduleSetting>;
  quantityUnit: Maybe<Scalars['String']['output']>;
};

export type Attachment = {
  __typename?: 'Attachment';
  attachableId: Scalars['ID']['output'];
  attachableType: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  fileType: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nameForSupplier: Maybe<Scalars['String']['output']>;
  pdfPreviewSignedUrl: Maybe<Scalars['String']['output']>;
  seqNo: Scalars['Int']['output'];
  signedDownloadUrl: Maybe<Scalars['String']['output']>;
  signedUrl: Scalars['String']['output'];
  size: Maybe<Scalars['Int']['output']>;
  thumbnailSignedUrl: Maybe<Scalars['String']['output']>;
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  url: Scalars['String']['output'];
};

export type AttachmentInput = {
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type AttachmentOffer = {
  __typename?: 'AttachmentOffer';
  attachment: Attachment;
  designChangeCode: Maybe<Scalars['String']['output']>;
  discardDeadlineOn: Maybe<Scalars['ISO8601Date']['output']>;
  discardEvent: Maybe<AttachmentOfferEvent>;
  downloadEvents: Maybe<Array<AttachmentOfferEvent>>;
  downloadLimitCount: Maybe<Scalars['Int']['output']>;
  figureNumber: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDiscardNecessary: Scalars['Boolean']['output'];
  isDownloadable: Scalars['Boolean']['output'];
  itemCode: Maybe<Scalars['String']['output']>;
  itemName: Maybe<Scalars['String']['output']>;
  itemRootCode: Maybe<Scalars['String']['output']>;
  kind: Maybe<Scalars['String']['output']>;
  latestAcknowledgedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  memo: Maybe<Scalars['String']['output']>;
  offeredAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  originalAttachment: Attachment;
  personInChargeAdminUser: Maybe<AdminUser>;
  previewUrl: Maybe<Scalars['String']['output']>;
  purpose: Maybe<Scalars['String']['output']>;
  quotationItem: Maybe<QuotationItemV2>;
  status: Scalars['String']['output'];
  supplier: Supplier;
  tenant: Tenant;
  uid: Scalars['String']['output'];
};

export type AttachmentOfferConfig = {
  __typename?: 'AttachmentOfferConfig';
  isActiveOnQuotation: Scalars['Boolean']['output'];
  sealOpacity: Scalars['Float']['output'];
  sealPositionKind: Scalars['String']['output'];
  watermarkOpacity: Scalars['Float']['output'];
};

/** The connection type for AttachmentOffer. */
export type AttachmentOfferConnection = {
  __typename?: 'AttachmentOfferConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AttachmentOfferEdge>>>;
  /** A list of nodes. */
  nodes: Array<AttachmentOffer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of AttachmentOfferDownloadEventCreate */
export type AttachmentOfferDownloadEventCreateInput = {
  attachmentOfferId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AttachmentOfferDownloadEventCreate. */
export type AttachmentOfferDownloadEventCreatePayload = {
  __typename?: 'AttachmentOfferDownloadEventCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  downloadUrl: Maybe<Scalars['String']['output']>;
  isSuccess: Scalars['Boolean']['output'];
};

/** An edge in a connection. */
export type AttachmentOfferEdge = {
  __typename?: 'AttachmentOfferEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<AttachmentOffer>;
};

export type AttachmentOfferEvent = {
  __typename?: 'AttachmentOfferEvent';
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  kind: Maybe<Scalars['String']['output']>;
  supplierAccount: Maybe<SupplierAccount>;
  supplierUser: Maybe<SupplierUser>;
};

/** Autogenerated input type of AttachmentOffersDiscard */
export type AttachmentOffersDiscardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of AttachmentOffersDiscard. */
export type AttachmentOffersDiscardPayload = {
  __typename?: 'AttachmentOffersDiscardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  isSuccess: Scalars['Boolean']['output'];
};

export type AttachmentUploadUrl = {
  __typename?: 'AttachmentUploadUrl';
  containerName: Scalars['String']['output'];
  directory: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  uploadUrl: Scalars['ID']['output'];
};

export type BaseMaterial = {
  __typename?: 'BaseMaterial';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  outerDiameter: Maybe<Scalars['Float']['output']>;
  thickness: Maybe<Scalars['Float']['output']>;
};

/** 災害の分類。earthquake=地震 / heavy_rain_flood=大雨・洪水 */
export enum BcpDisasterKindEnum {
  Earthquake = 'EARTHQUAKE',
  HeavyRainFlood = 'HEAVY_RAIN_FLOOD'
}

export type BcpIncidentAnswerCategories = {
  __typename?: 'BcpIncidentAnswerCategories';
  buildingDamageComment: Maybe<Scalars['String']['output']>;
  buildingDamageLevel: Maybe<BcpIncidentAnswerCategoryLevelEnum>;
  deliveryImpactComment: Maybe<Scalars['String']['output']>;
  deliveryImpactLevel: Maybe<BcpIncidentAnswerCategoryLevelEnum>;
  equipmentDamageComment: Maybe<Scalars['String']['output']>;
  equipmentDamageLevel: Maybe<BcpIncidentAnswerCategoryLevelEnum>;
  humanDamageComment: Maybe<Scalars['String']['output']>;
  humanDamageLevel: Maybe<BcpIncidentAnswerCategoryLevelEnum>;
  productionImpactComment: Maybe<Scalars['String']['output']>;
  productionImpactLevel: Maybe<BcpIncidentAnswerCategoryLevelEnum>;
  supportRequest: Maybe<Scalars['String']['output']>;
};

export type BcpIncidentAnswerCategoriesInput = {
  buildingDamageComment?: InputMaybe<Scalars['String']['input']>;
  buildingDamageLevel?: InputMaybe<BcpIncidentAnswerCategoryLevelEnum>;
  deliveryImpactComment?: InputMaybe<Scalars['String']['input']>;
  deliveryImpactLevel?: InputMaybe<BcpIncidentAnswerCategoryLevelEnum>;
  equipmentDamageComment?: InputMaybe<Scalars['String']['input']>;
  equipmentDamageLevel?: InputMaybe<BcpIncidentAnswerCategoryLevelEnum>;
  humanDamageComment?: InputMaybe<Scalars['String']['input']>;
  humanDamageLevel?: InputMaybe<BcpIncidentAnswerCategoryLevelEnum>;
  productionImpactComment?: InputMaybe<Scalars['String']['input']>;
  productionImpactLevel?: InputMaybe<BcpIncidentAnswerCategoryLevelEnum>;
  supportRequest?: InputMaybe<Scalars['String']['input']>;
};

export type BcpIncidentAnswerCategoriesTokenInput = {
  buildingDamageComment?: InputMaybe<Scalars['String']['input']>;
  buildingDamageLevel?: InputMaybe<BcpIncidentAnswerCategoryLevelEnum>;
  deliveryImpactComment?: InputMaybe<Scalars['String']['input']>;
  deliveryImpactLevel?: InputMaybe<BcpIncidentAnswerCategoryLevelEnum>;
  equipmentDamageComment?: InputMaybe<Scalars['String']['input']>;
  equipmentDamageLevel?: InputMaybe<BcpIncidentAnswerCategoryLevelEnum>;
  humanDamageComment?: InputMaybe<Scalars['String']['input']>;
  humanDamageLevel?: InputMaybe<BcpIncidentAnswerCategoryLevelEnum>;
  productionImpactComment?: InputMaybe<Scalars['String']['input']>;
  productionImpactLevel?: InputMaybe<BcpIncidentAnswerCategoryLevelEnum>;
};

/** 回答の区分の段階。nothing=なし / minor=軽い / severe=重い / checking=確認中 */
export enum BcpIncidentAnswerCategoryLevelEnum {
  Checking = 'checking',
  Minor = 'minor',
  Nothing = 'nothing',
  Severe = 'severe'
}

export type BcpIncidentAnswerDraft = {
  __typename?: 'BcpIncidentAnswerDraft';
  answered: Scalars['Boolean']['output'];
  answeredAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  answeredBy: Maybe<Scalars['String']['output']>;
  asksParts: Scalars['Boolean']['output'];
  attachments: Array<Attachment>;
  categories: BcpIncidentAnswerCategories;
  detailReportEta: Maybe<Scalars['String']['output']>;
  detailReportPending: Scalars['Boolean']['output'];
  /** 災害の分類（地震／大雨・洪水）。回答画面の文言を出し分ける */
  disasterKind: BcpDisasterKindEnum;
  dueDatetime: Maybe<Scalars['ISO8601DateTime']['output']>;
  hasImpact: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  impactDetail: Maybe<Scalars['String']['output']>;
  incidentName: Scalars['String']['output'];
  incidentStatus: Maybe<BcpIncidentAnswerDraftIncidentStatusEnum>;
  isDrill: Scalars['Boolean']['output'];
  partSupplyChainSteps: Array<BcpIncidentAnswerPartSupplyChainStep>;
  parts: Array<BcpIncidentAnswerPart>;
  partsAiProposalRemaining: Scalars['Int']['output'];
  partsDecideSiteImpact: Scalars['Boolean']['output'];
  /** 前回（最新）の確定回答。答え直しの初期値に使う */
  previousAnswer: Maybe<BcpIncidentPreviousAnswer>;
  siteName: Maybe<Scalars['String']['output']>;
  tenantName: Scalars['String']['output'];
  version: Scalars['String']['output'];
};


export type BcpIncidentAnswerDraftPartSupplyChainStepsArgs = {
  partId: Scalars['ID']['input'];
};

/** BcpIncidentAnswerDraft incident_status enum */
export enum BcpIncidentAnswerDraftIncidentStatusEnum {
  Completed = 'completed',
  Dismissed = 'dismissed',
  Draft = 'draft',
  InProgress = 'in_progress'
}

export type BcpIncidentAnswerPart = {
  __typename?: 'BcpIncidentAnswerPart';
  comment: Maybe<Scalars['String']['output']>;
  figureNumber: Maybe<Scalars['String']['output']>;
  hasSupplyChain: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  impactKind: Maybe<BcpIncidentAnswerPartImpactKindEnum>;
  isConnected: Scalars['Boolean']['output'];
  partCode: Scalars['String']['output'];
  partName: Scalars['String']['output'];
  previousComment: Maybe<Scalars['String']['output']>;
  previousImpactKind: Maybe<BcpIncidentAnswerPartImpactKindEnum>;
  supplierCode: Maybe<Scalars['String']['output']>;
};

export type BcpIncidentAnswerPartAnswerInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  impactKind: BcpIncidentAnswerPartImpactKindEnum;
  partCode: Scalars['String']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
};

/** BcpIncidentAnswerDraftPart impact_kind enum */
export enum BcpIncidentAnswerPartImpactKindEnum {
  Checking = 'checking',
  Impact = 'impact',
  NoImpact = 'no_impact'
}

export type BcpIncidentAnswerPartProposal = {
  __typename?: 'BcpIncidentAnswerPartProposal';
  comment: Maybe<Scalars['String']['output']>;
  groupIndex: Scalars['Int']['output'];
  impactKind: BcpIncidentAnswerPartImpactKindEnum;
  isOverridden: Scalars['Boolean']['output'];
  partCode: Scalars['String']['output'];
  supplierCode: Maybe<Scalars['String']['output']>;
};

export type BcpIncidentAnswerPartProposalGroup = {
  __typename?: 'BcpIncidentAnswerPartProposalGroup';
  allParts: Scalars['Boolean']['output'];
  comment: Maybe<Scalars['String']['output']>;
  groupIndex: Scalars['Int']['output'];
  impactKind: Maybe<BcpIncidentAnswerPartImpactKindEnum>;
  onlyUnanswered: Scalars['Boolean']['output'];
  partCodePrefixes: Array<Scalars['String']['output']>;
  partCodes: Array<Scalars['String']['output']>;
  partNameContains: Array<Scalars['String']['output']>;
};

export type BcpIncidentAnswerPartSupplyChainStep = {
  __typename?: 'BcpIncidentAnswerPartSupplyChainStep';
  processName: Scalars['String']['output'];
  processOrder: Scalars['Int']['output'];
  siteName: Maybe<Scalars['String']['output']>;
};

export type BcpIncidentAnswerRequest = {
  __typename?: 'BcpIncidentAnswerRequest';
  /** 災害の分類（地震／大雨・洪水）。拠点の下書きに焼き付けた値 */
  disasterKind: BcpDisasterKindEnum;
  /** 依頼に含まれる拠点（下書き）。拠点名の順 */
  drafts: Array<BcpIncidentAnswerDraft>;
  dueDatetime: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 回答済みだが詳細の回答が残っている拠点の数（詳報待ち、または品目まで聞く案件で影響ありなのに品目の回答が足りない拠点）。未回答の拠点は含まない */
  firstAnswerOnlyCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  incidentName: Maybe<Scalars['String']['output']>;
  incidentStatus: Maybe<BcpIncidentAnswerDraftIncidentStatusEnum>;
  /** 担当者に結び付かない人向けの会社の仮想グループか（recipientName は null） */
  isCompanyView: Scalars['Boolean']['output'];
  isDrill: Scalars['Boolean']['output'];
  /** 宛先の担当者の名前。会社の仮想グループは null */
  recipientName: Maybe<Scalars['String']['output']>;
  requestedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  siteCount: Scalars['Int']['output'];
  tenantId: Scalars['ID']['output'];
  tenantName: Scalars['String']['output'];
  /** 最後の依頼より後に回答が無い拠点が 1 つでもあるか（TOP の未回答の判定） */
  unanswered: Scalars['Boolean']['output'];
  unansweredCount: Scalars['Int']['output'];
};

export type BcpIncidentAnswerRequestByToken = {
  __typename?: 'BcpIncidentAnswerRequestByToken';
  /** state が answerable のときだけ返す */
  request: Maybe<BcpIncidentAnswerTokenRequest>;
  requestId: Scalars['ID']['output'];
  state: BcpIncidentAnswerTokenStateEnum;
};

/** The connection type for BcpIncidentAnswerRequest. */
export type BcpIncidentAnswerRequestConnection = {
  __typename?: 'BcpIncidentAnswerRequestConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<BcpIncidentAnswerRequestEdge>>>;
  /** A list of nodes. */
  nodes: Array<BcpIncidentAnswerRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of BcpIncidentAnswerRequestDraftsSave */
export type BcpIncidentAnswerRequestDraftsSaveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  drafts: Array<BcpIncidentAnswerRequestSiteInput>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of BcpIncidentAnswerRequestDraftsSave. */
export type BcpIncidentAnswerRequestDraftsSavePayload = {
  __typename?: 'BcpIncidentAnswerRequestDraftsSavePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
  request: Maybe<BcpIncidentAnswerRequest>;
};

/** An edge in a connection. */
export type BcpIncidentAnswerRequestEdge = {
  __typename?: 'BcpIncidentAnswerRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<BcpIncidentAnswerRequest>;
};

/** Autogenerated input type of BcpIncidentAnswerRequestOpenedByToken */
export type BcpIncidentAnswerRequestOpenedByTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Autogenerated return type of BcpIncidentAnswerRequestOpenedByToken. */
export type BcpIncidentAnswerRequestOpenedByTokenPayload = {
  __typename?: 'BcpIncidentAnswerRequestOpenedByTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
};

/** Autogenerated input type of BcpIncidentAnswerRequestOpened */
export type BcpIncidentAnswerRequestOpenedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of BcpIncidentAnswerRequestOpened. */
export type BcpIncidentAnswerRequestOpenedPayload = {
  __typename?: 'BcpIncidentAnswerRequestOpenedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
};

export type BcpIncidentAnswerRequestPartProposals = {
  __typename?: 'BcpIncidentAnswerRequestPartProposals';
  draftId: Scalars['ID']['output'];
  proposals: Array<BcpIncidentAnswerPartProposal>;
};

/** Autogenerated input type of BcpIncidentAnswerRequestPartsPropose */
export type BcpIncidentAnswerRequestPartsProposeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  situationText: Scalars['String']['input'];
};

/** Autogenerated return type of BcpIncidentAnswerRequestPartsPropose. */
export type BcpIncidentAnswerRequestPartsProposePayload = {
  __typename?: 'BcpIncidentAnswerRequestPartsProposePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
  remainingCount: Scalars['Int']['output'];
  siteProposals: Array<BcpIncidentAnswerRequestPartProposals>;
  unmatchedGroups: Array<BcpIncidentAnswerPartProposalGroup>;
  unreadInstructions: Array<Scalars['String']['output']>;
  unreadableAttachmentNames: Array<Scalars['String']['output']>;
};

export type BcpIncidentAnswerRequestSiteInput = {
  /** null は添付を触らない。配列は全置換 */
  attachments?: InputMaybe<Array<AttachmentInput>>;
  /** 区分別の回答。納入影響から影響の有無を決める。入力にあるキーだけ上書きし、無いキーは前の値のまま */
  categories: BcpIncidentAnswerCategoriesInput;
  detailReportEta?: InputMaybe<Scalars['String']['input']>;
  draftId: Scalars['ID']['input'];
  impactDetail?: InputMaybe<Scalars['String']['input']>;
  partAnswers?: InputMaybe<Array<BcpIncidentAnswerPartAnswerInput>>;
  /** 画面が読んだときの下書きの版（BcpIncidentAnswerDraft.version）。他で更新されていれば競合 */
  version: Scalars['String']['input'];
};

/** Autogenerated input type of BcpIncidentAnswerRequestSubmitByToken */
export type BcpIncidentAnswerRequestSubmitByTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  drafts: Array<BcpIncidentAnswerRequestTokenSiteInput>;
  token: Scalars['String']['input'];
};

/** Autogenerated return type of BcpIncidentAnswerRequestSubmitByToken. */
export type BcpIncidentAnswerRequestSubmitByTokenPayload = {
  __typename?: 'BcpIncidentAnswerRequestSubmitByTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
  state: Maybe<BcpIncidentAnswerTokenStateEnum>;
};

/** Autogenerated input type of BcpIncidentAnswerRequestSubmit */
export type BcpIncidentAnswerRequestSubmitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  drafts: Array<BcpIncidentAnswerRequestSiteInput>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of BcpIncidentAnswerRequestSubmit. */
export type BcpIncidentAnswerRequestSubmitPayload = {
  __typename?: 'BcpIncidentAnswerRequestSubmitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
  request: Maybe<BcpIncidentAnswerRequest>;
};

export type BcpIncidentAnswerRequestTokenSiteInput = {
  /** 5 区分（人的被害・建屋・設備・生産・納入影響）。納入影響から影響の有無を決める */
  categories: BcpIncidentAnswerCategoriesTokenInput;
  detailReportEta?: InputMaybe<Scalars['String']['input']>;
  draftId: Scalars['ID']['input'];
  impactDetail?: InputMaybe<Scalars['String']['input']>;
};

export type BcpIncidentAnswerTokenCategories = {
  __typename?: 'BcpIncidentAnswerTokenCategories';
  buildingDamageComment: Maybe<Scalars['String']['output']>;
  buildingDamageLevel: Maybe<BcpIncidentAnswerCategoryLevelEnum>;
  deliveryImpactComment: Maybe<Scalars['String']['output']>;
  deliveryImpactLevel: Maybe<BcpIncidentAnswerCategoryLevelEnum>;
  equipmentDamageComment: Maybe<Scalars['String']['output']>;
  equipmentDamageLevel: Maybe<BcpIncidentAnswerCategoryLevelEnum>;
  humanDamageComment: Maybe<Scalars['String']['output']>;
  humanDamageLevel: Maybe<BcpIncidentAnswerCategoryLevelEnum>;
  productionImpactComment: Maybe<Scalars['String']['output']>;
  productionImpactLevel: Maybe<BcpIncidentAnswerCategoryLevelEnum>;
};

export type BcpIncidentAnswerTokenDraft = {
  __typename?: 'BcpIncidentAnswerTokenDraft';
  answeredAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  answeredBy: Maybe<Scalars['String']['output']>;
  categories: BcpIncidentAnswerTokenCategories;
  detailReportEta: Maybe<Scalars['String']['output']>;
  detailReportPending: Scalars['Boolean']['output'];
  hasImpact: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  impactDetail: Maybe<Scalars['String']['output']>;
  parts: Array<BcpIncidentAnswerTokenPart>;
  partsDecideSiteImpact: Scalars['Boolean']['output'];
  previousAnswer: Maybe<BcpIncidentAnswerTokenPreviousAnswer>;
  siteName: Maybe<Scalars['String']['output']>;
};

export type BcpIncidentAnswerTokenPart = {
  __typename?: 'BcpIncidentAnswerTokenPart';
  id: Scalars['ID']['output'];
  impactKind: Maybe<BcpIncidentAnswerPartImpactKindEnum>;
  partCode: Scalars['String']['output'];
  previousComment: Maybe<Scalars['String']['output']>;
  previousImpactKind: Maybe<BcpIncidentAnswerPartImpactKindEnum>;
  supplierCode: Maybe<Scalars['String']['output']>;
};

export type BcpIncidentAnswerTokenPreviousAnswer = {
  __typename?: 'BcpIncidentAnswerTokenPreviousAnswer';
  answeredAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  categories: BcpIncidentAnswerTokenCategories;
  detailReportEta: Maybe<Scalars['String']['output']>;
  detailReportPending: Scalars['Boolean']['output'];
  hasImpact: Scalars['Boolean']['output'];
  impactDetail: Maybe<Scalars['String']['output']>;
};

export type BcpIncidentAnswerTokenRequest = {
  __typename?: 'BcpIncidentAnswerTokenRequest';
  disasterKind: BcpDisasterKindEnum;
  /** 依頼に含まれる拠点（下書き）。拠点名の順 */
  drafts: Array<BcpIncidentAnswerTokenDraft>;
  dueDatetime: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  incidentName: Maybe<Scalars['String']['output']>;
  isDrill: Scalars['Boolean']['output'];
  tenantName: Scalars['String']['output'];
};

/** ワンタイムURLの一次回答画面の状態 */
export enum BcpIncidentAnswerTokenStateEnum {
  Answerable = 'answerable',
  Answered = 'answered',
  Closed = 'closed',
  Expired = 'expired'
}

export type BcpIncidentPreviousAnswer = {
  __typename?: 'BcpIncidentPreviousAnswer';
  answeredAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  categories: BcpIncidentAnswerCategories;
  detailReportEta: Maybe<Scalars['String']['output']>;
  detailReportPending: Scalars['Boolean']['output'];
  hasImpact: Scalars['Boolean']['output'];
  impactDetail: Maybe<Scalars['String']['output']>;
};

export type CanceledPartOrderUnitPrice = {
  __typename?: 'CanceledPartOrderUnitPrice';
  cancelStatusKind: Scalars['String']['output'];
};

export type Category = {
  __typename?: 'Category';
  answerFormat: AnswerFormat;
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tenantId: Scalars['ID']['output'];
};

export type CertificationClass = {
  __typename?: 'CertificationClass';
  certificationStandard: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
};

export type CommentBase = {
  __typename?: 'CommentBase';
  commentKind: Scalars['String']['output'];
  commentNodes: Array<CommentNode>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  itemKind: Scalars['String']['output'];
  targetId: Scalars['ID']['output'];
  tenantId: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Comment kind enum */
export enum CommentKindEnum {
  /** Announcement external comment */
  AnnouncementExternal = 'ANNOUNCEMENT_EXTERNAL',
  /** Announcement internal comment */
  AnnouncementInternal = 'ANNOUNCEMENT_INTERNAL',
  /** Data share comment */
  DataShare = 'DATA_SHARE',
  /** Price registration comparison comment */
  PriceRegistrationComparison = 'PRICE_REGISTRATION_COMPARISON',
  /** Project comment */
  Project = 'PROJECT',
  /** Quotation comparison comment */
  QuotationComparison = 'QUOTATION_COMPARISON',
  /** Quotation comparison selection application comment */
  QuotationComparisonSelectionApplication = 'QUOTATION_COMPARISON_SELECTION_APPLICATION',
  /** Quotation db comment */
  QuotationDb = 'QUOTATION_DB',
  /** Quotation request comment */
  QuotationRequest = 'QUOTATION_REQUEST',
  /** Supplier file comment */
  SupplierFile = 'SUPPLIER_FILE',
  /** Task report comment */
  TaskReport = 'TASK_REPORT'
}

export type CommentNode = {
  __typename?: 'CommentNode';
  attachments: Array<Attachment>;
  authorAdminUserId: Maybe<Scalars['ID']['output']>;
  authorAdminUserName: Maybe<Scalars['String']['output']>;
  authorSupplierAccountId: Maybe<Scalars['ID']['output']>;
  authorSupplierAccountName: Maybe<Scalars['String']['output']>;
  authorSupplierUserId: Maybe<Scalars['ID']['output']>;
  authorSupplierUserName: Maybe<Scalars['String']['output']>;
  body: Scalars['String']['output'];
  canDelete: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  children: Array<CommentNode>;
  commentBaseId: Scalars['ID']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deletedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  parentId: Maybe<Scalars['ID']['output']>;
  supplier: Maybe<Supplier>;
  supplierId: Maybe<Scalars['ID']['output']>;
  supplierUserInfoCommentConfirmations: Array<SupplierUserInfoCommentConfirmation>;
  targetKind: CommentNodeTargetKindEnum;
  tenantId: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userCommentConfirmations: Array<UserCommentConfirmation>;
};

/** Comment node target kind enum */
export enum CommentNodeTargetKindEnum {
  ASupplierAndInternal = 'a_supplier_and_internal',
  BSupplier = 'b_supplier',
  CInternal = 'c_internal'
}

export type CommentSetting = {
  __typename?: 'CommentSetting';
  supplierAccountReadable: Scalars['Boolean']['output'];
  supplierAccountWritable: Scalars['Boolean']['output'];
};

export type CommonAnswerByFileInput = {
  answerInquiries: Array<CommonAnswerInquiryInput>;
  answerItems: Array<CommonAnswerItemInput>;
  answerMemo?: InputMaybe<Scalars['String']['input']>;
  answerPdfAttachments: Array<CommonAttachmentInput>;
  answerSupplyChainItemDetails: Array<CommonAnswerSupplyChainItemDetailInput>;
  attachments: Array<CommonAttachmentInput>;
  quotationContextInput: QuotationContextInput;
  quotationId: Scalars['ID']['input'];
  quotationRequestId: Scalars['ID']['input'];
};

export type CommonAnswerCalcFacilityInput = {
  amortizationCost?: InputMaybe<Scalars['Float']['input']>;
  amortizationNumber?: InputMaybe<Scalars['Float']['input']>;
  facilityCost?: InputMaybe<Scalars['Float']['input']>;
  facilityUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type CommonAnswerCalcInput = {
  answerFacilityCosts?: InputMaybe<Array<CommonAnswerCalcFacilityInput>>;
  answerFormatId: Scalars['ID']['input'];
  answerMaterialCosts?: InputMaybe<Array<CommonAnswerCalcMaterialCostInput>>;
  answerPartsCosts?: InputMaybe<Array<CommonAnswerCalcPartsCostInput>>;
  answerPrice: CommonAnswerCalcPriceInput;
  answerProcessingCosts?: InputMaybe<Array<CommonAnswerCalcProcessingInput>>;
  answerSubsidiaryMaterialCosts?: InputMaybe<Array<CommonAnswerCalcSubsidiaryMaterialCostInput>>;
  answerSupplySubparts?: InputMaybe<Array<CommonAnswerCalcSupplySubpartsInput>>;
  answerSurfaceProcessingCosts?: InputMaybe<Array<CommonAnswerCalcSpecialProcessingInput>>;
  tenantId: Scalars['ID']['input'];
};

export type CommonAnswerCalcMaterialCost = {
  __typename?: 'CommonAnswerCalcMaterialCost';
  materialCost: Maybe<Scalars['Float']['output']>;
  materialCostPerQty: Maybe<Scalars['Float']['output']>;
  materialCostSubtotal: Maybe<Scalars['Float']['output']>;
  materialCostSubtotalPerQty: Maybe<Scalars['Float']['output']>;
  scrap1Subtotal: Maybe<Scalars['Float']['output']>;
  scrap1SubtotalPerQty: Maybe<Scalars['Float']['output']>;
  scrap1Weight: Maybe<Scalars['Float']['output']>;
  scrap2Subtotal: Maybe<Scalars['Float']['output']>;
  scrap2SubtotalPerQty: Maybe<Scalars['Float']['output']>;
  scrapValueSubtotal: Maybe<Scalars['Float']['output']>;
  scrapValueSubtotalPerQty: Maybe<Scalars['Float']['output']>;
  uid: Maybe<Scalars['String']['output']>;
};

export type CommonAnswerCalcMaterialCostInput = {
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  cavity?: InputMaybe<Scalars['Float']['input']>;
  materialCost?: InputMaybe<Scalars['Float']['input']>;
  materialCostPerQty?: InputMaybe<Scalars['Float']['input']>;
  materialCostSubtotal?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  scrap1Subtotal?: InputMaybe<Scalars['Float']['input']>;
  scrap1UnitPrice?: InputMaybe<Scalars['Float']['input']>;
  scrap1Weight?: InputMaybe<Scalars['Float']['input']>;
  scrap2Subtotal?: InputMaybe<Scalars['Float']['input']>;
  scrap2UnitPrice?: InputMaybe<Scalars['Float']['input']>;
  scrap2Weight?: InputMaybe<Scalars['Float']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  weightAfterProcess?: InputMaybe<Scalars['Float']['input']>;
  weightBeforeProcess?: InputMaybe<Scalars['Float']['input']>;
};

export type CommonAnswerCalcPartsCost = {
  __typename?: 'CommonAnswerCalcPartsCost';
  partsCost: Maybe<Scalars['Float']['output']>;
  uid: Maybe<Scalars['String']['output']>;
};

export type CommonAnswerCalcPartsCostInput = {
  partsCost?: InputMaybe<Scalars['Float']['input']>;
  partsUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type CommonAnswerCalcPriceInput = {
  adjustment?: InputMaybe<Scalars['Float']['input']>;
  defectCost?: InputMaybe<Scalars['Float']['input']>;
  deliveryCost?: InputMaybe<Scalars['Float']['input']>;
  depreciation?: InputMaybe<Scalars['Float']['input']>;
  facilityAmortizationCost?: InputMaybe<Scalars['Float']['input']>;
  facilityCost?: InputMaybe<Scalars['Float']['input']>;
  jigManagementCost?: InputMaybe<Scalars['Float']['input']>;
  managementCost?: InputMaybe<Scalars['Float']['input']>;
  materialCost?: InputMaybe<Scalars['Float']['input']>;
  materialManagementCost?: InputMaybe<Scalars['Float']['input']>;
  packingCost?: InputMaybe<Scalars['Float']['input']>;
  paidSupplyPartSubtotal?: InputMaybe<Scalars['Float']['input']>;
  partsCost?: InputMaybe<Scalars['Float']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  processingManagementCost?: InputMaybe<Scalars['Float']['input']>;
  profit?: InputMaybe<Scalars['Float']['input']>;
  propertyRentCost?: InputMaybe<Scalars['Float']['input']>;
  subsidiaryMaterialCost?: InputMaybe<Scalars['Float']['input']>;
  surfaceProcessingCost?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type CommonAnswerCalcProcessingCost = {
  __typename?: 'CommonAnswerCalcProcessingCost';
  processingCost: Maybe<Scalars['Float']['output']>;
  processingCostSubtotal: Maybe<Scalars['Float']['output']>;
  setupCostSubtotal: Maybe<Scalars['Float']['output']>;
  uid: Maybe<Scalars['String']['output']>;
};

export type CommonAnswerCalcProcessingInput = {
  costForWeight?: InputMaybe<Scalars['Float']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  processingCostSubtotal?: InputMaybe<Scalars['Float']['input']>;
  processingCostSubtotalPerLot?: InputMaybe<Scalars['Float']['input']>;
  processingHeadcount?: InputMaybe<Scalars['Int']['input']>;
  processingRate?: InputMaybe<Scalars['Float']['input']>;
  processingTimeHour?: InputMaybe<Scalars['Float']['input']>;
  processingTimeMinute?: InputMaybe<Scalars['Float']['input']>;
  processingTimeSecond?: InputMaybe<Scalars['Float']['input']>;
  processingWeight?: InputMaybe<Scalars['Float']['input']>;
  productionLot?: InputMaybe<Scalars['Float']['input']>;
  setupCostSubtotal?: InputMaybe<Scalars['Float']['input']>;
  setupCostSubtotalPerLot?: InputMaybe<Scalars['Float']['input']>;
  setupRate?: InputMaybe<Scalars['Float']['input']>;
  setupTimeHour?: InputMaybe<Scalars['Float']['input']>;
  setupTimeMin?: InputMaybe<Scalars['Float']['input']>;
  setupTimeSec?: InputMaybe<Scalars['Float']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type CommonAnswerCalcResult = {
  __typename?: 'CommonAnswerCalcResult';
  answerPrice: CommonAnswerCalcResultPrice;
  facilityCosts: Maybe<Array<CommonAnswerCalcResultFacilityCost>>;
  materialCosts: Maybe<Array<CommonAnswerCalcMaterialCost>>;
  partsCosts: Maybe<Array<CommonAnswerCalcPartsCost>>;
  processingCosts: Maybe<Array<CommonAnswerCalcProcessingCost>>;
  surfaceProcessingCosts: Maybe<Array<CommonAnswerCalcSpecialProcessingCost>>;
};

export type CommonAnswerCalcResultFacilityCost = {
  __typename?: 'CommonAnswerCalcResultFacilityCost';
  amortizationCost: Maybe<Scalars['Float']['output']>;
  amortizationNumber: Maybe<Scalars['Float']['output']>;
  facilityCost: Maybe<Scalars['Float']['output']>;
  uid: Maybe<Scalars['String']['output']>;
};

export type CommonAnswerCalcResultPrice = {
  __typename?: 'CommonAnswerCalcResultPrice';
  facilityAmortizationCost: Maybe<Scalars['Float']['output']>;
  facilityCost: Maybe<Scalars['Float']['output']>;
  materialCost: Maybe<Scalars['Float']['output']>;
  paidSupplyPartSubtotal: Maybe<Scalars['Float']['output']>;
  partsCost: Maybe<Scalars['Float']['output']>;
  processingCost: Maybe<Scalars['Float']['output']>;
  subsidiaryMaterialCost: Maybe<Scalars['Float']['output']>;
  surfaceProcessingCost: Maybe<Scalars['Float']['output']>;
  unitPrice: Maybe<Scalars['Float']['output']>;
  unitPriceWithAmortization: Maybe<Scalars['Float']['output']>;
};

export type CommonAnswerCalcSpecialProcessingCost = {
  __typename?: 'CommonAnswerCalcSpecialProcessingCost';
  processingCost: Maybe<Scalars['Float']['output']>;
  processingCostSubtotal: Maybe<Scalars['Float']['output']>;
  setupCostSubtotal: Maybe<Scalars['Float']['output']>;
  uid: Maybe<Scalars['String']['output']>;
};

export type CommonAnswerCalcSpecialProcessingInput = {
  equipmentName?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  processName?: InputMaybe<Scalars['String']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  processingCostSubtotal?: InputMaybe<Scalars['Float']['input']>;
  processingRate?: InputMaybe<Scalars['Float']['input']>;
  processingTimeHour?: InputMaybe<Scalars['Float']['input']>;
  processingTimeMinute?: InputMaybe<Scalars['Float']['input']>;
  processingTimeSecond?: InputMaybe<Scalars['Float']['input']>;
  processingTimes?: InputMaybe<Scalars['Int']['input']>;
  productionLot?: InputMaybe<Scalars['Int']['input']>;
  rateKind?: InputMaybe<Scalars['String']['input']>;
  seqNo?: InputMaybe<Scalars['Int']['input']>;
  setupCostSubtotal?: InputMaybe<Scalars['Float']['input']>;
  setupRate?: InputMaybe<Scalars['Float']['input']>;
  setupTimeHour?: InputMaybe<Scalars['Float']['input']>;
  setupTimeMinute?: InputMaybe<Scalars['Float']['input']>;
  setupTimeSecond?: InputMaybe<Scalars['Float']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type CommonAnswerCalcSubsidiaryMaterialCostInput = {
  subsidiaryMaterialCost?: InputMaybe<Scalars['Float']['input']>;
};

export type CommonAnswerCalcSupplySubpartsInput = {
  supplyPartCost?: InputMaybe<Scalars['Float']['input']>;
};

export type CommonAnswerExcelAttachmentInput = {
  attachment: CommonAttachmentInput;
  quotationItemId?: InputMaybe<Scalars['ID']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
  resultMessage?: InputMaybe<Scalars['String']['input']>;
};

export type CommonAnswerFacilityCostInput = {
  amortizationNumber?: InputMaybe<Scalars['Int']['input']>;
  amortizationPeriod?: InputMaybe<Scalars['String']['input']>;
  amortizationPeriodAsYear?: InputMaybe<Scalars['Int']['input']>;
  cavity?: InputMaybe<Scalars['Int']['input']>;
  facilityCost?: InputMaybe<Scalars['Float']['input']>;
  facilityKindId: Scalars['ID']['input'];
  facilityUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isLend?: InputMaybe<Scalars['Boolean']['input']>;
  leadTime?: InputMaybe<Scalars['String']['input']>;
  maker?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentTimingKind?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quotationItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  recuttingCount?: InputMaybe<Scalars['Int']['input']>;
  spec?: InputMaybe<Scalars['String']['input']>;
};

export type CommonAnswerFacilityCostInputV2 = {
  amortizationCost?: InputMaybe<Scalars['Float']['input']>;
  amortizationNumber?: InputMaybe<Scalars['Int']['input']>;
  amortizationNumberPerPeriod?: InputMaybe<Scalars['Int']['input']>;
  amortizationPeriod?: InputMaybe<Scalars['String']['input']>;
  amortizationPeriodAsNum?: InputMaybe<Scalars['Int']['input']>;
  amortizationPeriodAsYear?: InputMaybe<Scalars['Int']['input']>;
  answerProcessingCostId?: InputMaybe<Scalars['ID']['input']>;
  cavity?: InputMaybe<Scalars['Int']['input']>;
  facilityCost?: InputMaybe<Scalars['Float']['input']>;
  facilityKindId: Scalars['ID']['input'];
  facilityUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isLend?: InputMaybe<Scalars['Boolean']['input']>;
  leadTime?: InputMaybe<Scalars['String']['input']>;
  maker?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentTimingKind?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quotationItemIds: Array<Scalars['ID']['input']>;
  recuttingCount?: InputMaybe<Scalars['Int']['input']>;
  spec?: InputMaybe<Scalars['String']['input']>;
};

export type CommonAnswerInput = {
  answerByFileCheckKind?: InputMaybe<Scalars['String']['input']>;
  answerFacilityCosts: Array<CommonAnswerFacilityCostInput>;
  answerInquiries: Array<CommonAnswerInquiryInput>;
  answerItems: Array<CommonAnswerItemInput>;
  answerMemo?: InputMaybe<Scalars['String']['input']>;
  answerPrices: Array<CommonAnswerPriceInput>;
  answerStatus: Scalars['String']['input'];
  answerSupplyChainItemDetails?: InputMaybe<Array<CommonAnswerSupplyChainItemDetailInput>>;
  attachments?: InputMaybe<Array<CommonAttachmentInput>>;
  currencyExchangeNote?: InputMaybe<Scalars['String']['input']>;
  currencyId: Scalars['ID']['input'];
  dayType: Scalars['String']['input'];
  expirationDate: Scalars['String']['input'];
  quotationContextInput?: InputMaybe<QuotationContextInput>;
  quotationId: Scalars['ID']['input'];
  quotationNo?: InputMaybe<Scalars['String']['input']>;
  quotationRequestId: Scalars['ID']['input'];
  wholesalerKnowledges?: InputMaybe<Array<CommonWholesalerKnowledgeInput>>;
};

export type CommonAnswerInquiryInput = {
  answerValueBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  answerValueNumber?: InputMaybe<Scalars['Float']['input']>;
  answerValueString?: InputMaybe<Scalars['String']['input']>;
  attachment?: InputMaybe<CommonAttachmentInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  quotationInquiryId: Scalars['ID']['input'];
};

export type CommonAnswerInquiryInputV2 = {
  answerValueBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  answerValueNumber?: InputMaybe<Scalars['Float']['input']>;
  answerValueString?: InputMaybe<Scalars['String']['input']>;
  attachment?: InputMaybe<CommonAttachmentInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  quotationInquiryId: Scalars['ID']['input'];
};

export type CommonAnswerItemInput = {
  deliveryForm?: InputMaybe<Scalars['String']['input']>;
  minimumOrderQuantity?: InputMaybe<Scalars['String']['input']>;
  originLocation?: InputMaybe<Scalars['String']['input']>;
  priceEffectiveFrom?: InputMaybe<Scalars['String']['input']>;
  priceEffectiveTo?: InputMaybe<Scalars['String']['input']>;
  quantityPerDeliveryForm?: InputMaybe<Scalars['String']['input']>;
  quotationItemId: Scalars['ID']['input'];
  specMemo?: InputMaybe<Scalars['String']['input']>;
};

export type CommonAnswerItemInputV2 = {
  deliveryForm?: InputMaybe<Scalars['String']['input']>;
  minimumOrderQuantity?: InputMaybe<Scalars['String']['input']>;
  originLocation?: InputMaybe<Scalars['String']['input']>;
  priceEffectiveFrom?: InputMaybe<Scalars['String']['input']>;
  priceEffectiveTo?: InputMaybe<Scalars['String']['input']>;
  quantityPerDeliveryForm?: InputMaybe<Scalars['String']['input']>;
  quotationItemId: Scalars['ID']['input'];
  specMemo?: InputMaybe<Scalars['String']['input']>;
};

export type CommonAnswerMaterialCostInput = {
  adjustment?: InputMaybe<Scalars['Float']['input']>;
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  cavity?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  materialCost?: InputMaybe<Scalars['Float']['input']>;
  materialCostSubtotal?: InputMaybe<Scalars['Float']['input']>;
  materialName?: InputMaybe<Scalars['String']['input']>;
  measure?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  priceTenantUnit?: InputMaybe<CommonAnswerTenantUnitInput>;
  procurementKind?: InputMaybe<Scalars['String']['input']>;
  scrap1Name?: InputMaybe<Scalars['String']['input']>;
  scrap1Subtotal?: InputMaybe<Scalars['Float']['input']>;
  scrap1UnitPrice?: InputMaybe<Scalars['Float']['input']>;
  scrap1Weight?: InputMaybe<Scalars['Float']['input']>;
  scrap2Name?: InputMaybe<Scalars['String']['input']>;
  scrap2Subtotal?: InputMaybe<Scalars['Float']['input']>;
  scrap2UnitPrice?: InputMaybe<Scalars['Float']['input']>;
  scrap2Weight?: InputMaybe<Scalars['Float']['input']>;
  scrapValueSubtotal?: InputMaybe<Scalars['Float']['input']>;
  seqNo?: InputMaybe<Scalars['Int']['input']>;
  thickness?: InputMaybe<Scalars['Float']['input']>;
  weightAfterProcess?: InputMaybe<Scalars['Float']['input']>;
  weightBeforeProcess?: InputMaybe<Scalars['Float']['input']>;
  weightTenantUnit?: InputMaybe<CommonAnswerTenantUnitInput>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type CommonAnswerMaterialCostInputV2 = {
  adjustment?: InputMaybe<Scalars['Float']['input']>;
  adjustmentCost?: InputMaybe<Scalars['Float']['input']>;
  adjustmentCostMemo?: InputMaybe<Scalars['String']['input']>;
  baseMaterialCode?: InputMaybe<Scalars['String']['input']>;
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  blendBaseUnitCost?: InputMaybe<Scalars['Float']['input']>;
  blendOtherMaterialName?: InputMaybe<Scalars['String']['input']>;
  blendOtherMaterialRatio?: InputMaybe<Scalars['Float']['input']>;
  blendOtherMaterialUnitCost?: InputMaybe<Scalars['Float']['input']>;
  blendPrimaryMaterialName?: InputMaybe<Scalars['String']['input']>;
  blendPrimaryMaterialRatio?: InputMaybe<Scalars['Float']['input']>;
  blendPrimaryMaterialUnitCost?: InputMaybe<Scalars['Float']['input']>;
  blendSecondaryMaterialName?: InputMaybe<Scalars['String']['input']>;
  blendSecondaryMaterialRatio?: InputMaybe<Scalars['Float']['input']>;
  blendSecondaryMaterialUnitCost?: InputMaybe<Scalars['Float']['input']>;
  blendUnitCostMarkupRatio?: InputMaybe<Scalars['Float']['input']>;
  cavity?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  lossGateCost?: InputMaybe<Scalars['Float']['input']>;
  lossGateUnitUsage?: InputMaybe<Scalars['Float']['input']>;
  lossOtherCost?: InputMaybe<Scalars['Float']['input']>;
  lossOtherMemo?: InputMaybe<Scalars['String']['input']>;
  lossOtherUnitUsage?: InputMaybe<Scalars['Float']['input']>;
  lossPurgeCost?: InputMaybe<Scalars['Float']['input']>;
  lossPurgeLotCount?: InputMaybe<Scalars['Int']['input']>;
  lossPurgeTotalWeight?: InputMaybe<Scalars['Float']['input']>;
  lossPurgeUnitUsage?: InputMaybe<Scalars['Float']['input']>;
  lossRunnerCost?: InputMaybe<Scalars['Float']['input']>;
  lossRunnerUnitUsage?: InputMaybe<Scalars['Float']['input']>;
  lossTotalCost?: InputMaybe<Scalars['Float']['input']>;
  lossTotalUnitUsage?: InputMaybe<Scalars['Float']['input']>;
  materialCost?: InputMaybe<Scalars['Float']['input']>;
  materialCostPerQty?: InputMaybe<Scalars['Float']['input']>;
  materialCostSubtotal?: InputMaybe<Scalars['Float']['input']>;
  materialCostSubtotalPerQty?: InputMaybe<Scalars['Float']['input']>;
  materialName?: InputMaybe<Scalars['String']['input']>;
  measure?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  procurementKind?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  scrap1Name?: InputMaybe<Scalars['String']['input']>;
  scrap1Subtotal?: InputMaybe<Scalars['Float']['input']>;
  scrap1SubtotalPerQty?: InputMaybe<Scalars['Float']['input']>;
  scrap1UnitPrice?: InputMaybe<Scalars['Float']['input']>;
  scrap1Weight?: InputMaybe<Scalars['Float']['input']>;
  scrap2Name?: InputMaybe<Scalars['String']['input']>;
  scrap2Subtotal?: InputMaybe<Scalars['Float']['input']>;
  scrap2SubtotalPerQty?: InputMaybe<Scalars['Float']['input']>;
  scrap2UnitPrice?: InputMaybe<Scalars['Float']['input']>;
  scrap2Weight?: InputMaybe<Scalars['Float']['input']>;
  scrapValueSubtotal?: InputMaybe<Scalars['Float']['input']>;
  scrapValueSubtotalPerQty?: InputMaybe<Scalars['Float']['input']>;
  seqNo?: InputMaybe<Scalars['Int']['input']>;
  thickness?: InputMaybe<Scalars['Float']['input']>;
  trialShotCost?: InputMaybe<Scalars['Float']['input']>;
  trialShotUnitUsage?: InputMaybe<Scalars['Float']['input']>;
  weightAfterProcess?: InputMaybe<Scalars['Float']['input']>;
  weightBeforeProcess?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type CommonAnswerPartsCostInput = {
  memo?: InputMaybe<Scalars['String']['input']>;
  partName?: InputMaybe<Scalars['String']['input']>;
  partNo?: InputMaybe<Scalars['String']['input']>;
  partSpec?: InputMaybe<Scalars['String']['input']>;
  partsCost?: InputMaybe<Scalars['Float']['input']>;
  partsCount?: InputMaybe<Scalars['Int']['input']>;
  partsUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  procurementKind?: InputMaybe<Scalars['String']['input']>;
  productionPlace?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  seqNo?: InputMaybe<Scalars['Int']['input']>;
};

export type CommonAnswerPartsCostInputV2 = {
  memo?: InputMaybe<Scalars['String']['input']>;
  partName?: InputMaybe<Scalars['String']['input']>;
  partNo?: InputMaybe<Scalars['String']['input']>;
  partSpec?: InputMaybe<Scalars['String']['input']>;
  partsCost?: InputMaybe<Scalars['Float']['input']>;
  partsCount?: InputMaybe<Scalars['Int']['input']>;
  partsUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  procurementKind?: InputMaybe<Scalars['String']['input']>;
  productionPlace?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  seqNo?: InputMaybe<Scalars['Int']['input']>;
};

export type CommonAnswerPriceInput = {
  adjustment?: InputMaybe<Scalars['Float']['input']>;
  answerMaterialCosts: Array<CommonAnswerMaterialCostInput>;
  answerPartsCosts: Array<CommonAnswerPartsCostInput>;
  answerProcessingCosts: Array<CommonAnswerProcessingCostInput>;
  answerSpecialProcessingCosts: Array<CommonAnswerSpecialProcessingCostInput>;
  answerSubsidiaryMaterialCosts: Array<CommonAnswerSubsidiaryMaterialCostInput>;
  boxCount?: InputMaybe<Scalars['Int']['input']>;
  defectCost?: InputMaybe<Scalars['Float']['input']>;
  defectRate?: InputMaybe<Scalars['Float']['input']>;
  deliveryCost?: InputMaybe<Scalars['Float']['input']>;
  deliveryCostPerBox?: InputMaybe<Scalars['Float']['input']>;
  deliveryDay?: InputMaybe<Scalars['Int']['input']>;
  depreciation?: InputMaybe<Scalars['Float']['input']>;
  equipmentDeliveryDay?: InputMaybe<Scalars['Int']['input']>;
  equipmentDeliveryStartDay?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  initialDeliveryDay?: InputMaybe<Scalars['Int']['input']>;
  internalPartSubtotal?: InputMaybe<Scalars['Float']['input']>;
  isDeclined?: InputMaybe<Scalars['Boolean']['input']>;
  managementCost?: InputMaybe<Scalars['Float']['input']>;
  materialCost?: InputMaybe<Scalars['Float']['input']>;
  materialDeliveryDay?: InputMaybe<Scalars['Int']['input']>;
  materialDeliveryStartDay?: InputMaybe<Scalars['Int']['input']>;
  materialManagementCost?: InputMaybe<Scalars['Float']['input']>;
  materialManagementRate?: InputMaybe<Scalars['Float']['input']>;
  moldDeliveryDay?: InputMaybe<Scalars['Int']['input']>;
  moldDeliveryStartDay?: InputMaybe<Scalars['Int']['input']>;
  outSourcePartManagementRate?: InputMaybe<Scalars['Float']['input']>;
  outSourcePartSubtotal?: InputMaybe<Scalars['Float']['input']>;
  packingCost?: InputMaybe<Scalars['Float']['input']>;
  packingCostPerBox?: InputMaybe<Scalars['Float']['input']>;
  paidSupplyPartSubtotal?: InputMaybe<Scalars['Float']['input']>;
  partsCost?: InputMaybe<Scalars['Float']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  processingManagementCost?: InputMaybe<Scalars['Float']['input']>;
  processingManagementRate?: InputMaybe<Scalars['Float']['input']>;
  profit?: InputMaybe<Scalars['Float']['input']>;
  profitRate?: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Float']['input'];
  quantityFrom?: InputMaybe<Scalars['Float']['input']>;
  quantityGroup: Scalars['String']['input'];
  quantityInOneBox?: InputMaybe<Scalars['Int']['input']>;
  quantityTo?: InputMaybe<Scalars['Float']['input']>;
  quotationItemId: Scalars['ID']['input'];
  rootQuotationItemId: Scalars['ID']['input'];
  subsidiaryMaterialCost?: InputMaybe<Scalars['Float']['input']>;
  surfaceProcessingCost?: InputMaybe<Scalars['Float']['input']>;
  trialDeliveryDay?: InputMaybe<Scalars['Int']['input']>;
  trialDeliveryStartDay?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type CommonAnswerPriceInputV2 = {
  adjustment?: InputMaybe<Scalars['Float']['input']>;
  /** 一式の総額。外税なら税抜、内税なら税込の金額（保存する税抜は税区分から逆算する） */
  amountExcludingTax?: InputMaybe<Scalars['String']['input']>;
  answerMaterialCosts: Array<CommonAnswerMaterialCostInputV2>;
  answerPartsCosts: Array<CommonAnswerPartsCostInputV2>;
  answerProcessingCosts: Array<CommonAnswerProcessingCostInputV2>;
  answerSubsidiaryMaterialCosts: Array<CommonAnswerSubsidiaryMaterialCostInputV2>;
  answerSurfaceProcessingCosts: Array<CommonAnswerSpecialProcessingCostInputV2>;
  boxCount?: InputMaybe<Scalars['Int']['input']>;
  defectCost?: InputMaybe<Scalars['Float']['input']>;
  defectRate?: InputMaybe<Scalars['Float']['input']>;
  deliveryCost?: InputMaybe<Scalars['Float']['input']>;
  deliveryCostPerBox?: InputMaybe<Scalars['Float']['input']>;
  deliveryDay?: InputMaybe<Scalars['Int']['input']>;
  depreciation?: InputMaybe<Scalars['Float']['input']>;
  designCost?: InputMaybe<Scalars['Float']['input']>;
  equipmentDeliveryDay?: InputMaybe<Scalars['Int']['input']>;
  equipmentDeliveryStartDay?: InputMaybe<Scalars['Int']['input']>;
  facilityAmortizationCost?: InputMaybe<Scalars['Float']['input']>;
  facilityCost?: InputMaybe<Scalars['Float']['input']>;
  initialDeliveryDay?: InputMaybe<Scalars['Int']['input']>;
  internalPartSubtotal?: InputMaybe<Scalars['Float']['input']>;
  isDeclined?: InputMaybe<Scalars['Boolean']['input']>;
  jigManagementCost?: InputMaybe<Scalars['Float']['input']>;
  managementCost?: InputMaybe<Scalars['Float']['input']>;
  materialCost?: InputMaybe<Scalars['Float']['input']>;
  materialDeliveryDay?: InputMaybe<Scalars['Int']['input']>;
  materialDeliveryStartDay?: InputMaybe<Scalars['Int']['input']>;
  materialManagementCost?: InputMaybe<Scalars['Float']['input']>;
  materialManagementRate?: InputMaybe<Scalars['Float']['input']>;
  moldDeliveryDay?: InputMaybe<Scalars['Int']['input']>;
  moldDeliveryStartDay?: InputMaybe<Scalars['Int']['input']>;
  outSourcePartManagementRate?: InputMaybe<Scalars['Float']['input']>;
  outSourcePartSubtotal?: InputMaybe<Scalars['Float']['input']>;
  packingCost?: InputMaybe<Scalars['Float']['input']>;
  packingCostPerBox?: InputMaybe<Scalars['Float']['input']>;
  paidSupplyPartSubtotal?: InputMaybe<Scalars['Float']['input']>;
  partsCost?: InputMaybe<Scalars['Float']['input']>;
  priceBasis?: InputMaybe<Scalars['String']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  processingManagementCost?: InputMaybe<Scalars['Float']['input']>;
  processingManagementRate?: InputMaybe<Scalars['Float']['input']>;
  profit?: InputMaybe<Scalars['Float']['input']>;
  profitRate?: InputMaybe<Scalars['Float']['input']>;
  propertyRentCost?: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Float']['input'];
  quantityInOneBox?: InputMaybe<Scalars['Int']['input']>;
  quotationItemChildStructId?: InputMaybe<Scalars['ID']['input']>;
  quotationItemId: Scalars['ID']['input'];
  subsidiaryMaterialCost?: InputMaybe<Scalars['Float']['input']>;
  subsidiaryMaterialManagementCost?: InputMaybe<Scalars['Float']['input']>;
  subsidiaryMaterialManagementRate?: InputMaybe<Scalars['Float']['input']>;
  surfaceProcessingCost?: InputMaybe<Scalars['Float']['input']>;
  /** 税区分 0外税 1内税 2非課税 3不課税。都度発注の見積だけが使う（通常の見積では無視して 0）。省くと 0 */
  taxType?: InputMaybe<Scalars['Int']['input']>;
  trialDeliveryDay?: InputMaybe<Scalars['Int']['input']>;
  trialDeliveryStartDay?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type CommonAnswerProcessingCostInput = {
  costForWeight?: InputMaybe<Scalars['Float']['input']>;
  equipmentName?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  processName?: InputMaybe<Scalars['String']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  processingCostSubtotal?: InputMaybe<Scalars['Float']['input']>;
  processingHeadcount?: InputMaybe<Scalars['Int']['input']>;
  processingRate?: InputMaybe<Scalars['Float']['input']>;
  processingTimeHour?: InputMaybe<Scalars['Float']['input']>;
  processingTimeMinute?: InputMaybe<Scalars['Float']['input']>;
  processingTimeSecond?: InputMaybe<Scalars['Float']['input']>;
  processingTimes?: InputMaybe<Scalars['Int']['input']>;
  processingWeight?: InputMaybe<Scalars['Float']['input']>;
  productionLot?: InputMaybe<Scalars['Int']['input']>;
  rateKind?: InputMaybe<Scalars['String']['input']>;
  seqNo?: InputMaybe<Scalars['Int']['input']>;
  setupCostSubtotal?: InputMaybe<Scalars['Float']['input']>;
  setupRate?: InputMaybe<Scalars['Float']['input']>;
  setupTimeHour?: InputMaybe<Scalars['Float']['input']>;
  setupTimeMinute?: InputMaybe<Scalars['Float']['input']>;
  setupTimeSecond?: InputMaybe<Scalars['Float']['input']>;
  weightTenantUnit?: InputMaybe<CommonAnswerTenantUnitInput>;
};

export type CommonAnswerProcessingCostInputV2 = {
  costForWeight?: InputMaybe<Scalars['Float']['input']>;
  equipmentName?: InputMaybe<Scalars['String']['input']>;
  facilityAmortizationNumber?: InputMaybe<Scalars['Int']['input']>;
  facilityAmortizationPeriod?: InputMaybe<Scalars['String']['input']>;
  facilityAmortizationPeriodAsYear?: InputMaybe<Scalars['Int']['input']>;
  facilityCavity?: InputMaybe<Scalars['Int']['input']>;
  facilityCost?: InputMaybe<Scalars['Float']['input']>;
  facilityIsLend?: InputMaybe<Scalars['Boolean']['input']>;
  facilityKindId?: InputMaybe<Scalars['ID']['input']>;
  facilityLeadTime?: InputMaybe<Scalars['String']['input']>;
  facilityMaker?: InputMaybe<Scalars['String']['input']>;
  facilityMemo?: InputMaybe<Scalars['String']['input']>;
  facilityName?: InputMaybe<Scalars['String']['input']>;
  facilityPaymentTimingKind?: InputMaybe<Scalars['String']['input']>;
  facilityQuantity?: InputMaybe<Scalars['Float']['input']>;
  facilityRecuttingCount?: InputMaybe<Scalars['Int']['input']>;
  facilitySpec?: InputMaybe<Scalars['String']['input']>;
  facilityUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  partCostRatio?: InputMaybe<Scalars['Float']['input']>;
  processName?: InputMaybe<Scalars['String']['input']>;
  processOutsourcingKind?: InputMaybe<Scalars['String']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  processingCostPerLot?: InputMaybe<Scalars['Float']['input']>;
  processingCostSubtotal?: InputMaybe<Scalars['Float']['input']>;
  processingCostSubtotalPerLot?: InputMaybe<Scalars['Float']['input']>;
  processingHeadcount?: InputMaybe<Scalars['Int']['input']>;
  processingRate?: InputMaybe<Scalars['Float']['input']>;
  processingTimeHour?: InputMaybe<Scalars['Float']['input']>;
  processingTimeMinute?: InputMaybe<Scalars['Float']['input']>;
  processingTimeSecond?: InputMaybe<Scalars['Float']['input']>;
  processingTimes?: InputMaybe<Scalars['Int']['input']>;
  processingWeight?: InputMaybe<Scalars['Float']['input']>;
  productionLot?: InputMaybe<Scalars['Int']['input']>;
  seqNo?: InputMaybe<Scalars['Int']['input']>;
  setupCostSubtotal?: InputMaybe<Scalars['Float']['input']>;
  setupCostSubtotalPerLot?: InputMaybe<Scalars['Float']['input']>;
  setupRate?: InputMaybe<Scalars['Float']['input']>;
  setupTimeHour?: InputMaybe<Scalars['Float']['input']>;
  setupTimeMinute?: InputMaybe<Scalars['Float']['input']>;
  setupTimeSecond?: InputMaybe<Scalars['Float']['input']>;
};

export type CommonAnswerSpecialProcessingCost = {
  __typename?: 'CommonAnswerSpecialProcessingCost';
  equipmentName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  memo: Maybe<Scalars['String']['output']>;
  processName: Scalars['String']['output'];
  processingCost: Scalars['Float']['output'];
  processingCostSubtotal: Maybe<Scalars['Float']['output']>;
  processingRate: Maybe<Scalars['Float']['output']>;
  processingTimeHour: Maybe<Scalars['Float']['output']>;
  processingTimeMinute: Maybe<Scalars['Float']['output']>;
  processingTimeSecond: Maybe<Scalars['Float']['output']>;
  processingTimes: Maybe<Scalars['Int']['output']>;
  productionLot: Maybe<Scalars['Int']['output']>;
  rateKind: Maybe<Scalars['String']['output']>;
  seqNo: Scalars['Int']['output'];
  setupCostSubtotal: Maybe<Scalars['Float']['output']>;
  setupRate: Maybe<Scalars['Float']['output']>;
  setupTimeHour: Maybe<Scalars['Float']['output']>;
  setupTimeMinute: Maybe<Scalars['Float']['output']>;
  setupTimeSecond: Maybe<Scalars['Float']['output']>;
};

export type CommonAnswerSpecialProcessingCostInput = {
  equipmentName?: InputMaybe<Scalars['String']['input']>;
  kind: Scalars['String']['input'];
  memo?: InputMaybe<Scalars['String']['input']>;
  processName?: InputMaybe<Scalars['String']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  processingCostSubtotal?: InputMaybe<Scalars['Float']['input']>;
  processingRate?: InputMaybe<Scalars['Float']['input']>;
  processingTimeHour?: InputMaybe<Scalars['Float']['input']>;
  processingTimeMinute?: InputMaybe<Scalars['Float']['input']>;
  processingTimeSecond?: InputMaybe<Scalars['Int']['input']>;
  processingTimes?: InputMaybe<Scalars['Int']['input']>;
  productionLot?: InputMaybe<Scalars['Int']['input']>;
  rateKind?: InputMaybe<Scalars['String']['input']>;
  setupCostSubtotal?: InputMaybe<Scalars['Float']['input']>;
  setupRate?: InputMaybe<Scalars['Float']['input']>;
  setupTimeHour?: InputMaybe<Scalars['Float']['input']>;
  setupTimeMinute?: InputMaybe<Scalars['Float']['input']>;
  setupTimeSecond?: InputMaybe<Scalars['Float']['input']>;
};

export type CommonAnswerSpecialProcessingCostInputV2 = {
  equipmentName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  processName?: InputMaybe<Scalars['String']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  processingCostSubtotal?: InputMaybe<Scalars['Float']['input']>;
  processingRate?: InputMaybe<Scalars['Float']['input']>;
  processingTimeHour?: InputMaybe<Scalars['Float']['input']>;
  processingTimeMinute?: InputMaybe<Scalars['Float']['input']>;
  processingTimeSecond?: InputMaybe<Scalars['Float']['input']>;
  processingTimes?: InputMaybe<Scalars['Int']['input']>;
  productionLot?: InputMaybe<Scalars['Int']['input']>;
  rateKind?: InputMaybe<Scalars['String']['input']>;
  seqNo?: InputMaybe<Scalars['Int']['input']>;
  setupCostSubtotal?: InputMaybe<Scalars['Float']['input']>;
  setupRate?: InputMaybe<Scalars['Float']['input']>;
  setupTimeHour?: InputMaybe<Scalars['Float']['input']>;
  setupTimeMinute?: InputMaybe<Scalars['Float']['input']>;
  setupTimeSecond?: InputMaybe<Scalars['Float']['input']>;
};

export type CommonAnswerSubsidiaryMaterialCost = {
  __typename?: 'CommonAnswerSubsidiaryMaterialCost';
  amortizationNumberPerPeriod: Maybe<Scalars['Int']['output']>;
  amortizationPeriodAsNum: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['ID']['output'];
  note: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['Float']['output']>;
  seqNo: Scalars['Int']['output'];
  subsidiaryMaterialCost: Scalars['Float']['output'];
  totalQuantity: Maybe<Scalars['Float']['output']>;
  totalSubsidiaryMaterialCost: Maybe<Scalars['Float']['output']>;
  unitPrice: Maybe<Scalars['Float']['output']>;
};

export type CommonAnswerSubsidiaryMaterialCostInput = {
  name?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  subsidiaryMaterialCost?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type CommonAnswerSubsidiaryMaterialCostInputV2 = {
  amortizationNumberPerPeriod?: InputMaybe<Scalars['Int']['input']>;
  amortizationPeriodAsNum?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  subsidiaryMaterialCost?: InputMaybe<Scalars['Float']['input']>;
  totalQuantity?: InputMaybe<Scalars['Float']['input']>;
  totalSubsidiaryMaterialCost?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type CommonAnswerSupplyChainItemDetailInput = {
  address?: InputMaybe<AddressInput>;
  answerId?: InputMaybe<Scalars['ID']['input']>;
  factoryName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isAlternative?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processName?: InputMaybe<Scalars['String']['input']>;
  quotationItemId?: InputMaybe<Scalars['ID']['input']>;
  supplierName?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};

export type CommonAnswerSupplySubpart = {
  __typename?: 'CommonAnswerSupplySubpart';
  id: Scalars['ID']['output'];
  partCode: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  quantityDenominator: Scalars['Int']['output'];
  rootPartCode: Maybe<Scalars['String']['output']>;
  supplyPartCost: Scalars['Float']['output'];
  supplyPartName: Maybe<Scalars['String']['output']>;
  unitPrice: Scalars['Float']['output'];
};

export type CommonAnswerTenantUnitInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  unit: CommonAnswerUnitInput;
  unitCode: Scalars['String']['input'];
};

export type CommonAnswerUnitInput = {
  conversionRate?: InputMaybe<Scalars['Float']['input']>;
  symbol: Scalars['String']['input'];
};

export type CommonAnswerUpsertInput = {
  answerByFileCheckKind?: InputMaybe<Scalars['String']['input']>;
  answerExcelAttachments: Array<CommonAnswerExcelAttachmentInput>;
  answerFacilityCosts: Array<CommonAnswerFacilityCostInputV2>;
  answerInquiries: Array<CommonAnswerInquiryInputV2>;
  answerItems: Array<CommonAnswerItemInputV2>;
  answerMemo?: InputMaybe<Scalars['String']['input']>;
  answerPrices: Array<CommonAnswerPriceInputV2>;
  answerStatus: Scalars['String']['input'];
  answerSupplyChainItemDetails?: InputMaybe<Array<CommonAnswerSupplyChainItemDetailInput>>;
  attachments?: InputMaybe<Array<CommonAttachmentInput>>;
  currencyExchangeNote?: InputMaybe<Scalars['String']['input']>;
  currencyId?: InputMaybe<Scalars['ID']['input']>;
  dayType?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  quotationContextInput?: InputMaybe<QuotationContextInput>;
  quotationCopiedFromId?: InputMaybe<Scalars['ID']['input']>;
  quotationNo?: InputMaybe<Scalars['String']['input']>;
  quotationRequestId: Scalars['ID']['input'];
  wholesalerKnowledges?: InputMaybe<Array<CommonWholesalerKnowledgeInput>>;
};

export type CommonAttachmentInput = {
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CommonQuotationItemSupplySubpart = {
  __typename?: 'CommonQuotationItemSupplySubpart';
  id: Scalars['ID']['output'];
  partCode: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  quantityDenominator: Scalars['Int']['output'];
  rootPartCode: Maybe<Scalars['String']['output']>;
  supplyPartCost: Scalars['Float']['output'];
  supplyPartName: Maybe<Scalars['String']['output']>;
  unitPrice: Scalars['Float']['output'];
};

export type CommonSpecialProcessingDetailFormat = {
  __typename?: 'CommonSpecialProcessingDetailFormat';
  isUseEquipmentName: Scalars['Boolean']['output'];
  isUseMemo: Scalars['Boolean']['output'];
  isUseProcessingCostSubtotal: Scalars['Boolean']['output'];
  isUseProcessingRate: Scalars['Boolean']['output'];
  isUseProcessingTimeHour: Scalars['Boolean']['output'];
  isUseProcessingTimeMinute: Scalars['Boolean']['output'];
  isUseProcessingTimeSecond: Scalars['Boolean']['output'];
  isUseProcessingTimes: Scalars['Boolean']['output'];
  isUseProductionLot: Scalars['Boolean']['output'];
  isUseSetupCostSubtotal: Scalars['Boolean']['output'];
  isUseSetupInformation: Scalars['Boolean']['output'];
  isUseSetupRate: Scalars['Boolean']['output'];
  isUseSetupTimeHour: Scalars['Boolean']['output'];
  isUseSetupTimeMinute: Scalars['Boolean']['output'];
  isUseSetupTimeSecond: Scalars['Boolean']['output'];
  kind: Scalars['String']['output'];
  kindLabel: Scalars['String']['output'];
  rateKind: Maybe<Scalars['String']['output']>;
};

export type CommonSupplyPartInfo = {
  __typename?: 'CommonSupplyPartInfo';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  specs: Maybe<Array<CommonSupplyPartSpec>>;
  supplyPartId: Maybe<Scalars['ID']['output']>;
  tenantId: Scalars['ID']['output'];
  unitPrice: Maybe<Scalars['Float']['output']>;
};

export type CommonSupplyPartSpec = {
  __typename?: 'CommonSupplyPartSpec';
  code: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  unit: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type CommonWholesalerKnowledgeInput = {
  makerActualPartName?: InputMaybe<Scalars['String']['input']>;
  nsBcp?: InputMaybe<Array<Scalars['ID']['input']>>;
  nsCredit?: InputMaybe<Array<Scalars['ID']['input']>>;
  nsCsr?: InputMaybe<Array<Scalars['ID']['input']>>;
  nsFlexibility?: InputMaybe<Array<Scalars['ID']['input']>>;
  nsMakerSalesWillingness?: InputMaybe<Array<Scalars['ID']['input']>>;
  quotationItemId: Scalars['ID']['input'];
  salesVolumeAtMaker?: InputMaybe<Scalars['Float']['input']>;
  txLaunch?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of ConfirmCommentRead */
export type ConfirmCommentReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commentNodeId: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
};

/** Autogenerated return type of ConfirmCommentRead. */
export type ConfirmCommentReadPayload = {
  __typename?: 'ConfirmCommentReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ContactClass = {
  __typename?: 'ContactClass';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type Country = {
  __typename?: 'Country';
  id: Scalars['ID']['output'];
  iso3: Maybe<Scalars['String']['output']>;
  name: Scalars['ID']['output'];
  states: Array<State>;
  translation: Maybe<Scalars['String']['output']>;
};

export type CrContactClassLink = {
  __typename?: 'CrContactClassLink';
  contactClass: ContactClass;
  id: Scalars['ID']['output'];
};

export type CrSupplierFirm = {
  __typename?: 'CrSupplierFirm';
  address: Maybe<Address>;
  before: Maybe<CrSupplierFirm>;
  beforeAfterKind: SupplierSurveyBeforeAfterKindEnum;
  businessDescription: Maybe<Scalars['String']['output']>;
  capital: Maybe<Scalars['Float']['output']>;
  capitalCurrency: Maybe<Currency>;
  closingMonth: Maybe<SupplierClosingMonthEnum>;
  companyBackground: Maybe<Scalars['String']['output']>;
  dividendAmount: Maybe<Scalars['Float']['output']>;
  email: Maybe<Scalars['String']['output']>;
  establishedDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  generalKind1Option: Maybe<TenantSelectOption>;
  generalKind2Option: Maybe<TenantSelectOption>;
  generalKind3Option: Maybe<TenantSelectOption>;
  generalKind4Option: Maybe<TenantSelectOption>;
  generalKind5Option: Maybe<TenantSelectOption>;
  generalKind6Option: Maybe<TenantSelectOption>;
  generalKind7Option: Maybe<TenantSelectOption>;
  generalKind8Option: Maybe<TenantSelectOption>;
  generalKind9Option: Maybe<TenantSelectOption>;
  generalKind10Option: Maybe<TenantSelectOption>;
  generalKinds1Options: Array<TenantSelectOption>;
  generalKinds2Options: Array<TenantSelectOption>;
  generalKinds3Options: Array<TenantSelectOption>;
  generalKinds4Options: Array<TenantSelectOption>;
  generalKinds5Options: Array<TenantSelectOption>;
  generalKinds6Options: Array<TenantSelectOption>;
  generalKinds7Options: Array<TenantSelectOption>;
  generalKinds8Options: Array<TenantSelectOption>;
  generalKinds9Options: Array<TenantSelectOption>;
  generalKinds10Options: Array<TenantSelectOption>;
  generalText1: Maybe<Scalars['String']['output']>;
  generalText2: Maybe<Scalars['String']['output']>;
  generalText3: Maybe<Scalars['String']['output']>;
  generalText4: Maybe<Scalars['String']['output']>;
  generalText5: Maybe<Scalars['String']['output']>;
  generalText6: Maybe<Scalars['String']['output']>;
  generalText7: Maybe<Scalars['String']['output']>;
  generalText8: Maybe<Scalars['String']['output']>;
  generalText9: Maybe<Scalars['String']['output']>;
  generalText10: Maybe<Scalars['String']['output']>;
  generalText11: Maybe<Scalars['String']['output']>;
  generalText12: Maybe<Scalars['String']['output']>;
  generalText13: Maybe<Scalars['String']['output']>;
  generalText14: Maybe<Scalars['String']['output']>;
  generalText15: Maybe<Scalars['String']['output']>;
  generalText16: Maybe<Scalars['String']['output']>;
  generalText17: Maybe<Scalars['String']['output']>;
  generalText18: Maybe<Scalars['String']['output']>;
  generalText19: Maybe<Scalars['String']['output']>;
  generalText20: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industry: Maybe<Industry>;
  issuedShares: Maybe<Scalars['Float']['output']>;
  listingKind: Maybe<SupplierListingKindEnum>;
  name: Scalars['String']['output'];
  nameEn: Maybe<Scalars['String']['output']>;
  nameKana: Maybe<Scalars['String']['output']>;
  nameShort: Maybe<Scalars['String']['output']>;
  numberOfEmployees: Maybe<Scalars['Int']['output']>;
  numberOfEmployeesOther: Maybe<Scalars['Int']['output']>;
  president: Maybe<Scalars['String']['output']>;
  startTransactionDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  supplierFirm: SupplierFirm;
  tel: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type CrSupplierFirmBankInfo = {
  __typename?: 'CrSupplierFirmBankInfo';
  before: Maybe<CrSupplierFirmBankInfo>;
  beforeAfterKind: SupplierSurveyBeforeAfterKindEnum;
  borrowingRatio: Maybe<Scalars['Float']['output']>;
  branchName: Maybe<Scalars['String']['output']>;
  financialInstitutionName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  memo: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmBankInfoDelete */
export type CrSupplierFirmBankInfoDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmBankInfoDelete. */
export type CrSupplierFirmBankInfoDeletePayload = {
  __typename?: 'CrSupplierFirmBankInfoDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmBankInfoUpsert */
export type CrSupplierFirmBankInfoUpsertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmBankInfoUpsert. */
export type CrSupplierFirmBankInfoUpsertPayload = {
  __typename?: 'CrSupplierFirmBankInfoUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type CrSupplierFirmCertificationInfo = {
  __typename?: 'CrSupplierFirmCertificationInfo';
  acquisitionDate: Maybe<Scalars['ISO8601Date']['output']>;
  before: Maybe<CrSupplierFirmCertificationInfo>;
  beforeAfterKind: SupplierSurveyBeforeAfterKindEnum;
  certificationAuthorityName: Maybe<Scalars['String']['output']>;
  certificationClass: CertificationClass;
  certificationNumber: Maybe<Scalars['String']['output']>;
  expirationDate: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isRelatedToOwnCompany: Maybe<Scalars['Boolean']['output']>;
  memo: Maybe<Scalars['String']['output']>;
  revisionDate: Maybe<Scalars['ISO8601Date']['output']>;
  updateDate: Maybe<Scalars['ISO8601Date']['output']>;
};

/** Autogenerated input type of CrSupplierFirmCertificationInfoDelete */
export type CrSupplierFirmCertificationInfoDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmCertificationInfoDelete. */
export type CrSupplierFirmCertificationInfoDeletePayload = {
  __typename?: 'CrSupplierFirmCertificationInfoDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmCertificationInfoUpsert */
export type CrSupplierFirmCertificationInfoUpsertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmCertificationInfoUpsert. */
export type CrSupplierFirmCertificationInfoUpsertPayload = {
  __typename?: 'CrSupplierFirmCertificationInfoUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type CrSupplierFirmEmployeeNumberInfo = {
  __typename?: 'CrSupplierFirmEmployeeNumberInfo';
  before: Maybe<CrSupplierFirmEmployeeNumberInfo>;
  beforeAfterKind: SupplierSurveyBeforeAfterKindEnum;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  numberOfEmployees: Maybe<Scalars['Int']['output']>;
  numberOfEmployeesMan: Maybe<Scalars['Int']['output']>;
  numberOfEmployeesWoman: Maybe<Scalars['Int']['output']>;
  showGenderBreakdown: Scalars['Boolean']['output'];
  supplierEmployeeClass: SupplierEmployeeClass;
};

/** Autogenerated input type of CrSupplierFirmEmployeeNumberInfoDelete */
export type CrSupplierFirmEmployeeNumberInfoDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmEmployeeNumberInfoDelete. */
export type CrSupplierFirmEmployeeNumberInfoDeletePayload = {
  __typename?: 'CrSupplierFirmEmployeeNumberInfoDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmEmployeeNumberInfoUpsert */
export type CrSupplierFirmEmployeeNumberInfoUpsertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmEmployeeNumberInfoUpsert. */
export type CrSupplierFirmEmployeeNumberInfoUpsertPayload = {
  __typename?: 'CrSupplierFirmEmployeeNumberInfoUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type CrSupplierFirmEquipmentInfo = {
  __typename?: 'CrSupplierFirmEquipmentInfo';
  before: Maybe<CrSupplierFirmEquipmentInfo>;
  beforeAfterKind: SupplierSurveyBeforeAfterKindEnum;
  category: Maybe<Scalars['String']['output']>;
  equipmentMachineName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  location: Maybe<Scalars['String']['output']>;
  manufacturerName: Maybe<Scalars['String']['output']>;
  model: Maybe<Scalars['String']['output']>;
  productionCapacity: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['Float']['output']>;
  quantityUnit: Maybe<Scalars['String']['output']>;
  remarks: Maybe<Scalars['String']['output']>;
  year: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmEquipmentInfoDelete */
export type CrSupplierFirmEquipmentInfoDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmEquipmentInfoDelete. */
export type CrSupplierFirmEquipmentInfoDeletePayload = {
  __typename?: 'CrSupplierFirmEquipmentInfoDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmEquipmentInfoUpsert */
export type CrSupplierFirmEquipmentInfoUpsertInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  equipmentMachineName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  manufacturerName?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  productionCapacity?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quantityUnit?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  year?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CrSupplierFirmEquipmentInfoUpsert. */
export type CrSupplierFirmEquipmentInfoUpsertPayload = {
  __typename?: 'CrSupplierFirmEquipmentInfoUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type CrSupplierFirmFileInfo = {
  __typename?: 'CrSupplierFirmFileInfo';
  attachment: Attachment;
  before: Maybe<CrSupplierFirmFileInfo>;
  beforeAfterKind: SupplierSurveyBeforeAfterKindEnum;
  expirationDateFrom: Maybe<Scalars['ISO8601Date']['output']>;
  expirationDateTo: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  memo: Maybe<Scalars['String']['output']>;
  registeredAt: Scalars['ISO8601DateTime']['output'];
  registeredBy: Maybe<Scalars['String']['output']>;
  supplierFileClass: SupplierFileClass;
};

/** Autogenerated input type of CrSupplierFirmFileInfoDelete */
export type CrSupplierFirmFileInfoDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmFileInfoDelete. */
export type CrSupplierFirmFileInfoDeletePayload = {
  __typename?: 'CrSupplierFirmFileInfoDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmFileInfoUpsert */
export type CrSupplierFirmFileInfoUpsertInput = {
  attachment: AttachmentInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  expirationDateFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  expirationDateTo?: InputMaybe<Scalars['ISO8601Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  supplierFileClassId?: InputMaybe<Scalars['ID']['input']>;
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmFileInfoUpsert. */
export type CrSupplierFirmFileInfoUpsertPayload = {
  __typename?: 'CrSupplierFirmFileInfoUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type CrSupplierFirmFinancialDetail = {
  __typename?: 'CrSupplierFirmFinancialDetail';
  amount: Maybe<Scalars['Float']['output']>;
  before: Maybe<CrSupplierFirmFinancialDetail>;
  beforeAfterKind: SupplierSurveyBeforeAfterKindEnum;
  changeRate: Maybe<Scalars['Float']['output']>;
  displayAmount: Maybe<Scalars['Float']['output']>;
  financialStatementKind: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  parentId: Maybe<Scalars['ID']['output']>;
  supplierAccountingItem: SupplierAccountingItem;
};

/** Autogenerated input type of CrSupplierFirmFinancialDetailDelete */
export type CrSupplierFirmFinancialDetailDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmFinancialDetailDelete. */
export type CrSupplierFirmFinancialDetailDeletePayload = {
  __typename?: 'CrSupplierFirmFinancialDetailDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmFinancialDetailUpsert */
export type CrSupplierFirmFinancialDetailUpsertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmFinancialDetailUpsert. */
export type CrSupplierFirmFinancialDetailUpsertPayload = {
  __typename?: 'CrSupplierFirmFinancialDetailUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type CrSupplierFirmFinancialInfo = {
  __typename?: 'CrSupplierFirmFinancialInfo';
  before: Maybe<CrSupplierFirmFinancialInfo>;
  beforeAfterKind: SupplierSurveyBeforeAfterKindEnum;
  bsAmountUnitKindLabel: Maybe<Scalars['String']['output']>;
  bsLiabilityNetAssetTotalChangeRate: Maybe<Scalars['Float']['output']>;
  cfAmountUnitKindLabel: Maybe<Scalars['String']['output']>;
  currency: Currency;
  financialStatementPeriodFrom: Maybe<Scalars['ISO8601Date']['output']>;
  financialStatementPeriodTo: Maybe<Scalars['ISO8601Date']['output']>;
  grossProfitMarginRatio: Maybe<Scalars['Float']['output']>;
  grossProfitMarginRatioChangeRate: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  netProfitRatio: Maybe<Scalars['Float']['output']>;
  netProfitRatioChangeRate: Maybe<Scalars['Float']['output']>;
  operatingProfitRatio: Maybe<Scalars['Float']['output']>;
  operatingProfitRatioChangeRate: Maybe<Scalars['Float']['output']>;
  plAmountUnitKindLabel: Maybe<Scalars['String']['output']>;
  salesOperatingProfitRatio: Maybe<Scalars['Float']['output']>;
  salesOperatingProfitRatioChangeRate: Maybe<Scalars['Float']['output']>;
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['output'];
};

/** Autogenerated input type of CrSupplierFirmFinancialInfoDelete */
export type CrSupplierFirmFinancialInfoDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmFinancialInfoDelete. */
export type CrSupplierFirmFinancialInfoDeletePayload = {
  __typename?: 'CrSupplierFirmFinancialInfoDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmFinancialInfoUpsert */
export type CrSupplierFirmFinancialInfoUpsertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmFinancialInfoUpsert. */
export type CrSupplierFirmFinancialInfoUpsertPayload = {
  __typename?: 'CrSupplierFirmFinancialInfoUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type CrSupplierFirmKeyPositionInfo = {
  __typename?: 'CrSupplierFirmKeyPositionInfo';
  age: Maybe<Scalars['Int']['output']>;
  before: Maybe<CrSupplierFirmKeyPositionInfo>;
  beforeAfterKind: SupplierSurveyBeforeAfterKindEnum;
  birthDate: Maybe<Scalars['ISO8601Date']['output']>;
  fullName: Maybe<Scalars['String']['output']>;
  hasRepresentativeAuthority: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  memo: Maybe<Scalars['String']['output']>;
  nameKana: Maybe<Scalars['String']['output']>;
  positionName: Maybe<Scalars['String']['output']>;
  positionStartDate: Maybe<Scalars['ISO8601Date']['output']>;
  responsibilities: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmKeyPositionInfoDelete */
export type CrSupplierFirmKeyPositionInfoDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmKeyPositionInfoDelete. */
export type CrSupplierFirmKeyPositionInfoDeletePayload = {
  __typename?: 'CrSupplierFirmKeyPositionInfoDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmKeyPositionInfoUpsert */
export type CrSupplierFirmKeyPositionInfoUpsertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmKeyPositionInfoUpsert. */
export type CrSupplierFirmKeyPositionInfoUpsertPayload = {
  __typename?: 'CrSupplierFirmKeyPositionInfoUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type CrSupplierFirmLaborSituationInfo = {
  __typename?: 'CrSupplierFirmLaborSituationInfo';
  annualWorkingDays: Maybe<Scalars['Float']['output']>;
  attendanceRate: Maybe<Scalars['Float']['output']>;
  averageAge: Maybe<Scalars['Float']['output']>;
  averageBasicSalary: Maybe<Scalars['Float']['output']>;
  averageOvertimePerPerson: Maybe<Scalars['Float']['output']>;
  averageYearsOfService: Maybe<Scalars['Float']['output']>;
  before: Maybe<CrSupplierFirmLaborSituationInfo>;
  beforeAfterKind: SupplierSurveyBeforeAfterKindEnum;
  holidayType: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  memo: Maybe<Scalars['String']['output']>;
};

export type CrSupplierFirmManufacturingSite = {
  __typename?: 'CrSupplierFirmManufacturingSite';
  address: Maybe<Address>;
  before: Maybe<CrSupplierFirmManufacturingSite>;
  beforeAfterKind: SupplierSurveyBeforeAfterKindEnum;
  buildingArea: Maybe<Scalars['Float']['output']>;
  buildingOwnershipKind: Maybe<SupplierManufacturingSiteBuildingOwnershipKindEnum>;
  businessDescription: Maybe<Scalars['String']['output']>;
  capitalAmount: Maybe<Scalars['Float']['output']>;
  capitalCurrency: Maybe<Currency>;
  code: Maybe<Scalars['String']['output']>;
  establishedDate: Maybe<Scalars['ISO8601Date']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  investmentRatio: Maybe<Scalars['Float']['output']>;
  investmentRatio2: Maybe<Scalars['Float']['output']>;
  investmentTypeName: Maybe<Scalars['String']['output']>;
  investorName: Maybe<Scalars['String']['output']>;
  investorName2: Maybe<Scalars['String']['output']>;
  isArchived: Scalars['Boolean']['output'];
  landArea: Maybe<Scalars['Float']['output']>;
  landOwnershipKind: Maybe<SupplierManufacturingSiteLandOwnershipKindEnum>;
  memo: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  numberOfEmployees: Maybe<Scalars['Int']['output']>;
  numberOfEmployeesOther: Maybe<Scalars['Int']['output']>;
  overseasExpansionDate: Maybe<Scalars['ISO8601Date']['output']>;
  partsMemo: Maybe<Scalars['String']['output']>;
  president: Maybe<Scalars['String']['output']>;
  tel: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmManufacturingSiteDelete */
export type CrSupplierFirmManufacturingSiteDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmManufacturingSiteDelete. */
export type CrSupplierFirmManufacturingSiteDeletePayload = {
  __typename?: 'CrSupplierFirmManufacturingSiteDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmManufacturingSiteUpsert */
export type CrSupplierFirmManufacturingSiteUpsertInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  buildingArea?: InputMaybe<Scalars['Float']['input']>;
  buildingOwnershipKind?: InputMaybe<SupplierManufacturingSiteBuildingOwnershipKindEnum>;
  businessDescription?: InputMaybe<Scalars['String']['input']>;
  capitalAmount?: InputMaybe<Scalars['Float']['input']>;
  capitalCurrencyId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  establishedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  investmentRatio?: InputMaybe<Scalars['Float']['input']>;
  investmentRatio2?: InputMaybe<Scalars['Float']['input']>;
  investmentTypeName?: InputMaybe<Scalars['String']['input']>;
  investorName?: InputMaybe<Scalars['String']['input']>;
  investorName2?: InputMaybe<Scalars['String']['input']>;
  landArea?: InputMaybe<Scalars['Float']['input']>;
  landOwnershipKind?: InputMaybe<SupplierManufacturingSiteLandOwnershipKindEnum>;
  memo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  numberOfEmployeesOther?: InputMaybe<Scalars['Int']['input']>;
  overseasExpansionDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  partsMemo?: InputMaybe<Scalars['String']['input']>;
  president?: InputMaybe<Scalars['String']['input']>;
  stateId?: InputMaybe<Scalars['ID']['input']>;
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  tel?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CrSupplierFirmManufacturingSiteUpsert. */
export type CrSupplierFirmManufacturingSiteUpsertPayload = {
  __typename?: 'CrSupplierFirmManufacturingSiteUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type CrSupplierFirmMemberOrganization = {
  __typename?: 'CrSupplierFirmMemberOrganization';
  before: Maybe<CrSupplierFirmMemberOrganization>;
  beforeAfterKind: SupplierSurveyBeforeAfterKindEnum;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  memo: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type CrSupplierFirmOutsourcingInfo = {
  __typename?: 'CrSupplierFirmOutsourcingInfo';
  address: Maybe<Address>;
  before: Maybe<CrSupplierFirmOutsourcingInfo>;
  beforeAfterKind: SupplierSurveyBeforeAfterKindEnum;
  capitalAmount: Maybe<Scalars['Float']['output']>;
  certificationInfo: Maybe<Scalars['String']['output']>;
  crSupplierOutsourcingClassLinks: Array<CrSupplierOutsourcingClassLink>;
  factory: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industry: Maybe<Scalars['String']['output']>;
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  numberOfEmployees: Maybe<Scalars['Int']['output']>;
  president: Maybe<Scalars['String']['output']>;
  processingType: Maybe<Scalars['String']['output']>;
  purchaseRate: Maybe<Scalars['Float']['output']>;
  remarks: Maybe<Scalars['String']['output']>;
  salesAmount: Maybe<Scalars['Float']['output']>;
  siteName: Maybe<Scalars['String']['output']>;
  tenantDependencyRate: Maybe<Scalars['Float']['output']>;
  transactionAmount: Maybe<Scalars['Float']['output']>;
  transactionItem: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmOutsourcingInfoDelete */
export type CrSupplierFirmOutsourcingInfoDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmOutsourcingInfoDelete. */
export type CrSupplierFirmOutsourcingInfoDeletePayload = {
  __typename?: 'CrSupplierFirmOutsourcingInfoDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmOutsourcingInfoUpsert */
export type CrSupplierFirmOutsourcingInfoUpsertInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  capitalAmount?: InputMaybe<Scalars['Float']['input']>;
  certificationInfo?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  factory?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  president?: InputMaybe<Scalars['String']['input']>;
  processingType?: InputMaybe<Scalars['String']['input']>;
  purchaseRate?: InputMaybe<Scalars['Float']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  salesAmount?: InputMaybe<Scalars['Float']['input']>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  stateId?: InputMaybe<Scalars['ID']['input']>;
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  supplierOutsourcingClassIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantDependencyRate?: InputMaybe<Scalars['Float']['input']>;
  transactionAmount?: InputMaybe<Scalars['Float']['input']>;
  transactionItem?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CrSupplierFirmOutsourcingInfoUpsert. */
export type CrSupplierFirmOutsourcingInfoUpsertPayload = {
  __typename?: 'CrSupplierFirmOutsourcingInfoUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type CrSupplierFirmRepresentativeInfo = {
  __typename?: 'CrSupplierFirmRepresentativeInfo';
  age: Maybe<Scalars['Int']['output']>;
  before: Maybe<CrSupplierFirmRepresentativeInfo>;
  beforeAfterKind: SupplierSurveyBeforeAfterKindEnum;
  biography: Maybe<Scalars['String']['output']>;
  birthDate: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isExistSuccessor: Maybe<Scalars['Boolean']['output']>;
  memo: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  nameEn: Maybe<Scalars['String']['output']>;
  nameKana: Maybe<Scalars['String']['output']>;
  position: Maybe<Scalars['String']['output']>;
  successorAge: Maybe<Scalars['Int']['output']>;
  successorName: Maybe<Scalars['String']['output']>;
  successorRelationship: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmRepresentativeInfoDelete */
export type CrSupplierFirmRepresentativeInfoDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmRepresentativeInfoDelete. */
export type CrSupplierFirmRepresentativeInfoDeletePayload = {
  __typename?: 'CrSupplierFirmRepresentativeInfoDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmRepresentativeInfoUpsert */
export type CrSupplierFirmRepresentativeInfoUpsertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmRepresentativeInfoUpsert. */
export type CrSupplierFirmRepresentativeInfoUpsertPayload = {
  __typename?: 'CrSupplierFirmRepresentativeInfoUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type CrSupplierFirmSalesStatusInfo = {
  __typename?: 'CrSupplierFirmSalesStatusInfo';
  address: Maybe<Address>;
  before: Maybe<CrSupplierFirmSalesStatusInfo>;
  beforeAfterKind: SupplierSurveyBeforeAfterKindEnum;
  companyName: Maybe<Scalars['String']['output']>;
  hasTransactionToTenant: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isTenantSales: Scalars['Boolean']['output'];
  memo: Maybe<Scalars['String']['output']>;
  salesAmount: Maybe<Scalars['Float']['output']>;
  salesPartsMemo: Maybe<Scalars['String']['output']>;
  salesRatio: Maybe<Scalars['Float']['output']>;
};

/** Autogenerated input type of CrSupplierFirmSalesStatusInfoDelete */
export type CrSupplierFirmSalesStatusInfoDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmSalesStatusInfoDelete. */
export type CrSupplierFirmSalesStatusInfoDeletePayload = {
  __typename?: 'CrSupplierFirmSalesStatusInfoDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmSalesStatusInfoUpsert */
export type CrSupplierFirmSalesStatusInfoUpsertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmSalesStatusInfoUpsert. */
export type CrSupplierFirmSalesStatusInfoUpsertPayload = {
  __typename?: 'CrSupplierFirmSalesStatusInfoUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type CrSupplierFirmShareholderInfo = {
  __typename?: 'CrSupplierFirmShareholderInfo';
  before: Maybe<CrSupplierFirmShareholderInfo>;
  beforeAfterKind: SupplierSurveyBeforeAfterKindEnum;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  memo: Maybe<Scalars['String']['output']>;
  percentage: Maybe<Scalars['Float']['output']>;
  shareholderName: Maybe<Scalars['String']['output']>;
  shareholding: Maybe<Scalars['Float']['output']>;
};

/** Autogenerated input type of CrSupplierFirmShareholderInfoDelete */
export type CrSupplierFirmShareholderInfoDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmShareholderInfoDelete. */
export type CrSupplierFirmShareholderInfoDeletePayload = {
  __typename?: 'CrSupplierFirmShareholderInfoDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmShareholderInfoUpsert */
export type CrSupplierFirmShareholderInfoUpsertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmShareholderInfoUpsert. */
export type CrSupplierFirmShareholderInfoUpsertPayload = {
  __typename?: 'CrSupplierFirmShareholderInfoUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type CrSupplierFirmSite = {
  __typename?: 'CrSupplierFirmSite';
  address: Maybe<Address>;
  before: Maybe<CrSupplierFirmSite>;
  beforeAfterKind: SupplierSurveyBeforeAfterKindEnum;
  buildingArea: Maybe<Scalars['Float']['output']>;
  buildingOwnershipKind: Maybe<SupplierSiteBuildingOwnershipKindEnum>;
  businessDescription: Maybe<Scalars['String']['output']>;
  capitalAmount: Maybe<Scalars['Float']['output']>;
  capitalCurrency: Maybe<Currency>;
  code: Maybe<Scalars['String']['output']>;
  establishedDate: Maybe<Scalars['ISO8601Date']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  investmentRatio: Maybe<Scalars['Float']['output']>;
  investmentRatio2: Maybe<Scalars['Float']['output']>;
  investmentTypeName: Maybe<Scalars['String']['output']>;
  investorName: Maybe<Scalars['String']['output']>;
  investorName2: Maybe<Scalars['String']['output']>;
  isArchived: Scalars['Boolean']['output'];
  landArea: Maybe<Scalars['Float']['output']>;
  landOwnershipKind: Maybe<SupplierSiteLandOwnershipKindEnum>;
  memo: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  numberOfEmployees: Maybe<Scalars['Int']['output']>;
  numberOfEmployeesOther: Maybe<Scalars['Int']['output']>;
  overseasExpansionDate: Maybe<Scalars['ISO8601Date']['output']>;
  partsMemo: Maybe<Scalars['String']['output']>;
  president: Maybe<Scalars['String']['output']>;
  tel: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmSiteDelete */
export type CrSupplierFirmSiteDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmSiteDelete. */
export type CrSupplierFirmSiteDeletePayload = {
  __typename?: 'CrSupplierFirmSiteDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmSiteUpsert */
export type CrSupplierFirmSiteUpsertInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  buildingArea?: InputMaybe<Scalars['Float']['input']>;
  buildingOwnershipKind?: InputMaybe<SupplierSiteBuildingOwnershipKindEnum>;
  businessDescription?: InputMaybe<Scalars['String']['input']>;
  capitalAmount?: InputMaybe<Scalars['Float']['input']>;
  capitalCurrencyId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  establishedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  investmentRatio?: InputMaybe<Scalars['Float']['input']>;
  investmentRatio2?: InputMaybe<Scalars['Float']['input']>;
  investmentTypeName?: InputMaybe<Scalars['String']['input']>;
  investorName?: InputMaybe<Scalars['String']['input']>;
  investorName2?: InputMaybe<Scalars['String']['input']>;
  landArea?: InputMaybe<Scalars['Float']['input']>;
  landOwnershipKind?: InputMaybe<SupplierSiteLandOwnershipKindEnum>;
  memo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  numberOfEmployeesOther?: InputMaybe<Scalars['Int']['input']>;
  overseasExpansionDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  partsMemo?: InputMaybe<Scalars['String']['input']>;
  president?: InputMaybe<Scalars['String']['input']>;
  stateId?: InputMaybe<Scalars['ID']['input']>;
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  tel?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CrSupplierFirmSiteUpsert. */
export type CrSupplierFirmSiteUpsertPayload = {
  __typename?: 'CrSupplierFirmSiteUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type CrSupplierFirmSurveyEnqueteAnswer = {
  __typename?: 'CrSupplierFirmSurveyEnqueteAnswer';
  before: Maybe<CrSupplierFirmSurveyEnqueteAnswer>;
  beforeAfterKind: SupplierSurveyBeforeAfterKindEnum;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  supplierEnqueteAnswer: SupplierEnqueteAnswer;
};

/** Autogenerated input type of CrSupplierFirmUpsert */
export type CrSupplierFirmUpsertInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  businessDescription?: InputMaybe<Scalars['String']['input']>;
  capital?: InputMaybe<Scalars['Float']['input']>;
  capitalCurrencyId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  closingMonth?: InputMaybe<Scalars['String']['input']>;
  companyBackground?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  dividendAmount?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  establishedDate?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  generalKind1?: InputMaybe<Scalars['ID']['input']>;
  generalKind2?: InputMaybe<Scalars['ID']['input']>;
  generalKind3?: InputMaybe<Scalars['ID']['input']>;
  generalKind4?: InputMaybe<Scalars['ID']['input']>;
  generalKind5?: InputMaybe<Scalars['ID']['input']>;
  generalKind6?: InputMaybe<Scalars['ID']['input']>;
  generalKind7?: InputMaybe<Scalars['ID']['input']>;
  generalKind8?: InputMaybe<Scalars['ID']['input']>;
  generalKind9?: InputMaybe<Scalars['ID']['input']>;
  generalKind10?: InputMaybe<Scalars['ID']['input']>;
  generalKinds1?: InputMaybe<Array<Scalars['ID']['input']>>;
  generalKinds2?: InputMaybe<Array<Scalars['ID']['input']>>;
  generalKinds3?: InputMaybe<Array<Scalars['ID']['input']>>;
  generalKinds4?: InputMaybe<Array<Scalars['ID']['input']>>;
  generalKinds5?: InputMaybe<Array<Scalars['ID']['input']>>;
  generalKinds6?: InputMaybe<Array<Scalars['ID']['input']>>;
  generalKinds7?: InputMaybe<Array<Scalars['ID']['input']>>;
  generalKinds8?: InputMaybe<Array<Scalars['ID']['input']>>;
  generalKinds9?: InputMaybe<Array<Scalars['ID']['input']>>;
  generalKinds10?: InputMaybe<Array<Scalars['ID']['input']>>;
  generalText1?: InputMaybe<Scalars['String']['input']>;
  generalText2?: InputMaybe<Scalars['String']['input']>;
  generalText3?: InputMaybe<Scalars['String']['input']>;
  generalText4?: InputMaybe<Scalars['String']['input']>;
  generalText5?: InputMaybe<Scalars['String']['input']>;
  generalText6?: InputMaybe<Scalars['String']['input']>;
  generalText7?: InputMaybe<Scalars['String']['input']>;
  generalText8?: InputMaybe<Scalars['String']['input']>;
  generalText9?: InputMaybe<Scalars['String']['input']>;
  generalText10?: InputMaybe<Scalars['String']['input']>;
  generalText11?: InputMaybe<Scalars['String']['input']>;
  generalText12?: InputMaybe<Scalars['String']['input']>;
  generalText13?: InputMaybe<Scalars['String']['input']>;
  generalText14?: InputMaybe<Scalars['String']['input']>;
  generalText15?: InputMaybe<Scalars['String']['input']>;
  generalText16?: InputMaybe<Scalars['String']['input']>;
  generalText17?: InputMaybe<Scalars['String']['input']>;
  generalText18?: InputMaybe<Scalars['String']['input']>;
  generalText19?: InputMaybe<Scalars['String']['input']>;
  generalText20?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  industryId?: InputMaybe<Scalars['ID']['input']>;
  issuedShares?: InputMaybe<Scalars['Float']['input']>;
  listingKind?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  nameKana?: InputMaybe<Scalars['String']['input']>;
  nameShort?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  numberOfEmployeesOther?: InputMaybe<Scalars['Int']['input']>;
  president?: InputMaybe<Scalars['String']['input']>;
  startTransactionDate?: InputMaybe<Scalars['String']['input']>;
  stateId?: InputMaybe<Scalars['ID']['input']>;
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  tel?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CrSupplierFirmUpsert. */
export type CrSupplierFirmUpsertPayload = {
  __typename?: 'CrSupplierFirmUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type CrSupplierFirmUserInfo = {
  __typename?: 'CrSupplierFirmUserInfo';
  address: Maybe<Address>;
  before: Maybe<CrSupplierFirmUserInfo>;
  beforeAfterKind: SupplierSurveyBeforeAfterKindEnum;
  crContactClassLinks: Array<CrContactClassLink>;
  department: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailEmergency: Maybe<Scalars['String']['output']>;
  endOn: Maybe<Scalars['ISO8601DateTime']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  mailingAddress: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nameKana: Maybe<Scalars['String']['output']>;
  startOn: Maybe<Scalars['ISO8601DateTime']['output']>;
  supplierFirm: SupplierFirm;
  tel: Maybe<Scalars['String']['output']>;
  telEmergency: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmUserInfoDelete */
export type CrSupplierFirmUserInfoDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of CrSupplierFirmUserInfoDelete. */
export type CrSupplierFirmUserInfoDeletePayload = {
  __typename?: 'CrSupplierFirmUserInfoDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CrSupplierFirmUserInfoUpsert */
export type CrSupplierFirmUserInfoUpsertInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactClassIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailEmergency?: InputMaybe<Scalars['String']['input']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameKana?: InputMaybe<Scalars['String']['input']>;
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  tel?: InputMaybe<Scalars['String']['input']>;
  telEmergency?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CrSupplierFirmUserInfoUpsert. */
export type CrSupplierFirmUserInfoUpsertPayload = {
  __typename?: 'CrSupplierFirmUserInfoUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type CrSupplierOutsourcingClassLink = {
  __typename?: 'CrSupplierOutsourcingClassLink';
  id: Scalars['ID']['output'];
  supplierOutsourcingClass: SupplierOutsourcingClass;
};

export type CsvExportRes = {
  __typename?: 'CsvExportRes';
  errs: Array<Scalars['String']['output']>;
  result: Maybe<SupplierCsvExportResult>;
};

export type CsvImportErrorRecord = {
  __typename?: 'CsvImportErrorRecord';
  message: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type Currency = {
  __typename?: 'Currency';
  currencyCode: Scalars['String']['output'];
  decimalPrecision: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isBaseCurrency: Scalars['Boolean']['output'];
  numericCode: Scalars['Int']['output'];
  symbol: Scalars['String']['output'];
};

export type DataShare = {
  __typename?: 'DataShare';
  addedCount: Scalars['Int']['output'];
  changedCount: Scalars['Int']['output'];
  deletedCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  sharedAt: Scalars['ISO8601DateTime']['output'];
  updatedCount: Scalars['Int']['output'];
};

/** Autogenerated input type of DeleteComment */
export type DeleteCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteComment. */
export type DeleteCommentPayload = {
  __typename?: 'DeleteCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  commentNode: Maybe<CommentNode>;
  errors: Array<Scalars['String']['output']>;
};

export type DeliveredAnnouncement = {
  __typename?: 'DeliveredAnnouncement';
  announcement: Announcement;
  announcementId: Scalars['Int']['output'];
  confirmedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  supplierUserInfoId: Scalars['Int']['output'];
  tenant: Tenant;
  tenantId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  viewedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of DeliveredAnnouncementConfirm */
export type DeliveredAnnouncementConfirmInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeliveredAnnouncementConfirm. */
export type DeliveredAnnouncementConfirmPayload = {
  __typename?: 'DeliveredAnnouncementConfirmPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  deliveredAnnouncement: Maybe<DeliveredAnnouncement>;
  errors: Array<ValidationErr>;
};

/** The connection type for DeliveredAnnouncement. */
export type DeliveredAnnouncementConnection = {
  __typename?: 'DeliveredAnnouncementConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<DeliveredAnnouncementEdge>>>;
  /** A list of nodes. */
  nodes: Array<DeliveredAnnouncement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeliveredAnnouncementEdge = {
  __typename?: 'DeliveredAnnouncementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<DeliveredAnnouncement>;
};

/** Autogenerated input type of DeliveredAnnouncementView */
export type DeliveredAnnouncementViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeliveredAnnouncementView. */
export type DeliveredAnnouncementViewPayload = {
  __typename?: 'DeliveredAnnouncementViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  deliveredAnnouncement: Maybe<DeliveredAnnouncement>;
  errors: Array<ValidationErr>;
};

export type DeliverySite = {
  __typename?: 'DeliverySite';
  code: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Employee = {
  __typename?: 'Employee';
  email: Maybe<Scalars['String']['output']>;
  employeeNumber: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Enquete = {
  __typename?: 'Enquete';
  answerGranularityKind: EnqueteAnswerGranularityKindEnum;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  displayFrom: Maybe<Scalars['ISO8601DateTime']['output']>;
  displayTo: Maybe<Scalars['ISO8601DateTime']['output']>;
  enqueteDataSchema: Maybe<EnqueteDataSchema>;
  enqueteKind: EnqueteKindEnum;
  id: Scalars['ID']['output'];
  priority: EnquetePriorityEnum;
  questionSchema: Maybe<EnqueteQuestionSchema>;
  status: EnqueteStatusEnum;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type EnqueteAnswer = {
  __typename?: 'EnqueteAnswer';
  answeredAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  enquete: Enquete;
  enqueteDataSchema: Maybe<EnqueteDataSchema>;
  enqueteQuestionAnswers: Array<EnqueteQuestionAnswer>;
  id: Scalars['ID']['output'];
  notificationTargets: Array<EnqueteNotificationTarget>;
  questionSchema: Maybe<EnqueteQuestionSchema>;
  returnReason: Maybe<Scalars['String']['output']>;
  returnedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: EnqueteAnswerStatusEnum;
  supplierUserInfo: Maybe<SupplierUserInfo>;
  supplierUserInfoId: Maybe<Scalars['ID']['output']>;
  supplyChainCompanyEmployeeEmail: Maybe<Scalars['String']['output']>;
  supplyChainCompanyEmployeeName: Maybe<Scalars['String']['output']>;
  supplyChainCompanyEmployeeNumber: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
};

/** The connection type for EnqueteAnswer. */
export type EnqueteAnswerConnection = {
  __typename?: 'EnqueteAnswerConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<EnqueteAnswerEdge>>>;
  /** A list of nodes. */
  nodes: Array<EnqueteAnswer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EnqueteAnswerEdge = {
  __typename?: 'EnqueteAnswerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<EnqueteAnswer>;
};

/** Enquete answer granularity kind enum */
export enum EnqueteAnswerGranularityKindEnum {
  Supplier = 'supplier',
  UserInfo = 'user_info'
}

/** アンケート回答モード */
export enum EnqueteAnswerModeEnum {
  /** 下書き保存 */
  Draft = 'DRAFT',
  /** 正式送信 */
  Submit = 'SUBMIT'
}

/** Enquete answer status enum */
export enum EnqueteAnswerStatusEnum {
  BeforeAnswer = 'before_answer',
  Draft = 'draft',
  Submitted = 'submitted'
}

export type EnqueteDataColumn = {
  __typename?: 'EnqueteDataColumn';
  createdAt: Scalars['ISO8601DateTime']['output'];
  dataType: EnqueteDataColumnKindEnum;
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Enquete data column kind enum */
export enum EnqueteDataColumnKindEnum {
  Date = 'date',
  File = 'file',
  Fixed = 'fixed',
  MultiSelect = 'multi_select',
  Numeric = 'numeric',
  SelectOption = 'select_option',
  Text = 'text'
}

export type EnqueteDataFixedCell = {
  __typename?: 'EnqueteDataFixedCell';
  columnId: Scalars['ID']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  rowId: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value: Scalars['String']['output'];
};

export type EnqueteDataRow = {
  __typename?: 'EnqueteDataRow';
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type EnqueteDataSchema = {
  __typename?: 'EnqueteDataSchema';
  attachments: Array<Attachment>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Scalars['String']['output'];
  enqueteDataColumns: Array<EnqueteDataColumn>;
  enqueteDataFixedCells: Array<EnqueteDataFixedCell>;
  enqueteDataRows: Array<EnqueteDataRow>;
  id: Scalars['ID']['output'];
  referredMaster: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Enquete kind enum */
export enum EnqueteKindEnum {
  Data = 'data',
  General = 'general'
}

export type EnqueteNotificationTarget = {
  __typename?: 'EnqueteNotificationTarget';
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Enquete priority enum */
export enum EnquetePriorityEnum {
  High = 'high',
  Normal = 'normal'
}

export type EnqueteQuestion = {
  __typename?: 'EnqueteQuestion';
  attachments: Array<Attachment>;
  /** この質問に付いた条件分岐（無ければ null） */
  condition: Maybe<EnqueteQuestionCondition>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  length: Maybe<Scalars['Int']['output']>;
  questionKind: EnqueteQuestionKindEnum;
  questionOptions: Array<EnqueteQuestionOption>;
  subQuestions: Array<EnqueteSubQuestion>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type EnqueteQuestionAnswer = {
  __typename?: 'EnqueteQuestionAnswer';
  attachments: Array<Attachment>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  enqueteQuestion: EnqueteQuestion;
  id: Scalars['ID']['output'];
  subQuestionId: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value: Scalars['String']['output'];
};

export type EnqueteQuestionAnswerInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  questionId: Scalars['ID']['input'];
  subQuestionId?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type EnqueteQuestionCondition = {
  __typename?: 'EnqueteQuestionCondition';
  effect: EnqueteQuestionConditionEffectEnum;
  id: Scalars['ID']['output'];
  /** 条件に使う、親の質問の選択肢のID。いずれかが選ばれたら条件を満たす */
  optionIds: Array<Scalars['ID']['output']>;
  parentQuestionId: Scalars['ID']['output'];
  questionId: Scalars['ID']['output'];
};

/** 質問の条件分岐の効果。SHOW は条件を満たすときだけ質問を表示、REQUIRED は条件を満たすとき回答を必須にする */
export enum EnqueteQuestionConditionEffectEnum {
  Required = 'REQUIRED',
  Show = 'SHOW'
}

/** Enquete question kind enum */
export enum EnqueteQuestionKindEnum {
  Date = 'date',
  File = 'file',
  GridSelect = 'grid_select',
  LikertScale = 'likert_scale',
  MultiSelect = 'multi_select',
  Numeric = 'numeric',
  SelectOption = 'select_option',
  Text = 'text'
}

export type EnqueteQuestionOption = {
  __typename?: 'EnqueteQuestionOption';
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type EnqueteQuestionSchema = {
  __typename?: 'EnqueteQuestionSchema';
  attachments: Array<Attachment>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** SAQモードかどうか */
  isSaq: Scalars['Boolean']['output'];
  questionSections: Array<EnqueteQuestionSection>;
  questions: Array<EnqueteQuestion>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type EnqueteQuestionSection = {
  __typename?: 'EnqueteQuestionSection';
  attachments: Array<Attachment>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  questions: Array<EnqueteQuestion>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Enquete status enum */
export enum EnqueteStatusEnum {
  Closed = 'closed',
  Draft = 'draft',
  Published = 'published'
}

export type EnqueteSubQuestion = {
  __typename?: 'EnqueteSubQuestion';
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayOrder: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  questionId: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ErrorRecord = {
  __typename?: 'ErrorRecord';
  message: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type FacilityKind = {
  __typename?: 'FacilityKind';
  code: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isUseAmortizationNumber: Scalars['Boolean']['output'];
  isUseAmortizationPeriod: Scalars['Boolean']['output'];
  isUseAmortizationPeriodAsYear: Scalars['Boolean']['output'];
  isUseCavity: Scalars['Boolean']['output'];
  isUseLeadTime: Scalars['Boolean']['output'];
  isUseLend: Scalars['Boolean']['output'];
  isUseMaker: Scalars['Boolean']['output'];
  isUsePart: Scalars['Boolean']['output'];
  isUsePaymentTimingKind: Scalars['Boolean']['output'];
  isUseProcessing: Scalars['Boolean']['output'];
  isUseRecuttingCount: Scalars['Boolean']['output'];
  isUseSpec: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** Autogenerated input type of GenerateSupplierSurveyInfoImportExcel */
export type GenerateSupplierSurveyInfoImportExcelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of GenerateSupplierSurveyInfoImportExcel. */
export type GenerateSupplierSurveyInfoImportExcelPayload = {
  __typename?: 'GenerateSupplierSurveyInfoImportExcelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  signedUrl: Maybe<Scalars['String']['output']>;
};

export type IncompleteTask = {
  __typename?: 'IncompleteTask';
  /** 一行見積回答のパッケージの見積依頼のとき、一括回答の画面（/supplier_quotation_packages/{id}/answer）のパッケージ ID */
  bulkAnswerPackageId: Maybe<Scalars['ID']['output']>;
  delayed: Scalars['Boolean']['output'];
  dueDate: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  /** トライアル（間接材購買）由来の見積依頼か。true は /trial_quotations へ遷移する（購買受付 GA 由来は false） */
  isTrial: Scalars['Boolean']['output'];
  supplierCode: Maybe<Scalars['String']['output']>;
  taskType: IncompleteTaskEnum;
  tenantId: Maybe<Scalars['ID']['output']>;
  tenantName: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** The connection type for IncompleteTask. */
export type IncompleteTaskConnection = {
  __typename?: 'IncompleteTaskConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<IncompleteTaskEdge>>>;
  /** A list of nodes. */
  nodes: Array<IncompleteTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IncompleteTaskEdge = {
  __typename?: 'IncompleteTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<IncompleteTask>;
};

export enum IncompleteTaskEnum {
  /** 販売価格改定の依頼 */
  PriceAdjustment = 'PRICE_ADJUSTMENT',
  /** 見積の依頼 */
  Quotation = 'QUOTATION',
  /** 会社情報の確認依頼 */
  SupplierFirmInfoConfirmation = 'SUPPLIER_FIRM_INFO_CONFIRMATION'
}

export type Industry = {
  __typename?: 'Industry';
  code: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  tenantId: Scalars['ID']['output'];
};

export type InputFormError = {
  __typename?: 'InputFormError';
  dictKey: Scalars['String']['output'];
  field: Scalars['String']['output'];
  formSchemaCode: Scalars['String']['output'];
  messages: Array<Scalars['String']['output']>;
  seqNo: Maybe<Scalars['Int']['output']>;
};

export type InputFormSchema = {
  __typename?: 'InputFormSchema';
  code: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  dictKey: Scalars['String']['output'];
  properties: Scalars['JSON']['output'];
  tenantId: Maybe<Scalars['ID']['output']>;
};

export type ItemProp = {
  __typename?: 'ItemProp';
  code: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: ItemPropKind;
  name: Scalars['String']['output'];
  unit: Maybe<Scalars['String']['output']>;
};

export type ItemPropInfo = {
  __typename?: 'ItemPropInfo';
  booleanValue: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isUseQuotationInput: Scalars['Boolean']['output'];
  isUseQuotationRequest: Scalars['Boolean']['output'];
  itemProp: ItemProp;
  itemProppableId: Scalars['ID']['output'];
  itemProppableType: Scalars['String']['output'];
  numberValue: Maybe<Scalars['Float']['output']>;
  position: Scalars['Int']['output'];
  selectedOptionIds: Array<Scalars['ID']['output']>;
  /** 選んだ選択肢（表示順）。アーカイブ済みも含む */
  selectedOptions: Array<ItemPropOption>;
  stringValue: Maybe<Scalars['String']['output']>;
};

export enum ItemPropKind {
  AString = 'a_string',
  BNumber = 'b_number',
  CBoolean = 'c_boolean',
  DSelection = 'd_selection'
}

export type ItemPropOption = {
  __typename?: 'ItemPropOption';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

export type ItemRequirement = {
  __typename?: 'ItemRequirement';
  category: Maybe<Category>;
  categoryId: Maybe<Scalars['ID']['output']>;
  code: Maybe<Scalars['String']['output']>;
  designAttachments: Array<Attachment>;
  designChangeCode: Maybe<Scalars['String']['output']>;
  figureNumber: Maybe<Scalars['String']['output']>;
  itemPropInfosForSupplier: Array<ItemPropInfo>;
  makerCode: Maybe<Scalars['String']['output']>;
  makerModelNumber: Maybe<Scalars['String']['output']>;
  makerName: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  rootPartCode: Maybe<Scalars['String']['output']>;
  specAttachments: Array<Attachment>;
};

export type ItemToAnswer = {
  __typename?: 'ItemToAnswer';
  answerPrice: Maybe<AnswerPrice>;
  isDuplicate: Scalars['Boolean']['output'];
  quantity: Scalars['Float']['output'];
  quantityGroup: Scalars['String']['output'];
  quotationItem: QuotationItemV2;
  quotationItemAssemblyEntity: Maybe<QuotationItemAssemblyEntity>;
  rootQuotationItemId: Scalars['ID']['output'];
  seq: Scalars['Int']['output'];
  totalQuantityOnBranch: Scalars['Float']['output'];
};

export type ListViewSchema = {
  __typename?: 'ListViewSchema';
  code: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  listProperties: Array<ListViewSchemaListProperty>;
  searchFormProperties: Array<ListViewSchemaSearchFormProperty>;
  tenantId: Maybe<Scalars['ID']['output']>;
};

export type ListViewSchemaListProperty = {
  __typename?: 'ListViewSchemaListProperty';
  labelDictKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ListViewSchemaSearchFormProperty = {
  __typename?: 'ListViewSchemaSearchFormProperty';
  accountKind: Maybe<Scalars['String']['output']>;
  from: Maybe<Scalars['String']['output']>;
  labelDictKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  optionLabels: Maybe<Array<Scalars['String']['output']>>;
  optionValues: Maybe<Array<Scalars['String']['output']>>;
  selectOptions: Maybe<Array<ListViewSchemaSearchFormSelectOption>>;
  shrinkable: Maybe<Scalars['Boolean']['output']>;
  to: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  withArchived: Maybe<Scalars['Boolean']['output']>;
};

export type ListViewSchemaSearchFormSelectOption = {
  __typename?: 'ListViewSchemaSearchFormSelectOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ManufacturingSite = {
  __typename?: 'ManufacturingSite';
  code: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Mold = {
  __typename?: 'Mold';
  assetNumber: Maybe<Scalars['String']['output']>;
  attachments: Array<Attachment>;
  category: Maybe<Scalars['String']['output']>;
  depth: Maybe<Scalars['Float']['output']>;
  disposeAttachments: Array<Attachment>;
  disposeEvidenceComment: Maybe<Scalars['String']['output']>;
  employee: Employee;
  evidenceComment: Maybe<Scalars['String']['output']>;
  height: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isNew: Maybe<Scalars['Boolean']['output']>;
  isPermanent: Maybe<Scalars['Boolean']['output']>;
  manageable: Maybe<MoldManageable>;
  manageableId: Maybe<Scalars['ID']['output']>;
  manageableType: Maybe<Scalars['String']['output']>;
  moldDispose: MoldDispose;
  moldLifecycleEvent: MoldLifecycleEvent;
  moldProduction: MoldProduction;
  moldStartUp: MoldStartUp;
  moldStorage: MoldStorage;
  moldUsages: Array<MoldUsage>;
  name: Scalars['String']['output'];
  paymentAttachments: Array<Attachment>;
  paymentEvidenceComment: Maybe<Scalars['String']['output']>;
  publicMemo: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  storageAttachments: Array<Attachment>;
  storageEvidenceComment: Maybe<Scalars['String']['output']>;
  storageLocation: Maybe<Scalars['String']['output']>;
  storageSymbol: Maybe<Scalars['String']['output']>;
  supplier: Supplier;
  supplierDisposeReportAttachments: Array<Attachment>;
  supplierDisposeReportComment: Maybe<Scalars['String']['output']>;
  supplierDisposeReportedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  tenantId: Scalars['ID']['output'];
  uid: Scalars['String']['output'];
  weight: Maybe<Scalars['Float']['output']>;
  weightTenantUnit: Maybe<TenantUnit>;
  width: Maybe<Scalars['Float']['output']>;
};

/** The connection type for Mold. */
export type MoldConnection = {
  __typename?: 'MoldConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<MoldEdge>>>;
  /** A list of nodes. */
  nodes: Array<Mold>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MoldDisposalSupplierApplication = {
  __typename?: 'MoldDisposalSupplierApplication';
  applicationDate: Scalars['ISO8601Date']['output'];
  approvalDate: Maybe<Scalars['ISO8601Date']['output']>;
  attachments: Maybe<Array<Attachment>>;
  comment: Scalars['String']['output'];
  confirmationDueDate: Scalars['ISO8601Date']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  employee: Employee;
  id: Scalars['ID']['output'];
  moldDisposalSupplierApplicationDetails: Maybe<Array<MoldDisposalSupplierApplicationDetail>>;
  remandComment: Maybe<Scalars['String']['output']>;
  status: Scalars['Int']['output'];
  supplier: Supplier;
  supplierAccount: Maybe<SupplierAccount>;
  supplierCorporationAttachments: Maybe<Array<Attachment>>;
  supplierUser: Maybe<SupplierUser>;
  tenant: Tenant;
  title: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for MoldDisposalSupplierApplication. */
export type MoldDisposalSupplierApplicationConnection = {
  __typename?: 'MoldDisposalSupplierApplicationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<MoldDisposalSupplierApplicationEdge>>>;
  /** A list of nodes. */
  nodes: Array<MoldDisposalSupplierApplication>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MoldDisposalSupplierApplicationDetail = {
  __typename?: 'MoldDisposalSupplierApplicationDetail';
  createdAt: Scalars['ISO8601DateTime']['output'];
  disposeCost: Maybe<Scalars['Float']['output']>;
  disposeRequestDate: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  mold: Mold;
  moldDisposalSupplierApplicationId: Scalars['ID']['output'];
  publicMemo: Maybe<Scalars['String']['output']>;
  scrapCost: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type MoldDisposalSupplierApplicationDetailInput = {
  disposeCost: Scalars['Float']['input'];
  disposeRequestDate: Scalars['ISO8601Date']['input'];
  moldId: Scalars['ID']['input'];
  publicMemo?: InputMaybe<Scalars['String']['input']>;
  scrapCost?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated input type of MoldDisposalSupplierApplicationDispose */
export type MoldDisposalSupplierApplicationDisposeInput = {
  attachments?: InputMaybe<Array<CommonAttachmentInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of MoldDisposalSupplierApplicationDispose. */
export type MoldDisposalSupplierApplicationDisposePayload = {
  __typename?: 'MoldDisposalSupplierApplicationDisposePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  moldDisposalSupplierApplication: Maybe<MoldDisposalSupplierApplication>;
};

/** An edge in a connection. */
export type MoldDisposalSupplierApplicationEdge = {
  __typename?: 'MoldDisposalSupplierApplicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<MoldDisposalSupplierApplication>;
};

/** Autogenerated input type of MoldDisposalSupplierApplicationSave */
export type MoldDisposalSupplierApplicationSaveInput = {
  attachments?: InputMaybe<Array<CommonAttachmentInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmationDueDate: Scalars['ISO8601Date']['input'];
  employeeId: Scalars['ID']['input'];
  moldDisposalSupplierApplicationDetails: Array<MoldDisposalSupplierApplicationDetailInput>;
  previousId?: InputMaybe<Scalars['ID']['input']>;
  supplierAccountId?: InputMaybe<Scalars['ID']['input']>;
  supplierId: Scalars['ID']['input'];
  supplierUserId?: InputMaybe<Scalars['ID']['input']>;
  tenantId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

/** Autogenerated return type of MoldDisposalSupplierApplicationSave. */
export type MoldDisposalSupplierApplicationSavePayload = {
  __typename?: 'MoldDisposalSupplierApplicationSavePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  moldDisposalSupplierApplication: Maybe<MoldDisposalSupplierApplication>;
};

export type MoldDispose = {
  __typename?: 'MoldDispose';
  disposeCost: Maybe<Scalars['Float']['output']>;
  disposeRequestDate: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  moldId: Scalars['ID']['output'];
  scrapCost: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['ID']['output'];
};

/** An edge in a connection. */
export type MoldEdge = {
  __typename?: 'MoldEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Mold>;
};

export type MoldLifecycleEvent = {
  __typename?: 'MoldLifecycleEvent';
  disposeDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  inspectionReceiptDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  moldId: Scalars['ID']['output'];
  operationStartDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  productionStartNotificationReceiptDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  quoteStatementReceiptDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  storageStartDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  tenantId: Scalars['ID']['output'];
};

export type MoldManageable = {
  __typename?: 'MoldManageable';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MoldProduction = {
  __typename?: 'MoldProduction';
  cumulativePartTransaction: Maybe<Scalars['Int']['output']>;
  flowTendency: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  moldId: Scalars['ID']['output'];
  outputPerShot: Maybe<Scalars['Int']['output']>;
  remainingShotCount: Maybe<Scalars['Int']['output']>;
  shotCount: Maybe<Scalars['Int']['output']>;
  tenantId: Scalars['ID']['output'];
};

export type MoldStartUp = {
  __typename?: 'MoldStartUp';
  acquisitionCost: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  moldId: Scalars['ID']['output'];
  quotedCost: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['ID']['output'];
};

export type MoldStatusCount = {
  __typename?: 'MoldStatusCount';
  dispose: Maybe<Scalars['Int']['output']>;
  production: Maybe<Scalars['Int']['output']>;
  startUp: Maybe<Scalars['Int']['output']>;
  storage: Maybe<Scalars['Int']['output']>;
};

export type MoldStorage = {
  __typename?: 'MoldStorage';
  id: Scalars['ID']['output'];
  moldId: Scalars['ID']['output'];
  retroactivePrice: Maybe<Scalars['Float']['output']>;
  storageCost: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['ID']['output'];
};

export type MoldStoragePayment = {
  __typename?: 'MoldStoragePayment';
  acceptanceDate: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  moldCount: Scalars['Int']['output'];
  moldStoragePaymentItems: Array<MoldStoragePaymentItem>;
  supplier: Supplier;
  tenant: Tenant;
  totalStorageCost: Scalars['Float']['output'];
  uid: Scalars['String']['output'];
};

/** The connection type for MoldStoragePayment. */
export type MoldStoragePaymentConnection = {
  __typename?: 'MoldStoragePaymentConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<MoldStoragePaymentEdge>>>;
  /** A list of nodes. */
  nodes: Array<MoldStoragePayment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MoldStoragePaymentEdge = {
  __typename?: 'MoldStoragePaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<MoldStoragePayment>;
};

export type MoldStoragePaymentItem = {
  __typename?: 'MoldStoragePaymentItem';
  id: Scalars['ID']['output'];
  mold: Mold;
  moldStoragePaymentId: Scalars['ID']['output'];
  storageCost: Scalars['Float']['output'];
  storageStartDate: Scalars['ISO8601Date']['output'];
};

export type MoldTargettable = Part;

export type MoldUsage = {
  __typename?: 'MoldUsage';
  id: Scalars['ID']['output'];
  moldId: Scalars['ID']['output'];
  targettable: Maybe<MoldTargettable>;
  targettableType: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['ID']['output'];
};

export type MoldsForApplication = {
  __typename?: 'MoldsForApplication';
  molds: Array<Mold>;
  supplierCode: Scalars['String']['output'];
  supplierId: Scalars['ID']['output'];
  supplierName: Scalars['String']['output'];
  tenantId: Scalars['ID']['output'];
  tenantName: Scalars['String']['output'];
};

export type MoldsWithStatusCount = {
  __typename?: 'MoldsWithStatusCount';
  moldStatusCount: MoldStatusCount;
  molds: MoldConnection;
};


export type MoldsWithStatusCountMoldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addComment: Maybe<AddCommentPayload>;
  answerByAttachmentFile: Maybe<AnswerByAttachmentFilePayload>;
  answerByFile: Maybe<AnswerByFilePayload>;
  answerCalc: Maybe<AnswerCalcPayload>;
  answerExcelImportV2: Maybe<AnswerExcelImportV2Payload>;
  answerExcelMultipleImport: Maybe<AnswerExcelMultipleImportPayload>;
  answerToGeneralEnquete: Maybe<AnswerToGeneralEnquetePayload>;
  answerUpdateV2: Maybe<AnswerUpdateV2Payload>;
  answerUpsert: Maybe<AnswerUpsertPayload>;
  answerUpsertValidate: Maybe<AnswerUpsertValidatePayload>;
  attachmentOfferDownloadEventCreate: Maybe<AttachmentOfferDownloadEventCreatePayload>;
  attachmentOffersDiscard: Maybe<AttachmentOffersDiscardPayload>;
  bcpIncidentAnswerRequestDraftsSave: Maybe<BcpIncidentAnswerRequestDraftsSavePayload>;
  bcpIncidentAnswerRequestOpened: Maybe<BcpIncidentAnswerRequestOpenedPayload>;
  bcpIncidentAnswerRequestOpenedByToken: Maybe<BcpIncidentAnswerRequestOpenedByTokenPayload>;
  bcpIncidentAnswerRequestPartsPropose: Maybe<BcpIncidentAnswerRequestPartsProposePayload>;
  bcpIncidentAnswerRequestSubmit: Maybe<BcpIncidentAnswerRequestSubmitPayload>;
  bcpIncidentAnswerRequestSubmitByToken: Maybe<BcpIncidentAnswerRequestSubmitByTokenPayload>;
  confirmCommentRead: Maybe<ConfirmCommentReadPayload>;
  crSupplierFirmBankInfoDelete: Maybe<CrSupplierFirmBankInfoDeletePayload>;
  crSupplierFirmBankInfoUpsert: Maybe<CrSupplierFirmBankInfoUpsertPayload>;
  crSupplierFirmCertificationInfoDelete: Maybe<CrSupplierFirmCertificationInfoDeletePayload>;
  crSupplierFirmCertificationInfoUpsert: Maybe<CrSupplierFirmCertificationInfoUpsertPayload>;
  crSupplierFirmEmployeeNumberInfoDelete: Maybe<CrSupplierFirmEmployeeNumberInfoDeletePayload>;
  crSupplierFirmEmployeeNumberInfoUpsert: Maybe<CrSupplierFirmEmployeeNumberInfoUpsertPayload>;
  crSupplierFirmEquipmentInfoDelete: Maybe<CrSupplierFirmEquipmentInfoDeletePayload>;
  crSupplierFirmEquipmentInfoUpsert: Maybe<CrSupplierFirmEquipmentInfoUpsertPayload>;
  crSupplierFirmFileInfoDelete: Maybe<CrSupplierFirmFileInfoDeletePayload>;
  crSupplierFirmFileInfoUpsert: Maybe<CrSupplierFirmFileInfoUpsertPayload>;
  crSupplierFirmFinancialDetailDelete: Maybe<CrSupplierFirmFinancialDetailDeletePayload>;
  crSupplierFirmFinancialDetailUpsert: Maybe<CrSupplierFirmFinancialDetailUpsertPayload>;
  crSupplierFirmFinancialInfoDelete: Maybe<CrSupplierFirmFinancialInfoDeletePayload>;
  crSupplierFirmFinancialInfoUpsert: Maybe<CrSupplierFirmFinancialInfoUpsertPayload>;
  crSupplierFirmKeyPositionInfoDelete: Maybe<CrSupplierFirmKeyPositionInfoDeletePayload>;
  crSupplierFirmKeyPositionInfoUpsert: Maybe<CrSupplierFirmKeyPositionInfoUpsertPayload>;
  crSupplierFirmManufacturingSiteDelete: Maybe<CrSupplierFirmManufacturingSiteDeletePayload>;
  crSupplierFirmManufacturingSiteUpsert: Maybe<CrSupplierFirmManufacturingSiteUpsertPayload>;
  crSupplierFirmOutsourcingInfoDelete: Maybe<CrSupplierFirmOutsourcingInfoDeletePayload>;
  crSupplierFirmOutsourcingInfoUpsert: Maybe<CrSupplierFirmOutsourcingInfoUpsertPayload>;
  crSupplierFirmRepresentativeInfoDelete: Maybe<CrSupplierFirmRepresentativeInfoDeletePayload>;
  crSupplierFirmRepresentativeInfoUpsert: Maybe<CrSupplierFirmRepresentativeInfoUpsertPayload>;
  crSupplierFirmSalesStatusInfoDelete: Maybe<CrSupplierFirmSalesStatusInfoDeletePayload>;
  crSupplierFirmSalesStatusInfoUpsert: Maybe<CrSupplierFirmSalesStatusInfoUpsertPayload>;
  crSupplierFirmShareholderInfoDelete: Maybe<CrSupplierFirmShareholderInfoDeletePayload>;
  crSupplierFirmShareholderInfoUpsert: Maybe<CrSupplierFirmShareholderInfoUpsertPayload>;
  crSupplierFirmSiteDelete: Maybe<CrSupplierFirmSiteDeletePayload>;
  crSupplierFirmSiteUpsert: Maybe<CrSupplierFirmSiteUpsertPayload>;
  crSupplierFirmUpsert: Maybe<CrSupplierFirmUpsertPayload>;
  crSupplierFirmUserInfoDelete: Maybe<CrSupplierFirmUserInfoDeletePayload>;
  crSupplierFirmUserInfoUpsert: Maybe<CrSupplierFirmUserInfoUpsertPayload>;
  deleteComment: Maybe<DeleteCommentPayload>;
  deliveredAnnouncementConfirm: Maybe<DeliveredAnnouncementConfirmPayload>;
  deliveredAnnouncementView: Maybe<DeliveredAnnouncementViewPayload>;
  generateSupplierSurveyInfoImportExcel: Maybe<GenerateSupplierSurveyInfoImportExcelPayload>;
  moldDisposalSupplierApplicationDispose: Maybe<MoldDisposalSupplierApplicationDisposePayload>;
  moldDisposalSupplierApplicationSave: Maybe<MoldDisposalSupplierApplicationSavePayload>;
  packageBulkAnswerAiDraft: Maybe<PackageBulkAnswerAiDraftPayload>;
  packageBulkAnswerSubmit: Maybe<PackageBulkAnswerSubmitPayload>;
  partCsvExport: Maybe<PartCsvExportPayload>;
  priceAdjustmentAmend: Maybe<PriceAdjustmentAmendPayload>;
  priceAdjustmentAmendAsking: Maybe<PriceAdjustmentAmendAskingPayload>;
  priceAdjustmentAmendForm: Maybe<AmendSupplierPriceAdjustmentDraftPayload>;
  priceAdjustmentAnswer: Maybe<PriceAdjustmentAnswerPayload>;
  priceAdjustmentApplication: Maybe<PriceAdjustmentApplicationPayload>;
  priceAdjustmentApprove: Maybe<PriceAdjustmentApprovePayload>;
  priceAdjustmentAsk: Maybe<PriceAdjustmentAskPayload>;
  priceAdjustmentClose: Maybe<PriceAdjustmentClosePayload>;
  priceAdjustmentComplete: Maybe<PriceAdjustmentCompletePayload>;
  priceAdjustmentCreateByPartOrderUnitPrice: Maybe<PriceAdjustmentCreateByPartOrderUnitPricePayload>;
  priceAdjustmentDelete: Maybe<PriceAdjustmentDeletePayload>;
  priceAdjustmentExcelExport: Maybe<PriceAdjustmentExcelExportPayload>;
  priceAdjustmentExcelRegistrationExport: Maybe<PriceAdjustmentExcelRegistrationExportPayload>;
  priceAdjustmentExcelSchemaExport: Maybe<PriceAdjustmentExcelSchemaExportPayload>;
  priceAdjustmentExcelSchemaImport: Maybe<PriceAdjustmentExcelSchemaImportPayload>;
  priceAdjustmentItemValidate: Maybe<PriceAdjustmentItemValidatePayload>;
  priceAdjustmentSave: Maybe<PriceAdjustmentSavePayload>;
  priceAdjustmentUpdate: Maybe<PriceAdjustmentUpdatePayload>;
  priceAdjustmentWithdraw: Maybe<PriceAdjustmentWithdrawPayload>;
  priceAdjustmentsCreatableCheck: Maybe<PriceAdjustmentsCreatableCheckPayload>;
  priceAdjustmentsCreatableCheckByIds: Maybe<PriceAdjustmentsCreatableCheckByIdsPayload>;
  priceAdjustmentsCreate: Maybe<PriceAdjustmentsCreatePayload>;
  priceAdjustmentsCsvCreate: Maybe<PriceAdjustmentsCsvCreatePayload>;
  profileUpdate: Maybe<ProfileUpdatePayload>;
  quotationsDecline: Maybe<QuotationsDeclinePayload>;
  shareCommentUpsert: Maybe<ShareCommentUpsertPayload>;
  sharedDataCsvExport: Maybe<SharedDataCsvExportPayload>;
  sharedDataCsvImport: Maybe<SharedDataCsvImportPayload>;
  supplierAccountInvitationBySupplierFrontendComplete: Maybe<SupplierAccountInvitationBySupplierFrontendCompletePayload>;
  supplierAccountInvitationBySupplierFrontendDelete: Maybe<SupplierAccountInvitationBySupplierFrontendDeletePayload>;
  supplierAccountInvitationBySupplierFrontendUpsert: Maybe<SupplierAccountInvitationBySupplierFrontendUpsertPayload>;
  supplierAccountInvitationByTenantFrontendComplete: Maybe<SupplierAccountInvitationByTenantFrontendCompletePayload>;
  supplierAccountSelectedTenantUpdate: Maybe<SupplierAccountSelectedTenantUpdatePayload>;
  supplierAccountTenantLinkDelete: Maybe<SupplierAccountTenantLinkDeletePayload>;
  supplierAccountTenantLinkRestore: Maybe<SupplierAccountTenantLinkRestorePayload>;
  supplierAccountTenantLinkUpsert: Maybe<SupplierAccountTenantLinkUpsertPayload>;
  supplierAnnouncementsRead: Maybe<SupplierAnnouncementsReadPayload>;
  supplierCorporationEmployeeArchive: Maybe<SupplierCorporationEmployeeArchivePayload>;
  supplierCorporationEmployeeUnarchive: Maybe<SupplierCorporationEmployeeUnarchivePayload>;
  supplierFirmInfoConfirmationRequestStatusUpdate: Maybe<SupplierFirmInfoConfirmationRequestStatusUpdatePayload>;
  supplierMoldStorageApplicationSave: Maybe<SupplierMoldStorageApplicationSavePayload>;
  supplierSurveyInfoExcelImport: Maybe<SupplierSurveyInfoExcelImportPayload>;
  supplyPartCsvExport: Maybe<SupplyPartCsvExportPayload>;
  trialQuotationAnswerAiDraft: Maybe<TrialQuotationAnswerAiDraftPayload>;
  trialQuotationAnswerCancel: Maybe<TrialQuotationAnswerCancelPayload>;
  trialQuotationAnswerSubmit: Maybe<TrialQuotationAnswerSubmitPayload>;
  trialQuotationAttachmentClassify: Maybe<TrialQuotationAttachmentClassifyPayload>;
  updateComment: Maybe<UpdateCommentPayload>;
};


export type MutationAddCommentArgs = {
  input: AddCommentInput;
};


export type MutationAnswerByAttachmentFileArgs = {
  input: AnswerByAttachmentFileInput;
};


export type MutationAnswerByFileArgs = {
  input: AnswerByFileInput;
};


export type MutationAnswerCalcArgs = {
  input: AnswerCalcInput;
};


export type MutationAnswerExcelImportV2Args = {
  input: AnswerExcelImportV2Input;
};


export type MutationAnswerExcelMultipleImportArgs = {
  input: AnswerExcelMultipleImportInput;
};


export type MutationAnswerToGeneralEnqueteArgs = {
  input: AnswerToGeneralEnqueteInput;
};


export type MutationAnswerUpdateV2Args = {
  input: AnswerUpdateV2Input;
};


export type MutationAnswerUpsertArgs = {
  input: AnswerUpsertInput;
};


export type MutationAnswerUpsertValidateArgs = {
  input: AnswerUpsertValidateInput;
};


export type MutationAttachmentOfferDownloadEventCreateArgs = {
  input: AttachmentOfferDownloadEventCreateInput;
};


export type MutationAttachmentOffersDiscardArgs = {
  input: AttachmentOffersDiscardInput;
};


export type MutationBcpIncidentAnswerRequestDraftsSaveArgs = {
  input: BcpIncidentAnswerRequestDraftsSaveInput;
};


export type MutationBcpIncidentAnswerRequestOpenedArgs = {
  input: BcpIncidentAnswerRequestOpenedInput;
};


export type MutationBcpIncidentAnswerRequestOpenedByTokenArgs = {
  input: BcpIncidentAnswerRequestOpenedByTokenInput;
};


export type MutationBcpIncidentAnswerRequestPartsProposeArgs = {
  input: BcpIncidentAnswerRequestPartsProposeInput;
};


export type MutationBcpIncidentAnswerRequestSubmitArgs = {
  input: BcpIncidentAnswerRequestSubmitInput;
};


export type MutationBcpIncidentAnswerRequestSubmitByTokenArgs = {
  input: BcpIncidentAnswerRequestSubmitByTokenInput;
};


export type MutationConfirmCommentReadArgs = {
  input: ConfirmCommentReadInput;
};


export type MutationCrSupplierFirmBankInfoDeleteArgs = {
  input: CrSupplierFirmBankInfoDeleteInput;
};


export type MutationCrSupplierFirmBankInfoUpsertArgs = {
  input: CrSupplierFirmBankInfoUpsertInput;
};


export type MutationCrSupplierFirmCertificationInfoDeleteArgs = {
  input: CrSupplierFirmCertificationInfoDeleteInput;
};


export type MutationCrSupplierFirmCertificationInfoUpsertArgs = {
  input: CrSupplierFirmCertificationInfoUpsertInput;
};


export type MutationCrSupplierFirmEmployeeNumberInfoDeleteArgs = {
  input: CrSupplierFirmEmployeeNumberInfoDeleteInput;
};


export type MutationCrSupplierFirmEmployeeNumberInfoUpsertArgs = {
  input: CrSupplierFirmEmployeeNumberInfoUpsertInput;
};


export type MutationCrSupplierFirmEquipmentInfoDeleteArgs = {
  input: CrSupplierFirmEquipmentInfoDeleteInput;
};


export type MutationCrSupplierFirmEquipmentInfoUpsertArgs = {
  input: CrSupplierFirmEquipmentInfoUpsertInput;
};


export type MutationCrSupplierFirmFileInfoDeleteArgs = {
  input: CrSupplierFirmFileInfoDeleteInput;
};


export type MutationCrSupplierFirmFileInfoUpsertArgs = {
  input: CrSupplierFirmFileInfoUpsertInput;
};


export type MutationCrSupplierFirmFinancialDetailDeleteArgs = {
  input: CrSupplierFirmFinancialDetailDeleteInput;
};


export type MutationCrSupplierFirmFinancialDetailUpsertArgs = {
  input: CrSupplierFirmFinancialDetailUpsertInput;
};


export type MutationCrSupplierFirmFinancialInfoDeleteArgs = {
  input: CrSupplierFirmFinancialInfoDeleteInput;
};


export type MutationCrSupplierFirmFinancialInfoUpsertArgs = {
  input: CrSupplierFirmFinancialInfoUpsertInput;
};


export type MutationCrSupplierFirmKeyPositionInfoDeleteArgs = {
  input: CrSupplierFirmKeyPositionInfoDeleteInput;
};


export type MutationCrSupplierFirmKeyPositionInfoUpsertArgs = {
  input: CrSupplierFirmKeyPositionInfoUpsertInput;
};


export type MutationCrSupplierFirmManufacturingSiteDeleteArgs = {
  input: CrSupplierFirmManufacturingSiteDeleteInput;
};


export type MutationCrSupplierFirmManufacturingSiteUpsertArgs = {
  input: CrSupplierFirmManufacturingSiteUpsertInput;
};


export type MutationCrSupplierFirmOutsourcingInfoDeleteArgs = {
  input: CrSupplierFirmOutsourcingInfoDeleteInput;
};


export type MutationCrSupplierFirmOutsourcingInfoUpsertArgs = {
  input: CrSupplierFirmOutsourcingInfoUpsertInput;
};


export type MutationCrSupplierFirmRepresentativeInfoDeleteArgs = {
  input: CrSupplierFirmRepresentativeInfoDeleteInput;
};


export type MutationCrSupplierFirmRepresentativeInfoUpsertArgs = {
  input: CrSupplierFirmRepresentativeInfoUpsertInput;
};


export type MutationCrSupplierFirmSalesStatusInfoDeleteArgs = {
  input: CrSupplierFirmSalesStatusInfoDeleteInput;
};


export type MutationCrSupplierFirmSalesStatusInfoUpsertArgs = {
  input: CrSupplierFirmSalesStatusInfoUpsertInput;
};


export type MutationCrSupplierFirmShareholderInfoDeleteArgs = {
  input: CrSupplierFirmShareholderInfoDeleteInput;
};


export type MutationCrSupplierFirmShareholderInfoUpsertArgs = {
  input: CrSupplierFirmShareholderInfoUpsertInput;
};


export type MutationCrSupplierFirmSiteDeleteArgs = {
  input: CrSupplierFirmSiteDeleteInput;
};


export type MutationCrSupplierFirmSiteUpsertArgs = {
  input: CrSupplierFirmSiteUpsertInput;
};


export type MutationCrSupplierFirmUpsertArgs = {
  input: CrSupplierFirmUpsertInput;
};


export type MutationCrSupplierFirmUserInfoDeleteArgs = {
  input: CrSupplierFirmUserInfoDeleteInput;
};


export type MutationCrSupplierFirmUserInfoUpsertArgs = {
  input: CrSupplierFirmUserInfoUpsertInput;
};


export type MutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};


export type MutationDeliveredAnnouncementConfirmArgs = {
  input: DeliveredAnnouncementConfirmInput;
};


export type MutationDeliveredAnnouncementViewArgs = {
  input: DeliveredAnnouncementViewInput;
};


export type MutationGenerateSupplierSurveyInfoImportExcelArgs = {
  input: GenerateSupplierSurveyInfoImportExcelInput;
};


export type MutationMoldDisposalSupplierApplicationDisposeArgs = {
  input: MoldDisposalSupplierApplicationDisposeInput;
};


export type MutationMoldDisposalSupplierApplicationSaveArgs = {
  input: MoldDisposalSupplierApplicationSaveInput;
};


export type MutationPackageBulkAnswerAiDraftArgs = {
  input: PackageBulkAnswerAiDraftInput;
};


export type MutationPackageBulkAnswerSubmitArgs = {
  input: PackageBulkAnswerSubmitInput;
};


export type MutationPartCsvExportArgs = {
  input: PartCsvExportInput;
};


export type MutationPriceAdjustmentAmendArgs = {
  input: PriceAdjustmentAmendInput;
};


export type MutationPriceAdjustmentAmendAskingArgs = {
  input: PriceAdjustmentAmendAskingInput;
};


export type MutationPriceAdjustmentAmendFormArgs = {
  input: AmendSupplierPriceAdjustmentDraftInput;
};


export type MutationPriceAdjustmentAnswerArgs = {
  input: PriceAdjustmentAnswerInput;
};


export type MutationPriceAdjustmentApplicationArgs = {
  input: PriceAdjustmentApplicationInput;
};


export type MutationPriceAdjustmentApproveArgs = {
  input: PriceAdjustmentApproveInput;
};


export type MutationPriceAdjustmentAskArgs = {
  input: PriceAdjustmentAskInput;
};


export type MutationPriceAdjustmentCloseArgs = {
  input: PriceAdjustmentCloseInput;
};


export type MutationPriceAdjustmentCompleteArgs = {
  input: PriceAdjustmentCompleteInput;
};


export type MutationPriceAdjustmentCreateByPartOrderUnitPriceArgs = {
  input: PriceAdjustmentCreateByPartOrderUnitPriceInput;
};


export type MutationPriceAdjustmentDeleteArgs = {
  input: PriceAdjustmentDeleteInput;
};


export type MutationPriceAdjustmentExcelExportArgs = {
  input: PriceAdjustmentExcelExportInput;
};


export type MutationPriceAdjustmentExcelRegistrationExportArgs = {
  input: PriceAdjustmentExcelRegistrationExportInput;
};


export type MutationPriceAdjustmentExcelSchemaExportArgs = {
  input: PriceAdjustmentExcelSchemaExportInput;
};


export type MutationPriceAdjustmentExcelSchemaImportArgs = {
  input: PriceAdjustmentExcelSchemaImportInput;
};


export type MutationPriceAdjustmentItemValidateArgs = {
  input: PriceAdjustmentItemValidateInput;
};


export type MutationPriceAdjustmentSaveArgs = {
  input: PriceAdjustmentSaveInput;
};


export type MutationPriceAdjustmentUpdateArgs = {
  input: PriceAdjustmentUpdateInput;
};


export type MutationPriceAdjustmentWithdrawArgs = {
  input: PriceAdjustmentWithdrawInput;
};


export type MutationPriceAdjustmentsCreatableCheckArgs = {
  input: PriceAdjustmentsCreatableCheckInput;
};


export type MutationPriceAdjustmentsCreatableCheckByIdsArgs = {
  input: PriceAdjustmentsCreatableCheckByIdsInput;
};


export type MutationPriceAdjustmentsCreateArgs = {
  input: PriceAdjustmentsCreateInput;
};


export type MutationPriceAdjustmentsCsvCreateArgs = {
  input: PriceAdjustmentsCsvCreateInput;
};


export type MutationProfileUpdateArgs = {
  input: ProfileUpdateInput;
};


export type MutationQuotationsDeclineArgs = {
  input: QuotationsDeclineInput;
};


export type MutationShareCommentUpsertArgs = {
  input: ShareCommentUpsertInput;
};


export type MutationSharedDataCsvExportArgs = {
  input: SharedDataCsvExportInput;
};


export type MutationSharedDataCsvImportArgs = {
  input: SharedDataCsvImportInput;
};


export type MutationSupplierAccountInvitationBySupplierFrontendCompleteArgs = {
  input: SupplierAccountInvitationBySupplierFrontendCompleteInput;
};


export type MutationSupplierAccountInvitationBySupplierFrontendDeleteArgs = {
  input: SupplierAccountInvitationBySupplierFrontendDeleteInput;
};


export type MutationSupplierAccountInvitationBySupplierFrontendUpsertArgs = {
  input: SupplierAccountInvitationBySupplierFrontendUpsertInput;
};


export type MutationSupplierAccountInvitationByTenantFrontendCompleteArgs = {
  input: SupplierAccountInvitationByTenantFrontendCompleteInput;
};


export type MutationSupplierAccountSelectedTenantUpdateArgs = {
  input: SupplierAccountSelectedTenantUpdateInput;
};


export type MutationSupplierAccountTenantLinkDeleteArgs = {
  input: SupplierAccountTenantLinkDeleteInput;
};


export type MutationSupplierAccountTenantLinkRestoreArgs = {
  input: SupplierAccountTenantLinkRestoreInput;
};


export type MutationSupplierAccountTenantLinkUpsertArgs = {
  input: SupplierAccountTenantLinkUpsertInput;
};


export type MutationSupplierAnnouncementsReadArgs = {
  input: SupplierAnnouncementsReadInput;
};


export type MutationSupplierCorporationEmployeeArchiveArgs = {
  input: SupplierCorporationEmployeeArchiveInput;
};


export type MutationSupplierCorporationEmployeeUnarchiveArgs = {
  input: SupplierCorporationEmployeeUnarchiveInput;
};


export type MutationSupplierFirmInfoConfirmationRequestStatusUpdateArgs = {
  input: SupplierFirmInfoConfirmationRequestStatusUpdateInput;
};


export type MutationSupplierMoldStorageApplicationSaveArgs = {
  input: SupplierMoldStorageApplicationSaveInput;
};


export type MutationSupplierSurveyInfoExcelImportArgs = {
  input: SupplierSurveyInfoExcelImportInput;
};


export type MutationSupplyPartCsvExportArgs = {
  input: SupplyPartCsvExportInput;
};


export type MutationTrialQuotationAnswerAiDraftArgs = {
  input: TrialQuotationAnswerAiDraftInput;
};


export type MutationTrialQuotationAnswerCancelArgs = {
  input: TrialQuotationAnswerCancelInput;
};


export type MutationTrialQuotationAnswerSubmitArgs = {
  input: TrialQuotationAnswerSubmitInput;
};


export type MutationTrialQuotationAttachmentClassifyArgs = {
  input: TrialQuotationAttachmentClassifyInput;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};

/** Autogenerated input type of PackageBulkAnswerAiDraft */
export type PackageBulkAnswerAiDraftInput = {
  answerMemo?: InputMaybe<Scalars['String']['input']>;
  attachments: Array<CommonAttachmentInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  packageId: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
};

/** Autogenerated return type of PackageBulkAnswerAiDraft. */
export type PackageBulkAnswerAiDraftPayload = {
  __typename?: 'PackageBulkAnswerAiDraftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** AI が読み取った通貨（テナントが使う通貨のみ） */
  currencyId: Maybe<Scalars['ID']['output']>;
  errors: Array<Scalars['String']['output']>;
  /** 見積有効期限（AI 起票） */
  expirationDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** AI からの注記（読み取りの不確かさ等） */
  note: Maybe<Scalars['String']['output']>;
  quotationNo: Maybe<Scalars['String']['output']>;
  rows: Array<PackageBulkAnswerAiDraftRow>;
};

export type PackageBulkAnswerAiDraftRow = {
  __typename?: 'PackageBulkAnswerAiDraftRow';
  /** 一式のときの税抜金額（品目の合計） */
  amountExcludingTax: Maybe<Scalars['String']['output']>;
  /** 見積書に取り扱いなし・対応不可とある品目。辞退は人が選ぶ（画面は目印を出すだけ） */
  declineSuggested: Scalars['Boolean']['output'];
  deliveryDay: Maybe<Scalars['Int']['output']>;
  /** per_unit（単価）または lump_sum（一式） */
  priceBasis: Scalars['String']['output'];
  quotationRequestId: Scalars['ID']['output'];
  /** 単価のときの税抜単価 */
  unitPrice: Maybe<Scalars['String']['output']>;
};

export type PackageBulkAnswerHeaderInput = {
  attachments?: InputMaybe<Array<CommonAttachmentInput>>;
  currencyId?: InputMaybe<Scalars['ID']['input']>;
  dayType?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  quotationNo?: InputMaybe<Scalars['String']['input']>;
};

export type PackageBulkAnswerRowError = {
  __typename?: 'PackageBulkAnswerRowError';
  formErrors: Array<InputFormError>;
  messages: Array<Scalars['String']['output']>;
  quotationRequestId: Scalars['ID']['output'];
};

export type PackageBulkAnswerRowInput = {
  /** 一式のときの金額（品目の合計）。外税なら税抜、内税なら税込 */
  amountExcludingTax?: InputMaybe<Scalars['String']['input']>;
  /** 画面が読んだ時点の回答の版（行の baseUpdatedAt）。未回答の行は省く。今と違えば conflict */
  baseUpdatedAt?: InputMaybe<Scalars['String']['input']>;
  deliveryDay?: InputMaybe<Scalars['Int']['input']>;
  isDeclined?: InputMaybe<Scalars['Boolean']['input']>;
  /** per_unit（単価）または lump_sum（一式）。省くと per_unit */
  priceBasis?: InputMaybe<Scalars['String']['input']>;
  quotationRequestId: Scalars['ID']['input'];
  /** 税区分 0外税 1内税 2非課税 3不課税。省くと 0（通常の見積では無視して 0） */
  taxType?: InputMaybe<Scalars['Int']['input']>;
  /** 単価のときの単価。外税なら税抜、内税なら税込 */
  unitPrice?: InputMaybe<Scalars['String']['input']>;
};

export type PackageBulkAnswerSheet = {
  __typename?: 'PackageBulkAnswerSheet';
  /** パッケージ内の最も早い回答期限 */
  answerDueDate: Maybe<Scalars['ISO8601Date']['output']>;
  answerEntryKind: Scalars['String']['output'];
  /** 依頼文・添付・通貨の候補など、依頼単位の表示用 */
  firstQuotation: Maybe<Quotation>;
  /** 既存の回答（下書き含む）のうち最後に更新した 1 件。通貨・見積番号・有効期限・備考・添付の初期値 */
  headerAnswer: Maybe<Answer>;
  packageId: Scalars['ID']['output'];
  requestAttachmentOffers: Array<AttachmentOffer>;
  /** パッケージの全見積の依頼の添付（同じファイルは 1 件） */
  requestAttachments: Array<Attachment>;
  rows: Array<PackageBulkAnswerSheetRow>;
  supplierCode: Scalars['String']['output'];
  supplierName: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PackageBulkAnswerSheetRow = {
  __typename?: 'PackageBulkAnswerSheetRow';
  amountExcludingTax: Maybe<Scalars['String']['output']>;
  /** 内税のときだけ返す税込の総額（開き直したとき、入力した税込の金額に戻す用）。内税以外・未回答は null */
  amountIncludingTax: Maybe<Scalars['String']['output']>;
  /** 排他用。提出時に行の baseUpdatedAt としてそのまま返す。未回答は null */
  baseUpdatedAt: Maybe<Scalars['String']['output']>;
  deliveryDay: Maybe<Scalars['Int']['output']>;
  /** 見積条件の希望納期。読み取り専用（回答の納期とは別）。無ければ null */
  desiredDeliveryDueOn: Maybe<Scalars['ISO8601Date']['output']>;
  /** false の行（選定承認中・締め切り後など）は読み取り専用で、提出の対象にならない */
  isCanBeAnswered: Scalars['Boolean']['output'];
  isDeclined: Scalars['Boolean']['output'];
  makerModel: Scalars['String']['output'];
  makerName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  priceBasis: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  quotationId: Scalars['ID']['output'];
  quotationItemId: Scalars['ID']['output'];
  quotationRequestId: Scalars['ID']['output'];
  /** サプライヤー向けの回答状況（QuotationRequest#status_for_supplier_kind） */
  status: Scalars['String']['output'];
  /** 税区分 0外税 1内税 2非課税 3不課税。未回答の行は null */
  taxType: Maybe<Scalars['Int']['output']>;
  unitName: Maybe<Scalars['String']['output']>;
  unitPrice: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of PackageBulkAnswerSubmit */
export type PackageBulkAnswerSubmitInput = {
  /** draft（下書き保存）または final_answer（提出） */
  answerStatus: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** conflict を確認したうえで上書きする */
  force?: InputMaybe<Scalars['Boolean']['input']>;
  header: PackageBulkAnswerHeaderInput;
  packageId: Scalars['ID']['input'];
  rows: Array<PackageBulkAnswerRowInput>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
};

/** Autogenerated return type of PackageBulkAnswerSubmit. */
export type PackageBulkAnswerSubmitPayload = {
  __typename?: 'PackageBulkAnswerSubmitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  conflictQuotationRequestIds: Array<Scalars['ID']['output']>;
  errors: Array<Scalars['String']['output']>;
  isConflict: Scalars['Boolean']['output'];
  isSuccess: Scalars['Boolean']['output'];
  rowErrors: Array<PackageBulkAnswerRowError>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

export type Part = {
  __typename?: 'Part';
  activePartOrderUnitPrices: Array<PartOrderUnitPrice>;
  activePartPrices: Maybe<Array<PartPrice>>;
  category: Category;
  code: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deliverySiteObjects: Array<DeliverySite>;
  deliverySites: Array<DeliverySite>;
  displayCode: Scalars['String']['output'];
  figureNumber: Maybe<Scalars['String']['output']>;
  flowTendency: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAdjustable: Scalars['Boolean']['output'];
  isEnd: Scalars['Boolean']['output'];
  isNew: Maybe<Scalars['Boolean']['output']>;
  isNotEnd: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  oneAnswerFormat: AnswerFormat;
  partAnnualTotal: Maybe<PartAnnualTotal>;
  partAttachmentDesign: Maybe<PartAttachment>;
  partAttachmentSpec: Maybe<PartAttachment>;
  partTransactions: Maybe<Array<PartTransaction>>;
  partUnofficialAnnouncement: Maybe<PartUnofficialAnnouncement>;
  purchaseGroupPart: Maybe<PurchaseGroupPart>;
  quotaionDesignAttachments: Array<QuotationAttachment>;
  quotaionSpecAttachments: Array<QuotationAttachment>;
  receiverCode: Maybe<Scalars['String']['output']>;
  receiverName: Maybe<Scalars['String']['output']>;
  rootPartCode: Maybe<Scalars['String']['output']>;
  sameGroupParts: Array<Part>;
  supplyPartInfo: Maybe<CommonSupplyPartInfo>;
  temporaryCode: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['ID']['output'];
  totalReceivedQuantity: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PartAnnualTotal = {
  __typename?: 'PartAnnualTotal';
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  partId: Scalars['ID']['output'];
  quantity1: Scalars['Float']['output'];
  quantity2: Scalars['Float']['output'];
  quantity3: Scalars['Float']['output'];
  quantity4: Scalars['Float']['output'];
  quantity5: Scalars['Float']['output'];
  quantity6: Scalars['Float']['output'];
  quantity7: Scalars['Float']['output'];
  quantity8: Scalars['Float']['output'];
  quantity9: Scalars['Float']['output'];
  quantity10: Scalars['Float']['output'];
  quantity11: Scalars['Float']['output'];
  quantity12: Scalars['Float']['output'];
  recordedOn: Scalars['ISO8601Date']['output'];
  supplierId: Scalars['ID']['output'];
  tenantId: Scalars['ID']['output'];
};

export type PartAttachment = {
  __typename?: 'PartAttachment';
  attachments: Array<Attachment>;
  id: Scalars['ID']['output'];
  partAttachmentKind: Scalars['String']['output'];
  partId: Scalars['ID']['output'];
  tenantId: Scalars['ID']['output'];
};

/** Autogenerated input type of PartCsvExport */
export type PartCsvExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  conditionsText?: InputMaybe<Scalars['String']['input']>;
  figureNumber?: InputMaybe<Scalars['String']['input']>;
  referenceDate?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
};

/** Autogenerated return type of PartCsvExport. */
export type PartCsvExportPayload = {
  __typename?: 'PartCsvExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  res: CsvExportRes;
};

export type PartFacilityPrice = {
  __typename?: 'PartFacilityPrice';
  acquiredOn: Maybe<Scalars['ISO8601Date']['output']>;
  amortizationCost: Maybe<Scalars['Float']['output']>;
  amortizationNumber: Maybe<Scalars['Int']['output']>;
  facilityCost: Maybe<Scalars['Float']['output']>;
  facilityKind: FacilityKind;
  facilityKindId: Scalars['ID']['output'];
  id: Maybe<Scalars['ID']['output']>;
  memo: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  paymentEndOn: Maybe<Scalars['ISO8601Date']['output']>;
  paymentInstallmentKind: Scalars['String']['output'];
  paymentLastMonth: Maybe<Scalars['Float']['output']>;
  paymentMonthly: Maybe<Scalars['Float']['output']>;
  paymentStartOn: Maybe<Scalars['ISO8601Date']['output']>;
  tenantId: Scalars['ID']['output'];
};

export type PartList = {
  __typename?: 'PartList';
  code: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayCode: Scalars['String']['output'];
  figureNumber: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAdjustable: Scalars['Boolean']['output'];
  latestOrderUnitPrices: Array<PartOrderUnitPrice>;
  name: Scalars['String']['output'];
  receiverCode: Maybe<Scalars['String']['output']>;
  receiverName: Maybe<Scalars['String']['output']>;
  rootPartCode: Maybe<Scalars['String']['output']>;
  temporaryCode: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantId: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for PartList. */
export type PartListConnection = {
  __typename?: 'PartListConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PartListEdge>>>;
  /** A list of nodes. */
  nodes: Array<PartList>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PartListEdge = {
  __typename?: 'PartListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PartList>;
};

export type PartMaterialPrice = {
  __typename?: 'PartMaterialPrice';
  baseMaterial: Maybe<BaseMaterial>;
  cavity: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  initialCost: Maybe<Scalars['Float']['output']>;
  materialCost: Maybe<Scalars['Float']['output']>;
  materialCostOnDate: Maybe<Scalars['Float']['output']>;
  materialCostPerQty: Maybe<Scalars['Float']['output']>;
  materialCostPerQtyOnDate: Maybe<Scalars['Float']['output']>;
  materialName: Maybe<Scalars['String']['output']>;
  materialUnitPrice: Maybe<Scalars['Float']['output']>;
  materialUnitPriceOnDate: Maybe<Scalars['Float']['output']>;
  measure: Maybe<Scalars['String']['output']>;
  priceTenantUnit: Maybe<TenantUnit>;
  procurementKind: Maybe<Scalars['String']['output']>;
  productWeight: Maybe<Scalars['Float']['output']>;
  quantity: Maybe<Scalars['Float']['output']>;
  reservedWeight: Maybe<Scalars['Float']['output']>;
  scrapSubtotal: Maybe<Scalars['Float']['output']>;
  scrapUnitPrice: Maybe<Scalars['Float']['output']>;
  scrapUnitPriceOnDate: Maybe<Scalars['Float']['output']>;
  scrapWeight: Maybe<Scalars['Float']['output']>;
  startOn: Maybe<Scalars['ISO8601Date']['output']>;
  startUpMonth: Maybe<Scalars['ISO8601Date']['output']>;
  variation: Maybe<Scalars['Float']['output']>;
  weightTenantUnit: Maybe<TenantUnit>;
};

export type PartOrderUnitPrice = {
  __typename?: 'PartOrderUnitPrice';
  amortizationCost: Maybe<Scalars['Float']['output']>;
  answerPrice: Maybe<AnswerPrice>;
  currency: Maybe<Currency>;
  deliveryCost: Maybe<Scalars['Float']['output']>;
  endOn: Maybe<Scalars['ISO8601Date']['output']>;
  facilityAmortizationCost: Maybe<Scalars['Float']['output']>;
  facilityCost: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  ifKey1: Maybe<Scalars['String']['output']>;
  ifKey2: Maybe<Scalars['String']['output']>;
  isExpired: Scalars['Boolean']['output'];
  itemRequirement: Maybe<ItemRequirement>;
  jigManagementCost: Maybe<Scalars['Float']['output']>;
  latestCanceledPartOrderUnitPrice: Maybe<CanceledPartOrderUnitPrice>;
  managementCost: Maybe<Scalars['Float']['output']>;
  manufacturingSite: Maybe<ManufacturingSite>;
  materialCost: Maybe<Scalars['Float']['output']>;
  materialManagementCost: Maybe<Scalars['Float']['output']>;
  paidSupplyPartSubtotal: Maybe<Scalars['Float']['output']>;
  part: Part;
  partFacilityPrices: Array<PartFacilityPrice>;
  partMaterialPrices: Array<PartMaterialPrice>;
  partOrderUnitPriceFormat: Maybe<PartOrderUnitPriceFormat>;
  partProcessingCosts: Array<PartProcessingCost>;
  partReasons: Array<PartReason>;
  partSubpartPrices: Array<PartSubpartPrice>;
  partSubsidiaryMaterialCosts: Array<PartSubsidiaryMaterialCost>;
  partSupplySubpartPrices: Array<PartSupplySubpartPrice>;
  partsCost: Maybe<Scalars['Float']['output']>;
  previousUnitPrice: Maybe<Scalars['Float']['output']>;
  priceAdjustmentItems: Maybe<Array<PriceAdjustmentItem>>;
  processingCostSubtotal: Maybe<Scalars['Float']['output']>;
  project: Maybe<Project>;
  propertyRentCost: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Float']['output'];
  quotation: Maybe<Quotation>;
  quotationContext: Maybe<QuotationContext>;
  sourcePriceAdjustmentItem: Maybe<PriceAdjustmentItem>;
  startOn: Scalars['ISO8601Date']['output'];
  subsidiaryMaterialCost: Maybe<Scalars['Float']['output']>;
  supplier: Supplier;
  tenant: Maybe<Tenant>;
  tenantId: Scalars['ID']['output'];
  tenantPeriodUnit: Maybe<TenantPeriodUnit>;
  tenantUnit: Maybe<TenantUnit>;
  unitPrice: Scalars['Float']['output'];
  updateMemo: Maybe<Scalars['String']['output']>;
};

export type PartOrderUnitPriceForList = {
  __typename?: 'PartOrderUnitPriceForList';
  cancelStatusKind: Maybe<Scalars['String']['output']>;
  deliverySite: Maybe<DeliverySite>;
  id: Scalars['ID']['output'];
  ifKey1: Maybe<Scalars['String']['output']>;
  ifKey2: Maybe<Scalars['String']['output']>;
  manufacturingSite: Maybe<ManufacturingSite>;
  part: Part;
  partReasons: Array<PartReason>;
  startOn: Scalars['ISO8601Date']['output'];
  supplier: Supplier;
  unitPrice: Scalars['Float']['output'];
};

/** The connection type for PartOrderUnitPriceForList. */
export type PartOrderUnitPriceForListConnection = {
  __typename?: 'PartOrderUnitPriceForListConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PartOrderUnitPriceForListEdge>>>;
  /** A list of nodes. */
  nodes: Array<PartOrderUnitPriceForList>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PartOrderUnitPriceForListEdge = {
  __typename?: 'PartOrderUnitPriceForListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PartOrderUnitPriceForList>;
};

export type PartOrderUnitPriceFormat = {
  __typename?: 'PartOrderUnitPriceFormat';
  code: Scalars['String']['output'];
  materialDetailDescription: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type PartPrice = {
  __typename?: 'PartPrice';
  adjustment: Maybe<Scalars['Float']['output']>;
  dayType: Maybe<Scalars['String']['output']>;
  dayTypeDisplay: Maybe<Scalars['String']['output']>;
  defectCost: Maybe<Scalars['Float']['output']>;
  deliveryCost: Maybe<Scalars['Float']['output']>;
  deliveryDay: Maybe<Scalars['Int']['output']>;
  depreciation: Maybe<Scalars['Float']['output']>;
  endDate: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  initialDeliveryDay: Maybe<Scalars['Int']['output']>;
  internalPartSubtotal: Maybe<Scalars['Float']['output']>;
  isActive: Scalars['Boolean']['output'];
  isBase: Scalars['Boolean']['output'];
  managementCost: Maybe<Scalars['Float']['output']>;
  materialCost: Maybe<Scalars['Float']['output']>;
  outSourcePartManagementRate: Maybe<Scalars['Float']['output']>;
  outSourcePartSubtotal: Maybe<Scalars['Float']['output']>;
  packingCost: Maybe<Scalars['Float']['output']>;
  paidSupplyPartSubtotal: Maybe<Scalars['Float']['output']>;
  part: Part;
  partsCost: Maybe<Scalars['Float']['output']>;
  processingCost: Maybe<Scalars['Float']['output']>;
  profit: Maybe<Scalars['Float']['output']>;
  profitRate: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Float']['output'];
  quantityFrom: Scalars['Float']['output'];
  quantityTo: Maybe<Scalars['Float']['output']>;
  startDate: Scalars['ISO8601Date']['output'];
  tenantId: Scalars['ID']['output'];
  unitPrice: Scalars['Float']['output'];
  updateMemo: Maybe<Scalars['String']['output']>;
};

export type PartProcessingCost = {
  __typename?: 'PartProcessingCost';
  costForWeight: Maybe<Scalars['Float']['output']>;
  equipmentName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  memo: Maybe<Scalars['String']['output']>;
  partFacilityPrice: Maybe<PartFacilityPrice>;
  partOrderUnitPrice: PartOrderUnitPrice;
  processName: Scalars['String']['output'];
  processOutsourcingKind: Maybe<Scalars['String']['output']>;
  processingCost: Scalars['Float']['output'];
  processingCostSubtotal: Maybe<Scalars['Float']['output']>;
  processingCostSubtotalPerLot: Maybe<Scalars['Float']['output']>;
  processingHeadcount: Maybe<Scalars['Int']['output']>;
  processingRate: Maybe<Scalars['Float']['output']>;
  processingTimeHour: Maybe<Scalars['Float']['output']>;
  processingTimeMinute: Maybe<Scalars['Float']['output']>;
  processingTimeSecond: Maybe<Scalars['Float']['output']>;
  processingTimes: Maybe<Scalars['Int']['output']>;
  processingWeight: Maybe<Scalars['Float']['output']>;
  productionLot: Maybe<Scalars['Int']['output']>;
  rateKind: Maybe<Scalars['String']['output']>;
  setupCostSubtotal: Maybe<Scalars['Float']['output']>;
  setupRate: Maybe<Scalars['Float']['output']>;
  setupTimeHour: Maybe<Scalars['Float']['output']>;
  setupTimeMinute: Maybe<Scalars['Float']['output']>;
  setupTimeSecond: Maybe<Scalars['Float']['output']>;
  weightTenantUnit: Maybe<TenantUnit>;
};

export type PartReason = {
  __typename?: 'PartReason';
  id: Maybe<Scalars['ID']['output']>;
  priceChangeReason: PriceChangeReason;
  priceDifference: Maybe<Scalars['Float']['output']>;
  sequence: Maybe<Scalars['Int']['output']>;
  tenantId: Scalars['ID']['output'];
};

export type PartSubpartPrice = {
  __typename?: 'PartSubpartPrice';
  id: Scalars['ID']['output'];
  partCode: Maybe<Scalars['String']['output']>;
  partCost: Maybe<Scalars['Float']['output']>;
  partName: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['Int']['output']>;
  quantityDenominator: Scalars['Int']['output'];
  unitPrice: Maybe<Scalars['Float']['output']>;
};

export type PartSubsidiaryMaterialCost = {
  __typename?: 'PartSubsidiaryMaterialCost';
  id: Scalars['ID']['output'];
  name: Scalars['ID']['output'];
  note: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['Float']['output']>;
  subsidiaryMaterialCost: Scalars['Float']['output'];
  unitPrice: Maybe<Scalars['Float']['output']>;
};

export type PartSupplyPrice = {
  __typename?: 'PartSupplyPrice';
  assignmentPrice: Maybe<Scalars['Float']['output']>;
  assignmentPriceKind: PartSupplyPriceAssignmentPriceKindEnum;
  endOn: Maybe<Scalars['ISO8601Date']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  part: Part;
  startOn: Scalars['ISO8601Date']['output'];
  supplier: Supplier;
  tenant: Tenant;
  tenantUnit: Maybe<TenantUnit>;
};

export enum PartSupplyPriceAssignmentPriceKindEnum {
  APaid = 'a_paid',
  BFree = 'b_free'
}

/** The connection type for PartSupplyPrice. */
export type PartSupplyPriceConnection = {
  __typename?: 'PartSupplyPriceConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PartSupplyPriceEdge>>>;
  /** A list of nodes. */
  nodes: Array<PartSupplyPrice>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PartSupplyPriceEdge = {
  __typename?: 'PartSupplyPriceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PartSupplyPrice>;
};

export type PartSupplySubpartPrice = {
  __typename?: 'PartSupplySubpartPrice';
  id: Maybe<Scalars['ID']['output']>;
  partOrderUnitPrice: Maybe<PartOrderUnitPrice>;
  quantity: Maybe<Scalars['Int']['output']>;
  quantityDenominator: Scalars['Int']['output'];
  supplyPart: Part;
  supplyPartCost: Maybe<Scalars['Float']['output']>;
  supplyPartId: Scalars['ID']['output'];
  unitPrice: Maybe<Scalars['Float']['output']>;
};

export type PartTransaction = {
  __typename?: 'PartTransaction';
  checkDate: Scalars['ISO8601Date']['output'];
  checkNumber: Maybe<Scalars['String']['output']>;
  checkSeqNo: Maybe<Scalars['Int']['output']>;
  currency: Currency;
  currencyRate: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  orderNumber: Maybe<Scalars['String']['output']>;
  orderSeqNo: Maybe<Scalars['Int']['output']>;
  part: Part;
  receivedOn: Maybe<Scalars['ISO8601Date']['output']>;
  receivedQuantity: Scalars['Float']['output'];
  subtotal: Scalars['Float']['output'];
  supplier: Supplier;
  tenantId: Scalars['ID']['output'];
  toJpy: PartTransactionJpy;
  unitPrice: Scalars['Float']['output'];
};

export type PartTransactionJpy = {
  __typename?: 'PartTransactionJpy';
  subtotal: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type PartUnofficialAnnouncement = {
  __typename?: 'PartUnofficialAnnouncement';
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  partId: Scalars['ID']['output'];
  quantity1: Scalars['Float']['output'];
  quantity2: Scalars['Float']['output'];
  quantity3: Scalars['Float']['output'];
  recordedOn: Scalars['ISO8601Date']['output'];
  supplierId: Scalars['ID']['output'];
  tenantId: Scalars['ID']['output'];
};

export type PdfImportResult = {
  __typename?: 'PdfImportResult';
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  signedUrl: Scalars['String']['output'];
};

export type PriceAdjustment = {
  __typename?: 'PriceAdjustment';
  adjustmentPurpose: Scalars['String']['output'];
  applicantKind: Scalars['String']['output'];
  confirmationDeadlineDate: Maybe<Scalars['ISO8601Date']['output']>;
  confirmationStartDate: Maybe<Scalars['ISO8601Date']['output']>;
  currentAsking: Maybe<PriceAdjustmentEvent>;
  currentEvent: PriceAdjustmentEvent;
  id: Scalars['ID']['output'];
  inChargeAdminUser: Maybe<AdminUser>;
  inChargeSupplierAccount: Maybe<SupplierAccount>;
  inChargeSupplierUser: Maybe<SupplierUser>;
  memo: Scalars['String']['output'];
  priceAdjustmentCsvAttachmentId: Maybe<Scalars['ID']['output']>;
  priceAdjustmentItems: Maybe<Array<PriceAdjustmentItem>>;
  priceEffectiveDate: Maybe<Scalars['ISO8601Date']['output']>;
  priceExpirationDate: Maybe<Scalars['ISO8601Date']['output']>;
  supplier: Supplier;
  supplierAccounts: Array<SupplierAccount>;
  supplierCode: Scalars['String']['output'];
  supplierUsers: Maybe<Array<SupplierUser>>;
  targetTerm: Scalars['String']['output'];
  tenant: Tenant;
  tenantCode: Scalars['String']['output'];
  tenantId: Scalars['ID']['output'];
};

export enum PriceAdjustmentAdjustmentKindEnum {
  AByUser = 'a_by_user',
  BByAutoBaseMaterialPrice = 'b_by_auto_base_material_price'
}

/** Autogenerated input type of PriceAdjustmentAmendAsking */
export type PriceAdjustmentAmendAskingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: PriceAdjustmentInput;
};

/** Autogenerated return type of PriceAdjustmentAmendAsking. */
export type PriceAdjustmentAmendAskingPayload = {
  __typename?: 'PriceAdjustmentAmendAskingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
  priceAdjustment: Maybe<PriceAdjustment>;
};

/** Autogenerated input type of PriceAdjustmentAmend */
export type PriceAdjustmentAmendInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: PriceAdjustmentInput;
};

/** Autogenerated return type of PriceAdjustmentAmend. */
export type PriceAdjustmentAmendPayload = {
  __typename?: 'PriceAdjustmentAmendPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
  priceAdjustment: Maybe<PriceAdjustment>;
};

/** Autogenerated input type of PriceAdjustmentAnswer */
export type PriceAdjustmentAnswerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: PriceAdjustmentInput;
};

/** Autogenerated return type of PriceAdjustmentAnswer. */
export type PriceAdjustmentAnswerPayload = {
  __typename?: 'PriceAdjustmentAnswerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
  priceAdjustment: Maybe<PriceAdjustment>;
};

/** Autogenerated input type of PriceAdjustmentApplication */
export type PriceAdjustmentApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: PriceAdjustmentFormSaveInput;
};

/** Autogenerated return type of PriceAdjustmentApplication. */
export type PriceAdjustmentApplicationPayload = {
  __typename?: 'PriceAdjustmentApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  inputFormErrors: Maybe<Array<InputFormError>>;
  priceAdjustment: Maybe<PriceAdjustment>;
};

/** Autogenerated input type of PriceAdjustmentAsk */
export type PriceAdjustmentAskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: PriceAdjustmentInput;
};

/** Autogenerated return type of PriceAdjustmentAsk. */
export type PriceAdjustmentAskPayload = {
  __typename?: 'PriceAdjustmentAskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
  priceAdjustment: Maybe<PriceAdjustment>;
};

/** Autogenerated input type of PriceAdjustmentClose */
export type PriceAdjustmentCloseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  memo: Scalars['String']['input'];
};

/** Autogenerated return type of PriceAdjustmentClose. */
export type PriceAdjustmentClosePayload = {
  __typename?: 'PriceAdjustmentClosePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
  id: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of PriceAdjustmentComplete */
export type PriceAdjustmentCompleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: PriceAdjustmentInput;
};

/** Autogenerated return type of PriceAdjustmentComplete. */
export type PriceAdjustmentCompletePayload = {
  __typename?: 'PriceAdjustmentCompletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
  priceAdjustment: Maybe<PriceAdjustment>;
};

/** The connection type for PriceAdjustment. */
export type PriceAdjustmentConnection = {
  __typename?: 'PriceAdjustmentConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PriceAdjustmentEdge>>>;
  /** A list of nodes. */
  nodes: Array<PriceAdjustment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of PriceAdjustmentCreateByPartOrderUnitPrice */
export type PriceAdjustmentCreateByPartOrderUnitPriceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  partOrderUnitPriceIds: Array<Scalars['ID']['input']>;
  tenantId: Scalars['ID']['input'];
};

/** Autogenerated return type of PriceAdjustmentCreateByPartOrderUnitPrice. */
export type PriceAdjustmentCreateByPartOrderUnitPricePayload = {
  __typename?: 'PriceAdjustmentCreateByPartOrderUnitPricePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
  priceAdjustment: Maybe<PriceAdjustment>;
};

/** Autogenerated input type of PriceAdjustmentDelete */
export type PriceAdjustmentDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PriceAdjustmentDelete. */
export type PriceAdjustmentDeletePayload = {
  __typename?: 'PriceAdjustmentDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
  id: Maybe<Scalars['ID']['output']>;
};

export type PriceAdjustmentDetail = {
  __typename?: 'PriceAdjustmentDetail';
  adjustmentKind: PriceAdjustmentAdjustmentKindEnum;
  adjustmentPurpose: Maybe<Scalars['String']['output']>;
  answerFormat: Maybe<AnswerFormat>;
  applicantKind: Scalars['String']['output'];
  attachments: Array<Attachment>;
  completeEvent: Maybe<PriceAdjustmentEvent>;
  confirmationDeadlineDate: Maybe<Scalars['ISO8601Date']['output']>;
  confirmationStartDate: Maybe<Scalars['ISO8601Date']['output']>;
  currentAsking: Maybe<PriceAdjustmentEvent>;
  currentEvent: PriceAdjustmentEvent;
  id: Scalars['ID']['output'];
  inChargeAdminUser: Maybe<AdminUser>;
  inChargeSupplierAccount: Maybe<SupplierAccount>;
  inChargeSupplierUser: Maybe<SupplierUser>;
  isItemDeletable: Scalars['Boolean']['output'];
  isSupplierEditable: Scalars['Boolean']['output'];
  memo: Scalars['String']['output'];
  priceAdjustmentCsvAttachmentId: Maybe<Scalars['ID']['output']>;
  priceAdjustmentEvents: Array<PriceAdjustmentEvent>;
  priceAdjustmentItems: Maybe<Array<PriceAdjustmentItem>>;
  priceAdjustmentSetting: PriceAdjustmentSetting;
  priceEffectiveDate: Maybe<Scalars['ISO8601Date']['output']>;
  priceExpirationDate: Maybe<Scalars['ISO8601Date']['output']>;
  supplier: Supplier;
  supplierAccounts: Array<SupplierAccount>;
  supplierCode: Scalars['String']['output'];
  supplierCorporationAttachments: Array<Attachment>;
  supplierUsers: Maybe<Array<SupplierUser>>;
  targetTerm: Scalars['String']['output'];
  tenant: Tenant;
  tenantCode: Scalars['String']['output'];
  tenantId: Scalars['ID']['output'];
};

/** An edge in a connection. */
export type PriceAdjustmentEdge = {
  __typename?: 'PriceAdjustmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PriceAdjustment>;
};

export type PriceAdjustmentEvent = {
  __typename?: 'PriceAdjustmentEvent';
  actionName: Scalars['String']['output'];
  adjustmentStatusName: Scalars['String']['output'];
  confirmationStatusName: Scalars['String']['output'];
  confirmationStatusValue: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  eventKind: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  memo: Maybe<Scalars['String']['output']>;
  triggeredBy: TriggeredBy;
  triggeredByType: Scalars['String']['output'];
};

/** Autogenerated input type of PriceAdjustmentExcelExport */
export type PriceAdjustmentExcelExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PriceAdjustmentExcelExport. */
export type PriceAdjustmentExcelExportPayload = {
  __typename?: 'PriceAdjustmentExcelExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
  signedUrl: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of PriceAdjustmentExcelRegistrationExport */
export type PriceAdjustmentExcelRegistrationExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of PriceAdjustmentExcelRegistrationExport. */
export type PriceAdjustmentExcelRegistrationExportPayload = {
  __typename?: 'PriceAdjustmentExcelRegistrationExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
  signedUrl: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of PriceAdjustmentExcelSchemaExport */
export type PriceAdjustmentExcelSchemaExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  priceAdjustmentId: Scalars['ID']['input'];
};

/** Autogenerated return type of PriceAdjustmentExcelSchemaExport. */
export type PriceAdjustmentExcelSchemaExportPayload = {
  __typename?: 'PriceAdjustmentExcelSchemaExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
  fileName: Maybe<Scalars['String']['output']>;
  fileUrl: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of PriceAdjustmentExcelSchemaImport */
export type PriceAdjustmentExcelSchemaImportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fileUrl: Scalars['String']['input'];
  priceAdjustmentId: Scalars['ID']['input'];
};

/** Autogenerated return type of PriceAdjustmentExcelSchemaImport. */
export type PriceAdjustmentExcelSchemaImportPayload = {
  __typename?: 'PriceAdjustmentExcelSchemaImportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  deletedItemIds: Maybe<Array<Scalars['ID']['output']>>;
  deletedProcessingIds: Maybe<Array<Scalars['ID']['output']>>;
  deletedSubpartIds: Maybe<Array<Scalars['ID']['output']>>;
  deletedSubsidiaryMaterialIds: Maybe<Array<Scalars['ID']['output']>>;
  errors: Array<ValidationErr>;
  priceAdjustmentItems: Maybe<Array<PriceAdjustmentItem>>;
  validationErrors: Maybe<Array<Scalars['String']['output']>>;
};

export type PriceAdjustmentFormSaveDeleteInput = {
  items: Array<Scalars['ID']['input']>;
  processingPrices: Array<Scalars['ID']['input']>;
  subpartPrices: Array<Scalars['ID']['input']>;
  subsidiaryMaterialCosts: Array<Scalars['ID']['input']>;
};

export type PriceAdjustmentFormSaveInput = {
  adjustmentPurpose?: InputMaybe<Scalars['String']['input']>;
  confirmationDeadlineDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  deleteIds: PriceAdjustmentFormSaveDeleteInput;
  id: Scalars['ID']['input'];
  inChargeAdminUserId?: InputMaybe<Scalars['ID']['input']>;
  items: Array<PriceAdjustmentFormSaveItemInput>;
  memo?: InputMaybe<Scalars['String']['input']>;
  priceEffectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  supplierCorporationAttachments?: InputMaybe<Array<CommonAttachmentInput>>;
};

export type PriceAdjustmentFormSaveItemInput = {
  amortizationCost?: InputMaybe<Scalars['Float']['input']>;
  deliveryCost?: InputMaybe<Scalars['Float']['input']>;
  facilityAmortizationCost?: InputMaybe<Scalars['Float']['input']>;
  facilityCost?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  jigManagementCost?: InputMaybe<Scalars['Float']['input']>;
  managementCost?: InputMaybe<Scalars['Float']['input']>;
  materialCost?: InputMaybe<Scalars['Float']['input']>;
  materialCostNotSupplySubtotal?: InputMaybe<Scalars['Float']['input']>;
  materialCostSupplySubtotal?: InputMaybe<Scalars['Float']['input']>;
  materialCosts: Array<PriceAdjustmentFormSaveMaterialCostInput>;
  materialManagementCost?: InputMaybe<Scalars['Float']['input']>;
  netUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  notSupplyPartSubtotal?: InputMaybe<Scalars['Float']['input']>;
  paidSupplyPartSubtotal?: InputMaybe<Scalars['Float']['input']>;
  partsCost?: InputMaybe<Scalars['Float']['input']>;
  processingPriceSubtotal?: InputMaybe<Scalars['Float']['input']>;
  processingPrices: Array<PriceAdjustmentFormSaveProcessingPriceInput>;
  propertyRentCost?: InputMaybe<Scalars['Float']['input']>;
  quotationContext?: InputMaybe<PriceAdjustmentFormSaveQuotationContextInput>;
  subpartPrices: Array<PriceAdjustmentFormSaveSubpartPriceInput>;
  subsidiaryMaterialCost?: InputMaybe<Scalars['Float']['input']>;
  subsidiaryMaterialCosts: Array<PriceAdjustmentFormSaveSubsidiaryMaterialCostInput>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
  unitPriceWithAmortization?: InputMaybe<Scalars['Float']['input']>;
};

export type PriceAdjustmentFormSaveMaterialCostInput = {
  cavity?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  materialCost?: InputMaybe<Scalars['Float']['input']>;
  materialCostPerQty?: InputMaybe<Scalars['Float']['input']>;
  materialName?: InputMaybe<Scalars['String']['input']>;
  materialUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  measure?: InputMaybe<Scalars['String']['input']>;
  procurementKind?: InputMaybe<Scalars['String']['input']>;
  productWeight?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  reservedWeight?: InputMaybe<Scalars['Float']['input']>;
  scrapSubtotal?: InputMaybe<Scalars['Float']['input']>;
  scrapUnitPrice?: InputMaybe<Scalars['Float']['input']>;
  scrapWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type PriceAdjustmentFormSaveProcessingPriceInput = {
  equipmentName?: InputMaybe<Scalars['String']['input']>;
  facilityCost?: InputMaybe<Scalars['Float']['input']>;
  facilityKindId?: InputMaybe<Scalars['ID']['input']>;
  facilityName?: InputMaybe<Scalars['String']['input']>;
  facilityPaymentInstallmentKind?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  processName?: InputMaybe<Scalars['String']['input']>;
  processOutsourcingKind?: InputMaybe<Scalars['String']['input']>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  processingCostPerLot?: InputMaybe<Scalars['Float']['input']>;
  processingCostSubtotal?: InputMaybe<Scalars['Float']['input']>;
  processingCostSubtotalPerLot?: InputMaybe<Scalars['Float']['input']>;
  processingRate?: InputMaybe<Scalars['Float']['input']>;
  processingTimeHour?: InputMaybe<Scalars['Float']['input']>;
  productionLot?: InputMaybe<Scalars['Int']['input']>;
};

export type PriceAdjustmentFormSaveQuotationContextInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  currency1Id?: InputMaybe<Scalars['ID']['input']>;
  currency2Id?: InputMaybe<Scalars['ID']['input']>;
  currency3Id?: InputMaybe<Scalars['ID']['input']>;
  currencyRate1?: InputMaybe<Scalars['Float']['input']>;
  currencyRate2?: InputMaybe<Scalars['Float']['input']>;
  currencyRate3?: InputMaybe<Scalars['Float']['input']>;
  deliveryCartHandling?: InputMaybe<Array<Scalars['String']['input']>>;
  deliveryPeriod?: InputMaybe<Scalars['String']['input']>;
  deliverySiteId?: InputMaybe<Scalars['ID']['input']>;
  equipmentAndToolHandling?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  manufacturingSiteId?: InputMaybe<Scalars['ID']['input']>;
  materialAndPaintHandling?: InputMaybe<Array<Scalars['String']['input']>>;
  materialPriceDateOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  modelDepreciationQuantity?: InputMaybe<Scalars['Float']['input']>;
  modelDepreciationTenantPeriodUnitId?: InputMaybe<Scalars['ID']['input']>;
  modelDepreciationTenantUnitId?: InputMaybe<Scalars['ID']['input']>;
};

export type PriceAdjustmentFormSaveSubpartPriceInput = {
  id: Scalars['ID']['input'];
  partCode?: InputMaybe<Scalars['String']['input']>;
  partCost?: InputMaybe<Scalars['Float']['input']>;
  partName?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type PriceAdjustmentFormSaveSubsidiaryMaterialCostInput = {
  id: Scalars['ID']['input'];
  subsidiaryMaterialCost?: InputMaybe<Scalars['Float']['input']>;
  subsidiaryMaterialName?: InputMaybe<Scalars['String']['input']>;
};

export type PriceAdjustmentInput = {
  adjustmentPurpose: Scalars['String']['input'];
  confirmationDeadlineDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  confirmationStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  eventMemo: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  inChargeAdminUserId?: InputMaybe<Scalars['ID']['input']>;
  inChargeSupplierAccountId?: InputMaybe<Scalars['ID']['input']>;
  inChargeSupplierUserId?: InputMaybe<Scalars['ID']['input']>;
  inputItems: Array<PriceAdjustmentUpdateInputItem>;
  memo: Scalars['String']['input'];
  priceEffectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  priceExpirationDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  supplierCode: Scalars['String']['input'];
  supplierCorporationAttachments?: InputMaybe<Array<CommonAttachmentInput>>;
  targetTerm: Scalars['String']['input'];
};

export type PriceAdjustmentItem = {
  __typename?: 'PriceAdjustmentItem';
  answerFormat: Maybe<AnswerFormat>;
  id: Scalars['ID']['output'];
  latestAskingDetail: Maybe<PriceAdjustmentItemDetail>;
  memo: Maybe<Scalars['String']['output']>;
  newDetail: Maybe<PriceAdjustmentItemDetail>;
  oldDetail: Maybe<PriceAdjustmentItemDetail>;
  part: Part;
  partForRegistration: Maybe<Part>;
  partOrderUnitPrice: Maybe<PartOrderUnitPrice>;
  priceAdjustment: PriceAdjustment;
  priceAdjustmentItemMaterialPrices: Maybe<Array<PriceAdjustmentItemMaterialPrice>>;
  priceChangeReasons: Maybe<Array<PriceChangeReason>>;
  project: Maybe<Project>;
  quantity: Scalars['Float']['output'];
  reasonSnapshots: Maybe<Array<PriceAdjustmentItemPriceChangeReason>>;
  tenantId: Scalars['ID']['output'];
  tenantPeriodUnit: Maybe<TenantPeriodUnit>;
  tenantUnit: Maybe<TenantUnit>;
};

export type PriceAdjustmentItemDetail = {
  __typename?: 'PriceAdjustmentItemDetail';
  amortizationCost: Maybe<Scalars['Float']['output']>;
  deliveryCost: Maybe<Scalars['Float']['output']>;
  deliverySite: Maybe<DeliverySite>;
  deliverySiteId: Maybe<Scalars['ID']['output']>;
  facilityAmortizationCost: Maybe<Scalars['Float']['output']>;
  facilityCost: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  jigManagementCost: Maybe<Scalars['Float']['output']>;
  kind: Scalars['String']['output'];
  managementCost: Maybe<Scalars['Float']['output']>;
  manufacturingSite: Maybe<ManufacturingSite>;
  manufacturingSiteId: Maybe<Scalars['ID']['output']>;
  materialCost: Maybe<Scalars['Float']['output']>;
  materialCostNotSupplySubtotal: Maybe<Scalars['Float']['output']>;
  materialCostSupplySubtotal: Maybe<Scalars['Float']['output']>;
  materialManagementCost: Maybe<Scalars['Float']['output']>;
  memo: Scalars['String']['output'];
  netUnitPrice: Maybe<Scalars['Float']['output']>;
  notSupplyPartSubtotal: Maybe<Scalars['Float']['output']>;
  otherCost: Maybe<Scalars['Float']['output']>;
  paidSupplyPartSubtotal: Maybe<Scalars['Float']['output']>;
  partsCost: Maybe<Scalars['Float']['output']>;
  priceAdjustmentItemDetailMaterialPrices: Maybe<Array<PriceAdjustmentItemDetailMaterialPrice>>;
  priceAdjustmentItemDetailProcessingPrices: Maybe<Array<PriceAdjustmentItemDetailProcessingPrice>>;
  priceAdjustmentItemDetailSubpartPrices: Maybe<Array<PriceAdjustmentItemDetailSubpartPrice>>;
  priceAdjustmentItemDetailSubsidiaryMaterialCosts: Maybe<Array<PriceAdjustmentItemDetailSubsidiaryMaterialCost>>;
  priceAdjustmentItemDetailSupplySubpartPrices: Maybe<Array<PriceAdjustmentItemDetailSupplySubpartPrice>>;
  processingCost: Maybe<Scalars['Float']['output']>;
  processingPriceSubtotal: Maybe<Scalars['Float']['output']>;
  propertyRentCost: Maybe<Scalars['Float']['output']>;
  quotationContext: Maybe<QuotationContext>;
  scrapPrice: Maybe<Scalars['Float']['output']>;
  subsidiaryMaterialCost: Maybe<Scalars['Float']['output']>;
  supplyPartPrice: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['ID']['output'];
  unitPrice: Maybe<Scalars['Float']['output']>;
};

export type PriceAdjustmentItemDetailMaterialPrice = {
  __typename?: 'PriceAdjustmentItemDetailMaterialPrice';
  baseMaterial: Maybe<BaseMaterial>;
  cavity: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  initialCost: Maybe<Scalars['Float']['output']>;
  materialCode: Maybe<Scalars['String']['output']>;
  materialCost: Maybe<Scalars['Float']['output']>;
  materialCostPerQty: Maybe<Scalars['Float']['output']>;
  materialName: Maybe<Scalars['String']['output']>;
  materialUnitPrice: Maybe<Scalars['Float']['output']>;
  measure: Maybe<Scalars['String']['output']>;
  partMaterialPrice: Maybe<PartMaterialPrice>;
  partMaterialPriceId: Maybe<Scalars['ID']['output']>;
  priceTenantUnit: Maybe<TenantUnit>;
  procurementKind: Maybe<Scalars['String']['output']>;
  productWeight: Maybe<Scalars['Float']['output']>;
  quantity: Maybe<Scalars['Float']['output']>;
  reservedWeight: Maybe<Scalars['Float']['output']>;
  scrapSubtotal: Maybe<Scalars['Float']['output']>;
  scrapUnitPrice: Maybe<Scalars['Float']['output']>;
  scrapWeight: Maybe<Scalars['Float']['output']>;
  startOn: Maybe<Scalars['ISO8601Date']['output']>;
  startUpMonth: Maybe<Scalars['ISO8601Date']['output']>;
  variation: Maybe<Scalars['Float']['output']>;
  weightTenantUnit: Maybe<TenantUnit>;
};

export type PriceAdjustmentItemDetailProcessingPrice = {
  __typename?: 'PriceAdjustmentItemDetailProcessingPrice';
  costForWeight: Maybe<Scalars['Float']['output']>;
  equipmentName: Maybe<Scalars['String']['output']>;
  facilityCost: Maybe<Scalars['Float']['output']>;
  facilityKindId: Maybe<Scalars['ID']['output']>;
  facilityName: Maybe<Scalars['String']['output']>;
  facilityPaymentInstallmentKind: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  memo: Maybe<Scalars['String']['output']>;
  partFacilityPrice: Maybe<PartFacilityPrice>;
  partProcessingCostId: Maybe<Scalars['ID']['output']>;
  priceAdjustmentItemDetailId: Scalars['ID']['output'];
  processName: Scalars['String']['output'];
  processOutsourcingKind: Maybe<Scalars['String']['output']>;
  processingCost: Scalars['Float']['output'];
  processingCostPerLot: Maybe<Scalars['Float']['output']>;
  processingCostSubtotal: Maybe<Scalars['Float']['output']>;
  processingCostSubtotalPerLot: Maybe<Scalars['Float']['output']>;
  processingHeadcount: Maybe<Scalars['Int']['output']>;
  processingRate: Maybe<Scalars['Float']['output']>;
  processingTimeHour: Maybe<Scalars['Float']['output']>;
  processingTimeMinute: Maybe<Scalars['Float']['output']>;
  processingTimeSecond: Maybe<Scalars['Float']['output']>;
  processingTimes: Maybe<Scalars['Int']['output']>;
  processingWeight: Maybe<Scalars['Float']['output']>;
  productionLot: Maybe<Scalars['Int']['output']>;
  rateKind: Maybe<Scalars['Int']['output']>;
  setupCostSubtotal: Maybe<Scalars['Float']['output']>;
  setupRate: Maybe<Scalars['Float']['output']>;
  setupTimeHour: Maybe<Scalars['Float']['output']>;
  setupTimeMinute: Maybe<Scalars['Float']['output']>;
  setupTimeSecond: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['ID']['output'];
  weightTenantUnitId: Maybe<Scalars['ID']['output']>;
};

export type PriceAdjustmentItemDetailSubpartPrice = {
  __typename?: 'PriceAdjustmentItemDetailSubpartPrice';
  id: Maybe<Scalars['ID']['output']>;
  partCode: Maybe<Scalars['String']['output']>;
  partCost: Maybe<Scalars['Float']['output']>;
  partName: Maybe<Scalars['String']['output']>;
  partSubpartPriceId: Maybe<Scalars['ID']['output']>;
  priceAdjustmentItemDetailId: Scalars['ID']['output'];
  quantity: Maybe<Scalars['Int']['output']>;
  quantityDenominator: Maybe<Scalars['Int']['output']>;
  tenantId: Scalars['ID']['output'];
  unitPrice: Maybe<Scalars['Float']['output']>;
};

export type PriceAdjustmentItemDetailSubsidiaryMaterialCost = {
  __typename?: 'PriceAdjustmentItemDetailSubsidiaryMaterialCost';
  id: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  note: Maybe<Scalars['String']['output']>;
  partSubsidiaryMaterialCostId: Maybe<Scalars['ID']['output']>;
  priceAdjustmentItemDetailId: Scalars['ID']['output'];
  quantity: Maybe<Scalars['Float']['output']>;
  subsidiaryMaterialCost: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['ID']['output'];
  unitPrice: Maybe<Scalars['Float']['output']>;
};

export type PriceAdjustmentItemDetailSupplySubpartPrice = {
  __typename?: 'PriceAdjustmentItemDetailSupplySubpartPrice';
  id: Scalars['ID']['output'];
  partCode: Maybe<Scalars['String']['output']>;
  partSupplySubpartPriceId: Maybe<Scalars['ID']['output']>;
  priceAdjustmentItemDetailId: Scalars['ID']['output'];
  quantity: Maybe<Scalars['Int']['output']>;
  quantityDenominator: Maybe<Scalars['Int']['output']>;
  rootPartCode: Maybe<Scalars['String']['output']>;
  supplyPart: Maybe<Part>;
  supplyPartCost: Maybe<Scalars['Float']['output']>;
  supplyPartName: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['ID']['output'];
  unitPrice: Maybe<Scalars['Float']['output']>;
};

export type PriceAdjustmentItemMaterialPrice = {
  __typename?: 'PriceAdjustmentItemMaterialPrice';
  baseMaterial: Maybe<BaseMaterial>;
  id: Scalars['ID']['output'];
  initialCost: Maybe<Scalars['Float']['output']>;
  materialCost: Maybe<Scalars['Float']['output']>;
  materialName: Maybe<Scalars['String']['output']>;
  materialUnitPrice: Maybe<Scalars['Float']['output']>;
  measure: Maybe<Scalars['String']['output']>;
  partMaterialPrice: PartMaterialPrice;
  priceTenantUnit: Maybe<TenantUnit>;
  procurementKind: Maybe<Scalars['String']['output']>;
  productWeight: Maybe<Scalars['Float']['output']>;
  quantity: Maybe<Scalars['Float']['output']>;
  reservedWeight: Maybe<Scalars['Float']['output']>;
  scrapSubtotal: Maybe<Scalars['Float']['output']>;
  scrapUnitPrice: Maybe<Scalars['Float']['output']>;
  scrapWeight: Maybe<Scalars['Float']['output']>;
  startOn: Maybe<Scalars['ISO8601Date']['output']>;
  startUpMonth: Maybe<Scalars['ISO8601Date']['output']>;
  variation: Maybe<Scalars['Float']['output']>;
  weightTenantUnit: Maybe<TenantUnit>;
};

export type PriceAdjustmentItemPriceChangeReason = {
  __typename?: 'PriceAdjustmentItemPriceChangeReason';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  priceChangeReasonId: Scalars['ID']['output'];
  priceDifference: Maybe<Scalars['Float']['output']>;
  reason: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  tenantId: Scalars['ID']['output'];
};

/** Autogenerated input type of PriceAdjustmentItemValidate */
export type PriceAdjustmentItemValidateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: PriceAdjustmentFormSaveItemInput;
};

/** Autogenerated return type of PriceAdjustmentItemValidate. */
export type PriceAdjustmentItemValidatePayload = {
  __typename?: 'PriceAdjustmentItemValidatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Maybe<Array<InputFormError>>;
  isValid: Scalars['Boolean']['output'];
};

export type PriceAdjustmentSetting = {
  __typename?: 'PriceAdjustmentSetting';
  id: Scalars['ID']['output'];
  isUseMaterialPriceAdjustment: Maybe<Scalars['Boolean']['output']>;
  isUsePriceAdjustmentFormEdit: Scalars['Boolean']['output'];
  materialPriceAdjustmentTargetKind: PriceAdjustmentSettingMaterialPriceAdjustmentTargetKindEnum;
  reasonCount: Scalars['Int']['output'];
  tenantId: Scalars['ID']['output'];
};

export enum PriceAdjustmentSettingMaterialPriceAdjustmentTargetKindEnum {
  AByMaterialPriceChange = 'a_by_material_price_change',
  BByEffectiveUnitPrice = 'b_by_effective_unit_price'
}

export type PriceAdjustmentStatus = {
  __typename?: 'PriceAdjustmentStatus';
  name: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

/** Autogenerated input type of PriceAdjustmentUpdate */
export type PriceAdjustmentUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: PriceAdjustmentInput;
};

export type PriceAdjustmentUpdateInputItem = {
  id: Scalars['ID']['input'];
  isDelete: Scalars['Boolean']['input'];
  materialCost?: InputMaybe<Scalars['Float']['input']>;
  memo: Scalars['String']['input'];
  otherCost?: InputMaybe<Scalars['Float']['input']>;
  priceChangeReasons: Array<PriceAdjustmentUpdateInputItemChangeReason>;
  processingCost?: InputMaybe<Scalars['Float']['input']>;
  scrapPrice?: InputMaybe<Scalars['Float']['input']>;
  supplyPartPrice?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type PriceAdjustmentUpdateInputItemChangeReason = {
  id: Scalars['ID']['input'];
  priceDifference?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated return type of PriceAdjustmentUpdate. */
export type PriceAdjustmentUpdatePayload = {
  __typename?: 'PriceAdjustmentUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
  priceAdjustment: Maybe<PriceAdjustment>;
};

/** Autogenerated input type of PriceAdjustmentWithdraw */
export type PriceAdjustmentWithdrawInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: PriceAdjustmentFormSaveInput;
};

/** Autogenerated return type of PriceAdjustmentWithdraw. */
export type PriceAdjustmentWithdrawPayload = {
  __typename?: 'PriceAdjustmentWithdrawPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  priceAdjustment: Maybe<PriceAdjustment>;
};

/** Autogenerated input type of PriceAdjustmentsCreatableCheckByIds */
export type PriceAdjustmentsCreatableCheckByIdsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of PriceAdjustmentsCreatableCheckByIds. */
export type PriceAdjustmentsCreatableCheckByIdsPayload = {
  __typename?: 'PriceAdjustmentsCreatableCheckByIdsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  err: Maybe<Scalars['String']['output']>;
  priceAdjustableIds: Maybe<Array<Scalars['ID']['output']>>;
  priceUnadjustablePartCodeAndNames: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of PriceAdjustmentsCreatableCheck */
export type PriceAdjustmentsCreatableCheckInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  figureNumber?: InputMaybe<Scalars['String']['input']>;
  referenceDate?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
};

/** Autogenerated return type of PriceAdjustmentsCreatableCheck. */
export type PriceAdjustmentsCreatableCheckPayload = {
  __typename?: 'PriceAdjustmentsCreatableCheckPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  err: Maybe<Scalars['String']['output']>;
  priceAdjustableIds: Maybe<Array<Scalars['ID']['output']>>;
  priceUnadjustablePartCodeAndNames: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of PriceAdjustmentsCreate */
export type PriceAdjustmentsCreateInput = {
  adjustmentPurpose: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  confirmationDeadlineDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  confirmationStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  partsId: Array<Scalars['ID']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  targetTerm: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};

/** Autogenerated return type of PriceAdjustmentsCreate. */
export type PriceAdjustmentsCreatePayload = {
  __typename?: 'PriceAdjustmentsCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
  priceAdjustments: Maybe<Array<PriceAdjustment>>;
};

/** Autogenerated input type of PriceAdjustmentsCsvCreate */
export type PriceAdjustmentsCsvCreateInput = {
  adjustmentPurpose: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  confirmationDeadlineDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  confirmationStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  fileName: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
  targetTerm: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};

/** Autogenerated return type of PriceAdjustmentsCsvCreate. */
export type PriceAdjustmentsCsvCreatePayload = {
  __typename?: 'PriceAdjustmentsCsvCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errorRecords: Maybe<Array<ErrorRecord>>;
  errors: Array<ValidationErr>;
  priceAdjustments: Maybe<Array<PriceAdjustment>>;
};

export type PriceChangeReason = {
  __typename?: 'PriceChangeReason';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  tenantId: Scalars['ID']['output'];
};

export type ProcurementKindSetting = {
  __typename?: 'ProcurementKindSetting';
  /** 表示名。空なら辞書の既定ラベルを使う */
  label: Maybe<Scalars['String']['output']>;
  /** 調達区分(enum 名) */
  procurementKind: Scalars['String']['output'];
  /** 表示順 */
  seq: Scalars['Int']['output'];
};

/** 調達区分を使う明細 */
export enum ProcurementKindTargetKindEnum {
  /** 材料費 */
  MaterialCost = 'MATERIAL_COST',
  /** 部品費 */
  PartCost = 'PART_COST'
}

export type Product = {
  __typename?: 'Product';
  annualQuantity: Maybe<Scalars['String']['output']>;
  code: Maybe<Scalars['String']['output']>;
  customerDevelopmentCode: Maybe<Scalars['String']['output']>;
  customerName: Maybe<Scalars['String']['output']>;
  detail: Maybe<Scalars['String']['output']>;
  division: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  manufacturingLocation: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orderProbability: Maybe<Scalars['String']['output']>;
  orderType: Maybe<Scalars['String']['output']>;
  productScheduleGroups: Array<ProductScheduleGroup>;
  scheduledSalesDate: Maybe<Scalars['String']['output']>;
};

export type ProductConfig = {
  __typename?: 'ProductConfig';
  isUseAnnualQuantity: Scalars['Boolean']['output'];
  isUseCustomerDevelopmentCode: Scalars['Boolean']['output'];
  isUseCustomerName: Scalars['Boolean']['output'];
  isUseDetail: Scalars['Boolean']['output'];
  isUseDivision: Scalars['Boolean']['output'];
  isUseManufacturingLocation: Scalars['Boolean']['output'];
  isUseOrderProbability: Scalars['Boolean']['output'];
  isUseOrderType: Scalars['Boolean']['output'];
  isUseScheduledSalesDate: Scalars['Boolean']['output'];
  isVisibleAnnualQuantity: Scalars['Boolean']['output'];
  isVisibleCustomerDevelopmentCode: Scalars['Boolean']['output'];
  isVisibleCustomerName: Scalars['Boolean']['output'];
  isVisibleDetail: Scalars['Boolean']['output'];
  isVisibleDevelopmentCode: Scalars['Boolean']['output'];
  isVisibleDivision: Scalars['Boolean']['output'];
  isVisibleManufacturingLocation: Scalars['Boolean']['output'];
  isVisibleName: Scalars['Boolean']['output'];
  isVisibleOrderProbability: Scalars['Boolean']['output'];
  isVisibleOrderType: Scalars['Boolean']['output'];
  isVisibleScheduledSalesDate: Scalars['Boolean']['output'];
};

export type ProductSchedule = {
  __typename?: 'ProductSchedule';
  eventName: Scalars['String']['output'];
  eventOn: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  seqNo: Maybe<Scalars['Int']['output']>;
};

export type ProductScheduleGroup = {
  __typename?: 'ProductScheduleGroup';
  id: Scalars['ID']['output'];
  productSchedules: Array<ProductSchedule>;
  seqNo: Scalars['Int']['output'];
};

export type ProductScheduleGroupSnapshot = {
  __typename?: 'ProductScheduleGroupSnapshot';
  id: Scalars['ID']['output'];
  productSchedules: Array<ProductScheduleSnapshot>;
  seqNo: Scalars['Int']['output'];
};

export type ProductScheduleSetting = {
  __typename?: 'ProductScheduleSetting';
  code: Scalars['String']['output'];
  groupSeqNo: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  seqNo: Scalars['Int']['output'];
};

export type ProductScheduleSnapshot = {
  __typename?: 'ProductScheduleSnapshot';
  eventName: Scalars['String']['output'];
  eventOn: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  seqNo: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of ProfileUpdate */
export type ProfileUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  csvExportEncodingKind?: InputMaybe<SupplierUserCsvExportEncodingKindEnum>;
  department: Scalars['String']['input'];
  email: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  supplierUserInfos?: InputMaybe<Array<Scalars['JSON']['input']>>;
  tel: Scalars['String']['input'];
  tenantAssignments?: InputMaybe<Array<TenantAssignmentInput>>;
  title: Scalars['String']['input'];
};

/** Autogenerated return type of ProfileUpdate. */
export type ProfileUpdatePayload = {
  __typename?: 'ProfileUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  err: Maybe<Scalars['String']['output']>;
  profile: Maybe<SupplierAccount>;
};

export type Project = {
  __typename?: 'Project';
  id: Scalars['ID']['output'];
  modelTitle: Maybe<Scalars['String']['output']>;
  modelTypeName: Maybe<Scalars['String']['output']>;
  modelYear: Maybe<Scalars['Float']['output']>;
  projectFormat: Maybe<ProjectFormat>;
  projectModel: Maybe<ProjectModel>;
  projectSchedules: Array<ProjectSchedule>;
  quotationContext: QuotationContext;
  title: Scalars['String']['output'];
  uid: Scalars['ID']['output'];
};

export type ProjectFormat = {
  __typename?: 'ProjectFormat';
  isSingleUnitProject: Scalars['Boolean']['output'];
};

export type ProjectItem = {
  __typename?: 'ProjectItem';
  id: Scalars['ID']['output'];
  quantityPerRoot: Maybe<Scalars['Float']['output']>;
};

export type ProjectModel = {
  __typename?: 'ProjectModel';
  annualQuantity: Maybe<Scalars['String']['output']>;
  code: Maybe<Scalars['String']['output']>;
  customerDevelopmentCode: Maybe<Scalars['String']['output']>;
  customerName: Maybe<Scalars['String']['output']>;
  deliverySiteId: Maybe<Scalars['String']['output']>;
  deliverySiteName: Maybe<Scalars['String']['output']>;
  detail: Maybe<Scalars['String']['output']>;
  division: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  manufacturingLocation: Maybe<Scalars['String']['output']>;
  manufacturingSiteId: Maybe<Scalars['String']['output']>;
  manufacturingSiteName: Maybe<Scalars['String']['output']>;
  modelDepreciation: Maybe<Scalars['String']['output']>;
  modelDepreciationQuantity: Maybe<Scalars['Float']['output']>;
  modelDepreciationTenantPeriodUnitId: Maybe<Scalars['ID']['output']>;
  modelDepreciationTenantUnitId: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  orderProbability: Maybe<Scalars['String']['output']>;
  orderType: Maybe<Scalars['String']['output']>;
  productWeight: Maybe<Scalars['Float']['output']>;
  scheduledSalesDate: Maybe<Scalars['String']['output']>;
};

export type ProjectSchedule = {
  __typename?: 'ProjectSchedule';
  eventName: Scalars['String']['output'];
  eventOn: Maybe<Scalars['ISO8601Date']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  qualificationLevelId: Maybe<Scalars['String']['output']>;
  qualificationLevelName: Maybe<Scalars['String']['output']>;
  seqNo: Maybe<Scalars['Int']['output']>;
};

export type PurchaseGroupPart = {
  __typename?: 'PurchaseGroupPart';
  groupUid: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isParent: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  accountInvitationByToken: AccountInvitationByTokenPayload;
  adminUsers: AdminUserConnection;
  adminUsersByTransaction: AdminUserConnection;
  allStates: Array<State>;
  attachmentOffer: Maybe<AttachmentOffer>;
  attachmentOffers: AttachmentOfferConnection;
  attachmentUploadUrls: AttachmentUploadUrl;
  bcpIncidentAnswerDraft: Maybe<BcpIncidentAnswerDraft>;
  bcpIncidentAnswerRequest: Maybe<BcpIncidentAnswerRequest>;
  bcpIncidentAnswerRequestByToken: Maybe<BcpIncidentAnswerRequestByToken>;
  bcpIncidentAnswerRequests: BcpIncidentAnswerRequestConnection;
  commentBase: Maybe<CommentBase>;
  commentSetting: Maybe<CommentSetting>;
  contactClasses: Array<ContactClass>;
  countries: Array<Country>;
  crSupplierFirm: Array<CrSupplierFirm>;
  crSupplierFirmBankInfos: Array<Array<CrSupplierFirmBankInfo>>;
  crSupplierFirmCertificationInfos: Array<Array<CrSupplierFirmCertificationInfo>>;
  crSupplierFirmEmployeeNumberInfos: Array<Array<CrSupplierFirmEmployeeNumberInfo>>;
  crSupplierFirmEquipmentInfos: Array<Array<CrSupplierFirmEquipmentInfo>>;
  crSupplierFirmFileInfos: Array<Array<CrSupplierFirmFileInfo>>;
  crSupplierFirmFinancialDetails: Array<Array<CrSupplierFirmFinancialDetail>>;
  crSupplierFirmFinancialInfo: Array<Maybe<CrSupplierFirmFinancialInfo>>;
  crSupplierFirmKeyPositionInfos: Array<Array<CrSupplierFirmKeyPositionInfo>>;
  crSupplierFirmLaborSituationInfo: Array<Maybe<CrSupplierFirmLaborSituationInfo>>;
  crSupplierFirmManufacturingSites: Array<Array<CrSupplierFirmManufacturingSite>>;
  crSupplierFirmMemberOrganizations: Array<Array<CrSupplierFirmMemberOrganization>>;
  crSupplierFirmOutsourcingInfos: Array<Array<CrSupplierFirmOutsourcingInfo>>;
  crSupplierFirmRepresentativeInfo: Array<Maybe<CrSupplierFirmRepresentativeInfo>>;
  crSupplierFirmSalesStatusInfos: Array<Array<CrSupplierFirmSalesStatusInfo>>;
  crSupplierFirmShareholderInfos: Array<Array<CrSupplierFirmShareholderInfo>>;
  crSupplierFirmSites: Array<Array<CrSupplierFirmSite>>;
  crSupplierFirmSurveyEnqueteAnswers: Array<Array<CrSupplierFirmSurveyEnqueteAnswer>>;
  crSupplierFirmUserInfos: Array<Array<CrSupplierFirmUserInfo>>;
  currencies: Array<Currency>;
  dataShares: Maybe<Array<DataShare>>;
  deliveredAnnouncement: Maybe<DeliveredAnnouncement>;
  deliveredAnnouncements: DeliveredAnnouncementConnection;
  deliverySites: Array<DeliverySite>;
  enqueteAnswer: EnqueteAnswer;
  enqueteAnswers: EnqueteAnswerConnection;
  hasUnreadComments: Scalars['Boolean']['output'];
  incompleteTasks: IncompleteTaskConnection;
  industries: Array<Industry>;
  inputFormSchema: Maybe<InputFormSchema>;
  itemRequirementByPriceAdjustmentItem: Maybe<ItemRequirement>;
  listViewSchema: ListViewSchema;
  manufacturingSites: Array<ManufacturingSite>;
  me: Maybe<SupplierAccount>;
  mold: Mold;
  moldDisposalSupplierApplication: Maybe<MoldDisposalSupplierApplication>;
  moldDisposalSupplierApplications: MoldDisposalSupplierApplicationConnection;
  moldStoragePayments: MoldStoragePaymentConnection;
  molds: MoldsWithStatusCount;
  moldsForApplication: Maybe<MoldsForApplication>;
  mySuppliers: Array<Supplier>;
  packageBulkAnswerSheet: PackageBulkAnswerSheet;
  partList: PartListConnection;
  partOrderUnitPricesByIds: Array<PartOrderUnitPrice>;
  partOrderUnitPricesForAdjustment: Array<PartOrderUnitPrice>;
  partOrderUnitPricesForList: PartOrderUnitPriceForListConnection;
  partSupplyPriceHistory: PartSupplyPriceConnection;
  partSupplyPriceList: PartSupplyPriceConnection;
  priceAdjustment: PriceAdjustmentDetail;
  priceAdjustmentAdjustmentStatuses: Array<PriceAdjustmentStatus>;
  priceAdjustmentConfirmationStatuses: Array<PriceAdjustmentStatus>;
  priceAdjustmentItemForForm: PriceAdjustmentItem;
  priceAdjustmentItemProject: Maybe<Project>;
  priceAdjustmentMaterialErrors: Array<Scalars['String']['output']>;
  priceAdjustmentSetting: PriceAdjustmentSetting;
  priceAdjustments: PriceAdjustmentConnection;
  priceAdjustmentsV2: PriceAdjustmentConnection;
  priceChangeReasons: Array<PriceChangeReason>;
  privacyPolicy: VersionedAgreement;
  /** 回答先テナントの調達区分の選択肢設定。空配列なら設定なし(画面ごとの既定の選択肢を使う) */
  procurementKindSettings: Array<ProcurementKindSetting>;
  profile: Maybe<SupplierAccount>;
  quotation: Quotation;
  quotationsV2: QuotationConnection;
  selectableSupplierFileClasses: Array<SupplierFileClass>;
  selectableTenants: TenantCandidateConnection;
  selectedTenant: Maybe<Tenant>;
  sharedAnnualTotals: Maybe<SharedAnnualTotalsResult>;
  sharedPartMaterialUsages: Maybe<SharedPartMaterialUsagesResult>;
  sharedPartStructures: Maybe<SharedPartStructuresResult>;
  sharedPartTransactions: Maybe<SharedPartTransactionsResult>;
  sharedParts: Maybe<SharedPartsResult>;
  sharedUnofficialAnnouncements: Maybe<SharedUnofficialAnnouncementsResult>;
  states: Array<State>;
  supplierAccountInvitationBySupplierFrontend: SupplierAccountInvitationBySupplierFrontendPayload;
  supplierAccountInvitationsBySupplierFrontend: SupplierAccountInvitationBySupplierFrontendConnection;
  supplierAccounts: SupplierAccountConnection;
  supplierAnnouncements: SupplierAnnouncementsView;
  supplierCorporation: Maybe<SupplierCorporation>;
  supplierCorporationEmployees: SupplierCorporationEmployeeConnection;
  supplierFileClasses: Array<SupplierFileClass>;
  supplierFileInfo: Maybe<SupplierFileInfo>;
  supplierFileInfos: SupplierFileInfoConnection;
  supplierFirmInfoConfirmationRequest: SupplierFirmInfoConfirmationRequest;
  supplierFirmInfoConfirmationRequests: SupplierFirmInfoConfirmationRequestConnection;
  supplierMoldStorageApplication: Maybe<SupplierMoldStorageApplication>;
  supplierMoldStorageApplications: SupplierMoldStorageApplicationConnection;
  supplierOptions: Array<SupplierOption>;
  supplierOutsourcingClasses: Array<SupplierOutsourcingClass>;
  supplierQuotationPackageCountByStatus: SupplierQuotationPackageStatusCount;
  supplierQuotationPackages: SupplierQuotationPackageConnection;
  supplierScreenItemConfigs: Array<SupplierScreenItemConfig>;
  supplierScreenSurveyInfoConfigs: Array<SupplierScreenSurveyInfoConfig>;
  supplierSurveyInfoImportConfig: Maybe<SupplierSurveyInfoImportConfig>;
  tenant: Maybe<Tenant>;
  tenantCandidates: TenantCandidateConnection;
  tenantConfig: Maybe<TenantConfig>;
  tenantDirectories: TenantDirectoryConnection;
  tenantDirectory: Maybe<TenantDirectoryDetail>;
  tenantPeriodUnits: Array<TenantPeriodUnit>;
  tenantSelect: Maybe<TenantSelect>;
  tenantSelectOptions: Array<TenantSelectOption>;
  tenantUnits: Array<TenantUnit>;
  tenants: TenantCandidateConnection;
  termsOfService: VersionedAgreement;
  trialQuotationAnswerSheet: TrialQuotationAnswerSheet;
};


export type QueryAccountInvitationByTokenArgs = {
  fromKind: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type QueryAdminUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  roleCondition?: InputMaybe<Scalars['JSON']['input']>;
  tenantId: Scalars['ID']['input'];
};


export type QueryAdminUsersByTransactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['ID']['input'];
  transactionKind: Scalars['String']['input'];
};


export type QueryAttachmentOfferArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAttachmentOffersArgs = {
  adminUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  attachmentKinds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  figureNumber?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  itemName?: InputMaybe<Scalars['String']['input']>;
  itemRootCode?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttachmentUploadUrlsArgs = {
  filename: Scalars['String']['input'];
};


export type QueryBcpIncidentAnswerDraftArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBcpIncidentAnswerRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBcpIncidentAnswerRequestByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryBcpIncidentAnswerRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCommentBaseArgs = {
  commentKind: CommentKindEnum;
  itemKind: Scalars['String']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  targetId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
};


export type QueryCommentSettingArgs = {
  commentKind: CommentKindEnum;
  itemKind?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  targetId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
};


export type QueryContactClassesArgs = {
  tenantId: Scalars['ID']['input'];
};


export type QueryCrSupplierFirmArgs = {
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};


export type QueryCrSupplierFirmBankInfosArgs = {
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};


export type QueryCrSupplierFirmCertificationInfosArgs = {
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};


export type QueryCrSupplierFirmEmployeeNumberInfosArgs = {
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};


export type QueryCrSupplierFirmEquipmentInfosArgs = {
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};


export type QueryCrSupplierFirmFileInfosArgs = {
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};


export type QueryCrSupplierFirmFinancialDetailsArgs = {
  financialStatementKind: Scalars['String']['input'];
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};


export type QueryCrSupplierFirmFinancialInfoArgs = {
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};


export type QueryCrSupplierFirmKeyPositionInfosArgs = {
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};


export type QueryCrSupplierFirmLaborSituationInfoArgs = {
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};


export type QueryCrSupplierFirmManufacturingSitesArgs = {
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};


export type QueryCrSupplierFirmMemberOrganizationsArgs = {
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};


export type QueryCrSupplierFirmOutsourcingInfosArgs = {
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};


export type QueryCrSupplierFirmRepresentativeInfoArgs = {
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};


export type QueryCrSupplierFirmSalesStatusInfosArgs = {
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};


export type QueryCrSupplierFirmShareholderInfosArgs = {
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};


export type QueryCrSupplierFirmSitesArgs = {
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};


export type QueryCrSupplierFirmSurveyEnqueteAnswersArgs = {
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};


export type QueryCrSupplierFirmUserInfosArgs = {
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};


export type QueryDataSharesArgs = {
  shareConfigId: Scalars['ID']['input'];
  supplierCode: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};


export type QueryDeliveredAnnouncementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDeliveredAnnouncementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyNotConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDeliverySitesArgs = {
  tenantId: Scalars['ID']['input'];
};


export type QueryEnqueteAnswerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEnqueteAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeClosed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyUnanswered?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  supplierUserInfoId?: InputMaybe<Scalars['ID']['input']>;
  supplyChainCompanyEmployeeId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryHasUnreadCommentsArgs = {
  commentKind: CommentKindEnum;
  ignoreCommentTop?: InputMaybe<Scalars['Boolean']['input']>;
  itemKind?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  targetId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
};


export type QueryIncompleteTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIndustriesArgs = {
  tenantId: Scalars['ID']['input'];
};


export type QueryInputFormSchemaArgs = {
  code: Scalars['String']['input'];
  formattableId?: InputMaybe<Scalars['ID']['input']>;
  formattableType?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
};


export type QueryItemRequirementByPriceAdjustmentItemArgs = {
  priceAdjustmentItemId: Scalars['ID']['input'];
};


export type QueryListViewSchemaArgs = {
  code: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryManufacturingSitesArgs = {
  tenantId: Scalars['ID']['input'];
};


export type QueryMoldArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMoldDisposalSupplierApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMoldDisposalSupplierApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  applicationNo?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  moldNo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMoldStoragePaymentsArgs = {
  acceptanceDateFrom?: InputMaybe<Scalars['String']['input']>;
  acceptanceDateTo?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
  uidKeyword?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMoldsArgs = {
  assetNumber?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  classification?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  employeeName?: InputMaybe<Scalars['String']['input']>;
  isMainReadPage?: InputMaybe<Scalars['Boolean']['input']>;
  maker?: InputMaybe<Scalars['String']['input']>;
  manager?: InputMaybe<Scalars['String']['input']>;
  partCode?: InputMaybe<Scalars['String']['input']>;
  partName?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  supplierKeyWord?: InputMaybe<Scalars['String']['input']>;
  tab: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMoldsForApplicationArgs = {
  ids: Array<Scalars['ID']['input']>;
  selectedTenantId: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPackageBulkAnswerSheetArgs = {
  packageId: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
};


export type QueryPartListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  figureNumber?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  partCodes?: InputMaybe<Scalars['String']['input']>;
  partNames?: InputMaybe<Scalars['String']['input']>;
  referenceDate?: InputMaybe<Scalars['String']['input']>;
  rootPartCodes?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
};


export type QueryPartOrderUnitPricesByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
  materialPriceDateOn?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
};


export type QueryPartOrderUnitPricesForAdjustmentArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantId: Scalars['ID']['input'];
};


export type QueryPartOrderUnitPricesForListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cancelStatusKind?: InputMaybe<Scalars['String']['input']>;
  deliverySiteIds?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  ifKey1?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manufacturingSiteIds?: InputMaybe<Scalars['String']['input']>;
  partCode?: InputMaybe<Scalars['String']['input']>;
  partName?: InputMaybe<Scalars['String']['input']>;
  reasonIds?: InputMaybe<Scalars['String']['input']>;
  rootPartCode?: InputMaybe<Scalars['String']['input']>;
  searchKind?: InputMaybe<Scalars['String']['input']>;
  startOnSince?: InputMaybe<Scalars['String']['input']>;
  startOnUntil?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
};


export type QueryPartSupplyPriceHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  partId: Scalars['String']['input'];
  supplierCode: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type QueryPartSupplyPriceListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignmentPriceKind?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  figureNumber?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  referenceDate?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


export type QueryPriceAdjustmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPriceAdjustmentAdjustmentStatusesArgs = {
  tenantId: Scalars['ID']['input'];
};


export type QueryPriceAdjustmentItemForFormArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPriceAdjustmentItemProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPriceAdjustmentMaterialErrorsArgs = {
  id: Scalars['ID']['input'];
  priceEffectiveDate: Scalars['ISO8601Date']['input'];
};


export type QueryPriceAdjustmentSettingArgs = {
  tenantId: Scalars['ID']['input'];
};


export type QueryPriceAdjustmentsArgs = {
  adjustmentStatuses?: InputMaybe<Array<Scalars['Int']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  confirmationDeadlineDateFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  confirmationDeadlineDateTo?: InputMaybe<Scalars['ISO8601Date']['input']>;
  confirmationStartDateFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  confirmationStartDateTo?: InputMaybe<Scalars['ISO8601Date']['input']>;
  confirmationStatuses?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inChargeSupplierUserId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ownConfirmationSupplierCode?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
};


export type QueryPriceAdjustmentsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  confirmDueDateSince?: InputMaybe<Scalars['String']['input']>;
  confirmDueDateUntil?: InputMaybe<Scalars['String']['input']>;
  confirmStartDateSince?: InputMaybe<Scalars['String']['input']>;
  confirmStartDateUntil?: InputMaybe<Scalars['String']['input']>;
  confirmationStatus?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  partCode?: InputMaybe<Scalars['String']['input']>;
  partName?: InputMaybe<Scalars['String']['input']>;
  personInChargeIds?: InputMaybe<Scalars['String']['input']>;
  priceEffectiveDateSince?: InputMaybe<Scalars['String']['input']>;
  priceEffectiveDateUntil?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  rootPartCode?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
};


export type QueryPriceChangeReasonsArgs = {
  tenantId: Scalars['ID']['input'];
};


export type QueryProcurementKindSettingsArgs = {
  targetKind: ProcurementKindTargetKindEnum;
  tenantId: Scalars['ID']['input'];
};


export type QueryQuotationArgs = {
  id: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
};


export type QueryQuotationsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  answerDueDateSince?: InputMaybe<Scalars['ISO8601Date']['input']>;
  answerDueDateUntil?: InputMaybe<Scalars['ISO8601Date']['input']>;
  answerStatus?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  itemName?: InputMaybe<Scalars['String']['input']>;
  itemRootCode?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  partsName?: InputMaybe<Scalars['String']['input']>;
  progressStatus?: InputMaybe<Scalars['String']['input']>;
  quotationUid?: InputMaybe<Scalars['String']['input']>;
  quotationUids?: InputMaybe<Array<Scalars['String']['input']>>;
  requestedOnSince?: InputMaybe<Scalars['ISO8601Date']['input']>;
  requestedOnUntil?: InputMaybe<Scalars['ISO8601Date']['input']>;
  selectionStatus?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
};


export type QuerySelectableSupplierFileClassesArgs = {
  supplierFileClassId?: InputMaybe<Scalars['ID']['input']>;
  tenantId: Scalars['ID']['input'];
};


export type QuerySelectableTenantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kind: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySelectedTenantArgs = {
  kind?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySharedAnnualTotalsArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  shareId?: InputMaybe<Scalars['ID']['input']>;
  supplierCode: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};


export type QuerySharedPartMaterialUsagesArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  shareId?: InputMaybe<Scalars['ID']['input']>;
  supplierCode: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};


export type QuerySharedPartStructuresArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  shareId?: InputMaybe<Scalars['ID']['input']>;
  supplierCode: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};


export type QuerySharedPartTransactionsArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  shareId?: InputMaybe<Scalars['ID']['input']>;
  supplierCode: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};


export type QuerySharedPartsArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  shareId?: InputMaybe<Scalars['ID']['input']>;
  supplierCode: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};


export type QuerySharedUnofficialAnnouncementsArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  shareId?: InputMaybe<Scalars['ID']['input']>;
  supplierCode: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};


export type QueryStatesArgs = {
  countryId: Scalars['ID']['input'];
};


export type QuerySupplierAccountInvitationBySupplierFrontendArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplierAccountInvitationsBySupplierFrontendArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupplierAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  withArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySupplierCorporationEmployeesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<SupplierCorporationEmployeeScopeEnum>;
  withArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySupplierFileClassesArgs = {
  tenantId: Scalars['ID']['input'];
};


export type QuerySupplierFileInfoArgs = {
  id: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
};


export type QuerySupplierFileInfosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierFileClassId?: InputMaybe<Scalars['ID']['input']>;
  tenantId: Scalars['ID']['input'];
};


export type QuerySupplierFirmInfoConfirmationRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplierFirmInfoConfirmationRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  answerDateFrom?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  answerDateTo?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  confirmationRequestNo?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  notificationTargets?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<SupplierFirmInfoConfirmationRequestStatusEnum>>;
  surveyYears?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
};


export type QuerySupplierMoldStorageApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplierMoldStorageApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  applicationNo?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  moldNo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupplierOptionsArgs = {
  tenantId: Scalars['ID']['input'];
};


export type QuerySupplierOutsourcingClassesArgs = {
  tenantId: Scalars['ID']['input'];
};


export type QuerySupplierQuotationPackageCountByStatusArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
};


export type QuerySupplierQuotationPackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
};


export type QuerySupplierScreenItemConfigsArgs = {
  componentId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
};


export type QuerySupplierScreenSurveyInfoConfigsArgs = {
  tenantId: Scalars['ID']['input'];
};


export type QuerySupplierSurveyInfoImportConfigArgs = {
  tenantId: Scalars['ID']['input'];
};


export type QueryTenantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTenantCandidatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTenantConfigArgs = {
  tenantId: Scalars['ID']['input'];
};


export type QueryTenantDirectoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  firmName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  supplierAccountId?: InputMaybe<Scalars['ID']['input']>;
  supplierUserId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTenantDirectoryArgs = {
  id: Scalars['ID']['input'];
  includePast?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTenantSelectArgs = {
  nitoelSelectId: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};


export type QueryTenantSelectOptionsArgs = {
  nitoelSelectId: Scalars['String']['input'];
};


export type QueryTenantUnitsArgs = {
  unitKind?: InputMaybe<UnitKindEnum>;
};


export type QueryTenantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  firmName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  supplierAccountId?: InputMaybe<Scalars['ID']['input']>;
  supplierUserId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTrialQuotationAnswerSheetArgs = {
  quotationId: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
};

export type Quotation = {
  __typename?: 'Quotation';
  adminUsersForSupplierFront: Array<AdminUser>;
  announcementKind: Scalars['String']['output'];
  answerDueDate: Maybe<Scalars['ISO8601Date']['output']>;
  answerFormat: AnswerFormat;
  answerFormatKind: Scalars['String']['output'];
  applicationFormat: ApplicationFormat;
  attachmentOffers: Array<AttachmentOffer>;
  attachments: Array<Attachment>;
  closeMemoForSupplier: Maybe<Scalars['String']['output']>;
  dayTypeSetting: Scalars['String']['output'];
  deliveryInputKind: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isBeforeMigration: Scalars['Boolean']['output'];
  isDetailCostUsed: Scalars['Boolean']['output'];
  /** 購買受付（GA）由来の見積か */
  isFromPurchaseReceipt: Scalars['Boolean']['output'];
  isOneOffOrder: Scalars['Boolean']['output'];
  isRequestSupplyChain: Scalars['Boolean']['output'];
  isUseAnswerExcelImport: Scalars['Boolean']['output'];
  itemsToAnswer: Array<ItemToAnswer>;
  kind: Scalars['String']['output'];
  orderQuantityUnit: Maybe<Scalars['String']['output']>;
  previousQuotation: Maybe<Quotation>;
  previousQuotationId: Maybe<Scalars['ID']['output']>;
  quotationContext: Maybe<QuotationContext>;
  quotationInquiries: Array<QuotationInquiry>;
  quotationItemsV2: Array<QuotationItemV2>;
  quotationProductSchedules: Array<QuotationProductSchedule>;
  quotationProducts: Array<QuotationProduct>;
  quotationRequest: QuotationRequest;
  requestText: Maybe<Scalars['String']['output']>;
  selectKind: Scalars['String']['output'];
  status: Scalars['String']['output'];
  supplierQuotationPackage: Maybe<SupplierQuotationPackage>;
  tenant: Tenant;
  uid: Scalars['String']['output'];
  uniqFacilityKinds: Array<FacilityKind>;
};

export type QuotationAttachment = {
  __typename?: 'QuotationAttachment';
  attachments: Array<Attachment>;
  id: Scalars['ID']['output'];
  quotationAttachmentKind: Scalars['String']['output'];
  quotationId: Scalars['ID']['output'];
  quotationItemIds: Array<Scalars['String']['output']>;
  tenantId: Scalars['ID']['output'];
};

export type QuotationConfig = {
  __typename?: 'QuotationConfig';
  dayTypeSetting: Scalars['String']['output'];
  deliveryInputKind: Scalars['String']['output'];
  isUseAnswerExcelMultipleSupplementalAttachments: Scalars['Boolean']['output'];
  isUseComment: Scalars['Boolean']['output'];
  isUseFieldComment: Scalars['Boolean']['output'];
  isUseQuotationPackage: Scalars['Boolean']['output'];
  isUseTemporaryAnswer: Scalars['Boolean']['output'];
};

/** The connection type for Quotation. */
export type QuotationConnection = {
  __typename?: 'QuotationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<QuotationEdge>>>;
  /** A list of nodes. */
  nodes: Array<Quotation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuotationContext = {
  __typename?: 'QuotationContext';
  assumedExchangeRateCny: Array<Scalars['Float']['output']>;
  assumedExchangeRateUsd: Array<Scalars['Float']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  contextableType: Maybe<Scalars['String']['output']>;
  costBearingDollyKind: Maybe<QuotationContextCostBearingDollyKindEnum>;
  costBearingInitialCostKind: Maybe<QuotationContextCostBearingInitialCostKindEnum>;
  currency1Id: Maybe<Scalars['String']['output']>;
  currency2Id: Maybe<Scalars['String']['output']>;
  currency3Id: Maybe<Scalars['String']['output']>;
  currencyName1: Maybe<Scalars['String']['output']>;
  currencyName2: Maybe<Scalars['String']['output']>;
  currencyName3: Maybe<Scalars['String']['output']>;
  currencyRate1: Maybe<Scalars['Float']['output']>;
  currencyRate2: Maybe<Scalars['Float']['output']>;
  currencyRate3: Maybe<Scalars['Float']['output']>;
  currencyRateDisplay1: Maybe<Scalars['String']['output']>;
  currencyRateDisplay2: Maybe<Scalars['String']['output']>;
  currencyRateDisplay3: Maybe<Scalars['String']['output']>;
  deliveryCartHandling: Maybe<Array<Scalars['ID']['output']>>;
  deliveryCartHandlingLabels: Maybe<Array<Scalars['String']['output']>>;
  deliveryPeriod: Maybe<Scalars['String']['output']>;
  deliverySiteId: Maybe<Scalars['String']['output']>;
  deliverySiteName: Maybe<Scalars['String']['output']>;
  desiredDeliveryDueOn: Maybe<Scalars['ISO8601Date']['output']>;
  equipmentAndToolHandling: Maybe<Array<Scalars['ID']['output']>>;
  equipmentAndToolHandlingLabels: Maybe<Array<Scalars['String']['output']>>;
  id: Maybe<Scalars['ID']['output']>;
  incoterms: Array<Scalars['ID']['output']>;
  incotermsLabels: Array<Scalars['String']['output']>;
  massProductionCategory: Maybe<Array<Scalars['ID']['output']>>;
  massProductionCategoryLabels: Maybe<Array<Scalars['String']['output']>>;
  materialAndPaintHandling: Maybe<Array<Scalars['ID']['output']>>;
  materialAndPaintHandlingLabels: Maybe<Array<Scalars['String']['output']>>;
  materialPriceDateOn: Maybe<Scalars['ISO8601Date']['output']>;
  materialPriceReferenceDate: Array<Scalars['ISO8601Date']['output']>;
  materialSupplyPresenceKind: Maybe<QuotationContextMaterialSupplyPresenceKindEnum>;
  modelDepreciation: Maybe<Scalars['String']['output']>;
  modelDepreciationQuantity: Maybe<Scalars['Float']['output']>;
  modelDepreciationTenantPeriodUnit: Maybe<TenantPeriodUnit>;
  modelDepreciationTenantUnit: Maybe<TenantUnit>;
  naphthaDateOn: Maybe<Scalars['ISO8601Date']['output']>;
  naphthaPrice: Maybe<Scalars['Float']['output']>;
  partSupplyPresenceKind: Maybe<QuotationContextPartSupplyPresenceKindEnum>;
  paymentInstallmentInitialCostKind: Maybe<QuotationContextPaymentInstallmentInitialCostKindEnum>;
  paymentMethod: Maybe<Array<Scalars['ID']['output']>>;
  paymentMethodLabels: Maybe<Array<Scalars['String']['output']>>;
  requestProcess: Maybe<Array<Scalars['ID']['output']>>;
  requestProcessLabels: Maybe<Array<Scalars['String']['output']>>;
  ruleOfCurrencyRateChange: Array<Scalars['ID']['output']>;
  ruleOfCurrencyRateChangeLabels: Array<Scalars['String']['output']>;
  ruleOfMarketChange: Array<Scalars['ID']['output']>;
  ruleOfMarketChangeLabels: Array<Scalars['String']['output']>;
};

export enum QuotationContextCostBearingDollyKindEnum {
  AOrderer = 'a_orderer',
  BContractor = 'b_contractor'
}

export enum QuotationContextCostBearingInitialCostKindEnum {
  AOrderer = 'a_orderer',
  BContractor = 'b_contractor'
}

export type QuotationContextInput = {
  assumedExchangeRateCny?: InputMaybe<Array<Scalars['Float']['input']>>;
  assumedExchangeRateUsd?: InputMaybe<Array<Scalars['Float']['input']>>;
  costBearingDollyKind?: InputMaybe<QuotationContextCostBearingDollyKindEnum>;
  costBearingInitialCostKind?: InputMaybe<QuotationContextCostBearingInitialCostKindEnum>;
  incoterms?: InputMaybe<Array<Scalars['ID']['input']>>;
  massProductionCategory?: InputMaybe<Array<Scalars['ID']['input']>>;
  materialPriceReferenceDate?: InputMaybe<Array<Scalars['ISO8601Date']['input']>>;
  materialSupplyPresenceKind?: InputMaybe<QuotationContextMaterialSupplyPresenceKindEnum>;
  partSupplyPresenceKind?: InputMaybe<QuotationContextPartSupplyPresenceKindEnum>;
  paymentInstallmentInitialCostKind?: InputMaybe<QuotationContextPaymentInstallmentInitialCostKindEnum>;
  paymentMethod?: InputMaybe<Array<Scalars['ID']['input']>>;
  requestProcess?: InputMaybe<Array<Scalars['ID']['input']>>;
  ruleOfCurrencyRateChange?: InputMaybe<Array<Scalars['ID']['input']>>;
  ruleOfMarketChange?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum QuotationContextMaterialSupplyPresenceKindEnum {
  AAbsent = 'a_absent',
  BPresent = 'b_present'
}

export enum QuotationContextPartSupplyPresenceKindEnum {
  AAbsent = 'a_absent',
  BPresent = 'b_present'
}

export enum QuotationContextPaymentInstallmentInitialCostKindEnum {
  ALumpSum = 'a_lump_sum',
  BInstallments_24 = 'b_installments_24',
  CUnitPriceIncluded = 'c_unit_price_included'
}

/** An edge in a connection. */
export type QuotationEdge = {
  __typename?: 'QuotationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Quotation>;
};

export type QuotationInquiry = {
  __typename?: 'QuotationInquiry';
  attachment: Maybe<Attachment>;
  id: Scalars['ID']['output'];
  inquiryType: Scalars['String']['output'];
  quotation: Quotation;
  seqNo: Scalars['Int']['output'];
  tenantId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  unit: Maybe<Scalars['String']['output']>;
};

export type QuotationItemAssemblyEntity = {
  __typename?: 'QuotationItemAssemblyEntity';
  depth: Scalars['Int']['output'];
  numberCount: Scalars['Int']['output'];
  quotationItem: QuotationItemV2;
  unitKind: Scalars['String']['output'];
};

export type QuotationItemChildStruct = {
  __typename?: 'QuotationItemChildStruct';
  id: Scalars['ID']['output'];
  itemRequirement: Maybe<ItemRequirement>;
  level: Scalars['Int']['output'];
  parentId: Maybe<Scalars['ID']['output']>;
  quantityPerRoot: Scalars['Float']['output'];
  quotationItemId: Scalars['ID']['output'];
  quotationRequestKind: QuotationRequestKindEnum;
  tenantUnit: TenantUnit;
};

export type QuotationItemMaterial = {
  __typename?: 'QuotationItemMaterial';
  baseMaterialCode: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  materialBasePrice: Maybe<Scalars['Float']['output']>;
  materialName: Scalars['String']['output'];
  procurementKind: Maybe<Scalars['String']['output']>;
  quotationItemId: Scalars['Int']['output'];
  scrap1UnitPrice: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['Int']['output'];
  thickness: Maybe<Scalars['Float']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export type QuotationItemSelection = {
  __typename?: 'QuotationItemSelection';
  id: Scalars['ID']['output'];
  isSelected: Scalars['Boolean']['output'];
};

export type QuotationItemV2 = {
  __typename?: 'QuotationItemV2';
  deliverySites: Array<DeliverySite>;
  id: Scalars['ID']['output'];
  isNew: Maybe<Scalars['Boolean']['output']>;
  isRoot: Scalars['Boolean']['output'];
  itemRequirement: ItemRequirement;
  multiLot: Array<Scalars['Float']['output']>;
  products: Array<Product>;
  project: Maybe<Project>;
  projectItem: Maybe<ProjectItem>;
  quantity: Maybe<Scalars['Float']['output']>;
  quantityGroups: Array<Scalars['String']['output']>;
  quotation: Quotation;
  quotationItemChildStructs: Array<QuotationItemChildStruct>;
  quotationItemMaterials: Array<QuotationItemMaterial>;
  quotationItemSelection: Maybe<QuotationItemSelection>;
  quotationItemSupplyParts: Array<CommonSupplyPartInfo>;
  quotationItemSupplySubparts: Array<CommonQuotationItemSupplySubpart>;
  receiverCode: Maybe<Scalars['String']['output']>;
  receiverName: Maybe<Scalars['String']['output']>;
  tenantPeriodUnit: Maybe<TenantPeriodUnit>;
  tenantUnit: Maybe<TenantUnit>;
};

export type QuotationProduct = {
  __typename?: 'QuotationProduct';
  annualQuantity: Maybe<Scalars['String']['output']>;
  customerDevelopmentCode: Maybe<Scalars['String']['output']>;
  customerName: Maybe<Scalars['String']['output']>;
  developmentCode: Maybe<Scalars['String']['output']>;
  orderProbability: Maybe<Scalars['String']['output']>;
  orderType: Maybe<Scalars['String']['output']>;
  productDetail: Maybe<Scalars['String']['output']>;
  productDevision: Maybe<Scalars['String']['output']>;
  productId: Maybe<Scalars['ID']['output']>;
  productInformation: Maybe<Scalars['String']['output']>;
  productManufacturingLocation: Maybe<Scalars['String']['output']>;
  productScheduleGroupSnapshots: Array<ProductScheduleGroupSnapshot>;
  scheduledSalesDate: Maybe<Scalars['String']['output']>;
};

export type QuotationProductSchedule = {
  __typename?: 'QuotationProductSchedule';
  groupSeqNo: Scalars['Int']['output'];
  id: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  seqNo: Scalars['Int']['output'];
  value: Maybe<Scalars['String']['output']>;
};

export type QuotationRequest = {
  __typename?: 'QuotationRequest';
  answer: Maybe<Answer>;
  answeredAt: Maybe<Scalars['ISO8601Date']['output']>;
  answeredAtZoned: Maybe<Scalars['ISO8601DateTime']['output']>;
  commentForSupplier: Maybe<Scalars['String']['output']>;
  currencies: Array<Currency>;
  id: Scalars['ID']['output'];
  isAnswered: Scalars['Boolean']['output'];
  isCanBeAnswered: Scalars['Boolean']['output'];
  isCanBeDeclined: Scalars['Boolean']['output'];
  isDeclined: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  pdfImportResult: Maybe<PdfImportResult>;
  personInCharge: Scalars['String']['output'];
  requestedOn: Maybe<Scalars['ISO8601Date']['output']>;
  statusForSupplier: Scalars['String']['output'];
  supplier: Supplier;
  supplierCountryId: Scalars['ID']['output'];
  tenantId: Scalars['ID']['output'];
  uid: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum QuotationRequestKindEnum {
  ANotSpecified = 'a_not_specified',
  BRequested = 'b_requested'
}

/** Autogenerated input type of QuotationsDecline */
export type QuotationsDeclineInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  declineMemo?: InputMaybe<Scalars['String']['input']>;
  quotationRequestIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of QuotationsDecline. */
export type QuotationsDeclinePayload = {
  __typename?: 'QuotationsDeclinePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  isSuccess: Scalars['Boolean']['output'];
};

export type ShareColumn = {
  __typename?: 'ShareColumn';
  columnName: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  fieldKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isShare: Scalars['Boolean']['output'];
  tableName: Scalars['String']['output'];
};

export type ShareComment = {
  __typename?: 'ShareComment';
  booleanMemo1: Maybe<Scalars['Boolean']['output']>;
  booleanMemo2: Maybe<Scalars['Boolean']['output']>;
  booleanMemo3: Maybe<Scalars['Boolean']['output']>;
  booleanMemo4: Maybe<Scalars['Boolean']['output']>;
  booleanMemo5: Maybe<Scalars['Boolean']['output']>;
  dateMemo1: Maybe<Scalars['ISO8601Date']['output']>;
  dateMemo2: Maybe<Scalars['ISO8601Date']['output']>;
  dateMemo3: Maybe<Scalars['ISO8601Date']['output']>;
  dateMemo4: Maybe<Scalars['ISO8601Date']['output']>;
  dateMemo5: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  numericMemo1: Maybe<Scalars['Float']['output']>;
  numericMemo2: Maybe<Scalars['Float']['output']>;
  numericMemo3: Maybe<Scalars['Float']['output']>;
  numericMemo4: Maybe<Scalars['Float']['output']>;
  numericMemo5: Maybe<Scalars['Float']['output']>;
  serviceId: Scalars['ID']['output'];
  textMemo1: Maybe<Scalars['String']['output']>;
  textMemo2: Maybe<Scalars['String']['output']>;
  textMemo3: Maybe<Scalars['String']['output']>;
  textMemo4: Maybe<Scalars['String']['output']>;
  textMemo5: Maybe<Scalars['String']['output']>;
};

export type ShareCommentConfig = {
  __typename?: 'ShareCommentConfig';
  columnName: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  fieldKey: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  fieldType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isShare: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ShareCommentUpsert */
export type ShareCommentUpsertInput = {
  booleanMemo1?: InputMaybe<Scalars['Boolean']['input']>;
  booleanMemo2?: InputMaybe<Scalars['Boolean']['input']>;
  booleanMemo3?: InputMaybe<Scalars['Boolean']['input']>;
  booleanMemo4?: InputMaybe<Scalars['Boolean']['input']>;
  booleanMemo5?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dateMemo1?: InputMaybe<Scalars['ISO8601Date']['input']>;
  dateMemo2?: InputMaybe<Scalars['ISO8601Date']['input']>;
  dateMemo3?: InputMaybe<Scalars['ISO8601Date']['input']>;
  dateMemo4?: InputMaybe<Scalars['ISO8601Date']['input']>;
  dateMemo5?: InputMaybe<Scalars['ISO8601Date']['input']>;
  numericMemo1?: InputMaybe<Scalars['Float']['input']>;
  numericMemo2?: InputMaybe<Scalars['Float']['input']>;
  numericMemo3?: InputMaybe<Scalars['Float']['input']>;
  numericMemo4?: InputMaybe<Scalars['Float']['input']>;
  numericMemo5?: InputMaybe<Scalars['Float']['input']>;
  serviceId: Scalars['ID']['input'];
  shareConfigId: Scalars['ID']['input'];
  shareId?: InputMaybe<Scalars['ID']['input']>;
  supplierCode: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
  textMemo1?: InputMaybe<Scalars['String']['input']>;
  textMemo2?: InputMaybe<Scalars['String']['input']>;
  textMemo3?: InputMaybe<Scalars['String']['input']>;
  textMemo4?: InputMaybe<Scalars['String']['input']>;
  textMemo5?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ShareCommentUpsert. */
export type ShareCommentUpsertPayload = {
  __typename?: 'ShareCommentUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  err: Maybe<Scalars['String']['output']>;
  shareComment: Maybe<ShareComment>;
};

export type SharedAnnualTotalsResult = {
  __typename?: 'SharedAnnualTotalsResult';
  rows: Array<SharedDataRow>;
  shareColumns: Array<ShareColumn>;
  shareCommentConfigs: Array<ShareCommentConfig>;
  shareConfigId: Scalars['ID']['output'];
  shareKind: Scalars['String']['output'];
  supplierId: Scalars['ID']['output'];
  totalCount: Scalars['Int']['output'];
};

export type SharedDataCell = {
  __typename?: 'SharedDataCell';
  displayValue: Scalars['String']['output'];
  fieldKey: Scalars['String']['output'];
};

export type SharedDataCommentCell = {
  __typename?: 'SharedDataCommentCell';
  fieldKey: Scalars['String']['output'];
  fieldType: Scalars['String']['output'];
  value: Maybe<Scalars['JSON']['output']>;
};

/** Autogenerated input type of SharedDataCsvExport */
export type SharedDataCsvExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  shareConfigId: Scalars['ID']['input'];
  shareId?: InputMaybe<Scalars['ID']['input']>;
  supplierCode: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};

/** Autogenerated return type of SharedDataCsvExport. */
export type SharedDataCsvExportPayload = {
  __typename?: 'SharedDataCsvExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  res: CsvExportRes;
};

/** Autogenerated input type of SharedDataCsvImport */
export type SharedDataCsvImportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fileUrl: Scalars['String']['input'];
  shareConfigId: Scalars['ID']['input'];
  shareId: Scalars['ID']['input'];
  supplierCode: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};

/** Autogenerated return type of SharedDataCsvImport. */
export type SharedDataCsvImportPayload = {
  __typename?: 'SharedDataCsvImportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errs: Array<Scalars['String']['output']>;
  result: Maybe<SharedDataCsvImportResult>;
};

export type SharedDataCsvImportResult = {
  __typename?: 'SharedDataCsvImportResult';
  errorCount: Scalars['Int']['output'];
  errors: Array<CsvImportErrorRecord>;
  successCount: Scalars['Int']['output'];
};

export type SharedDataRow = {
  __typename?: 'SharedDataRow';
  cells: Array<SharedDataCell>;
  commentCells: Array<SharedDataCommentCell>;
  id: Scalars['ID']['output'];
  operationKind: Maybe<Scalars['String']['output']>;
  serviceId: Scalars['ID']['output'];
};

export type SharedPartMaterialUsagesResult = {
  __typename?: 'SharedPartMaterialUsagesResult';
  rows: Array<SharedDataRow>;
  shareColumns: Array<ShareColumn>;
  shareCommentConfigs: Array<ShareCommentConfig>;
  shareConfigId: Scalars['ID']['output'];
  shareKind: Scalars['String']['output'];
  supplierId: Scalars['ID']['output'];
  totalCount: Scalars['Int']['output'];
};

export type SharedPartStructuresResult = {
  __typename?: 'SharedPartStructuresResult';
  rows: Array<SharedDataRow>;
  shareColumns: Array<ShareColumn>;
  shareCommentConfigs: Array<ShareCommentConfig>;
  shareConfigId: Scalars['ID']['output'];
  shareKind: Scalars['String']['output'];
  supplierId: Scalars['ID']['output'];
  totalCount: Scalars['Int']['output'];
};

export type SharedPartTransactionsResult = {
  __typename?: 'SharedPartTransactionsResult';
  rows: Array<SharedDataRow>;
  shareColumns: Array<ShareColumn>;
  shareCommentConfigs: Array<ShareCommentConfig>;
  shareConfigId: Scalars['ID']['output'];
  shareKind: Scalars['String']['output'];
  supplierId: Scalars['ID']['output'];
  totalCount: Scalars['Int']['output'];
};

export type SharedPartsResult = {
  __typename?: 'SharedPartsResult';
  rows: Array<SharedDataRow>;
  shareColumns: Array<ShareColumn>;
  shareCommentConfigs: Array<ShareCommentConfig>;
  shareConfigId: Scalars['ID']['output'];
  shareKind: Scalars['String']['output'];
  supplierId: Scalars['ID']['output'];
  totalCount: Scalars['Int']['output'];
};

export type SharedUnofficialAnnouncementsResult = {
  __typename?: 'SharedUnofficialAnnouncementsResult';
  rows: Array<SharedDataRow>;
  shareColumns: Array<ShareColumn>;
  shareCommentConfigs: Array<ShareCommentConfig>;
  shareConfigId: Scalars['ID']['output'];
  shareKind: Scalars['String']['output'];
  supplierId: Scalars['ID']['output'];
  totalCount: Scalars['Int']['output'];
};

export type State = {
  __typename?: 'State';
  country: Country;
  countryId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['ID']['output'];
};

export type Supplier = {
  __typename?: 'Supplier';
  adminUser: Maybe<AdminUser>;
  code: Scalars['String']['output'];
  displayCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  industry: Maybe<Scalars['String']['output']>;
  isEligibleToSubcontractAct: Scalars['Boolean']['output'];
  isTemporary: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
  supplierFirmId: Maybe<Scalars['ID']['output']>;
  temporaryCode: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SupplierAccount = {
  __typename?: 'SupplierAccount';
  csvExportEncodingKind: SupplierUserCsvExportEncodingKindEnum;
  department: Scalars['String']['output'];
  email: Scalars['String']['output'];
  hasExistingSceOnTenant: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  languageCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nameKana: Maybe<Scalars['String']['output']>;
  profileTenantAssignments: Array<TenantMemberAssignment>;
  selectedTenant: Maybe<Tenant>;
  supplierAccountTenantLinks: Array<SupplierAccountTenantLink>;
  supplierCorporation: Maybe<SupplierCorporation>;
  tel: Scalars['String']['output'];
  tenantMemberAssignments: Array<TenantMemberAssignment>;
  title: Scalars['String']['output'];
};


export type SupplierAccountHasExistingSceOnTenantArgs = {
  tenantId: Scalars['ID']['input'];
};


export type SupplierAccountProfileTenantAssignmentsArgs = {
  includePast?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SupplierAccountTenantMemberAssignmentsArgs = {
  includePast?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId: Scalars['ID']['input'];
};

/** The connection type for SupplierAccount. */
export type SupplierAccountConnection = {
  __typename?: 'SupplierAccountConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SupplierAccountEdge>>>;
  /** A list of nodes. */
  nodes: Array<SupplierAccount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SupplierAccountEdge = {
  __typename?: 'SupplierAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SupplierAccount>;
};

export type SupplierAccountInvitationBySupplierFrontend = {
  __typename?: 'SupplierAccountInvitationBySupplierFrontend';
  email: Scalars['String']['output'];
  expired: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  supplierIds: Scalars['JSON']['output'];
};

/** Autogenerated input type of SupplierAccountInvitationBySupplierFrontendComplete */
export type SupplierAccountInvitationBySupplierFrontendCompleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Autogenerated return type of SupplierAccountInvitationBySupplierFrontendComplete. */
export type SupplierAccountInvitationBySupplierFrontendCompletePayload = {
  __typename?: 'SupplierAccountInvitationBySupplierFrontendCompletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  err: Maybe<Scalars['String']['output']>;
};

/** The connection type for SupplierAccountInvitationBySupplierFrontend. */
export type SupplierAccountInvitationBySupplierFrontendConnection = {
  __typename?: 'SupplierAccountInvitationBySupplierFrontendConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SupplierAccountInvitationBySupplierFrontendEdge>>>;
  /** A list of nodes. */
  nodes: Array<SupplierAccountInvitationBySupplierFrontend>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of SupplierAccountInvitationBySupplierFrontendDelete */
export type SupplierAccountInvitationBySupplierFrontendDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SupplierAccountInvitationBySupplierFrontendDelete. */
export type SupplierAccountInvitationBySupplierFrontendDeletePayload = {
  __typename?: 'SupplierAccountInvitationBySupplierFrontendDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  err: Maybe<Scalars['String']['output']>;
};

/** An edge in a connection. */
export type SupplierAccountInvitationBySupplierFrontendEdge = {
  __typename?: 'SupplierAccountInvitationBySupplierFrontendEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SupplierAccountInvitationBySupplierFrontend>;
};

export type SupplierAccountInvitationBySupplierFrontendPayload = {
  __typename?: 'SupplierAccountInvitationBySupplierFrontendPayload';
  errs: Array<Scalars['String']['output']>;
  invitation: Maybe<SupplierAccountInvitationBySupplierFrontend>;
};

/** Autogenerated input type of SupplierAccountInvitationBySupplierFrontendUpsert */
export type SupplierAccountInvitationBySupplierFrontendUpsertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  supplierIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of SupplierAccountInvitationBySupplierFrontendUpsert. */
export type SupplierAccountInvitationBySupplierFrontendUpsertPayload = {
  __typename?: 'SupplierAccountInvitationBySupplierFrontendUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  err: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SupplierAccountInvitationByTenantFrontendComplete */
export type SupplierAccountInvitationByTenantFrontendCompleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Autogenerated return type of SupplierAccountInvitationByTenantFrontendComplete. */
export type SupplierAccountInvitationByTenantFrontendCompletePayload = {
  __typename?: 'SupplierAccountInvitationByTenantFrontendCompletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  err: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SupplierAccountSelectedTenantUpdate */
export type SupplierAccountSelectedTenantUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
};

/** Autogenerated return type of SupplierAccountSelectedTenantUpdate. */
export type SupplierAccountSelectedTenantUpdatePayload = {
  __typename?: 'SupplierAccountSelectedTenantUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Maybe<ValidationErr>;
  tenantName: Maybe<Scalars['String']['output']>;
};

export type SupplierAccountTenantLink = {
  __typename?: 'SupplierAccountTenantLink';
  corporation: SupplierCorporation;
  id: Scalars['ID']['output'];
  isSendNotification: Scalars['Boolean']['output'];
  isSendSupplierFirmInfoConfirmationRequest: Scalars['Boolean']['output'];
  startedAt: Scalars['ISO8601DateTime']['output'];
  supplierCode: Scalars['String']['output'];
  supplierFirm: Maybe<SupplierFirm>;
  tenant: Tenant;
};

/** Autogenerated input type of SupplierAccountTenantLinkDelete */
export type SupplierAccountTenantLinkDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endedAt?: InputMaybe<Scalars['String']['input']>;
  supplierAccountId: Scalars['ID']['input'];
  supplierCode: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};

/** Autogenerated return type of SupplierAccountTenantLinkDelete. */
export type SupplierAccountTenantLinkDeletePayload = {
  __typename?: 'SupplierAccountTenantLinkDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  err: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SupplierAccountTenantLinkRestore */
export type SupplierAccountTenantLinkRestoreInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isSendSupplierFirmInfoConfirmationRequest?: InputMaybe<Scalars['Boolean']['input']>;
  startedAt?: InputMaybe<Scalars['String']['input']>;
  supplierAccountId: Scalars['ID']['input'];
  supplierCode: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};

/** Autogenerated return type of SupplierAccountTenantLinkRestore. */
export type SupplierAccountTenantLinkRestorePayload = {
  __typename?: 'SupplierAccountTenantLinkRestorePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  err: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SupplierAccountTenantLinkUpsert */
export type SupplierAccountTenantLinkUpsertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isSendNotification: Scalars['Boolean']['input'];
  isSendSupplierFirmInfoConfirmationRequest?: InputMaybe<Scalars['Boolean']['input']>;
  startedAt?: InputMaybe<Scalars['String']['input']>;
  supplierAccountId: Scalars['ID']['input'];
  supplierCode: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};

/** Autogenerated return type of SupplierAccountTenantLinkUpsert. */
export type SupplierAccountTenantLinkUpsertPayload = {
  __typename?: 'SupplierAccountTenantLinkUpsertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  err: Maybe<Scalars['String']['output']>;
};

export type SupplierAccountingItem = {
  __typename?: 'SupplierAccountingItem';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAsset: Scalars['Boolean']['output'];
  isEditable: Scalars['Boolean']['output'];
  isLiability: Scalars['Boolean']['output'];
  isNetAsset: Scalars['Boolean']['output'];
  isSubtraction: Scalars['Boolean']['output'];
  kind: Scalars['Int']['output'];
  level: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentId: Maybe<Scalars['ID']['output']>;
};

export type SupplierAnnouncement = {
  __typename?: 'SupplierAnnouncement';
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  linkText: Scalars['String']['output'];
  linkUrl: Scalars['String']['output'];
  releasedAt: Scalars['ISO8601DateTime']['output'];
  title: Scalars['String']['output'];
};

export type SupplierAnnouncementWithStatus = {
  __typename?: 'SupplierAnnouncementWithStatus';
  isRead: Scalars['Boolean']['output'];
  supplierAnnouncement: SupplierAnnouncement;
};

/** The connection type for SupplierAnnouncementWithStatus. */
export type SupplierAnnouncementWithStatusConnection = {
  __typename?: 'SupplierAnnouncementWithStatusConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SupplierAnnouncementWithStatusEdge>>>;
  /** A list of nodes. */
  nodes: Array<SupplierAnnouncementWithStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SupplierAnnouncementWithStatusEdge = {
  __typename?: 'SupplierAnnouncementWithStatusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SupplierAnnouncementWithStatus>;
};

/** Autogenerated input type of SupplierAnnouncementsRead */
export type SupplierAnnouncementsReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SupplierAnnouncementsRead. */
export type SupplierAnnouncementsReadPayload = {
  __typename?: 'SupplierAnnouncementsReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  result: Scalars['Boolean']['output'];
};

export type SupplierAnnouncementsView = {
  __typename?: 'SupplierAnnouncementsView';
  supplierAnnouncements: SupplierAnnouncementWithStatusConnection;
  unreadCount: Scalars['Int']['output'];
};


export type SupplierAnnouncementsViewSupplierAnnouncementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum SupplierClosingMonthEnum {
  AJanuary = 'a_january',
  BFebruary = 'b_february',
  CMarch = 'c_march',
  DApril = 'd_april',
  EMay = 'e_may',
  FJune = 'f_june',
  GJuly = 'g_july',
  HAugust = 'h_august',
  ISeptember = 'i_september',
  JOctober = 'j_october',
  KNovember = 'k_november',
  LDecember = 'l_december'
}

export type SupplierCorporation = {
  __typename?: 'SupplierCorporation';
  hasAnswerExcelTemplateAttachment: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SupplierCorporationEmployee = {
  __typename?: 'SupplierCorporationEmployee';
  department: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nameKana: Maybe<Scalars['String']['output']>;
  positionTitle: Scalars['String']['output'];
  supplierAccountTenantLinks: Array<SupplierAccountTenantLink>;
  tel: Scalars['String']['output'];
};

/** Autogenerated input type of SupplierCorporationEmployeeArchive */
export type SupplierCorporationEmployeeArchiveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SupplierCorporationEmployeeArchive. */
export type SupplierCorporationEmployeeArchivePayload = {
  __typename?: 'SupplierCorporationEmployeeArchivePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
  supplierCorporationEmployee: Maybe<SupplierCorporationEmployee>;
};

/** The connection type for SupplierCorporationEmployee. */
export type SupplierCorporationEmployeeConnection = {
  __typename?: 'SupplierCorporationEmployeeConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SupplierCorporationEmployeeEdge>>>;
  /** A list of nodes. */
  nodes: Array<SupplierCorporationEmployee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SupplierCorporationEmployeeEdge = {
  __typename?: 'SupplierCorporationEmployeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SupplierCorporationEmployee>;
};

export enum SupplierCorporationEmployeeScopeEnum {
  Corporation = 'corporation',
  Firm = 'firm'
}

/** Autogenerated input type of SupplierCorporationEmployeeUnarchive */
export type SupplierCorporationEmployeeUnarchiveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SupplierCorporationEmployeeUnarchive. */
export type SupplierCorporationEmployeeUnarchivePayload = {
  __typename?: 'SupplierCorporationEmployeeUnarchivePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<ValidationErr>;
  supplierCorporationEmployee: Maybe<SupplierCorporationEmployee>;
};

export type SupplierCsvExportResult = {
  __typename?: 'SupplierCsvExportResult';
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  conditions: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdAtUnix: Scalars['Int']['output'];
  fileUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  signedUrl: Maybe<Scalars['String']['output']>;
  startedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: Scalars['String']['output'];
  supplierAccount: Maybe<SupplierAccount>;
  supplierUser: Maybe<SupplierUser>;
};

export type SupplierEmployeeClass = {
  __typename?: 'SupplierEmployeeClass';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type SupplierEnqueteAnswer = {
  __typename?: 'SupplierEnqueteAnswer';
  answerValue: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Maybe<Scalars['Boolean']['output']>;
  supplierEnqueteQuestionConfig: SupplierEnqueteQuestionConfig;
};

export type SupplierEnqueteQuestionConfig = {
  __typename?: 'SupplierEnqueteQuestionConfig';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SupplierFileClass = {
  __typename?: 'SupplierFileClass';
  canModifyBySupplierFirmInfoConfirmationRequest: Scalars['Boolean']['output'];
  canSupplierDeleteCrAnswer: Scalars['Boolean']['output'];
  canSupplierEditCrAnswer: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isSatisfyElectronicBookPreservationAct: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type SupplierFileInfo = {
  __typename?: 'SupplierFileInfo';
  attachment: Attachment;
  expirationDateFrom: Maybe<Scalars['ISO8601Date']['output']>;
  expirationDateTo: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  memo: Maybe<Scalars['String']['output']>;
  registeredAt: Scalars['ISO8601DateTime']['output'];
  registeredBy: Maybe<Scalars['String']['output']>;
  supplierFileClass: SupplierFileClass;
};

/** The connection type for SupplierFileInfo. */
export type SupplierFileInfoConnection = {
  __typename?: 'SupplierFileInfoConnection';
  /** ファイルクラス別の件数 */
  countByClass: Scalars['JSON']['output'];
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SupplierFileInfoEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<SupplierFileInfo>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SupplierFileInfoEdge = {
  __typename?: 'SupplierFileInfoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SupplierFileInfo>;
};

export type SupplierFirm = {
  __typename?: 'SupplierFirm';
  hasAnswerExcelTemplateAttachment: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  supplierFirmAddress: Maybe<SupplierFirmAddress>;
};

export type SupplierFirmAddress = {
  __typename?: 'SupplierFirmAddress';
  address: Scalars['String']['output'];
  building: Scalars['String']['output'];
  country: Maybe<Country>;
  countryId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  state: Maybe<State>;
  stateId: Maybe<Scalars['ID']['output']>;
  zipCode: Maybe<Scalars['String']['output']>;
};

export type SupplierFirmInfoConfirmationRequest = {
  __typename?: 'SupplierFirmInfoConfirmationRequest';
  answerDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  answerKind: SupplierFirmInfoConfirmationRequestAnswerKindEnum;
  answerer: Maybe<Scalars['String']['output']>;
  canInputAnswer: Scalars['Boolean']['output'];
  canShowAnswer: Scalars['Boolean']['output'];
  confirmationRequestNo: Scalars['String']['output'];
  contactEmail: Maybe<Scalars['String']['output']>;
  contactName: Maybe<Scalars['String']['output']>;
  contactTel: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['ISO8601DateTime']['output'];
  fileName: Maybe<Scalars['String']['output']>;
  fileUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isBasicInfoSelected: Scalars['Boolean']['output'];
  isBusinessBaseInfoSelected: Scalars['Boolean']['output'];
  isContactInfoSelected: Scalars['Boolean']['output'];
  isEquipmentInfoSelected: Scalars['Boolean']['output'];
  isFileInfoSelected: Scalars['Boolean']['output'];
  isOutsourcingInfoSelected: Scalars['Boolean']['output'];
  isOverdue: Scalars['Boolean']['output'];
  isSurveyInfoSelected: Scalars['Boolean']['output'];
  remandComment: Maybe<Scalars['String']['output']>;
  remandDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  remandedBy: Maybe<Scalars['String']['output']>;
  requestDate: Scalars['ISO8601DateTime']['output'];
  signedUrl: Maybe<Scalars['String']['output']>;
  status: SupplierFirmInfoConfirmationRequestStatusEnum;
  /** @deprecated Use supplyChainCompany as the request owner */
  supplierFirm: SupplierFirm;
  supplierFirmInfoConfirmationRequestDestinations: Array<SupplierFirmInfoConfirmationRequestDestination>;
  surveyYear: Scalars['Int']['output'];
  tenant: Tenant;
  withdrawnBy: Maybe<Scalars['String']['output']>;
  withdrawnDate: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum SupplierFirmInfoConfirmationRequestAnswerKindEnum {
  AAnswerSurveyInfoByExcel = 'a_answer_survey_info_by_excel',
  BAnswerAllInfoByExcel = 'b_answer_all_info_by_excel'
}

/** The connection type for SupplierFirmInfoConfirmationRequest. */
export type SupplierFirmInfoConfirmationRequestConnection = {
  __typename?: 'SupplierFirmInfoConfirmationRequestConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SupplierFirmInfoConfirmationRequestEdge>>>;
  /** A list of nodes. */
  nodes: Array<SupplierFirmInfoConfirmationRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SupplierFirmInfoConfirmationRequestDestination = {
  __typename?: 'SupplierFirmInfoConfirmationRequestDestination';
  id: Scalars['ID']['output'];
  supplierUserInfo: Maybe<SupplierUserInfo>;
  supplyChainCompanyEmployeeEmail: Maybe<Scalars['String']['output']>;
  supplyChainCompanyEmployeeName: Maybe<Scalars['String']['output']>;
  supplyChainCompanyEmployeeNumber: Maybe<Scalars['String']['output']>;
};

/** An edge in a connection. */
export type SupplierFirmInfoConfirmationRequestEdge = {
  __typename?: 'SupplierFirmInfoConfirmationRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SupplierFirmInfoConfirmationRequest>;
};

export enum SupplierFirmInfoConfirmationRequestStatusEnum {
  AWaiting = 'a_waiting',
  BAnswered = 'b_answered',
  CRemanded = 'c_remanded',
  DSyncing = 'd_syncing',
  EWithdrawn = 'e_withdrawn',
  FCompleted = 'f_completed',
  GInternalApproving = 'g_internal_approving'
}

/** Autogenerated input type of SupplierFirmInfoConfirmationRequestStatusUpdate */
export type SupplierFirmInfoConfirmationRequestStatusUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<SupplierFirmInfoConfirmationRequestStatusEnum>;
};

/** Autogenerated return type of SupplierFirmInfoConfirmationRequestStatusUpdate. */
export type SupplierFirmInfoConfirmationRequestStatusUpdatePayload = {
  __typename?: 'SupplierFirmInfoConfirmationRequestStatusUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export enum SupplierListingKindEnum {
  AUnlisted = 'a_unlisted',
  BListed = 'b_listed'
}

export enum SupplierManufacturingSiteBuildingOwnershipKindEnum {
  ABuildingSelfOwned = 'a_building_self_owned',
  BBuildingOthersOwned = 'b_building_others_owned'
}

export enum SupplierManufacturingSiteLandOwnershipKindEnum {
  ALandSelfOwned = 'a_land_self_owned',
  BLandOthersOwned = 'b_land_others_owned'
}

export type SupplierMoldStorageApplication = {
  __typename?: 'SupplierMoldStorageApplication';
  applicationDate: Scalars['ISO8601Date']['output'];
  approvalDate: Maybe<Scalars['ISO8601Date']['output']>;
  attachments: Maybe<Array<Attachment>>;
  comment: Scalars['String']['output'];
  confirmationDueDate: Scalars['ISO8601Date']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  employee: Employee;
  id: Scalars['ID']['output'];
  remandComment: Maybe<Scalars['String']['output']>;
  status: Scalars['Int']['output'];
  supplier: Supplier;
  supplierAccount: Maybe<SupplierAccount>;
  supplierCorporationAttachments: Maybe<Array<Attachment>>;
  supplierMoldStorageApplicationDetails: Maybe<Array<SupplierMoldStorageApplicationDetail>>;
  supplierUser: Maybe<SupplierUser>;
  tenant: Tenant;
  title: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for SupplierMoldStorageApplication. */
export type SupplierMoldStorageApplicationConnection = {
  __typename?: 'SupplierMoldStorageApplicationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SupplierMoldStorageApplicationEdge>>>;
  /** A list of nodes. */
  nodes: Array<SupplierMoldStorageApplication>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SupplierMoldStorageApplicationDetail = {
  __typename?: 'SupplierMoldStorageApplicationDetail';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  mold: Mold;
  publicMemo: Maybe<Scalars['String']['output']>;
  remandComment: Maybe<Scalars['String']['output']>;
  storageCost: Maybe<Scalars['Float']['output']>;
  storageStartDate: Maybe<Scalars['ISO8601Date']['output']>;
  supplierMoldStorageApplicationId: Scalars['ID']['output'];
  tenantId: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SupplierMoldStorageApplicationDetailInput = {
  moldId: Scalars['ID']['input'];
  publicMemo?: InputMaybe<Scalars['String']['input']>;
  storageCost: Scalars['Float']['input'];
  storageStartDate: Scalars['ISO8601Date']['input'];
};

/** An edge in a connection. */
export type SupplierMoldStorageApplicationEdge = {
  __typename?: 'SupplierMoldStorageApplicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SupplierMoldStorageApplication>;
};

/** Autogenerated input type of SupplierMoldStorageApplicationSave */
export type SupplierMoldStorageApplicationSaveInput = {
  attachments?: InputMaybe<Array<CommonAttachmentInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  confirmationDueDate: Scalars['ISO8601Date']['input'];
  employeeId: Scalars['ID']['input'];
  previousId?: InputMaybe<Scalars['ID']['input']>;
  supplierAccountId?: InputMaybe<Scalars['ID']['input']>;
  supplierId: Scalars['ID']['input'];
  supplierMoldStorageApplicationDetails: Array<SupplierMoldStorageApplicationDetailInput>;
  supplierUserId?: InputMaybe<Scalars['ID']['input']>;
  tenantId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

/** Autogenerated return type of SupplierMoldStorageApplicationSave. */
export type SupplierMoldStorageApplicationSavePayload = {
  __typename?: 'SupplierMoldStorageApplicationSavePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  supplierMoldStorageApplication: Maybe<SupplierMoldStorageApplication>;
};

export type SupplierOption = {
  __typename?: 'SupplierOption';
  supplierCode: Scalars['String']['output'];
  supplierId: Scalars['ID']['output'];
  supplierName: Scalars['String']['output'];
  tenantId: Scalars['ID']['output'];
};

export type SupplierOutsourcingClass = {
  __typename?: 'SupplierOutsourcingClass';
  code: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type SupplierPriceAdjustmentDraftAmendInput = {
  eventMemo?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type SupplierQuotationPackage = {
  __typename?: 'SupplierQuotationPackage';
  /** individual（個別見積回答）または one_line（一行見積回答。パッケージ単位で一括回答できる） */
  answerEntryKind: Scalars['String']['output'];
  answerStatusText: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  firstQuotation: Maybe<Quotation>;
  firstQuotationAdminUser: Maybe<AdminUser>;
  firstQuotationItem: Maybe<QuotationItemV2>;
  firstQuotationRequest: Maybe<QuotationRequest>;
  id: Scalars['ID']['output'];
  quotations: Array<Quotation>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for SupplierQuotationPackage. */
export type SupplierQuotationPackageConnection = {
  __typename?: 'SupplierQuotationPackageConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SupplierQuotationPackageEdge>>>;
  /** A list of nodes. */
  nodes: Array<SupplierQuotationPackage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SupplierQuotationPackageEdge = {
  __typename?: 'SupplierQuotationPackageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<SupplierQuotationPackage>;
};

export type SupplierQuotationPackageStatusCount = {
  __typename?: 'SupplierQuotationPackageStatusCount';
  all: Scalars['Int']['output'];
  answered: Scalars['Int']['output'];
  notAnswered: Scalars['Int']['output'];
  overdue: Scalars['Int']['output'];
};

export type SupplierScreenItemConfig = {
  __typename?: 'SupplierScreenItemConfig';
  componentId: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  visible: Scalars['Boolean']['output'];
};

export type SupplierScreenSurveyInfoConfig = {
  __typename?: 'SupplierScreenSurveyInfoConfig';
  componentId: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  visible: Scalars['Boolean']['output'];
  width: Scalars['Int']['output'];
};

export enum SupplierSiteBuildingOwnershipKindEnum {
  ABuildingSelfOwned = 'a_building_self_owned',
  BBuildingOthersOwned = 'b_building_others_owned'
}

export enum SupplierSiteLandOwnershipKindEnum {
  ALandSelfOwned = 'a_land_self_owned',
  BLandOthersOwned = 'b_land_others_owned'
}

export enum SupplierSurveyBeforeAfterKindEnum {
  ABefore = 'a_before',
  BAfter = 'b_after'
}

/** Autogenerated input type of SupplierSurveyInfoExcelImport */
export type SupplierSurveyInfoExcelImportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  importTargetExcel: AttachmentInput;
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of SupplierSurveyInfoExcelImport. */
export type SupplierSurveyInfoExcelImportPayload = {
  __typename?: 'SupplierSurveyInfoExcelImportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  warnings: Array<Scalars['String']['output']>;
};

export type SupplierSurveyInfoImportConfig = {
  __typename?: 'SupplierSurveyInfoImportConfig';
  attachment: Maybe<Attachment>;
};

export type SupplierUser = {
  __typename?: 'SupplierUser';
  department: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  languageCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  selectedTenant: Maybe<Tenant>;
  supplierAccountTenantLinks: Array<SupplierAccountTenantLink>;
  supplierFirm: SupplierFirm;
  supplierFirmId: Scalars['ID']['output'];
  supplierUserInfos: Array<SupplierUserInfo>;
  tel: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum SupplierUserCsvExportEncodingKindEnum {
  Auto = 'auto',
  Sjis = 'sjis',
  Utf8 = 'utf8',
  Utf8Bom = 'utf8_bom'
}

export type SupplierUserInfo = {
  __typename?: 'SupplierUserInfo';
  email: Maybe<Scalars['String']['output']>;
  endOn: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isSendNotification: Maybe<Scalars['Boolean']['output']>;
  isSendSupplierFirmInfoConfirmationRequest: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  startOn: Maybe<Scalars['ISO8601Date']['output']>;
  supplierFirmId: Scalars['ID']['output'];
  supplierUserId: Maybe<Scalars['ID']['output']>;
  tenantId: Scalars['ID']['output'];
  tenantName: Scalars['String']['output'];
};

export type SupplierUserInfoCommentConfirmation = {
  __typename?: 'SupplierUserInfoCommentConfirmation';
  commentNodeId: Scalars['ID']['output'];
  confirmedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  supplier: Supplier;
  supplierId: Scalars['ID']['output'];
  supplierUserInfo: Maybe<SupplierUserInfo>;
  supplierUserInfoId: Maybe<Scalars['ID']['output']>;
  supplyChainCompanyEmployeeEmail: Maybe<Scalars['String']['output']>;
  supplyChainCompanyEmployeeName: Maybe<Scalars['String']['output']>;
  supplyChainCompanyEmployeeNumber: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of SupplyPartCsvExport */
export type SupplyPartCsvExportInput = {
  assignmentPriceKind?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  conditionsText?: InputMaybe<Scalars['String']['input']>;
  figureNumber?: InputMaybe<Scalars['String']['input']>;
  referenceDate?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

/** Autogenerated return type of SupplyPartCsvExport. */
export type SupplyPartCsvExportPayload = {
  __typename?: 'SupplyPartCsvExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  res: CsvExportRes;
};

export type Tenant = {
  __typename?: 'Tenant';
  attachmentOfferConfig: Maybe<AttachmentOfferConfig>;
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inOperationScope: Scalars['Boolean']['output'];
  manualUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  priceAdjustmentSetting: Maybe<PriceAdjustmentSetting>;
  productConfig: Maybe<ProductConfig>;
  quotationConfig: Maybe<QuotationConfig>;
  supplierAccounts: Array<SupplierAccount>;
  supplierCodesForFirm: Array<Scalars['String']['output']>;
  supplierUsers: Array<SupplierUser>;
};


export type TenantSupplierAccountsArgs = {
  includePast?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TenantAssignmentInput = {
  isSendSupplierFirmInfoConfirmationRequest?: InputMaybe<Scalars['Boolean']['input']>;
  startedAt?: InputMaybe<Scalars['String']['input']>;
  supplierCode: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};

export type TenantCandidate = {
  __typename?: 'TenantCandidate';
  id: Scalars['ID']['output'];
  inOperationScope: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  supplierCodes: Array<Scalars['String']['output']>;
};

/** The connection type for TenantCandidate. */
export type TenantCandidateConnection = {
  __typename?: 'TenantCandidateConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TenantCandidateEdge>>>;
  /** A list of nodes. */
  nodes: Array<TenantCandidate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TenantCandidateEdge = {
  __typename?: 'TenantCandidateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<TenantCandidate>;
};

export type TenantConfig = {
  __typename?: 'TenantConfig';
  currencyCode: Scalars['String']['output'];
  isUsePurchaseRequest: Scalars['Boolean']['output'];
  isUseTrialPurchaseRequest: Scalars['Boolean']['output'];
  tenantId: Scalars['ID']['output'];
};

export type TenantDirectory = {
  __typename?: 'TenantDirectory';
  manuals: Array<TenantSupplierManual>;
  memberCount: Scalars['Int']['output'];
  tenant: Tenant;
};

/** The connection type for TenantDirectory. */
export type TenantDirectoryConnection = {
  __typename?: 'TenantDirectoryConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TenantDirectoryEdge>>>;
  /** A list of nodes. */
  nodes: Array<TenantDirectory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TenantDirectoryDetail = {
  __typename?: 'TenantDirectoryDetail';
  allowedSupplierCodes: Array<Scalars['String']['output']>;
  manuals: Array<TenantSupplierManual>;
  memberCount: Scalars['Int']['output'];
  supplierAccounts: Array<SupplierAccount>;
  tenant: Tenant;
};

/** An edge in a connection. */
export type TenantDirectoryEdge = {
  __typename?: 'TenantDirectoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<TenantDirectory>;
};

export type TenantMemberAssignment = {
  __typename?: 'TenantMemberAssignment';
  endedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isSendNotification: Scalars['Boolean']['output'];
  isSendSupplierFirmInfoConfirmationRequest: Scalars['Boolean']['output'];
  startedAt: Scalars['ISO8601DateTime']['output'];
  supplierAccountId: Maybe<Scalars['ID']['output']>;
  supplierAccountTenantLinkId: Maybe<Scalars['ID']['output']>;
  supplierCode: Scalars['String']['output'];
  tenant: Tenant;
  tenantId: Scalars['ID']['output'];
  tenantName: Scalars['String']['output'];
};

export type TenantPeriodUnit = {
  __typename?: 'TenantPeriodUnit';
  id: Scalars['ID']['output'];
  isUse: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  periodUnitKind: Scalars['String']['output'];
  periodValue: Scalars['Int']['output'];
};

export type TenantSelect = {
  __typename?: 'TenantSelect';
  id: Scalars['ID']['output'];
  tenantSelectOptions: Array<TenantSelectOption>;
  tenantSelectOptionsArchived: Array<TenantSelectOption>;
};

export type TenantSelectOption = {
  __typename?: 'TenantSelectOption';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  longLabel: Maybe<Scalars['String']['output']>;
  seq: Scalars['Int']['output'];
};

export type TenantSupplierManual = {
  __typename?: 'TenantSupplierManual';
  fileName: Scalars['String']['output'];
  supplierCode: Scalars['String']['output'];
  supplierId: Scalars['ID']['output'];
  supplierName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TenantUnit = {
  __typename?: 'TenantUnit';
  externalSystemUnitCode: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isUse: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  unit: Unit;
  unitCode: Scalars['String']['output'];
};

export type TrialQuotationAnswer = {
  __typename?: 'TrialQuotationAnswer';
  answerMemo: Scalars['String']['output'];
  attachments: Array<TrialQuotationAnswerAttachment>;
  /** 納入可能日（依頼単位・任意） */
  deliveryOn: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  /** 依頼全体の辞退 */
  isDeclined: Scalars['Boolean']['output'];
  items: Array<TrialQuotationAnswerItem>;
  /** 見積有効期限（依頼単位・任意） */
  quotationValidUntil: Maybe<Scalars['ISO8601Date']['output']>;
  revisionNo: Scalars['Int']['output'];
  /** 1:提出済み, 2:取消し済み */
  state: Scalars['Int']['output'];
  submittedAt: Scalars['ISO8601DateTime']['output'];
};

export type TrialQuotationAnswerAiDraftBreakdown = {
  __typename?: 'TrialQuotationAnswerAiDraftBreakdown';
  /** 内訳の品名 */
  name: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  /** 内訳の単位（読み取れない場合は空文字） */
  unitName: Scalars['String']['output'];
  unitPrice: Scalars['Float']['output'];
};

/** Autogenerated input type of TrialQuotationAnswerAiDraft */
export type TrialQuotationAnswerAiDraftInput = {
  answerMemo?: InputMaybe<Scalars['String']['input']>;
  attachments: Array<TrialQuotationAnswerAttachmentInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  quotationRequestId: Scalars['ID']['input'];
};

export type TrialQuotationAnswerAiDraftItem = {
  __typename?: 'TrialQuotationAnswerAiDraftItem';
  breakdowns: Array<TrialQuotationAnswerAiDraftBreakdown>;
  quotationItemId: Scalars['ID']['output'];
  /** 税区分 0外税1内税2非課税3不課税（読み取れなければ null） */
  taxType: Maybe<Scalars['Int']['output']>;
  /** 設備は内訳合計のロールアップ */
  unitPrice: Scalars['Float']['output'];
};

/** Autogenerated return type of TrialQuotationAnswerAiDraft. */
export type TrialQuotationAnswerAiDraftPayload = {
  __typename?: 'TrialQuotationAnswerAiDraftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  items: Array<TrialQuotationAnswerAiDraftItem>;
  /** AI からの注記（読み取りの不確かさ等） */
  note: Maybe<Scalars['String']['output']>;
  /** 見積有効期限（AI起票） */
  quotationValidUntil: Maybe<Scalars['ISO8601Date']['output']>;
};

export type TrialQuotationAnswerAttachment = {
  __typename?: 'TrialQuotationAnswerAttachment';
  /** 1:見積書, 2:参考資料 */
  attachmentKind: Scalars['Int']['output'];
  byteSize: Scalars['Int']['output'];
  contentType: Scalars['String']['output'];
  /** SAS 付きダウンロード URL（有効期限付き） */
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  seqNo: Scalars['Int']['output'];
  /** Azure Blob の格納 URL（アップロード時の fileUrl） */
  url: Scalars['String']['output'];
};

export type TrialQuotationAnswerAttachmentInput = {
  /** 1:見積書, 2:参考資料 */
  attachmentKind: Scalars['Int']['input'];
  byteSize?: InputMaybe<Scalars['Int']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** Autogenerated input type of TrialQuotationAnswerCancel */
export type TrialQuotationAnswerCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  quotationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of TrialQuotationAnswerCancel. */
export type TrialQuotationAnswerCancelPayload = {
  __typename?: 'TrialQuotationAnswerCancelPayload';
  answer: Maybe<TrialQuotationAnswer>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type TrialQuotationAnswerItem = {
  __typename?: 'TrialQuotationAnswerItem';
  breakdownSeqNo: Scalars['Int']['output'];
  /** 明細単位の辞退 */
  isDeclined: Scalars['Boolean']['output'];
  /** メーカー型番（回答時スナップショット） */
  makerModel: Scalars['String']['output'];
  /** メーカー名（回答時スナップショット） */
  makerName: Scalars['String']['output'];
  /** 品名（回答時スナップショット） */
  name: Scalars['String']['output'];
  /** 回答数量（null=依頼数量のまま） */
  quantity: Maybe<Scalars['Float']['output']>;
  quotationItemId: Scalars['ID']['output'];
  seqNo: Scalars['Int']['output'];
  /** 税区分 0外税1内税2非課税3不課税 */
  taxType: Scalars['Int']['output'];
  /** 単位（回答時スナップショット） */
  unitName: Scalars['String']['output'];
  /** 回答単価（辞退明細は null） */
  unitPrice: Maybe<Scalars['Float']['output']>;
};

export type TrialQuotationAnswerItemInput = {
  isDeclined: Scalars['Boolean']['input'];
  makerModel?: InputMaybe<Scalars['String']['input']>;
  makerName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quotationItemId: Scalars['ID']['input'];
  /** 0外税1内税2非課税3不課税（既定=0） */
  taxType?: InputMaybe<Scalars['Int']['input']>;
  unitName?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type TrialQuotationAnswerSheet = {
  __typename?: 'TrialQuotationAnswerSheet';
  answerDueDate: Maybe<Scalars['ISO8601Date']['output']>;
  answers: Array<TrialQuotationAnswer>;
  baseRevisionNo: Scalars['Int']['output'];
  isCanBeAnswered: Scalars['Boolean']['output'];
  isFacility: Scalars['Boolean']['output'];
  isTrialSelectionLocked: Scalars['Boolean']['output'];
  items: Array<TrialQuotationAnswerSheetItem>;
  latestAnswer: Maybe<TrialQuotationAnswer>;
  quotationId: Scalars['ID']['output'];
  quotationRequestId: Scalars['ID']['output'];
  requestAttachments: Array<TrialQuotationRequestAttachment>;
  /** 購買が伝える希望納期 */
  requestDueDate: Maybe<Scalars['ISO8601Date']['output']>;
  requestText: Maybe<Scalars['String']['output']>;
  supplierCode: Scalars['String']['output'];
  supplierName: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** 内訳行で選べる単位（テナント単位マスタ） */
  unitOptions: Array<Scalars['String']['output']>;
};

export type TrialQuotationAnswerSheetItem = {
  __typename?: 'TrialQuotationAnswerSheetItem';
  makerModel: Scalars['String']['output'];
  makerName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  quotationItemId: Scalars['ID']['output'];
  seqNo: Scalars['Int']['output'];
  unitName: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of TrialQuotationAnswerSubmit */
export type TrialQuotationAnswerSubmitInput = {
  answerMemo?: InputMaybe<Scalars['String']['input']>;
  attachments: Array<TrialQuotationAnswerAttachmentInput>;
  baseRevisionNo: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 納入可能日（依頼単位・任意） */
  deliveryOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  isDeclined: Scalars['Boolean']['input'];
  items: Array<TrialQuotationAnswerItemInput>;
  quotationRequestId: Scalars['ID']['input'];
  /** 見積有効期限（依頼単位・任意） */
  quotationValidUntil?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated return type of TrialQuotationAnswerSubmit. */
export type TrialQuotationAnswerSubmitPayload = {
  __typename?: 'TrialQuotationAnswerSubmitPayload';
  answer: Maybe<TrialQuotationAnswer>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  conflict: Scalars['Boolean']['output'];
  errors: Array<Scalars['String']['output']>;
};

export type TrialQuotationAttachmentClassification = {
  __typename?: 'TrialQuotationAttachmentClassification';
  /** 1:見積書, 2:参考資料 */
  attachmentKind: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

/** Autogenerated input type of TrialQuotationAttachmentClassify */
export type TrialQuotationAttachmentClassifyInput = {
  attachments: Array<TrialQuotationAnswerAttachmentInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  quotationRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of TrialQuotationAttachmentClassify. */
export type TrialQuotationAttachmentClassifyPayload = {
  __typename?: 'TrialQuotationAttachmentClassifyPayload';
  classifications: Array<TrialQuotationAttachmentClassification>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type TrialQuotationRequestAttachment = {
  __typename?: 'TrialQuotationRequestAttachment';
  byteSize: Scalars['Int']['output'];
  contentType: Scalars['String']['output'];
  /** SAS 付きダウンロード URL（有効期限付き） */
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  seqNo: Scalars['Int']['output'];
};

export type TriggeredBy = AdminUser | SupplierAccount | SupplierUser;

export type Unit = {
  __typename?: 'Unit';
  baseUnitCode: Scalars['String']['output'];
  code: Scalars['String']['output'];
  conversionRate: Scalars['Float']['output'];
  symbol: Scalars['String']['output'];
  unitKind: Maybe<UnitKindEnum>;
};

export enum UnitKindEnum {
  AQty = 'a_qty',
  BLen = 'b_len',
  CWeight = 'c_weight',
  DVolume = 'd_volume',
  ESquare = 'e_square'
}

/** Autogenerated input type of UpdateComment */
export type UpdateCommentInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateComment. */
export type UpdateCommentPayload = {
  __typename?: 'UpdateCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  commentNode: Maybe<CommentNode>;
  errors: Array<Scalars['String']['output']>;
};

export type UserCommentConfirmation = {
  __typename?: 'UserCommentConfirmation';
  adminUser: AdminUser;
  adminUserId: Scalars['ID']['output'];
  commentNodeId: Scalars['ID']['output'];
  confirmedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  tenantId: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ValidationErr = {
  __typename?: 'ValidationErr';
  message: Scalars['String']['output'];
  path: Scalars['String']['output'];
  shortMessage: Scalars['String']['output'];
};

export type VersionedAgreement = {
  __typename?: 'VersionedAgreement';
  content: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type WholesalerKnowledge = {
  __typename?: 'WholesalerKnowledge';
  id: Scalars['ID']['output'];
  makerActualPartName: Maybe<Scalars['String']['output']>;
  quotationItemId: Scalars['ID']['output'];
};

/** Autogenerated input type of amendSupplierPriceAdjustmentDraft */
export type AmendSupplierPriceAdjustmentDraftInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: SupplierPriceAdjustmentDraftAmendInput;
};

/** Autogenerated return type of amendSupplierPriceAdjustmentDraft. */
export type AmendSupplierPriceAdjustmentDraftPayload = {
  __typename?: 'amendSupplierPriceAdjustmentDraftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  priceAdjustment: Maybe<PriceAdjustment>;
};

/** Autogenerated input type of priceAdjustmentApprove */
export type PriceAdjustmentApproveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventMemo?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of priceAdjustmentApprove. */
export type PriceAdjustmentApprovePayload = {
  __typename?: 'priceAdjustmentApprovePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  priceAdjustment: Maybe<PriceAdjustment>;
};

/** Autogenerated input type of priceAdjustmentSave */
export type PriceAdjustmentSaveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: PriceAdjustmentFormSaveInput;
};

/** Autogenerated return type of priceAdjustmentSave. */
export type PriceAdjustmentSavePayload = {
  __typename?: 'priceAdjustmentSavePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  inputFormErrors: Maybe<Array<InputFormError>>;
  priceAdjustment: Maybe<PriceAdjustment>;
};

export type AddressFieldFragment = { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null };

export type AnnouncementFieldsFragment = { __typename?: 'Announcement', body: string, confirmationDeadline: any | null, displayFrom: any, displayTo: any, id: string, priority: AnnouncementPriorityEnum, status: AnnouncementStatusEnum, title: string, tenantId: number, applicantUser: { __typename?: 'AdminUser', name: string }, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> };

export type AnswerFieldFragment = { __typename?: 'Answer', id: string, status: string, statusLabel: string, memo: string | null, expiredAt: any | null, isDirect: boolean, isFileAnswer: boolean, isSupplierFileAnswer: boolean, dayType: string | null, quotationNo: string | null, expirationDate: string | null, currencyId: string, facilityCost: number, currencyExchangeNote: string | null, inputKind: string, quotationCopiedFrom: { __typename?: 'Quotation', id: string, uid: string } | null, answerPrices: Array<{ __typename?: 'AnswerPrice', id: string, quantity: number, quantityFrom: number, quantityTo: number | null, isDeclined: boolean, priceBasis: string, taxType: number, amountExcludingTax: string | null, amountIncludingTax: string | null, unitPrice: number | null, materialCost: number | null, partsCost: number | null, processingCost: number | null, surfaceProcessingCost: number | null, subsidiaryMaterialCost: number | null, materialManagementCost: number | null, materialManagementRate: number | null, processingManagementCost: number | null, processingManagementRate: number | null, managementCost: number | null, quantityInOneBox: number | null, deliveryCostPerBox: number | null, boxCount: number | null, deliveryCost: number | null, packingCostPerBox: number | null, packingCost: number | null, defectCost: number | null, defectRate: number | null, profit: number | null, adjustment: number | null, profitRate: number | null, depreciation: number | null, internalPartSubtotal: number | null, outSourcePartSubtotal: number | null, outSourcePartManagementRate: number | null, paidSupplyPartSubtotal: number | null, deliveryDay: number | null, initialDeliveryDay: number | null, materialDeliveryDay: number | null, materialDeliveryStartDay: number | null, equipmentDeliveryDay: number | null, equipmentDeliveryStartDay: number | null, moldDeliveryDay: number | null, moldDeliveryStartDay: number | null, trialDeliveryDay: number | null, trialDeliveryStartDay: number | null, facilityCost: number | null, jigManagementCost: number | null, propertyRentCost: number | null, designCost: number | null, subsidiaryMaterialManagementRate: number | null, subsidiaryMaterialManagementCost: number | null, quotationItemId: string, quotationItemChildStructId: string | null, answerPartsCosts: Array<{ __typename?: 'AnswerPartsCost', id: string, procurementKind: string | null, seqNo: number, partNo: string | null, partName: string | null, productionPlace: string | null, partSpec: string | null, partsCount: number | null, quantity: number | null, partsUnitPrice: number | null, memo: string | null, partsCost: number }>, answerProcessingCosts: Array<{ __typename?: 'AnswerProcessingCost', id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, memo: string | null, processingCost: number, rateKind: string | null, processingWeight: number | null, costForWeight: number | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostSubtotalPerLot: number | null, setupCostSubtotalPerLot: number | null, processingCostPerLot: number | null, partCostRatio: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSpecialProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerSurfaceProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerMaterialCosts: Array<{ __typename?: 'AnswerMaterialCost', id: string, seqNo: number, materialName: string, thickness: number | null, width: number | null, height: number | null, measure: string | null, weightBeforeProcess: number | null, weightAfterProcess: number | null, basePrice: number | null, adjustment: number | null, materialCostSubtotal: number | null, scrapValueSubtotal: number | null, materialCost: number, procurementKind: string | null, cavity: number | null, scrap1Name: string | null, scrap1Weight: number | null, scrap1UnitPrice: number | null, scrap1Subtotal: number | null, scrap2Name: string | null, scrap2Weight: number | null, scrap2UnitPrice: number | null, scrap2Subtotal: number | null, memo: string | null, baseMaterialCode: string | null, materialCostPerQty: number | null, scrap1SubtotalPerQty: number | null, scrap2SubtotalPerQty: number | null, scrapValueSubtotalPerQty: number | null, quantity: number | null, blendPrimaryMaterialName: string | null, blendPrimaryMaterialRatio: number | null, blendPrimaryMaterialUnitCost: number | null, blendSecondaryMaterialName: string | null, blendSecondaryMaterialRatio: number | null, blendSecondaryMaterialUnitCost: number | null, blendOtherMaterialName: string | null, blendOtherMaterialRatio: number | null, blendOtherMaterialUnitCost: number | null, blendBaseUnitCost: number | null, blendUnitCostMarkupRatio: number | null, lossPurgeLotCount: number | null, lossPurgeTotalWeight: number | null, lossPurgeUnitUsage: number | null, lossPurgeCost: number | null, lossGateUnitUsage: number | null, lossGateCost: number | null, lossRunnerUnitUsage: number | null, lossRunnerCost: number | null, lossOtherMemo: string | null, lossOtherUnitUsage: number | null, lossOtherCost: number | null, lossTotalUnitUsage: number | null, lossTotalCost: number | null, trialShotUnitUsage: number | null, trialShotCost: number | null, adjustmentCostMemo: string | null, adjustmentCost: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, priceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSubsidiaryMaterialCosts: Array<{ __typename?: 'CommonAnswerSubsidiaryMaterialCost', id: string, seqNo: number, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number, note: string | null, totalQuantity: number | null, totalSubsidiaryMaterialCost: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null }>, answerSupplySubparts: Array<{ __typename?: 'CommonAnswerSupplySubpart', id: string, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, quantity: number, quantityDenominator: number, unitPrice: number }> }>, answerFacilityCosts: Array<{ __typename?: 'AnswerFacilityCost', id: string, name: string, maker: string | null, spec: string | null, quantity: number | null, facilityUnitPrice: number | null, facilityCost: number, isLend: boolean | null, amortizationCost: number | null, amortizationNumber: number | null, amortizationPeriod: string | null, cavity: number | null, leadTime: string | null, memo: string | null, amortizationPeriodAsYear: number | null, paymentTimingKind: string | null, recuttingCount: number | null, answerProcessingCostId: string | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null, facilityKind: { __typename?: 'FacilityKind', id: string }, parts: Array<{ __typename?: 'Part', id: string, name: string, displayCode: string }>, quotationItems: Array<{ __typename?: 'QuotationItemV2', id: string, itemRequirement: { __typename?: 'ItemRequirement', name: string, code: string | null } }> }>, answerInquiries: Array<{ __typename?: 'AnswerInquiry', id: string, answerValueString: string | null, answerValueNumber: number | null, answerValueBoolean: boolean | null, quotationInquiry: { __typename?: 'QuotationInquiry', id: string, seqNo: number, title: string, inquiryType: string, unit: string | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null, supplierCorporationAttachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }>, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierCorporationAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierAccount: { __typename?: 'SupplierAccount', id: string, name: string } | null, supplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null, answerSupplyChainItemDetails: Array<{ __typename?: 'AnswerSupplyChainItemDetail', id: string | null, tenantId: string | null, quotationItemId: string | null, answerId: string | null, processName: string | null, supplierName: string | null, isAlternative: boolean | null, isNew: boolean | null, note: string | null, factoryName: string | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null }>, answerItems: Array<{ __typename?: 'AnswerItem', quotationItemId: string, minimumOrderQuantity: string | null, deliveryForm: string | null, quantityPerDeliveryForm: string | null, priceEffectiveFrom: any | null, priceEffectiveTo: any | null, specMemo: string | null, originLocation: string | null }>, wholesalerKnowledges: Array<{ __typename?: 'WholesalerKnowledge', quotationItemId: string, makerActualPartName: string | null }>, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null, answerOriginalFiles: Array<{ __typename?: 'AnswerOriginalFile', attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null, supplierCorporationAttachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }>, answerExcelAttachments: Array<{ __typename?: 'AnswerExcelAttachment', id: string | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null, supplierCorporationAttachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }> };

export type AnswerExcelImportAnswerPriceFieldFragment = { __typename?: 'AnswerPriceExcelResultV2', quotationItemId: string, partId: string | null, quantity: number, unitPrice: number | null, materialCost: number | null, partsCost: number | null, processingCost: number | null, materialManagementCost: number | null, materialManagementRate: number | null, processingManagementCost: number | null, processingManagementRate: number | null, managementCost: number | null, quantityInOneBox: number | null, deliveryCostPerBox: number | null, boxCount: number | null, deliveryCost: number | null, packingCostPerBox: number | null, packingCost: number | null, defectCost: number | null, defectRate: number | null, profit: number | null, adjustment: number | null, profitRate: number | null, depreciation: number | null, internalPartSubtotal: number | null, outSourcePartSubtotal: number | null, outSourcePartManagementRate: number | null, paidSupplyPartSubtotal: number | null, deliveryDay: number | null, initialDeliveryDay: number | null, materialDeliveryDay: number | null, materialDeliveryStartDay: number | null, equipmentDeliveryDay: number | null, equipmentDeliveryStartDay: number | null, moldDeliveryDay: number | null, moldDeliveryStartDay: number | null, trialDeliveryDay: number | null, trialDeliveryStartDay: number | null, subsidiaryMaterialCost: number | null, surfaceProcessingCost: number | null, partRelatedFacilityCost: number | null, propertyRentCost: number | null, jigManagementCost: number | null, facilityCost: number | null, designCost: number | null, subsidiaryMaterialManagementRate: number | null, subsidiaryMaterialManagementCost: number | null, quotationItemChildStructId: string | null, answerPartsCosts: Array<{ __typename?: 'AnswerPartsCost', procurementKind: string | null, seqNo: number, partNo: string | null, partName: string | null, productionPlace: string | null, partSpec: string | null, partsCount: number | null, quantity: number | null, partsUnitPrice: number | null, memo: string | null, partsCost: number }>, answerMaterialCosts: Array<{ __typename?: 'AnswerMaterialCost', seqNo: number, materialName: string, thickness: number | null, width: number | null, height: number | null, measure: string | null, weightBeforeProcess: number | null, weightAfterProcess: number | null, basePrice: number | null, adjustment: number | null, materialCostSubtotal: number | null, scrapValueSubtotal: number | null, procurementKind: string | null, materialCost: number, cavity: number | null, scrap1Name: string | null, scrap1Weight: number | null, scrap1UnitPrice: number | null, scrap1Subtotal: number | null, scrap2Name: string | null, scrap2Weight: number | null, scrap2UnitPrice: number | null, scrap2Subtotal: number | null, memo: string | null, baseMaterialCode: string | null, quantity: number | null, materialCostSubtotalPerQty: number | null, scrap1SubtotalPerQty: number | null, scrap2SubtotalPerQty: number | null, scrapValueSubtotalPerQty: number | null, materialCostPerQty: number | null, blendPrimaryMaterialName: string | null, blendPrimaryMaterialRatio: number | null, blendPrimaryMaterialUnitCost: number | null, blendSecondaryMaterialName: string | null, blendSecondaryMaterialRatio: number | null, blendSecondaryMaterialUnitCost: number | null, blendOtherMaterialName: string | null, blendOtherMaterialRatio: number | null, blendOtherMaterialUnitCost: number | null, blendBaseUnitCost: number | null, blendUnitCostMarkupRatio: number | null, lossPurgeLotCount: number | null, lossPurgeTotalWeight: number | null, lossPurgeUnitUsage: number | null, lossPurgeCost: number | null, lossGateUnitUsage: number | null, lossGateCost: number | null, lossRunnerUnitUsage: number | null, lossRunnerCost: number | null, lossOtherMemo: string | null, lossOtherUnitUsage: number | null, lossOtherCost: number | null, lossTotalUnitUsage: number | null, lossTotalCost: number | null, trialShotUnitUsage: number | null, trialShotCost: number | null, adjustmentCostMemo: string | null, adjustmentCost: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, priceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerProcessingCosts: Array<{ __typename?: 'AnswerProcessingCost', seqNo: number, processName: string, productionLot: number | null, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, memo: string | null, processingCost: number, rateKind: string | null, processingWeight: number | null, costForWeight: number | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostSubtotalPerLot: number | null, setupCostSubtotalPerLot: number | null, processingCostPerLot: number | null, partCostRatio: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, answerFacilityCost: { __typename?: 'AnswerFacilityCost', name: string, maker: string | null, spec: string | null, quantity: number | null, facilityUnitPrice: number | null, facilityCost: number, isLend: boolean | null, amortizationNumber: number | null, amortizationPeriod: string | null, cavity: number | null, leadTime: string | null, memo: string | null, amortizationPeriodAsYear: number | null, paymentTimingKind: string | null, recuttingCount: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null, facilityKind: { __typename?: 'FacilityKind', id: string, name: string } } | null }>, answerSpecialProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerSubsidiaryMaterialCosts: Array<{ __typename?: 'CommonAnswerSubsidiaryMaterialCost', seqNo: number, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number, note: string | null, totalQuantity: number | null, totalSubsidiaryMaterialCost: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null }> };

export type AnswerFacilityCostFieldFragment = { __typename?: 'AnswerFacilityCost', id: string, name: string, maker: string | null, spec: string | null, quantity: number | null, facilityUnitPrice: number | null, facilityCost: number, isLend: boolean | null, amortizationCost: number | null, amortizationNumber: number | null, amortizationPeriod: string | null, cavity: number | null, leadTime: string | null, memo: string | null, amortizationPeriodAsYear: number | null, paymentTimingKind: string | null, recuttingCount: number | null, answerProcessingCostId: string | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null, facilityKind: { __typename?: 'FacilityKind', id: string }, parts: Array<{ __typename?: 'Part', id: string, name: string, displayCode: string }>, quotationItems: Array<{ __typename?: 'QuotationItemV2', id: string, itemRequirement: { __typename?: 'ItemRequirement', name: string, code: string | null } }> };

export type AnswerFormatFieldFragment = { __typename?: 'AnswerFormat', id: string, isUseMaterialCost: boolean, isUseMaterialCostDetail: boolean, isUseMaterialSize: boolean, isUseMaterialScrap: boolean, isUseMaterialCostProcurementKind: boolean, isUseMaterialCostCavity: boolean, isUseMaterialCostAdjustment: boolean, isUseMaterialCostMemo: boolean, isUseMaterialCostThickness: boolean, isUseMaterialCostWidth: boolean, isUseMaterialCostHeight: boolean, isUseMaterialCostMeasure: boolean, isUseMaterialCostWeightBeforeProcess: boolean, isUseMaterialCostWeightAfterProcess: boolean, isUseMaterialCostBasePrice: boolean, isUsePartsCost: boolean, isUsePartsCostDetail: boolean, isUsePartsCostProcurementKind: boolean, isUsePartsCostPartNo: boolean, isUsePartsCostPartName: boolean, isUsePartsCostProductionPlace: boolean, isUsePartsCostQuantity: boolean, isUsePartsCostPartsUnitPrice: boolean, isUsePartsCostMemo: boolean, isUsePartsCostPartSpec: boolean, isUsePartsCostPartsCount: boolean, isUseProcessingCost: boolean, isUseProcessingCostDetail: boolean, isUseProcessingCostProductionLot: boolean, isUseProcessingCostEquipmentName: boolean, isUseProcessingCostProcessingTimeHour: boolean, isUseProcessingCostProcessingTimeMinute: boolean, isUseProcessingCostProcessingTimeSecond: boolean, isUseProcessingCostProcessingRate: boolean, isUseSetupInformation: boolean, isUseProcessingCostProcessingTimes: boolean, isUseProcessingCostSetupTimeHour: boolean, isUseProcessingCostSetupTimeMinute: boolean, isUseProcessingCostSetupTimeSecond: boolean, isUseProcessingCostSetupRate: boolean, isUseProcessingCostProcessingCostSubtotal: boolean, isUseProcessingCostSetupCostSubtotal: boolean, isUseProcessingCostMemo: boolean, processingCostRateKind: string | null, isUseManagementCost: boolean, isUseMaterialManagementRate: boolean, isUseMaterialManagementCost: boolean, isUseProcessingManagementRate: boolean, isUseProcessingManagementCost: boolean, isUseDeliveryCost: boolean, isUseDeliveryBoxInformation: boolean, isUsePackingCost: boolean, isUsePackingBoxInformation: boolean, isUseDefectCost: boolean, isUseDefectRate: boolean, isUseProfit: boolean, isUseProfitRate: boolean, isUseAdjustment: boolean, isUseDepreciation: boolean, isUseInternalPartSubtotal: boolean, isUseOutSourcePartSubtotal: boolean, isUseOutSourcePartManagementRate: boolean, isUsePaidSupplyPartSubtotal: boolean, isUseInitialDeliveryDay: boolean, isUseMaterialDeliveryDay: boolean, isUseEquipmentDeliveryDay: boolean, isUseMoldDeliveryDay: boolean, isUseTrialDeliveryDay: boolean, isUseDeliveryDay: boolean, isUseGanttForDeliveryDay: boolean, isUseSurfaceProcessingCost: boolean, isUseSubsidiaryMaterialCost: boolean, isUseSubsidiaryMaterialCostDetail: boolean, isSetScrapName: boolean, scrap1Name: string | null, scrap2Name: string | null, isUseCurrencyExchangeNote: boolean, isUseAnswerByItem: boolean, isUseMinimumOrderQuantity: boolean, isUseDeliveryForm: boolean, isUseQuantityPerDeliveryForm: boolean, isUsePriceEffectiveDate: boolean, priceRegistrationFormatId: string | null, answerMethod: string, isUseProcessingWeight: boolean, isUseCostForWeight: boolean, isUseProcessingHeadcount: boolean, calculationKind: string, isUseWholesalerKnowledge: boolean, useMakerActualPartName: string, makerActualPartNameHelperTxt: string | null, materialCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, materialCostPriceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, specialProcessingDetailFormatsList: Array<{ __typename?: 'CommonSpecialProcessingDetailFormat', kind: string, kindLabel: string, isUseProductionLot: boolean, isUseEquipmentName: boolean, isUseProcessingTimeHour: boolean, isUseProcessingTimeMinute: boolean, isUseProcessingTimeSecond: boolean, isUseProcessingRate: boolean, isUseSetupInformation: boolean, isUseSetupTimeHour: boolean, isUseSetupTimeMinute: boolean, isUseSetupTimeSecond: boolean, isUseSetupRate: boolean, isUseMemo: boolean, isUseProcessingTimes: boolean, isUseProcessingCostSubtotal: boolean, isUseSetupCostSubtotal: boolean, rateKind: string | null }>, processingCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, facilityKinds: Array<{ __typename?: 'FacilityKind', id: string, code: string | null, name: string }> };

export type AnswerInquiryFieldFragment = { __typename?: 'AnswerInquiry', id: string, answerValueString: string | null, answerValueNumber: number | null, answerValueBoolean: boolean | null, quotationInquiry: { __typename?: 'QuotationInquiry', id: string, seqNo: number, title: string, inquiryType: string, unit: string | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null, supplierCorporationAttachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null };

export type AnswerItemFieldFragment = { __typename?: 'AnswerItem', quotationItemId: string, minimumOrderQuantity: string | null, deliveryForm: string | null, quantityPerDeliveryForm: string | null, priceEffectiveFrom: any | null, priceEffectiveTo: any | null, specMemo: string | null, originLocation: string | null };

export type AnswerMaterialCostFieldFragment = { __typename?: 'AnswerMaterialCost', id: string, seqNo: number, materialName: string, thickness: number | null, width: number | null, height: number | null, measure: string | null, weightBeforeProcess: number | null, weightAfterProcess: number | null, basePrice: number | null, adjustment: number | null, materialCostSubtotal: number | null, scrapValueSubtotal: number | null, materialCost: number, procurementKind: string | null, cavity: number | null, scrap1Name: string | null, scrap1Weight: number | null, scrap1UnitPrice: number | null, scrap1Subtotal: number | null, scrap2Name: string | null, scrap2Weight: number | null, scrap2UnitPrice: number | null, scrap2Subtotal: number | null, memo: string | null, baseMaterialCode: string | null, materialCostPerQty: number | null, scrap1SubtotalPerQty: number | null, scrap2SubtotalPerQty: number | null, scrapValueSubtotalPerQty: number | null, quantity: number | null, blendPrimaryMaterialName: string | null, blendPrimaryMaterialRatio: number | null, blendPrimaryMaterialUnitCost: number | null, blendSecondaryMaterialName: string | null, blendSecondaryMaterialRatio: number | null, blendSecondaryMaterialUnitCost: number | null, blendOtherMaterialName: string | null, blendOtherMaterialRatio: number | null, blendOtherMaterialUnitCost: number | null, blendBaseUnitCost: number | null, blendUnitCostMarkupRatio: number | null, lossPurgeLotCount: number | null, lossPurgeTotalWeight: number | null, lossPurgeUnitUsage: number | null, lossPurgeCost: number | null, lossGateUnitUsage: number | null, lossGateCost: number | null, lossRunnerUnitUsage: number | null, lossRunnerCost: number | null, lossOtherMemo: string | null, lossOtherUnitUsage: number | null, lossOtherCost: number | null, lossTotalUnitUsage: number | null, lossTotalCost: number | null, trialShotUnitUsage: number | null, trialShotCost: number | null, adjustmentCostMemo: string | null, adjustmentCost: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, priceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null };

export type AnswerPartsCostFieldFragment = { __typename?: 'AnswerPartsCost', id: string, procurementKind: string | null, seqNo: number, partNo: string | null, partName: string | null, productionPlace: string | null, partSpec: string | null, partsCount: number | null, quantity: number | null, partsUnitPrice: number | null, memo: string | null, partsCost: number };

export type AnswerPriceFieldFragment = { __typename?: 'AnswerPrice', id: string, quantity: number, quantityFrom: number, quantityTo: number | null, isDeclined: boolean, priceBasis: string, taxType: number, amountExcludingTax: string | null, amountIncludingTax: string | null, unitPrice: number | null, materialCost: number | null, partsCost: number | null, processingCost: number | null, surfaceProcessingCost: number | null, subsidiaryMaterialCost: number | null, materialManagementCost: number | null, materialManagementRate: number | null, processingManagementCost: number | null, processingManagementRate: number | null, managementCost: number | null, quantityInOneBox: number | null, deliveryCostPerBox: number | null, boxCount: number | null, deliveryCost: number | null, packingCostPerBox: number | null, packingCost: number | null, defectCost: number | null, defectRate: number | null, profit: number | null, adjustment: number | null, profitRate: number | null, depreciation: number | null, internalPartSubtotal: number | null, outSourcePartSubtotal: number | null, outSourcePartManagementRate: number | null, paidSupplyPartSubtotal: number | null, deliveryDay: number | null, initialDeliveryDay: number | null, materialDeliveryDay: number | null, materialDeliveryStartDay: number | null, equipmentDeliveryDay: number | null, equipmentDeliveryStartDay: number | null, moldDeliveryDay: number | null, moldDeliveryStartDay: number | null, trialDeliveryDay: number | null, trialDeliveryStartDay: number | null, facilityCost: number | null, jigManagementCost: number | null, propertyRentCost: number | null, designCost: number | null, subsidiaryMaterialManagementRate: number | null, subsidiaryMaterialManagementCost: number | null, quotationItemId: string, quotationItemChildStructId: string | null, answerPartsCosts: Array<{ __typename?: 'AnswerPartsCost', id: string, procurementKind: string | null, seqNo: number, partNo: string | null, partName: string | null, productionPlace: string | null, partSpec: string | null, partsCount: number | null, quantity: number | null, partsUnitPrice: number | null, memo: string | null, partsCost: number }>, answerProcessingCosts: Array<{ __typename?: 'AnswerProcessingCost', id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, memo: string | null, processingCost: number, rateKind: string | null, processingWeight: number | null, costForWeight: number | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostSubtotalPerLot: number | null, setupCostSubtotalPerLot: number | null, processingCostPerLot: number | null, partCostRatio: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSpecialProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerSurfaceProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerMaterialCosts: Array<{ __typename?: 'AnswerMaterialCost', id: string, seqNo: number, materialName: string, thickness: number | null, width: number | null, height: number | null, measure: string | null, weightBeforeProcess: number | null, weightAfterProcess: number | null, basePrice: number | null, adjustment: number | null, materialCostSubtotal: number | null, scrapValueSubtotal: number | null, materialCost: number, procurementKind: string | null, cavity: number | null, scrap1Name: string | null, scrap1Weight: number | null, scrap1UnitPrice: number | null, scrap1Subtotal: number | null, scrap2Name: string | null, scrap2Weight: number | null, scrap2UnitPrice: number | null, scrap2Subtotal: number | null, memo: string | null, baseMaterialCode: string | null, materialCostPerQty: number | null, scrap1SubtotalPerQty: number | null, scrap2SubtotalPerQty: number | null, scrapValueSubtotalPerQty: number | null, quantity: number | null, blendPrimaryMaterialName: string | null, blendPrimaryMaterialRatio: number | null, blendPrimaryMaterialUnitCost: number | null, blendSecondaryMaterialName: string | null, blendSecondaryMaterialRatio: number | null, blendSecondaryMaterialUnitCost: number | null, blendOtherMaterialName: string | null, blendOtherMaterialRatio: number | null, blendOtherMaterialUnitCost: number | null, blendBaseUnitCost: number | null, blendUnitCostMarkupRatio: number | null, lossPurgeLotCount: number | null, lossPurgeTotalWeight: number | null, lossPurgeUnitUsage: number | null, lossPurgeCost: number | null, lossGateUnitUsage: number | null, lossGateCost: number | null, lossRunnerUnitUsage: number | null, lossRunnerCost: number | null, lossOtherMemo: string | null, lossOtherUnitUsage: number | null, lossOtherCost: number | null, lossTotalUnitUsage: number | null, lossTotalCost: number | null, trialShotUnitUsage: number | null, trialShotCost: number | null, adjustmentCostMemo: string | null, adjustmentCost: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, priceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSubsidiaryMaterialCosts: Array<{ __typename?: 'CommonAnswerSubsidiaryMaterialCost', id: string, seqNo: number, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number, note: string | null, totalQuantity: number | null, totalSubsidiaryMaterialCost: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null }>, answerSupplySubparts: Array<{ __typename?: 'CommonAnswerSupplySubpart', id: string, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, quantity: number, quantityDenominator: number, unitPrice: number }> };

export type AnswerProcessingCostFieldFragment = { __typename?: 'AnswerProcessingCost', id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, memo: string | null, processingCost: number, rateKind: string | null, processingWeight: number | null, costForWeight: number | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostSubtotalPerLot: number | null, setupCostSubtotalPerLot: number | null, processingCostPerLot: number | null, partCostRatio: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null };

export type AnswerSpecialProcessingCostFieldFragment = { __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null };

export type AnswerSubsidiaryMaterialCostFieldFragment = { __typename?: 'CommonAnswerSubsidiaryMaterialCost', id: string, seqNo: number, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number, note: string | null, totalQuantity: number | null, totalSubsidiaryMaterialCost: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null };

export type AnswerSupplyChainItemDetailFieldFragment = { __typename?: 'AnswerSupplyChainItemDetail', id: string | null, tenantId: string | null, quotationItemId: string | null, answerId: string | null, processName: string | null, supplierName: string | null, isAlternative: boolean | null, isNew: boolean | null, note: string | null, factoryName: string | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null };

export type ApplicationFormatFieldFragment = { __typename?: 'ApplicationFormat', isUseReceiver: boolean, isUseDesignAttachment: boolean, isUseSpecAttachment: boolean, isUseFigureNumber: boolean, quantityUnit: string | null, isUseIsNew: boolean, isUseDeliverySite: boolean, isSendSelectionMail: boolean, isUseQuotationContext: boolean, isUseQcIncoterms: boolean, isUseQcRuleOfCurrencyRateChange: boolean, isUseQcRuleOfMarketChange: boolean, isUseRequestProcess: boolean, isUseMaterialPriceReferenceDate: boolean, isUseAssumedExchangeRateUsd: boolean, isUseAssumedExchangeRateCny: boolean, isUsePartSupplyPresence: boolean, isUseMaterialSupplyPresence: boolean, isUseCostBearingDolly: boolean, isUseCostBearingInitialCost: boolean, isUsePaymentMethod: boolean, isUsePaymentInstallmentInitialCost: boolean, isUseMassProductionCategory: boolean, isUseMaker: boolean, isUseItemPropInfo: boolean, productScheduleSettings: Array<{ __typename?: 'ProductScheduleSetting', groupSeqNo: number, seqNo: number, name: string }>, itemProps: Array<{ __typename?: 'ItemProp', id: string, name: string, code: string | null, unit: string | null, kind: ItemPropKind }> };

export type AttachmentFieldFragment = { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any };

export type AttachmentOfferFieldFragment = { __typename?: 'AttachmentOffer', id: string, uid: string, itemRootCode: string | null, itemName: string | null, itemCode: string | null, designChangeCode: string | null, figureNumber: string | null, purpose: string | null, isDiscardNecessary: boolean, discardDeadlineOn: any | null, status: string, isDownloadable: boolean, previewUrl: string | null, latestAcknowledgedAt: any | null, memo: string | null, offeredAt: any | null, tenant: { __typename?: 'Tenant', id: string, name: string }, supplier: { __typename?: 'Supplier', code: string, name: string }, personInChargeAdminUser: { __typename?: 'AdminUser', id: string, name: string } | null, attachment: { __typename?: 'Attachment', id: string, name: string, nameForSupplier: string | null }, discardEvent: { __typename?: 'AttachmentOfferEvent', createdAt: any | null, supplierAccount: { __typename?: 'SupplierAccount', id: string, name: string } | null, supplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null } | null, downloadEvents: Array<{ __typename?: 'AttachmentOfferEvent', id: string }> | null, quotationItem: { __typename?: 'QuotationItemV2', id: string, quotation: { __typename?: 'Quotation', id: string, uid: string }, project: { __typename?: 'Project', id: string } | null } | null };

export type AttachmentOfferListFieldFragment = { __typename?: 'AttachmentOffer', id: string, uid: string, itemRootCode: string | null, itemCode: string | null, itemName: string | null, figureNumber: string | null, status: string, isDownloadable: boolean, latestAcknowledgedAt: any | null, discardDeadlineOn: any | null, offeredAt: any | null, isDiscardNecessary: boolean, attachment: { __typename?: 'Attachment', id: string, name: string, nameForSupplier: string | null }, personInChargeAdminUser: { __typename?: 'AdminUser', id: string, name: string } | null, discardEvent: { __typename?: 'AttachmentOfferEvent', createdAt: any | null, supplierAccount: { __typename?: 'SupplierAccount', id: string, name: string } | null, supplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null } | null, downloadEvents: Array<{ __typename?: 'AttachmentOfferEvent', id: string }> | null, tenant: { __typename?: 'Tenant', id: string }, supplier: { __typename?: 'Supplier', id: string, code: string, name: string } };

export type BcpAnswerTokenCategoriesFieldFragment = { __typename?: 'BcpIncidentAnswerTokenCategories', humanDamageLevel: BcpIncidentAnswerCategoryLevelEnum | null, humanDamageComment: string | null, buildingDamageLevel: BcpIncidentAnswerCategoryLevelEnum | null, buildingDamageComment: string | null, equipmentDamageLevel: BcpIncidentAnswerCategoryLevelEnum | null, equipmentDamageComment: string | null, productionImpactLevel: BcpIncidentAnswerCategoryLevelEnum | null, productionImpactComment: string | null, deliveryImpactLevel: BcpIncidentAnswerCategoryLevelEnum | null, deliveryImpactComment: string | null };

export type CommentBaseFieldFragment = { __typename?: 'CommentBase', id: string, commentKind: string, targetId: string, itemKind: string, createdAt: any, updatedAt: any, commentNodes: Array<{ __typename?: 'CommentNode', id: string, body: string, parentId: string | null, authorAdminUserId: string | null, authorAdminUserName: string | null, authorSupplierAccountId: string | null, authorSupplierAccountName: string | null, authorSupplierUserId: string | null, authorSupplierUserName: string | null, targetKind: CommentNodeTargetKindEnum, supplierId: string | null, deletedAt: any | null, canEdit: boolean, canDelete: boolean, createdAt: any, updatedAt: any, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierUserInfoCommentConfirmations: Array<{ __typename?: 'SupplierUserInfoCommentConfirmation', id: string, supplierUserInfoId: string | null, confirmedAt: any | null, supplyChainCompanyEmployeeName: string | null, supplierUserInfo: { __typename?: 'SupplierUserInfo', id: string, supplierUserId: string | null } | null }>, userCommentConfirmations: Array<{ __typename?: 'UserCommentConfirmation', id: string, adminUserId: string, confirmedAt: any | null, adminUser: { __typename?: 'AdminUser', id: string, name: string } }> }> };

export type CommentNodeFieldFragment = { __typename?: 'CommentNode', id: string, body: string, parentId: string | null, authorAdminUserId: string | null, authorAdminUserName: string | null, authorSupplierAccountId: string | null, authorSupplierAccountName: string | null, authorSupplierUserId: string | null, authorSupplierUserName: string | null, targetKind: CommentNodeTargetKindEnum, supplierId: string | null, deletedAt: any | null, canEdit: boolean, canDelete: boolean, createdAt: any, updatedAt: any, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierUserInfoCommentConfirmations: Array<{ __typename?: 'SupplierUserInfoCommentConfirmation', id: string, supplierUserInfoId: string | null, confirmedAt: any | null, supplyChainCompanyEmployeeName: string | null, supplierUserInfo: { __typename?: 'SupplierUserInfo', id: string, supplierUserId: string | null } | null }>, userCommentConfirmations: Array<{ __typename?: 'UserCommentConfirmation', id: string, adminUserId: string, confirmedAt: any | null, adminUser: { __typename?: 'AdminUser', id: string, name: string } }> };

export type SelectedTenantFieldFragment = { __typename?: 'Tenant', id: string, name: string, code: string, inOperationScope: boolean, quotationConfig: { __typename?: 'QuotationConfig', isUseQuotationPackage: boolean, isUseTemporaryAnswer: boolean } | null };

export type ContactClassFieldFragment = { __typename?: 'ContactClass', id: string, code: string, name: string, order: number, isArchived: boolean };

export type CountryFieldFragment = { __typename?: 'Country', id: string, name: string, translation: string | null };

export type CrContactClassLinkFieldFragment = { __typename?: 'CrContactClassLink', id: string, contactClass: { __typename?: 'ContactClass', id: string, code: string, name: string, order: number, isArchived: boolean } };

export type CrSupplierFirmFieldFragment = { __typename?: 'CrSupplierFirm', id: string, beforeAfterKind: SupplierSurveyBeforeAfterKindEnum, name: string, nameShort: string | null, nameEn: string | null, nameKana: string | null, president: string | null, url: string | null, capital: number | null, tel: string | null, fax: string | null, email: string | null, establishedDate: any | null, startTransactionDate: any | null, numberOfEmployees: number | null, listingKind: SupplierListingKindEnum | null, closingMonth: SupplierClosingMonthEnum | null, issuedShares: number | null, dividendAmount: number | null, companyBackground: string | null, numberOfEmployeesOther: number | null, businessDescription: string | null, generalText1: string | null, generalText2: string | null, generalText3: string | null, generalText4: string | null, generalText5: string | null, generalText6: string | null, generalText7: string | null, generalText8: string | null, generalText9: string | null, generalText10: string | null, generalText11: string | null, generalText12: string | null, generalText13: string | null, generalText14: string | null, generalText15: string | null, generalText16: string | null, generalText17: string | null, generalText18: string | null, generalText19: string | null, generalText20: string | null, capitalCurrency: { __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean } | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null, industry: { __typename?: 'Industry', id: string, code: string | null, name: string | null, order: number, isArchived: boolean } | null, generalKind1Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind2Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind3Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind4Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind5Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind6Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind7Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind8Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind9Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind10Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKinds1Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds2Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds3Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds4Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds5Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds6Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds7Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds8Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds9Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds10Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }> };

export type CrSupplierFirmBankInfoFieldFragment = { __typename?: 'CrSupplierFirmBankInfo', id: string, isArchived: boolean, financialInstitutionName: string | null, branchName: string | null, borrowingRatio: number | null, memo: string | null };

export type CrSupplierFirmBankInfoWithBeforeFieldFragment = { __typename?: 'CrSupplierFirmBankInfo', id: string, isArchived: boolean, financialInstitutionName: string | null, branchName: string | null, borrowingRatio: number | null, memo: string | null, before: { __typename?: 'CrSupplierFirmBankInfo', id: string, isArchived: boolean, financialInstitutionName: string | null, branchName: string | null, borrowingRatio: number | null, memo: string | null } | null };

export type CrSupplierFirmCertificationInfoFieldFragment = { __typename?: 'CrSupplierFirmCertificationInfo', id: string, isArchived: boolean, acquisitionDate: any | null, expirationDate: any | null, isRelatedToOwnCompany: boolean | null, certificationAuthorityName: string | null, certificationNumber: string | null, updateDate: any | null, revisionDate: any | null, memo: string | null, certificationClass: { __typename?: 'CertificationClass', id: string, name: string | null, certificationStandard: string | null } };

export type CrSupplierFirmCertificationInfoWithBeforeFieldFragment = { __typename?: 'CrSupplierFirmCertificationInfo', id: string, isArchived: boolean, acquisitionDate: any | null, expirationDate: any | null, isRelatedToOwnCompany: boolean | null, certificationAuthorityName: string | null, certificationNumber: string | null, updateDate: any | null, revisionDate: any | null, memo: string | null, before: { __typename?: 'CrSupplierFirmCertificationInfo', id: string, isArchived: boolean, acquisitionDate: any | null, expirationDate: any | null, isRelatedToOwnCompany: boolean | null, certificationAuthorityName: string | null, certificationNumber: string | null, updateDate: any | null, revisionDate: any | null, memo: string | null, certificationClass: { __typename?: 'CertificationClass', id: string, name: string | null, certificationStandard: string | null } } | null, certificationClass: { __typename?: 'CertificationClass', id: string, name: string | null, certificationStandard: string | null } };

export type CrSupplierFirmEmployeeNumberInfoFieldFragment = { __typename?: 'CrSupplierFirmEmployeeNumberInfo', id: string, isArchived: boolean, numberOfEmployees: number | null, numberOfEmployeesMan: number | null, numberOfEmployeesWoman: number | null, showGenderBreakdown: boolean, supplierEmployeeClass: { __typename?: 'SupplierEmployeeClass', id: string, name: string } };

export type CrSupplierFirmEmployeeNumberInfoWithBeforeFieldFragment = { __typename?: 'CrSupplierFirmEmployeeNumberInfo', id: string, isArchived: boolean, numberOfEmployees: number | null, numberOfEmployeesMan: number | null, numberOfEmployeesWoman: number | null, showGenderBreakdown: boolean, before: { __typename?: 'CrSupplierFirmEmployeeNumberInfo', id: string, isArchived: boolean, numberOfEmployees: number | null, numberOfEmployeesMan: number | null, numberOfEmployeesWoman: number | null, showGenderBreakdown: boolean, supplierEmployeeClass: { __typename?: 'SupplierEmployeeClass', id: string, name: string } } | null, supplierEmployeeClass: { __typename?: 'SupplierEmployeeClass', id: string, name: string } };

export type CrSupplierFirmEquipmentInfoFieldFragment = { __typename?: 'CrSupplierFirmEquipmentInfo', id: string, equipmentMachineName: string | null, manufacturerName: string | null, model: string | null, year: string | null, quantity: number | null, remarks: string | null, location: string | null, quantityUnit: string | null, productionCapacity: string | null, isArchived: boolean, category: string | null };

export type CrSupplierFirmEquipmentInfoWithBeforeFieldFragment = { __typename?: 'CrSupplierFirmEquipmentInfo', id: string, equipmentMachineName: string | null, manufacturerName: string | null, model: string | null, year: string | null, quantity: number | null, remarks: string | null, location: string | null, quantityUnit: string | null, productionCapacity: string | null, isArchived: boolean, category: string | null, before: { __typename?: 'CrSupplierFirmEquipmentInfo', id: string, equipmentMachineName: string | null, manufacturerName: string | null, model: string | null, year: string | null, quantity: number | null, remarks: string | null, location: string | null, quantityUnit: string | null, productionCapacity: string | null, isArchived: boolean, category: string | null } | null };

export type CrSupplierFirmFileInfoFieldFragment = { __typename?: 'CrSupplierFirmFileInfo', id: string, expirationDateFrom: any | null, expirationDateTo: any | null, isArchived: boolean, registeredAt: any, registeredBy: string | null, memo: string | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }, supplierFileClass: { __typename?: 'SupplierFileClass', id: string, name: string, order: number, isSatisfyElectronicBookPreservationAct: boolean, canModifyBySupplierFirmInfoConfirmationRequest: boolean, canSupplierEditCrAnswer: boolean, canSupplierDeleteCrAnswer: boolean } };

export type CrSupplierFirmFileInfoWithBeforeFieldFragment = { __typename?: 'CrSupplierFirmFileInfo', id: string, expirationDateFrom: any | null, expirationDateTo: any | null, isArchived: boolean, registeredAt: any, registeredBy: string | null, memo: string | null, before: { __typename?: 'CrSupplierFirmFileInfo', id: string, expirationDateFrom: any | null, expirationDateTo: any | null, isArchived: boolean, registeredAt: any, registeredBy: string | null, memo: string | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }, supplierFileClass: { __typename?: 'SupplierFileClass', id: string, name: string, order: number, isSatisfyElectronicBookPreservationAct: boolean, canModifyBySupplierFirmInfoConfirmationRequest: boolean, canSupplierEditCrAnswer: boolean, canSupplierDeleteCrAnswer: boolean } } | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }, supplierFileClass: { __typename?: 'SupplierFileClass', id: string, name: string, order: number, isSatisfyElectronicBookPreservationAct: boolean, canModifyBySupplierFirmInfoConfirmationRequest: boolean, canSupplierEditCrAnswer: boolean, canSupplierDeleteCrAnswer: boolean } };

export type CrSupplierFirmFinancialDetailFieldFragment = { __typename?: 'CrSupplierFirmFinancialDetail', id: string, isArchived: boolean, financialStatementKind: string | null, name: string | null, amount: number | null, displayAmount: number | null, parentId: string | null, changeRate: number | null, supplierAccountingItem: { __typename?: 'SupplierAccountingItem', id: string, parentId: string | null, code: string, name: string, isAsset: boolean, isLiability: boolean, isNetAsset: boolean, isEditable: boolean, isSubtraction: boolean, level: number } };

export type CrSupplierFirmFinancialDetailWithBeforeFieldFragment = { __typename?: 'CrSupplierFirmFinancialDetail', id: string, isArchived: boolean, financialStatementKind: string | null, name: string | null, amount: number | null, displayAmount: number | null, parentId: string | null, changeRate: number | null, before: { __typename?: 'CrSupplierFirmFinancialDetail', id: string, isArchived: boolean, financialStatementKind: string | null, name: string | null, amount: number | null, displayAmount: number | null, parentId: string | null, changeRate: number | null, supplierAccountingItem: { __typename?: 'SupplierAccountingItem', id: string, parentId: string | null, code: string, name: string, isAsset: boolean, isLiability: boolean, isNetAsset: boolean, isEditable: boolean, isSubtraction: boolean, level: number } } | null, supplierAccountingItem: { __typename?: 'SupplierAccountingItem', id: string, parentId: string | null, code: string, name: string, isAsset: boolean, isLiability: boolean, isNetAsset: boolean, isEditable: boolean, isSubtraction: boolean, level: number } };

export type CrSupplierFirmFinancialInfoFieldFragment = { __typename?: 'CrSupplierFirmFinancialInfo', id: string, supplierFirmInfoConfirmationRequestId: string, isArchived: boolean, financialStatementPeriodFrom: any | null, financialStatementPeriodTo: any | null, bsAmountUnitKindLabel: string | null, plAmountUnitKindLabel: string | null, cfAmountUnitKindLabel: string | null, grossProfitMarginRatio: number | null, operatingProfitRatio: number | null, salesOperatingProfitRatio: number | null, netProfitRatio: number | null, grossProfitMarginRatioChangeRate: number | null, operatingProfitRatioChangeRate: number | null, salesOperatingProfitRatioChangeRate: number | null, netProfitRatioChangeRate: number | null, bsLiabilityNetAssetTotalChangeRate: number | null, currency: { __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean } };

export type CrSupplierFirmFinancialInfoWithBeforeFieldFragment = { __typename?: 'CrSupplierFirmFinancialInfo', id: string, supplierFirmInfoConfirmationRequestId: string, isArchived: boolean, financialStatementPeriodFrom: any | null, financialStatementPeriodTo: any | null, bsAmountUnitKindLabel: string | null, plAmountUnitKindLabel: string | null, cfAmountUnitKindLabel: string | null, grossProfitMarginRatio: number | null, operatingProfitRatio: number | null, salesOperatingProfitRatio: number | null, netProfitRatio: number | null, grossProfitMarginRatioChangeRate: number | null, operatingProfitRatioChangeRate: number | null, salesOperatingProfitRatioChangeRate: number | null, netProfitRatioChangeRate: number | null, bsLiabilityNetAssetTotalChangeRate: number | null, before: { __typename?: 'CrSupplierFirmFinancialInfo', id: string, supplierFirmInfoConfirmationRequestId: string, isArchived: boolean, financialStatementPeriodFrom: any | null, financialStatementPeriodTo: any | null, bsAmountUnitKindLabel: string | null, plAmountUnitKindLabel: string | null, cfAmountUnitKindLabel: string | null, grossProfitMarginRatio: number | null, operatingProfitRatio: number | null, salesOperatingProfitRatio: number | null, netProfitRatio: number | null, grossProfitMarginRatioChangeRate: number | null, operatingProfitRatioChangeRate: number | null, salesOperatingProfitRatioChangeRate: number | null, netProfitRatioChangeRate: number | null, bsLiabilityNetAssetTotalChangeRate: number | null, currency: { __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean } } | null, currency: { __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean } };

export type CrSupplierFirmKeyPositionInfoFieldFragment = { __typename?: 'CrSupplierFirmKeyPositionInfo', id: string, isArchived: boolean, positionName: string | null, responsibilities: string | null, fullName: string | null, age: number | null, memo: string | null, nameKana: string | null, hasRepresentativeAuthority: boolean | null, birthDate: any | null, positionStartDate: any | null };

export type CrSupplierFirmKeyPositionInfoWithBeforeFieldFragment = { __typename?: 'CrSupplierFirmKeyPositionInfo', id: string, isArchived: boolean, positionName: string | null, responsibilities: string | null, fullName: string | null, age: number | null, memo: string | null, nameKana: string | null, hasRepresentativeAuthority: boolean | null, birthDate: any | null, positionStartDate: any | null, before: { __typename?: 'CrSupplierFirmKeyPositionInfo', id: string, isArchived: boolean, positionName: string | null, responsibilities: string | null, fullName: string | null, age: number | null, memo: string | null, nameKana: string | null, hasRepresentativeAuthority: boolean | null, birthDate: any | null, positionStartDate: any | null } | null };

export type CrSupplierFirmLaborSituationInfoFieldFragment = { __typename?: 'CrSupplierFirmLaborSituationInfo', id: string, annualWorkingDays: number | null, holidayType: string | null, averageOvertimePerPerson: number | null, attendanceRate: number | null, averageBasicSalary: number | null, averageAge: number | null, averageYearsOfService: number | null, memo: string | null, isArchived: boolean };

export type CrSupplierFirmLaborSituationInfoWithBeforeFieldFragment = { __typename?: 'CrSupplierFirmLaborSituationInfo', id: string, annualWorkingDays: number | null, holidayType: string | null, averageOvertimePerPerson: number | null, attendanceRate: number | null, averageBasicSalary: number | null, averageAge: number | null, averageYearsOfService: number | null, memo: string | null, isArchived: boolean, before: { __typename?: 'CrSupplierFirmLaborSituationInfo', id: string, annualWorkingDays: number | null, holidayType: string | null, averageOvertimePerPerson: number | null, attendanceRate: number | null, averageBasicSalary: number | null, averageAge: number | null, averageYearsOfService: number | null, memo: string | null, isArchived: boolean } | null };

export type CrSupplierFirmManufacturingSiteFieldFragment = { __typename?: 'CrSupplierFirmManufacturingSite', id: string, code: string | null, name: string, isArchived: boolean, tel: string | null, fax: string | null, landArea: number | null, landOwnershipKind: SupplierManufacturingSiteLandOwnershipKindEnum | null, buildingArea: number | null, buildingOwnershipKind: SupplierManufacturingSiteBuildingOwnershipKindEnum | null, president: string | null, capitalAmount: number | null, businessDescription: string | null, numberOfEmployees: number | null, establishedDate: any | null, overseasExpansionDate: any | null, investmentTypeName: string | null, investmentRatio: number | null, memo: string | null, partsMemo: string | null, numberOfEmployeesOther: number | null, investorName: string | null, investorName2: string | null, investmentRatio2: number | null, capitalCurrency: { __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean } | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null };

export type CrSupplierFirmManufacturingSiteWithBeforeFieldFragment = { __typename?: 'CrSupplierFirmManufacturingSite', id: string, code: string | null, name: string, isArchived: boolean, tel: string | null, fax: string | null, landArea: number | null, landOwnershipKind: SupplierManufacturingSiteLandOwnershipKindEnum | null, buildingArea: number | null, buildingOwnershipKind: SupplierManufacturingSiteBuildingOwnershipKindEnum | null, president: string | null, capitalAmount: number | null, businessDescription: string | null, numberOfEmployees: number | null, establishedDate: any | null, overseasExpansionDate: any | null, investmentTypeName: string | null, investmentRatio: number | null, memo: string | null, partsMemo: string | null, numberOfEmployeesOther: number | null, investorName: string | null, investorName2: string | null, investmentRatio2: number | null, before: { __typename?: 'CrSupplierFirmManufacturingSite', id: string, code: string | null, name: string, isArchived: boolean, tel: string | null, fax: string | null, landArea: number | null, landOwnershipKind: SupplierManufacturingSiteLandOwnershipKindEnum | null, buildingArea: number | null, buildingOwnershipKind: SupplierManufacturingSiteBuildingOwnershipKindEnum | null, president: string | null, capitalAmount: number | null, businessDescription: string | null, numberOfEmployees: number | null, establishedDate: any | null, overseasExpansionDate: any | null, investmentTypeName: string | null, investmentRatio: number | null, memo: string | null, partsMemo: string | null, numberOfEmployeesOther: number | null, investorName: string | null, investorName2: string | null, investmentRatio2: number | null, capitalCurrency: { __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean } | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null } | null, capitalCurrency: { __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean } | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null };

export type CrSupplierFirmMemberOrganizationFieldFragment = { __typename?: 'CrSupplierFirmMemberOrganization', id: string, isArchived: boolean, name: string | null, memo: string | null };

export type CrSupplierFirmMemberOrganizationWithBeforeFieldFragment = { __typename?: 'CrSupplierFirmMemberOrganization', id: string, isArchived: boolean, name: string | null, memo: string | null, before: { __typename?: 'CrSupplierFirmMemberOrganization', id: string, isArchived: boolean, name: string | null, memo: string | null } | null };

export type CrSupplierFirmOutsourcingInfoFieldFragment = { __typename?: 'CrSupplierFirmOutsourcingInfo', id: string, name: string, siteName: string | null, isArchived: boolean, factory: string | null, industry: string | null, numberOfEmployees: number | null, president: string | null, remarks: string | null, salesAmount: number | null, transactionAmount: number | null, transactionItem: string | null, purchaseRate: number | null, processingType: string | null, tenantDependencyRate: number | null, capitalAmount: number | null, certificationInfo: string | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null, crSupplierOutsourcingClassLinks: Array<{ __typename?: 'CrSupplierOutsourcingClassLink', id: string, supplierOutsourcingClass: { __typename?: 'SupplierOutsourcingClass', id: string, code: string | null, name: string, order: number, isArchived: boolean } }> };

export type CrSupplierFirmOutsourcingInfoWithBeforeFieldFragment = { __typename?: 'CrSupplierFirmOutsourcingInfo', id: string, name: string, siteName: string | null, isArchived: boolean, factory: string | null, industry: string | null, numberOfEmployees: number | null, president: string | null, remarks: string | null, salesAmount: number | null, transactionAmount: number | null, transactionItem: string | null, purchaseRate: number | null, processingType: string | null, tenantDependencyRate: number | null, capitalAmount: number | null, certificationInfo: string | null, before: { __typename?: 'CrSupplierFirmOutsourcingInfo', id: string, name: string, siteName: string | null, isArchived: boolean, factory: string | null, industry: string | null, numberOfEmployees: number | null, president: string | null, remarks: string | null, salesAmount: number | null, transactionAmount: number | null, transactionItem: string | null, purchaseRate: number | null, processingType: string | null, tenantDependencyRate: number | null, capitalAmount: number | null, certificationInfo: string | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null, crSupplierOutsourcingClassLinks: Array<{ __typename?: 'CrSupplierOutsourcingClassLink', id: string, supplierOutsourcingClass: { __typename?: 'SupplierOutsourcingClass', id: string, code: string | null, name: string, order: number, isArchived: boolean } }> } | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null, crSupplierOutsourcingClassLinks: Array<{ __typename?: 'CrSupplierOutsourcingClassLink', id: string, supplierOutsourcingClass: { __typename?: 'SupplierOutsourcingClass', id: string, code: string | null, name: string, order: number, isArchived: boolean } }> };

export type CrSupplierFirmRepresentativeInfoFieldFragment = { __typename?: 'CrSupplierFirmRepresentativeInfo', id: string, isArchived: boolean, name: string | null, nameKana: string | null, nameEn: string | null, position: string | null, biography: string | null, age: number | null, memo: string | null, isExistSuccessor: boolean | null, successorName: string | null, successorRelationship: string | null, successorAge: number | null, birthDate: any | null };

export type CrSupplierFirmRepresentativeInfoWithBeforeFieldFragment = { __typename?: 'CrSupplierFirmRepresentativeInfo', id: string, isArchived: boolean, name: string | null, nameKana: string | null, nameEn: string | null, position: string | null, biography: string | null, age: number | null, memo: string | null, isExistSuccessor: boolean | null, successorName: string | null, successorRelationship: string | null, successorAge: number | null, birthDate: any | null, before: { __typename?: 'CrSupplierFirmRepresentativeInfo', id: string, isArchived: boolean, name: string | null, nameKana: string | null, nameEn: string | null, position: string | null, biography: string | null, age: number | null, memo: string | null, isExistSuccessor: boolean | null, successorName: string | null, successorRelationship: string | null, successorAge: number | null, birthDate: any | null } | null };

export type CrSupplierFirmSalesStatusInfoFieldFragment = { __typename?: 'CrSupplierFirmSalesStatusInfo', id: string, isArchived: boolean, companyName: string | null, salesRatio: number | null, isTenantSales: boolean, salesAmount: number | null, memo: string | null, salesPartsMemo: string | null, hasTransactionToTenant: boolean | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null };

export type CrSupplierFirmSalesStatusInfoWithBeforeFieldFragment = { __typename?: 'CrSupplierFirmSalesStatusInfo', id: string, isArchived: boolean, companyName: string | null, salesRatio: number | null, isTenantSales: boolean, salesAmount: number | null, memo: string | null, salesPartsMemo: string | null, hasTransactionToTenant: boolean | null, before: { __typename?: 'CrSupplierFirmSalesStatusInfo', id: string, isArchived: boolean, companyName: string | null, salesRatio: number | null, isTenantSales: boolean, salesAmount: number | null, memo: string | null, salesPartsMemo: string | null, hasTransactionToTenant: boolean | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null } | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null };

export type CrSupplierFirmShareholderInfoFieldFragment = { __typename?: 'CrSupplierFirmShareholderInfo', id: string, isArchived: boolean, shareholderName: string | null, percentage: number | null, shareholding: number | null, memo: string | null };

export type CrSupplierFirmShareholderInfoWithBeforeFieldFragment = { __typename?: 'CrSupplierFirmShareholderInfo', id: string, isArchived: boolean, shareholderName: string | null, percentage: number | null, shareholding: number | null, memo: string | null, before: { __typename?: 'CrSupplierFirmShareholderInfo', id: string, isArchived: boolean, shareholderName: string | null, percentage: number | null, shareholding: number | null, memo: string | null } | null };

export type CrSupplierFirmSiteFieldFragment = { __typename?: 'CrSupplierFirmSite', id: string, code: string | null, name: string | null, isArchived: boolean, tel: string | null, fax: string | null, landArea: number | null, landOwnershipKind: SupplierSiteLandOwnershipKindEnum | null, buildingArea: number | null, buildingOwnershipKind: SupplierSiteBuildingOwnershipKindEnum | null, president: string | null, capitalAmount: number | null, businessDescription: string | null, numberOfEmployees: number | null, establishedDate: any | null, overseasExpansionDate: any | null, investmentTypeName: string | null, investmentRatio: number | null, memo: string | null, partsMemo: string | null, numberOfEmployeesOther: number | null, investorName: string | null, investorName2: string | null, investmentRatio2: number | null, capitalCurrency: { __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean } | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null };

export type CrSupplierFirmSiteWithBeforeFieldFragment = { __typename?: 'CrSupplierFirmSite', id: string, code: string | null, name: string | null, isArchived: boolean, tel: string | null, fax: string | null, landArea: number | null, landOwnershipKind: SupplierSiteLandOwnershipKindEnum | null, buildingArea: number | null, buildingOwnershipKind: SupplierSiteBuildingOwnershipKindEnum | null, president: string | null, capitalAmount: number | null, businessDescription: string | null, numberOfEmployees: number | null, establishedDate: any | null, overseasExpansionDate: any | null, investmentTypeName: string | null, investmentRatio: number | null, memo: string | null, partsMemo: string | null, numberOfEmployeesOther: number | null, investorName: string | null, investorName2: string | null, investmentRatio2: number | null, before: { __typename?: 'CrSupplierFirmSite', id: string, code: string | null, name: string | null, isArchived: boolean, tel: string | null, fax: string | null, landArea: number | null, landOwnershipKind: SupplierSiteLandOwnershipKindEnum | null, buildingArea: number | null, buildingOwnershipKind: SupplierSiteBuildingOwnershipKindEnum | null, president: string | null, capitalAmount: number | null, businessDescription: string | null, numberOfEmployees: number | null, establishedDate: any | null, overseasExpansionDate: any | null, investmentTypeName: string | null, investmentRatio: number | null, memo: string | null, partsMemo: string | null, numberOfEmployeesOther: number | null, investorName: string | null, investorName2: string | null, investmentRatio2: number | null, capitalCurrency: { __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean } | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null } | null, capitalCurrency: { __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean } | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null };

export type CrSupplierFirmSurveyEnqueteAnswerFieldFragment = { __typename?: 'CrSupplierFirmSurveyEnqueteAnswer', id: string, isArchived: boolean, supplierEnqueteAnswer: { __typename?: 'SupplierEnqueteAnswer', answerValue: string | null, isArchived: boolean | null, supplierEnqueteQuestionConfig: { __typename?: 'SupplierEnqueteQuestionConfig', name: string, code: string } } };

export type CrSupplierFirmSurveyEnqueteAnswerWithBeforeFieldFragment = { __typename?: 'CrSupplierFirmSurveyEnqueteAnswer', id: string, isArchived: boolean, before: { __typename?: 'CrSupplierFirmSurveyEnqueteAnswer', id: string, isArchived: boolean, supplierEnqueteAnswer: { __typename?: 'SupplierEnqueteAnswer', answerValue: string | null, isArchived: boolean | null, supplierEnqueteQuestionConfig: { __typename?: 'SupplierEnqueteQuestionConfig', name: string, code: string } } } | null, supplierEnqueteAnswer: { __typename?: 'SupplierEnqueteAnswer', answerValue: string | null, isArchived: boolean | null, supplierEnqueteQuestionConfig: { __typename?: 'SupplierEnqueteQuestionConfig', name: string, code: string } } };

export type CrSupplierFirmUserInfoFieldFragment = { __typename?: 'CrSupplierFirmUserInfo', id: string, beforeAfterKind: SupplierSurveyBeforeAfterKindEnum, name: string, nameKana: string | null, email: string, tel: string | null, fax: string | null, department: string | null, title: string | null, emailEmergency: string | null, telEmergency: string | null, mailingAddress: string | null, startOn: any | null, endOn: any | null, isArchived: boolean, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null, crContactClassLinks: Array<{ __typename?: 'CrContactClassLink', id: string, contactClass: { __typename?: 'ContactClass', id: string, code: string, name: string, order: number, isArchived: boolean } }> };

export type CrSupplierFirmUserInfoWithBeforeFieldFragment = { __typename?: 'CrSupplierFirmUserInfo', id: string, beforeAfterKind: SupplierSurveyBeforeAfterKindEnum, name: string, nameKana: string | null, email: string, tel: string | null, fax: string | null, department: string | null, title: string | null, emailEmergency: string | null, telEmergency: string | null, mailingAddress: string | null, startOn: any | null, endOn: any | null, isArchived: boolean, before: { __typename?: 'CrSupplierFirmUserInfo', id: string, beforeAfterKind: SupplierSurveyBeforeAfterKindEnum, name: string, nameKana: string | null, email: string, tel: string | null, fax: string | null, department: string | null, title: string | null, emailEmergency: string | null, telEmergency: string | null, mailingAddress: string | null, startOn: any | null, endOn: any | null, isArchived: boolean, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null, crContactClassLinks: Array<{ __typename?: 'CrContactClassLink', id: string, contactClass: { __typename?: 'ContactClass', id: string, code: string, name: string, order: number, isArchived: boolean } }> } | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null, crContactClassLinks: Array<{ __typename?: 'CrContactClassLink', id: string, contactClass: { __typename?: 'ContactClass', id: string, code: string, name: string, order: number, isArchived: boolean } }> };

export type CrSupplierFirmWithBeforeFieldFragment = { __typename?: 'CrSupplierFirm', id: string, beforeAfterKind: SupplierSurveyBeforeAfterKindEnum, name: string, nameShort: string | null, nameEn: string | null, nameKana: string | null, president: string | null, url: string | null, capital: number | null, tel: string | null, fax: string | null, email: string | null, establishedDate: any | null, startTransactionDate: any | null, numberOfEmployees: number | null, listingKind: SupplierListingKindEnum | null, closingMonth: SupplierClosingMonthEnum | null, issuedShares: number | null, dividendAmount: number | null, companyBackground: string | null, numberOfEmployeesOther: number | null, businessDescription: string | null, generalText1: string | null, generalText2: string | null, generalText3: string | null, generalText4: string | null, generalText5: string | null, generalText6: string | null, generalText7: string | null, generalText8: string | null, generalText9: string | null, generalText10: string | null, generalText11: string | null, generalText12: string | null, generalText13: string | null, generalText14: string | null, generalText15: string | null, generalText16: string | null, generalText17: string | null, generalText18: string | null, generalText19: string | null, generalText20: string | null, before: { __typename?: 'CrSupplierFirm', id: string, beforeAfterKind: SupplierSurveyBeforeAfterKindEnum, name: string, nameShort: string | null, nameEn: string | null, nameKana: string | null, president: string | null, url: string | null, capital: number | null, tel: string | null, fax: string | null, email: string | null, establishedDate: any | null, startTransactionDate: any | null, numberOfEmployees: number | null, listingKind: SupplierListingKindEnum | null, closingMonth: SupplierClosingMonthEnum | null, issuedShares: number | null, dividendAmount: number | null, companyBackground: string | null, numberOfEmployeesOther: number | null, businessDescription: string | null, generalText1: string | null, generalText2: string | null, generalText3: string | null, generalText4: string | null, generalText5: string | null, generalText6: string | null, generalText7: string | null, generalText8: string | null, generalText9: string | null, generalText10: string | null, generalText11: string | null, generalText12: string | null, generalText13: string | null, generalText14: string | null, generalText15: string | null, generalText16: string | null, generalText17: string | null, generalText18: string | null, generalText19: string | null, generalText20: string | null, capitalCurrency: { __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean } | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null, industry: { __typename?: 'Industry', id: string, code: string | null, name: string | null, order: number, isArchived: boolean } | null, generalKind1Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind2Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind3Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind4Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind5Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind6Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind7Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind8Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind9Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind10Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKinds1Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds2Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds3Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds4Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds5Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds6Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds7Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds8Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds9Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds10Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }> } | null, capitalCurrency: { __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean } | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null, industry: { __typename?: 'Industry', id: string, code: string | null, name: string | null, order: number, isArchived: boolean } | null, generalKind1Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind2Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind3Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind4Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind5Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind6Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind7Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind8Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind9Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind10Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKinds1Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds2Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds3Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds4Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds5Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds6Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds7Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds8Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds9Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds10Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }> };

export type CrSupplierOutsourcingClassLinkFieldFragment = { __typename?: 'CrSupplierOutsourcingClassLink', id: string, supplierOutsourcingClass: { __typename?: 'SupplierOutsourcingClass', id: string, code: string | null, name: string, order: number, isArchived: boolean } };

export type CsvExportResFieldFragment = { __typename?: 'CsvExportRes', errs: Array<string>, result: { __typename?: 'SupplierCsvExportResult', signedUrl: string | null } | null };

export type CurrencyFieldFragment = { __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean };

export type DeliveredAnnouncementFieldsFragment = { __typename?: 'DeliveredAnnouncement', id: string, confirmedAt: any | null, viewedAt: any | null, tenant: { __typename?: 'Tenant', name: string }, announcement: { __typename?: 'Announcement', body: string, confirmationDeadline: any | null, displayFrom: any, displayTo: any, id: string, priority: AnnouncementPriorityEnum, status: AnnouncementStatusEnum, title: string, tenantId: number, applicantUser: { __typename?: 'AdminUser', name: string }, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> } };

export type DeliverySiteFieldFragment = { __typename?: 'DeliverySite', id: string, name: string, code: string | null };

export type FacilityKindFieldFragment = { __typename?: 'FacilityKind', id: string, name: string, isUseMaker: boolean, isUseSpec: boolean, isUseLend: boolean, isUseAmortizationNumber: boolean, isUseAmortizationPeriod: boolean, isUsePart: boolean, isUseProcessing: boolean, isUseCavity: boolean, isUseLeadTime: boolean, isUseAmortizationPeriodAsYear: boolean, isUsePaymentTimingKind: boolean, isUseRecuttingCount: boolean };

export type IncompleteTaskFieldFragment = { __typename?: 'IncompleteTask', id: string, tenantId: string | null, tenantName: string, supplierCode: string | null, taskType: IncompleteTaskEnum, title: string, dueDate: any | null, delayed: boolean, isTrial: boolean, bulkAnswerPackageId: string | null };

export type IndustryFieldFragment = { __typename?: 'Industry', id: string, code: string | null, name: string | null, order: number, isArchived: boolean };

export type InputFormErrorFragment = { __typename?: 'InputFormError', formSchemaCode: string, dictKey: string, field: string, messages: Array<string>, seqNo: number | null };

export type ItemPropFieldFragment = { __typename?: 'ItemProp', id: string, name: string, code: string | null, unit: string | null, kind: ItemPropKind };

export type ItemPropInfoFieldFragment = { __typename?: 'ItemPropInfo', id: string, itemProppableType: string, itemProppableId: string, stringValue: string | null, numberValue: number | null, booleanValue: boolean | null, position: number, itemProp: { __typename?: 'ItemProp', id: string, name: string, code: string | null, unit: string | null, kind: ItemPropKind }, selectedOptions: Array<{ __typename?: 'ItemPropOption', id: string, label: string, position: number }> };

export type ItemRequirementFieldFragment = { __typename?: 'ItemRequirement', code: string | null, name: string, makerName: string | null, makerCode: string | null, makerModelNumber: string | null, figureNumber: string | null, rootPartCode: string | null, designChangeCode: string | null, itemPropInfosForSupplier: Array<{ __typename?: 'ItemPropInfo', id: string, itemProppableType: string, itemProppableId: string, stringValue: string | null, numberValue: number | null, booleanValue: boolean | null, position: number, itemProp: { __typename?: 'ItemProp', id: string, name: string, code: string | null, unit: string | null, kind: ItemPropKind }, selectedOptions: Array<{ __typename?: 'ItemPropOption', id: string, label: string, position: number }> }>, specAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, designAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> };

export type ItemToAnswerFieldFragment = { __typename?: 'ItemToAnswer', seq: number, quantity: number, quantityGroup: string, rootQuotationItemId: string, totalQuantityOnBranch: number, isDuplicate: boolean, quotationItemAssemblyEntity: { __typename?: 'QuotationItemAssemblyEntity', depth: number, numberCount: number, unitKind: string } | null, quotationItem: { __typename?: 'QuotationItemV2', id: string, isRoot: boolean, isNew: boolean | null, quantity: number | null, multiLot: Array<number>, quantityGroups: Array<string>, receiverCode: string | null, receiverName: string | null, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, makerName: string | null, makerCode: string | null, makerModelNumber: string | null, figureNumber: string | null, rootPartCode: string | null, designChangeCode: string | null, itemPropInfosForSupplier: Array<{ __typename?: 'ItemPropInfo', id: string, itemProppableType: string, itemProppableId: string, stringValue: string | null, numberValue: number | null, booleanValue: boolean | null, position: number, itemProp: { __typename?: 'ItemProp', id: string, name: string, code: string | null, unit: string | null, kind: ItemPropKind }, selectedOptions: Array<{ __typename?: 'ItemPropOption', id: string, label: string, position: number }> }>, specAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, designAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> }, quotationItemSelection: { __typename?: 'QuotationItemSelection', isSelected: boolean } | null, quotationItemSupplyParts: Array<{ __typename?: 'CommonSupplyPartInfo', id: string, name: string, code: string, supplyPartId: string | null, tenantId: string, unitPrice: number | null, specs: Array<{ __typename?: 'CommonSupplyPartSpec', id: string | null, code: string | null, name: string | null, unit: string | null, value: string | null }> | null }>, deliverySites: Array<{ __typename?: 'DeliverySite', id: string, name: string, code: string | null }>, tenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string } | null, products: Array<{ __typename?: 'Product', id: string, customerName: string | null, customerDevelopmentCode: string | null, name: string, code: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null, productScheduleGroups: Array<{ __typename?: 'ProductScheduleGroup', id: string, seqNo: number, productSchedules: Array<{ __typename?: 'ProductSchedule', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null }> }> }>, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, quotationItemSupplySubparts: Array<{ __typename?: 'CommonQuotationItemSupplySubpart', id: string, supplyPartName: string | null, partCode: string | null, rootPartCode: string | null, unitPrice: number, quantity: number, quantityDenominator: number, supplyPartCost: number }>, quotationItemMaterials: Array<{ __typename?: 'QuotationItemMaterial', id: string, baseMaterialCode: string | null, materialName: string, thickness: number | null, width: number | null, procurementKind: string | null, materialBasePrice: number | null, scrap1UnitPrice: number | null }>, project: { __typename?: 'Project', id: string, modelTitle: string | null, modelTypeName: string | null, modelYear: number | null, title: string, uid: string, projectSchedules: Array<{ __typename?: 'ProjectSchedule', id: string | null, eventName: string, eventOn: any | null, qualificationLevelName: string | null }>, projectModel: { __typename?: 'ProjectModel', id: string, deliverySiteName: string | null, manufacturingSiteName: string | null, productWeight: number | null, name: string | null, code: string | null, customerName: string | null, customerDevelopmentCode: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null } | null } | null, projectItem: { __typename?: 'ProjectItem', id: string, quantityPerRoot: number | null } | null, quotationItemChildStructs: Array<{ __typename?: 'QuotationItemChildStruct', id: string, level: number, parentId: string | null, quantityPerRoot: number, quotationRequestKind: QuotationRequestKindEnum, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, figureNumber: string | null } | null, tenantUnit: { __typename?: 'TenantUnit', id: string, name: string } }> }, answerPrice: { __typename?: 'AnswerPrice', id: string, quantity: number, quantityFrom: number, quantityTo: number | null, isDeclined: boolean, priceBasis: string, taxType: number, amountExcludingTax: string | null, amountIncludingTax: string | null, unitPrice: number | null, materialCost: number | null, partsCost: number | null, processingCost: number | null, surfaceProcessingCost: number | null, subsidiaryMaterialCost: number | null, materialManagementCost: number | null, materialManagementRate: number | null, processingManagementCost: number | null, processingManagementRate: number | null, managementCost: number | null, quantityInOneBox: number | null, deliveryCostPerBox: number | null, boxCount: number | null, deliveryCost: number | null, packingCostPerBox: number | null, packingCost: number | null, defectCost: number | null, defectRate: number | null, profit: number | null, adjustment: number | null, profitRate: number | null, depreciation: number | null, internalPartSubtotal: number | null, outSourcePartSubtotal: number | null, outSourcePartManagementRate: number | null, paidSupplyPartSubtotal: number | null, deliveryDay: number | null, initialDeliveryDay: number | null, materialDeliveryDay: number | null, materialDeliveryStartDay: number | null, equipmentDeliveryDay: number | null, equipmentDeliveryStartDay: number | null, moldDeliveryDay: number | null, moldDeliveryStartDay: number | null, trialDeliveryDay: number | null, trialDeliveryStartDay: number | null, facilityCost: number | null, jigManagementCost: number | null, propertyRentCost: number | null, designCost: number | null, subsidiaryMaterialManagementRate: number | null, subsidiaryMaterialManagementCost: number | null, quotationItemId: string, quotationItemChildStructId: string | null, answerPartsCosts: Array<{ __typename?: 'AnswerPartsCost', id: string, procurementKind: string | null, seqNo: number, partNo: string | null, partName: string | null, productionPlace: string | null, partSpec: string | null, partsCount: number | null, quantity: number | null, partsUnitPrice: number | null, memo: string | null, partsCost: number }>, answerProcessingCosts: Array<{ __typename?: 'AnswerProcessingCost', id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, memo: string | null, processingCost: number, rateKind: string | null, processingWeight: number | null, costForWeight: number | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostSubtotalPerLot: number | null, setupCostSubtotalPerLot: number | null, processingCostPerLot: number | null, partCostRatio: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSpecialProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerSurfaceProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerMaterialCosts: Array<{ __typename?: 'AnswerMaterialCost', id: string, seqNo: number, materialName: string, thickness: number | null, width: number | null, height: number | null, measure: string | null, weightBeforeProcess: number | null, weightAfterProcess: number | null, basePrice: number | null, adjustment: number | null, materialCostSubtotal: number | null, scrapValueSubtotal: number | null, materialCost: number, procurementKind: string | null, cavity: number | null, scrap1Name: string | null, scrap1Weight: number | null, scrap1UnitPrice: number | null, scrap1Subtotal: number | null, scrap2Name: string | null, scrap2Weight: number | null, scrap2UnitPrice: number | null, scrap2Subtotal: number | null, memo: string | null, baseMaterialCode: string | null, materialCostPerQty: number | null, scrap1SubtotalPerQty: number | null, scrap2SubtotalPerQty: number | null, scrapValueSubtotalPerQty: number | null, quantity: number | null, blendPrimaryMaterialName: string | null, blendPrimaryMaterialRatio: number | null, blendPrimaryMaterialUnitCost: number | null, blendSecondaryMaterialName: string | null, blendSecondaryMaterialRatio: number | null, blendSecondaryMaterialUnitCost: number | null, blendOtherMaterialName: string | null, blendOtherMaterialRatio: number | null, blendOtherMaterialUnitCost: number | null, blendBaseUnitCost: number | null, blendUnitCostMarkupRatio: number | null, lossPurgeLotCount: number | null, lossPurgeTotalWeight: number | null, lossPurgeUnitUsage: number | null, lossPurgeCost: number | null, lossGateUnitUsage: number | null, lossGateCost: number | null, lossRunnerUnitUsage: number | null, lossRunnerCost: number | null, lossOtherMemo: string | null, lossOtherUnitUsage: number | null, lossOtherCost: number | null, lossTotalUnitUsage: number | null, lossTotalCost: number | null, trialShotUnitUsage: number | null, trialShotCost: number | null, adjustmentCostMemo: string | null, adjustmentCost: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, priceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSubsidiaryMaterialCosts: Array<{ __typename?: 'CommonAnswerSubsidiaryMaterialCost', id: string, seqNo: number, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number, note: string | null, totalQuantity: number | null, totalSubsidiaryMaterialCost: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null }>, answerSupplySubparts: Array<{ __typename?: 'CommonAnswerSupplySubpart', id: string, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, quantity: number, quantityDenominator: number, unitPrice: number }> } | null };

export type ManufacturingSiteFieldFragment = { __typename?: 'ManufacturingSite', id: string, name: string, code: string | null };

export type MeFieldFragment = { __typename?: 'SupplierAccount', id: string, name: string, email: string, languageCode: string, supplierCorporation: { __typename?: 'SupplierCorporation', id: string, name: string } | null, supplierAccountTenantLinks: Array<{ __typename?: 'SupplierAccountTenantLink', id: string, tenant: { __typename?: 'Tenant', id: string, name: string }, corporation: { __typename?: 'SupplierCorporation', name: string } }>, selectedTenant: { __typename?: 'Tenant', id: string, name: string, code: string, inOperationScope: boolean, quotationConfig: { __typename?: 'QuotationConfig', isUseQuotationPackage: boolean, isUseTemporaryAnswer: boolean } | null } | null };

export type MoldFieldFragment = { __typename?: 'Mold', id: string, uid: string, tenantId: string, name: string, width: number | null, depth: number | null, height: number | null, weight: number | null, isNew: boolean | null, isPermanent: boolean | null, manageableId: string | null, manageableType: string | null, publicMemo: string | null, storageLocation: string | null, category: string | null, assetNumber: string | null, storageSymbol: string | null, status: string | null, evidenceComment: string | null, paymentEvidenceComment: string | null, storageEvidenceComment: string | null, disposeEvidenceComment: string | null, supplierDisposeReportComment: string | null, supplierDisposeReportedAt: any | null, employee: { __typename?: 'Employee', id: string, name: string }, supplier: { __typename?: 'Supplier', id: string, name: string, code: string, adminUser: { __typename?: 'AdminUser', id: string, name: string, employee: { __typename?: 'Employee', id: string, name: string } | null } | null }, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string } | null, manageable: { __typename?: 'MoldManageable', id: string, name: string, code: string } | null, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, paymentAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, storageAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, disposeAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierDisposeReportAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, moldStartUp: { __typename?: 'MoldStartUp', id: string, tenantId: string, moldId: string, quotedCost: number | null, acquisitionCost: number | null }, moldProduction: { __typename?: 'MoldProduction', id: string, tenantId: string, moldId: string, outputPerShot: number | null, shotCount: number | null, cumulativePartTransaction: number | null, remainingShotCount: number | null, flowTendency: number | null }, moldStorage: { __typename?: 'MoldStorage', id: string, tenantId: string, moldId: string, storageCost: number | null, retroactivePrice: number | null }, moldDispose: { __typename?: 'MoldDispose', id: string, tenantId: string, moldId: string, disposeCost: number | null, scrapCost: number | null, disposeRequestDate: any | null }, moldLifecycleEvent: { __typename?: 'MoldLifecycleEvent', id: string, tenantId: string, moldId: string, operationStartDate: any | null, inspectionReceiptDate: any | null, productionStartNotificationReceiptDate: any | null, quoteStatementReceiptDate: any | null, storageStartDate: any | null, disposeDate: any | null }, moldUsages: Array<{ __typename?: 'MoldUsage', id: string, moldId: string, targettableType: string | null, targettable: { __typename?: 'Part', id: string, name: string, code: string | null, figureNumber: string | null, rootPartCode: string | null, totalReceivedQuantity: number | null, flowTendency: string | null, partAnnualTotal: { __typename?: 'PartAnnualTotal', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number, quantity4: number, quantity5: number, quantity6: number, quantity7: number, quantity8: number, quantity9: number, quantity10: number, quantity11: number, quantity12: number } | null, partUnofficialAnnouncement: { __typename?: 'PartUnofficialAnnouncement', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number } | null, partTransactions: Array<{ __typename?: 'PartTransaction', id: string, tenantId: string, orderNumber: string | null, orderSeqNo: number | null, receivedOn: any | null, unitPrice: number, receivedQuantity: number, checkNumber: string | null, checkSeqNo: number | null, checkDate: any, subtotal: number, currencyRate: number, part: { __typename?: 'Part', id: string, name: string, code: string | null }, supplier: { __typename?: 'Supplier', id: string, name: string, isTemporary: boolean, code: string }, currency: { __typename?: 'Currency', isBaseCurrency: boolean, currencyCode: string }, toJpy: { __typename?: 'PartTransactionJpy', subtotal: number, unitPrice: number } }> | null } | null }> };

export type MoldCompactFieldFragment = { __typename?: 'Mold', id: string, uid: string, name: string, manageableId: string | null, manageableType: string | null, category: string | null, assetNumber: string | null, manageable: { __typename?: 'MoldManageable', id: string, name: string, code: string } | null, moldUsages: Array<{ __typename?: 'MoldUsage', id: string, moldId: string, targettableType: string | null, targettable: { __typename?: 'Part', id: string, name: string, code: string | null, figureNumber: string | null } | null }> };

export type MoldDisposalSupplierApplicationFieldFragment = { __typename?: 'MoldDisposalSupplierApplication', id: string, uid: string, title: string, status: number, applicationDate: any, confirmationDueDate: any, approvalDate: any | null, comment: string, remandComment: string | null, createdAt: any, updatedAt: any, supplier: { __typename?: 'Supplier', id: string, name: string, code: string }, employee: { __typename?: 'Employee', id: string, name: string }, tenant: { __typename?: 'Tenant', id: string, name: string, code: string }, supplierAccount: { __typename?: 'SupplierAccount', id: string, name: string } | null, supplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> | null, moldDisposalSupplierApplicationDetails: Array<{ __typename?: 'MoldDisposalSupplierApplicationDetail', id: string, disposeCost: number | null, disposeRequestDate: any | null, publicMemo: string | null, scrapCost: number | null, createdAt: any, updatedAt: any, mold: { __typename?: 'Mold', id: string, uid: string, tenantId: string, name: string, width: number | null, depth: number | null, height: number | null, weight: number | null, isNew: boolean | null, isPermanent: boolean | null, manageableId: string | null, manageableType: string | null, publicMemo: string | null, storageLocation: string | null, category: string | null, assetNumber: string | null, storageSymbol: string | null, status: string | null, evidenceComment: string | null, paymentEvidenceComment: string | null, storageEvidenceComment: string | null, disposeEvidenceComment: string | null, supplierDisposeReportComment: string | null, supplierDisposeReportedAt: any | null, employee: { __typename?: 'Employee', id: string, name: string }, supplier: { __typename?: 'Supplier', id: string, name: string, code: string, adminUser: { __typename?: 'AdminUser', id: string, name: string, employee: { __typename?: 'Employee', id: string, name: string } | null } | null }, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string } | null, manageable: { __typename?: 'MoldManageable', id: string, name: string, code: string } | null, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, paymentAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, storageAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, disposeAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierDisposeReportAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, moldStartUp: { __typename?: 'MoldStartUp', id: string, tenantId: string, moldId: string, quotedCost: number | null, acquisitionCost: number | null }, moldProduction: { __typename?: 'MoldProduction', id: string, tenantId: string, moldId: string, outputPerShot: number | null, shotCount: number | null, cumulativePartTransaction: number | null, remainingShotCount: number | null, flowTendency: number | null }, moldStorage: { __typename?: 'MoldStorage', id: string, tenantId: string, moldId: string, storageCost: number | null, retroactivePrice: number | null }, moldDispose: { __typename?: 'MoldDispose', id: string, tenantId: string, moldId: string, disposeCost: number | null, scrapCost: number | null, disposeRequestDate: any | null }, moldLifecycleEvent: { __typename?: 'MoldLifecycleEvent', id: string, tenantId: string, moldId: string, operationStartDate: any | null, inspectionReceiptDate: any | null, productionStartNotificationReceiptDate: any | null, quoteStatementReceiptDate: any | null, storageStartDate: any | null, disposeDate: any | null }, moldUsages: Array<{ __typename?: 'MoldUsage', id: string, moldId: string, targettableType: string | null, targettable: { __typename?: 'Part', id: string, name: string, code: string | null, figureNumber: string | null, rootPartCode: string | null, totalReceivedQuantity: number | null, flowTendency: string | null, partAnnualTotal: { __typename?: 'PartAnnualTotal', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number, quantity4: number, quantity5: number, quantity6: number, quantity7: number, quantity8: number, quantity9: number, quantity10: number, quantity11: number, quantity12: number } | null, partUnofficialAnnouncement: { __typename?: 'PartUnofficialAnnouncement', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number } | null, partTransactions: Array<{ __typename?: 'PartTransaction', id: string, tenantId: string, orderNumber: string | null, orderSeqNo: number | null, receivedOn: any | null, unitPrice: number, receivedQuantity: number, checkNumber: string | null, checkSeqNo: number | null, checkDate: any, subtotal: number, currencyRate: number, part: { __typename?: 'Part', id: string, name: string, code: string | null }, supplier: { __typename?: 'Supplier', id: string, name: string, isTemporary: boolean, code: string }, currency: { __typename?: 'Currency', isBaseCurrency: boolean, currencyCode: string }, toJpy: { __typename?: 'PartTransactionJpy', subtotal: number, unitPrice: number } }> | null } | null }> } }> | null };

export type MoldListFieldFragment = { __typename?: 'Mold', id: string, uid: string, tenantId: string, name: string, width: number | null, depth: number | null, height: number | null, weight: number | null, isNew: boolean | null, isPermanent: boolean | null, manageableId: string | null, manageableType: string | null, publicMemo: string | null, storageLocation: string | null, category: string | null, assetNumber: string | null, storageSymbol: string | null, employee: { __typename?: 'Employee', id: string, name: string }, supplier: { __typename?: 'Supplier', id: string, name: string, code: string }, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string } | null, moldStartUp: { __typename?: 'MoldStartUp', id: string, tenantId: string, moldId: string, quotedCost: number | null, acquisitionCost: number | null }, moldProduction: { __typename?: 'MoldProduction', id: string, tenantId: string, moldId: string, outputPerShot: number | null, shotCount: number | null, cumulativePartTransaction: number | null, remainingShotCount: number | null, flowTendency: number | null }, moldStorage: { __typename?: 'MoldStorage', id: string, tenantId: string, moldId: string, storageCost: number | null, retroactivePrice: number | null }, moldDispose: { __typename?: 'MoldDispose', id: string, tenantId: string, moldId: string, disposeCost: number | null, scrapCost: number | null, disposeRequestDate: any | null }, moldLifecycleEvent: { __typename?: 'MoldLifecycleEvent', id: string, tenantId: string, moldId: string, operationStartDate: any | null, inspectionReceiptDate: any | null, productionStartNotificationReceiptDate: any | null, quoteStatementReceiptDate: any | null, storageStartDate: any | null, disposeDate: any | null }, moldUsages: Array<{ __typename?: 'MoldUsage', id: string, moldId: string, targettableType: string | null, targettable: { __typename?: 'Part', id: string, code: string | null, name: string, figureNumber: string | null, totalReceivedQuantity: number | null } | null }> };

export type MoldPartFragment = { __typename?: 'Part', id: string, name: string, code: string | null, figureNumber: string | null, rootPartCode: string | null, totalReceivedQuantity: number | null, flowTendency: string | null, partAnnualTotal: { __typename?: 'PartAnnualTotal', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number, quantity4: number, quantity5: number, quantity6: number, quantity7: number, quantity8: number, quantity9: number, quantity10: number, quantity11: number, quantity12: number } | null, partUnofficialAnnouncement: { __typename?: 'PartUnofficialAnnouncement', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number } | null, partTransactions: Array<{ __typename?: 'PartTransaction', id: string, tenantId: string, orderNumber: string | null, orderSeqNo: number | null, receivedOn: any | null, unitPrice: number, receivedQuantity: number, checkNumber: string | null, checkSeqNo: number | null, checkDate: any, subtotal: number, currencyRate: number, part: { __typename?: 'Part', id: string, name: string, code: string | null }, supplier: { __typename?: 'Supplier', id: string, name: string, isTemporary: boolean, code: string }, currency: { __typename?: 'Currency', isBaseCurrency: boolean, currencyCode: string }, toJpy: { __typename?: 'PartTransactionJpy', subtotal: number, unitPrice: number } }> | null };

export type MoldStoragePaymentFieldFragment = { __typename?: 'MoldStoragePayment', id: string, uid: string, acceptanceDate: any, totalStorageCost: number, moldCount: number, supplier: { __typename?: 'Supplier', id: string, name: string, code: string }, tenant: { __typename?: 'Tenant', id: string, name: string, code: string }, moldStoragePaymentItems: Array<{ __typename?: 'MoldStoragePaymentItem', id: string, moldStoragePaymentId: string, storageStartDate: any, storageCost: number, mold: { __typename?: 'Mold', id: string, uid: string, name: string, manageableId: string | null, manageableType: string | null, category: string | null, assetNumber: string | null, manageable: { __typename?: 'MoldManageable', id: string, name: string, code: string } | null, moldUsages: Array<{ __typename?: 'MoldUsage', id: string, moldId: string, targettableType: string | null, targettable: { __typename?: 'Part', id: string, name: string, code: string | null, figureNumber: string | null } | null }> } }> };

export type MoldStoragePaymentItemFieldFragment = { __typename?: 'MoldStoragePaymentItem', id: string, moldStoragePaymentId: string, storageStartDate: any, storageCost: number, mold: { __typename?: 'Mold', id: string, uid: string, name: string, manageableId: string | null, manageableType: string | null, category: string | null, assetNumber: string | null, manageable: { __typename?: 'MoldManageable', id: string, name: string, code: string } | null, moldUsages: Array<{ __typename?: 'MoldUsage', id: string, moldId: string, targettableType: string | null, targettable: { __typename?: 'Part', id: string, name: string, code: string | null, figureNumber: string | null } | null }> } };

export type PageInfoFieldFragment = { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null };

export type PartFieldFragment = { __typename?: 'Part', id: string, code: string | null, displayCode: string, figureNumber: string | null, receiverCode: string | null, receiverName: string | null, name: string, isAdjustable: boolean, rootPartCode: string | null, isNotEnd: boolean, isNew: boolean | null, deliverySiteObjects: Array<{ __typename?: 'DeliverySite', id: string, name: string }>, oneAnswerFormat: { __typename?: 'AnswerFormat', id: string, isUseMaterialCost: boolean, isUseMaterialCostDetail: boolean, isUseMaterialSize: boolean, isUseMaterialScrap: boolean, isUseMaterialCostProcurementKind: boolean, isUseMaterialCostCavity: boolean, isUseMaterialCostAdjustment: boolean, isUseMaterialCostMemo: boolean, isUseMaterialCostThickness: boolean, isUseMaterialCostWidth: boolean, isUseMaterialCostHeight: boolean, isUseMaterialCostMeasure: boolean, isUseMaterialCostWeightBeforeProcess: boolean, isUseMaterialCostWeightAfterProcess: boolean, isUseMaterialCostBasePrice: boolean, isUsePartsCost: boolean, isUsePartsCostDetail: boolean, isUsePartsCostProcurementKind: boolean, isUsePartsCostPartNo: boolean, isUsePartsCostPartName: boolean, isUsePartsCostProductionPlace: boolean, isUsePartsCostQuantity: boolean, isUsePartsCostPartsUnitPrice: boolean, isUsePartsCostMemo: boolean, isUsePartsCostPartSpec: boolean, isUsePartsCostPartsCount: boolean, isUseProcessingCost: boolean, isUseProcessingCostDetail: boolean, isUseProcessingCostProductionLot: boolean, isUseProcessingCostEquipmentName: boolean, isUseProcessingCostProcessingTimeHour: boolean, isUseProcessingCostProcessingTimeMinute: boolean, isUseProcessingCostProcessingTimeSecond: boolean, isUseProcessingCostProcessingRate: boolean, isUseSetupInformation: boolean, isUseProcessingCostProcessingTimes: boolean, isUseProcessingCostSetupTimeHour: boolean, isUseProcessingCostSetupTimeMinute: boolean, isUseProcessingCostSetupTimeSecond: boolean, isUseProcessingCostSetupRate: boolean, isUseProcessingCostProcessingCostSubtotal: boolean, isUseProcessingCostSetupCostSubtotal: boolean, isUseProcessingCostMemo: boolean, processingCostRateKind: string | null, isUseManagementCost: boolean, isUseMaterialManagementRate: boolean, isUseMaterialManagementCost: boolean, isUseProcessingManagementRate: boolean, isUseProcessingManagementCost: boolean, isUseDeliveryCost: boolean, isUseDeliveryBoxInformation: boolean, isUsePackingCost: boolean, isUsePackingBoxInformation: boolean, isUseDefectCost: boolean, isUseDefectRate: boolean, isUseProfit: boolean, isUseProfitRate: boolean, isUseAdjustment: boolean, isUseDepreciation: boolean, isUseInternalPartSubtotal: boolean, isUseOutSourcePartSubtotal: boolean, isUseOutSourcePartManagementRate: boolean, isUsePaidSupplyPartSubtotal: boolean, isUseInitialDeliveryDay: boolean, isUseMaterialDeliveryDay: boolean, isUseEquipmentDeliveryDay: boolean, isUseMoldDeliveryDay: boolean, isUseTrialDeliveryDay: boolean, isUseDeliveryDay: boolean, isUseGanttForDeliveryDay: boolean, isUseSurfaceProcessingCost: boolean, isUseSubsidiaryMaterialCost: boolean, isUseSubsidiaryMaterialCostDetail: boolean, isSetScrapName: boolean, scrap1Name: string | null, scrap2Name: string | null, isUseCurrencyExchangeNote: boolean, isUseAnswerByItem: boolean, isUseMinimumOrderQuantity: boolean, isUseDeliveryForm: boolean, isUseQuantityPerDeliveryForm: boolean, isUsePriceEffectiveDate: boolean, priceRegistrationFormatId: string | null, answerMethod: string, isUseProcessingWeight: boolean, isUseCostForWeight: boolean, isUseProcessingHeadcount: boolean, calculationKind: string, isUseWholesalerKnowledge: boolean, useMakerActualPartName: string, makerActualPartNameHelperTxt: string | null, materialCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, materialCostPriceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, specialProcessingDetailFormatsList: Array<{ __typename?: 'CommonSpecialProcessingDetailFormat', kind: string, kindLabel: string, isUseProductionLot: boolean, isUseEquipmentName: boolean, isUseProcessingTimeHour: boolean, isUseProcessingTimeMinute: boolean, isUseProcessingTimeSecond: boolean, isUseProcessingRate: boolean, isUseSetupInformation: boolean, isUseSetupTimeHour: boolean, isUseSetupTimeMinute: boolean, isUseSetupTimeSecond: boolean, isUseSetupRate: boolean, isUseMemo: boolean, isUseProcessingTimes: boolean, isUseProcessingCostSubtotal: boolean, isUseSetupCostSubtotal: boolean, rateKind: string | null }>, processingCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, facilityKinds: Array<{ __typename?: 'FacilityKind', id: string, code: string | null, name: string }> }, partAttachmentDesign: { __typename?: 'PartAttachment', partAttachmentKind: string, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> } | null, partAttachmentSpec: { __typename?: 'PartAttachment', partAttachmentKind: string, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> } | null, supplyPartInfo: { __typename?: 'CommonSupplyPartInfo', id: string, name: string, code: string, supplyPartId: string | null, tenantId: string, unitPrice: number | null, specs: Array<{ __typename?: 'CommonSupplyPartSpec', id: string | null, code: string | null, name: string | null, unit: string | null, value: string | null }> | null } | null, deliverySites: Array<{ __typename?: 'DeliverySite', id: string, name: string, code: string | null }>, quotaionDesignAttachments: Array<{ __typename?: 'QuotationAttachment', quotationAttachmentKind: string, quotationItemIds: Array<string>, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> }>, quotaionSpecAttachments: Array<{ __typename?: 'QuotationAttachment', quotationAttachmentKind: string, quotationItemIds: Array<string>, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> }>, sameGroupParts: Array<{ __typename?: 'Part', id: string, code: string | null, name: string }> };

export type PartAnnualTotalFieldFragment = { __typename?: 'PartAnnualTotal', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number, quantity4: number, quantity5: number, quantity6: number, quantity7: number, quantity8: number, quantity9: number, quantity10: number, quantity11: number, quantity12: number };

export type PartAttachmentFieldFragment = { __typename?: 'PartAttachment', partAttachmentKind: string, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> };

export type PartListFieldFragment = { __typename?: 'PartList', id: string, code: string | null, displayCode: string, rootPartCode: string | null, receiverCode: string | null, receiverName: string | null, name: string, isAdjustable: boolean, figureNumber: string | null, latestOrderUnitPrices: Array<{ __typename?: 'PartOrderUnitPrice', quantity: number, unitPrice: number, startOn: any, endOn: any | null, id: string, supplier: { __typename?: 'Supplier', id: string, code: string, name: string }, currency: { __typename?: 'Currency', currencyCode: string } | null, tenantUnit: { __typename?: 'TenantUnit', name: string } | null, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', name: string } | null }>, tenant: { __typename?: 'Tenant', id: string, name: string } };

export type PartMaterialPriceFieldsFragment = { __typename?: 'PartMaterialPrice', id: string, initialCost: number | null, reservedWeight: number | null, productWeight: number | null, scrapWeight: number | null, startOn: any | null, startUpMonth: any | null, variation: number | null, measure: string | null, materialName: string | null, materialUnitPrice: number | null, materialCostPerQty: number | null, materialCost: number | null, scrapUnitPrice: number | null, scrapSubtotal: number | null, procurementKind: string | null, quantity: number | null, baseMaterial: { __typename?: 'BaseMaterial', id: string, code: string, name: string } | null, weightTenantUnit: { __typename?: 'TenantUnit', unitCode: string, name: string } | null };

export type PartOrderUnitPriceFieldFragment = { __typename?: 'PartOrderUnitPrice', id: string, unitPrice: number, quantity: number, startOn: any, endOn: any | null, isExpired: boolean, ifKey1: string | null, ifKey2: string | null, currency: { __typename?: 'Currency', id: string, displayName: string, currencyCode: string, decimalPrecision: number } | null, tenantUnit: { __typename?: 'TenantUnit', unitCode: string, name: string } | null, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, part: { __typename?: 'Part', id: string, displayCode: string, name: string, figureNumber: string | null } };

export type PartOrderUnitPriceForListFieldFragment = { __typename?: 'PartOrderUnitPriceForList', id: string, unitPrice: number, startOn: any, ifKey1: string | null, ifKey2: string | null, cancelStatusKind: string | null, part: { __typename?: 'Part', id: string, code: string | null, name: string, rootPartCode: string | null, isEnd: boolean }, supplier: { __typename?: 'Supplier', id: string, code: string, name: string }, manufacturingSite: { __typename?: 'ManufacturingSite', id: string, name: string, code: string | null } | null, partReasons: Array<{ __typename?: 'PartReason', id: string | null, priceDifference: number | null, sequence: number | null, priceChangeReason: { __typename?: 'PriceChangeReason', id: string, reason: string, code: string, sequence: number } }> };

export type PartReasonFieldFragment = { __typename?: 'PartReason', id: string | null, priceDifference: number | null, sequence: number | null, priceChangeReason: { __typename?: 'PriceChangeReason', id: string, reason: string, code: string, sequence: number } };

export type PartSearchModalFieldFragment = { __typename?: 'Part', id: string, code: string | null, name: string, rootPartCode: string | null };

export type PartSupplyPriceFieldFragment = { __typename?: 'PartSupplyPrice', id: string | null, assignmentPriceKind: PartSupplyPriceAssignmentPriceKindEnum, assignmentPrice: number | null, startOn: any, endOn: any | null, supplier: { __typename?: 'Supplier', id: string, code: string, name: string }, tenant: { __typename?: 'Tenant', name: string }, tenantUnit: { __typename?: 'TenantUnit', name: string } | null, part: { __typename?: 'Part', displayCode: string, name: string, figureNumber: string | null, id: string } };

export type PartTransactionFieldFragment = { __typename?: 'PartTransaction', id: string, tenantId: string, orderNumber: string | null, orderSeqNo: number | null, receivedOn: any | null, unitPrice: number, receivedQuantity: number, checkNumber: string | null, checkSeqNo: number | null, checkDate: any, subtotal: number, currencyRate: number, part: { __typename?: 'Part', id: string, name: string, code: string | null }, supplier: { __typename?: 'Supplier', id: string, name: string, isTemporary: boolean, code: string }, currency: { __typename?: 'Currency', isBaseCurrency: boolean, currencyCode: string }, toJpy: { __typename?: 'PartTransactionJpy', subtotal: number, unitPrice: number } };

export type PartUnofficialAnnouncementFieldFragment = { __typename?: 'PartUnofficialAnnouncement', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number };

export type PriceAdjustmentFieldFragment = { __typename?: 'PriceAdjustment', id: string, tenantId: string, tenantCode: string, supplierCode: string, adjustmentPurpose: string, applicantKind: string, targetTerm: string, confirmationStartDate: any | null, confirmationDeadlineDate: any | null, priceEffectiveDate: any | null, priceExpirationDate: any | null, memo: string, supplier: { __typename?: 'Supplier', id: string, name: string, displayCode: string }, inChargeAdminUser: { __typename?: 'AdminUser', id: string, name: string } | null, inChargeSupplierAccount: { __typename?: 'SupplierAccount', id: string, name: string } | null, inChargeSupplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null, supplierAccounts: Array<{ __typename?: 'SupplierAccount', id: string, name: string }>, supplierUsers: Array<{ __typename?: 'SupplierUser', id: string, name: string }> | null, currentEvent: { __typename?: 'PriceAdjustmentEvent', id: string, eventKind: string, memo: string | null, triggeredByType: string, createdAt: any, confirmationStatusName: string, confirmationStatusValue: number, adjustmentStatusName: string, actionName: string, triggeredBy:
      | { __typename?: 'AdminUser', id: string, name: string }
      | { __typename?: 'SupplierAccount', id: string, name: string }
      | { __typename?: 'SupplierUser', id: string, name: string }
     }, currentAsking: { __typename?: 'PriceAdjustmentEvent', id: string, eventKind: string, memo: string | null, triggeredByType: string, createdAt: any, confirmationStatusName: string, confirmationStatusValue: number, adjustmentStatusName: string, actionName: string, triggeredBy:
      | { __typename?: 'AdminUser', id: string, name: string }
      | { __typename?: 'SupplierAccount', id: string, name: string }
      | { __typename?: 'SupplierUser', id: string, name: string }
     } | null, tenant: { __typename?: 'Tenant', id: string, name: string }, priceAdjustmentItems: Array<{ __typename?: 'PriceAdjustmentItem', id: string, partOrderUnitPrice: { __typename?: 'PartOrderUnitPrice', id: string, part: { __typename?: 'Part', id: string, name: string, code: string | null, rootPartCode: string | null } } | null }> | null };

export type PriceAdjustmentDetailFieldFragment = { __typename?: 'PriceAdjustmentDetail', id: string, tenantId: string, tenantCode: string, supplierCode: string, targetTerm: string, adjustmentPurpose: string | null, applicantKind: string, confirmationStartDate: any | null, confirmationDeadlineDate: any | null, priceEffectiveDate: any | null, priceExpirationDate: any | null, adjustmentKind: PriceAdjustmentAdjustmentKindEnum, memo: string, isSupplierEditable: boolean, isItemDeletable: boolean, tenant: { __typename?: 'Tenant', id: string, name: string }, supplier: { __typename?: 'Supplier', id: string, name: string, code: string, displayCode: string, supplierFirmId: string | null }, answerFormat: { __typename?: 'AnswerFormat', id: string, isUseMaterialCost: boolean, isUseMaterialCostDetail: boolean, isUseMaterialSize: boolean, isUseMaterialScrap: boolean, isUseMaterialCostProcurementKind: boolean, isUseMaterialCostCavity: boolean, isUseMaterialCostAdjustment: boolean, isUseMaterialCostMemo: boolean, isUseMaterialCostThickness: boolean, isUseMaterialCostWidth: boolean, isUseMaterialCostHeight: boolean, isUseMaterialCostMeasure: boolean, isUseMaterialCostWeightBeforeProcess: boolean, isUseMaterialCostWeightAfterProcess: boolean, isUseMaterialCostBasePrice: boolean, isUsePartsCost: boolean, isUsePartsCostDetail: boolean, isUsePartsCostProcurementKind: boolean, isUsePartsCostPartNo: boolean, isUsePartsCostPartName: boolean, isUsePartsCostProductionPlace: boolean, isUsePartsCostQuantity: boolean, isUsePartsCostPartsUnitPrice: boolean, isUsePartsCostMemo: boolean, isUsePartsCostPartSpec: boolean, isUsePartsCostPartsCount: boolean, isUseProcessingCost: boolean, isUseProcessingCostDetail: boolean, isUseProcessingCostProductionLot: boolean, isUseProcessingCostEquipmentName: boolean, isUseProcessingCostProcessingTimeHour: boolean, isUseProcessingCostProcessingTimeMinute: boolean, isUseProcessingCostProcessingTimeSecond: boolean, isUseProcessingCostProcessingRate: boolean, isUseSetupInformation: boolean, isUseProcessingCostProcessingTimes: boolean, isUseProcessingCostSetupTimeHour: boolean, isUseProcessingCostSetupTimeMinute: boolean, isUseProcessingCostSetupTimeSecond: boolean, isUseProcessingCostSetupRate: boolean, isUseProcessingCostProcessingCostSubtotal: boolean, isUseProcessingCostSetupCostSubtotal: boolean, isUseProcessingCostMemo: boolean, processingCostRateKind: string | null, isUseManagementCost: boolean, isUseMaterialManagementRate: boolean, isUseMaterialManagementCost: boolean, isUseProcessingManagementRate: boolean, isUseProcessingManagementCost: boolean, isUseDeliveryCost: boolean, isUseDeliveryBoxInformation: boolean, isUsePackingCost: boolean, isUsePackingBoxInformation: boolean, isUseDefectCost: boolean, isUseDefectRate: boolean, isUseProfit: boolean, isUseProfitRate: boolean, isUseAdjustment: boolean, isUseDepreciation: boolean, isUseInternalPartSubtotal: boolean, isUseOutSourcePartSubtotal: boolean, isUseOutSourcePartManagementRate: boolean, isUsePaidSupplyPartSubtotal: boolean, isUseInitialDeliveryDay: boolean, isUseMaterialDeliveryDay: boolean, isUseEquipmentDeliveryDay: boolean, isUseMoldDeliveryDay: boolean, isUseTrialDeliveryDay: boolean, isUseDeliveryDay: boolean, isUseGanttForDeliveryDay: boolean, isUseSurfaceProcessingCost: boolean, isUseSubsidiaryMaterialCost: boolean, isUseSubsidiaryMaterialCostDetail: boolean, isSetScrapName: boolean, scrap1Name: string | null, scrap2Name: string | null, isUseCurrencyExchangeNote: boolean, isUseAnswerByItem: boolean, isUseMinimumOrderQuantity: boolean, isUseDeliveryForm: boolean, isUseQuantityPerDeliveryForm: boolean, isUsePriceEffectiveDate: boolean, priceRegistrationFormatId: string | null, answerMethod: string, isUseProcessingWeight: boolean, isUseCostForWeight: boolean, isUseProcessingHeadcount: boolean, calculationKind: string, isUseWholesalerKnowledge: boolean, useMakerActualPartName: string, makerActualPartNameHelperTxt: string | null, materialCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, materialCostPriceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, specialProcessingDetailFormatsList: Array<{ __typename?: 'CommonSpecialProcessingDetailFormat', kind: string, kindLabel: string, isUseProductionLot: boolean, isUseEquipmentName: boolean, isUseProcessingTimeHour: boolean, isUseProcessingTimeMinute: boolean, isUseProcessingTimeSecond: boolean, isUseProcessingRate: boolean, isUseSetupInformation: boolean, isUseSetupTimeHour: boolean, isUseSetupTimeMinute: boolean, isUseSetupTimeSecond: boolean, isUseSetupRate: boolean, isUseMemo: boolean, isUseProcessingTimes: boolean, isUseProcessingCostSubtotal: boolean, isUseSetupCostSubtotal: boolean, rateKind: string | null }>, processingCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, facilityKinds: Array<{ __typename?: 'FacilityKind', id: string, code: string | null, name: string }> } | null, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierCorporationAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, inChargeAdminUser: { __typename?: 'AdminUser', id: string, name: string, email: string, adminUserGroups: Array<{ __typename?: 'AdminUserGroup', id: string, name: string }> | null } | null, inChargeSupplierAccount: { __typename?: 'SupplierAccount', id: string, name: string } | null, inChargeSupplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null, supplierAccounts: Array<{ __typename?: 'SupplierAccount', id: string, name: string }>, supplierUsers: Array<{ __typename?: 'SupplierUser', id: string, name: string }> | null, currentEvent: { __typename?: 'PriceAdjustmentEvent', id: string, eventKind: string, memo: string | null, triggeredByType: string, createdAt: any, confirmationStatusName: string, confirmationStatusValue: number, adjustmentStatusName: string, actionName: string, triggeredBy:
      | { __typename?: 'AdminUser', id: string, name: string }
      | { __typename?: 'SupplierAccount', id: string, name: string }
      | { __typename?: 'SupplierUser', id: string, name: string }
     }, currentAsking: { __typename?: 'PriceAdjustmentEvent', id: string, eventKind: string, memo: string | null, triggeredByType: string, createdAt: any, confirmationStatusName: string, confirmationStatusValue: number, adjustmentStatusName: string, actionName: string, triggeredBy:
      | { __typename?: 'AdminUser', id: string, name: string }
      | { __typename?: 'SupplierAccount', id: string, name: string }
      | { __typename?: 'SupplierUser', id: string, name: string }
     } | null, completeEvent: { __typename?: 'PriceAdjustmentEvent', id: string, eventKind: string, memo: string | null, triggeredByType: string, createdAt: any, confirmationStatusName: string, confirmationStatusValue: number, adjustmentStatusName: string, actionName: string, triggeredBy:
      | { __typename?: 'AdminUser', id: string, name: string }
      | { __typename?: 'SupplierAccount', id: string, name: string }
      | { __typename?: 'SupplierUser', id: string, name: string }
     } | null, priceAdjustmentItems: Array<{ __typename?: 'PriceAdjustmentItem', id: string, tenantId: string, quantity: number, memo: string | null, tenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string } | null, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, part: { __typename?: 'Part', id: string, name: string, displayCode: string, rootPartCode: string | null, sameGroupParts: Array<{ __typename?: 'Part', name: string, displayCode: string }> }, newDetail: { __typename?: 'PriceAdjustmentItemDetail', id: string, tenantId: string, kind: string, unitPrice: number | null, materialCost: number | null, processingCost: number | null, otherCost: number | null, supplyPartPrice: number | null, scrapPrice: number | null, memo: string, notSupplyPartSubtotal: number | null, subsidiaryMaterialCost: number | null, propertyRentCost: number | null, paidSupplyPartSubtotal: number | null, facilityCost: number | null, facilityAmortizationCost: number | null, amortizationCost: number | null, jigManagementCost: number | null, netUnitPrice: number | null, materialCostNotSupplySubtotal: number | null, materialCostSupplySubtotal: number | null, materialManagementCost: number | null, partsCost: number | null, deliveryCost: number | null, managementCost: number | null, processingPriceSubtotal: number | null, manufacturingSite: { __typename?: 'ManufacturingSite', code: string | null, name: string } | null } | null, oldDetail: { __typename?: 'PriceAdjustmentItemDetail', id: string, tenantId: string, kind: string, unitPrice: number | null, materialCost: number | null, processingCost: number | null, otherCost: number | null, supplyPartPrice: number | null, scrapPrice: number | null, memo: string, notSupplyPartSubtotal: number | null, subsidiaryMaterialCost: number | null, propertyRentCost: number | null, paidSupplyPartSubtotal: number | null, facilityCost: number | null, facilityAmortizationCost: number | null, amortizationCost: number | null, jigManagementCost: number | null, netUnitPrice: number | null, materialCostNotSupplySubtotal: number | null, materialCostSupplySubtotal: number | null, materialManagementCost: number | null, partsCost: number | null, deliveryCost: number | null, managementCost: number | null, processingPriceSubtotal: number | null, manufacturingSite: { __typename?: 'ManufacturingSite', code: string | null, name: string } | null } | null, latestAskingDetail: { __typename?: 'PriceAdjustmentItemDetail', id: string, tenantId: string, kind: string, unitPrice: number | null, materialCost: number | null, processingCost: number | null, otherCost: number | null, supplyPartPrice: number | null, scrapPrice: number | null, memo: string, notSupplyPartSubtotal: number | null, subsidiaryMaterialCost: number | null, propertyRentCost: number | null, paidSupplyPartSubtotal: number | null, facilityCost: number | null, facilityAmortizationCost: number | null, amortizationCost: number | null, jigManagementCost: number | null, netUnitPrice: number | null, materialCostNotSupplySubtotal: number | null, materialCostSupplySubtotal: number | null, materialManagementCost: number | null, partsCost: number | null, deliveryCost: number | null, managementCost: number | null, processingPriceSubtotal: number | null, manufacturingSite: { __typename?: 'ManufacturingSite', code: string | null, name: string } | null } | null, priceChangeReasons: Array<{ __typename?: 'PriceChangeReason', id: string, tenantId: string, code: string, reason: string, sequence: number }> | null, reasonSnapshots: Array<{ __typename?: 'PriceAdjustmentItemPriceChangeReason', id: string, tenantId: string, code: string, reason: string, sequence: number, priceChangeReasonId: string, priceDifference: number | null }> | null, partOrderUnitPrice: { __typename?: 'PartOrderUnitPrice', id: string, unitPrice: number, ifKey1: string | null, ifKey2: string | null, tenantUnit: { __typename?: 'TenantUnit', unitCode: string, name: string } | null, tenant: { __typename?: 'Tenant', id: string, name: string, code: string } | null, supplier: { __typename?: 'Supplier', id: string, name: string, code: string, displayCode: string, isEligibleToSubcontractAct: boolean }, currency: { __typename?: 'Currency', currencyCode: string, decimalPrecision: number, displayName: string } | null, itemRequirement: { __typename?: 'ItemRequirement', designChangeCode: string | null } | null } | null }> | null, priceAdjustmentSetting: { __typename?: 'PriceAdjustmentSetting', id: string, tenantId: string, reasonCount: number, isUseMaterialPriceAdjustment: boolean | null, isUsePriceAdjustmentFormEdit: boolean, materialPriceAdjustmentTargetKind: PriceAdjustmentSettingMaterialPriceAdjustmentTargetKindEnum }, priceAdjustmentEvents: Array<{ __typename?: 'PriceAdjustmentEvent', id: string, eventKind: string, memo: string | null, triggeredByType: string, createdAt: any, confirmationStatusName: string, confirmationStatusValue: number, adjustmentStatusName: string, actionName: string, triggeredBy:
      | { __typename?: 'AdminUser', id: string, name: string }
      | { __typename?: 'SupplierAccount', id: string, name: string }
      | { __typename?: 'SupplierUser', id: string, name: string }
     }> };

export type PriceAdjustmentEventFieldFragment = { __typename?: 'PriceAdjustmentEvent', id: string, eventKind: string, memo: string | null, triggeredByType: string, createdAt: any, confirmationStatusName: string, confirmationStatusValue: number, adjustmentStatusName: string, actionName: string, triggeredBy:
    | { __typename?: 'AdminUser', id: string, name: string }
    | { __typename?: 'SupplierAccount', id: string, name: string }
    | { __typename?: 'SupplierUser', id: string, name: string }
   };

export type PriceAdjustmentItemFieldFragment = { __typename?: 'PriceAdjustmentItem', id: string, tenantId: string, quantity: number, memo: string | null, tenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string } | null, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, part: { __typename?: 'Part', id: string, name: string, displayCode: string, rootPartCode: string | null, sameGroupParts: Array<{ __typename?: 'Part', name: string, displayCode: string }> }, newDetail: { __typename?: 'PriceAdjustmentItemDetail', id: string, tenantId: string, kind: string, unitPrice: number | null, materialCost: number | null, processingCost: number | null, otherCost: number | null, supplyPartPrice: number | null, scrapPrice: number | null, memo: string, notSupplyPartSubtotal: number | null, subsidiaryMaterialCost: number | null, propertyRentCost: number | null, paidSupplyPartSubtotal: number | null, facilityCost: number | null, facilityAmortizationCost: number | null, amortizationCost: number | null, jigManagementCost: number | null, netUnitPrice: number | null, materialCostNotSupplySubtotal: number | null, materialCostSupplySubtotal: number | null, materialManagementCost: number | null, partsCost: number | null, deliveryCost: number | null, managementCost: number | null, processingPriceSubtotal: number | null, manufacturingSite: { __typename?: 'ManufacturingSite', code: string | null, name: string } | null } | null, oldDetail: { __typename?: 'PriceAdjustmentItemDetail', id: string, tenantId: string, kind: string, unitPrice: number | null, materialCost: number | null, processingCost: number | null, otherCost: number | null, supplyPartPrice: number | null, scrapPrice: number | null, memo: string, notSupplyPartSubtotal: number | null, subsidiaryMaterialCost: number | null, propertyRentCost: number | null, paidSupplyPartSubtotal: number | null, facilityCost: number | null, facilityAmortizationCost: number | null, amortizationCost: number | null, jigManagementCost: number | null, netUnitPrice: number | null, materialCostNotSupplySubtotal: number | null, materialCostSupplySubtotal: number | null, materialManagementCost: number | null, partsCost: number | null, deliveryCost: number | null, managementCost: number | null, processingPriceSubtotal: number | null, manufacturingSite: { __typename?: 'ManufacturingSite', code: string | null, name: string } | null } | null, latestAskingDetail: { __typename?: 'PriceAdjustmentItemDetail', id: string, tenantId: string, kind: string, unitPrice: number | null, materialCost: number | null, processingCost: number | null, otherCost: number | null, supplyPartPrice: number | null, scrapPrice: number | null, memo: string, notSupplyPartSubtotal: number | null, subsidiaryMaterialCost: number | null, propertyRentCost: number | null, paidSupplyPartSubtotal: number | null, facilityCost: number | null, facilityAmortizationCost: number | null, amortizationCost: number | null, jigManagementCost: number | null, netUnitPrice: number | null, materialCostNotSupplySubtotal: number | null, materialCostSupplySubtotal: number | null, materialManagementCost: number | null, partsCost: number | null, deliveryCost: number | null, managementCost: number | null, processingPriceSubtotal: number | null, manufacturingSite: { __typename?: 'ManufacturingSite', code: string | null, name: string } | null } | null, priceChangeReasons: Array<{ __typename?: 'PriceChangeReason', id: string, tenantId: string, code: string, reason: string, sequence: number }> | null, reasonSnapshots: Array<{ __typename?: 'PriceAdjustmentItemPriceChangeReason', id: string, tenantId: string, code: string, reason: string, sequence: number, priceChangeReasonId: string, priceDifference: number | null }> | null, partOrderUnitPrice: { __typename?: 'PartOrderUnitPrice', id: string, unitPrice: number, ifKey1: string | null, ifKey2: string | null, tenantUnit: { __typename?: 'TenantUnit', unitCode: string, name: string } | null, tenant: { __typename?: 'Tenant', id: string, name: string, code: string } | null, supplier: { __typename?: 'Supplier', id: string, name: string, code: string, displayCode: string, isEligibleToSubcontractAct: boolean }, currency: { __typename?: 'Currency', currencyCode: string, decimalPrecision: number, displayName: string } | null, itemRequirement: { __typename?: 'ItemRequirement', designChangeCode: string | null } | null } | null };

export type PriceAdjustmentItemDetailFieldFragment = { __typename?: 'PriceAdjustmentItemDetail', id: string, tenantId: string, kind: string, unitPrice: number | null, materialCost: number | null, processingCost: number | null, otherCost: number | null, supplyPartPrice: number | null, scrapPrice: number | null, memo: string, notSupplyPartSubtotal: number | null, subsidiaryMaterialCost: number | null, propertyRentCost: number | null, paidSupplyPartSubtotal: number | null, facilityCost: number | null, facilityAmortizationCost: number | null, amortizationCost: number | null, jigManagementCost: number | null, netUnitPrice: number | null, materialCostNotSupplySubtotal: number | null, materialCostSupplySubtotal: number | null, materialManagementCost: number | null, partsCost: number | null, deliveryCost: number | null, managementCost: number | null, processingPriceSubtotal: number | null, manufacturingSite: { __typename?: 'ManufacturingSite', code: string | null, name: string } | null };

export type PriceAdjustmentItemDetailForFormFieldFragment = { __typename?: 'PriceAdjustmentItemDetail', id: string, tenantId: string, kind: string, unitPrice: number | null, materialCost: number | null, processingCost: number | null, otherCost: number | null, supplyPartPrice: number | null, scrapPrice: number | null, memo: string, notSupplyPartSubtotal: number | null, subsidiaryMaterialCost: number | null, propertyRentCost: number | null, paidSupplyPartSubtotal: number | null, facilityCost: number | null, facilityAmortizationCost: number | null, amortizationCost: number | null, jigManagementCost: number | null, materialManagementCost: number | null, materialCostNotSupplySubtotal: number | null, materialCostSupplySubtotal: number | null, partsCost: number | null, netUnitPrice: number | null, deliveryCost: number | null, managementCost: number | null, processingPriceSubtotal: number | null, manufacturingSite: { __typename?: 'ManufacturingSite', id: string, name: string, code: string | null } | null, priceAdjustmentItemDetailMaterialPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailMaterialPrice', id: string, materialName: string | null, materialCode: string | null, materialCost: number | null, materialUnitPrice: number | null, initialCost: number | null, measure: string | null, procurementKind: string | null, productWeight: number | null, quantity: number | null, reservedWeight: number | null, scrapSubtotal: number | null, scrapUnitPrice: number | null, scrapWeight: number | null, startOn: any | null, startUpMonth: any | null, variation: number | null, cavity: number | null, materialCostPerQty: number | null, partMaterialPriceId: string | null, baseMaterial: { __typename?: 'BaseMaterial', id: string, name: string, code: string } | null, partMaterialPrice: { __typename?: 'PartMaterialPrice', id: string } | null, priceTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null }> | null, priceAdjustmentItemDetailProcessingPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailProcessingPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, processName: string, equipmentName: string | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingTimeHour: number | null, processingRate: number | null, processingCostSubtotal: number | null, processingCostSubtotalPerLot: number | null, setupTimeMinute: number | null, setupTimeHour: number | null, setupTimeSecond: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, productionLot: number | null, rateKind: number | null, setupRate: number | null, processingWeight: number | null, costForWeight: number | null, weightTenantUnitId: string | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostPerLot: number | null, partProcessingCostId: string | null, facilityKindId: string | null, facilityName: string | null, facilityCost: number | null, facilityPaymentInstallmentKind: string | null, partFacilityPrice: { __typename?: 'PartFacilityPrice', id: string | null, facilityKindId: string, name: string | null, facilityCost: number | null, acquiredOn: any | null, memo: string | null, amortizationNumber: number | null, amortizationCost: number | null, paymentInstallmentKind: string, paymentMonthly: number | null, paymentLastMonth: number | null, paymentStartOn: any | null, paymentEndOn: any | null, tenantId: string, facilityKind: { __typename?: 'FacilityKind', id: string, name: string } } | null }> | null, priceAdjustmentItemDetailSubpartPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailSubpartPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, partCode: string | null, partName: string | null, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, partCost: number | null, partSubpartPriceId: string | null }> | null, priceAdjustmentItemDetailSubsidiaryMaterialCosts: Array<{ __typename?: 'PriceAdjustmentItemDetailSubsidiaryMaterialCost', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number | null, note: string | null, partSubsidiaryMaterialCostId: string | null }> | null, priceAdjustmentItemDetailSupplySubpartPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailSupplySubpartPrice', id: string, tenantId: string, priceAdjustmentItemDetailId: string, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, supplyPartCost: number | null, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, partSupplySubpartPriceId: string | null, supplyPart: { __typename?: 'Part', id: string, code: string | null, name: string } | null }> | null, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null };

export type PriceAdjustmentItemDetailMaterialPriceFieldFragment = { __typename?: 'PriceAdjustmentItemDetailMaterialPrice', id: string, materialName: string | null, materialCode: string | null, materialCost: number | null, materialUnitPrice: number | null, initialCost: number | null, measure: string | null, procurementKind: string | null, productWeight: number | null, quantity: number | null, reservedWeight: number | null, scrapSubtotal: number | null, scrapUnitPrice: number | null, scrapWeight: number | null, startOn: any | null, startUpMonth: any | null, variation: number | null, cavity: number | null, materialCostPerQty: number | null, partMaterialPriceId: string | null, baseMaterial: { __typename?: 'BaseMaterial', id: string, name: string, code: string } | null, partMaterialPrice: { __typename?: 'PartMaterialPrice', id: string } | null, priceTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null };

export type PriceAdjustmentItemDetailProcessingPriceFieldFragment = { __typename?: 'PriceAdjustmentItemDetailProcessingPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, processName: string, equipmentName: string | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingTimeHour: number | null, processingRate: number | null, processingCostSubtotal: number | null, processingCostSubtotalPerLot: number | null, setupTimeMinute: number | null, setupTimeHour: number | null, setupTimeSecond: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, productionLot: number | null, rateKind: number | null, setupRate: number | null, processingWeight: number | null, costForWeight: number | null, weightTenantUnitId: string | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostPerLot: number | null, partProcessingCostId: string | null, facilityKindId: string | null, facilityName: string | null, facilityCost: number | null, facilityPaymentInstallmentKind: string | null, partFacilityPrice: { __typename?: 'PartFacilityPrice', id: string | null, facilityKindId: string, name: string | null, facilityCost: number | null, acquiredOn: any | null, memo: string | null, amortizationNumber: number | null, amortizationCost: number | null, paymentInstallmentKind: string, paymentMonthly: number | null, paymentLastMonth: number | null, paymentStartOn: any | null, paymentEndOn: any | null, tenantId: string, facilityKind: { __typename?: 'FacilityKind', id: string, name: string } } | null };

export type PriceAdjustmentItemDetailSubpartPriceFieldFragment = { __typename?: 'PriceAdjustmentItemDetailSubpartPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, partCode: string | null, partName: string | null, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, partCost: number | null, partSubpartPriceId: string | null };

export type PriceAdjustmentItemDetailSubsidiaryMaterialCostFieldFragment = { __typename?: 'PriceAdjustmentItemDetailSubsidiaryMaterialCost', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number | null, note: string | null, partSubsidiaryMaterialCostId: string | null };

export type PriceAdjustmentItemDetailSupplySubpartPriceFieldFragment = { __typename?: 'PriceAdjustmentItemDetailSupplySubpartPrice', id: string, tenantId: string, priceAdjustmentItemDetailId: string, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, supplyPartCost: number | null, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, partSupplySubpartPriceId: string | null, supplyPart: { __typename?: 'Part', id: string, code: string | null, name: string } | null };

export type PriceAdjustmentItemForFormFieldFragment = { __typename?: 'PriceAdjustmentItem', id: string, tenantId: string, quantity: number, memo: string | null, tenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string } | null, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, part: { __typename?: 'Part', id: string, code: string | null, displayCode: string, figureNumber: string | null, receiverCode: string | null, receiverName: string | null, name: string, isAdjustable: boolean, rootPartCode: string | null, deliverySiteObjects: Array<{ __typename?: 'DeliverySite', id: string, name: string }>, deliverySites: Array<{ __typename?: 'DeliverySite', id: string, name: string, code: string | null }>, sameGroupParts: Array<{ __typename?: 'Part', id: string, code: string | null, name: string }>, activePartOrderUnitPrices: Array<{ __typename?: 'PartOrderUnitPrice', itemRequirement: { __typename?: 'ItemRequirement', designChangeCode: string | null } | null }> }, newDetail: { __typename?: 'PriceAdjustmentItemDetail', id: string, tenantId: string, kind: string, unitPrice: number | null, materialCost: number | null, processingCost: number | null, otherCost: number | null, supplyPartPrice: number | null, scrapPrice: number | null, memo: string, notSupplyPartSubtotal: number | null, subsidiaryMaterialCost: number | null, propertyRentCost: number | null, paidSupplyPartSubtotal: number | null, facilityCost: number | null, facilityAmortizationCost: number | null, amortizationCost: number | null, jigManagementCost: number | null, materialManagementCost: number | null, materialCostNotSupplySubtotal: number | null, materialCostSupplySubtotal: number | null, partsCost: number | null, netUnitPrice: number | null, deliveryCost: number | null, managementCost: number | null, processingPriceSubtotal: number | null, manufacturingSite: { __typename?: 'ManufacturingSite', id: string, name: string, code: string | null } | null, priceAdjustmentItemDetailMaterialPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailMaterialPrice', id: string, materialName: string | null, materialCode: string | null, materialCost: number | null, materialUnitPrice: number | null, initialCost: number | null, measure: string | null, procurementKind: string | null, productWeight: number | null, quantity: number | null, reservedWeight: number | null, scrapSubtotal: number | null, scrapUnitPrice: number | null, scrapWeight: number | null, startOn: any | null, startUpMonth: any | null, variation: number | null, cavity: number | null, materialCostPerQty: number | null, partMaterialPriceId: string | null, baseMaterial: { __typename?: 'BaseMaterial', id: string, name: string, code: string } | null, partMaterialPrice: { __typename?: 'PartMaterialPrice', id: string } | null, priceTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null }> | null, priceAdjustmentItemDetailProcessingPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailProcessingPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, processName: string, equipmentName: string | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingTimeHour: number | null, processingRate: number | null, processingCostSubtotal: number | null, processingCostSubtotalPerLot: number | null, setupTimeMinute: number | null, setupTimeHour: number | null, setupTimeSecond: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, productionLot: number | null, rateKind: number | null, setupRate: number | null, processingWeight: number | null, costForWeight: number | null, weightTenantUnitId: string | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostPerLot: number | null, partProcessingCostId: string | null, facilityKindId: string | null, facilityName: string | null, facilityCost: number | null, facilityPaymentInstallmentKind: string | null, partFacilityPrice: { __typename?: 'PartFacilityPrice', id: string | null, facilityKindId: string, name: string | null, facilityCost: number | null, acquiredOn: any | null, memo: string | null, amortizationNumber: number | null, amortizationCost: number | null, paymentInstallmentKind: string, paymentMonthly: number | null, paymentLastMonth: number | null, paymentStartOn: any | null, paymentEndOn: any | null, tenantId: string, facilityKind: { __typename?: 'FacilityKind', id: string, name: string } } | null }> | null, priceAdjustmentItemDetailSubpartPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailSubpartPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, partCode: string | null, partName: string | null, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, partCost: number | null, partSubpartPriceId: string | null }> | null, priceAdjustmentItemDetailSubsidiaryMaterialCosts: Array<{ __typename?: 'PriceAdjustmentItemDetailSubsidiaryMaterialCost', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number | null, note: string | null, partSubsidiaryMaterialCostId: string | null }> | null, priceAdjustmentItemDetailSupplySubpartPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailSupplySubpartPrice', id: string, tenantId: string, priceAdjustmentItemDetailId: string, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, supplyPartCost: number | null, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, partSupplySubpartPriceId: string | null, supplyPart: { __typename?: 'Part', id: string, code: string | null, name: string } | null }> | null, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null } | null, oldDetail: { __typename?: 'PriceAdjustmentItemDetail', id: string, tenantId: string, kind: string, unitPrice: number | null, materialCost: number | null, processingCost: number | null, otherCost: number | null, supplyPartPrice: number | null, scrapPrice: number | null, memo: string, notSupplyPartSubtotal: number | null, subsidiaryMaterialCost: number | null, propertyRentCost: number | null, paidSupplyPartSubtotal: number | null, facilityCost: number | null, facilityAmortizationCost: number | null, amortizationCost: number | null, jigManagementCost: number | null, materialManagementCost: number | null, materialCostNotSupplySubtotal: number | null, materialCostSupplySubtotal: number | null, partsCost: number | null, netUnitPrice: number | null, deliveryCost: number | null, managementCost: number | null, processingPriceSubtotal: number | null, manufacturingSite: { __typename?: 'ManufacturingSite', id: string, name: string, code: string | null } | null, priceAdjustmentItemDetailMaterialPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailMaterialPrice', id: string, materialName: string | null, materialCode: string | null, materialCost: number | null, materialUnitPrice: number | null, initialCost: number | null, measure: string | null, procurementKind: string | null, productWeight: number | null, quantity: number | null, reservedWeight: number | null, scrapSubtotal: number | null, scrapUnitPrice: number | null, scrapWeight: number | null, startOn: any | null, startUpMonth: any | null, variation: number | null, cavity: number | null, materialCostPerQty: number | null, partMaterialPriceId: string | null, baseMaterial: { __typename?: 'BaseMaterial', id: string, name: string, code: string } | null, partMaterialPrice: { __typename?: 'PartMaterialPrice', id: string } | null, priceTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null }> | null, priceAdjustmentItemDetailProcessingPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailProcessingPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, processName: string, equipmentName: string | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingTimeHour: number | null, processingRate: number | null, processingCostSubtotal: number | null, processingCostSubtotalPerLot: number | null, setupTimeMinute: number | null, setupTimeHour: number | null, setupTimeSecond: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, productionLot: number | null, rateKind: number | null, setupRate: number | null, processingWeight: number | null, costForWeight: number | null, weightTenantUnitId: string | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostPerLot: number | null, partProcessingCostId: string | null, facilityKindId: string | null, facilityName: string | null, facilityCost: number | null, facilityPaymentInstallmentKind: string | null, partFacilityPrice: { __typename?: 'PartFacilityPrice', id: string | null, facilityKindId: string, name: string | null, facilityCost: number | null, acquiredOn: any | null, memo: string | null, amortizationNumber: number | null, amortizationCost: number | null, paymentInstallmentKind: string, paymentMonthly: number | null, paymentLastMonth: number | null, paymentStartOn: any | null, paymentEndOn: any | null, tenantId: string, facilityKind: { __typename?: 'FacilityKind', id: string, name: string } } | null }> | null, priceAdjustmentItemDetailSubpartPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailSubpartPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, partCode: string | null, partName: string | null, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, partCost: number | null, partSubpartPriceId: string | null }> | null, priceAdjustmentItemDetailSubsidiaryMaterialCosts: Array<{ __typename?: 'PriceAdjustmentItemDetailSubsidiaryMaterialCost', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number | null, note: string | null, partSubsidiaryMaterialCostId: string | null }> | null, priceAdjustmentItemDetailSupplySubpartPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailSupplySubpartPrice', id: string, tenantId: string, priceAdjustmentItemDetailId: string, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, supplyPartCost: number | null, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, partSupplySubpartPriceId: string | null, supplyPart: { __typename?: 'Part', id: string, code: string | null, name: string } | null }> | null, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null } | null, latestAskingDetail: { __typename?: 'PriceAdjustmentItemDetail', id: string, tenantId: string, kind: string, unitPrice: number | null, materialCost: number | null, processingCost: number | null, otherCost: number | null, supplyPartPrice: number | null, scrapPrice: number | null, memo: string, notSupplyPartSubtotal: number | null, subsidiaryMaterialCost: number | null, propertyRentCost: number | null, paidSupplyPartSubtotal: number | null, facilityCost: number | null, facilityAmortizationCost: number | null, amortizationCost: number | null, jigManagementCost: number | null, materialManagementCost: number | null, materialCostNotSupplySubtotal: number | null, materialCostSupplySubtotal: number | null, partsCost: number | null, netUnitPrice: number | null, deliveryCost: number | null, managementCost: number | null, processingPriceSubtotal: number | null, manufacturingSite: { __typename?: 'ManufacturingSite', id: string, name: string, code: string | null } | null, priceAdjustmentItemDetailMaterialPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailMaterialPrice', id: string, materialName: string | null, materialCode: string | null, materialCost: number | null, materialUnitPrice: number | null, initialCost: number | null, measure: string | null, procurementKind: string | null, productWeight: number | null, quantity: number | null, reservedWeight: number | null, scrapSubtotal: number | null, scrapUnitPrice: number | null, scrapWeight: number | null, startOn: any | null, startUpMonth: any | null, variation: number | null, cavity: number | null, materialCostPerQty: number | null, partMaterialPriceId: string | null, baseMaterial: { __typename?: 'BaseMaterial', id: string, name: string, code: string } | null, partMaterialPrice: { __typename?: 'PartMaterialPrice', id: string } | null, priceTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null }> | null, priceAdjustmentItemDetailProcessingPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailProcessingPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, processName: string, equipmentName: string | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingTimeHour: number | null, processingRate: number | null, processingCostSubtotal: number | null, processingCostSubtotalPerLot: number | null, setupTimeMinute: number | null, setupTimeHour: number | null, setupTimeSecond: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, productionLot: number | null, rateKind: number | null, setupRate: number | null, processingWeight: number | null, costForWeight: number | null, weightTenantUnitId: string | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostPerLot: number | null, partProcessingCostId: string | null, facilityKindId: string | null, facilityName: string | null, facilityCost: number | null, facilityPaymentInstallmentKind: string | null, partFacilityPrice: { __typename?: 'PartFacilityPrice', id: string | null, facilityKindId: string, name: string | null, facilityCost: number | null, acquiredOn: any | null, memo: string | null, amortizationNumber: number | null, amortizationCost: number | null, paymentInstallmentKind: string, paymentMonthly: number | null, paymentLastMonth: number | null, paymentStartOn: any | null, paymentEndOn: any | null, tenantId: string, facilityKind: { __typename?: 'FacilityKind', id: string, name: string } } | null }> | null, priceAdjustmentItemDetailSubpartPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailSubpartPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, partCode: string | null, partName: string | null, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, partCost: number | null, partSubpartPriceId: string | null }> | null, priceAdjustmentItemDetailSubsidiaryMaterialCosts: Array<{ __typename?: 'PriceAdjustmentItemDetailSubsidiaryMaterialCost', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number | null, note: string | null, partSubsidiaryMaterialCostId: string | null }> | null, priceAdjustmentItemDetailSupplySubpartPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailSupplySubpartPrice', id: string, tenantId: string, priceAdjustmentItemDetailId: string, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, supplyPartCost: number | null, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, partSupplySubpartPriceId: string | null, supplyPart: { __typename?: 'Part', id: string, code: string | null, name: string } | null }> | null, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null } | null, priceChangeReasons: Array<{ __typename?: 'PriceChangeReason', id: string, tenantId: string, code: string, reason: string, sequence: number }> | null, reasonSnapshots: Array<{ __typename?: 'PriceAdjustmentItemPriceChangeReason', id: string, tenantId: string, code: string, reason: string, sequence: number, priceChangeReasonId: string, priceDifference: number | null }> | null, partOrderUnitPrice: { __typename?: 'PartOrderUnitPrice', id: string, unitPrice: number, quantity: number, startOn: any, endOn: any | null, isExpired: boolean, ifKey1: string | null, ifKey2: string | null, currency: { __typename?: 'Currency', id: string, displayName: string, currencyCode: string, decimalPrecision: number } | null, tenantUnit: { __typename?: 'TenantUnit', unitCode: string, name: string } | null, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, part: { __typename?: 'Part', id: string, displayCode: string, name: string, figureNumber: string | null } } | null, priceAdjustment: { __typename?: 'PriceAdjustment', id: string, targetTerm: string, supplierCode: string, supplier: { __typename?: 'Supplier', id: string, name: string, displayCode: string } }, answerFormat: { __typename?: 'AnswerFormat', id: string, isUseMaterialCost: boolean, isUseMaterialCostDetail: boolean, isUseMaterialSize: boolean, isUseMaterialScrap: boolean, isUseMaterialCostProcurementKind: boolean, isUseMaterialCostCavity: boolean, isUseMaterialCostAdjustment: boolean, isUseMaterialCostMemo: boolean, isUseMaterialCostThickness: boolean, isUseMaterialCostWidth: boolean, isUseMaterialCostHeight: boolean, isUseMaterialCostMeasure: boolean, isUseMaterialCostWeightBeforeProcess: boolean, isUseMaterialCostWeightAfterProcess: boolean, isUseMaterialCostBasePrice: boolean, isUsePartsCost: boolean, isUsePartsCostDetail: boolean, isUsePartsCostProcurementKind: boolean, isUsePartsCostPartNo: boolean, isUsePartsCostPartName: boolean, isUsePartsCostProductionPlace: boolean, isUsePartsCostQuantity: boolean, isUsePartsCostPartsUnitPrice: boolean, isUsePartsCostMemo: boolean, isUsePartsCostPartSpec: boolean, isUsePartsCostPartsCount: boolean, isUseProcessingCost: boolean, isUseProcessingCostDetail: boolean, isUseProcessingCostProductionLot: boolean, isUseProcessingCostEquipmentName: boolean, isUseProcessingCostProcessingTimeHour: boolean, isUseProcessingCostProcessingTimeMinute: boolean, isUseProcessingCostProcessingTimeSecond: boolean, isUseProcessingCostProcessingRate: boolean, isUseSetupInformation: boolean, isUseProcessingCostProcessingTimes: boolean, isUseProcessingCostSetupTimeHour: boolean, isUseProcessingCostSetupTimeMinute: boolean, isUseProcessingCostSetupTimeSecond: boolean, isUseProcessingCostSetupRate: boolean, isUseProcessingCostProcessingCostSubtotal: boolean, isUseProcessingCostSetupCostSubtotal: boolean, isUseProcessingCostMemo: boolean, processingCostRateKind: string | null, isUseManagementCost: boolean, isUseMaterialManagementRate: boolean, isUseMaterialManagementCost: boolean, isUseProcessingManagementRate: boolean, isUseProcessingManagementCost: boolean, isUseDeliveryCost: boolean, isUseDeliveryBoxInformation: boolean, isUsePackingCost: boolean, isUsePackingBoxInformation: boolean, isUseDefectCost: boolean, isUseDefectRate: boolean, isUseProfit: boolean, isUseProfitRate: boolean, isUseAdjustment: boolean, isUseDepreciation: boolean, isUseInternalPartSubtotal: boolean, isUseOutSourcePartSubtotal: boolean, isUseOutSourcePartManagementRate: boolean, isUsePaidSupplyPartSubtotal: boolean, isUseInitialDeliveryDay: boolean, isUseMaterialDeliveryDay: boolean, isUseEquipmentDeliveryDay: boolean, isUseMoldDeliveryDay: boolean, isUseTrialDeliveryDay: boolean, isUseDeliveryDay: boolean, isUseGanttForDeliveryDay: boolean, isUseSurfaceProcessingCost: boolean, isUseSubsidiaryMaterialCost: boolean, isUseSubsidiaryMaterialCostDetail: boolean, isSetScrapName: boolean, scrap1Name: string | null, scrap2Name: string | null, isUseCurrencyExchangeNote: boolean, isUseAnswerByItem: boolean, isUseMinimumOrderQuantity: boolean, isUseDeliveryForm: boolean, isUseQuantityPerDeliveryForm: boolean, isUsePriceEffectiveDate: boolean, priceRegistrationFormatId: string | null, answerMethod: string, isUseProcessingWeight: boolean, isUseCostForWeight: boolean, isUseProcessingHeadcount: boolean, calculationKind: string, isUseWholesalerKnowledge: boolean, useMakerActualPartName: string, makerActualPartNameHelperTxt: string | null, materialCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, materialCostPriceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, specialProcessingDetailFormatsList: Array<{ __typename?: 'CommonSpecialProcessingDetailFormat', kind: string, kindLabel: string, isUseProductionLot: boolean, isUseEquipmentName: boolean, isUseProcessingTimeHour: boolean, isUseProcessingTimeMinute: boolean, isUseProcessingTimeSecond: boolean, isUseProcessingRate: boolean, isUseSetupInformation: boolean, isUseSetupTimeHour: boolean, isUseSetupTimeMinute: boolean, isUseSetupTimeSecond: boolean, isUseSetupRate: boolean, isUseMemo: boolean, isUseProcessingTimes: boolean, isUseProcessingCostSubtotal: boolean, isUseSetupCostSubtotal: boolean, rateKind: string | null }>, processingCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, facilityKinds: Array<{ __typename?: 'FacilityKind', id: string, code: string | null, name: string }> } | null };

export type PriceAdjustmentItemPriceChangeReasonFieldFragment = { __typename?: 'PriceAdjustmentItemPriceChangeReason', id: string, tenantId: string, code: string, reason: string, sequence: number, priceChangeReasonId: string, priceDifference: number | null };

export type PriceAdjustmentItemProjectFieldFragment = { __typename?: 'Project', id: string, modelYear: number | null, title: string, modelTitle: string | null, modelTypeName: string | null, projectModel: { __typename?: 'ProjectModel', id: string, deliverySiteName: string | null, modelDepreciation: string | null, modelDepreciationQuantity: number | null, manufacturingSiteName: string | null } | null, projectFormat: { __typename?: 'ProjectFormat', isSingleUnitProject: boolean } | null, projectSchedules: Array<{ __typename?: 'ProjectSchedule', id: string | null, eventName: string, eventOn: any | null, qualificationLevelName: string | null, seqNo: number | null }>, quotationContext: { __typename?: 'QuotationContext', materialPriceDateOn: any | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, comment: string | null } };

export type PriceAdjustmentSettingFieldFragment = { __typename?: 'PriceAdjustmentSetting', id: string, tenantId: string, reasonCount: number, isUseMaterialPriceAdjustment: boolean | null, isUsePriceAdjustmentFormEdit: boolean, materialPriceAdjustmentTargetKind: PriceAdjustmentSettingMaterialPriceAdjustmentTargetKindEnum };

export type PriceChangeReasonFieldFragment = { __typename?: 'PriceChangeReason', id: string, tenantId: string, code: string, reason: string, sequence: number };

export type ProductFieldFragment = { __typename?: 'Product', id: string, customerName: string | null, customerDevelopmentCode: string | null, name: string, code: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null, productScheduleGroups: Array<{ __typename?: 'ProductScheduleGroup', id: string, seqNo: number, productSchedules: Array<{ __typename?: 'ProductSchedule', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null }> }> };

export type ProductConfigFieldFragment = { __typename?: 'ProductConfig', isVisibleDevelopmentCode: boolean, isVisibleName: boolean, isVisibleCustomerName: boolean, isVisibleCustomerDevelopmentCode: boolean, isVisibleDivision: boolean, isVisibleDetail: boolean, isVisibleManufacturingLocation: boolean, isVisibleAnnualQuantity: boolean, isVisibleScheduledSalesDate: boolean, isVisibleOrderType: boolean, isVisibleOrderProbability: boolean, isUseCustomerName: boolean, isUseCustomerDevelopmentCode: boolean, isUseDivision: boolean, isUseDetail: boolean, isUseManufacturingLocation: boolean, isUseAnnualQuantity: boolean, isUseScheduledSalesDate: boolean, isUseOrderType: boolean, isUseOrderProbability: boolean };

export type ProductScheduleFieldFragment = { __typename?: 'ProductSchedule', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null };

export type ProductScheduleGroupFieldFragment = { __typename?: 'ProductScheduleGroup', id: string, seqNo: number, productSchedules: Array<{ __typename?: 'ProductSchedule', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null }> };

export type ProductScheduleGroupSnapshotFieldFragment = { __typename?: 'ProductScheduleGroupSnapshot', id: string, seqNo: number, productSchedules: Array<{ __typename?: 'ProductScheduleSnapshot', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null }> };

export type ProductScheduleSnapshotFieldFragment = { __typename?: 'ProductScheduleSnapshot', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null };

export type QuotationAttachmentFieldFragment = { __typename?: 'QuotationAttachment', quotationAttachmentKind: string, quotationItemIds: Array<string>, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> };

export type QuotationContextFieldFragment = { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null };

export type QuotationInquiryFieldFragment = { __typename?: 'QuotationInquiry', id: string, seqNo: number, title: string, inquiryType: string, unit: string | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null };

export type QuotationItemSelectionFieldFragment = { __typename?: 'QuotationItemSelection', isSelected: boolean };

export type QuotationItemV2FieldFragment = { __typename?: 'QuotationItemV2', id: string, isRoot: boolean, isNew: boolean | null, quantity: number | null, multiLot: Array<number>, quantityGroups: Array<string>, receiverCode: string | null, receiverName: string | null, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, makerName: string | null, makerCode: string | null, makerModelNumber: string | null, figureNumber: string | null, rootPartCode: string | null, designChangeCode: string | null, itemPropInfosForSupplier: Array<{ __typename?: 'ItemPropInfo', id: string, itemProppableType: string, itemProppableId: string, stringValue: string | null, numberValue: number | null, booleanValue: boolean | null, position: number, itemProp: { __typename?: 'ItemProp', id: string, name: string, code: string | null, unit: string | null, kind: ItemPropKind }, selectedOptions: Array<{ __typename?: 'ItemPropOption', id: string, label: string, position: number }> }>, specAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, designAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> }, quotationItemSelection: { __typename?: 'QuotationItemSelection', isSelected: boolean } | null, quotationItemSupplyParts: Array<{ __typename?: 'CommonSupplyPartInfo', id: string, name: string, code: string, supplyPartId: string | null, tenantId: string, unitPrice: number | null, specs: Array<{ __typename?: 'CommonSupplyPartSpec', id: string | null, code: string | null, name: string | null, unit: string | null, value: string | null }> | null }>, deliverySites: Array<{ __typename?: 'DeliverySite', id: string, name: string, code: string | null }>, tenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string } | null, products: Array<{ __typename?: 'Product', id: string, customerName: string | null, customerDevelopmentCode: string | null, name: string, code: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null, productScheduleGroups: Array<{ __typename?: 'ProductScheduleGroup', id: string, seqNo: number, productSchedules: Array<{ __typename?: 'ProductSchedule', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null }> }> }>, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, quotationItemSupplySubparts: Array<{ __typename?: 'CommonQuotationItemSupplySubpart', id: string, supplyPartName: string | null, partCode: string | null, rootPartCode: string | null, unitPrice: number, quantity: number, quantityDenominator: number, supplyPartCost: number }>, quotationItemMaterials: Array<{ __typename?: 'QuotationItemMaterial', id: string, baseMaterialCode: string | null, materialName: string, thickness: number | null, width: number | null, procurementKind: string | null, materialBasePrice: number | null, scrap1UnitPrice: number | null }>, project: { __typename?: 'Project', id: string, modelTitle: string | null, modelTypeName: string | null, modelYear: number | null, title: string, uid: string, projectSchedules: Array<{ __typename?: 'ProjectSchedule', id: string | null, eventName: string, eventOn: any | null, qualificationLevelName: string | null }>, projectModel: { __typename?: 'ProjectModel', id: string, deliverySiteName: string | null, manufacturingSiteName: string | null, productWeight: number | null, name: string | null, code: string | null, customerName: string | null, customerDevelopmentCode: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null } | null } | null, projectItem: { __typename?: 'ProjectItem', id: string, quantityPerRoot: number | null } | null, quotationItemChildStructs: Array<{ __typename?: 'QuotationItemChildStruct', id: string, level: number, parentId: string | null, quantityPerRoot: number, quotationRequestKind: QuotationRequestKindEnum, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, figureNumber: string | null } | null, tenantUnit: { __typename?: 'TenantUnit', id: string, name: string } }> };

export type QuotationListV2FieldFragment = { __typename?: 'Quotation', id: string, uid: string, status: string, answerDueDate: any | null, announcementKind: string, isUseAnswerExcelImport: boolean, isFromPurchaseReceipt: boolean, tenant: { __typename?: 'Tenant', id: string, name: string }, quotationItemsV2: Array<{ __typename?: 'QuotationItemV2', id: string, quantity: number | null, tenantUnit: { __typename?: 'TenantUnit', name: string } | null, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', name: string } | null, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, rootPartCode: string | null, designChangeCode: string | null, figureNumber: string | null }, quotationItemSelection: { __typename?: 'QuotationItemSelection', isSelected: boolean } | null }>, quotationRequest: { __typename?: 'QuotationRequest', id: string, isAnswered: boolean, isDeclined: boolean, answeredAt: any | null, requestedOn: any | null, personInCharge: string, statusForSupplier: string, isCanBeAnswered: boolean, isCanBeDeclined: boolean, supplier: { __typename?: 'Supplier', id: string, code: string, name: string }, answer: { __typename?: 'Answer', status: string, answerPrices: Array<{ __typename?: 'AnswerPrice', unitPrice: number | null }>, currency: { __typename?: 'Currency', displayName: string } | null, answerExcelAttachments: Array<{ __typename?: 'AnswerExcelAttachment', resultMessage: string | null }> } | null }, applicationFormat: { __typename?: 'ApplicationFormat', isSendSelectionMail: boolean }, supplierQuotationPackage: { __typename?: 'SupplierQuotationPackage', id: string, answerEntryKind: string } | null };

export type QuotationProductFieldFragment = { __typename?: 'QuotationProduct', productId: string | null, productInformation: string | null, customerName: string | null, customerDevelopmentCode: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, developmentCode: string | null, productDevision: string | null, productDetail: string | null, productManufacturingLocation: string | null, orderType: string | null, orderProbability: string | null, productScheduleGroupSnapshots: Array<{ __typename?: 'ProductScheduleGroupSnapshot', id: string, seqNo: number, productSchedules: Array<{ __typename?: 'ProductScheduleSnapshot', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null }> }> };

export type QuotationProductScheduleFieldFragment = { __typename?: 'QuotationProductSchedule', id: string | null, groupSeqNo: number, seqNo: number, name: string, value: string | null };

export type QuotationRequestFieldFragment = { __typename?: 'QuotationRequest', id: string, isAnswered: boolean, isDeclined: boolean, answeredAt: any | null, requestedOn: any | null, isLocked: boolean, commentForSupplier: string | null, personInCharge: string, supplierCountryId: string, answeredAtZoned: any | null, statusForSupplier: string, isCanBeAnswered: boolean, isCanBeDeclined: boolean, answer: { __typename?: 'Answer', declineReason: string | null, id: string, status: string, statusLabel: string, memo: string | null, expiredAt: any | null, isDirect: boolean, isFileAnswer: boolean, isSupplierFileAnswer: boolean, dayType: string | null, quotationNo: string | null, expirationDate: string | null, currencyId: string, facilityCost: number, currencyExchangeNote: string | null, inputKind: string, quotationCopiedFrom: { __typename?: 'Quotation', id: string, uid: string } | null, answerPrices: Array<{ __typename?: 'AnswerPrice', id: string, quantity: number, quantityFrom: number, quantityTo: number | null, isDeclined: boolean, priceBasis: string, taxType: number, amountExcludingTax: string | null, amountIncludingTax: string | null, unitPrice: number | null, materialCost: number | null, partsCost: number | null, processingCost: number | null, surfaceProcessingCost: number | null, subsidiaryMaterialCost: number | null, materialManagementCost: number | null, materialManagementRate: number | null, processingManagementCost: number | null, processingManagementRate: number | null, managementCost: number | null, quantityInOneBox: number | null, deliveryCostPerBox: number | null, boxCount: number | null, deliveryCost: number | null, packingCostPerBox: number | null, packingCost: number | null, defectCost: number | null, defectRate: number | null, profit: number | null, adjustment: number | null, profitRate: number | null, depreciation: number | null, internalPartSubtotal: number | null, outSourcePartSubtotal: number | null, outSourcePartManagementRate: number | null, paidSupplyPartSubtotal: number | null, deliveryDay: number | null, initialDeliveryDay: number | null, materialDeliveryDay: number | null, materialDeliveryStartDay: number | null, equipmentDeliveryDay: number | null, equipmentDeliveryStartDay: number | null, moldDeliveryDay: number | null, moldDeliveryStartDay: number | null, trialDeliveryDay: number | null, trialDeliveryStartDay: number | null, facilityCost: number | null, jigManagementCost: number | null, propertyRentCost: number | null, designCost: number | null, subsidiaryMaterialManagementRate: number | null, subsidiaryMaterialManagementCost: number | null, quotationItemId: string, quotationItemChildStructId: string | null, answerPartsCosts: Array<{ __typename?: 'AnswerPartsCost', id: string, procurementKind: string | null, seqNo: number, partNo: string | null, partName: string | null, productionPlace: string | null, partSpec: string | null, partsCount: number | null, quantity: number | null, partsUnitPrice: number | null, memo: string | null, partsCost: number }>, answerProcessingCosts: Array<{ __typename?: 'AnswerProcessingCost', id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, memo: string | null, processingCost: number, rateKind: string | null, processingWeight: number | null, costForWeight: number | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostSubtotalPerLot: number | null, setupCostSubtotalPerLot: number | null, processingCostPerLot: number | null, partCostRatio: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSpecialProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerSurfaceProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerMaterialCosts: Array<{ __typename?: 'AnswerMaterialCost', id: string, seqNo: number, materialName: string, thickness: number | null, width: number | null, height: number | null, measure: string | null, weightBeforeProcess: number | null, weightAfterProcess: number | null, basePrice: number | null, adjustment: number | null, materialCostSubtotal: number | null, scrapValueSubtotal: number | null, materialCost: number, procurementKind: string | null, cavity: number | null, scrap1Name: string | null, scrap1Weight: number | null, scrap1UnitPrice: number | null, scrap1Subtotal: number | null, scrap2Name: string | null, scrap2Weight: number | null, scrap2UnitPrice: number | null, scrap2Subtotal: number | null, memo: string | null, baseMaterialCode: string | null, materialCostPerQty: number | null, scrap1SubtotalPerQty: number | null, scrap2SubtotalPerQty: number | null, scrapValueSubtotalPerQty: number | null, quantity: number | null, blendPrimaryMaterialName: string | null, blendPrimaryMaterialRatio: number | null, blendPrimaryMaterialUnitCost: number | null, blendSecondaryMaterialName: string | null, blendSecondaryMaterialRatio: number | null, blendSecondaryMaterialUnitCost: number | null, blendOtherMaterialName: string | null, blendOtherMaterialRatio: number | null, blendOtherMaterialUnitCost: number | null, blendBaseUnitCost: number | null, blendUnitCostMarkupRatio: number | null, lossPurgeLotCount: number | null, lossPurgeTotalWeight: number | null, lossPurgeUnitUsage: number | null, lossPurgeCost: number | null, lossGateUnitUsage: number | null, lossGateCost: number | null, lossRunnerUnitUsage: number | null, lossRunnerCost: number | null, lossOtherMemo: string | null, lossOtherUnitUsage: number | null, lossOtherCost: number | null, lossTotalUnitUsage: number | null, lossTotalCost: number | null, trialShotUnitUsage: number | null, trialShotCost: number | null, adjustmentCostMemo: string | null, adjustmentCost: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, priceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSubsidiaryMaterialCosts: Array<{ __typename?: 'CommonAnswerSubsidiaryMaterialCost', id: string, seqNo: number, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number, note: string | null, totalQuantity: number | null, totalSubsidiaryMaterialCost: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null }>, answerSupplySubparts: Array<{ __typename?: 'CommonAnswerSupplySubpart', id: string, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, quantity: number, quantityDenominator: number, unitPrice: number }> }>, answerFacilityCosts: Array<{ __typename?: 'AnswerFacilityCost', id: string, name: string, maker: string | null, spec: string | null, quantity: number | null, facilityUnitPrice: number | null, facilityCost: number, isLend: boolean | null, amortizationCost: number | null, amortizationNumber: number | null, amortizationPeriod: string | null, cavity: number | null, leadTime: string | null, memo: string | null, amortizationPeriodAsYear: number | null, paymentTimingKind: string | null, recuttingCount: number | null, answerProcessingCostId: string | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null, facilityKind: { __typename?: 'FacilityKind', id: string }, parts: Array<{ __typename?: 'Part', id: string, name: string, displayCode: string }>, quotationItems: Array<{ __typename?: 'QuotationItemV2', id: string, itemRequirement: { __typename?: 'ItemRequirement', name: string, code: string | null } }> }>, answerInquiries: Array<{ __typename?: 'AnswerInquiry', id: string, answerValueString: string | null, answerValueNumber: number | null, answerValueBoolean: boolean | null, quotationInquiry: { __typename?: 'QuotationInquiry', id: string, seqNo: number, title: string, inquiryType: string, unit: string | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null, supplierCorporationAttachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }>, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierCorporationAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierAccount: { __typename?: 'SupplierAccount', id: string, name: string } | null, supplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null, answerSupplyChainItemDetails: Array<{ __typename?: 'AnswerSupplyChainItemDetail', id: string | null, tenantId: string | null, quotationItemId: string | null, answerId: string | null, processName: string | null, supplierName: string | null, isAlternative: boolean | null, isNew: boolean | null, note: string | null, factoryName: string | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null }>, answerItems: Array<{ __typename?: 'AnswerItem', quotationItemId: string, minimumOrderQuantity: string | null, deliveryForm: string | null, quantityPerDeliveryForm: string | null, priceEffectiveFrom: any | null, priceEffectiveTo: any | null, specMemo: string | null, originLocation: string | null }>, wholesalerKnowledges: Array<{ __typename?: 'WholesalerKnowledge', quotationItemId: string, makerActualPartName: string | null }>, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null, answerOriginalFiles: Array<{ __typename?: 'AnswerOriginalFile', attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null, supplierCorporationAttachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }>, answerExcelAttachments: Array<{ __typename?: 'AnswerExcelAttachment', id: string | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null, supplierCorporationAttachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }> } | null, pdfImportResult: { __typename?: 'PdfImportResult', id: string, signedUrl: string, fileName: string } | null, currencies: Array<{ __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean }>, supplier: { __typename?: 'Supplier', id: string, code: string, name: string, isEligibleToSubcontractAct: boolean } };

export type QuotationV2FieldFragment = { __typename?: 'Quotation', id: string, uid: string, status: string, announcementKind: string, kind: string, selectKind: string, closeMemoForSupplier: string | null, answerDueDate: any | null, requestText: string | null, isDetailCostUsed: boolean, isUseAnswerExcelImport: boolean, isRequestSupplyChain: boolean, isBeforeMigration: boolean, isOneOffOrder: boolean, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, itemsToAnswer: Array<{ __typename?: 'ItemToAnswer', seq: number, quantity: number, quantityGroup: string, rootQuotationItemId: string, totalQuantityOnBranch: number, isDuplicate: boolean, quotationItemAssemblyEntity: { __typename?: 'QuotationItemAssemblyEntity', depth: number, numberCount: number, unitKind: string } | null, quotationItem: { __typename?: 'QuotationItemV2', id: string, isRoot: boolean, isNew: boolean | null, quantity: number | null, multiLot: Array<number>, quantityGroups: Array<string>, receiverCode: string | null, receiverName: string | null, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, makerName: string | null, makerCode: string | null, makerModelNumber: string | null, figureNumber: string | null, rootPartCode: string | null, designChangeCode: string | null, itemPropInfosForSupplier: Array<{ __typename?: 'ItemPropInfo', id: string, itemProppableType: string, itemProppableId: string, stringValue: string | null, numberValue: number | null, booleanValue: boolean | null, position: number, itemProp: { __typename?: 'ItemProp', id: string, name: string, code: string | null, unit: string | null, kind: ItemPropKind }, selectedOptions: Array<{ __typename?: 'ItemPropOption', id: string, label: string, position: number }> }>, specAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, designAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> }, quotationItemSelection: { __typename?: 'QuotationItemSelection', isSelected: boolean } | null, quotationItemSupplyParts: Array<{ __typename?: 'CommonSupplyPartInfo', id: string, name: string, code: string, supplyPartId: string | null, tenantId: string, unitPrice: number | null, specs: Array<{ __typename?: 'CommonSupplyPartSpec', id: string | null, code: string | null, name: string | null, unit: string | null, value: string | null }> | null }>, deliverySites: Array<{ __typename?: 'DeliverySite', id: string, name: string, code: string | null }>, tenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string } | null, products: Array<{ __typename?: 'Product', id: string, customerName: string | null, customerDevelopmentCode: string | null, name: string, code: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null, productScheduleGroups: Array<{ __typename?: 'ProductScheduleGroup', id: string, seqNo: number, productSchedules: Array<{ __typename?: 'ProductSchedule', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null }> }> }>, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, quotationItemSupplySubparts: Array<{ __typename?: 'CommonQuotationItemSupplySubpart', id: string, supplyPartName: string | null, partCode: string | null, rootPartCode: string | null, unitPrice: number, quantity: number, quantityDenominator: number, supplyPartCost: number }>, quotationItemMaterials: Array<{ __typename?: 'QuotationItemMaterial', id: string, baseMaterialCode: string | null, materialName: string, thickness: number | null, width: number | null, procurementKind: string | null, materialBasePrice: number | null, scrap1UnitPrice: number | null }>, project: { __typename?: 'Project', id: string, modelTitle: string | null, modelTypeName: string | null, modelYear: number | null, title: string, uid: string, projectSchedules: Array<{ __typename?: 'ProjectSchedule', id: string | null, eventName: string, eventOn: any | null, qualificationLevelName: string | null }>, projectModel: { __typename?: 'ProjectModel', id: string, deliverySiteName: string | null, manufacturingSiteName: string | null, productWeight: number | null, name: string | null, code: string | null, customerName: string | null, customerDevelopmentCode: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null } | null } | null, projectItem: { __typename?: 'ProjectItem', id: string, quantityPerRoot: number | null } | null, quotationItemChildStructs: Array<{ __typename?: 'QuotationItemChildStruct', id: string, level: number, parentId: string | null, quantityPerRoot: number, quotationRequestKind: QuotationRequestKindEnum, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, figureNumber: string | null } | null, tenantUnit: { __typename?: 'TenantUnit', id: string, name: string } }> }, answerPrice: { __typename?: 'AnswerPrice', id: string, quantity: number, quantityFrom: number, quantityTo: number | null, isDeclined: boolean, priceBasis: string, taxType: number, amountExcludingTax: string | null, amountIncludingTax: string | null, unitPrice: number | null, materialCost: number | null, partsCost: number | null, processingCost: number | null, surfaceProcessingCost: number | null, subsidiaryMaterialCost: number | null, materialManagementCost: number | null, materialManagementRate: number | null, processingManagementCost: number | null, processingManagementRate: number | null, managementCost: number | null, quantityInOneBox: number | null, deliveryCostPerBox: number | null, boxCount: number | null, deliveryCost: number | null, packingCostPerBox: number | null, packingCost: number | null, defectCost: number | null, defectRate: number | null, profit: number | null, adjustment: number | null, profitRate: number | null, depreciation: number | null, internalPartSubtotal: number | null, outSourcePartSubtotal: number | null, outSourcePartManagementRate: number | null, paidSupplyPartSubtotal: number | null, deliveryDay: number | null, initialDeliveryDay: number | null, materialDeliveryDay: number | null, materialDeliveryStartDay: number | null, equipmentDeliveryDay: number | null, equipmentDeliveryStartDay: number | null, moldDeliveryDay: number | null, moldDeliveryStartDay: number | null, trialDeliveryDay: number | null, trialDeliveryStartDay: number | null, facilityCost: number | null, jigManagementCost: number | null, propertyRentCost: number | null, designCost: number | null, subsidiaryMaterialManagementRate: number | null, subsidiaryMaterialManagementCost: number | null, quotationItemId: string, quotationItemChildStructId: string | null, answerPartsCosts: Array<{ __typename?: 'AnswerPartsCost', id: string, procurementKind: string | null, seqNo: number, partNo: string | null, partName: string | null, productionPlace: string | null, partSpec: string | null, partsCount: number | null, quantity: number | null, partsUnitPrice: number | null, memo: string | null, partsCost: number }>, answerProcessingCosts: Array<{ __typename?: 'AnswerProcessingCost', id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, memo: string | null, processingCost: number, rateKind: string | null, processingWeight: number | null, costForWeight: number | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostSubtotalPerLot: number | null, setupCostSubtotalPerLot: number | null, processingCostPerLot: number | null, partCostRatio: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSpecialProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerSurfaceProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerMaterialCosts: Array<{ __typename?: 'AnswerMaterialCost', id: string, seqNo: number, materialName: string, thickness: number | null, width: number | null, height: number | null, measure: string | null, weightBeforeProcess: number | null, weightAfterProcess: number | null, basePrice: number | null, adjustment: number | null, materialCostSubtotal: number | null, scrapValueSubtotal: number | null, materialCost: number, procurementKind: string | null, cavity: number | null, scrap1Name: string | null, scrap1Weight: number | null, scrap1UnitPrice: number | null, scrap1Subtotal: number | null, scrap2Name: string | null, scrap2Weight: number | null, scrap2UnitPrice: number | null, scrap2Subtotal: number | null, memo: string | null, baseMaterialCode: string | null, materialCostPerQty: number | null, scrap1SubtotalPerQty: number | null, scrap2SubtotalPerQty: number | null, scrapValueSubtotalPerQty: number | null, quantity: number | null, blendPrimaryMaterialName: string | null, blendPrimaryMaterialRatio: number | null, blendPrimaryMaterialUnitCost: number | null, blendSecondaryMaterialName: string | null, blendSecondaryMaterialRatio: number | null, blendSecondaryMaterialUnitCost: number | null, blendOtherMaterialName: string | null, blendOtherMaterialRatio: number | null, blendOtherMaterialUnitCost: number | null, blendBaseUnitCost: number | null, blendUnitCostMarkupRatio: number | null, lossPurgeLotCount: number | null, lossPurgeTotalWeight: number | null, lossPurgeUnitUsage: number | null, lossPurgeCost: number | null, lossGateUnitUsage: number | null, lossGateCost: number | null, lossRunnerUnitUsage: number | null, lossRunnerCost: number | null, lossOtherMemo: string | null, lossOtherUnitUsage: number | null, lossOtherCost: number | null, lossTotalUnitUsage: number | null, lossTotalCost: number | null, trialShotUnitUsage: number | null, trialShotCost: number | null, adjustmentCostMemo: string | null, adjustmentCost: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, priceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSubsidiaryMaterialCosts: Array<{ __typename?: 'CommonAnswerSubsidiaryMaterialCost', id: string, seqNo: number, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number, note: string | null, totalQuantity: number | null, totalSubsidiaryMaterialCost: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null }>, answerSupplySubparts: Array<{ __typename?: 'CommonAnswerSupplySubpart', id: string, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, quantity: number, quantityDenominator: number, unitPrice: number }> } | null }>, quotationItemsV2: Array<{ __typename?: 'QuotationItemV2', id: string, isRoot: boolean, isNew: boolean | null, quantity: number | null, multiLot: Array<number>, quantityGroups: Array<string>, receiverCode: string | null, receiverName: string | null, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, makerName: string | null, makerCode: string | null, makerModelNumber: string | null, figureNumber: string | null, rootPartCode: string | null, designChangeCode: string | null, itemPropInfosForSupplier: Array<{ __typename?: 'ItemPropInfo', id: string, itemProppableType: string, itemProppableId: string, stringValue: string | null, numberValue: number | null, booleanValue: boolean | null, position: number, itemProp: { __typename?: 'ItemProp', id: string, name: string, code: string | null, unit: string | null, kind: ItemPropKind }, selectedOptions: Array<{ __typename?: 'ItemPropOption', id: string, label: string, position: number }> }>, specAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, designAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> }, quotationItemSelection: { __typename?: 'QuotationItemSelection', isSelected: boolean } | null, quotationItemSupplyParts: Array<{ __typename?: 'CommonSupplyPartInfo', id: string, name: string, code: string, supplyPartId: string | null, tenantId: string, unitPrice: number | null, specs: Array<{ __typename?: 'CommonSupplyPartSpec', id: string | null, code: string | null, name: string | null, unit: string | null, value: string | null }> | null }>, deliverySites: Array<{ __typename?: 'DeliverySite', id: string, name: string, code: string | null }>, tenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string } | null, products: Array<{ __typename?: 'Product', id: string, customerName: string | null, customerDevelopmentCode: string | null, name: string, code: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null, productScheduleGroups: Array<{ __typename?: 'ProductScheduleGroup', id: string, seqNo: number, productSchedules: Array<{ __typename?: 'ProductSchedule', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null }> }> }>, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, quotationItemSupplySubparts: Array<{ __typename?: 'CommonQuotationItemSupplySubpart', id: string, supplyPartName: string | null, partCode: string | null, rootPartCode: string | null, unitPrice: number, quantity: number, quantityDenominator: number, supplyPartCost: number }>, quotationItemMaterials: Array<{ __typename?: 'QuotationItemMaterial', id: string, baseMaterialCode: string | null, materialName: string, thickness: number | null, width: number | null, procurementKind: string | null, materialBasePrice: number | null, scrap1UnitPrice: number | null }>, project: { __typename?: 'Project', id: string, modelTitle: string | null, modelTypeName: string | null, modelYear: number | null, title: string, uid: string, projectSchedules: Array<{ __typename?: 'ProjectSchedule', id: string | null, eventName: string, eventOn: any | null, qualificationLevelName: string | null }>, projectModel: { __typename?: 'ProjectModel', id: string, deliverySiteName: string | null, manufacturingSiteName: string | null, productWeight: number | null, name: string | null, code: string | null, customerName: string | null, customerDevelopmentCode: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null } | null } | null, projectItem: { __typename?: 'ProjectItem', id: string, quantityPerRoot: number | null } | null, quotationItemChildStructs: Array<{ __typename?: 'QuotationItemChildStruct', id: string, level: number, parentId: string | null, quantityPerRoot: number, quotationRequestKind: QuotationRequestKindEnum, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, figureNumber: string | null } | null, tenantUnit: { __typename?: 'TenantUnit', id: string, name: string } }> }>, quotationRequest: { __typename?: 'QuotationRequest', id: string, isAnswered: boolean, isDeclined: boolean, answeredAt: any | null, requestedOn: any | null, isLocked: boolean, commentForSupplier: string | null, personInCharge: string, supplierCountryId: string, answeredAtZoned: any | null, statusForSupplier: string, isCanBeAnswered: boolean, isCanBeDeclined: boolean, answer: { __typename?: 'Answer', declineReason: string | null, id: string, status: string, statusLabel: string, memo: string | null, expiredAt: any | null, isDirect: boolean, isFileAnswer: boolean, isSupplierFileAnswer: boolean, dayType: string | null, quotationNo: string | null, expirationDate: string | null, currencyId: string, facilityCost: number, currencyExchangeNote: string | null, inputKind: string, quotationCopiedFrom: { __typename?: 'Quotation', id: string, uid: string } | null, answerPrices: Array<{ __typename?: 'AnswerPrice', id: string, quantity: number, quantityFrom: number, quantityTo: number | null, isDeclined: boolean, priceBasis: string, taxType: number, amountExcludingTax: string | null, amountIncludingTax: string | null, unitPrice: number | null, materialCost: number | null, partsCost: number | null, processingCost: number | null, surfaceProcessingCost: number | null, subsidiaryMaterialCost: number | null, materialManagementCost: number | null, materialManagementRate: number | null, processingManagementCost: number | null, processingManagementRate: number | null, managementCost: number | null, quantityInOneBox: number | null, deliveryCostPerBox: number | null, boxCount: number | null, deliveryCost: number | null, packingCostPerBox: number | null, packingCost: number | null, defectCost: number | null, defectRate: number | null, profit: number | null, adjustment: number | null, profitRate: number | null, depreciation: number | null, internalPartSubtotal: number | null, outSourcePartSubtotal: number | null, outSourcePartManagementRate: number | null, paidSupplyPartSubtotal: number | null, deliveryDay: number | null, initialDeliveryDay: number | null, materialDeliveryDay: number | null, materialDeliveryStartDay: number | null, equipmentDeliveryDay: number | null, equipmentDeliveryStartDay: number | null, moldDeliveryDay: number | null, moldDeliveryStartDay: number | null, trialDeliveryDay: number | null, trialDeliveryStartDay: number | null, facilityCost: number | null, jigManagementCost: number | null, propertyRentCost: number | null, designCost: number | null, subsidiaryMaterialManagementRate: number | null, subsidiaryMaterialManagementCost: number | null, quotationItemId: string, quotationItemChildStructId: string | null, answerPartsCosts: Array<{ __typename?: 'AnswerPartsCost', id: string, procurementKind: string | null, seqNo: number, partNo: string | null, partName: string | null, productionPlace: string | null, partSpec: string | null, partsCount: number | null, quantity: number | null, partsUnitPrice: number | null, memo: string | null, partsCost: number }>, answerProcessingCosts: Array<{ __typename?: 'AnswerProcessingCost', id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, memo: string | null, processingCost: number, rateKind: string | null, processingWeight: number | null, costForWeight: number | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostSubtotalPerLot: number | null, setupCostSubtotalPerLot: number | null, processingCostPerLot: number | null, partCostRatio: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSpecialProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerSurfaceProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerMaterialCosts: Array<{ __typename?: 'AnswerMaterialCost', id: string, seqNo: number, materialName: string, thickness: number | null, width: number | null, height: number | null, measure: string | null, weightBeforeProcess: number | null, weightAfterProcess: number | null, basePrice: number | null, adjustment: number | null, materialCostSubtotal: number | null, scrapValueSubtotal: number | null, materialCost: number, procurementKind: string | null, cavity: number | null, scrap1Name: string | null, scrap1Weight: number | null, scrap1UnitPrice: number | null, scrap1Subtotal: number | null, scrap2Name: string | null, scrap2Weight: number | null, scrap2UnitPrice: number | null, scrap2Subtotal: number | null, memo: string | null, baseMaterialCode: string | null, materialCostPerQty: number | null, scrap1SubtotalPerQty: number | null, scrap2SubtotalPerQty: number | null, scrapValueSubtotalPerQty: number | null, quantity: number | null, blendPrimaryMaterialName: string | null, blendPrimaryMaterialRatio: number | null, blendPrimaryMaterialUnitCost: number | null, blendSecondaryMaterialName: string | null, blendSecondaryMaterialRatio: number | null, blendSecondaryMaterialUnitCost: number | null, blendOtherMaterialName: string | null, blendOtherMaterialRatio: number | null, blendOtherMaterialUnitCost: number | null, blendBaseUnitCost: number | null, blendUnitCostMarkupRatio: number | null, lossPurgeLotCount: number | null, lossPurgeTotalWeight: number | null, lossPurgeUnitUsage: number | null, lossPurgeCost: number | null, lossGateUnitUsage: number | null, lossGateCost: number | null, lossRunnerUnitUsage: number | null, lossRunnerCost: number | null, lossOtherMemo: string | null, lossOtherUnitUsage: number | null, lossOtherCost: number | null, lossTotalUnitUsage: number | null, lossTotalCost: number | null, trialShotUnitUsage: number | null, trialShotCost: number | null, adjustmentCostMemo: string | null, adjustmentCost: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, priceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSubsidiaryMaterialCosts: Array<{ __typename?: 'CommonAnswerSubsidiaryMaterialCost', id: string, seqNo: number, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number, note: string | null, totalQuantity: number | null, totalSubsidiaryMaterialCost: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null }>, answerSupplySubparts: Array<{ __typename?: 'CommonAnswerSupplySubpart', id: string, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, quantity: number, quantityDenominator: number, unitPrice: number }> }>, answerFacilityCosts: Array<{ __typename?: 'AnswerFacilityCost', id: string, name: string, maker: string | null, spec: string | null, quantity: number | null, facilityUnitPrice: number | null, facilityCost: number, isLend: boolean | null, amortizationCost: number | null, amortizationNumber: number | null, amortizationPeriod: string | null, cavity: number | null, leadTime: string | null, memo: string | null, amortizationPeriodAsYear: number | null, paymentTimingKind: string | null, recuttingCount: number | null, answerProcessingCostId: string | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null, facilityKind: { __typename?: 'FacilityKind', id: string }, parts: Array<{ __typename?: 'Part', id: string, name: string, displayCode: string }>, quotationItems: Array<{ __typename?: 'QuotationItemV2', id: string, itemRequirement: { __typename?: 'ItemRequirement', name: string, code: string | null } }> }>, answerInquiries: Array<{ __typename?: 'AnswerInquiry', id: string, answerValueString: string | null, answerValueNumber: number | null, answerValueBoolean: boolean | null, quotationInquiry: { __typename?: 'QuotationInquiry', id: string, seqNo: number, title: string, inquiryType: string, unit: string | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null, supplierCorporationAttachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }>, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierCorporationAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierAccount: { __typename?: 'SupplierAccount', id: string, name: string } | null, supplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null, answerSupplyChainItemDetails: Array<{ __typename?: 'AnswerSupplyChainItemDetail', id: string | null, tenantId: string | null, quotationItemId: string | null, answerId: string | null, processName: string | null, supplierName: string | null, isAlternative: boolean | null, isNew: boolean | null, note: string | null, factoryName: string | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null }>, answerItems: Array<{ __typename?: 'AnswerItem', quotationItemId: string, minimumOrderQuantity: string | null, deliveryForm: string | null, quantityPerDeliveryForm: string | null, priceEffectiveFrom: any | null, priceEffectiveTo: any | null, specMemo: string | null, originLocation: string | null }>, wholesalerKnowledges: Array<{ __typename?: 'WholesalerKnowledge', quotationItemId: string, makerActualPartName: string | null }>, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null, answerOriginalFiles: Array<{ __typename?: 'AnswerOriginalFile', attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null, supplierCorporationAttachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }>, answerExcelAttachments: Array<{ __typename?: 'AnswerExcelAttachment', id: string | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null, supplierCorporationAttachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }> } | null, pdfImportResult: { __typename?: 'PdfImportResult', id: string, signedUrl: string, fileName: string } | null, currencies: Array<{ __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean }>, supplier: { __typename?: 'Supplier', id: string, code: string, name: string, isEligibleToSubcontractAct: boolean } }, applicationFormat: { __typename?: 'ApplicationFormat', isUseReceiver: boolean, isUseDesignAttachment: boolean, isUseSpecAttachment: boolean, isUseFigureNumber: boolean, quantityUnit: string | null, isUseIsNew: boolean, isUseDeliverySite: boolean, isSendSelectionMail: boolean, isUseQuotationContext: boolean, isUseQcIncoterms: boolean, isUseQcRuleOfCurrencyRateChange: boolean, isUseQcRuleOfMarketChange: boolean, isUseRequestProcess: boolean, isUseMaterialPriceReferenceDate: boolean, isUseAssumedExchangeRateUsd: boolean, isUseAssumedExchangeRateCny: boolean, isUsePartSupplyPresence: boolean, isUseMaterialSupplyPresence: boolean, isUseCostBearingDolly: boolean, isUseCostBearingInitialCost: boolean, isUsePaymentMethod: boolean, isUsePaymentInstallmentInitialCost: boolean, isUseMassProductionCategory: boolean, isUseMaker: boolean, isUseItemPropInfo: boolean, productScheduleSettings: Array<{ __typename?: 'ProductScheduleSetting', groupSeqNo: number, seqNo: number, name: string }>, itemProps: Array<{ __typename?: 'ItemProp', id: string, name: string, code: string | null, unit: string | null, kind: ItemPropKind }> }, answerFormat: { __typename?: 'AnswerFormat', id: string, isUseMaterialCost: boolean, isUseMaterialCostDetail: boolean, isUseMaterialSize: boolean, isUseMaterialScrap: boolean, isUseMaterialCostProcurementKind: boolean, isUseMaterialCostCavity: boolean, isUseMaterialCostAdjustment: boolean, isUseMaterialCostMemo: boolean, isUseMaterialCostThickness: boolean, isUseMaterialCostWidth: boolean, isUseMaterialCostHeight: boolean, isUseMaterialCostMeasure: boolean, isUseMaterialCostWeightBeforeProcess: boolean, isUseMaterialCostWeightAfterProcess: boolean, isUseMaterialCostBasePrice: boolean, isUsePartsCost: boolean, isUsePartsCostDetail: boolean, isUsePartsCostProcurementKind: boolean, isUsePartsCostPartNo: boolean, isUsePartsCostPartName: boolean, isUsePartsCostProductionPlace: boolean, isUsePartsCostQuantity: boolean, isUsePartsCostPartsUnitPrice: boolean, isUsePartsCostMemo: boolean, isUsePartsCostPartSpec: boolean, isUsePartsCostPartsCount: boolean, isUseProcessingCost: boolean, isUseProcessingCostDetail: boolean, isUseProcessingCostProductionLot: boolean, isUseProcessingCostEquipmentName: boolean, isUseProcessingCostProcessingTimeHour: boolean, isUseProcessingCostProcessingTimeMinute: boolean, isUseProcessingCostProcessingTimeSecond: boolean, isUseProcessingCostProcessingRate: boolean, isUseSetupInformation: boolean, isUseProcessingCostProcessingTimes: boolean, isUseProcessingCostSetupTimeHour: boolean, isUseProcessingCostSetupTimeMinute: boolean, isUseProcessingCostSetupTimeSecond: boolean, isUseProcessingCostSetupRate: boolean, isUseProcessingCostProcessingCostSubtotal: boolean, isUseProcessingCostSetupCostSubtotal: boolean, isUseProcessingCostMemo: boolean, processingCostRateKind: string | null, isUseManagementCost: boolean, isUseMaterialManagementRate: boolean, isUseMaterialManagementCost: boolean, isUseProcessingManagementRate: boolean, isUseProcessingManagementCost: boolean, isUseDeliveryCost: boolean, isUseDeliveryBoxInformation: boolean, isUsePackingCost: boolean, isUsePackingBoxInformation: boolean, isUseDefectCost: boolean, isUseDefectRate: boolean, isUseProfit: boolean, isUseProfitRate: boolean, isUseAdjustment: boolean, isUseDepreciation: boolean, isUseInternalPartSubtotal: boolean, isUseOutSourcePartSubtotal: boolean, isUseOutSourcePartManagementRate: boolean, isUsePaidSupplyPartSubtotal: boolean, isUseInitialDeliveryDay: boolean, isUseMaterialDeliveryDay: boolean, isUseEquipmentDeliveryDay: boolean, isUseMoldDeliveryDay: boolean, isUseTrialDeliveryDay: boolean, isUseDeliveryDay: boolean, isUseGanttForDeliveryDay: boolean, isUseSurfaceProcessingCost: boolean, isUseSubsidiaryMaterialCost: boolean, isUseSubsidiaryMaterialCostDetail: boolean, isSetScrapName: boolean, scrap1Name: string | null, scrap2Name: string | null, isUseCurrencyExchangeNote: boolean, isUseAnswerByItem: boolean, isUseMinimumOrderQuantity: boolean, isUseDeliveryForm: boolean, isUseQuantityPerDeliveryForm: boolean, isUsePriceEffectiveDate: boolean, priceRegistrationFormatId: string | null, answerMethod: string, isUseProcessingWeight: boolean, isUseCostForWeight: boolean, isUseProcessingHeadcount: boolean, calculationKind: string, isUseWholesalerKnowledge: boolean, useMakerActualPartName: string, makerActualPartNameHelperTxt: string | null, materialCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, materialCostPriceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, specialProcessingDetailFormatsList: Array<{ __typename?: 'CommonSpecialProcessingDetailFormat', kind: string, kindLabel: string, isUseProductionLot: boolean, isUseEquipmentName: boolean, isUseProcessingTimeHour: boolean, isUseProcessingTimeMinute: boolean, isUseProcessingTimeSecond: boolean, isUseProcessingRate: boolean, isUseSetupInformation: boolean, isUseSetupTimeHour: boolean, isUseSetupTimeMinute: boolean, isUseSetupTimeSecond: boolean, isUseSetupRate: boolean, isUseMemo: boolean, isUseProcessingTimes: boolean, isUseProcessingCostSubtotal: boolean, isUseSetupCostSubtotal: boolean, rateKind: string | null }>, processingCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, facilityKinds: Array<{ __typename?: 'FacilityKind', id: string, code: string | null, name: string }> }, quotationProducts: Array<{ __typename?: 'QuotationProduct', productId: string | null, productInformation: string | null, customerName: string | null, customerDevelopmentCode: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, developmentCode: string | null, productDevision: string | null, productDetail: string | null, productManufacturingLocation: string | null, orderType: string | null, orderProbability: string | null, productScheduleGroupSnapshots: Array<{ __typename?: 'ProductScheduleGroupSnapshot', id: string, seqNo: number, productSchedules: Array<{ __typename?: 'ProductScheduleSnapshot', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null }> }> }>, quotationProductSchedules: Array<{ __typename?: 'QuotationProductSchedule', id: string | null, groupSeqNo: number, seqNo: number, name: string, value: string | null }>, tenant: { __typename?: 'Tenant', id: string, name: string, code: string, productConfig: { __typename?: 'ProductConfig', isVisibleDevelopmentCode: boolean, isVisibleName: boolean, isVisibleCustomerName: boolean, isVisibleCustomerDevelopmentCode: boolean, isVisibleDivision: boolean, isVisibleDetail: boolean, isVisibleManufacturingLocation: boolean, isVisibleAnnualQuantity: boolean, isVisibleScheduledSalesDate: boolean, isVisibleOrderType: boolean, isVisibleOrderProbability: boolean, isUseCustomerName: boolean, isUseCustomerDevelopmentCode: boolean, isUseDivision: boolean, isUseDetail: boolean, isUseManufacturingLocation: boolean, isUseAnnualQuantity: boolean, isUseScheduledSalesDate: boolean, isUseOrderType: boolean, isUseOrderProbability: boolean } | null, quotationConfig: { __typename?: 'QuotationConfig', dayTypeSetting: string, deliveryInputKind: string, isUseTemporaryAnswer: boolean, isUseQuotationPackage: boolean, isUseComment: boolean, isUseFieldComment: boolean } | null, attachmentOfferConfig: { __typename?: 'AttachmentOfferConfig', isActiveOnQuotation: boolean } | null }, quotationInquiries: Array<{ __typename?: 'QuotationInquiry', id: string, seqNo: number, title: string, inquiryType: string, unit: string | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }>, uniqFacilityKinds: Array<{ __typename?: 'FacilityKind', id: string, name: string, isUseMaker: boolean, isUseSpec: boolean, isUseLend: boolean, isUseAmortizationNumber: boolean, isUseAmortizationPeriod: boolean, isUsePart: boolean, isUseProcessing: boolean, isUseCavity: boolean, isUseLeadTime: boolean, isUseAmortizationPeriodAsYear: boolean, isUsePaymentTimingKind: boolean, isUseRecuttingCount: boolean }>, previousQuotation: { __typename?: 'Quotation', id: string, uid: string } | null, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null, supplierQuotationPackage: { __typename?: 'SupplierQuotationPackage', id: string, title: string, answerEntryKind: string } | null, attachmentOffers: Array<{ __typename?: 'AttachmentOffer', id: string, isDiscardNecessary: boolean, status: string, kind: string | null, isDownloadable: boolean, attachment: { __typename?: 'Attachment', id: string, nameForSupplier: string | null }, tenant: { __typename?: 'Tenant', id: string } }> };

export type SameGroupPartsFieldFragment = { __typename?: 'Part', id: string, code: string | null, name: string };

export type SpecialProcessingDetailFormatFieldFragment = { __typename?: 'CommonSpecialProcessingDetailFormat', kind: string, kindLabel: string, isUseProductionLot: boolean, isUseEquipmentName: boolean, isUseProcessingTimeHour: boolean, isUseProcessingTimeMinute: boolean, isUseProcessingTimeSecond: boolean, isUseProcessingRate: boolean, isUseSetupInformation: boolean, isUseSetupTimeHour: boolean, isUseSetupTimeMinute: boolean, isUseSetupTimeSecond: boolean, isUseSetupRate: boolean, isUseMemo: boolean, isUseProcessingTimes: boolean, isUseProcessingCostSubtotal: boolean, isUseSetupCostSubtotal: boolean, rateKind: string | null };

export type StateFieldFragment = { __typename?: 'State', id: string, name: string };

export type SupplierAccountFieldFragment = { __typename?: 'SupplierAccount', id: string, name: string };

export type SupplierAccountCoreFieldFragment = { __typename?: 'SupplierAccount', id: string, name: string, email: string, tel: string, department: string, title: string, languageCode: string, csvExportEncodingKind: SupplierUserCsvExportEncodingKindEnum, supplierAccountTenantLinks: Array<{ __typename?: 'SupplierAccountTenantLink', id: string, tenant: { __typename?: 'Tenant', id: string, name: string } }> };

export type SupplierAccountProfileFieldFragment = { __typename?: 'SupplierAccount', id: string, name: string, email: string, tel: string, department: string, title: string, languageCode: string, csvExportEncodingKind: SupplierUserCsvExportEncodingKindEnum, profileTenantAssignments: Array<{ __typename?: 'TenantMemberAssignment', id: string, tenantId: string, tenantName: string, supplierCode: string, startedAt: any, endedAt: any | null, isSendNotification: boolean, isArchived: boolean, isSendSupplierFirmInfoConfirmationRequest: boolean, supplierAccountId: string | null, supplierAccountTenantLinkId: string | null }>, supplierAccountTenantLinks: Array<{ __typename?: 'SupplierAccountTenantLink', id: string, tenant: { __typename?: 'Tenant', id: string, name: string } }> };

export type SupplierAccountTenantMemberFieldFragment = { __typename?: 'SupplierAccount', hasExistingSceOnTenant: boolean, id: string, name: string, email: string, tel: string, department: string, title: string, languageCode: string, csvExportEncodingKind: SupplierUserCsvExportEncodingKindEnum, tenantMemberAssignments: Array<{ __typename?: 'TenantMemberAssignment', id: string, tenantId: string, tenantName: string, supplierCode: string, startedAt: any, endedAt: any | null, isSendNotification: boolean, isArchived: boolean, isSendSupplierFirmInfoConfirmationRequest: boolean, supplierAccountId: string | null, supplierAccountTenantLinkId: string | null }>, supplierAccountTenantLinks: Array<{ __typename?: 'SupplierAccountTenantLink', id: string, tenant: { __typename?: 'Tenant', id: string, name: string } }> };

export type SupplierAccountWithInfoFieldFragment = { __typename?: 'SupplierAccount', id: string, name: string, email: string, tel: string, department: string, title: string, languageCode: string, csvExportEncodingKind: SupplierUserCsvExportEncodingKindEnum, supplierAccountTenantLinks: Array<{ __typename?: 'SupplierAccountTenantLink', id: string, tenant: { __typename?: 'Tenant', id: string, name: string } }> };

export type SupplierAccountingItemFieldFragment = { __typename?: 'SupplierAccountingItem', id: string, parentId: string | null, code: string, name: string, isAsset: boolean, isLiability: boolean, isNetAsset: boolean, isEditable: boolean, isSubtraction: boolean, level: number };

export type SupplierAnnouncementFieldFragment = { __typename?: 'SupplierAnnouncement', id: string, title: string, content: string, releasedAt: any, linkText: string, linkUrl: string };

export type SupplierEnqueteAnswerFieldFragment = { __typename?: 'SupplierEnqueteAnswer', answerValue: string | null, isArchived: boolean | null, supplierEnqueteQuestionConfig: { __typename?: 'SupplierEnqueteQuestionConfig', name: string, code: string } };

export type SupplierEnqueteQuestionConfigFieldFragment = { __typename?: 'SupplierEnqueteQuestionConfig', name: string, code: string };

export type SupplierFileClassFieldFragment = { __typename?: 'SupplierFileClass', id: string, name: string, order: number, isSatisfyElectronicBookPreservationAct: boolean, canModifyBySupplierFirmInfoConfirmationRequest: boolean, canSupplierEditCrAnswer: boolean, canSupplierDeleteCrAnswer: boolean };

export type SupplierFileInfoFieldFragment = { __typename?: 'SupplierFileInfo', id: string, isActive: boolean, isArchived: boolean, expirationDateFrom: any | null, expirationDateTo: any | null, registeredAt: any, registeredBy: string | null, memo: string | null, supplierFileClass: { __typename?: 'SupplierFileClass', id: string, name: string, order: number, isSatisfyElectronicBookPreservationAct: boolean, canModifyBySupplierFirmInfoConfirmationRequest: boolean, canSupplierEditCrAnswer: boolean, canSupplierDeleteCrAnswer: boolean }, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } };

export type SupplierFirmAddressFieldFragment = { __typename?: 'SupplierFirmAddress', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null };

export type SupplierFirmInfoConfirmationRequestFieldFragment = { __typename?: 'SupplierFirmInfoConfirmationRequest', id: string, confirmationRequestNo: string, status: SupplierFirmInfoConfirmationRequestStatusEnum, surveyYear: number, answerDate: any | null, answerer: string | null, requestDate: any, dueDate: any, canInputAnswer: boolean, canShowAnswer: boolean, isBasicInfoSelected: boolean, isContactInfoSelected: boolean, isSurveyInfoSelected: boolean, isBusinessBaseInfoSelected: boolean, isEquipmentInfoSelected: boolean, isOutsourcingInfoSelected: boolean, isFileInfoSelected: boolean, isOverdue: boolean, remandComment: string | null, contactName: string | null, contactEmail: string | null, contactTel: string | null, remandedBy: string | null, remandDate: any | null, withdrawnDate: any | null, withdrawnBy: string | null, fileName: string | null, signedUrl: string | null, answerKind: SupplierFirmInfoConfirmationRequestAnswerKindEnum, tenant: { __typename?: 'Tenant', id: string, name: string, code: string }, supplierFirmInfoConfirmationRequestDestinations: Array<{ __typename?: 'SupplierFirmInfoConfirmationRequestDestination', id: string, supplyChainCompanyEmployeeName: string | null, supplyChainCompanyEmployeeEmail: string | null }> };

export type SupplierFirmInfoConfirmationRequestDestinationFieldFragment = { __typename?: 'SupplierFirmInfoConfirmationRequestDestination', id: string, supplyChainCompanyEmployeeName: string | null, supplyChainCompanyEmployeeEmail: string | null };

export type SupplierMoldStorageApplicationFieldFragment = { __typename?: 'SupplierMoldStorageApplication', id: string, uid: string, status: number, applicationDate: any, confirmationDueDate: any, approvalDate: any | null, comment: string, remandComment: string | null, title: string, createdAt: any, updatedAt: any, supplier: { __typename?: 'Supplier', id: string, name: string, code: string }, employee: { __typename?: 'Employee', id: string, name: string }, tenant: { __typename?: 'Tenant', id: string, name: string, code: string }, supplierAccount: { __typename?: 'SupplierAccount', id: string, name: string } | null, supplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> | null, supplierMoldStorageApplicationDetails: Array<{ __typename?: 'SupplierMoldStorageApplicationDetail', id: string, storageCost: number | null, storageStartDate: any | null, publicMemo: string | null, createdAt: any, updatedAt: any, mold: { __typename?: 'Mold', id: string, uid: string, tenantId: string, name: string, width: number | null, depth: number | null, height: number | null, weight: number | null, isNew: boolean | null, isPermanent: boolean | null, manageableId: string | null, manageableType: string | null, publicMemo: string | null, storageLocation: string | null, category: string | null, assetNumber: string | null, storageSymbol: string | null, status: string | null, evidenceComment: string | null, paymentEvidenceComment: string | null, storageEvidenceComment: string | null, disposeEvidenceComment: string | null, supplierDisposeReportComment: string | null, supplierDisposeReportedAt: any | null, employee: { __typename?: 'Employee', id: string, name: string }, supplier: { __typename?: 'Supplier', id: string, name: string, code: string, adminUser: { __typename?: 'AdminUser', id: string, name: string, employee: { __typename?: 'Employee', id: string, name: string } | null } | null }, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string } | null, manageable: { __typename?: 'MoldManageable', id: string, name: string, code: string } | null, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, paymentAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, storageAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, disposeAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierDisposeReportAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, moldStartUp: { __typename?: 'MoldStartUp', id: string, tenantId: string, moldId: string, quotedCost: number | null, acquisitionCost: number | null }, moldProduction: { __typename?: 'MoldProduction', id: string, tenantId: string, moldId: string, outputPerShot: number | null, shotCount: number | null, cumulativePartTransaction: number | null, remainingShotCount: number | null, flowTendency: number | null }, moldStorage: { __typename?: 'MoldStorage', id: string, tenantId: string, moldId: string, storageCost: number | null, retroactivePrice: number | null }, moldDispose: { __typename?: 'MoldDispose', id: string, tenantId: string, moldId: string, disposeCost: number | null, scrapCost: number | null, disposeRequestDate: any | null }, moldLifecycleEvent: { __typename?: 'MoldLifecycleEvent', id: string, tenantId: string, moldId: string, operationStartDate: any | null, inspectionReceiptDate: any | null, productionStartNotificationReceiptDate: any | null, quoteStatementReceiptDate: any | null, storageStartDate: any | null, disposeDate: any | null }, moldUsages: Array<{ __typename?: 'MoldUsage', id: string, moldId: string, targettableType: string | null, targettable: { __typename?: 'Part', id: string, name: string, code: string | null, figureNumber: string | null, rootPartCode: string | null, totalReceivedQuantity: number | null, flowTendency: string | null, partAnnualTotal: { __typename?: 'PartAnnualTotal', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number, quantity4: number, quantity5: number, quantity6: number, quantity7: number, quantity8: number, quantity9: number, quantity10: number, quantity11: number, quantity12: number } | null, partUnofficialAnnouncement: { __typename?: 'PartUnofficialAnnouncement', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number } | null, partTransactions: Array<{ __typename?: 'PartTransaction', id: string, tenantId: string, orderNumber: string | null, orderSeqNo: number | null, receivedOn: any | null, unitPrice: number, receivedQuantity: number, checkNumber: string | null, checkSeqNo: number | null, checkDate: any, subtotal: number, currencyRate: number, part: { __typename?: 'Part', id: string, name: string, code: string | null }, supplier: { __typename?: 'Supplier', id: string, name: string, isTemporary: boolean, code: string }, currency: { __typename?: 'Currency', isBaseCurrency: boolean, currencyCode: string }, toJpy: { __typename?: 'PartTransactionJpy', subtotal: number, unitPrice: number } }> | null } | null }> } }> | null };

export type SupplierOutsourcingClassFieldFragment = { __typename?: 'SupplierOutsourcingClass', id: string, code: string | null, name: string, order: number, isArchived: boolean };

export type SupplierQuotationPackageListItemFieldFragment = { __typename?: 'SupplierQuotationPackage', id: string, title: string, answerEntryKind: string, answerStatusText: string, firstQuotation: { __typename?: 'Quotation', id: string, status: string, answerDueDate: any | null, isFromPurchaseReceipt: boolean } | null, firstQuotationItem: { __typename?: 'QuotationItemV2', id: string, quantity: number | null, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string } } | null, firstQuotationAdminUser: { __typename?: 'AdminUser', id: string, name: string } | null, firstQuotationRequest: { __typename?: 'QuotationRequest', id: string, requestedOn: any | null, supplier: { __typename?: 'Supplier', code: string, name: string } } | null, quotations: Array<{ __typename?: 'Quotation', id: string, uid: string, isFromPurchaseReceipt: boolean, isUseAnswerExcelImport: boolean, quotationRequest: { __typename?: 'QuotationRequest', id: string, isCanBeDeclined: boolean }, quotationItemsV2: Array<{ __typename?: 'QuotationItemV2', id: string }> }> };

export type SupplierScreenItemConfigFieldFragment = { __typename?: 'SupplierScreenItemConfig', componentId: string, itemId: string, visible: boolean, order: number };

export type SupplierScreenSurveyInfoConfigFieldFragment = { __typename?: 'SupplierScreenSurveyInfoConfig', componentId: string, visible: boolean, order: number, width: number };

export type SupplierSurveyInfoImportConfigFieldFragment = { __typename?: 'SupplierSurveyInfoImportConfig', attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null };

export type SupplierUserFieldFragment = { __typename?: 'SupplierUser', id: string, name: string };

export type SupplyPartInfoFieldFragment = { __typename?: 'CommonSupplyPartInfo', id: string, name: string, code: string, supplyPartId: string | null, tenantId: string, unitPrice: number | null, specs: Array<{ __typename?: 'CommonSupplyPartSpec', id: string | null, code: string | null, name: string | null, unit: string | null, value: string | null }> | null };

export type TenantBaseFieldFragment = { __typename?: 'Tenant', id: string, name: string, code: string, manualUrl: string | null, supplierCodesForFirm: Array<string>, quotationConfig: { __typename?: 'QuotationConfig', isUseQuotationPackage: boolean, isUseTemporaryAnswer: boolean } | null };

export type TenantFieldFragment = { __typename?: 'Tenant', id: string, name: string, code: string, manualUrl: string | null, supplierCodesForFirm: Array<string>, supplierAccounts: Array<{ __typename?: 'SupplierAccount', id: string, name: string, email: string, tel: string, department: string, title: string, languageCode: string, csvExportEncodingKind: SupplierUserCsvExportEncodingKindEnum, supplierAccountTenantLinks: Array<{ __typename?: 'SupplierAccountTenantLink', id: string, tenant: { __typename?: 'Tenant', id: string, name: string } }> }>, quotationConfig: { __typename?: 'QuotationConfig', isUseQuotationPackage: boolean, isUseTemporaryAnswer: boolean } | null };

export type TenantDetailFieldFragment = { __typename?: 'Tenant', id: string, name: string, code: string, manualUrl: string | null, supplierCodesForFirm: Array<string>, supplierAccounts: Array<{ __typename?: 'SupplierAccount', id: string, name: string, email: string, tel: string, department: string, title: string, languageCode: string, csvExportEncodingKind: SupplierUserCsvExportEncodingKindEnum, tenantMemberAssignments: Array<{ __typename?: 'TenantMemberAssignment', id: string, tenantId: string, tenantName: string, supplierCode: string, startedAt: any, endedAt: any | null, isSendNotification: boolean, isArchived: boolean, isSendSupplierFirmInfoConfirmationRequest: boolean, supplierAccountId: string | null, supplierAccountTenantLinkId: string | null }>, supplierAccountTenantLinks: Array<{ __typename?: 'SupplierAccountTenantLink', id: string, tenant: { __typename?: 'Tenant', id: string, name: string } }> }>, quotationConfig: { __typename?: 'QuotationConfig', isUseQuotationPackage: boolean, isUseTemporaryAnswer: boolean } | null };

export type TenantMemberAssignmentFieldFragment = { __typename?: 'TenantMemberAssignment', id: string, tenantId: string, tenantName: string, supplierCode: string, startedAt: any, endedAt: any | null, isSendNotification: boolean, isArchived: boolean, isSendSupplierFirmInfoConfirmationRequest: boolean, supplierAccountId: string | null, supplierAccountTenantLinkId: string | null };

export type TenantSelectFieldFragment = { __typename?: 'TenantSelect', tenantSelectOptions: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }> };

export type TenantSelectOptionFieldFragment = { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null };

export type TenantUnitForAnswerFieldFragment = { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } };

export type TenantDirectoryTenantsIndexFieldFragment = { __typename?: 'TenantDirectory', memberCount: number, tenant: { __typename?: 'Tenant', id: string, name: string }, manuals: Array<{ __typename?: 'TenantSupplierManual', supplierCode: string, supplierId: string, supplierName: string, url: string }> };

export type TenantDirectoryMemberAccountTenantsShowFieldFragment = { __typename?: 'SupplierAccount', id: string, name: string, email: string, tenantMemberAssignments: Array<{ __typename?: 'TenantMemberAssignment', id: string, tenantId: string, tenantName: string, supplierCode: string, startedAt: any, endedAt: any | null, isSendNotification: boolean, isArchived: boolean, isSendSupplierFirmInfoConfirmationRequest: boolean, supplierAccountId: string | null, supplierAccountTenantLinkId: string | null }> };

export type TenantDirectoryDetailTenantsShowFieldFragment = { __typename?: 'TenantDirectoryDetail', allowedSupplierCodes: Array<string>, memberCount: number, manuals: Array<{ __typename?: 'TenantSupplierManual', supplierCode: string, supplierId: string, supplierName: string, url: string }>, tenant: { __typename?: 'Tenant', id: string, name: string }, supplierAccounts: Array<{ __typename?: 'SupplierAccount', id: string, name: string, email: string, tenantMemberAssignments: Array<{ __typename?: 'TenantMemberAssignment', id: string, tenantId: string, tenantName: string, supplierCode: string, startedAt: any, endedAt: any | null, isSendNotification: boolean, isArchived: boolean, isSendSupplierFirmInfoConfirmationRequest: boolean, supplierAccountId: string | null, supplierAccountTenantLinkId: string | null }> }> };

export type TenantSupplierManualTenantsFieldFragment = { __typename?: 'TenantSupplierManual', supplierCode: string, supplierId: string, supplierName: string, url: string };

export type TrialQuotationAnswerRevisionFieldFragment = { __typename?: 'TrialQuotationAnswer', id: string, revisionNo: number, state: number, isDeclined: boolean, answerMemo: string, deliveryOn: any | null, quotationValidUntil: any | null, submittedAt: any, items: Array<{ __typename?: 'TrialQuotationAnswerItem', quotationItemId: string, seqNo: number, breakdownSeqNo: number, name: string, makerName: string, makerModel: string, quantity: number | null, unitName: string, taxType: number, unitPrice: number | null, isDeclined: boolean }>, attachments: Array<{ __typename?: 'TrialQuotationAnswerAttachment', id: string, attachmentKind: number, seqNo: number, fileName: string, contentType: string, byteSize: number, url: string, downloadUrl: string }> };

export type ValidationErrFieldFragment = { __typename?: 'ValidationErr', path: string, message: string, shortMessage: string };

export type VersionedAgreementFieldFragment = { __typename?: 'VersionedAgreement', version: string, content: string };

export type AnswerExcelImportV2MutationVariables = Exact<{
  attachments: Array<CommonAttachmentInput> | CommonAttachmentInput;
  quotationRequestId: Scalars['ID']['input'];
}>;


export type AnswerExcelImportV2Mutation = { __typename?: 'Mutation', answerExcelImportV2: { __typename?: 'AnswerExcelImportV2Payload', errors: Array<string>, warnings: Array<string>, answerExcelResult: { __typename?: 'AnswerExcelResultV2', quotationCopiedFrom: { __typename?: 'Quotation', id: string, uid: string } | null, answer: { __typename?: 'AnswerExcelResultAnswerV2', memo: string | null, dayType: string | null, quotationNo: string | null, expirationDate: string | null, facilityCost: number | null, currencyExchangeNote: string | null, currencyId: string | null, answerFacilityCosts: Array<{ __typename?: 'AnswerFacilityCost', name: string, maker: string | null, spec: string | null, quantity: number | null, facilityUnitPrice: number | null, facilityCost: number, isLend: boolean | null, amortizationCost: number | null, amortizationNumber: number | null, amortizationPeriod: string | null, cavity: number | null, leadTime: string | null, memo: string | null, amortizationPeriodAsYear: number | null, paymentTimingKind: string | null, recuttingCount: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null, facilityKind: { __typename?: 'FacilityKind', id: string, name: string }, parts: Array<{ __typename?: 'Part', id: string, name: string, displayCode: string }>, quotationItems: Array<{ __typename?: 'QuotationItemV2', id: string, itemRequirement: { __typename?: 'ItemRequirement', name: string, code: string | null } }> }>, quotationContext: { __typename?: 'QuotationContext', incoterms: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfMarketChange: Array<string>, requestProcess: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, massProductionCategory: Array<string> | null }, answerItems: Array<{ __typename?: 'AnswerItem', quotationItemId: string, minimumOrderQuantity: string | null, deliveryForm: string | null, quantityPerDeliveryForm: string | null, priceEffectiveFrom: any | null, priceEffectiveTo: any | null, specMemo: string | null, originLocation: string | null }> }, itemToAnswer: Array<{ __typename?: 'AnswerExcelItemToAnswerV2', seq: number, quantity: number, quantityGroup: string, rootQuotationItemId: string, totalQuantityOnBranch: number, isDuplicate: boolean, quotationItemAssemblyEntity: { __typename?: 'QuotationItemAssemblyEntity', depth: number, numberCount: number, unitKind: string } | null, quotationItem: { __typename?: 'QuotationItemV2', id: string, isRoot: boolean, isNew: boolean | null, quantity: number | null, multiLot: Array<number>, quantityGroups: Array<string>, receiverCode: string | null, receiverName: string | null, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, makerName: string | null, makerCode: string | null, makerModelNumber: string | null, figureNumber: string | null, rootPartCode: string | null, designChangeCode: string | null, itemPropInfosForSupplier: Array<{ __typename?: 'ItemPropInfo', id: string, itemProppableType: string, itemProppableId: string, stringValue: string | null, numberValue: number | null, booleanValue: boolean | null, position: number, itemProp: { __typename?: 'ItemProp', id: string, name: string, code: string | null, unit: string | null, kind: ItemPropKind }, selectedOptions: Array<{ __typename?: 'ItemPropOption', id: string, label: string, position: number }> }>, specAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, designAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> }, quotationItemSelection: { __typename?: 'QuotationItemSelection', isSelected: boolean } | null, quotationItemSupplyParts: Array<{ __typename?: 'CommonSupplyPartInfo', id: string, name: string, code: string, supplyPartId: string | null, tenantId: string, unitPrice: number | null, specs: Array<{ __typename?: 'CommonSupplyPartSpec', id: string | null, code: string | null, name: string | null, unit: string | null, value: string | null }> | null }>, deliverySites: Array<{ __typename?: 'DeliverySite', id: string, name: string, code: string | null }>, tenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string } | null, products: Array<{ __typename?: 'Product', id: string, customerName: string | null, customerDevelopmentCode: string | null, name: string, code: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null, productScheduleGroups: Array<{ __typename?: 'ProductScheduleGroup', id: string, seqNo: number, productSchedules: Array<{ __typename?: 'ProductSchedule', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null }> }> }>, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, quotationItemSupplySubparts: Array<{ __typename?: 'CommonQuotationItemSupplySubpart', id: string, supplyPartName: string | null, partCode: string | null, rootPartCode: string | null, unitPrice: number, quantity: number, quantityDenominator: number, supplyPartCost: number }>, quotationItemMaterials: Array<{ __typename?: 'QuotationItemMaterial', id: string, baseMaterialCode: string | null, materialName: string, thickness: number | null, width: number | null, procurementKind: string | null, materialBasePrice: number | null, scrap1UnitPrice: number | null }>, project: { __typename?: 'Project', id: string, modelTitle: string | null, modelTypeName: string | null, modelYear: number | null, title: string, uid: string, projectSchedules: Array<{ __typename?: 'ProjectSchedule', id: string | null, eventName: string, eventOn: any | null, qualificationLevelName: string | null }>, projectModel: { __typename?: 'ProjectModel', id: string, deliverySiteName: string | null, manufacturingSiteName: string | null, productWeight: number | null, name: string | null, code: string | null, customerName: string | null, customerDevelopmentCode: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null } | null } | null, projectItem: { __typename?: 'ProjectItem', id: string, quantityPerRoot: number | null } | null, quotationItemChildStructs: Array<{ __typename?: 'QuotationItemChildStruct', id: string, level: number, parentId: string | null, quantityPerRoot: number, quotationRequestKind: QuotationRequestKindEnum, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, figureNumber: string | null } | null, tenantUnit: { __typename?: 'TenantUnit', id: string, name: string } }> }, answerPrice: { __typename?: 'AnswerPriceExcelResultV2', quotationItemId: string, partId: string | null, quantity: number, unitPrice: number | null, materialCost: number | null, partsCost: number | null, processingCost: number | null, materialManagementCost: number | null, materialManagementRate: number | null, processingManagementCost: number | null, processingManagementRate: number | null, managementCost: number | null, quantityInOneBox: number | null, deliveryCostPerBox: number | null, boxCount: number | null, deliveryCost: number | null, packingCostPerBox: number | null, packingCost: number | null, defectCost: number | null, defectRate: number | null, profit: number | null, adjustment: number | null, profitRate: number | null, depreciation: number | null, internalPartSubtotal: number | null, outSourcePartSubtotal: number | null, outSourcePartManagementRate: number | null, paidSupplyPartSubtotal: number | null, deliveryDay: number | null, initialDeliveryDay: number | null, materialDeliveryDay: number | null, materialDeliveryStartDay: number | null, equipmentDeliveryDay: number | null, equipmentDeliveryStartDay: number | null, moldDeliveryDay: number | null, moldDeliveryStartDay: number | null, trialDeliveryDay: number | null, trialDeliveryStartDay: number | null, subsidiaryMaterialCost: number | null, surfaceProcessingCost: number | null, partRelatedFacilityCost: number | null, propertyRentCost: number | null, jigManagementCost: number | null, facilityCost: number | null, designCost: number | null, subsidiaryMaterialManagementRate: number | null, subsidiaryMaterialManagementCost: number | null, quotationItemChildStructId: string | null, answerPartsCosts: Array<{ __typename?: 'AnswerPartsCost', procurementKind: string | null, seqNo: number, partNo: string | null, partName: string | null, productionPlace: string | null, partSpec: string | null, partsCount: number | null, quantity: number | null, partsUnitPrice: number | null, memo: string | null, partsCost: number }>, answerMaterialCosts: Array<{ __typename?: 'AnswerMaterialCost', seqNo: number, materialName: string, thickness: number | null, width: number | null, height: number | null, measure: string | null, weightBeforeProcess: number | null, weightAfterProcess: number | null, basePrice: number | null, adjustment: number | null, materialCostSubtotal: number | null, scrapValueSubtotal: number | null, procurementKind: string | null, materialCost: number, cavity: number | null, scrap1Name: string | null, scrap1Weight: number | null, scrap1UnitPrice: number | null, scrap1Subtotal: number | null, scrap2Name: string | null, scrap2Weight: number | null, scrap2UnitPrice: number | null, scrap2Subtotal: number | null, memo: string | null, baseMaterialCode: string | null, quantity: number | null, materialCostSubtotalPerQty: number | null, scrap1SubtotalPerQty: number | null, scrap2SubtotalPerQty: number | null, scrapValueSubtotalPerQty: number | null, materialCostPerQty: number | null, blendPrimaryMaterialName: string | null, blendPrimaryMaterialRatio: number | null, blendPrimaryMaterialUnitCost: number | null, blendSecondaryMaterialName: string | null, blendSecondaryMaterialRatio: number | null, blendSecondaryMaterialUnitCost: number | null, blendOtherMaterialName: string | null, blendOtherMaterialRatio: number | null, blendOtherMaterialUnitCost: number | null, blendBaseUnitCost: number | null, blendUnitCostMarkupRatio: number | null, lossPurgeLotCount: number | null, lossPurgeTotalWeight: number | null, lossPurgeUnitUsage: number | null, lossPurgeCost: number | null, lossGateUnitUsage: number | null, lossGateCost: number | null, lossRunnerUnitUsage: number | null, lossRunnerCost: number | null, lossOtherMemo: string | null, lossOtherUnitUsage: number | null, lossOtherCost: number | null, lossTotalUnitUsage: number | null, lossTotalCost: number | null, trialShotUnitUsage: number | null, trialShotCost: number | null, adjustmentCostMemo: string | null, adjustmentCost: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, priceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerProcessingCosts: Array<{ __typename?: 'AnswerProcessingCost', seqNo: number, processName: string, productionLot: number | null, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, memo: string | null, processingCost: number, rateKind: string | null, processingWeight: number | null, costForWeight: number | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostSubtotalPerLot: number | null, setupCostSubtotalPerLot: number | null, processingCostPerLot: number | null, partCostRatio: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, answerFacilityCost: { __typename?: 'AnswerFacilityCost', name: string, maker: string | null, spec: string | null, quantity: number | null, facilityUnitPrice: number | null, facilityCost: number, isLend: boolean | null, amortizationNumber: number | null, amortizationPeriod: string | null, cavity: number | null, leadTime: string | null, memo: string | null, amortizationPeriodAsYear: number | null, paymentTimingKind: string | null, recuttingCount: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null, facilityKind: { __typename?: 'FacilityKind', id: string, name: string } } | null }>, answerSpecialProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerSubsidiaryMaterialCosts: Array<{ __typename?: 'CommonAnswerSubsidiaryMaterialCost', seqNo: number, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number, note: string | null, totalQuantity: number | null, totalSubsidiaryMaterialCost: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null }> } | null, childAnswerPrices: Array<{ __typename?: 'AnswerPriceExcelResultV2', quotationItemId: string, partId: string | null, quantity: number, unitPrice: number | null, materialCost: number | null, partsCost: number | null, processingCost: number | null, materialManagementCost: number | null, materialManagementRate: number | null, processingManagementCost: number | null, processingManagementRate: number | null, managementCost: number | null, quantityInOneBox: number | null, deliveryCostPerBox: number | null, boxCount: number | null, deliveryCost: number | null, packingCostPerBox: number | null, packingCost: number | null, defectCost: number | null, defectRate: number | null, profit: number | null, adjustment: number | null, profitRate: number | null, depreciation: number | null, internalPartSubtotal: number | null, outSourcePartSubtotal: number | null, outSourcePartManagementRate: number | null, paidSupplyPartSubtotal: number | null, deliveryDay: number | null, initialDeliveryDay: number | null, materialDeliveryDay: number | null, materialDeliveryStartDay: number | null, equipmentDeliveryDay: number | null, equipmentDeliveryStartDay: number | null, moldDeliveryDay: number | null, moldDeliveryStartDay: number | null, trialDeliveryDay: number | null, trialDeliveryStartDay: number | null, subsidiaryMaterialCost: number | null, surfaceProcessingCost: number | null, partRelatedFacilityCost: number | null, propertyRentCost: number | null, jigManagementCost: number | null, facilityCost: number | null, designCost: number | null, subsidiaryMaterialManagementRate: number | null, subsidiaryMaterialManagementCost: number | null, quotationItemChildStructId: string | null, answerPartsCosts: Array<{ __typename?: 'AnswerPartsCost', procurementKind: string | null, seqNo: number, partNo: string | null, partName: string | null, productionPlace: string | null, partSpec: string | null, partsCount: number | null, quantity: number | null, partsUnitPrice: number | null, memo: string | null, partsCost: number }>, answerMaterialCosts: Array<{ __typename?: 'AnswerMaterialCost', seqNo: number, materialName: string, thickness: number | null, width: number | null, height: number | null, measure: string | null, weightBeforeProcess: number | null, weightAfterProcess: number | null, basePrice: number | null, adjustment: number | null, materialCostSubtotal: number | null, scrapValueSubtotal: number | null, procurementKind: string | null, materialCost: number, cavity: number | null, scrap1Name: string | null, scrap1Weight: number | null, scrap1UnitPrice: number | null, scrap1Subtotal: number | null, scrap2Name: string | null, scrap2Weight: number | null, scrap2UnitPrice: number | null, scrap2Subtotal: number | null, memo: string | null, baseMaterialCode: string | null, quantity: number | null, materialCostSubtotalPerQty: number | null, scrap1SubtotalPerQty: number | null, scrap2SubtotalPerQty: number | null, scrapValueSubtotalPerQty: number | null, materialCostPerQty: number | null, blendPrimaryMaterialName: string | null, blendPrimaryMaterialRatio: number | null, blendPrimaryMaterialUnitCost: number | null, blendSecondaryMaterialName: string | null, blendSecondaryMaterialRatio: number | null, blendSecondaryMaterialUnitCost: number | null, blendOtherMaterialName: string | null, blendOtherMaterialRatio: number | null, blendOtherMaterialUnitCost: number | null, blendBaseUnitCost: number | null, blendUnitCostMarkupRatio: number | null, lossPurgeLotCount: number | null, lossPurgeTotalWeight: number | null, lossPurgeUnitUsage: number | null, lossPurgeCost: number | null, lossGateUnitUsage: number | null, lossGateCost: number | null, lossRunnerUnitUsage: number | null, lossRunnerCost: number | null, lossOtherMemo: string | null, lossOtherUnitUsage: number | null, lossOtherCost: number | null, lossTotalUnitUsage: number | null, lossTotalCost: number | null, trialShotUnitUsage: number | null, trialShotCost: number | null, adjustmentCostMemo: string | null, adjustmentCost: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, priceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerProcessingCosts: Array<{ __typename?: 'AnswerProcessingCost', seqNo: number, processName: string, productionLot: number | null, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, memo: string | null, processingCost: number, rateKind: string | null, processingWeight: number | null, costForWeight: number | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostSubtotalPerLot: number | null, setupCostSubtotalPerLot: number | null, processingCostPerLot: number | null, partCostRatio: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, answerFacilityCost: { __typename?: 'AnswerFacilityCost', name: string, maker: string | null, spec: string | null, quantity: number | null, facilityUnitPrice: number | null, facilityCost: number, isLend: boolean | null, amortizationNumber: number | null, amortizationPeriod: string | null, cavity: number | null, leadTime: string | null, memo: string | null, amortizationPeriodAsYear: number | null, paymentTimingKind: string | null, recuttingCount: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null, facilityKind: { __typename?: 'FacilityKind', id: string, name: string } } | null }>, answerSpecialProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerSubsidiaryMaterialCosts: Array<{ __typename?: 'CommonAnswerSubsidiaryMaterialCost', seqNo: number, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number, note: string | null, totalQuantity: number | null, totalSubsidiaryMaterialCost: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null }> }> }> } | null } | null };

export type AnswerExcelMultipleImportMutationVariables = Exact<{
  attachments: Array<CommonAttachmentInput> | CommonAttachmentInput;
  isValidateOnly?: InputMaybe<Scalars['Boolean']['input']>;
  referenceAttachments?: InputMaybe<Array<CommonAttachmentInput> | CommonAttachmentInput>;
  tenantId: Scalars['ID']['input'];
}>;


export type AnswerExcelMultipleImportMutation = { __typename?: 'Mutation', answerExcelMultipleImport: { __typename?: 'AnswerExcelMultipleImportPayload', results: Array<{ __typename?: 'AnswerExcelMultipleImportResult', attachmentIndex: number | null, errors: Array<string>, fileName: string | null, quotationUid: string | null, warnings: Array<string>, itemToAnswer: Array<{ __typename?: 'AnswerExcelItemToAnswerV2', seq: number, quantity: number, quantityGroup: string, rootQuotationItemId: string, totalQuantityOnBranch: number, isDuplicate: boolean, quotationItemAssemblyEntity: { __typename?: 'QuotationItemAssemblyEntity', depth: number, numberCount: number, unitKind: string } | null, quotationItem: { __typename?: 'QuotationItemV2', id: string, isRoot: boolean, isNew: boolean | null, quantity: number | null, multiLot: Array<number>, quantityGroups: Array<string>, receiverCode: string | null, receiverName: string | null, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, makerName: string | null, makerCode: string | null, makerModelNumber: string | null, figureNumber: string | null, rootPartCode: string | null, designChangeCode: string | null, itemPropInfosForSupplier: Array<{ __typename?: 'ItemPropInfo', id: string, itemProppableType: string, itemProppableId: string, stringValue: string | null, numberValue: number | null, booleanValue: boolean | null, position: number, itemProp: { __typename?: 'ItemProp', id: string, name: string, code: string | null, unit: string | null, kind: ItemPropKind }, selectedOptions: Array<{ __typename?: 'ItemPropOption', id: string, label: string, position: number }> }>, specAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, designAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> }, quotationItemSelection: { __typename?: 'QuotationItemSelection', isSelected: boolean } | null, quotationItemSupplyParts: Array<{ __typename?: 'CommonSupplyPartInfo', id: string, name: string, code: string, supplyPartId: string | null, tenantId: string, unitPrice: number | null, specs: Array<{ __typename?: 'CommonSupplyPartSpec', id: string | null, code: string | null, name: string | null, unit: string | null, value: string | null }> | null }>, deliverySites: Array<{ __typename?: 'DeliverySite', id: string, name: string, code: string | null }>, tenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string } | null, products: Array<{ __typename?: 'Product', id: string, customerName: string | null, customerDevelopmentCode: string | null, name: string, code: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null, productScheduleGroups: Array<{ __typename?: 'ProductScheduleGroup', id: string, seqNo: number, productSchedules: Array<{ __typename?: 'ProductSchedule', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null }> }> }>, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, quotationItemSupplySubparts: Array<{ __typename?: 'CommonQuotationItemSupplySubpart', id: string, supplyPartName: string | null, partCode: string | null, rootPartCode: string | null, unitPrice: number, quantity: number, quantityDenominator: number, supplyPartCost: number }>, quotationItemMaterials: Array<{ __typename?: 'QuotationItemMaterial', id: string, baseMaterialCode: string | null, materialName: string, thickness: number | null, width: number | null, procurementKind: string | null, materialBasePrice: number | null, scrap1UnitPrice: number | null }>, project: { __typename?: 'Project', id: string, modelTitle: string | null, modelTypeName: string | null, modelYear: number | null, title: string, uid: string, projectSchedules: Array<{ __typename?: 'ProjectSchedule', id: string | null, eventName: string, eventOn: any | null, qualificationLevelName: string | null }>, projectModel: { __typename?: 'ProjectModel', id: string, deliverySiteName: string | null, manufacturingSiteName: string | null, productWeight: number | null, name: string | null, code: string | null, customerName: string | null, customerDevelopmentCode: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null } | null } | null, projectItem: { __typename?: 'ProjectItem', id: string, quantityPerRoot: number | null } | null, quotationItemChildStructs: Array<{ __typename?: 'QuotationItemChildStruct', id: string, level: number, parentId: string | null, quantityPerRoot: number, quotationRequestKind: QuotationRequestKindEnum, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, figureNumber: string | null } | null, tenantUnit: { __typename?: 'TenantUnit', id: string, name: string } }> }, answerPrice: { __typename?: 'AnswerPriceExcelResultV2', quotationItemId: string, partId: string | null, quantity: number, unitPrice: number | null, materialCost: number | null, partsCost: number | null, processingCost: number | null, materialManagementCost: number | null, materialManagementRate: number | null, processingManagementCost: number | null, processingManagementRate: number | null, managementCost: number | null, quantityInOneBox: number | null, deliveryCostPerBox: number | null, boxCount: number | null, deliveryCost: number | null, packingCostPerBox: number | null, packingCost: number | null, defectCost: number | null, defectRate: number | null, profit: number | null, adjustment: number | null, profitRate: number | null, depreciation: number | null, internalPartSubtotal: number | null, outSourcePartSubtotal: number | null, outSourcePartManagementRate: number | null, paidSupplyPartSubtotal: number | null, deliveryDay: number | null, initialDeliveryDay: number | null, materialDeliveryDay: number | null, materialDeliveryStartDay: number | null, equipmentDeliveryDay: number | null, equipmentDeliveryStartDay: number | null, moldDeliveryDay: number | null, moldDeliveryStartDay: number | null, trialDeliveryDay: number | null, trialDeliveryStartDay: number | null, subsidiaryMaterialCost: number | null, surfaceProcessingCost: number | null, partRelatedFacilityCost: number | null, propertyRentCost: number | null, jigManagementCost: number | null, facilityCost: number | null, designCost: number | null, subsidiaryMaterialManagementRate: number | null, subsidiaryMaterialManagementCost: number | null, quotationItemChildStructId: string | null, answerPartsCosts: Array<{ __typename?: 'AnswerPartsCost', procurementKind: string | null, seqNo: number, partNo: string | null, partName: string | null, productionPlace: string | null, partSpec: string | null, partsCount: number | null, quantity: number | null, partsUnitPrice: number | null, memo: string | null, partsCost: number }>, answerMaterialCosts: Array<{ __typename?: 'AnswerMaterialCost', seqNo: number, materialName: string, thickness: number | null, width: number | null, height: number | null, measure: string | null, weightBeforeProcess: number | null, weightAfterProcess: number | null, basePrice: number | null, adjustment: number | null, materialCostSubtotal: number | null, scrapValueSubtotal: number | null, procurementKind: string | null, materialCost: number, cavity: number | null, scrap1Name: string | null, scrap1Weight: number | null, scrap1UnitPrice: number | null, scrap1Subtotal: number | null, scrap2Name: string | null, scrap2Weight: number | null, scrap2UnitPrice: number | null, scrap2Subtotal: number | null, memo: string | null, baseMaterialCode: string | null, quantity: number | null, materialCostSubtotalPerQty: number | null, scrap1SubtotalPerQty: number | null, scrap2SubtotalPerQty: number | null, scrapValueSubtotalPerQty: number | null, materialCostPerQty: number | null, blendPrimaryMaterialName: string | null, blendPrimaryMaterialRatio: number | null, blendPrimaryMaterialUnitCost: number | null, blendSecondaryMaterialName: string | null, blendSecondaryMaterialRatio: number | null, blendSecondaryMaterialUnitCost: number | null, blendOtherMaterialName: string | null, blendOtherMaterialRatio: number | null, blendOtherMaterialUnitCost: number | null, blendBaseUnitCost: number | null, blendUnitCostMarkupRatio: number | null, lossPurgeLotCount: number | null, lossPurgeTotalWeight: number | null, lossPurgeUnitUsage: number | null, lossPurgeCost: number | null, lossGateUnitUsage: number | null, lossGateCost: number | null, lossRunnerUnitUsage: number | null, lossRunnerCost: number | null, lossOtherMemo: string | null, lossOtherUnitUsage: number | null, lossOtherCost: number | null, lossTotalUnitUsage: number | null, lossTotalCost: number | null, trialShotUnitUsage: number | null, trialShotCost: number | null, adjustmentCostMemo: string | null, adjustmentCost: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, priceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerProcessingCosts: Array<{ __typename?: 'AnswerProcessingCost', seqNo: number, processName: string, productionLot: number | null, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, memo: string | null, processingCost: number, rateKind: string | null, processingWeight: number | null, costForWeight: number | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostSubtotalPerLot: number | null, setupCostSubtotalPerLot: number | null, processingCostPerLot: number | null, partCostRatio: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, answerFacilityCost: { __typename?: 'AnswerFacilityCost', name: string, maker: string | null, spec: string | null, quantity: number | null, facilityUnitPrice: number | null, facilityCost: number, isLend: boolean | null, amortizationNumber: number | null, amortizationPeriod: string | null, cavity: number | null, leadTime: string | null, memo: string | null, amortizationPeriodAsYear: number | null, paymentTimingKind: string | null, recuttingCount: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null, facilityKind: { __typename?: 'FacilityKind', id: string, name: string } } | null }>, answerSpecialProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerSubsidiaryMaterialCosts: Array<{ __typename?: 'CommonAnswerSubsidiaryMaterialCost', seqNo: number, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number, note: string | null, totalQuantity: number | null, totalSubsidiaryMaterialCost: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null }> } | null, childAnswerPrices: Array<{ __typename?: 'AnswerPriceExcelResultV2', quotationItemId: string, partId: string | null, quantity: number, unitPrice: number | null, materialCost: number | null, partsCost: number | null, processingCost: number | null, materialManagementCost: number | null, materialManagementRate: number | null, processingManagementCost: number | null, processingManagementRate: number | null, managementCost: number | null, quantityInOneBox: number | null, deliveryCostPerBox: number | null, boxCount: number | null, deliveryCost: number | null, packingCostPerBox: number | null, packingCost: number | null, defectCost: number | null, defectRate: number | null, profit: number | null, adjustment: number | null, profitRate: number | null, depreciation: number | null, internalPartSubtotal: number | null, outSourcePartSubtotal: number | null, outSourcePartManagementRate: number | null, paidSupplyPartSubtotal: number | null, deliveryDay: number | null, initialDeliveryDay: number | null, materialDeliveryDay: number | null, materialDeliveryStartDay: number | null, equipmentDeliveryDay: number | null, equipmentDeliveryStartDay: number | null, moldDeliveryDay: number | null, moldDeliveryStartDay: number | null, trialDeliveryDay: number | null, trialDeliveryStartDay: number | null, subsidiaryMaterialCost: number | null, surfaceProcessingCost: number | null, partRelatedFacilityCost: number | null, propertyRentCost: number | null, jigManagementCost: number | null, facilityCost: number | null, designCost: number | null, subsidiaryMaterialManagementRate: number | null, subsidiaryMaterialManagementCost: number | null, quotationItemChildStructId: string | null, answerPartsCosts: Array<{ __typename?: 'AnswerPartsCost', procurementKind: string | null, seqNo: number, partNo: string | null, partName: string | null, productionPlace: string | null, partSpec: string | null, partsCount: number | null, quantity: number | null, partsUnitPrice: number | null, memo: string | null, partsCost: number }>, answerMaterialCosts: Array<{ __typename?: 'AnswerMaterialCost', seqNo: number, materialName: string, thickness: number | null, width: number | null, height: number | null, measure: string | null, weightBeforeProcess: number | null, weightAfterProcess: number | null, basePrice: number | null, adjustment: number | null, materialCostSubtotal: number | null, scrapValueSubtotal: number | null, procurementKind: string | null, materialCost: number, cavity: number | null, scrap1Name: string | null, scrap1Weight: number | null, scrap1UnitPrice: number | null, scrap1Subtotal: number | null, scrap2Name: string | null, scrap2Weight: number | null, scrap2UnitPrice: number | null, scrap2Subtotal: number | null, memo: string | null, baseMaterialCode: string | null, quantity: number | null, materialCostSubtotalPerQty: number | null, scrap1SubtotalPerQty: number | null, scrap2SubtotalPerQty: number | null, scrapValueSubtotalPerQty: number | null, materialCostPerQty: number | null, blendPrimaryMaterialName: string | null, blendPrimaryMaterialRatio: number | null, blendPrimaryMaterialUnitCost: number | null, blendSecondaryMaterialName: string | null, blendSecondaryMaterialRatio: number | null, blendSecondaryMaterialUnitCost: number | null, blendOtherMaterialName: string | null, blendOtherMaterialRatio: number | null, blendOtherMaterialUnitCost: number | null, blendBaseUnitCost: number | null, blendUnitCostMarkupRatio: number | null, lossPurgeLotCount: number | null, lossPurgeTotalWeight: number | null, lossPurgeUnitUsage: number | null, lossPurgeCost: number | null, lossGateUnitUsage: number | null, lossGateCost: number | null, lossRunnerUnitUsage: number | null, lossRunnerCost: number | null, lossOtherMemo: string | null, lossOtherUnitUsage: number | null, lossOtherCost: number | null, lossTotalUnitUsage: number | null, lossTotalCost: number | null, trialShotUnitUsage: number | null, trialShotCost: number | null, adjustmentCostMemo: string | null, adjustmentCost: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, priceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerProcessingCosts: Array<{ __typename?: 'AnswerProcessingCost', seqNo: number, processName: string, productionLot: number | null, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, memo: string | null, processingCost: number, rateKind: string | null, processingWeight: number | null, costForWeight: number | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostSubtotalPerLot: number | null, setupCostSubtotalPerLot: number | null, processingCostPerLot: number | null, partCostRatio: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, answerFacilityCost: { __typename?: 'AnswerFacilityCost', name: string, maker: string | null, spec: string | null, quantity: number | null, facilityUnitPrice: number | null, facilityCost: number, isLend: boolean | null, amortizationNumber: number | null, amortizationPeriod: string | null, cavity: number | null, leadTime: string | null, memo: string | null, amortizationPeriodAsYear: number | null, paymentTimingKind: string | null, recuttingCount: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null, facilityKind: { __typename?: 'FacilityKind', id: string, name: string } } | null }>, answerSpecialProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerSubsidiaryMaterialCosts: Array<{ __typename?: 'CommonAnswerSubsidiaryMaterialCost', seqNo: number, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number, note: string | null, totalQuantity: number | null, totalSubsidiaryMaterialCost: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null }> }> }> | null }> } | null };

export type AddCommentMutationVariables = Exact<{
  targetId: Scalars['ID']['input'];
  commentKind: CommentKindEnum;
  itemKind: Scalars['String']['input'];
  body: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
  attachments?: InputMaybe<Array<AttachmentInput> | AttachmentInput>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddCommentMutation = { __typename?: 'Mutation', addComment: { __typename?: 'AddCommentPayload', errors: Array<string>, commentBase: { __typename?: 'CommentBase', id: string, commentKind: string, targetId: string, itemKind: string, createdAt: any, updatedAt: any, commentNodes: Array<{ __typename?: 'CommentNode', id: string, body: string, parentId: string | null, authorAdminUserId: string | null, authorAdminUserName: string | null, authorSupplierAccountId: string | null, authorSupplierAccountName: string | null, authorSupplierUserId: string | null, authorSupplierUserName: string | null, targetKind: CommentNodeTargetKindEnum, supplierId: string | null, deletedAt: any | null, canEdit: boolean, canDelete: boolean, createdAt: any, updatedAt: any, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierUserInfoCommentConfirmations: Array<{ __typename?: 'SupplierUserInfoCommentConfirmation', id: string, supplierUserInfoId: string | null, confirmedAt: any | null, supplyChainCompanyEmployeeName: string | null, supplierUserInfo: { __typename?: 'SupplierUserInfo', id: string, supplierUserId: string | null } | null }>, userCommentConfirmations: Array<{ __typename?: 'UserCommentConfirmation', id: string, adminUserId: string, confirmedAt: any | null, adminUser: { __typename?: 'AdminUser', id: string, name: string } }> }> } | null } | null };

export type AnswerByAttachmentFileV2MutationVariables = Exact<{
  answerInquiries: Array<CommonAnswerInquiryInput> | CommonAnswerInquiryInput;
  attachment: CommonAttachmentInput;
  quotationRequestId: Scalars['ID']['input'];
}>;


export type AnswerByAttachmentFileV2Mutation = { __typename?: 'Mutation', answerByAttachmentFile: { __typename?: 'AnswerByAttachmentFilePayload', quotation: { __typename?: 'Quotation', id: string, uid: string, status: string, announcementKind: string, kind: string, selectKind: string, closeMemoForSupplier: string | null, answerDueDate: any | null, requestText: string | null, isDetailCostUsed: boolean, isUseAnswerExcelImport: boolean, isRequestSupplyChain: boolean, isBeforeMigration: boolean, isOneOffOrder: boolean, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, itemsToAnswer: Array<{ __typename?: 'ItemToAnswer', seq: number, quantity: number, quantityGroup: string, rootQuotationItemId: string, totalQuantityOnBranch: number, isDuplicate: boolean, quotationItemAssemblyEntity: { __typename?: 'QuotationItemAssemblyEntity', depth: number, numberCount: number, unitKind: string } | null, quotationItem: { __typename?: 'QuotationItemV2', id: string, isRoot: boolean, isNew: boolean | null, quantity: number | null, multiLot: Array<number>, quantityGroups: Array<string>, receiverCode: string | null, receiverName: string | null, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, makerName: string | null, makerCode: string | null, makerModelNumber: string | null, figureNumber: string | null, rootPartCode: string | null, designChangeCode: string | null, itemPropInfosForSupplier: Array<{ __typename?: 'ItemPropInfo', id: string, itemProppableType: string, itemProppableId: string, stringValue: string | null, numberValue: number | null, booleanValue: boolean | null, position: number, itemProp: { __typename?: 'ItemProp', id: string, name: string, code: string | null, unit: string | null, kind: ItemPropKind }, selectedOptions: Array<{ __typename?: 'ItemPropOption', id: string, label: string, position: number }> }>, specAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, designAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> }, quotationItemSelection: { __typename?: 'QuotationItemSelection', isSelected: boolean } | null, quotationItemSupplyParts: Array<{ __typename?: 'CommonSupplyPartInfo', id: string, name: string, code: string, supplyPartId: string | null, tenantId: string, unitPrice: number | null, specs: Array<{ __typename?: 'CommonSupplyPartSpec', id: string | null, code: string | null, name: string | null, unit: string | null, value: string | null }> | null }>, deliverySites: Array<{ __typename?: 'DeliverySite', id: string, name: string, code: string | null }>, tenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string } | null, products: Array<{ __typename?: 'Product', id: string, customerName: string | null, customerDevelopmentCode: string | null, name: string, code: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null, productScheduleGroups: Array<{ __typename?: 'ProductScheduleGroup', id: string, seqNo: number, productSchedules: Array<{ __typename?: 'ProductSchedule', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null }> }> }>, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, quotationItemSupplySubparts: Array<{ __typename?: 'CommonQuotationItemSupplySubpart', id: string, supplyPartName: string | null, partCode: string | null, rootPartCode: string | null, unitPrice: number, quantity: number, quantityDenominator: number, supplyPartCost: number }>, quotationItemMaterials: Array<{ __typename?: 'QuotationItemMaterial', id: string, baseMaterialCode: string | null, materialName: string, thickness: number | null, width: number | null, procurementKind: string | null, materialBasePrice: number | null, scrap1UnitPrice: number | null }>, project: { __typename?: 'Project', id: string, modelTitle: string | null, modelTypeName: string | null, modelYear: number | null, title: string, uid: string, projectSchedules: Array<{ __typename?: 'ProjectSchedule', id: string | null, eventName: string, eventOn: any | null, qualificationLevelName: string | null }>, projectModel: { __typename?: 'ProjectModel', id: string, deliverySiteName: string | null, manufacturingSiteName: string | null, productWeight: number | null, name: string | null, code: string | null, customerName: string | null, customerDevelopmentCode: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null } | null } | null, projectItem: { __typename?: 'ProjectItem', id: string, quantityPerRoot: number | null } | null, quotationItemChildStructs: Array<{ __typename?: 'QuotationItemChildStruct', id: string, level: number, parentId: string | null, quantityPerRoot: number, quotationRequestKind: QuotationRequestKindEnum, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, figureNumber: string | null } | null, tenantUnit: { __typename?: 'TenantUnit', id: string, name: string } }> }, answerPrice: { __typename?: 'AnswerPrice', id: string, quantity: number, quantityFrom: number, quantityTo: number | null, isDeclined: boolean, priceBasis: string, taxType: number, amountExcludingTax: string | null, amountIncludingTax: string | null, unitPrice: number | null, materialCost: number | null, partsCost: number | null, processingCost: number | null, surfaceProcessingCost: number | null, subsidiaryMaterialCost: number | null, materialManagementCost: number | null, materialManagementRate: number | null, processingManagementCost: number | null, processingManagementRate: number | null, managementCost: number | null, quantityInOneBox: number | null, deliveryCostPerBox: number | null, boxCount: number | null, deliveryCost: number | null, packingCostPerBox: number | null, packingCost: number | null, defectCost: number | null, defectRate: number | null, profit: number | null, adjustment: number | null, profitRate: number | null, depreciation: number | null, internalPartSubtotal: number | null, outSourcePartSubtotal: number | null, outSourcePartManagementRate: number | null, paidSupplyPartSubtotal: number | null, deliveryDay: number | null, initialDeliveryDay: number | null, materialDeliveryDay: number | null, materialDeliveryStartDay: number | null, equipmentDeliveryDay: number | null, equipmentDeliveryStartDay: number | null, moldDeliveryDay: number | null, moldDeliveryStartDay: number | null, trialDeliveryDay: number | null, trialDeliveryStartDay: number | null, facilityCost: number | null, jigManagementCost: number | null, propertyRentCost: number | null, designCost: number | null, subsidiaryMaterialManagementRate: number | null, subsidiaryMaterialManagementCost: number | null, quotationItemId: string, quotationItemChildStructId: string | null, answerPartsCosts: Array<{ __typename?: 'AnswerPartsCost', id: string, procurementKind: string | null, seqNo: number, partNo: string | null, partName: string | null, productionPlace: string | null, partSpec: string | null, partsCount: number | null, quantity: number | null, partsUnitPrice: number | null, memo: string | null, partsCost: number }>, answerProcessingCosts: Array<{ __typename?: 'AnswerProcessingCost', id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, memo: string | null, processingCost: number, rateKind: string | null, processingWeight: number | null, costForWeight: number | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostSubtotalPerLot: number | null, setupCostSubtotalPerLot: number | null, processingCostPerLot: number | null, partCostRatio: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSpecialProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerSurfaceProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerMaterialCosts: Array<{ __typename?: 'AnswerMaterialCost', id: string, seqNo: number, materialName: string, thickness: number | null, width: number | null, height: number | null, measure: string | null, weightBeforeProcess: number | null, weightAfterProcess: number | null, basePrice: number | null, adjustment: number | null, materialCostSubtotal: number | null, scrapValueSubtotal: number | null, materialCost: number, procurementKind: string | null, cavity: number | null, scrap1Name: string | null, scrap1Weight: number | null, scrap1UnitPrice: number | null, scrap1Subtotal: number | null, scrap2Name: string | null, scrap2Weight: number | null, scrap2UnitPrice: number | null, scrap2Subtotal: number | null, memo: string | null, baseMaterialCode: string | null, materialCostPerQty: number | null, scrap1SubtotalPerQty: number | null, scrap2SubtotalPerQty: number | null, scrapValueSubtotalPerQty: number | null, quantity: number | null, blendPrimaryMaterialName: string | null, blendPrimaryMaterialRatio: number | null, blendPrimaryMaterialUnitCost: number | null, blendSecondaryMaterialName: string | null, blendSecondaryMaterialRatio: number | null, blendSecondaryMaterialUnitCost: number | null, blendOtherMaterialName: string | null, blendOtherMaterialRatio: number | null, blendOtherMaterialUnitCost: number | null, blendBaseUnitCost: number | null, blendUnitCostMarkupRatio: number | null, lossPurgeLotCount: number | null, lossPurgeTotalWeight: number | null, lossPurgeUnitUsage: number | null, lossPurgeCost: number | null, lossGateUnitUsage: number | null, lossGateCost: number | null, lossRunnerUnitUsage: number | null, lossRunnerCost: number | null, lossOtherMemo: string | null, lossOtherUnitUsage: number | null, lossOtherCost: number | null, lossTotalUnitUsage: number | null, lossTotalCost: number | null, trialShotUnitUsage: number | null, trialShotCost: number | null, adjustmentCostMemo: string | null, adjustmentCost: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, priceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSubsidiaryMaterialCosts: Array<{ __typename?: 'CommonAnswerSubsidiaryMaterialCost', id: string, seqNo: number, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number, note: string | null, totalQuantity: number | null, totalSubsidiaryMaterialCost: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null }>, answerSupplySubparts: Array<{ __typename?: 'CommonAnswerSupplySubpart', id: string, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, quantity: number, quantityDenominator: number, unitPrice: number }> } | null }>, quotationItemsV2: Array<{ __typename?: 'QuotationItemV2', id: string, isRoot: boolean, isNew: boolean | null, quantity: number | null, multiLot: Array<number>, quantityGroups: Array<string>, receiverCode: string | null, receiverName: string | null, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, makerName: string | null, makerCode: string | null, makerModelNumber: string | null, figureNumber: string | null, rootPartCode: string | null, designChangeCode: string | null, itemPropInfosForSupplier: Array<{ __typename?: 'ItemPropInfo', id: string, itemProppableType: string, itemProppableId: string, stringValue: string | null, numberValue: number | null, booleanValue: boolean | null, position: number, itemProp: { __typename?: 'ItemProp', id: string, name: string, code: string | null, unit: string | null, kind: ItemPropKind }, selectedOptions: Array<{ __typename?: 'ItemPropOption', id: string, label: string, position: number }> }>, specAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, designAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> }, quotationItemSelection: { __typename?: 'QuotationItemSelection', isSelected: boolean } | null, quotationItemSupplyParts: Array<{ __typename?: 'CommonSupplyPartInfo', id: string, name: string, code: string, supplyPartId: string | null, tenantId: string, unitPrice: number | null, specs: Array<{ __typename?: 'CommonSupplyPartSpec', id: string | null, code: string | null, name: string | null, unit: string | null, value: string | null }> | null }>, deliverySites: Array<{ __typename?: 'DeliverySite', id: string, name: string, code: string | null }>, tenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string } | null, products: Array<{ __typename?: 'Product', id: string, customerName: string | null, customerDevelopmentCode: string | null, name: string, code: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null, productScheduleGroups: Array<{ __typename?: 'ProductScheduleGroup', id: string, seqNo: number, productSchedules: Array<{ __typename?: 'ProductSchedule', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null }> }> }>, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, quotationItemSupplySubparts: Array<{ __typename?: 'CommonQuotationItemSupplySubpart', id: string, supplyPartName: string | null, partCode: string | null, rootPartCode: string | null, unitPrice: number, quantity: number, quantityDenominator: number, supplyPartCost: number }>, quotationItemMaterials: Array<{ __typename?: 'QuotationItemMaterial', id: string, baseMaterialCode: string | null, materialName: string, thickness: number | null, width: number | null, procurementKind: string | null, materialBasePrice: number | null, scrap1UnitPrice: number | null }>, project: { __typename?: 'Project', id: string, modelTitle: string | null, modelTypeName: string | null, modelYear: number | null, title: string, uid: string, projectSchedules: Array<{ __typename?: 'ProjectSchedule', id: string | null, eventName: string, eventOn: any | null, qualificationLevelName: string | null }>, projectModel: { __typename?: 'ProjectModel', id: string, deliverySiteName: string | null, manufacturingSiteName: string | null, productWeight: number | null, name: string | null, code: string | null, customerName: string | null, customerDevelopmentCode: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null } | null } | null, projectItem: { __typename?: 'ProjectItem', id: string, quantityPerRoot: number | null } | null, quotationItemChildStructs: Array<{ __typename?: 'QuotationItemChildStruct', id: string, level: number, parentId: string | null, quantityPerRoot: number, quotationRequestKind: QuotationRequestKindEnum, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, figureNumber: string | null } | null, tenantUnit: { __typename?: 'TenantUnit', id: string, name: string } }> }>, quotationRequest: { __typename?: 'QuotationRequest', id: string, isAnswered: boolean, isDeclined: boolean, answeredAt: any | null, requestedOn: any | null, isLocked: boolean, commentForSupplier: string | null, personInCharge: string, supplierCountryId: string, answeredAtZoned: any | null, statusForSupplier: string, isCanBeAnswered: boolean, isCanBeDeclined: boolean, answer: { __typename?: 'Answer', declineReason: string | null, id: string, status: string, statusLabel: string, memo: string | null, expiredAt: any | null, isDirect: boolean, isFileAnswer: boolean, isSupplierFileAnswer: boolean, dayType: string | null, quotationNo: string | null, expirationDate: string | null, currencyId: string, facilityCost: number, currencyExchangeNote: string | null, inputKind: string, quotationCopiedFrom: { __typename?: 'Quotation', id: string, uid: string } | null, answerPrices: Array<{ __typename?: 'AnswerPrice', id: string, quantity: number, quantityFrom: number, quantityTo: number | null, isDeclined: boolean, priceBasis: string, taxType: number, amountExcludingTax: string | null, amountIncludingTax: string | null, unitPrice: number | null, materialCost: number | null, partsCost: number | null, processingCost: number | null, surfaceProcessingCost: number | null, subsidiaryMaterialCost: number | null, materialManagementCost: number | null, materialManagementRate: number | null, processingManagementCost: number | null, processingManagementRate: number | null, managementCost: number | null, quantityInOneBox: number | null, deliveryCostPerBox: number | null, boxCount: number | null, deliveryCost: number | null, packingCostPerBox: number | null, packingCost: number | null, defectCost: number | null, defectRate: number | null, profit: number | null, adjustment: number | null, profitRate: number | null, depreciation: number | null, internalPartSubtotal: number | null, outSourcePartSubtotal: number | null, outSourcePartManagementRate: number | null, paidSupplyPartSubtotal: number | null, deliveryDay: number | null, initialDeliveryDay: number | null, materialDeliveryDay: number | null, materialDeliveryStartDay: number | null, equipmentDeliveryDay: number | null, equipmentDeliveryStartDay: number | null, moldDeliveryDay: number | null, moldDeliveryStartDay: number | null, trialDeliveryDay: number | null, trialDeliveryStartDay: number | null, facilityCost: number | null, jigManagementCost: number | null, propertyRentCost: number | null, designCost: number | null, subsidiaryMaterialManagementRate: number | null, subsidiaryMaterialManagementCost: number | null, quotationItemId: string, quotationItemChildStructId: string | null, answerPartsCosts: Array<{ __typename?: 'AnswerPartsCost', id: string, procurementKind: string | null, seqNo: number, partNo: string | null, partName: string | null, productionPlace: string | null, partSpec: string | null, partsCount: number | null, quantity: number | null, partsUnitPrice: number | null, memo: string | null, partsCost: number }>, answerProcessingCosts: Array<{ __typename?: 'AnswerProcessingCost', id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, memo: string | null, processingCost: number, rateKind: string | null, processingWeight: number | null, costForWeight: number | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostSubtotalPerLot: number | null, setupCostSubtotalPerLot: number | null, processingCostPerLot: number | null, partCostRatio: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSpecialProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerSurfaceProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerMaterialCosts: Array<{ __typename?: 'AnswerMaterialCost', id: string, seqNo: number, materialName: string, thickness: number | null, width: number | null, height: number | null, measure: string | null, weightBeforeProcess: number | null, weightAfterProcess: number | null, basePrice: number | null, adjustment: number | null, materialCostSubtotal: number | null, scrapValueSubtotal: number | null, materialCost: number, procurementKind: string | null, cavity: number | null, scrap1Name: string | null, scrap1Weight: number | null, scrap1UnitPrice: number | null, scrap1Subtotal: number | null, scrap2Name: string | null, scrap2Weight: number | null, scrap2UnitPrice: number | null, scrap2Subtotal: number | null, memo: string | null, baseMaterialCode: string | null, materialCostPerQty: number | null, scrap1SubtotalPerQty: number | null, scrap2SubtotalPerQty: number | null, scrapValueSubtotalPerQty: number | null, quantity: number | null, blendPrimaryMaterialName: string | null, blendPrimaryMaterialRatio: number | null, blendPrimaryMaterialUnitCost: number | null, blendSecondaryMaterialName: string | null, blendSecondaryMaterialRatio: number | null, blendSecondaryMaterialUnitCost: number | null, blendOtherMaterialName: string | null, blendOtherMaterialRatio: number | null, blendOtherMaterialUnitCost: number | null, blendBaseUnitCost: number | null, blendUnitCostMarkupRatio: number | null, lossPurgeLotCount: number | null, lossPurgeTotalWeight: number | null, lossPurgeUnitUsage: number | null, lossPurgeCost: number | null, lossGateUnitUsage: number | null, lossGateCost: number | null, lossRunnerUnitUsage: number | null, lossRunnerCost: number | null, lossOtherMemo: string | null, lossOtherUnitUsage: number | null, lossOtherCost: number | null, lossTotalUnitUsage: number | null, lossTotalCost: number | null, trialShotUnitUsage: number | null, trialShotCost: number | null, adjustmentCostMemo: string | null, adjustmentCost: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, priceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSubsidiaryMaterialCosts: Array<{ __typename?: 'CommonAnswerSubsidiaryMaterialCost', id: string, seqNo: number, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number, note: string | null, totalQuantity: number | null, totalSubsidiaryMaterialCost: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null }>, answerSupplySubparts: Array<{ __typename?: 'CommonAnswerSupplySubpart', id: string, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, quantity: number, quantityDenominator: number, unitPrice: number }> }>, answerFacilityCosts: Array<{ __typename?: 'AnswerFacilityCost', id: string, name: string, maker: string | null, spec: string | null, quantity: number | null, facilityUnitPrice: number | null, facilityCost: number, isLend: boolean | null, amortizationCost: number | null, amortizationNumber: number | null, amortizationPeriod: string | null, cavity: number | null, leadTime: string | null, memo: string | null, amortizationPeriodAsYear: number | null, paymentTimingKind: string | null, recuttingCount: number | null, answerProcessingCostId: string | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null, facilityKind: { __typename?: 'FacilityKind', id: string }, parts: Array<{ __typename?: 'Part', id: string, name: string, displayCode: string }>, quotationItems: Array<{ __typename?: 'QuotationItemV2', id: string, itemRequirement: { __typename?: 'ItemRequirement', name: string, code: string | null } }> }>, answerInquiries: Array<{ __typename?: 'AnswerInquiry', id: string, answerValueString: string | null, answerValueNumber: number | null, answerValueBoolean: boolean | null, quotationInquiry: { __typename?: 'QuotationInquiry', id: string, seqNo: number, title: string, inquiryType: string, unit: string | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null, supplierCorporationAttachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }>, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierCorporationAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierAccount: { __typename?: 'SupplierAccount', id: string, name: string } | null, supplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null, answerSupplyChainItemDetails: Array<{ __typename?: 'AnswerSupplyChainItemDetail', id: string | null, tenantId: string | null, quotationItemId: string | null, answerId: string | null, processName: string | null, supplierName: string | null, isAlternative: boolean | null, isNew: boolean | null, note: string | null, factoryName: string | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null }>, answerItems: Array<{ __typename?: 'AnswerItem', quotationItemId: string, minimumOrderQuantity: string | null, deliveryForm: string | null, quantityPerDeliveryForm: string | null, priceEffectiveFrom: any | null, priceEffectiveTo: any | null, specMemo: string | null, originLocation: string | null }>, wholesalerKnowledges: Array<{ __typename?: 'WholesalerKnowledge', quotationItemId: string, makerActualPartName: string | null }>, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null, answerOriginalFiles: Array<{ __typename?: 'AnswerOriginalFile', attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null, supplierCorporationAttachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }>, answerExcelAttachments: Array<{ __typename?: 'AnswerExcelAttachment', id: string | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null, supplierCorporationAttachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }> } | null, pdfImportResult: { __typename?: 'PdfImportResult', id: string, signedUrl: string, fileName: string } | null, currencies: Array<{ __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean }>, supplier: { __typename?: 'Supplier', id: string, code: string, name: string, isEligibleToSubcontractAct: boolean } }, applicationFormat: { __typename?: 'ApplicationFormat', isUseReceiver: boolean, isUseDesignAttachment: boolean, isUseSpecAttachment: boolean, isUseFigureNumber: boolean, quantityUnit: string | null, isUseIsNew: boolean, isUseDeliverySite: boolean, isSendSelectionMail: boolean, isUseQuotationContext: boolean, isUseQcIncoterms: boolean, isUseQcRuleOfCurrencyRateChange: boolean, isUseQcRuleOfMarketChange: boolean, isUseRequestProcess: boolean, isUseMaterialPriceReferenceDate: boolean, isUseAssumedExchangeRateUsd: boolean, isUseAssumedExchangeRateCny: boolean, isUsePartSupplyPresence: boolean, isUseMaterialSupplyPresence: boolean, isUseCostBearingDolly: boolean, isUseCostBearingInitialCost: boolean, isUsePaymentMethod: boolean, isUsePaymentInstallmentInitialCost: boolean, isUseMassProductionCategory: boolean, isUseMaker: boolean, isUseItemPropInfo: boolean, productScheduleSettings: Array<{ __typename?: 'ProductScheduleSetting', groupSeqNo: number, seqNo: number, name: string }>, itemProps: Array<{ __typename?: 'ItemProp', id: string, name: string, code: string | null, unit: string | null, kind: ItemPropKind }> }, answerFormat: { __typename?: 'AnswerFormat', id: string, isUseMaterialCost: boolean, isUseMaterialCostDetail: boolean, isUseMaterialSize: boolean, isUseMaterialScrap: boolean, isUseMaterialCostProcurementKind: boolean, isUseMaterialCostCavity: boolean, isUseMaterialCostAdjustment: boolean, isUseMaterialCostMemo: boolean, isUseMaterialCostThickness: boolean, isUseMaterialCostWidth: boolean, isUseMaterialCostHeight: boolean, isUseMaterialCostMeasure: boolean, isUseMaterialCostWeightBeforeProcess: boolean, isUseMaterialCostWeightAfterProcess: boolean, isUseMaterialCostBasePrice: boolean, isUsePartsCost: boolean, isUsePartsCostDetail: boolean, isUsePartsCostProcurementKind: boolean, isUsePartsCostPartNo: boolean, isUsePartsCostPartName: boolean, isUsePartsCostProductionPlace: boolean, isUsePartsCostQuantity: boolean, isUsePartsCostPartsUnitPrice: boolean, isUsePartsCostMemo: boolean, isUsePartsCostPartSpec: boolean, isUsePartsCostPartsCount: boolean, isUseProcessingCost: boolean, isUseProcessingCostDetail: boolean, isUseProcessingCostProductionLot: boolean, isUseProcessingCostEquipmentName: boolean, isUseProcessingCostProcessingTimeHour: boolean, isUseProcessingCostProcessingTimeMinute: boolean, isUseProcessingCostProcessingTimeSecond: boolean, isUseProcessingCostProcessingRate: boolean, isUseSetupInformation: boolean, isUseProcessingCostProcessingTimes: boolean, isUseProcessingCostSetupTimeHour: boolean, isUseProcessingCostSetupTimeMinute: boolean, isUseProcessingCostSetupTimeSecond: boolean, isUseProcessingCostSetupRate: boolean, isUseProcessingCostProcessingCostSubtotal: boolean, isUseProcessingCostSetupCostSubtotal: boolean, isUseProcessingCostMemo: boolean, processingCostRateKind: string | null, isUseManagementCost: boolean, isUseMaterialManagementRate: boolean, isUseMaterialManagementCost: boolean, isUseProcessingManagementRate: boolean, isUseProcessingManagementCost: boolean, isUseDeliveryCost: boolean, isUseDeliveryBoxInformation: boolean, isUsePackingCost: boolean, isUsePackingBoxInformation: boolean, isUseDefectCost: boolean, isUseDefectRate: boolean, isUseProfit: boolean, isUseProfitRate: boolean, isUseAdjustment: boolean, isUseDepreciation: boolean, isUseInternalPartSubtotal: boolean, isUseOutSourcePartSubtotal: boolean, isUseOutSourcePartManagementRate: boolean, isUsePaidSupplyPartSubtotal: boolean, isUseInitialDeliveryDay: boolean, isUseMaterialDeliveryDay: boolean, isUseEquipmentDeliveryDay: boolean, isUseMoldDeliveryDay: boolean, isUseTrialDeliveryDay: boolean, isUseDeliveryDay: boolean, isUseGanttForDeliveryDay: boolean, isUseSurfaceProcessingCost: boolean, isUseSubsidiaryMaterialCost: boolean, isUseSubsidiaryMaterialCostDetail: boolean, isSetScrapName: boolean, scrap1Name: string | null, scrap2Name: string | null, isUseCurrencyExchangeNote: boolean, isUseAnswerByItem: boolean, isUseMinimumOrderQuantity: boolean, isUseDeliveryForm: boolean, isUseQuantityPerDeliveryForm: boolean, isUsePriceEffectiveDate: boolean, priceRegistrationFormatId: string | null, answerMethod: string, isUseProcessingWeight: boolean, isUseCostForWeight: boolean, isUseProcessingHeadcount: boolean, calculationKind: string, isUseWholesalerKnowledge: boolean, useMakerActualPartName: string, makerActualPartNameHelperTxt: string | null, materialCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, materialCostPriceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, specialProcessingDetailFormatsList: Array<{ __typename?: 'CommonSpecialProcessingDetailFormat', kind: string, kindLabel: string, isUseProductionLot: boolean, isUseEquipmentName: boolean, isUseProcessingTimeHour: boolean, isUseProcessingTimeMinute: boolean, isUseProcessingTimeSecond: boolean, isUseProcessingRate: boolean, isUseSetupInformation: boolean, isUseSetupTimeHour: boolean, isUseSetupTimeMinute: boolean, isUseSetupTimeSecond: boolean, isUseSetupRate: boolean, isUseMemo: boolean, isUseProcessingTimes: boolean, isUseProcessingCostSubtotal: boolean, isUseSetupCostSubtotal: boolean, rateKind: string | null }>, processingCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, facilityKinds: Array<{ __typename?: 'FacilityKind', id: string, code: string | null, name: string }> }, quotationProducts: Array<{ __typename?: 'QuotationProduct', productId: string | null, productInformation: string | null, customerName: string | null, customerDevelopmentCode: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, developmentCode: string | null, productDevision: string | null, productDetail: string | null, productManufacturingLocation: string | null, orderType: string | null, orderProbability: string | null, productScheduleGroupSnapshots: Array<{ __typename?: 'ProductScheduleGroupSnapshot', id: string, seqNo: number, productSchedules: Array<{ __typename?: 'ProductScheduleSnapshot', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null }> }> }>, quotationProductSchedules: Array<{ __typename?: 'QuotationProductSchedule', id: string | null, groupSeqNo: number, seqNo: number, name: string, value: string | null }>, tenant: { __typename?: 'Tenant', id: string, name: string, code: string, productConfig: { __typename?: 'ProductConfig', isVisibleDevelopmentCode: boolean, isVisibleName: boolean, isVisibleCustomerName: boolean, isVisibleCustomerDevelopmentCode: boolean, isVisibleDivision: boolean, isVisibleDetail: boolean, isVisibleManufacturingLocation: boolean, isVisibleAnnualQuantity: boolean, isVisibleScheduledSalesDate: boolean, isVisibleOrderType: boolean, isVisibleOrderProbability: boolean, isUseCustomerName: boolean, isUseCustomerDevelopmentCode: boolean, isUseDivision: boolean, isUseDetail: boolean, isUseManufacturingLocation: boolean, isUseAnnualQuantity: boolean, isUseScheduledSalesDate: boolean, isUseOrderType: boolean, isUseOrderProbability: boolean } | null, quotationConfig: { __typename?: 'QuotationConfig', dayTypeSetting: string, deliveryInputKind: string, isUseTemporaryAnswer: boolean, isUseQuotationPackage: boolean, isUseComment: boolean, isUseFieldComment: boolean } | null, attachmentOfferConfig: { __typename?: 'AttachmentOfferConfig', isActiveOnQuotation: boolean } | null }, quotationInquiries: Array<{ __typename?: 'QuotationInquiry', id: string, seqNo: number, title: string, inquiryType: string, unit: string | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }>, uniqFacilityKinds: Array<{ __typename?: 'FacilityKind', id: string, name: string, isUseMaker: boolean, isUseSpec: boolean, isUseLend: boolean, isUseAmortizationNumber: boolean, isUseAmortizationPeriod: boolean, isUsePart: boolean, isUseProcessing: boolean, isUseCavity: boolean, isUseLeadTime: boolean, isUseAmortizationPeriodAsYear: boolean, isUsePaymentTimingKind: boolean, isUseRecuttingCount: boolean }>, previousQuotation: { __typename?: 'Quotation', id: string, uid: string } | null, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null, supplierQuotationPackage: { __typename?: 'SupplierQuotationPackage', id: string, title: string, answerEntryKind: string } | null, attachmentOffers: Array<{ __typename?: 'AttachmentOffer', id: string, isDiscardNecessary: boolean, status: string, kind: string | null, isDownloadable: boolean, attachment: { __typename?: 'Attachment', id: string, nameForSupplier: string | null }, tenant: { __typename?: 'Tenant', id: string } }> } } | null };

export type AnswerByFileMutationVariables = Exact<{
  answerByFileInput: CommonAnswerByFileInput;
}>;


export type AnswerByFileMutation = { __typename?: 'Mutation', answerByFile: { __typename?: 'AnswerByFilePayload', isSuccess: boolean, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type AnswerCalcMutationVariables = Exact<{
  input: CommonAnswerCalcInput;
}>;


export type AnswerCalcMutation = { __typename?: 'Mutation', answerCalc: { __typename?: 'AnswerCalcPayload', answerCalcResult: { __typename?: 'CommonAnswerCalcResult', answerPrice: { __typename?: 'CommonAnswerCalcResultPrice', unitPrice: number | null, materialCost: number | null, partsCost: number | null, processingCost: number | null, surfaceProcessingCost: number | null, subsidiaryMaterialCost: number | null, paidSupplyPartSubtotal: number | null, facilityCost: number | null, facilityAmortizationCost: number | null }, materialCosts: Array<{ __typename?: 'CommonAnswerCalcMaterialCost', materialCostSubtotal: number | null, scrap1Weight: number | null, scrap1Subtotal: number | null, materialCost: number | null, uid: string | null, scrapValueSubtotal: number | null, materialCostSubtotalPerQty: number | null, materialCostPerQty: number | null, scrapValueSubtotalPerQty: number | null, scrap1SubtotalPerQty: number | null, scrap2SubtotalPerQty: number | null, scrap2Subtotal: number | null }> | null, processingCosts: Array<{ __typename?: 'CommonAnswerCalcProcessingCost', uid: string | null, processingCost: number | null, processingCostSubtotal: number | null, setupCostSubtotal: number | null }> | null, surfaceProcessingCosts: Array<{ __typename?: 'CommonAnswerCalcSpecialProcessingCost', uid: string | null, processingCost: number | null, processingCostSubtotal: number | null, setupCostSubtotal: number | null }> | null, partsCosts: Array<{ __typename?: 'CommonAnswerCalcPartsCost', uid: string | null, partsCost: number | null }> | null, facilityCosts: Array<{ __typename?: 'CommonAnswerCalcResultFacilityCost', uid: string | null, facilityCost: number | null, amortizationCost: number | null, amortizationNumber: number | null }> | null } } | null };

export type AnswerToGeneralEnqueteMutationVariables = Exact<{
  input: AnswerToGeneralEnqueteInput;
}>;


export type AnswerToGeneralEnqueteMutation = { __typename?: 'Mutation', answerToGeneralEnquete: { __typename?: 'AnswerToGeneralEnquetePayload', errors: Array<string>, enqueteAnswer: { __typename?: 'EnqueteAnswer', id: string, status: EnqueteAnswerStatusEnum, answeredAt: any | null, enqueteQuestionAnswers: Array<{ __typename?: 'EnqueteQuestionAnswer', id: string, value: string, enqueteQuestion: { __typename?: 'EnqueteQuestion', id: string }, attachments: Array<{ __typename?: 'Attachment', id: string, name: string }> }> } | null } | null };

export type AnswerUpdateV2MutationVariables = Exact<{
  answer: CommonAnswerInput;
}>;


export type AnswerUpdateV2Mutation = { __typename?: 'Mutation', answerUpdateV2: { __typename?: 'AnswerUpdateV2Payload', quotation: { __typename?: 'Quotation', id: string, uid: string, status: string, announcementKind: string, kind: string, selectKind: string, closeMemoForSupplier: string | null, answerDueDate: any | null, requestText: string | null, isDetailCostUsed: boolean, isUseAnswerExcelImport: boolean, isRequestSupplyChain: boolean, isBeforeMigration: boolean, isOneOffOrder: boolean, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, itemsToAnswer: Array<{ __typename?: 'ItemToAnswer', seq: number, quantity: number, quantityGroup: string, rootQuotationItemId: string, totalQuantityOnBranch: number, isDuplicate: boolean, quotationItemAssemblyEntity: { __typename?: 'QuotationItemAssemblyEntity', depth: number, numberCount: number, unitKind: string } | null, quotationItem: { __typename?: 'QuotationItemV2', id: string, isRoot: boolean, isNew: boolean | null, quantity: number | null, multiLot: Array<number>, quantityGroups: Array<string>, receiverCode: string | null, receiverName: string | null, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, makerName: string | null, makerCode: string | null, makerModelNumber: string | null, figureNumber: string | null, rootPartCode: string | null, designChangeCode: string | null, itemPropInfosForSupplier: Array<{ __typename?: 'ItemPropInfo', id: string, itemProppableType: string, itemProppableId: string, stringValue: string | null, numberValue: number | null, booleanValue: boolean | null, position: number, itemProp: { __typename?: 'ItemProp', id: string, name: string, code: string | null, unit: string | null, kind: ItemPropKind }, selectedOptions: Array<{ __typename?: 'ItemPropOption', id: string, label: string, position: number }> }>, specAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, designAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> }, quotationItemSelection: { __typename?: 'QuotationItemSelection', isSelected: boolean } | null, quotationItemSupplyParts: Array<{ __typename?: 'CommonSupplyPartInfo', id: string, name: string, code: string, supplyPartId: string | null, tenantId: string, unitPrice: number | null, specs: Array<{ __typename?: 'CommonSupplyPartSpec', id: string | null, code: string | null, name: string | null, unit: string | null, value: string | null }> | null }>, deliverySites: Array<{ __typename?: 'DeliverySite', id: string, name: string, code: string | null }>, tenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string } | null, products: Array<{ __typename?: 'Product', id: string, customerName: string | null, customerDevelopmentCode: string | null, name: string, code: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null, productScheduleGroups: Array<{ __typename?: 'ProductScheduleGroup', id: string, seqNo: number, productSchedules: Array<{ __typename?: 'ProductSchedule', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null }> }> }>, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, quotationItemSupplySubparts: Array<{ __typename?: 'CommonQuotationItemSupplySubpart', id: string, supplyPartName: string | null, partCode: string | null, rootPartCode: string | null, unitPrice: number, quantity: number, quantityDenominator: number, supplyPartCost: number }>, quotationItemMaterials: Array<{ __typename?: 'QuotationItemMaterial', id: string, baseMaterialCode: string | null, materialName: string, thickness: number | null, width: number | null, procurementKind: string | null, materialBasePrice: number | null, scrap1UnitPrice: number | null }>, project: { __typename?: 'Project', id: string, modelTitle: string | null, modelTypeName: string | null, modelYear: number | null, title: string, uid: string, projectSchedules: Array<{ __typename?: 'ProjectSchedule', id: string | null, eventName: string, eventOn: any | null, qualificationLevelName: string | null }>, projectModel: { __typename?: 'ProjectModel', id: string, deliverySiteName: string | null, manufacturingSiteName: string | null, productWeight: number | null, name: string | null, code: string | null, customerName: string | null, customerDevelopmentCode: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null } | null } | null, projectItem: { __typename?: 'ProjectItem', id: string, quantityPerRoot: number | null } | null, quotationItemChildStructs: Array<{ __typename?: 'QuotationItemChildStruct', id: string, level: number, parentId: string | null, quantityPerRoot: number, quotationRequestKind: QuotationRequestKindEnum, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, figureNumber: string | null } | null, tenantUnit: { __typename?: 'TenantUnit', id: string, name: string } }> }, answerPrice: { __typename?: 'AnswerPrice', id: string, quantity: number, quantityFrom: number, quantityTo: number | null, isDeclined: boolean, priceBasis: string, taxType: number, amountExcludingTax: string | null, amountIncludingTax: string | null, unitPrice: number | null, materialCost: number | null, partsCost: number | null, processingCost: number | null, surfaceProcessingCost: number | null, subsidiaryMaterialCost: number | null, materialManagementCost: number | null, materialManagementRate: number | null, processingManagementCost: number | null, processingManagementRate: number | null, managementCost: number | null, quantityInOneBox: number | null, deliveryCostPerBox: number | null, boxCount: number | null, deliveryCost: number | null, packingCostPerBox: number | null, packingCost: number | null, defectCost: number | null, defectRate: number | null, profit: number | null, adjustment: number | null, profitRate: number | null, depreciation: number | null, internalPartSubtotal: number | null, outSourcePartSubtotal: number | null, outSourcePartManagementRate: number | null, paidSupplyPartSubtotal: number | null, deliveryDay: number | null, initialDeliveryDay: number | null, materialDeliveryDay: number | null, materialDeliveryStartDay: number | null, equipmentDeliveryDay: number | null, equipmentDeliveryStartDay: number | null, moldDeliveryDay: number | null, moldDeliveryStartDay: number | null, trialDeliveryDay: number | null, trialDeliveryStartDay: number | null, facilityCost: number | null, jigManagementCost: number | null, propertyRentCost: number | null, designCost: number | null, subsidiaryMaterialManagementRate: number | null, subsidiaryMaterialManagementCost: number | null, quotationItemId: string, quotationItemChildStructId: string | null, answerPartsCosts: Array<{ __typename?: 'AnswerPartsCost', id: string, procurementKind: string | null, seqNo: number, partNo: string | null, partName: string | null, productionPlace: string | null, partSpec: string | null, partsCount: number | null, quantity: number | null, partsUnitPrice: number | null, memo: string | null, partsCost: number }>, answerProcessingCosts: Array<{ __typename?: 'AnswerProcessingCost', id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, memo: string | null, processingCost: number, rateKind: string | null, processingWeight: number | null, costForWeight: number | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostSubtotalPerLot: number | null, setupCostSubtotalPerLot: number | null, processingCostPerLot: number | null, partCostRatio: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSpecialProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerSurfaceProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerMaterialCosts: Array<{ __typename?: 'AnswerMaterialCost', id: string, seqNo: number, materialName: string, thickness: number | null, width: number | null, height: number | null, measure: string | null, weightBeforeProcess: number | null, weightAfterProcess: number | null, basePrice: number | null, adjustment: number | null, materialCostSubtotal: number | null, scrapValueSubtotal: number | null, materialCost: number, procurementKind: string | null, cavity: number | null, scrap1Name: string | null, scrap1Weight: number | null, scrap1UnitPrice: number | null, scrap1Subtotal: number | null, scrap2Name: string | null, scrap2Weight: number | null, scrap2UnitPrice: number | null, scrap2Subtotal: number | null, memo: string | null, baseMaterialCode: string | null, materialCostPerQty: number | null, scrap1SubtotalPerQty: number | null, scrap2SubtotalPerQty: number | null, scrapValueSubtotalPerQty: number | null, quantity: number | null, blendPrimaryMaterialName: string | null, blendPrimaryMaterialRatio: number | null, blendPrimaryMaterialUnitCost: number | null, blendSecondaryMaterialName: string | null, blendSecondaryMaterialRatio: number | null, blendSecondaryMaterialUnitCost: number | null, blendOtherMaterialName: string | null, blendOtherMaterialRatio: number | null, blendOtherMaterialUnitCost: number | null, blendBaseUnitCost: number | null, blendUnitCostMarkupRatio: number | null, lossPurgeLotCount: number | null, lossPurgeTotalWeight: number | null, lossPurgeUnitUsage: number | null, lossPurgeCost: number | null, lossGateUnitUsage: number | null, lossGateCost: number | null, lossRunnerUnitUsage: number | null, lossRunnerCost: number | null, lossOtherMemo: string | null, lossOtherUnitUsage: number | null, lossOtherCost: number | null, lossTotalUnitUsage: number | null, lossTotalCost: number | null, trialShotUnitUsage: number | null, trialShotCost: number | null, adjustmentCostMemo: string | null, adjustmentCost: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, priceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSubsidiaryMaterialCosts: Array<{ __typename?: 'CommonAnswerSubsidiaryMaterialCost', id: string, seqNo: number, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number, note: string | null, totalQuantity: number | null, totalSubsidiaryMaterialCost: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null }>, answerSupplySubparts: Array<{ __typename?: 'CommonAnswerSupplySubpart', id: string, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, quantity: number, quantityDenominator: number, unitPrice: number }> } | null }>, quotationItemsV2: Array<{ __typename?: 'QuotationItemV2', id: string, isRoot: boolean, isNew: boolean | null, quantity: number | null, multiLot: Array<number>, quantityGroups: Array<string>, receiverCode: string | null, receiverName: string | null, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, makerName: string | null, makerCode: string | null, makerModelNumber: string | null, figureNumber: string | null, rootPartCode: string | null, designChangeCode: string | null, itemPropInfosForSupplier: Array<{ __typename?: 'ItemPropInfo', id: string, itemProppableType: string, itemProppableId: string, stringValue: string | null, numberValue: number | null, booleanValue: boolean | null, position: number, itemProp: { __typename?: 'ItemProp', id: string, name: string, code: string | null, unit: string | null, kind: ItemPropKind }, selectedOptions: Array<{ __typename?: 'ItemPropOption', id: string, label: string, position: number }> }>, specAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, designAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> }, quotationItemSelection: { __typename?: 'QuotationItemSelection', isSelected: boolean } | null, quotationItemSupplyParts: Array<{ __typename?: 'CommonSupplyPartInfo', id: string, name: string, code: string, supplyPartId: string | null, tenantId: string, unitPrice: number | null, specs: Array<{ __typename?: 'CommonSupplyPartSpec', id: string | null, code: string | null, name: string | null, unit: string | null, value: string | null }> | null }>, deliverySites: Array<{ __typename?: 'DeliverySite', id: string, name: string, code: string | null }>, tenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string } | null, products: Array<{ __typename?: 'Product', id: string, customerName: string | null, customerDevelopmentCode: string | null, name: string, code: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null, productScheduleGroups: Array<{ __typename?: 'ProductScheduleGroup', id: string, seqNo: number, productSchedules: Array<{ __typename?: 'ProductSchedule', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null }> }> }>, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, quotationItemSupplySubparts: Array<{ __typename?: 'CommonQuotationItemSupplySubpart', id: string, supplyPartName: string | null, partCode: string | null, rootPartCode: string | null, unitPrice: number, quantity: number, quantityDenominator: number, supplyPartCost: number }>, quotationItemMaterials: Array<{ __typename?: 'QuotationItemMaterial', id: string, baseMaterialCode: string | null, materialName: string, thickness: number | null, width: number | null, procurementKind: string | null, materialBasePrice: number | null, scrap1UnitPrice: number | null }>, project: { __typename?: 'Project', id: string, modelTitle: string | null, modelTypeName: string | null, modelYear: number | null, title: string, uid: string, projectSchedules: Array<{ __typename?: 'ProjectSchedule', id: string | null, eventName: string, eventOn: any | null, qualificationLevelName: string | null }>, projectModel: { __typename?: 'ProjectModel', id: string, deliverySiteName: string | null, manufacturingSiteName: string | null, productWeight: number | null, name: string | null, code: string | null, customerName: string | null, customerDevelopmentCode: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null } | null } | null, projectItem: { __typename?: 'ProjectItem', id: string, quantityPerRoot: number | null } | null, quotationItemChildStructs: Array<{ __typename?: 'QuotationItemChildStruct', id: string, level: number, parentId: string | null, quantityPerRoot: number, quotationRequestKind: QuotationRequestKindEnum, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, figureNumber: string | null } | null, tenantUnit: { __typename?: 'TenantUnit', id: string, name: string } }> }>, quotationRequest: { __typename?: 'QuotationRequest', id: string, isAnswered: boolean, isDeclined: boolean, answeredAt: any | null, requestedOn: any | null, isLocked: boolean, commentForSupplier: string | null, personInCharge: string, supplierCountryId: string, answeredAtZoned: any | null, statusForSupplier: string, isCanBeAnswered: boolean, isCanBeDeclined: boolean, answer: { __typename?: 'Answer', declineReason: string | null, id: string, status: string, statusLabel: string, memo: string | null, expiredAt: any | null, isDirect: boolean, isFileAnswer: boolean, isSupplierFileAnswer: boolean, dayType: string | null, quotationNo: string | null, expirationDate: string | null, currencyId: string, facilityCost: number, currencyExchangeNote: string | null, inputKind: string, quotationCopiedFrom: { __typename?: 'Quotation', id: string, uid: string } | null, answerPrices: Array<{ __typename?: 'AnswerPrice', id: string, quantity: number, quantityFrom: number, quantityTo: number | null, isDeclined: boolean, priceBasis: string, taxType: number, amountExcludingTax: string | null, amountIncludingTax: string | null, unitPrice: number | null, materialCost: number | null, partsCost: number | null, processingCost: number | null, surfaceProcessingCost: number | null, subsidiaryMaterialCost: number | null, materialManagementCost: number | null, materialManagementRate: number | null, processingManagementCost: number | null, processingManagementRate: number | null, managementCost: number | null, quantityInOneBox: number | null, deliveryCostPerBox: number | null, boxCount: number | null, deliveryCost: number | null, packingCostPerBox: number | null, packingCost: number | null, defectCost: number | null, defectRate: number | null, profit: number | null, adjustment: number | null, profitRate: number | null, depreciation: number | null, internalPartSubtotal: number | null, outSourcePartSubtotal: number | null, outSourcePartManagementRate: number | null, paidSupplyPartSubtotal: number | null, deliveryDay: number | null, initialDeliveryDay: number | null, materialDeliveryDay: number | null, materialDeliveryStartDay: number | null, equipmentDeliveryDay: number | null, equipmentDeliveryStartDay: number | null, moldDeliveryDay: number | null, moldDeliveryStartDay: number | null, trialDeliveryDay: number | null, trialDeliveryStartDay: number | null, facilityCost: number | null, jigManagementCost: number | null, propertyRentCost: number | null, designCost: number | null, subsidiaryMaterialManagementRate: number | null, subsidiaryMaterialManagementCost: number | null, quotationItemId: string, quotationItemChildStructId: string | null, answerPartsCosts: Array<{ __typename?: 'AnswerPartsCost', id: string, procurementKind: string | null, seqNo: number, partNo: string | null, partName: string | null, productionPlace: string | null, partSpec: string | null, partsCount: number | null, quantity: number | null, partsUnitPrice: number | null, memo: string | null, partsCost: number }>, answerProcessingCosts: Array<{ __typename?: 'AnswerProcessingCost', id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, memo: string | null, processingCost: number, rateKind: string | null, processingWeight: number | null, costForWeight: number | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostSubtotalPerLot: number | null, setupCostSubtotalPerLot: number | null, processingCostPerLot: number | null, partCostRatio: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSpecialProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerSurfaceProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerMaterialCosts: Array<{ __typename?: 'AnswerMaterialCost', id: string, seqNo: number, materialName: string, thickness: number | null, width: number | null, height: number | null, measure: string | null, weightBeforeProcess: number | null, weightAfterProcess: number | null, basePrice: number | null, adjustment: number | null, materialCostSubtotal: number | null, scrapValueSubtotal: number | null, materialCost: number, procurementKind: string | null, cavity: number | null, scrap1Name: string | null, scrap1Weight: number | null, scrap1UnitPrice: number | null, scrap1Subtotal: number | null, scrap2Name: string | null, scrap2Weight: number | null, scrap2UnitPrice: number | null, scrap2Subtotal: number | null, memo: string | null, baseMaterialCode: string | null, materialCostPerQty: number | null, scrap1SubtotalPerQty: number | null, scrap2SubtotalPerQty: number | null, scrapValueSubtotalPerQty: number | null, quantity: number | null, blendPrimaryMaterialName: string | null, blendPrimaryMaterialRatio: number | null, blendPrimaryMaterialUnitCost: number | null, blendSecondaryMaterialName: string | null, blendSecondaryMaterialRatio: number | null, blendSecondaryMaterialUnitCost: number | null, blendOtherMaterialName: string | null, blendOtherMaterialRatio: number | null, blendOtherMaterialUnitCost: number | null, blendBaseUnitCost: number | null, blendUnitCostMarkupRatio: number | null, lossPurgeLotCount: number | null, lossPurgeTotalWeight: number | null, lossPurgeUnitUsage: number | null, lossPurgeCost: number | null, lossGateUnitUsage: number | null, lossGateCost: number | null, lossRunnerUnitUsage: number | null, lossRunnerCost: number | null, lossOtherMemo: string | null, lossOtherUnitUsage: number | null, lossOtherCost: number | null, lossTotalUnitUsage: number | null, lossTotalCost: number | null, trialShotUnitUsage: number | null, trialShotCost: number | null, adjustmentCostMemo: string | null, adjustmentCost: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, priceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSubsidiaryMaterialCosts: Array<{ __typename?: 'CommonAnswerSubsidiaryMaterialCost', id: string, seqNo: number, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number, note: string | null, totalQuantity: number | null, totalSubsidiaryMaterialCost: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null }>, answerSupplySubparts: Array<{ __typename?: 'CommonAnswerSupplySubpart', id: string, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, quantity: number, quantityDenominator: number, unitPrice: number }> }>, answerFacilityCosts: Array<{ __typename?: 'AnswerFacilityCost', id: string, name: string, maker: string | null, spec: string | null, quantity: number | null, facilityUnitPrice: number | null, facilityCost: number, isLend: boolean | null, amortizationCost: number | null, amortizationNumber: number | null, amortizationPeriod: string | null, cavity: number | null, leadTime: string | null, memo: string | null, amortizationPeriodAsYear: number | null, paymentTimingKind: string | null, recuttingCount: number | null, answerProcessingCostId: string | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null, facilityKind: { __typename?: 'FacilityKind', id: string }, parts: Array<{ __typename?: 'Part', id: string, name: string, displayCode: string }>, quotationItems: Array<{ __typename?: 'QuotationItemV2', id: string, itemRequirement: { __typename?: 'ItemRequirement', name: string, code: string | null } }> }>, answerInquiries: Array<{ __typename?: 'AnswerInquiry', id: string, answerValueString: string | null, answerValueNumber: number | null, answerValueBoolean: boolean | null, quotationInquiry: { __typename?: 'QuotationInquiry', id: string, seqNo: number, title: string, inquiryType: string, unit: string | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null, supplierCorporationAttachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }>, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierCorporationAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierAccount: { __typename?: 'SupplierAccount', id: string, name: string } | null, supplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null, answerSupplyChainItemDetails: Array<{ __typename?: 'AnswerSupplyChainItemDetail', id: string | null, tenantId: string | null, quotationItemId: string | null, answerId: string | null, processName: string | null, supplierName: string | null, isAlternative: boolean | null, isNew: boolean | null, note: string | null, factoryName: string | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null }>, answerItems: Array<{ __typename?: 'AnswerItem', quotationItemId: string, minimumOrderQuantity: string | null, deliveryForm: string | null, quantityPerDeliveryForm: string | null, priceEffectiveFrom: any | null, priceEffectiveTo: any | null, specMemo: string | null, originLocation: string | null }>, wholesalerKnowledges: Array<{ __typename?: 'WholesalerKnowledge', quotationItemId: string, makerActualPartName: string | null }>, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null, answerOriginalFiles: Array<{ __typename?: 'AnswerOriginalFile', attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null, supplierCorporationAttachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }>, answerExcelAttachments: Array<{ __typename?: 'AnswerExcelAttachment', id: string | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null, supplierCorporationAttachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }> } | null, pdfImportResult: { __typename?: 'PdfImportResult', id: string, signedUrl: string, fileName: string } | null, currencies: Array<{ __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean }>, supplier: { __typename?: 'Supplier', id: string, code: string, name: string, isEligibleToSubcontractAct: boolean } }, applicationFormat: { __typename?: 'ApplicationFormat', isUseReceiver: boolean, isUseDesignAttachment: boolean, isUseSpecAttachment: boolean, isUseFigureNumber: boolean, quantityUnit: string | null, isUseIsNew: boolean, isUseDeliverySite: boolean, isSendSelectionMail: boolean, isUseQuotationContext: boolean, isUseQcIncoterms: boolean, isUseQcRuleOfCurrencyRateChange: boolean, isUseQcRuleOfMarketChange: boolean, isUseRequestProcess: boolean, isUseMaterialPriceReferenceDate: boolean, isUseAssumedExchangeRateUsd: boolean, isUseAssumedExchangeRateCny: boolean, isUsePartSupplyPresence: boolean, isUseMaterialSupplyPresence: boolean, isUseCostBearingDolly: boolean, isUseCostBearingInitialCost: boolean, isUsePaymentMethod: boolean, isUsePaymentInstallmentInitialCost: boolean, isUseMassProductionCategory: boolean, isUseMaker: boolean, isUseItemPropInfo: boolean, productScheduleSettings: Array<{ __typename?: 'ProductScheduleSetting', groupSeqNo: number, seqNo: number, name: string }>, itemProps: Array<{ __typename?: 'ItemProp', id: string, name: string, code: string | null, unit: string | null, kind: ItemPropKind }> }, answerFormat: { __typename?: 'AnswerFormat', id: string, isUseMaterialCost: boolean, isUseMaterialCostDetail: boolean, isUseMaterialSize: boolean, isUseMaterialScrap: boolean, isUseMaterialCostProcurementKind: boolean, isUseMaterialCostCavity: boolean, isUseMaterialCostAdjustment: boolean, isUseMaterialCostMemo: boolean, isUseMaterialCostThickness: boolean, isUseMaterialCostWidth: boolean, isUseMaterialCostHeight: boolean, isUseMaterialCostMeasure: boolean, isUseMaterialCostWeightBeforeProcess: boolean, isUseMaterialCostWeightAfterProcess: boolean, isUseMaterialCostBasePrice: boolean, isUsePartsCost: boolean, isUsePartsCostDetail: boolean, isUsePartsCostProcurementKind: boolean, isUsePartsCostPartNo: boolean, isUsePartsCostPartName: boolean, isUsePartsCostProductionPlace: boolean, isUsePartsCostQuantity: boolean, isUsePartsCostPartsUnitPrice: boolean, isUsePartsCostMemo: boolean, isUsePartsCostPartSpec: boolean, isUsePartsCostPartsCount: boolean, isUseProcessingCost: boolean, isUseProcessingCostDetail: boolean, isUseProcessingCostProductionLot: boolean, isUseProcessingCostEquipmentName: boolean, isUseProcessingCostProcessingTimeHour: boolean, isUseProcessingCostProcessingTimeMinute: boolean, isUseProcessingCostProcessingTimeSecond: boolean, isUseProcessingCostProcessingRate: boolean, isUseSetupInformation: boolean, isUseProcessingCostProcessingTimes: boolean, isUseProcessingCostSetupTimeHour: boolean, isUseProcessingCostSetupTimeMinute: boolean, isUseProcessingCostSetupTimeSecond: boolean, isUseProcessingCostSetupRate: boolean, isUseProcessingCostProcessingCostSubtotal: boolean, isUseProcessingCostSetupCostSubtotal: boolean, isUseProcessingCostMemo: boolean, processingCostRateKind: string | null, isUseManagementCost: boolean, isUseMaterialManagementRate: boolean, isUseMaterialManagementCost: boolean, isUseProcessingManagementRate: boolean, isUseProcessingManagementCost: boolean, isUseDeliveryCost: boolean, isUseDeliveryBoxInformation: boolean, isUsePackingCost: boolean, isUsePackingBoxInformation: boolean, isUseDefectCost: boolean, isUseDefectRate: boolean, isUseProfit: boolean, isUseProfitRate: boolean, isUseAdjustment: boolean, isUseDepreciation: boolean, isUseInternalPartSubtotal: boolean, isUseOutSourcePartSubtotal: boolean, isUseOutSourcePartManagementRate: boolean, isUsePaidSupplyPartSubtotal: boolean, isUseInitialDeliveryDay: boolean, isUseMaterialDeliveryDay: boolean, isUseEquipmentDeliveryDay: boolean, isUseMoldDeliveryDay: boolean, isUseTrialDeliveryDay: boolean, isUseDeliveryDay: boolean, isUseGanttForDeliveryDay: boolean, isUseSurfaceProcessingCost: boolean, isUseSubsidiaryMaterialCost: boolean, isUseSubsidiaryMaterialCostDetail: boolean, isSetScrapName: boolean, scrap1Name: string | null, scrap2Name: string | null, isUseCurrencyExchangeNote: boolean, isUseAnswerByItem: boolean, isUseMinimumOrderQuantity: boolean, isUseDeliveryForm: boolean, isUseQuantityPerDeliveryForm: boolean, isUsePriceEffectiveDate: boolean, priceRegistrationFormatId: string | null, answerMethod: string, isUseProcessingWeight: boolean, isUseCostForWeight: boolean, isUseProcessingHeadcount: boolean, calculationKind: string, isUseWholesalerKnowledge: boolean, useMakerActualPartName: string, makerActualPartNameHelperTxt: string | null, materialCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, materialCostPriceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, specialProcessingDetailFormatsList: Array<{ __typename?: 'CommonSpecialProcessingDetailFormat', kind: string, kindLabel: string, isUseProductionLot: boolean, isUseEquipmentName: boolean, isUseProcessingTimeHour: boolean, isUseProcessingTimeMinute: boolean, isUseProcessingTimeSecond: boolean, isUseProcessingRate: boolean, isUseSetupInformation: boolean, isUseSetupTimeHour: boolean, isUseSetupTimeMinute: boolean, isUseSetupTimeSecond: boolean, isUseSetupRate: boolean, isUseMemo: boolean, isUseProcessingTimes: boolean, isUseProcessingCostSubtotal: boolean, isUseSetupCostSubtotal: boolean, rateKind: string | null }>, processingCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, facilityKinds: Array<{ __typename?: 'FacilityKind', id: string, code: string | null, name: string }> }, quotationProducts: Array<{ __typename?: 'QuotationProduct', productId: string | null, productInformation: string | null, customerName: string | null, customerDevelopmentCode: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, developmentCode: string | null, productDevision: string | null, productDetail: string | null, productManufacturingLocation: string | null, orderType: string | null, orderProbability: string | null, productScheduleGroupSnapshots: Array<{ __typename?: 'ProductScheduleGroupSnapshot', id: string, seqNo: number, productSchedules: Array<{ __typename?: 'ProductScheduleSnapshot', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null }> }> }>, quotationProductSchedules: Array<{ __typename?: 'QuotationProductSchedule', id: string | null, groupSeqNo: number, seqNo: number, name: string, value: string | null }>, tenant: { __typename?: 'Tenant', id: string, name: string, code: string, productConfig: { __typename?: 'ProductConfig', isVisibleDevelopmentCode: boolean, isVisibleName: boolean, isVisibleCustomerName: boolean, isVisibleCustomerDevelopmentCode: boolean, isVisibleDivision: boolean, isVisibleDetail: boolean, isVisibleManufacturingLocation: boolean, isVisibleAnnualQuantity: boolean, isVisibleScheduledSalesDate: boolean, isVisibleOrderType: boolean, isVisibleOrderProbability: boolean, isUseCustomerName: boolean, isUseCustomerDevelopmentCode: boolean, isUseDivision: boolean, isUseDetail: boolean, isUseManufacturingLocation: boolean, isUseAnnualQuantity: boolean, isUseScheduledSalesDate: boolean, isUseOrderType: boolean, isUseOrderProbability: boolean } | null, quotationConfig: { __typename?: 'QuotationConfig', dayTypeSetting: string, deliveryInputKind: string, isUseTemporaryAnswer: boolean, isUseQuotationPackage: boolean, isUseComment: boolean, isUseFieldComment: boolean } | null, attachmentOfferConfig: { __typename?: 'AttachmentOfferConfig', isActiveOnQuotation: boolean } | null }, quotationInquiries: Array<{ __typename?: 'QuotationInquiry', id: string, seqNo: number, title: string, inquiryType: string, unit: string | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }>, uniqFacilityKinds: Array<{ __typename?: 'FacilityKind', id: string, name: string, isUseMaker: boolean, isUseSpec: boolean, isUseLend: boolean, isUseAmortizationNumber: boolean, isUseAmortizationPeriod: boolean, isUsePart: boolean, isUseProcessing: boolean, isUseCavity: boolean, isUseLeadTime: boolean, isUseAmortizationPeriodAsYear: boolean, isUsePaymentTimingKind: boolean, isUseRecuttingCount: boolean }>, previousQuotation: { __typename?: 'Quotation', id: string, uid: string } | null, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null, supplierQuotationPackage: { __typename?: 'SupplierQuotationPackage', id: string, title: string, answerEntryKind: string } | null, attachmentOffers: Array<{ __typename?: 'AttachmentOffer', id: string, isDiscardNecessary: boolean, status: string, kind: string | null, isDownloadable: boolean, attachment: { __typename?: 'Attachment', id: string, nameForSupplier: string | null }, tenant: { __typename?: 'Tenant', id: string } }> }, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type AnswerUpsertMutationVariables = Exact<{
  answer: CommonAnswerUpsertInput;
}>;


export type AnswerUpsertMutation = { __typename?: 'Mutation', answerUpsert: { __typename?: 'AnswerUpsertPayload', isSuccess: boolean, isCanBeAnswered: boolean, errors: Array<{ __typename?: 'InputFormError', formSchemaCode: string, dictKey: string, field: string, messages: Array<string>, seqNo: number | null }> | null, childErrors: Array<{ __typename?: 'AnswerUpsertChildFormError', structId: string, errors: Array<{ __typename?: 'InputFormError', formSchemaCode: string, dictKey: string, field: string, messages: Array<string>, seqNo: number | null }> }> | null } | null };

export type AnswerUpsertValidateMutationVariables = Exact<{
  answer: CommonAnswerUpsertInput;
}>;


export type AnswerUpsertValidateMutation = { __typename?: 'Mutation', answerUpsertValidate: { __typename?: 'AnswerUpsertValidatePayload', isSuccess: boolean, isCanBeAnswered: boolean, errors: Array<{ __typename?: 'InputFormError', formSchemaCode: string, dictKey: string, field: string, messages: Array<string>, seqNo: number | null }> | null, childErrors: Array<{ __typename?: 'AnswerUpsertChildFormError', structId: string, errors: Array<{ __typename?: 'InputFormError', formSchemaCode: string, dictKey: string, field: string, messages: Array<string>, seqNo: number | null }> }> | null } | null };

export type AttachmentOfferDownloadEventCreateMutationVariables = Exact<{
  attachmentOfferId: Scalars['ID']['input'];
}>;


export type AttachmentOfferDownloadEventCreateMutation = { __typename?: 'Mutation', attachmentOfferDownloadEventCreate: { __typename?: 'AttachmentOfferDownloadEventCreatePayload', isSuccess: boolean, downloadUrl: string | null } | null };

export type AttachmentOffersDiscardMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AttachmentOffersDiscardMutation = { __typename?: 'Mutation', attachmentOffersDiscard: { __typename?: 'AttachmentOffersDiscardPayload', isSuccess: boolean, errors: Array<string> } | null };

export type BcpIncidentAnswerRequestDraftsSaveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  drafts: Array<BcpIncidentAnswerRequestSiteInput> | BcpIncidentAnswerRequestSiteInput;
}>;


export type BcpIncidentAnswerRequestDraftsSaveMutation = { __typename?: 'Mutation', bcpIncidentAnswerRequestDraftsSave: { __typename?: 'BcpIncidentAnswerRequestDraftsSavePayload', request: { __typename?: 'BcpIncidentAnswerRequest', id: string, drafts: Array<{ __typename?: 'BcpIncidentAnswerDraft', id: string, version: string }> } | null, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type BcpIncidentAnswerRequestOpenedMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BcpIncidentAnswerRequestOpenedMutation = { __typename?: 'Mutation', bcpIncidentAnswerRequestOpened: { __typename?: 'BcpIncidentAnswerRequestOpenedPayload', errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type BcpIncidentAnswerRequestOpenedByTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type BcpIncidentAnswerRequestOpenedByTokenMutation = { __typename?: 'Mutation', bcpIncidentAnswerRequestOpenedByToken: { __typename?: 'BcpIncidentAnswerRequestOpenedByTokenPayload', errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type BcpIncidentAnswerRequestPartsProposeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  situationText: Scalars['String']['input'];
}>;


export type BcpIncidentAnswerRequestPartsProposeMutation = { __typename?: 'Mutation', bcpIncidentAnswerRequestPartsPropose: { __typename?: 'BcpIncidentAnswerRequestPartsProposePayload', unreadInstructions: Array<string>, unreadableAttachmentNames: Array<string>, remainingCount: number, siteProposals: Array<{ __typename?: 'BcpIncidentAnswerRequestPartProposals', draftId: string, proposals: Array<{ __typename?: 'BcpIncidentAnswerPartProposal', partCode: string, supplierCode: string | null, impactKind: BcpIncidentAnswerPartImpactKindEnum, comment: string | null, groupIndex: number, isOverridden: boolean }> }>, unmatchedGroups: Array<{ __typename?: 'BcpIncidentAnswerPartProposalGroup', groupIndex: number, impactKind: BcpIncidentAnswerPartImpactKindEnum | null, comment: string | null, allParts: boolean, onlyUnanswered: boolean, partCodePrefixes: Array<string>, partCodes: Array<string>, partNameContains: Array<string> }>, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type BcpIncidentAnswerRequestSubmitMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  drafts: Array<BcpIncidentAnswerRequestSiteInput> | BcpIncidentAnswerRequestSiteInput;
}>;


export type BcpIncidentAnswerRequestSubmitMutation = { __typename?: 'Mutation', bcpIncidentAnswerRequestSubmit: { __typename?: 'BcpIncidentAnswerRequestSubmitPayload', request: { __typename?: 'BcpIncidentAnswerRequest', id: string } | null, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type BcpIncidentAnswerRequestSubmitByTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
  drafts: Array<BcpIncidentAnswerRequestTokenSiteInput> | BcpIncidentAnswerRequestTokenSiteInput;
}>;


export type BcpIncidentAnswerRequestSubmitByTokenMutation = { __typename?: 'Mutation', bcpIncidentAnswerRequestSubmitByToken: { __typename?: 'BcpIncidentAnswerRequestSubmitByTokenPayload', state: BcpIncidentAnswerTokenStateEnum | null, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type ConfirmCommentReadMutationVariables = Exact<{
  commentNodeId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConfirmCommentReadMutation = { __typename?: 'Mutation', confirmCommentRead: { __typename?: 'ConfirmCommentReadPayload', success: boolean, errors: Array<string> } | null };

export type CrSupplierFirmBankInfoDeleteMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type CrSupplierFirmBankInfoDeleteMutation = { __typename?: 'Mutation', crSupplierFirmBankInfoDelete: { __typename?: 'CrSupplierFirmBankInfoDeletePayload', errors: Array<string> } | null };

export type CrSupplierFirmBankInfoUpsertMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CrSupplierFirmBankInfoUpsertMutation = { __typename?: 'Mutation', crSupplierFirmBankInfoUpsert: { __typename?: 'CrSupplierFirmBankInfoUpsertPayload', errors: Array<string> } | null };

export type CrSupplierFirmCertificationInfoDeleteMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type CrSupplierFirmCertificationInfoDeleteMutation = { __typename?: 'Mutation', crSupplierFirmCertificationInfoDelete: { __typename?: 'CrSupplierFirmCertificationInfoDeletePayload', errors: Array<string> } | null };

export type CrSupplierFirmCertificationInfoUpsertMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CrSupplierFirmCertificationInfoUpsertMutation = { __typename?: 'Mutation', crSupplierFirmCertificationInfoUpsert: { __typename?: 'CrSupplierFirmCertificationInfoUpsertPayload', errors: Array<string> } | null };

export type CrSupplierFirmEmployeeNumberInfoDeleteMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type CrSupplierFirmEmployeeNumberInfoDeleteMutation = { __typename?: 'Mutation', crSupplierFirmEmployeeNumberInfoDelete: { __typename?: 'CrSupplierFirmEmployeeNumberInfoDeletePayload', errors: Array<string> } | null };

export type CrSupplierFirmEmployeeNumberInfoUpsertMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CrSupplierFirmEmployeeNumberInfoUpsertMutation = { __typename?: 'Mutation', crSupplierFirmEmployeeNumberInfoUpsert: { __typename?: 'CrSupplierFirmEmployeeNumberInfoUpsertPayload', errors: Array<string> } | null };

export type CrSupplierFirmEquipmentInfoDeleteMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type CrSupplierFirmEquipmentInfoDeleteMutation = { __typename?: 'Mutation', crSupplierFirmEquipmentInfoDelete: { __typename?: 'CrSupplierFirmEquipmentInfoDeletePayload', errors: Array<string> } | null };

export type CrSupplierFirmEquipmentInfoUpsertMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  equipmentMachineName?: InputMaybe<Scalars['String']['input']>;
  manufacturerName?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quantityUnit?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  productionCapacity?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
}>;


export type CrSupplierFirmEquipmentInfoUpsertMutation = { __typename?: 'Mutation', crSupplierFirmEquipmentInfoUpsert: { __typename?: 'CrSupplierFirmEquipmentInfoUpsertPayload', errors: Array<string> } | null };

export type CrSupplierFirmFileInfoDeleteMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type CrSupplierFirmFileInfoDeleteMutation = { __typename?: 'Mutation', crSupplierFirmFileInfoDelete: { __typename?: 'CrSupplierFirmFileInfoDeletePayload', errors: Array<string> } | null };

export type CrSupplierFirmFileInfoUpsertMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  supplierFileClassId?: InputMaybe<Scalars['ID']['input']>;
  expirationDateFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  expirationDateTo?: InputMaybe<Scalars['ISO8601Date']['input']>;
  attachment: AttachmentInput;
  memo?: InputMaybe<Scalars['String']['input']>;
}>;


export type CrSupplierFirmFileInfoUpsertMutation = { __typename?: 'Mutation', crSupplierFirmFileInfoUpsert: { __typename?: 'CrSupplierFirmFileInfoUpsertPayload', errors: Array<string> } | null };

export type CrSupplierFirmFinancialDetailDeleteMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type CrSupplierFirmFinancialDetailDeleteMutation = { __typename?: 'Mutation', crSupplierFirmFinancialDetailDelete: { __typename?: 'CrSupplierFirmFinancialDetailDeletePayload', errors: Array<string> } | null };

export type CrSupplierFirmFinancialDetailUpsertMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CrSupplierFirmFinancialDetailUpsertMutation = { __typename?: 'Mutation', crSupplierFirmFinancialDetailUpsert: { __typename?: 'CrSupplierFirmFinancialDetailUpsertPayload', errors: Array<string> } | null };

export type CrSupplierFirmFinancialInfoDeleteMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type CrSupplierFirmFinancialInfoDeleteMutation = { __typename?: 'Mutation', crSupplierFirmFinancialInfoDelete: { __typename?: 'CrSupplierFirmFinancialInfoDeletePayload', errors: Array<string> } | null };

export type CrSupplierFirmFinancialInfoUpsertMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CrSupplierFirmFinancialInfoUpsertMutation = { __typename?: 'Mutation', crSupplierFirmFinancialInfoUpsert: { __typename?: 'CrSupplierFirmFinancialInfoUpsertPayload', errors: Array<string> } | null };

export type CrSupplierFirmKeyPositionInfoDeleteMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type CrSupplierFirmKeyPositionInfoDeleteMutation = { __typename?: 'Mutation', crSupplierFirmKeyPositionInfoDelete: { __typename?: 'CrSupplierFirmKeyPositionInfoDeletePayload', errors: Array<string> } | null };

export type CrSupplierFirmKeyPositionInfoUpsertMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CrSupplierFirmKeyPositionInfoUpsertMutation = { __typename?: 'Mutation', crSupplierFirmKeyPositionInfoUpsert: { __typename?: 'CrSupplierFirmKeyPositionInfoUpsertPayload', errors: Array<string> } | null };

export type CrSupplierFirmManufacturingSiteDeleteMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type CrSupplierFirmManufacturingSiteDeleteMutation = { __typename?: 'Mutation', crSupplierFirmManufacturingSiteDelete: { __typename?: 'CrSupplierFirmManufacturingSiteDeletePayload', errors: Array<string> } | null };

export type CrSupplierFirmManufacturingSiteUpsertMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  stateId?: InputMaybe<Scalars['ID']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  tel?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  landArea?: InputMaybe<Scalars['Float']['input']>;
  landOwnershipKind?: InputMaybe<SupplierManufacturingSiteLandOwnershipKindEnum>;
  buildingArea?: InputMaybe<Scalars['Float']['input']>;
  buildingOwnershipKind?: InputMaybe<SupplierManufacturingSiteBuildingOwnershipKindEnum>;
  president?: InputMaybe<Scalars['String']['input']>;
  capitalAmount?: InputMaybe<Scalars['Float']['input']>;
  capitalCurrencyId?: InputMaybe<Scalars['ID']['input']>;
  businessDescription?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  establishedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  overseasExpansionDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  investmentTypeName?: InputMaybe<Scalars['String']['input']>;
  investmentRatio?: InputMaybe<Scalars['Float']['input']>;
  partsMemo?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployeesOther?: InputMaybe<Scalars['Int']['input']>;
  investorName?: InputMaybe<Scalars['String']['input']>;
  investorName2?: InputMaybe<Scalars['String']['input']>;
  investmentRatio2?: InputMaybe<Scalars['Float']['input']>;
}>;


export type CrSupplierFirmManufacturingSiteUpsertMutation = { __typename?: 'Mutation', crSupplierFirmManufacturingSiteUpsert: { __typename?: 'CrSupplierFirmManufacturingSiteUpsertPayload', errors: Array<string> } | null };

export type CrSupplierFirmOutsourcingInfoDeleteMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type CrSupplierFirmOutsourcingInfoDeleteMutation = { __typename?: 'Mutation', crSupplierFirmOutsourcingInfoDelete: { __typename?: 'CrSupplierFirmOutsourcingInfoDeletePayload', errors: Array<string> } | null };

export type CrSupplierFirmOutsourcingInfoUpsertMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  stateId?: InputMaybe<Scalars['ID']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  transactionItem?: InputMaybe<Scalars['String']['input']>;
  factory?: InputMaybe<Scalars['String']['input']>;
  salesAmount?: InputMaybe<Scalars['Float']['input']>;
  transactionAmount?: InputMaybe<Scalars['Float']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  president?: InputMaybe<Scalars['String']['input']>;
  purchaseRate?: InputMaybe<Scalars['Float']['input']>;
  processingType?: InputMaybe<Scalars['String']['input']>;
  tenantDependencyRate?: InputMaybe<Scalars['Float']['input']>;
  capitalAmount?: InputMaybe<Scalars['Float']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  certificationInfo?: InputMaybe<Scalars['String']['input']>;
  supplierOutsourcingClassIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type CrSupplierFirmOutsourcingInfoUpsertMutation = { __typename?: 'Mutation', crSupplierFirmOutsourcingInfoUpsert: { __typename?: 'CrSupplierFirmOutsourcingInfoUpsertPayload', errors: Array<string> } | null };

export type CrSupplierFirmRepresentativeInfoDeleteMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type CrSupplierFirmRepresentativeInfoDeleteMutation = { __typename?: 'Mutation', crSupplierFirmRepresentativeInfoDelete: { __typename?: 'CrSupplierFirmRepresentativeInfoDeletePayload', errors: Array<string> } | null };

export type CrSupplierFirmRepresentativeInfoUpsertMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CrSupplierFirmRepresentativeInfoUpsertMutation = { __typename?: 'Mutation', crSupplierFirmRepresentativeInfoUpsert: { __typename?: 'CrSupplierFirmRepresentativeInfoUpsertPayload', errors: Array<string> } | null };

export type CrSupplierFirmSalesStatusInfoDeleteMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type CrSupplierFirmSalesStatusInfoDeleteMutation = { __typename?: 'Mutation', crSupplierFirmSalesStatusInfoDelete: { __typename?: 'CrSupplierFirmSalesStatusInfoDeletePayload', errors: Array<string> } | null };

export type CrSupplierFirmSalesStatusInfoUpsertMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CrSupplierFirmSalesStatusInfoUpsertMutation = { __typename?: 'Mutation', crSupplierFirmSalesStatusInfoUpsert: { __typename?: 'CrSupplierFirmSalesStatusInfoUpsertPayload', errors: Array<string> } | null };

export type CrSupplierFirmShareholderInfoDeleteMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type CrSupplierFirmShareholderInfoDeleteMutation = { __typename?: 'Mutation', crSupplierFirmShareholderInfoDelete: { __typename?: 'CrSupplierFirmShareholderInfoDeletePayload', errors: Array<string> } | null };

export type CrSupplierFirmShareholderInfoUpsertMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CrSupplierFirmShareholderInfoUpsertMutation = { __typename?: 'Mutation', crSupplierFirmShareholderInfoUpsert: { __typename?: 'CrSupplierFirmShareholderInfoUpsertPayload', errors: Array<string> } | null };

export type CrSupplierFirmSiteDeleteMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type CrSupplierFirmSiteDeleteMutation = { __typename?: 'Mutation', crSupplierFirmSiteDelete: { __typename?: 'CrSupplierFirmSiteDeletePayload', errors: Array<string> } | null };

export type CrSupplierFirmSiteUpsertMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  stateId?: InputMaybe<Scalars['ID']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  tel?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  landArea?: InputMaybe<Scalars['Float']['input']>;
  landOwnershipKind?: InputMaybe<SupplierSiteLandOwnershipKindEnum>;
  buildingArea?: InputMaybe<Scalars['Float']['input']>;
  buildingOwnershipKind?: InputMaybe<SupplierSiteBuildingOwnershipKindEnum>;
  president?: InputMaybe<Scalars['String']['input']>;
  capitalAmount?: InputMaybe<Scalars['Float']['input']>;
  capitalCurrencyId?: InputMaybe<Scalars['ID']['input']>;
  businessDescription?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  establishedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  overseasExpansionDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  investmentTypeName?: InputMaybe<Scalars['String']['input']>;
  investmentRatio?: InputMaybe<Scalars['Float']['input']>;
  partsMemo?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployeesOther?: InputMaybe<Scalars['Int']['input']>;
  investorName?: InputMaybe<Scalars['String']['input']>;
  investorName2?: InputMaybe<Scalars['String']['input']>;
  investmentRatio2?: InputMaybe<Scalars['Float']['input']>;
}>;


export type CrSupplierFirmSiteUpsertMutation = { __typename?: 'Mutation', crSupplierFirmSiteUpsert: { __typename?: 'CrSupplierFirmSiteUpsertPayload', errors: Array<string> } | null };

export type CrSupplierFirmUpsertMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameShort?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  nameKana?: InputMaybe<Scalars['String']['input']>;
  president?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  capital?: InputMaybe<Scalars['Float']['input']>;
  capitalCurrencyId?: InputMaybe<Scalars['ID']['input']>;
  tel?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  establishedDate?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  listingKind?: InputMaybe<Scalars['String']['input']>;
  closingMonth?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  stateId?: InputMaybe<Scalars['ID']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  issuedShares?: InputMaybe<Scalars['Float']['input']>;
  startTransactionDate?: InputMaybe<Scalars['String']['input']>;
  dividendAmount?: InputMaybe<Scalars['Float']['input']>;
  companyBackground?: InputMaybe<Scalars['String']['input']>;
  industryId?: InputMaybe<Scalars['ID']['input']>;
  numberOfEmployeesOther?: InputMaybe<Scalars['Int']['input']>;
  businessDescription?: InputMaybe<Scalars['String']['input']>;
  generalText1?: InputMaybe<Scalars['String']['input']>;
  generalText2?: InputMaybe<Scalars['String']['input']>;
  generalText3?: InputMaybe<Scalars['String']['input']>;
  generalText4?: InputMaybe<Scalars['String']['input']>;
  generalText5?: InputMaybe<Scalars['String']['input']>;
  generalText6?: InputMaybe<Scalars['String']['input']>;
  generalText7?: InputMaybe<Scalars['String']['input']>;
  generalText8?: InputMaybe<Scalars['String']['input']>;
  generalText9?: InputMaybe<Scalars['String']['input']>;
  generalText10?: InputMaybe<Scalars['String']['input']>;
  generalText11?: InputMaybe<Scalars['String']['input']>;
  generalText12?: InputMaybe<Scalars['String']['input']>;
  generalText13?: InputMaybe<Scalars['String']['input']>;
  generalText14?: InputMaybe<Scalars['String']['input']>;
  generalText15?: InputMaybe<Scalars['String']['input']>;
  generalText16?: InputMaybe<Scalars['String']['input']>;
  generalText17?: InputMaybe<Scalars['String']['input']>;
  generalText18?: InputMaybe<Scalars['String']['input']>;
  generalText19?: InputMaybe<Scalars['String']['input']>;
  generalText20?: InputMaybe<Scalars['String']['input']>;
  generalKind1?: InputMaybe<Scalars['ID']['input']>;
  generalKind2?: InputMaybe<Scalars['ID']['input']>;
  generalKind3?: InputMaybe<Scalars['ID']['input']>;
  generalKind4?: InputMaybe<Scalars['ID']['input']>;
  generalKind5?: InputMaybe<Scalars['ID']['input']>;
  generalKind6?: InputMaybe<Scalars['ID']['input']>;
  generalKind7?: InputMaybe<Scalars['ID']['input']>;
  generalKind8?: InputMaybe<Scalars['ID']['input']>;
  generalKind9?: InputMaybe<Scalars['ID']['input']>;
  generalKind10?: InputMaybe<Scalars['ID']['input']>;
  generalKinds1?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  generalKinds2?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  generalKinds3?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  generalKinds4?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  generalKinds5?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  generalKinds6?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  generalKinds7?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  generalKinds8?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  generalKinds9?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  generalKinds10?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type CrSupplierFirmUpsertMutation = { __typename?: 'Mutation', crSupplierFirmUpsert: { __typename?: 'CrSupplierFirmUpsertPayload', errors: Array<string> } | null };

export type CrSupplierFirmUserInfoDeleteMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type CrSupplierFirmUserInfoDeleteMutation = { __typename?: 'Mutation', crSupplierFirmUserInfoDelete: { __typename?: 'CrSupplierFirmUserInfoDeletePayload', errors: Array<string> } | null };

export type CrSupplierFirmUserInfoUpsertMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  contactClassIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameKana?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailEmergency?: InputMaybe<Scalars['String']['input']>;
  tel?: InputMaybe<Scalars['String']['input']>;
  telEmergency?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  endOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type CrSupplierFirmUserInfoUpsertMutation = { __typename?: 'Mutation', crSupplierFirmUserInfoUpsert: { __typename?: 'CrSupplierFirmUserInfoUpsertPayload', errors: Array<string> } | null };

export type DeleteCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', deleteComment: { __typename?: 'DeleteCommentPayload', errors: Array<string>, commentNode: { __typename?: 'CommentNode', id: string, body: string, parentId: string | null, authorAdminUserId: string | null, authorAdminUserName: string | null, authorSupplierAccountId: string | null, authorSupplierAccountName: string | null, authorSupplierUserId: string | null, authorSupplierUserName: string | null, targetKind: CommentNodeTargetKindEnum, supplierId: string | null, deletedAt: any | null, canEdit: boolean, canDelete: boolean, createdAt: any, updatedAt: any, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierUserInfoCommentConfirmations: Array<{ __typename?: 'SupplierUserInfoCommentConfirmation', id: string, supplierUserInfoId: string | null, confirmedAt: any | null, supplyChainCompanyEmployeeName: string | null, supplierUserInfo: { __typename?: 'SupplierUserInfo', id: string, supplierUserId: string | null } | null }>, userCommentConfirmations: Array<{ __typename?: 'UserCommentConfirmation', id: string, adminUserId: string, confirmedAt: any | null, adminUser: { __typename?: 'AdminUser', id: string, name: string } }> } | null } | null };

export type DeliveredAnnouncementConfirmMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeliveredAnnouncementConfirmMutation = { __typename?: 'Mutation', deliveredAnnouncementConfirm: { __typename?: 'DeliveredAnnouncementConfirmPayload', deliveredAnnouncement: { __typename?: 'DeliveredAnnouncement', id: string } | null, errors: Array<{ __typename?: 'ValidationErr', message: string }> } | null };

export type DeliveredAnnouncementViewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeliveredAnnouncementViewMutation = { __typename?: 'Mutation', deliveredAnnouncementView: { __typename?: 'DeliveredAnnouncementViewPayload', deliveredAnnouncement: { __typename?: 'DeliveredAnnouncement', id: string, viewedAt: any | null } | null, errors: Array<{ __typename?: 'ValidationErr', message: string }> } | null };

export type GenerateSupplierSurveyInfoImportExcelMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
}>;


export type GenerateSupplierSurveyInfoImportExcelMutation = { __typename?: 'Mutation', generateSupplierSurveyInfoImportExcel: { __typename?: 'GenerateSupplierSurveyInfoImportExcelPayload', errors: Array<string>, signedUrl: string | null, fileName: string | null } | null };

export type MoldDisposalSupplierApplicationDisposeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attachments?: InputMaybe<Array<CommonAttachmentInput> | CommonAttachmentInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type MoldDisposalSupplierApplicationDisposeMutation = { __typename?: 'Mutation', moldDisposalSupplierApplicationDispose: { __typename?: 'MoldDisposalSupplierApplicationDisposePayload', moldDisposalSupplierApplication: { __typename?: 'MoldDisposalSupplierApplication', id: string, uid: string, status: number, applicationDate: any, confirmationDueDate: any, comment: string, supplier: { __typename?: 'Supplier', id: string, name: string, code: string }, employee: { __typename?: 'Employee', id: string, name: string }, supplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null, tenant: { __typename?: 'Tenant', id: string, name: string }, attachments: Array<{ __typename?: 'Attachment', id: string, name: string, fileType: string | null, size: number | null }> | null, moldDisposalSupplierApplicationDetails: Array<{ __typename?: 'MoldDisposalSupplierApplicationDetail', id: string, disposeRequestDate: any | null, disposeCost: number | null, publicMemo: string | null, mold: { __typename?: 'Mold', id: string, uid: string, name: string } }> | null } | null } | null };

export type MoldDisposalSupplierApplicationSaveMutationVariables = Exact<{
  previousId?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
  supplierId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
  supplierAccountId?: InputMaybe<Scalars['ID']['input']>;
  supplierUserId?: InputMaybe<Scalars['ID']['input']>;
  attachments?: InputMaybe<Array<CommonAttachmentInput> | CommonAttachmentInput>;
  confirmationDueDate: Scalars['ISO8601Date']['input'];
  title: Scalars['String']['input'];
  moldDisposalSupplierApplicationDetails: Array<MoldDisposalSupplierApplicationDetailInput> | MoldDisposalSupplierApplicationDetailInput;
}>;


export type MoldDisposalSupplierApplicationSaveMutation = { __typename?: 'Mutation', moldDisposalSupplierApplicationSave: { __typename?: 'MoldDisposalSupplierApplicationSavePayload', moldDisposalSupplierApplication: { __typename?: 'MoldDisposalSupplierApplication', id: string, uid: string, title: string, comment: string, confirmationDueDate: any, status: number, moldDisposalSupplierApplicationDetails: Array<{ __typename?: 'MoldDisposalSupplierApplicationDetail', id: string, disposeCost: number | null, disposeRequestDate: any | null, publicMemo: string | null, scrapCost: number | null, mold: { __typename?: 'Mold', id: string, uid: string, tenantId: string, name: string, width: number | null, depth: number | null, height: number | null, weight: number | null, isNew: boolean | null, isPermanent: boolean | null, manageableId: string | null, manageableType: string | null, publicMemo: string | null, storageLocation: string | null, category: string | null, assetNumber: string | null, storageSymbol: string | null, status: string | null, evidenceComment: string | null, paymentEvidenceComment: string | null, storageEvidenceComment: string | null, disposeEvidenceComment: string | null, supplierDisposeReportComment: string | null, supplierDisposeReportedAt: any | null, employee: { __typename?: 'Employee', id: string, name: string }, supplier: { __typename?: 'Supplier', id: string, name: string, code: string, adminUser: { __typename?: 'AdminUser', id: string, name: string, employee: { __typename?: 'Employee', id: string, name: string } | null } | null }, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string } | null, manageable: { __typename?: 'MoldManageable', id: string, name: string, code: string } | null, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, paymentAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, storageAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, disposeAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierDisposeReportAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, moldStartUp: { __typename?: 'MoldStartUp', id: string, tenantId: string, moldId: string, quotedCost: number | null, acquisitionCost: number | null }, moldProduction: { __typename?: 'MoldProduction', id: string, tenantId: string, moldId: string, outputPerShot: number | null, shotCount: number | null, cumulativePartTransaction: number | null, remainingShotCount: number | null, flowTendency: number | null }, moldStorage: { __typename?: 'MoldStorage', id: string, tenantId: string, moldId: string, storageCost: number | null, retroactivePrice: number | null }, moldDispose: { __typename?: 'MoldDispose', id: string, tenantId: string, moldId: string, disposeCost: number | null, scrapCost: number | null, disposeRequestDate: any | null }, moldLifecycleEvent: { __typename?: 'MoldLifecycleEvent', id: string, tenantId: string, moldId: string, operationStartDate: any | null, inspectionReceiptDate: any | null, productionStartNotificationReceiptDate: any | null, quoteStatementReceiptDate: any | null, storageStartDate: any | null, disposeDate: any | null }, moldUsages: Array<{ __typename?: 'MoldUsage', id: string, moldId: string, targettableType: string | null, targettable: { __typename?: 'Part', id: string, name: string, code: string | null, figureNumber: string | null, rootPartCode: string | null, totalReceivedQuantity: number | null, flowTendency: string | null, partAnnualTotal: { __typename?: 'PartAnnualTotal', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number, quantity4: number, quantity5: number, quantity6: number, quantity7: number, quantity8: number, quantity9: number, quantity10: number, quantity11: number, quantity12: number } | null, partUnofficialAnnouncement: { __typename?: 'PartUnofficialAnnouncement', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number } | null, partTransactions: Array<{ __typename?: 'PartTransaction', id: string, tenantId: string, orderNumber: string | null, orderSeqNo: number | null, receivedOn: any | null, unitPrice: number, receivedQuantity: number, checkNumber: string | null, checkSeqNo: number | null, checkDate: any, subtotal: number, currencyRate: number, part: { __typename?: 'Part', id: string, name: string, code: string | null }, supplier: { __typename?: 'Supplier', id: string, name: string, isTemporary: boolean, code: string }, currency: { __typename?: 'Currency', isBaseCurrency: boolean, currencyCode: string }, toJpy: { __typename?: 'PartTransactionJpy', subtotal: number, unitPrice: number } }> | null } | null }> } }> | null } | null } | null };

export type PackageBulkAnswerAiDraftMutationVariables = Exact<{
  input: PackageBulkAnswerAiDraftInput;
}>;


export type PackageBulkAnswerAiDraftMutation = { __typename?: 'Mutation', packageBulkAnswerAiDraft: { __typename?: 'PackageBulkAnswerAiDraftPayload', quotationNo: string | null, expirationDate: any | null, currencyId: string | null, note: string | null, errors: Array<string>, rows: Array<{ __typename?: 'PackageBulkAnswerAiDraftRow', quotationRequestId: string, priceBasis: string, unitPrice: string | null, amountExcludingTax: string | null, deliveryDay: number | null, declineSuggested: boolean }> } | null };

export type PackageBulkAnswerSubmitMutationVariables = Exact<{
  input: PackageBulkAnswerSubmitInput;
}>;


export type PackageBulkAnswerSubmitMutation = { __typename?: 'Mutation', packageBulkAnswerSubmit: { __typename?: 'PackageBulkAnswerSubmitPayload', isSuccess: boolean, isConflict: boolean, conflictQuotationRequestIds: Array<string>, errors: Array<string>, rowErrors: Array<{ __typename?: 'PackageBulkAnswerRowError', quotationRequestId: string, messages: Array<string>, formErrors: Array<{ __typename?: 'InputFormError', formSchemaCode: string, dictKey: string, field: string, messages: Array<string>, seqNo: number | null }> }> } | null };

export type PartCsvExportMutationVariables = Exact<{
  code?: InputMaybe<Scalars['String']['input']>;
  figureNumber?: InputMaybe<Scalars['String']['input']>;
  referenceDate?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  conditionsText?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
}>;


export type PartCsvExportMutation = { __typename?: 'Mutation', partCsvExport: { __typename?: 'PartCsvExportPayload', res: { __typename?: 'CsvExportRes', errs: Array<string>, result: { __typename?: 'SupplierCsvExportResult', signedUrl: string | null } | null } } | null };

export type PriceAdjustmentAmendMutationVariables = Exact<{
  input: PriceAdjustmentAmendInput;
}>;


export type PriceAdjustmentAmendMutation = { __typename?: 'Mutation', priceAdjustmentAmend: { __typename?: 'PriceAdjustmentAmendPayload', priceAdjustment: { __typename?: 'PriceAdjustment', id: string } | null, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type PriceAdjustmentAmendAskingMutationVariables = Exact<{
  input: PriceAdjustmentAmendAskingInput;
}>;


export type PriceAdjustmentAmendAskingMutation = { __typename?: 'Mutation', priceAdjustmentAmendAsking: { __typename?: 'PriceAdjustmentAmendAskingPayload', priceAdjustment: { __typename?: 'PriceAdjustment', id: string } | null, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type PriceAdjustmentAnswerMutationVariables = Exact<{
  input: PriceAdjustmentAnswerInput;
}>;


export type PriceAdjustmentAnswerMutation = { __typename?: 'Mutation', priceAdjustmentAnswer: { __typename?: 'PriceAdjustmentAnswerPayload', priceAdjustment: { __typename?: 'PriceAdjustment', id: string } | null, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type PriceAdjustmentApplicationMutationVariables = Exact<{
  input: PriceAdjustmentApplicationInput;
}>;


export type PriceAdjustmentApplicationMutation = { __typename?: 'Mutation', priceAdjustmentApplication: { __typename?: 'PriceAdjustmentApplicationPayload', errors: Array<string>, priceAdjustment: { __typename?: 'PriceAdjustment', id: string } | null, inputFormErrors: Array<{ __typename?: 'InputFormError', formSchemaCode: string, dictKey: string, field: string, messages: Array<string>, seqNo: number | null }> | null } | null };

export type PriceAdjustmentApproveMutationVariables = Exact<{
  input: PriceAdjustmentApproveInput;
}>;


export type PriceAdjustmentApproveMutation = { __typename?: 'Mutation', priceAdjustmentApprove: { __typename?: 'priceAdjustmentApprovePayload', errors: Array<string>, priceAdjustment: { __typename?: 'PriceAdjustment', id: string } | null } | null };

export type PriceAdjustmentAskMutationVariables = Exact<{
  input: PriceAdjustmentAskInput;
}>;


export type PriceAdjustmentAskMutation = { __typename?: 'Mutation', priceAdjustmentAsk: { __typename?: 'PriceAdjustmentAskPayload', priceAdjustment: { __typename?: 'PriceAdjustment', id: string } | null, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type PriceAdjustmentCloseMutationVariables = Exact<{
  input: PriceAdjustmentCloseInput;
}>;


export type PriceAdjustmentCloseMutation = { __typename?: 'Mutation', priceAdjustmentClose: { __typename?: 'PriceAdjustmentClosePayload', id: string | null, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type PriceAdjustmentCompleteMutationVariables = Exact<{
  input: PriceAdjustmentCompleteInput;
}>;


export type PriceAdjustmentCompleteMutation = { __typename?: 'Mutation', priceAdjustmentComplete: { __typename?: 'PriceAdjustmentCompletePayload', priceAdjustment: { __typename?: 'PriceAdjustment', id: string } | null, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type PriceAdjustmentCreateByPartOrderUnitPriceMutationVariables = Exact<{
  partOrderUnitPriceIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
}>;


export type PriceAdjustmentCreateByPartOrderUnitPriceMutation = { __typename?: 'Mutation', priceAdjustmentCreateByPartOrderUnitPrice: { __typename?: 'PriceAdjustmentCreateByPartOrderUnitPricePayload', priceAdjustment: { __typename?: 'PriceAdjustment', id: string, tenantCode: string } | null, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type PriceAdjustmentDeleteMutationVariables = Exact<{
  input: PriceAdjustmentDeleteInput;
}>;


export type PriceAdjustmentDeleteMutation = { __typename?: 'Mutation', priceAdjustmentDelete: { __typename?: 'PriceAdjustmentDeletePayload', id: string | null, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type PriceAdjustmentExcelExportMutationVariables = Exact<{
  input: PriceAdjustmentExcelExportInput;
}>;


export type PriceAdjustmentExcelExportMutation = { __typename?: 'Mutation', priceAdjustmentExcelExport: { __typename?: 'PriceAdjustmentExcelExportPayload', signedUrl: string | null, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type PriceAdjustmentExcelSchemaExportMutationVariables = Exact<{
  input: PriceAdjustmentExcelSchemaExportInput;
}>;


export type PriceAdjustmentExcelSchemaExportMutation = { __typename?: 'Mutation', priceAdjustmentExcelSchemaExport: { __typename?: 'PriceAdjustmentExcelSchemaExportPayload', fileName: string | null, fileUrl: string | null, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type PriceAdjustmentExcelSchemaImportMutationVariables = Exact<{
  input: PriceAdjustmentExcelSchemaImportInput;
}>;


export type PriceAdjustmentExcelSchemaImportMutation = { __typename?: 'Mutation', priceAdjustmentExcelSchemaImport: { __typename?: 'PriceAdjustmentExcelSchemaImportPayload', deletedItemIds: Array<string> | null, deletedSubpartIds: Array<string> | null, deletedProcessingIds: Array<string> | null, deletedSubsidiaryMaterialIds: Array<string> | null, validationErrors: Array<string> | null, priceAdjustmentItems: Array<{ __typename?: 'PriceAdjustmentItem', id: string, tenantId: string, quantity: number, memo: string | null, tenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string } | null, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, part: { __typename?: 'Part', id: string, code: string | null, displayCode: string, figureNumber: string | null, receiverCode: string | null, receiverName: string | null, name: string, isAdjustable: boolean, rootPartCode: string | null, deliverySiteObjects: Array<{ __typename?: 'DeliverySite', id: string, name: string }>, deliverySites: Array<{ __typename?: 'DeliverySite', id: string, name: string, code: string | null }>, sameGroupParts: Array<{ __typename?: 'Part', id: string, code: string | null, name: string }>, activePartOrderUnitPrices: Array<{ __typename?: 'PartOrderUnitPrice', itemRequirement: { __typename?: 'ItemRequirement', designChangeCode: string | null } | null }> }, newDetail: { __typename?: 'PriceAdjustmentItemDetail', id: string, tenantId: string, kind: string, unitPrice: number | null, materialCost: number | null, processingCost: number | null, otherCost: number | null, supplyPartPrice: number | null, scrapPrice: number | null, memo: string, notSupplyPartSubtotal: number | null, subsidiaryMaterialCost: number | null, propertyRentCost: number | null, paidSupplyPartSubtotal: number | null, facilityCost: number | null, facilityAmortizationCost: number | null, amortizationCost: number | null, jigManagementCost: number | null, materialManagementCost: number | null, materialCostNotSupplySubtotal: number | null, materialCostSupplySubtotal: number | null, partsCost: number | null, netUnitPrice: number | null, deliveryCost: number | null, managementCost: number | null, processingPriceSubtotal: number | null, manufacturingSite: { __typename?: 'ManufacturingSite', id: string, name: string, code: string | null } | null, priceAdjustmentItemDetailMaterialPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailMaterialPrice', id: string, materialName: string | null, materialCode: string | null, materialCost: number | null, materialUnitPrice: number | null, initialCost: number | null, measure: string | null, procurementKind: string | null, productWeight: number | null, quantity: number | null, reservedWeight: number | null, scrapSubtotal: number | null, scrapUnitPrice: number | null, scrapWeight: number | null, startOn: any | null, startUpMonth: any | null, variation: number | null, cavity: number | null, materialCostPerQty: number | null, partMaterialPriceId: string | null, baseMaterial: { __typename?: 'BaseMaterial', id: string, name: string, code: string } | null, partMaterialPrice: { __typename?: 'PartMaterialPrice', id: string } | null, priceTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null }> | null, priceAdjustmentItemDetailProcessingPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailProcessingPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, processName: string, equipmentName: string | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingTimeHour: number | null, processingRate: number | null, processingCostSubtotal: number | null, processingCostSubtotalPerLot: number | null, setupTimeMinute: number | null, setupTimeHour: number | null, setupTimeSecond: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, productionLot: number | null, rateKind: number | null, setupRate: number | null, processingWeight: number | null, costForWeight: number | null, weightTenantUnitId: string | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostPerLot: number | null, partProcessingCostId: string | null, facilityKindId: string | null, facilityName: string | null, facilityCost: number | null, facilityPaymentInstallmentKind: string | null, partFacilityPrice: { __typename?: 'PartFacilityPrice', id: string | null, facilityKindId: string, name: string | null, facilityCost: number | null, acquiredOn: any | null, memo: string | null, amortizationNumber: number | null, amortizationCost: number | null, paymentInstallmentKind: string, paymentMonthly: number | null, paymentLastMonth: number | null, paymentStartOn: any | null, paymentEndOn: any | null, tenantId: string, facilityKind: { __typename?: 'FacilityKind', id: string, name: string } } | null }> | null, priceAdjustmentItemDetailSubpartPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailSubpartPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, partCode: string | null, partName: string | null, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, partCost: number | null, partSubpartPriceId: string | null }> | null, priceAdjustmentItemDetailSubsidiaryMaterialCosts: Array<{ __typename?: 'PriceAdjustmentItemDetailSubsidiaryMaterialCost', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number | null, note: string | null, partSubsidiaryMaterialCostId: string | null }> | null, priceAdjustmentItemDetailSupplySubpartPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailSupplySubpartPrice', id: string, tenantId: string, priceAdjustmentItemDetailId: string, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, supplyPartCost: number | null, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, partSupplySubpartPriceId: string | null, supplyPart: { __typename?: 'Part', id: string, code: string | null, name: string } | null }> | null, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null } | null, oldDetail: { __typename?: 'PriceAdjustmentItemDetail', id: string, tenantId: string, kind: string, unitPrice: number | null, materialCost: number | null, processingCost: number | null, otherCost: number | null, supplyPartPrice: number | null, scrapPrice: number | null, memo: string, notSupplyPartSubtotal: number | null, subsidiaryMaterialCost: number | null, propertyRentCost: number | null, paidSupplyPartSubtotal: number | null, facilityCost: number | null, facilityAmortizationCost: number | null, amortizationCost: number | null, jigManagementCost: number | null, materialManagementCost: number | null, materialCostNotSupplySubtotal: number | null, materialCostSupplySubtotal: number | null, partsCost: number | null, netUnitPrice: number | null, deliveryCost: number | null, managementCost: number | null, processingPriceSubtotal: number | null, manufacturingSite: { __typename?: 'ManufacturingSite', id: string, name: string, code: string | null } | null, priceAdjustmentItemDetailMaterialPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailMaterialPrice', id: string, materialName: string | null, materialCode: string | null, materialCost: number | null, materialUnitPrice: number | null, initialCost: number | null, measure: string | null, procurementKind: string | null, productWeight: number | null, quantity: number | null, reservedWeight: number | null, scrapSubtotal: number | null, scrapUnitPrice: number | null, scrapWeight: number | null, startOn: any | null, startUpMonth: any | null, variation: number | null, cavity: number | null, materialCostPerQty: number | null, partMaterialPriceId: string | null, baseMaterial: { __typename?: 'BaseMaterial', id: string, name: string, code: string } | null, partMaterialPrice: { __typename?: 'PartMaterialPrice', id: string } | null, priceTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null }> | null, priceAdjustmentItemDetailProcessingPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailProcessingPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, processName: string, equipmentName: string | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingTimeHour: number | null, processingRate: number | null, processingCostSubtotal: number | null, processingCostSubtotalPerLot: number | null, setupTimeMinute: number | null, setupTimeHour: number | null, setupTimeSecond: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, productionLot: number | null, rateKind: number | null, setupRate: number | null, processingWeight: number | null, costForWeight: number | null, weightTenantUnitId: string | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostPerLot: number | null, partProcessingCostId: string | null, facilityKindId: string | null, facilityName: string | null, facilityCost: number | null, facilityPaymentInstallmentKind: string | null, partFacilityPrice: { __typename?: 'PartFacilityPrice', id: string | null, facilityKindId: string, name: string | null, facilityCost: number | null, acquiredOn: any | null, memo: string | null, amortizationNumber: number | null, amortizationCost: number | null, paymentInstallmentKind: string, paymentMonthly: number | null, paymentLastMonth: number | null, paymentStartOn: any | null, paymentEndOn: any | null, tenantId: string, facilityKind: { __typename?: 'FacilityKind', id: string, name: string } } | null }> | null, priceAdjustmentItemDetailSubpartPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailSubpartPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, partCode: string | null, partName: string | null, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, partCost: number | null, partSubpartPriceId: string | null }> | null, priceAdjustmentItemDetailSubsidiaryMaterialCosts: Array<{ __typename?: 'PriceAdjustmentItemDetailSubsidiaryMaterialCost', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number | null, note: string | null, partSubsidiaryMaterialCostId: string | null }> | null, priceAdjustmentItemDetailSupplySubpartPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailSupplySubpartPrice', id: string, tenantId: string, priceAdjustmentItemDetailId: string, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, supplyPartCost: number | null, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, partSupplySubpartPriceId: string | null, supplyPart: { __typename?: 'Part', id: string, code: string | null, name: string } | null }> | null, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null } | null, latestAskingDetail: { __typename?: 'PriceAdjustmentItemDetail', id: string, tenantId: string, kind: string, unitPrice: number | null, materialCost: number | null, processingCost: number | null, otherCost: number | null, supplyPartPrice: number | null, scrapPrice: number | null, memo: string, notSupplyPartSubtotal: number | null, subsidiaryMaterialCost: number | null, propertyRentCost: number | null, paidSupplyPartSubtotal: number | null, facilityCost: number | null, facilityAmortizationCost: number | null, amortizationCost: number | null, jigManagementCost: number | null, materialManagementCost: number | null, materialCostNotSupplySubtotal: number | null, materialCostSupplySubtotal: number | null, partsCost: number | null, netUnitPrice: number | null, deliveryCost: number | null, managementCost: number | null, processingPriceSubtotal: number | null, manufacturingSite: { __typename?: 'ManufacturingSite', id: string, name: string, code: string | null } | null, priceAdjustmentItemDetailMaterialPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailMaterialPrice', id: string, materialName: string | null, materialCode: string | null, materialCost: number | null, materialUnitPrice: number | null, initialCost: number | null, measure: string | null, procurementKind: string | null, productWeight: number | null, quantity: number | null, reservedWeight: number | null, scrapSubtotal: number | null, scrapUnitPrice: number | null, scrapWeight: number | null, startOn: any | null, startUpMonth: any | null, variation: number | null, cavity: number | null, materialCostPerQty: number | null, partMaterialPriceId: string | null, baseMaterial: { __typename?: 'BaseMaterial', id: string, name: string, code: string } | null, partMaterialPrice: { __typename?: 'PartMaterialPrice', id: string } | null, priceTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null }> | null, priceAdjustmentItemDetailProcessingPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailProcessingPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, processName: string, equipmentName: string | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingTimeHour: number | null, processingRate: number | null, processingCostSubtotal: number | null, processingCostSubtotalPerLot: number | null, setupTimeMinute: number | null, setupTimeHour: number | null, setupTimeSecond: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, productionLot: number | null, rateKind: number | null, setupRate: number | null, processingWeight: number | null, costForWeight: number | null, weightTenantUnitId: string | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostPerLot: number | null, partProcessingCostId: string | null, facilityKindId: string | null, facilityName: string | null, facilityCost: number | null, facilityPaymentInstallmentKind: string | null, partFacilityPrice: { __typename?: 'PartFacilityPrice', id: string | null, facilityKindId: string, name: string | null, facilityCost: number | null, acquiredOn: any | null, memo: string | null, amortizationNumber: number | null, amortizationCost: number | null, paymentInstallmentKind: string, paymentMonthly: number | null, paymentLastMonth: number | null, paymentStartOn: any | null, paymentEndOn: any | null, tenantId: string, facilityKind: { __typename?: 'FacilityKind', id: string, name: string } } | null }> | null, priceAdjustmentItemDetailSubpartPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailSubpartPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, partCode: string | null, partName: string | null, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, partCost: number | null, partSubpartPriceId: string | null }> | null, priceAdjustmentItemDetailSubsidiaryMaterialCosts: Array<{ __typename?: 'PriceAdjustmentItemDetailSubsidiaryMaterialCost', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number | null, note: string | null, partSubsidiaryMaterialCostId: string | null }> | null, priceAdjustmentItemDetailSupplySubpartPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailSupplySubpartPrice', id: string, tenantId: string, priceAdjustmentItemDetailId: string, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, supplyPartCost: number | null, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, partSupplySubpartPriceId: string | null, supplyPart: { __typename?: 'Part', id: string, code: string | null, name: string } | null }> | null, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null } | null, priceChangeReasons: Array<{ __typename?: 'PriceChangeReason', id: string, tenantId: string, code: string, reason: string, sequence: number }> | null, reasonSnapshots: Array<{ __typename?: 'PriceAdjustmentItemPriceChangeReason', id: string, tenantId: string, code: string, reason: string, sequence: number, priceChangeReasonId: string, priceDifference: number | null }> | null, partOrderUnitPrice: { __typename?: 'PartOrderUnitPrice', id: string, unitPrice: number, quantity: number, startOn: any, endOn: any | null, isExpired: boolean, ifKey1: string | null, ifKey2: string | null, currency: { __typename?: 'Currency', id: string, displayName: string, currencyCode: string, decimalPrecision: number } | null, tenantUnit: { __typename?: 'TenantUnit', unitCode: string, name: string } | null, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, part: { __typename?: 'Part', id: string, displayCode: string, name: string, figureNumber: string | null } } | null, priceAdjustment: { __typename?: 'PriceAdjustment', id: string, targetTerm: string, supplierCode: string, supplier: { __typename?: 'Supplier', id: string, name: string, displayCode: string } }, answerFormat: { __typename?: 'AnswerFormat', id: string, isUseMaterialCost: boolean, isUseMaterialCostDetail: boolean, isUseMaterialSize: boolean, isUseMaterialScrap: boolean, isUseMaterialCostProcurementKind: boolean, isUseMaterialCostCavity: boolean, isUseMaterialCostAdjustment: boolean, isUseMaterialCostMemo: boolean, isUseMaterialCostThickness: boolean, isUseMaterialCostWidth: boolean, isUseMaterialCostHeight: boolean, isUseMaterialCostMeasure: boolean, isUseMaterialCostWeightBeforeProcess: boolean, isUseMaterialCostWeightAfterProcess: boolean, isUseMaterialCostBasePrice: boolean, isUsePartsCost: boolean, isUsePartsCostDetail: boolean, isUsePartsCostProcurementKind: boolean, isUsePartsCostPartNo: boolean, isUsePartsCostPartName: boolean, isUsePartsCostProductionPlace: boolean, isUsePartsCostQuantity: boolean, isUsePartsCostPartsUnitPrice: boolean, isUsePartsCostMemo: boolean, isUsePartsCostPartSpec: boolean, isUsePartsCostPartsCount: boolean, isUseProcessingCost: boolean, isUseProcessingCostDetail: boolean, isUseProcessingCostProductionLot: boolean, isUseProcessingCostEquipmentName: boolean, isUseProcessingCostProcessingTimeHour: boolean, isUseProcessingCostProcessingTimeMinute: boolean, isUseProcessingCostProcessingTimeSecond: boolean, isUseProcessingCostProcessingRate: boolean, isUseSetupInformation: boolean, isUseProcessingCostProcessingTimes: boolean, isUseProcessingCostSetupTimeHour: boolean, isUseProcessingCostSetupTimeMinute: boolean, isUseProcessingCostSetupTimeSecond: boolean, isUseProcessingCostSetupRate: boolean, isUseProcessingCostProcessingCostSubtotal: boolean, isUseProcessingCostSetupCostSubtotal: boolean, isUseProcessingCostMemo: boolean, processingCostRateKind: string | null, isUseManagementCost: boolean, isUseMaterialManagementRate: boolean, isUseMaterialManagementCost: boolean, isUseProcessingManagementRate: boolean, isUseProcessingManagementCost: boolean, isUseDeliveryCost: boolean, isUseDeliveryBoxInformation: boolean, isUsePackingCost: boolean, isUsePackingBoxInformation: boolean, isUseDefectCost: boolean, isUseDefectRate: boolean, isUseProfit: boolean, isUseProfitRate: boolean, isUseAdjustment: boolean, isUseDepreciation: boolean, isUseInternalPartSubtotal: boolean, isUseOutSourcePartSubtotal: boolean, isUseOutSourcePartManagementRate: boolean, isUsePaidSupplyPartSubtotal: boolean, isUseInitialDeliveryDay: boolean, isUseMaterialDeliveryDay: boolean, isUseEquipmentDeliveryDay: boolean, isUseMoldDeliveryDay: boolean, isUseTrialDeliveryDay: boolean, isUseDeliveryDay: boolean, isUseGanttForDeliveryDay: boolean, isUseSurfaceProcessingCost: boolean, isUseSubsidiaryMaterialCost: boolean, isUseSubsidiaryMaterialCostDetail: boolean, isSetScrapName: boolean, scrap1Name: string | null, scrap2Name: string | null, isUseCurrencyExchangeNote: boolean, isUseAnswerByItem: boolean, isUseMinimumOrderQuantity: boolean, isUseDeliveryForm: boolean, isUseQuantityPerDeliveryForm: boolean, isUsePriceEffectiveDate: boolean, priceRegistrationFormatId: string | null, answerMethod: string, isUseProcessingWeight: boolean, isUseCostForWeight: boolean, isUseProcessingHeadcount: boolean, calculationKind: string, isUseWholesalerKnowledge: boolean, useMakerActualPartName: string, makerActualPartNameHelperTxt: string | null, materialCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, materialCostPriceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, specialProcessingDetailFormatsList: Array<{ __typename?: 'CommonSpecialProcessingDetailFormat', kind: string, kindLabel: string, isUseProductionLot: boolean, isUseEquipmentName: boolean, isUseProcessingTimeHour: boolean, isUseProcessingTimeMinute: boolean, isUseProcessingTimeSecond: boolean, isUseProcessingRate: boolean, isUseSetupInformation: boolean, isUseSetupTimeHour: boolean, isUseSetupTimeMinute: boolean, isUseSetupTimeSecond: boolean, isUseSetupRate: boolean, isUseMemo: boolean, isUseProcessingTimes: boolean, isUseProcessingCostSubtotal: boolean, isUseSetupCostSubtotal: boolean, rateKind: string | null }>, processingCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, facilityKinds: Array<{ __typename?: 'FacilityKind', id: string, code: string | null, name: string }> } | null }> | null, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type PriceAdjustmentItemValidateMutationVariables = Exact<{
  input: PriceAdjustmentItemValidateInput;
}>;


export type PriceAdjustmentItemValidateMutation = { __typename?: 'Mutation', priceAdjustmentItemValidate: { __typename?: 'PriceAdjustmentItemValidatePayload', isValid: boolean, errors: Array<{ __typename?: 'InputFormError', formSchemaCode: string, dictKey: string, field: string, messages: Array<string>, seqNo: number | null }> | null } | null };

export type PriceAdjustmentSaveMutationVariables = Exact<{
  input: PriceAdjustmentSaveInput;
}>;


export type PriceAdjustmentSaveMutation = { __typename?: 'Mutation', priceAdjustmentSave: { __typename?: 'priceAdjustmentSavePayload', errors: Array<string>, priceAdjustment: { __typename?: 'PriceAdjustment', id: string } | null, inputFormErrors: Array<{ __typename?: 'InputFormError', formSchemaCode: string, dictKey: string, field: string, messages: Array<string>, seqNo: number | null }> | null } | null };

export type PriceAdjustmentUpdateMutationVariables = Exact<{
  input: PriceAdjustmentUpdateInput;
}>;


export type PriceAdjustmentUpdateMutation = { __typename?: 'Mutation', priceAdjustmentUpdate: { __typename?: 'PriceAdjustmentUpdatePayload', priceAdjustment: { __typename?: 'PriceAdjustment', id: string } | null, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type PriceAdjustmentWithdrawMutationVariables = Exact<{
  input: PriceAdjustmentWithdrawInput;
}>;


export type PriceAdjustmentWithdrawMutation = { __typename?: 'Mutation', priceAdjustmentWithdraw: { __typename?: 'PriceAdjustmentWithdrawPayload', errors: Array<string>, priceAdjustment: { __typename?: 'PriceAdjustment', id: string } | null } | null };

export type PriceAdjustmentsCreatableCheckMutationVariables = Exact<{
  code?: InputMaybe<Scalars['String']['input']>;
  figureNumber?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  referenceDate?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
}>;


export type PriceAdjustmentsCreatableCheckMutation = { __typename?: 'Mutation', priceAdjustmentsCreatableCheck: { __typename?: 'PriceAdjustmentsCreatableCheckPayload', priceAdjustableIds: Array<string> | null, priceUnadjustablePartCodeAndNames: Array<string> | null, err: string | null } | null };

export type PriceAdjustmentsCreatableCheckByIdsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PriceAdjustmentsCreatableCheckByIdsMutation = { __typename?: 'Mutation', priceAdjustmentsCreatableCheckByIds: { __typename?: 'PriceAdjustmentsCreatableCheckByIdsPayload', priceAdjustableIds: Array<string> | null, priceUnadjustablePartCodeAndNames: Array<string> | null, err: string | null } | null };

export type PriceAdjustmentsCreateMutationVariables = Exact<{
  partsId: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  targetTerm: Scalars['String']['input'];
  adjustmentPurpose: Scalars['String']['input'];
  confirmationStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  confirmationDeadlineDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  tenantId: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type PriceAdjustmentsCreateMutation = { __typename?: 'Mutation', priceAdjustmentsCreate: { __typename?: 'PriceAdjustmentsCreatePayload', priceAdjustments: Array<{ __typename?: 'PriceAdjustment', id: string }> | null, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type PriceAdjustmentsCsvCreateMutationVariables = Exact<{
  input: PriceAdjustmentsCsvCreateInput;
}>;


export type PriceAdjustmentsCsvCreateMutation = { __typename?: 'Mutation', priceAdjustmentsCsvCreate: { __typename?: 'PriceAdjustmentsCsvCreatePayload', priceAdjustments: Array<{ __typename?: 'PriceAdjustment', id: string }> | null, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }>, errorRecords: Array<{ __typename?: 'ErrorRecord', row: number, message: string }> | null } | null };

export type ProfileUpdateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  tel: Scalars['String']['input'];
  department: Scalars['String']['input'];
  title: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
  csvExportEncodingKind?: InputMaybe<SupplierUserCsvExportEncodingKindEnum>;
  tenantAssignments?: InputMaybe<Array<TenantAssignmentInput> | TenantAssignmentInput>;
}>;


export type ProfileUpdateMutation = { __typename?: 'Mutation', profileUpdate: { __typename?: 'ProfileUpdatePayload', err: string | null, profile: { __typename?: 'SupplierAccount', id: string, name: string, email: string } | null } | null };

export type QuotationsDeclineMutationVariables = Exact<{
  declineMemo?: InputMaybe<Scalars['String']['input']>;
  quotationRequestIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type QuotationsDeclineMutation = { __typename?: 'Mutation', quotationsDecline: { __typename?: 'QuotationsDeclinePayload', isSuccess: boolean, errors: Array<string> } | null };

export type ShareCommentUpsertMutationVariables = Exact<{
  input: ShareCommentUpsertInput;
}>;


export type ShareCommentUpsertMutation = { __typename?: 'Mutation', shareCommentUpsert: { __typename?: 'ShareCommentUpsertPayload', err: string | null, shareComment: { __typename?: 'ShareComment', id: string, serviceId: string, textMemo1: string | null, textMemo2: string | null, textMemo3: string | null, textMemo4: string | null, textMemo5: string | null, numericMemo1: number | null, numericMemo2: number | null, numericMemo3: number | null, numericMemo4: number | null, numericMemo5: number | null, dateMemo1: any | null, dateMemo2: any | null, dateMemo3: any | null, dateMemo4: any | null, dateMemo5: any | null, booleanMemo1: boolean | null, booleanMemo2: boolean | null, booleanMemo3: boolean | null, booleanMemo4: boolean | null, booleanMemo5: boolean | null } | null } | null };

export type SharedDataCsvExportMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  supplierCode: Scalars['String']['input'];
  shareConfigId: Scalars['ID']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  shareId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SharedDataCsvExportMutation = { __typename?: 'Mutation', sharedDataCsvExport: { __typename?: 'SharedDataCsvExportPayload', res: { __typename?: 'CsvExportRes', errs: Array<string>, result: { __typename?: 'SupplierCsvExportResult', signedUrl: string | null } | null } } | null };

export type SharedDataCsvImportMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  supplierCode: Scalars['String']['input'];
  shareConfigId: Scalars['ID']['input'];
  fileUrl: Scalars['String']['input'];
  shareId: Scalars['ID']['input'];
}>;


export type SharedDataCsvImportMutation = { __typename?: 'Mutation', sharedDataCsvImport: { __typename?: 'SharedDataCsvImportPayload', errs: Array<string>, result: { __typename?: 'SharedDataCsvImportResult', successCount: number, errorCount: number, errors: Array<{ __typename?: 'CsvImportErrorRecord', row: number, message: string }> } | null } | null };

export type SupplierAccountInvitationBySupplierFrontendCompleteMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type SupplierAccountInvitationBySupplierFrontendCompleteMutation = { __typename?: 'Mutation', supplierAccountInvitationBySupplierFrontendComplete: { __typename?: 'SupplierAccountInvitationBySupplierFrontendCompletePayload', err: string | null } | null };

export type SupplierAccountInvitationByTenantFrontendCompleteMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type SupplierAccountInvitationByTenantFrontendCompleteMutation = { __typename?: 'Mutation', supplierAccountInvitationByTenantFrontendComplete: { __typename?: 'SupplierAccountInvitationByTenantFrontendCompletePayload', err: string | null } | null };

export type SupplierAccountSelectedTenantUpdateMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
}>;


export type SupplierAccountSelectedTenantUpdateMutation = { __typename?: 'Mutation', supplierAccountSelectedTenantUpdate: { __typename?: 'SupplierAccountSelectedTenantUpdatePayload', tenantName: string | null, errors: { __typename?: 'ValidationErr', path: string, message: string, shortMessage: string } | null } | null };

export type SupplierAccountTenantLinkDeleteMutationVariables = Exact<{
  supplierAccountId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  supplierCode: Scalars['String']['input'];
  endedAt?: InputMaybe<Scalars['String']['input']>;
}>;


export type SupplierAccountTenantLinkDeleteMutation = { __typename?: 'Mutation', supplierAccountTenantLinkDelete: { __typename?: 'SupplierAccountTenantLinkDeletePayload', err: string | null } | null };

export type SupplierAccountTenantLinkRestoreMutationVariables = Exact<{
  supplierAccountId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  supplierCode: Scalars['String']['input'];
  startedAt?: InputMaybe<Scalars['String']['input']>;
  isSendSupplierFirmInfoConfirmationRequest?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SupplierAccountTenantLinkRestoreMutation = { __typename?: 'Mutation', supplierAccountTenantLinkRestore: { __typename?: 'SupplierAccountTenantLinkRestorePayload', err: string | null } | null };

export type SupplierAccountTenantLinkUpsertMutationVariables = Exact<{
  supplierAccountId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  supplierCode: Scalars['String']['input'];
  startedAt?: InputMaybe<Scalars['String']['input']>;
  isSendNotification: Scalars['Boolean']['input'];
  isSendSupplierFirmInfoConfirmationRequest?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SupplierAccountTenantLinkUpsertMutation = { __typename?: 'Mutation', supplierAccountTenantLinkUpsert: { __typename?: 'SupplierAccountTenantLinkUpsertPayload', err: string | null } | null };

export type SupplierAnnouncementReadMutationVariables = Exact<{ [key: string]: never; }>;


export type SupplierAnnouncementReadMutation = { __typename?: 'Mutation', supplierAnnouncementsRead: { __typename?: 'SupplierAnnouncementsReadPayload', result: boolean } | null };

export type SupplierCorporationEmployeeArchiveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SupplierCorporationEmployeeArchiveMutation = { __typename?: 'Mutation', supplierCorporationEmployeeArchive: { __typename?: 'SupplierCorporationEmployeeArchivePayload', supplierCorporationEmployee: { __typename?: 'SupplierCorporationEmployee', id: string } | null, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type SupplierCorporationEmployeeUnarchiveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SupplierCorporationEmployeeUnarchiveMutation = { __typename?: 'Mutation', supplierCorporationEmployeeUnarchive: { __typename?: 'SupplierCorporationEmployeeUnarchivePayload', supplierCorporationEmployee: { __typename?: 'SupplierCorporationEmployee', id: string } | null, errors: Array<{ __typename?: 'ValidationErr', path: string, message: string, shortMessage: string }> } | null };

export type SupplierFirmInfoConfirmationRequestStatusUpdateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<SupplierFirmInfoConfirmationRequestStatusEnum>;
}>;


export type SupplierFirmInfoConfirmationRequestStatusUpdateMutation = { __typename?: 'Mutation', supplierFirmInfoConfirmationRequestStatusUpdate: { __typename?: 'SupplierFirmInfoConfirmationRequestStatusUpdatePayload', errors: Array<string> } | null };

export type SupplierMoldStorageApplicationSaveMutationVariables = Exact<{
  previousId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
  supplierId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
  supplierAccountId?: InputMaybe<Scalars['ID']['input']>;
  supplierUserId?: InputMaybe<Scalars['ID']['input']>;
  attachments?: InputMaybe<Array<CommonAttachmentInput> | CommonAttachmentInput>;
  confirmationDueDate: Scalars['ISO8601Date']['input'];
  supplierMoldStorageApplicationDetails: Array<SupplierMoldStorageApplicationDetailInput> | SupplierMoldStorageApplicationDetailInput;
}>;


export type SupplierMoldStorageApplicationSaveMutation = { __typename?: 'Mutation', supplierMoldStorageApplicationSave: { __typename?: 'SupplierMoldStorageApplicationSavePayload', supplierMoldStorageApplication: { __typename?: 'SupplierMoldStorageApplication', id: string, uid: string, title: string, comment: string, confirmationDueDate: any, status: number, supplierMoldStorageApplicationDetails: Array<{ __typename?: 'SupplierMoldStorageApplicationDetail', id: string, storageCost: number | null, storageStartDate: any | null, publicMemo: string | null, mold: { __typename?: 'Mold', id: string, uid: string, tenantId: string, name: string, width: number | null, depth: number | null, height: number | null, weight: number | null, isNew: boolean | null, isPermanent: boolean | null, manageableId: string | null, manageableType: string | null, publicMemo: string | null, storageLocation: string | null, category: string | null, assetNumber: string | null, storageSymbol: string | null, status: string | null, evidenceComment: string | null, paymentEvidenceComment: string | null, storageEvidenceComment: string | null, disposeEvidenceComment: string | null, supplierDisposeReportComment: string | null, supplierDisposeReportedAt: any | null, employee: { __typename?: 'Employee', id: string, name: string }, supplier: { __typename?: 'Supplier', id: string, name: string, code: string, adminUser: { __typename?: 'AdminUser', id: string, name: string, employee: { __typename?: 'Employee', id: string, name: string } | null } | null }, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string } | null, manageable: { __typename?: 'MoldManageable', id: string, name: string, code: string } | null, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, paymentAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, storageAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, disposeAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierDisposeReportAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, moldStartUp: { __typename?: 'MoldStartUp', id: string, tenantId: string, moldId: string, quotedCost: number | null, acquisitionCost: number | null }, moldProduction: { __typename?: 'MoldProduction', id: string, tenantId: string, moldId: string, outputPerShot: number | null, shotCount: number | null, cumulativePartTransaction: number | null, remainingShotCount: number | null, flowTendency: number | null }, moldStorage: { __typename?: 'MoldStorage', id: string, tenantId: string, moldId: string, storageCost: number | null, retroactivePrice: number | null }, moldDispose: { __typename?: 'MoldDispose', id: string, tenantId: string, moldId: string, disposeCost: number | null, scrapCost: number | null, disposeRequestDate: any | null }, moldLifecycleEvent: { __typename?: 'MoldLifecycleEvent', id: string, tenantId: string, moldId: string, operationStartDate: any | null, inspectionReceiptDate: any | null, productionStartNotificationReceiptDate: any | null, quoteStatementReceiptDate: any | null, storageStartDate: any | null, disposeDate: any | null }, moldUsages: Array<{ __typename?: 'MoldUsage', id: string, moldId: string, targettableType: string | null, targettable: { __typename?: 'Part', id: string, name: string, code: string | null, figureNumber: string | null, rootPartCode: string | null, totalReceivedQuantity: number | null, flowTendency: string | null, partAnnualTotal: { __typename?: 'PartAnnualTotal', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number, quantity4: number, quantity5: number, quantity6: number, quantity7: number, quantity8: number, quantity9: number, quantity10: number, quantity11: number, quantity12: number } | null, partUnofficialAnnouncement: { __typename?: 'PartUnofficialAnnouncement', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number } | null, partTransactions: Array<{ __typename?: 'PartTransaction', id: string, tenantId: string, orderNumber: string | null, orderSeqNo: number | null, receivedOn: any | null, unitPrice: number, receivedQuantity: number, checkNumber: string | null, checkSeqNo: number | null, checkDate: any, subtotal: number, currencyRate: number, part: { __typename?: 'Part', id: string, name: string, code: string | null }, supplier: { __typename?: 'Supplier', id: string, name: string, isTemporary: boolean, code: string }, currency: { __typename?: 'Currency', isBaseCurrency: boolean, currencyCode: string }, toJpy: { __typename?: 'PartTransactionJpy', subtotal: number, unitPrice: number } }> | null } | null }> } }> | null } | null } | null };

export type SupplierPriceAdjustmentFormAmendMutationVariables = Exact<{
  input: AmendSupplierPriceAdjustmentDraftInput;
}>;


export type SupplierPriceAdjustmentFormAmendMutation = { __typename?: 'Mutation', priceAdjustmentAmendForm: { __typename?: 'amendSupplierPriceAdjustmentDraftPayload', errors: Array<string>, priceAdjustment: { __typename?: 'PriceAdjustment', id: string, tenantCode: string, targetTerm: string, memo: string, confirmationDeadlineDate: any | null } | null } | null };

export type SupplierSurveyInfoExcelImportMutationVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  importTargetExcel: AttachmentInput;
}>;


export type SupplierSurveyInfoExcelImportMutation = { __typename?: 'Mutation', supplierSurveyInfoExcelImport: { __typename?: 'SupplierSurveyInfoExcelImportPayload', errors: Array<string>, warnings: Array<string> } | null };

export type SupplyPartCsvExportMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  figureNumber?: InputMaybe<Scalars['String']['input']>;
  assignmentPriceKind?: InputMaybe<Scalars['String']['input']>;
  referenceDate?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  conditionsText?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type SupplyPartCsvExportMutation = { __typename?: 'Mutation', supplyPartCsvExport: { __typename?: 'SupplyPartCsvExportPayload', res: { __typename?: 'CsvExportRes', errs: Array<string>, result: { __typename?: 'SupplierCsvExportResult', signedUrl: string | null } | null } } | null };

export type TrialQuotationAnswerAiDraftMutationVariables = Exact<{
  input: TrialQuotationAnswerAiDraftInput;
}>;


export type TrialQuotationAnswerAiDraftMutation = { __typename?: 'Mutation', trialQuotationAnswerAiDraft: { __typename?: 'TrialQuotationAnswerAiDraftPayload', note: string | null, quotationValidUntil: any | null, errors: Array<string>, items: Array<{ __typename?: 'TrialQuotationAnswerAiDraftItem', quotationItemId: string, unitPrice: number, taxType: number | null, breakdowns: Array<{ __typename?: 'TrialQuotationAnswerAiDraftBreakdown', name: string, quantity: number, unitName: string, unitPrice: number }> }> } | null };

export type TrialQuotationAnswerCancelMutationVariables = Exact<{
  input: TrialQuotationAnswerCancelInput;
}>;


export type TrialQuotationAnswerCancelMutation = { __typename?: 'Mutation', trialQuotationAnswerCancel: { __typename?: 'TrialQuotationAnswerCancelPayload', errors: Array<string>, answer: { __typename?: 'TrialQuotationAnswer', id: string, revisionNo: number, state: number, isDeclined: boolean, answerMemo: string, deliveryOn: any | null, quotationValidUntil: any | null, submittedAt: any, items: Array<{ __typename?: 'TrialQuotationAnswerItem', quotationItemId: string, seqNo: number, breakdownSeqNo: number, name: string, makerName: string, makerModel: string, quantity: number | null, unitName: string, taxType: number, unitPrice: number | null, isDeclined: boolean }>, attachments: Array<{ __typename?: 'TrialQuotationAnswerAttachment', id: string, attachmentKind: number, seqNo: number, fileName: string, contentType: string, byteSize: number, url: string, downloadUrl: string }> } | null } | null };

export type TrialQuotationAnswerSubmitMutationVariables = Exact<{
  input: TrialQuotationAnswerSubmitInput;
}>;


export type TrialQuotationAnswerSubmitMutation = { __typename?: 'Mutation', trialQuotationAnswerSubmit: { __typename?: 'TrialQuotationAnswerSubmitPayload', conflict: boolean, errors: Array<string>, answer: { __typename?: 'TrialQuotationAnswer', id: string, revisionNo: number, state: number, isDeclined: boolean, answerMemo: string, deliveryOn: any | null, quotationValidUntil: any | null, submittedAt: any, items: Array<{ __typename?: 'TrialQuotationAnswerItem', quotationItemId: string, seqNo: number, breakdownSeqNo: number, name: string, makerName: string, makerModel: string, quantity: number | null, unitName: string, taxType: number, unitPrice: number | null, isDeclined: boolean }>, attachments: Array<{ __typename?: 'TrialQuotationAnswerAttachment', id: string, attachmentKind: number, seqNo: number, fileName: string, contentType: string, byteSize: number, url: string, downloadUrl: string }> } | null } | null };

export type TrialQuotationAttachmentClassifyMutationVariables = Exact<{
  input: TrialQuotationAttachmentClassifyInput;
}>;


export type TrialQuotationAttachmentClassifyMutation = { __typename?: 'Mutation', trialQuotationAttachmentClassify: { __typename?: 'TrialQuotationAttachmentClassifyPayload', errors: Array<string>, classifications: Array<{ __typename?: 'TrialQuotationAttachmentClassification', url: string, attachmentKind: number }> } | null };

export type UpdateCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  body: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
  attachments?: InputMaybe<Array<AttachmentInput> | AttachmentInput>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCommentMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'UpdateCommentPayload', errors: Array<string>, commentNode: { __typename?: 'CommentNode', id: string, body: string, parentId: string | null, authorAdminUserId: string | null, authorAdminUserName: string | null, authorSupplierAccountId: string | null, authorSupplierAccountName: string | null, authorSupplierUserId: string | null, authorSupplierUserName: string | null, targetKind: CommentNodeTargetKindEnum, supplierId: string | null, deletedAt: any | null, canEdit: boolean, canDelete: boolean, createdAt: any, updatedAt: any, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierUserInfoCommentConfirmations: Array<{ __typename?: 'SupplierUserInfoCommentConfirmation', id: string, supplierUserInfoId: string | null, confirmedAt: any | null, supplyChainCompanyEmployeeName: string | null, supplierUserInfo: { __typename?: 'SupplierUserInfo', id: string, supplierUserId: string | null } | null }>, userCommentConfirmations: Array<{ __typename?: 'UserCommentConfirmation', id: string, adminUserId: string, confirmedAt: any | null, adminUser: { __typename?: 'AdminUser', id: string, name: string } }> } | null } | null };

export type AdminUsersQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  roleCondition?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type AdminUsersQuery = { __typename?: 'Query', adminUsers: { __typename?: 'AdminUserConnection', nodes: Array<{ __typename?: 'AdminUser', id: string, name: string, email: string, adminUserGroups: Array<{ __typename?: 'AdminUserGroup', id: string, name: string }> | null }> } };

export type AdminUsersByTransactionQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  transactionKind: Scalars['String']['input'];
}>;


export type AdminUsersByTransactionQuery = { __typename?: 'Query', adminUsersByTransaction: { __typename?: 'AdminUserConnection', nodes: Array<{ __typename?: 'AdminUser', id: string, name: string }> } };

export type AgreementsQueryVariables = Exact<{ [key: string]: never; }>;


export type AgreementsQuery = { __typename?: 'Query', termsOfService: { __typename?: 'VersionedAgreement', version: string, content: string }, privacyPolicy: { __typename?: 'VersionedAgreement', version: string, content: string } };

export type AllStatesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllStatesQuery = { __typename?: 'Query', allStates: Array<{ __typename?: 'State', id: string, name: string, countryId: string }> };

export type AttachmentOfferQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AttachmentOfferQuery = { __typename?: 'Query', attachmentOffer: { __typename?: 'AttachmentOffer', id: string, uid: string, itemRootCode: string | null, itemName: string | null, itemCode: string | null, designChangeCode: string | null, figureNumber: string | null, purpose: string | null, isDiscardNecessary: boolean, discardDeadlineOn: any | null, status: string, isDownloadable: boolean, previewUrl: string | null, latestAcknowledgedAt: any | null, memo: string | null, offeredAt: any | null, tenant: { __typename?: 'Tenant', id: string, name: string }, supplier: { __typename?: 'Supplier', code: string, name: string }, personInChargeAdminUser: { __typename?: 'AdminUser', id: string, name: string } | null, attachment: { __typename?: 'Attachment', id: string, name: string, nameForSupplier: string | null }, discardEvent: { __typename?: 'AttachmentOfferEvent', createdAt: any | null, supplierAccount: { __typename?: 'SupplierAccount', id: string, name: string } | null, supplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null } | null, downloadEvents: Array<{ __typename?: 'AttachmentOfferEvent', id: string }> | null, quotationItem: { __typename?: 'QuotationItemV2', id: string, quotation: { __typename?: 'Quotation', id: string, uid: string }, project: { __typename?: 'Project', id: string } | null } | null } | null, selectedTenant: { __typename?: 'Tenant', id: string } | null };

export type AttachmentOffersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  itemName?: InputMaybe<Scalars['String']['input']>;
  itemRootCode?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  adminUserIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
  figureNumber?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type AttachmentOffersQuery = { __typename?: 'Query', attachmentOffers: { __typename?: 'AttachmentOfferConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, nodes: Array<{ __typename?: 'AttachmentOffer', id: string, uid: string, itemRootCode: string | null, itemCode: string | null, itemName: string | null, figureNumber: string | null, status: string, isDownloadable: boolean, latestAcknowledgedAt: any | null, discardDeadlineOn: any | null, offeredAt: any | null, isDiscardNecessary: boolean, attachment: { __typename?: 'Attachment', id: string, name: string, nameForSupplier: string | null }, personInChargeAdminUser: { __typename?: 'AdminUser', id: string, name: string } | null, discardEvent: { __typename?: 'AttachmentOfferEvent', createdAt: any | null, supplierAccount: { __typename?: 'SupplierAccount', id: string, name: string } | null, supplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null } | null, downloadEvents: Array<{ __typename?: 'AttachmentOfferEvent', id: string }> | null, tenant: { __typename?: 'Tenant', id: string }, supplier: { __typename?: 'Supplier', id: string, code: string, name: string } }> } };

export type BcpIncidentAnswerPartSupplyChainQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  partId: Scalars['ID']['input'];
}>;


export type BcpIncidentAnswerPartSupplyChainQuery = { __typename?: 'Query', bcpIncidentAnswerDraft: { __typename?: 'BcpIncidentAnswerDraft', id: string, partSupplyChainSteps: Array<{ __typename?: 'BcpIncidentAnswerPartSupplyChainStep', processOrder: number, processName: string, siteName: string | null }> } | null };

export type BcpIncidentAnswerRequestQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BcpIncidentAnswerRequestQuery = { __typename?: 'Query', bcpIncidentAnswerRequest: { __typename?: 'BcpIncidentAnswerRequest', id: string, tenantName: string, incidentName: string | null, incidentStatus: BcpIncidentAnswerDraftIncidentStatusEnum | null, isDrill: boolean, disasterKind: BcpDisasterKindEnum, dueDatetime: any | null, recipientName: string | null, isCompanyView: boolean, siteCount: number, drafts: Array<{ __typename?: 'BcpIncidentAnswerDraft', id: string, siteName: string | null, version: string, hasImpact: boolean | null, impactDetail: string | null, detailReportPending: boolean, detailReportEta: string | null, asksParts: boolean, answeredBy: string | null, answeredAt: any | null, partsDecideSiteImpact: boolean, partsAiProposalRemaining: number, categories: { __typename?: 'BcpIncidentAnswerCategories', humanDamageLevel: BcpIncidentAnswerCategoryLevelEnum | null, humanDamageComment: string | null, buildingDamageLevel: BcpIncidentAnswerCategoryLevelEnum | null, buildingDamageComment: string | null, equipmentDamageLevel: BcpIncidentAnswerCategoryLevelEnum | null, equipmentDamageComment: string | null, productionImpactLevel: BcpIncidentAnswerCategoryLevelEnum | null, productionImpactComment: string | null, deliveryImpactLevel: BcpIncidentAnswerCategoryLevelEnum | null, deliveryImpactComment: string | null, supportRequest: string | null }, previousAnswer: { __typename?: 'BcpIncidentPreviousAnswer', hasImpact: boolean, impactDetail: string | null, detailReportPending: boolean, detailReportEta: string | null, answeredAt: any | null, categories: { __typename?: 'BcpIncidentAnswerCategories', humanDamageLevel: BcpIncidentAnswerCategoryLevelEnum | null, humanDamageComment: string | null, buildingDamageLevel: BcpIncidentAnswerCategoryLevelEnum | null, buildingDamageComment: string | null, equipmentDamageLevel: BcpIncidentAnswerCategoryLevelEnum | null, equipmentDamageComment: string | null, productionImpactLevel: BcpIncidentAnswerCategoryLevelEnum | null, productionImpactComment: string | null, deliveryImpactLevel: BcpIncidentAnswerCategoryLevelEnum | null, deliveryImpactComment: string | null, supportRequest: string | null } } | null, attachments: Array<{ __typename?: 'Attachment', id: string, name: string, url: string }>, parts: Array<{ __typename?: 'BcpIncidentAnswerPart', id: string, partCode: string, partName: string, figureNumber: string | null, hasSupplyChain: boolean, supplierCode: string | null, isConnected: boolean, impactKind: BcpIncidentAnswerPartImpactKindEnum | null, comment: string | null, previousImpactKind: BcpIncidentAnswerPartImpactKindEnum | null, previousComment: string | null }> }> } | null };

export type BcpIncidentAnswerRequestByTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type BcpIncidentAnswerRequestByTokenQuery = { __typename?: 'Query', bcpIncidentAnswerRequestByToken: { __typename?: 'BcpIncidentAnswerRequestByToken', state: BcpIncidentAnswerTokenStateEnum, requestId: string, request: { __typename?: 'BcpIncidentAnswerTokenRequest', id: string, tenantName: string, incidentName: string | null, isDrill: boolean, disasterKind: BcpDisasterKindEnum, dueDatetime: any | null, drafts: Array<{ __typename?: 'BcpIncidentAnswerTokenDraft', id: string, siteName: string | null, hasImpact: boolean | null, impactDetail: string | null, detailReportPending: boolean, detailReportEta: string | null, answeredBy: string | null, answeredAt: any | null, partsDecideSiteImpact: boolean, categories: { __typename?: 'BcpIncidentAnswerTokenCategories', humanDamageLevel: BcpIncidentAnswerCategoryLevelEnum | null, humanDamageComment: string | null, buildingDamageLevel: BcpIncidentAnswerCategoryLevelEnum | null, buildingDamageComment: string | null, equipmentDamageLevel: BcpIncidentAnswerCategoryLevelEnum | null, equipmentDamageComment: string | null, productionImpactLevel: BcpIncidentAnswerCategoryLevelEnum | null, productionImpactComment: string | null, deliveryImpactLevel: BcpIncidentAnswerCategoryLevelEnum | null, deliveryImpactComment: string | null }, parts: Array<{ __typename?: 'BcpIncidentAnswerTokenPart', id: string, partCode: string, supplierCode: string | null, impactKind: BcpIncidentAnswerPartImpactKindEnum | null, previousImpactKind: BcpIncidentAnswerPartImpactKindEnum | null, previousComment: string | null }>, previousAnswer: { __typename?: 'BcpIncidentAnswerTokenPreviousAnswer', hasImpact: boolean, impactDetail: string | null, detailReportPending: boolean, detailReportEta: string | null, answeredAt: any | null, categories: { __typename?: 'BcpIncidentAnswerTokenCategories', humanDamageLevel: BcpIncidentAnswerCategoryLevelEnum | null, humanDamageComment: string | null, buildingDamageLevel: BcpIncidentAnswerCategoryLevelEnum | null, buildingDamageComment: string | null, equipmentDamageLevel: BcpIncidentAnswerCategoryLevelEnum | null, equipmentDamageComment: string | null, productionImpactLevel: BcpIncidentAnswerCategoryLevelEnum | null, productionImpactComment: string | null, deliveryImpactLevel: BcpIncidentAnswerCategoryLevelEnum | null, deliveryImpactComment: string | null } } | null }> } | null } | null };

export type BcpIncidentAnswerRequestSitesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BcpIncidentAnswerRequestSitesQuery = { __typename?: 'Query', bcpIncidentAnswerRequest: { __typename?: 'BcpIncidentAnswerRequest', id: string, tenantName: string, incidentName: string | null, disasterKind: BcpDisasterKindEnum, drafts: Array<{ __typename?: 'BcpIncidentAnswerDraft', id: string, siteName: string | null }> } | null };

export type BcpIncidentAnswerRequestsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  excludeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BcpIncidentAnswerRequestsQuery = { __typename?: 'Query', bcpIncidentAnswerRequests: { __typename?: 'BcpIncidentAnswerRequestConnection', totalCount: number, nodes: Array<{ __typename?: 'BcpIncidentAnswerRequest', id: string, tenantName: string, incidentName: string | null, isDrill: boolean, dueDatetime: any | null, incidentStatus: BcpIncidentAnswerDraftIncidentStatusEnum | null, siteCount: number, unanswered: boolean, firstAnswerOnlyCount: number }> } };

export type CommentBaseQueryVariables = Exact<{
  commentKind: CommentKindEnum;
  targetId: Scalars['ID']['input'];
  itemKind: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommentBaseQuery = { __typename?: 'Query', commentBase: { __typename?: 'CommentBase', id: string, commentKind: string, targetId: string, itemKind: string, createdAt: any, updatedAt: any, commentNodes: Array<{ __typename?: 'CommentNode', id: string, body: string, parentId: string | null, authorAdminUserId: string | null, authorAdminUserName: string | null, authorSupplierAccountId: string | null, authorSupplierAccountName: string | null, authorSupplierUserId: string | null, authorSupplierUserName: string | null, targetKind: CommentNodeTargetKindEnum, supplierId: string | null, deletedAt: any | null, canEdit: boolean, canDelete: boolean, createdAt: any, updatedAt: any, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierUserInfoCommentConfirmations: Array<{ __typename?: 'SupplierUserInfoCommentConfirmation', id: string, supplierUserInfoId: string | null, confirmedAt: any | null, supplyChainCompanyEmployeeName: string | null, supplierUserInfo: { __typename?: 'SupplierUserInfo', id: string, supplierUserId: string | null } | null }>, userCommentConfirmations: Array<{ __typename?: 'UserCommentConfirmation', id: string, adminUserId: string, confirmedAt: any | null, adminUser: { __typename?: 'AdminUser', id: string, name: string } }> }> } | null };

export type CommentSettingQueryVariables = Exact<{
  commentKind: CommentKindEnum;
  targetId: Scalars['ID']['input'];
  itemKind?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommentSettingQuery = { __typename?: 'Query', commentSetting: { __typename?: 'CommentSetting', supplierAccountReadable: boolean, supplierAccountWritable: boolean } | null };

export type ContactClassesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
}>;


export type ContactClassesQuery = { __typename?: 'Query', contactClasses: Array<{ __typename?: 'ContactClass', id: string, code: string, name: string, order: number, isArchived: boolean }> };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', id: string, name: string, translation: string | null, iso3: string | null }> };

export type CrSupplierFirmQueryVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
}>;


export type CrSupplierFirmQuery = { __typename?: 'Query', crSupplierFirm: Array<{ __typename?: 'CrSupplierFirm', id: string, beforeAfterKind: SupplierSurveyBeforeAfterKindEnum, name: string, nameShort: string | null, nameEn: string | null, nameKana: string | null, president: string | null, url: string | null, capital: number | null, tel: string | null, fax: string | null, email: string | null, establishedDate: any | null, startTransactionDate: any | null, numberOfEmployees: number | null, listingKind: SupplierListingKindEnum | null, closingMonth: SupplierClosingMonthEnum | null, issuedShares: number | null, dividendAmount: number | null, companyBackground: string | null, numberOfEmployeesOther: number | null, businessDescription: string | null, generalText1: string | null, generalText2: string | null, generalText3: string | null, generalText4: string | null, generalText5: string | null, generalText6: string | null, generalText7: string | null, generalText8: string | null, generalText9: string | null, generalText10: string | null, generalText11: string | null, generalText12: string | null, generalText13: string | null, generalText14: string | null, generalText15: string | null, generalText16: string | null, generalText17: string | null, generalText18: string | null, generalText19: string | null, generalText20: string | null, before: { __typename?: 'CrSupplierFirm', id: string, beforeAfterKind: SupplierSurveyBeforeAfterKindEnum, name: string, nameShort: string | null, nameEn: string | null, nameKana: string | null, president: string | null, url: string | null, capital: number | null, tel: string | null, fax: string | null, email: string | null, establishedDate: any | null, startTransactionDate: any | null, numberOfEmployees: number | null, listingKind: SupplierListingKindEnum | null, closingMonth: SupplierClosingMonthEnum | null, issuedShares: number | null, dividendAmount: number | null, companyBackground: string | null, numberOfEmployeesOther: number | null, businessDescription: string | null, generalText1: string | null, generalText2: string | null, generalText3: string | null, generalText4: string | null, generalText5: string | null, generalText6: string | null, generalText7: string | null, generalText8: string | null, generalText9: string | null, generalText10: string | null, generalText11: string | null, generalText12: string | null, generalText13: string | null, generalText14: string | null, generalText15: string | null, generalText16: string | null, generalText17: string | null, generalText18: string | null, generalText19: string | null, generalText20: string | null, capitalCurrency: { __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean } | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null, industry: { __typename?: 'Industry', id: string, code: string | null, name: string | null, order: number, isArchived: boolean } | null, generalKind1Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind2Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind3Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind4Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind5Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind6Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind7Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind8Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind9Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind10Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKinds1Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds2Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds3Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds4Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds5Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds6Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds7Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds8Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds9Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds10Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }> } | null, capitalCurrency: { __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean } | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null, industry: { __typename?: 'Industry', id: string, code: string | null, name: string | null, order: number, isArchived: boolean } | null, generalKind1Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind2Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind3Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind4Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind5Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind6Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind7Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind8Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind9Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKind10Option: { __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null } | null, generalKinds1Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds2Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds3Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds4Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds5Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds6Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds7Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds8Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds9Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }>, generalKinds10Options: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }> }> };

export type CrSupplierFirmBankInfosQueryVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
}>;


export type CrSupplierFirmBankInfosQuery = { __typename?: 'Query', crSupplierFirmBankInfos: Array<Array<{ __typename?: 'CrSupplierFirmBankInfo', id: string, isArchived: boolean, financialInstitutionName: string | null, branchName: string | null, borrowingRatio: number | null, memo: string | null, before: { __typename?: 'CrSupplierFirmBankInfo', id: string, isArchived: boolean, financialInstitutionName: string | null, branchName: string | null, borrowingRatio: number | null, memo: string | null } | null }>> };

export type CrSupplierFirmCertificationInfosQueryVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
}>;


export type CrSupplierFirmCertificationInfosQuery = { __typename?: 'Query', crSupplierFirmCertificationInfos: Array<Array<{ __typename?: 'CrSupplierFirmCertificationInfo', id: string, isArchived: boolean, acquisitionDate: any | null, expirationDate: any | null, isRelatedToOwnCompany: boolean | null, certificationAuthorityName: string | null, certificationNumber: string | null, updateDate: any | null, revisionDate: any | null, memo: string | null, before: { __typename?: 'CrSupplierFirmCertificationInfo', id: string, isArchived: boolean, acquisitionDate: any | null, expirationDate: any | null, isRelatedToOwnCompany: boolean | null, certificationAuthorityName: string | null, certificationNumber: string | null, updateDate: any | null, revisionDate: any | null, memo: string | null, certificationClass: { __typename?: 'CertificationClass', id: string, name: string | null, certificationStandard: string | null } } | null, certificationClass: { __typename?: 'CertificationClass', id: string, name: string | null, certificationStandard: string | null } }>> };

export type CrSupplierFirmEmployeeNumberInfosQueryVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
}>;


export type CrSupplierFirmEmployeeNumberInfosQuery = { __typename?: 'Query', crSupplierFirmEmployeeNumberInfos: Array<Array<{ __typename?: 'CrSupplierFirmEmployeeNumberInfo', id: string, isArchived: boolean, numberOfEmployees: number | null, numberOfEmployeesMan: number | null, numberOfEmployeesWoman: number | null, showGenderBreakdown: boolean, before: { __typename?: 'CrSupplierFirmEmployeeNumberInfo', id: string, isArchived: boolean, numberOfEmployees: number | null, numberOfEmployeesMan: number | null, numberOfEmployeesWoman: number | null, showGenderBreakdown: boolean, supplierEmployeeClass: { __typename?: 'SupplierEmployeeClass', id: string, name: string } } | null, supplierEmployeeClass: { __typename?: 'SupplierEmployeeClass', id: string, name: string } }>> };

export type CrSupplierFirmEquipmentInfosQueryVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
}>;


export type CrSupplierFirmEquipmentInfosQuery = { __typename?: 'Query', crSupplierFirmEquipmentInfos: Array<Array<{ __typename?: 'CrSupplierFirmEquipmentInfo', id: string, equipmentMachineName: string | null, manufacturerName: string | null, model: string | null, year: string | null, quantity: number | null, remarks: string | null, location: string | null, quantityUnit: string | null, productionCapacity: string | null, isArchived: boolean, category: string | null, before: { __typename?: 'CrSupplierFirmEquipmentInfo', id: string, equipmentMachineName: string | null, manufacturerName: string | null, model: string | null, year: string | null, quantity: number | null, remarks: string | null, location: string | null, quantityUnit: string | null, productionCapacity: string | null, isArchived: boolean, category: string | null } | null }>> };

export type CrSupplierFirmFileInfosQueryVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
}>;


export type CrSupplierFirmFileInfosQuery = { __typename?: 'Query', crSupplierFirmFileInfos: Array<Array<{ __typename?: 'CrSupplierFirmFileInfo', id: string, expirationDateFrom: any | null, expirationDateTo: any | null, isArchived: boolean, registeredAt: any, registeredBy: string | null, memo: string | null, before: { __typename?: 'CrSupplierFirmFileInfo', id: string, expirationDateFrom: any | null, expirationDateTo: any | null, isArchived: boolean, registeredAt: any, registeredBy: string | null, memo: string | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }, supplierFileClass: { __typename?: 'SupplierFileClass', id: string, name: string, order: number, isSatisfyElectronicBookPreservationAct: boolean, canModifyBySupplierFirmInfoConfirmationRequest: boolean, canSupplierEditCrAnswer: boolean, canSupplierDeleteCrAnswer: boolean } } | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }, supplierFileClass: { __typename?: 'SupplierFileClass', id: string, name: string, order: number, isSatisfyElectronicBookPreservationAct: boolean, canModifyBySupplierFirmInfoConfirmationRequest: boolean, canSupplierEditCrAnswer: boolean, canSupplierDeleteCrAnswer: boolean } }>> };

export type CrSupplierFirmFinancialDetailsQueryVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
  financialStatementKind: Scalars['String']['input'];
}>;


export type CrSupplierFirmFinancialDetailsQuery = { __typename?: 'Query', crSupplierFirmFinancialDetails: Array<Array<{ __typename?: 'CrSupplierFirmFinancialDetail', id: string, isArchived: boolean, financialStatementKind: string | null, name: string | null, amount: number | null, displayAmount: number | null, parentId: string | null, changeRate: number | null, before: { __typename?: 'CrSupplierFirmFinancialDetail', id: string, isArchived: boolean, financialStatementKind: string | null, name: string | null, amount: number | null, displayAmount: number | null, parentId: string | null, changeRate: number | null, supplierAccountingItem: { __typename?: 'SupplierAccountingItem', id: string, parentId: string | null, code: string, name: string, isAsset: boolean, isLiability: boolean, isNetAsset: boolean, isEditable: boolean, isSubtraction: boolean, level: number } } | null, supplierAccountingItem: { __typename?: 'SupplierAccountingItem', id: string, parentId: string | null, code: string, name: string, isAsset: boolean, isLiability: boolean, isNetAsset: boolean, isEditable: boolean, isSubtraction: boolean, level: number } }>> };

export type CrSupplierFirmFinancialInfoQueryVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
}>;


export type CrSupplierFirmFinancialInfoQuery = { __typename?: 'Query', crSupplierFirmFinancialInfo: Array<{ __typename?: 'CrSupplierFirmFinancialInfo', id: string, supplierFirmInfoConfirmationRequestId: string, isArchived: boolean, financialStatementPeriodFrom: any | null, financialStatementPeriodTo: any | null, bsAmountUnitKindLabel: string | null, plAmountUnitKindLabel: string | null, cfAmountUnitKindLabel: string | null, grossProfitMarginRatio: number | null, operatingProfitRatio: number | null, salesOperatingProfitRatio: number | null, netProfitRatio: number | null, grossProfitMarginRatioChangeRate: number | null, operatingProfitRatioChangeRate: number | null, salesOperatingProfitRatioChangeRate: number | null, netProfitRatioChangeRate: number | null, bsLiabilityNetAssetTotalChangeRate: number | null, before: { __typename?: 'CrSupplierFirmFinancialInfo', id: string, supplierFirmInfoConfirmationRequestId: string, isArchived: boolean, financialStatementPeriodFrom: any | null, financialStatementPeriodTo: any | null, bsAmountUnitKindLabel: string | null, plAmountUnitKindLabel: string | null, cfAmountUnitKindLabel: string | null, grossProfitMarginRatio: number | null, operatingProfitRatio: number | null, salesOperatingProfitRatio: number | null, netProfitRatio: number | null, grossProfitMarginRatioChangeRate: number | null, operatingProfitRatioChangeRate: number | null, salesOperatingProfitRatioChangeRate: number | null, netProfitRatioChangeRate: number | null, bsLiabilityNetAssetTotalChangeRate: number | null, currency: { __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean } } | null, currency: { __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean } } | null> };

export type CrSupplierFirmKeyPositionInfosQueryVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
}>;


export type CrSupplierFirmKeyPositionInfosQuery = { __typename?: 'Query', crSupplierFirmKeyPositionInfos: Array<Array<{ __typename?: 'CrSupplierFirmKeyPositionInfo', id: string, isArchived: boolean, positionName: string | null, responsibilities: string | null, fullName: string | null, age: number | null, memo: string | null, nameKana: string | null, hasRepresentativeAuthority: boolean | null, birthDate: any | null, positionStartDate: any | null, before: { __typename?: 'CrSupplierFirmKeyPositionInfo', id: string, isArchived: boolean, positionName: string | null, responsibilities: string | null, fullName: string | null, age: number | null, memo: string | null, nameKana: string | null, hasRepresentativeAuthority: boolean | null, birthDate: any | null, positionStartDate: any | null } | null }>> };

export type CrSupplierFirmLaborSituationInfoQueryVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
}>;


export type CrSupplierFirmLaborSituationInfoQuery = { __typename?: 'Query', crSupplierFirmLaborSituationInfo: Array<{ __typename?: 'CrSupplierFirmLaborSituationInfo', id: string, annualWorkingDays: number | null, holidayType: string | null, averageOvertimePerPerson: number | null, attendanceRate: number | null, averageBasicSalary: number | null, averageAge: number | null, averageYearsOfService: number | null, memo: string | null, isArchived: boolean, before: { __typename?: 'CrSupplierFirmLaborSituationInfo', id: string, annualWorkingDays: number | null, holidayType: string | null, averageOvertimePerPerson: number | null, attendanceRate: number | null, averageBasicSalary: number | null, averageAge: number | null, averageYearsOfService: number | null, memo: string | null, isArchived: boolean } | null } | null> };

export type CrSupplierFirmManufacturingSitesQueryVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
}>;


export type CrSupplierFirmManufacturingSitesQuery = { __typename?: 'Query', crSupplierFirmManufacturingSites: Array<Array<{ __typename?: 'CrSupplierFirmManufacturingSite', id: string, code: string | null, name: string, isArchived: boolean, tel: string | null, fax: string | null, landArea: number | null, landOwnershipKind: SupplierManufacturingSiteLandOwnershipKindEnum | null, buildingArea: number | null, buildingOwnershipKind: SupplierManufacturingSiteBuildingOwnershipKindEnum | null, president: string | null, capitalAmount: number | null, businessDescription: string | null, numberOfEmployees: number | null, establishedDate: any | null, overseasExpansionDate: any | null, investmentTypeName: string | null, investmentRatio: number | null, memo: string | null, partsMemo: string | null, numberOfEmployeesOther: number | null, investorName: string | null, investorName2: string | null, investmentRatio2: number | null, before: { __typename?: 'CrSupplierFirmManufacturingSite', id: string, code: string | null, name: string, isArchived: boolean, tel: string | null, fax: string | null, landArea: number | null, landOwnershipKind: SupplierManufacturingSiteLandOwnershipKindEnum | null, buildingArea: number | null, buildingOwnershipKind: SupplierManufacturingSiteBuildingOwnershipKindEnum | null, president: string | null, capitalAmount: number | null, businessDescription: string | null, numberOfEmployees: number | null, establishedDate: any | null, overseasExpansionDate: any | null, investmentTypeName: string | null, investmentRatio: number | null, memo: string | null, partsMemo: string | null, numberOfEmployeesOther: number | null, investorName: string | null, investorName2: string | null, investmentRatio2: number | null, capitalCurrency: { __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean } | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null } | null, capitalCurrency: { __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean } | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null }>> };

export type CrSupplierFirmMemberOrganizationsQueryVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
}>;


export type CrSupplierFirmMemberOrganizationsQuery = { __typename?: 'Query', crSupplierFirmMemberOrganizations: Array<Array<{ __typename?: 'CrSupplierFirmMemberOrganization', id: string, isArchived: boolean, name: string | null, memo: string | null, before: { __typename?: 'CrSupplierFirmMemberOrganization', id: string, isArchived: boolean, name: string | null, memo: string | null } | null }>> };

export type CrSupplierFirmOutsourcingInfosQueryVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
}>;


export type CrSupplierFirmOutsourcingInfosQuery = { __typename?: 'Query', crSupplierFirmOutsourcingInfos: Array<Array<{ __typename?: 'CrSupplierFirmOutsourcingInfo', id: string, name: string, siteName: string | null, isArchived: boolean, factory: string | null, industry: string | null, numberOfEmployees: number | null, president: string | null, remarks: string | null, salesAmount: number | null, transactionAmount: number | null, transactionItem: string | null, purchaseRate: number | null, processingType: string | null, tenantDependencyRate: number | null, capitalAmount: number | null, certificationInfo: string | null, before: { __typename?: 'CrSupplierFirmOutsourcingInfo', id: string, name: string, siteName: string | null, isArchived: boolean, factory: string | null, industry: string | null, numberOfEmployees: number | null, president: string | null, remarks: string | null, salesAmount: number | null, transactionAmount: number | null, transactionItem: string | null, purchaseRate: number | null, processingType: string | null, tenantDependencyRate: number | null, capitalAmount: number | null, certificationInfo: string | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null, crSupplierOutsourcingClassLinks: Array<{ __typename?: 'CrSupplierOutsourcingClassLink', id: string, supplierOutsourcingClass: { __typename?: 'SupplierOutsourcingClass', id: string, code: string | null, name: string, order: number, isArchived: boolean } }> } | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null, crSupplierOutsourcingClassLinks: Array<{ __typename?: 'CrSupplierOutsourcingClassLink', id: string, supplierOutsourcingClass: { __typename?: 'SupplierOutsourcingClass', id: string, code: string | null, name: string, order: number, isArchived: boolean } }> }>> };

export type CrSupplierFirmRepresentativeInfoQueryVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
}>;


export type CrSupplierFirmRepresentativeInfoQuery = { __typename?: 'Query', crSupplierFirmRepresentativeInfo: Array<{ __typename?: 'CrSupplierFirmRepresentativeInfo', id: string, isArchived: boolean, name: string | null, nameKana: string | null, nameEn: string | null, position: string | null, biography: string | null, age: number | null, memo: string | null, isExistSuccessor: boolean | null, successorName: string | null, successorRelationship: string | null, successorAge: number | null, birthDate: any | null, before: { __typename?: 'CrSupplierFirmRepresentativeInfo', id: string, isArchived: boolean, name: string | null, nameKana: string | null, nameEn: string | null, position: string | null, biography: string | null, age: number | null, memo: string | null, isExistSuccessor: boolean | null, successorName: string | null, successorRelationship: string | null, successorAge: number | null, birthDate: any | null } | null } | null> };

export type CrSupplierFirmSalesStatusInfosQueryVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
}>;


export type CrSupplierFirmSalesStatusInfosQuery = { __typename?: 'Query', crSupplierFirmSalesStatusInfos: Array<Array<{ __typename?: 'CrSupplierFirmSalesStatusInfo', id: string, isArchived: boolean, companyName: string | null, salesRatio: number | null, isTenantSales: boolean, salesAmount: number | null, memo: string | null, salesPartsMemo: string | null, hasTransactionToTenant: boolean | null, before: { __typename?: 'CrSupplierFirmSalesStatusInfo', id: string, isArchived: boolean, companyName: string | null, salesRatio: number | null, isTenantSales: boolean, salesAmount: number | null, memo: string | null, salesPartsMemo: string | null, hasTransactionToTenant: boolean | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null } | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null }>> };

export type CrSupplierFirmShareholderInfosQueryVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
}>;


export type CrSupplierFirmShareholderInfosQuery = { __typename?: 'Query', crSupplierFirmShareholderInfos: Array<Array<{ __typename?: 'CrSupplierFirmShareholderInfo', id: string, isArchived: boolean, shareholderName: string | null, percentage: number | null, shareholding: number | null, memo: string | null, before: { __typename?: 'CrSupplierFirmShareholderInfo', id: string, isArchived: boolean, shareholderName: string | null, percentage: number | null, shareholding: number | null, memo: string | null } | null }>> };

export type CrSupplierFirmSitesQueryVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
}>;


export type CrSupplierFirmSitesQuery = { __typename?: 'Query', crSupplierFirmSites: Array<Array<{ __typename?: 'CrSupplierFirmSite', id: string, code: string | null, name: string | null, isArchived: boolean, tel: string | null, fax: string | null, landArea: number | null, landOwnershipKind: SupplierSiteLandOwnershipKindEnum | null, buildingArea: number | null, buildingOwnershipKind: SupplierSiteBuildingOwnershipKindEnum | null, president: string | null, capitalAmount: number | null, businessDescription: string | null, numberOfEmployees: number | null, establishedDate: any | null, overseasExpansionDate: any | null, investmentTypeName: string | null, investmentRatio: number | null, memo: string | null, partsMemo: string | null, numberOfEmployeesOther: number | null, investorName: string | null, investorName2: string | null, investmentRatio2: number | null, before: { __typename?: 'CrSupplierFirmSite', id: string, code: string | null, name: string | null, isArchived: boolean, tel: string | null, fax: string | null, landArea: number | null, landOwnershipKind: SupplierSiteLandOwnershipKindEnum | null, buildingArea: number | null, buildingOwnershipKind: SupplierSiteBuildingOwnershipKindEnum | null, president: string | null, capitalAmount: number | null, businessDescription: string | null, numberOfEmployees: number | null, establishedDate: any | null, overseasExpansionDate: any | null, investmentTypeName: string | null, investmentRatio: number | null, memo: string | null, partsMemo: string | null, numberOfEmployeesOther: number | null, investorName: string | null, investorName2: string | null, investmentRatio2: number | null, capitalCurrency: { __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean } | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null } | null, capitalCurrency: { __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean } | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null }>> };

export type CrSupplierFirmSurveyEnqueteAnswersQueryVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
}>;


export type CrSupplierFirmSurveyEnqueteAnswersQuery = { __typename?: 'Query', crSupplierFirmSurveyEnqueteAnswers: Array<Array<{ __typename?: 'CrSupplierFirmSurveyEnqueteAnswer', id: string, isArchived: boolean, before: { __typename?: 'CrSupplierFirmSurveyEnqueteAnswer', id: string, isArchived: boolean, supplierEnqueteAnswer: { __typename?: 'SupplierEnqueteAnswer', answerValue: string | null, isArchived: boolean | null, supplierEnqueteQuestionConfig: { __typename?: 'SupplierEnqueteQuestionConfig', name: string, code: string } } } | null, supplierEnqueteAnswer: { __typename?: 'SupplierEnqueteAnswer', answerValue: string | null, isArchived: boolean | null, supplierEnqueteQuestionConfig: { __typename?: 'SupplierEnqueteQuestionConfig', name: string, code: string } } }>> };

export type CrSupplierFirmUserInfosQueryVariables = Exact<{
  supplierFirmInfoConfirmationRequestId: Scalars['ID']['input'];
}>;


export type CrSupplierFirmUserInfosQuery = { __typename?: 'Query', crSupplierFirmUserInfos: Array<Array<{ __typename?: 'CrSupplierFirmUserInfo', id: string, beforeAfterKind: SupplierSurveyBeforeAfterKindEnum, name: string, nameKana: string | null, email: string, tel: string | null, fax: string | null, department: string | null, title: string | null, emailEmergency: string | null, telEmergency: string | null, mailingAddress: string | null, startOn: any | null, endOn: any | null, isArchived: boolean, before: { __typename?: 'CrSupplierFirmUserInfo', id: string, beforeAfterKind: SupplierSurveyBeforeAfterKindEnum, name: string, nameKana: string | null, email: string, tel: string | null, fax: string | null, department: string | null, title: string | null, emailEmergency: string | null, telEmergency: string | null, mailingAddress: string | null, startOn: any | null, endOn: any | null, isArchived: boolean, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null, crContactClassLinks: Array<{ __typename?: 'CrContactClassLink', id: string, contactClass: { __typename?: 'ContactClass', id: string, code: string, name: string, order: number, isArchived: boolean } }> } | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null, crContactClassLinks: Array<{ __typename?: 'CrContactClassLink', id: string, contactClass: { __typename?: 'ContactClass', id: string, code: string, name: string, order: number, isArchived: boolean } }> }>> };

export type CurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrenciesQuery = { __typename?: 'Query', currencies: Array<{ __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean }> };

export type DataSharesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  supplierCode: Scalars['String']['input'];
  shareConfigId: Scalars['ID']['input'];
}>;


export type DataSharesQuery = { __typename?: 'Query', dataShares: Array<{ __typename?: 'DataShare', id: string, sharedAt: any, changedCount: number, addedCount: number, updatedCount: number, deletedCount: number }> | null };

export type DeliveredAnnouncementByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeliveredAnnouncementByIdQuery = { __typename?: 'Query', deliveredAnnouncement: { __typename?: 'DeliveredAnnouncement', id: string, confirmedAt: any | null, viewedAt: any | null, tenant: { __typename?: 'Tenant', name: string }, announcement: { __typename?: 'Announcement', body: string, confirmationDeadline: any | null, displayFrom: any, displayTo: any, id: string, priority: AnnouncementPriorityEnum, status: AnnouncementStatusEnum, title: string, tenantId: number, applicantUser: { __typename?: 'AdminUser', name: string }, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> } } | null };

export type DeliveredAnnouncementsQueryVariables = Exact<{
  onlyNotConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DeliveredAnnouncementsQuery = { __typename?: 'Query', deliveredAnnouncements: { __typename?: 'DeliveredAnnouncementConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, nodes: Array<{ __typename?: 'DeliveredAnnouncement', id: string, confirmedAt: any | null, viewedAt: any | null, tenant: { __typename?: 'Tenant', name: string }, announcement: { __typename?: 'Announcement', body: string, confirmationDeadline: any | null, displayFrom: any, displayTo: any, id: string, priority: AnnouncementPriorityEnum, status: AnnouncementStatusEnum, title: string, tenantId: number, applicantUser: { __typename?: 'AdminUser', name: string }, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> } }> } };

export type DeliverySitesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
}>;


export type DeliverySitesQuery = { __typename?: 'Query', deliverySites: Array<{ __typename?: 'DeliverySite', id: string, name: string, code: string | null }> };

export type EnqueteAnswerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EnqueteAnswerQuery = { __typename?: 'Query', enqueteAnswer: { __typename?: 'EnqueteAnswer', id: string, status: EnqueteAnswerStatusEnum, answeredAt: any | null, returnReason: string | null, returnedAt: any | null, supplyChainCompanyEmployeeName: string | null, enquete: { __typename?: 'Enquete', id: string, title: string, description: string | null, priority: EnquetePriorityEnum, displayFrom: any | null, displayTo: any | null, enqueteKind: EnqueteKindEnum, status: EnqueteStatusEnum, answerGranularityKind: EnqueteAnswerGranularityKindEnum, questionSchema: { __typename?: 'EnqueteQuestionSchema', id: string, title: string, description: string, isSaq: boolean, attachments: Array<{ __typename?: 'Attachment', id: string, url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, questions: Array<{ __typename?: 'EnqueteQuestion', id: string, title: string, questionKind: EnqueteQuestionKindEnum, displayOrder: number, isRequired: boolean, length: number | null, condition: { __typename?: 'EnqueteQuestionCondition', parentQuestionId: string, optionIds: Array<string>, effect: EnqueteQuestionConditionEffectEnum } | null, attachments: Array<{ __typename?: 'Attachment', id: string, url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, questionOptions: Array<{ __typename?: 'EnqueteQuestionOption', id: string, label: string, displayOrder: number }>, subQuestions: Array<{ __typename?: 'EnqueteSubQuestion', id: string, label: string, displayOrder: number | null }> }>, questionSections: Array<{ __typename?: 'EnqueteQuestionSection', id: string, title: string, description: string | null, displayOrder: number, attachments: Array<{ __typename?: 'Attachment', id: string, url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, questions: Array<{ __typename?: 'EnqueteQuestion', id: string, title: string, questionKind: EnqueteQuestionKindEnum, displayOrder: number, isRequired: boolean, length: number | null, condition: { __typename?: 'EnqueteQuestionCondition', parentQuestionId: string, optionIds: Array<string>, effect: EnqueteQuestionConditionEffectEnum } | null, attachments: Array<{ __typename?: 'Attachment', id: string, url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, questionOptions: Array<{ __typename?: 'EnqueteQuestionOption', id: string, label: string, displayOrder: number }>, subQuestions: Array<{ __typename?: 'EnqueteSubQuestion', id: string, label: string, displayOrder: number | null }> }> }> } | null, enqueteDataSchema: { __typename?: 'EnqueteDataSchema', id: string, title: string, description: string, attachments: Array<{ __typename?: 'Attachment', id: string, url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, enqueteDataColumns: Array<{ __typename?: 'EnqueteDataColumn', id: string, name: string, dataType: EnqueteDataColumnKindEnum, displayOrder: number, isRequired: boolean }>, enqueteDataRows: Array<{ __typename?: 'EnqueteDataRow', id: string, name: string, displayOrder: number }>, enqueteDataFixedCells: Array<{ __typename?: 'EnqueteDataFixedCell', id: string, value: string, rowId: string, columnId: string }> } | null }, notificationTargets: Array<{ __typename?: 'EnqueteNotificationTarget', id: string, name: string, email: string | null }>, tenant: { __typename?: 'Tenant', id: string, name: string }, enqueteQuestionAnswers: Array<{ __typename?: 'EnqueteQuestionAnswer', id: string, value: string, subQuestionId: string | null, attachments: Array<{ __typename?: 'Attachment', id: string, url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, enqueteQuestion: { __typename?: 'EnqueteQuestion', id: string, title: string, questionKind: EnqueteQuestionKindEnum, displayOrder: number, isRequired: boolean } }> } };

export type EnqueteAnswersQueryVariables = Exact<{
  withNotificationTargets?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  onlyUnanswered?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  excludeClosed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EnqueteAnswersQuery = { __typename?: 'Query', enqueteAnswers: { __typename?: 'EnqueteAnswerConnection', totalCount: number, nodes: Array<{ __typename?: 'EnqueteAnswer', id: string, status: EnqueteAnswerStatusEnum, answeredAt: any | null, supplyChainCompanyEmployeeName: string | null, enquete: { __typename?: 'Enquete', id: string, title: string, description: string | null, priority: EnquetePriorityEnum, displayFrom: any | null, displayTo: any | null, enqueteKind: EnqueteKindEnum, status: EnqueteStatusEnum, answerGranularityKind: EnqueteAnswerGranularityKindEnum, createdAt: any, updatedAt: any, questionSchema: { __typename?: 'EnqueteQuestionSchema', id: string, title: string } | null, enqueteDataSchema: { __typename?: 'EnqueteDataSchema', id: string, title: string } | null }, notificationTargets?: Array<{ __typename?: 'EnqueteNotificationTarget', id: string, name: string, email: string | null }>, tenant: { __typename?: 'Tenant', id: string, name: string } }> } };

export type HasUnreadCommentsQueryVariables = Exact<{
  commentKind: CommentKindEnum;
  targetId: Scalars['ID']['input'];
  itemKind?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
  ignoreCommentTop?: InputMaybe<Scalars['Boolean']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type HasUnreadCommentsQuery = { __typename?: 'Query', hasUnreadComments: boolean };

export type IncompleteTasksQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type IncompleteTasksQuery = { __typename?: 'Query', incompleteTasks: { __typename?: 'IncompleteTaskConnection', totalCount: number, nodes: Array<{ __typename?: 'IncompleteTask', id: string, tenantId: string | null, tenantName: string, supplierCode: string | null, taskType: IncompleteTaskEnum, title: string, dueDate: any | null, delayed: boolean, isTrial: boolean, bulkAnswerPackageId: string | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } };

export type IndustriesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
}>;


export type IndustriesQuery = { __typename?: 'Query', industries: Array<{ __typename?: 'Industry', id: string, code: string | null, name: string | null, order: number, isArchived: boolean }> };

export type InputFormSchemaQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  formattableId?: InputMaybe<Scalars['ID']['input']>;
  formattableType?: InputMaybe<Scalars['String']['input']>;
}>;


export type InputFormSchemaQuery = { __typename?: 'Query', inputFormSchema: { __typename?: 'InputFormSchema', code: string, description: string | null, dictKey: string, tenantId: string | null, properties: any } | null };

export type ItemRequirementByPriceAdjustmentItemQueryVariables = Exact<{
  priceAdjustmentItemId: Scalars['ID']['input'];
}>;


export type ItemRequirementByPriceAdjustmentItemQuery = { __typename?: 'Query', itemRequirementByPriceAdjustmentItem: { __typename?: 'ItemRequirement', code: string | null, name: string, makerName: string | null, makerCode: string | null, makerModelNumber: string | null, figureNumber: string | null, rootPartCode: string | null, designChangeCode: string | null, itemPropInfosForSupplier: Array<{ __typename?: 'ItemPropInfo', id: string, itemProppableType: string, itemProppableId: string, stringValue: string | null, numberValue: number | null, booleanValue: boolean | null, position: number, itemProp: { __typename?: 'ItemProp', id: string, name: string, code: string | null, unit: string | null, kind: ItemPropKind }, selectedOptions: Array<{ __typename?: 'ItemPropOption', id: string, label: string, position: number }> }>, specAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, designAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> } | null };

export type ListViewSchemaQueryVariables = Exact<{
  code: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ListViewSchemaQuery = { __typename?: 'Query', listViewSchema: { __typename?: 'ListViewSchema', code: string, description: string | null, tenantId: string | null, searchFormProperties: Array<{ __typename?: 'ListViewSchemaSearchFormProperty', name: string, labelDictKey: string, type: string, shrinkable: boolean | null, from: string | null, to: string | null, optionLabels: Array<string> | null, optionValues: Array<string> | null, withArchived: boolean | null, accountKind: string | null, selectOptions: Array<{ __typename?: 'ListViewSchemaSearchFormSelectOption', label: string, value: string }> | null }>, listProperties: Array<{ __typename?: 'ListViewSchemaListProperty', name: string, labelDictKey: string, type: string }> } };

export type ManufacturingSitesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
}>;


export type ManufacturingSitesQuery = { __typename?: 'Query', manufacturingSites: Array<{ __typename?: 'ManufacturingSite', id: string, name: string, code: string | null }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'SupplierAccount', id: string, name: string, email: string, languageCode: string, supplierCorporation: { __typename?: 'SupplierCorporation', id: string, name: string } | null, supplierAccountTenantLinks: Array<{ __typename?: 'SupplierAccountTenantLink', id: string, tenant: { __typename?: 'Tenant', id: string, name: string }, corporation: { __typename?: 'SupplierCorporation', name: string } }>, selectedTenant: { __typename?: 'Tenant', id: string, name: string, code: string, inOperationScope: boolean, quotationConfig: { __typename?: 'QuotationConfig', isUseQuotationPackage: boolean, isUseTemporaryAnswer: boolean } | null } | null } | null };

export type MoldQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MoldQuery = { __typename?: 'Query', mold: { __typename?: 'Mold', id: string, uid: string, tenantId: string, name: string, width: number | null, depth: number | null, height: number | null, weight: number | null, isNew: boolean | null, isPermanent: boolean | null, manageableId: string | null, manageableType: string | null, publicMemo: string | null, storageLocation: string | null, category: string | null, assetNumber: string | null, storageSymbol: string | null, status: string | null, evidenceComment: string | null, paymentEvidenceComment: string | null, storageEvidenceComment: string | null, disposeEvidenceComment: string | null, supplierDisposeReportComment: string | null, supplierDisposeReportedAt: any | null, employee: { __typename?: 'Employee', id: string, name: string }, supplier: { __typename?: 'Supplier', id: string, name: string, code: string, adminUser: { __typename?: 'AdminUser', id: string, name: string, employee: { __typename?: 'Employee', id: string, name: string } | null } | null }, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string } | null, manageable: { __typename?: 'MoldManageable', id: string, name: string, code: string } | null, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, paymentAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, storageAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, disposeAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierDisposeReportAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, moldStartUp: { __typename?: 'MoldStartUp', id: string, tenantId: string, moldId: string, quotedCost: number | null, acquisitionCost: number | null }, moldProduction: { __typename?: 'MoldProduction', id: string, tenantId: string, moldId: string, outputPerShot: number | null, shotCount: number | null, cumulativePartTransaction: number | null, remainingShotCount: number | null, flowTendency: number | null }, moldStorage: { __typename?: 'MoldStorage', id: string, tenantId: string, moldId: string, storageCost: number | null, retroactivePrice: number | null }, moldDispose: { __typename?: 'MoldDispose', id: string, tenantId: string, moldId: string, disposeCost: number | null, scrapCost: number | null, disposeRequestDate: any | null }, moldLifecycleEvent: { __typename?: 'MoldLifecycleEvent', id: string, tenantId: string, moldId: string, operationStartDate: any | null, inspectionReceiptDate: any | null, productionStartNotificationReceiptDate: any | null, quoteStatementReceiptDate: any | null, storageStartDate: any | null, disposeDate: any | null }, moldUsages: Array<{ __typename?: 'MoldUsage', id: string, moldId: string, targettableType: string | null, targettable: { __typename?: 'Part', id: string, name: string, code: string | null, figureNumber: string | null, rootPartCode: string | null, totalReceivedQuantity: number | null, flowTendency: string | null, partAnnualTotal: { __typename?: 'PartAnnualTotal', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number, quantity4: number, quantity5: number, quantity6: number, quantity7: number, quantity8: number, quantity9: number, quantity10: number, quantity11: number, quantity12: number } | null, partUnofficialAnnouncement: { __typename?: 'PartUnofficialAnnouncement', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number } | null, partTransactions: Array<{ __typename?: 'PartTransaction', id: string, tenantId: string, orderNumber: string | null, orderSeqNo: number | null, receivedOn: any | null, unitPrice: number, receivedQuantity: number, checkNumber: string | null, checkSeqNo: number | null, checkDate: any, subtotal: number, currencyRate: number, part: { __typename?: 'Part', id: string, name: string, code: string | null }, supplier: { __typename?: 'Supplier', id: string, name: string, isTemporary: boolean, code: string }, currency: { __typename?: 'Currency', isBaseCurrency: boolean, currencyCode: string }, toJpy: { __typename?: 'PartTransactionJpy', subtotal: number, unitPrice: number } }> | null } | null }> } };

export type MoldDisposalSupplierApplicationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MoldDisposalSupplierApplicationQuery = { __typename?: 'Query', moldDisposalSupplierApplication: { __typename?: 'MoldDisposalSupplierApplication', id: string, uid: string, title: string, status: number, applicationDate: any, confirmationDueDate: any, approvalDate: any | null, comment: string, remandComment: string | null, createdAt: any, updatedAt: any, supplier: { __typename?: 'Supplier', id: string, name: string, code: string }, employee: { __typename?: 'Employee', id: string, name: string }, tenant: { __typename?: 'Tenant', id: string, name: string, code: string }, supplierAccount: { __typename?: 'SupplierAccount', id: string, name: string } | null, supplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> | null, moldDisposalSupplierApplicationDetails: Array<{ __typename?: 'MoldDisposalSupplierApplicationDetail', id: string, disposeCost: number | null, disposeRequestDate: any | null, publicMemo: string | null, scrapCost: number | null, createdAt: any, updatedAt: any, mold: { __typename?: 'Mold', id: string, uid: string, tenantId: string, name: string, width: number | null, depth: number | null, height: number | null, weight: number | null, isNew: boolean | null, isPermanent: boolean | null, manageableId: string | null, manageableType: string | null, publicMemo: string | null, storageLocation: string | null, category: string | null, assetNumber: string | null, storageSymbol: string | null, status: string | null, evidenceComment: string | null, paymentEvidenceComment: string | null, storageEvidenceComment: string | null, disposeEvidenceComment: string | null, supplierDisposeReportComment: string | null, supplierDisposeReportedAt: any | null, employee: { __typename?: 'Employee', id: string, name: string }, supplier: { __typename?: 'Supplier', id: string, name: string, code: string, adminUser: { __typename?: 'AdminUser', id: string, name: string, employee: { __typename?: 'Employee', id: string, name: string } | null } | null }, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string } | null, manageable: { __typename?: 'MoldManageable', id: string, name: string, code: string } | null, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, paymentAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, storageAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, disposeAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierDisposeReportAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, moldStartUp: { __typename?: 'MoldStartUp', id: string, tenantId: string, moldId: string, quotedCost: number | null, acquisitionCost: number | null }, moldProduction: { __typename?: 'MoldProduction', id: string, tenantId: string, moldId: string, outputPerShot: number | null, shotCount: number | null, cumulativePartTransaction: number | null, remainingShotCount: number | null, flowTendency: number | null }, moldStorage: { __typename?: 'MoldStorage', id: string, tenantId: string, moldId: string, storageCost: number | null, retroactivePrice: number | null }, moldDispose: { __typename?: 'MoldDispose', id: string, tenantId: string, moldId: string, disposeCost: number | null, scrapCost: number | null, disposeRequestDate: any | null }, moldLifecycleEvent: { __typename?: 'MoldLifecycleEvent', id: string, tenantId: string, moldId: string, operationStartDate: any | null, inspectionReceiptDate: any | null, productionStartNotificationReceiptDate: any | null, quoteStatementReceiptDate: any | null, storageStartDate: any | null, disposeDate: any | null }, moldUsages: Array<{ __typename?: 'MoldUsage', id: string, moldId: string, targettableType: string | null, targettable: { __typename?: 'Part', id: string, name: string, code: string | null, figureNumber: string | null, rootPartCode: string | null, totalReceivedQuantity: number | null, flowTendency: string | null, partAnnualTotal: { __typename?: 'PartAnnualTotal', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number, quantity4: number, quantity5: number, quantity6: number, quantity7: number, quantity8: number, quantity9: number, quantity10: number, quantity11: number, quantity12: number } | null, partUnofficialAnnouncement: { __typename?: 'PartUnofficialAnnouncement', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number } | null, partTransactions: Array<{ __typename?: 'PartTransaction', id: string, tenantId: string, orderNumber: string | null, orderSeqNo: number | null, receivedOn: any | null, unitPrice: number, receivedQuantity: number, checkNumber: string | null, checkSeqNo: number | null, checkDate: any, subtotal: number, currencyRate: number, part: { __typename?: 'Part', id: string, name: string, code: string | null }, supplier: { __typename?: 'Supplier', id: string, name: string, isTemporary: boolean, code: string }, currency: { __typename?: 'Currency', isBaseCurrency: boolean, currencyCode: string }, toJpy: { __typename?: 'PartTransactionJpy', subtotal: number, unitPrice: number } }> | null } | null }> } }> | null } | null };

export type MoldDisposalSupplierApplicationsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  applicationNo?: InputMaybe<Scalars['String']['input']>;
  moldNo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MoldDisposalSupplierApplicationsQuery = { __typename?: 'Query', moldDisposalSupplierApplications: { __typename?: 'MoldDisposalSupplierApplicationConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, nodes: Array<{ __typename?: 'MoldDisposalSupplierApplication', id: string, uid: string, title: string, status: number, applicationDate: any, confirmationDueDate: any, approvalDate: any | null, comment: string, remandComment: string | null, createdAt: any, updatedAt: any, supplier: { __typename?: 'Supplier', id: string, name: string, code: string }, employee: { __typename?: 'Employee', id: string, name: string }, tenant: { __typename?: 'Tenant', id: string, name: string, code: string }, supplierAccount: { __typename?: 'SupplierAccount', id: string, name: string } | null, supplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> | null, moldDisposalSupplierApplicationDetails: Array<{ __typename?: 'MoldDisposalSupplierApplicationDetail', id: string, disposeCost: number | null, disposeRequestDate: any | null, publicMemo: string | null, scrapCost: number | null, createdAt: any, updatedAt: any, mold: { __typename?: 'Mold', id: string, uid: string, tenantId: string, name: string, width: number | null, depth: number | null, height: number | null, weight: number | null, isNew: boolean | null, isPermanent: boolean | null, manageableId: string | null, manageableType: string | null, publicMemo: string | null, storageLocation: string | null, category: string | null, assetNumber: string | null, storageSymbol: string | null, status: string | null, evidenceComment: string | null, paymentEvidenceComment: string | null, storageEvidenceComment: string | null, disposeEvidenceComment: string | null, supplierDisposeReportComment: string | null, supplierDisposeReportedAt: any | null, employee: { __typename?: 'Employee', id: string, name: string }, supplier: { __typename?: 'Supplier', id: string, name: string, code: string, adminUser: { __typename?: 'AdminUser', id: string, name: string, employee: { __typename?: 'Employee', id: string, name: string } | null } | null }, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string } | null, manageable: { __typename?: 'MoldManageable', id: string, name: string, code: string } | null, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, paymentAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, storageAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, disposeAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierDisposeReportAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, moldStartUp: { __typename?: 'MoldStartUp', id: string, tenantId: string, moldId: string, quotedCost: number | null, acquisitionCost: number | null }, moldProduction: { __typename?: 'MoldProduction', id: string, tenantId: string, moldId: string, outputPerShot: number | null, shotCount: number | null, cumulativePartTransaction: number | null, remainingShotCount: number | null, flowTendency: number | null }, moldStorage: { __typename?: 'MoldStorage', id: string, tenantId: string, moldId: string, storageCost: number | null, retroactivePrice: number | null }, moldDispose: { __typename?: 'MoldDispose', id: string, tenantId: string, moldId: string, disposeCost: number | null, scrapCost: number | null, disposeRequestDate: any | null }, moldLifecycleEvent: { __typename?: 'MoldLifecycleEvent', id: string, tenantId: string, moldId: string, operationStartDate: any | null, inspectionReceiptDate: any | null, productionStartNotificationReceiptDate: any | null, quoteStatementReceiptDate: any | null, storageStartDate: any | null, disposeDate: any | null }, moldUsages: Array<{ __typename?: 'MoldUsage', id: string, moldId: string, targettableType: string | null, targettable: { __typename?: 'Part', id: string, name: string, code: string | null, figureNumber: string | null, rootPartCode: string | null, totalReceivedQuantity: number | null, flowTendency: string | null, partAnnualTotal: { __typename?: 'PartAnnualTotal', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number, quantity4: number, quantity5: number, quantity6: number, quantity7: number, quantity8: number, quantity9: number, quantity10: number, quantity11: number, quantity12: number } | null, partUnofficialAnnouncement: { __typename?: 'PartUnofficialAnnouncement', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number } | null, partTransactions: Array<{ __typename?: 'PartTransaction', id: string, tenantId: string, orderNumber: string | null, orderSeqNo: number | null, receivedOn: any | null, unitPrice: number, receivedQuantity: number, checkNumber: string | null, checkSeqNo: number | null, checkDate: any, subtotal: number, currencyRate: number, part: { __typename?: 'Part', id: string, name: string, code: string | null }, supplier: { __typename?: 'Supplier', id: string, name: string, isTemporary: boolean, code: string }, currency: { __typename?: 'Currency', isBaseCurrency: boolean, currencyCode: string }, toJpy: { __typename?: 'PartTransactionJpy', subtotal: number, unitPrice: number } }> | null } | null }> } }> | null }> } };

export type MoldStoragePaymentsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  uidKeyword?: InputMaybe<Scalars['String']['input']>;
  acceptanceDateFrom?: InputMaybe<Scalars['String']['input']>;
  acceptanceDateTo?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MoldStoragePaymentsQuery = { __typename?: 'Query', moldStoragePayments: { __typename?: 'MoldStoragePaymentConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, nodes: Array<{ __typename?: 'MoldStoragePayment', id: string, uid: string, acceptanceDate: any, totalStorageCost: number, moldCount: number, supplier: { __typename?: 'Supplier', id: string, name: string, code: string }, tenant: { __typename?: 'Tenant', id: string, name: string, code: string }, moldStoragePaymentItems: Array<{ __typename?: 'MoldStoragePaymentItem', id: string, moldStoragePaymentId: string, storageStartDate: any, storageCost: number, mold: { __typename?: 'Mold', id: string, uid: string, name: string, manageableId: string | null, manageableType: string | null, category: string | null, assetNumber: string | null, manageable: { __typename?: 'MoldManageable', id: string, name: string, code: string } | null, moldUsages: Array<{ __typename?: 'MoldUsage', id: string, moldId: string, targettableType: string | null, targettable: { __typename?: 'Part', id: string, name: string, code: string | null, figureNumber: string | null } | null }> } }> }> } };

export type MoldsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  supplierKeyWord?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  employeeName?: InputMaybe<Scalars['String']['input']>;
  classification?: InputMaybe<Scalars['String']['input']>;
  manager?: InputMaybe<Scalars['String']['input']>;
  partCode?: InputMaybe<Scalars['String']['input']>;
  partName?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  assetNumber?: InputMaybe<Scalars['String']['input']>;
  maker?: InputMaybe<Scalars['String']['input']>;
  tab: Scalars['String']['input'];
  isMainReadPage?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MoldsQuery = { __typename?: 'Query', molds: { __typename?: 'MoldsWithStatusCount', molds: { __typename?: 'MoldConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, nodes: Array<{ __typename?: 'Mold', id: string, uid: string, tenantId: string, name: string, width: number | null, depth: number | null, height: number | null, weight: number | null, isNew: boolean | null, isPermanent: boolean | null, manageableId: string | null, manageableType: string | null, publicMemo: string | null, storageLocation: string | null, category: string | null, assetNumber: string | null, storageSymbol: string | null, employee: { __typename?: 'Employee', id: string, name: string }, supplier: { __typename?: 'Supplier', id: string, name: string, code: string }, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string } | null, moldStartUp: { __typename?: 'MoldStartUp', id: string, tenantId: string, moldId: string, quotedCost: number | null, acquisitionCost: number | null }, moldProduction: { __typename?: 'MoldProduction', id: string, tenantId: string, moldId: string, outputPerShot: number | null, shotCount: number | null, cumulativePartTransaction: number | null, remainingShotCount: number | null, flowTendency: number | null }, moldStorage: { __typename?: 'MoldStorage', id: string, tenantId: string, moldId: string, storageCost: number | null, retroactivePrice: number | null }, moldDispose: { __typename?: 'MoldDispose', id: string, tenantId: string, moldId: string, disposeCost: number | null, scrapCost: number | null, disposeRequestDate: any | null }, moldLifecycleEvent: { __typename?: 'MoldLifecycleEvent', id: string, tenantId: string, moldId: string, operationStartDate: any | null, inspectionReceiptDate: any | null, productionStartNotificationReceiptDate: any | null, quoteStatementReceiptDate: any | null, storageStartDate: any | null, disposeDate: any | null }, moldUsages: Array<{ __typename?: 'MoldUsage', id: string, moldId: string, targettableType: string | null, targettable: { __typename?: 'Part', id: string, code: string | null, name: string, figureNumber: string | null, totalReceivedQuantity: number | null } | null }> }> }, moldStatusCount: { __typename?: 'MoldStatusCount', startUp: number | null, production: number | null, storage: number | null, dispose: number | null } } };

export type MoldsForApplicationQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  selectedTenantId: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type MoldsForApplicationQuery = { __typename?: 'Query', moldsForApplication: { __typename?: 'MoldsForApplication', tenantId: string, tenantName: string, supplierId: string, supplierCode: string, supplierName: string, molds: Array<{ __typename?: 'Mold', id: string, uid: string, tenantId: string, name: string, width: number | null, depth: number | null, height: number | null, weight: number | null, isNew: boolean | null, isPermanent: boolean | null, manageableId: string | null, manageableType: string | null, publicMemo: string | null, storageLocation: string | null, category: string | null, assetNumber: string | null, storageSymbol: string | null, status: string | null, evidenceComment: string | null, paymentEvidenceComment: string | null, storageEvidenceComment: string | null, disposeEvidenceComment: string | null, supplierDisposeReportComment: string | null, supplierDisposeReportedAt: any | null, employee: { __typename?: 'Employee', id: string, name: string }, supplier: { __typename?: 'Supplier', id: string, name: string, code: string, adminUser: { __typename?: 'AdminUser', id: string, name: string, employee: { __typename?: 'Employee', id: string, name: string } | null } | null }, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string } | null, manageable: { __typename?: 'MoldManageable', id: string, name: string, code: string } | null, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, paymentAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, storageAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, disposeAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierDisposeReportAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, moldStartUp: { __typename?: 'MoldStartUp', id: string, tenantId: string, moldId: string, quotedCost: number | null, acquisitionCost: number | null }, moldProduction: { __typename?: 'MoldProduction', id: string, tenantId: string, moldId: string, outputPerShot: number | null, shotCount: number | null, cumulativePartTransaction: number | null, remainingShotCount: number | null, flowTendency: number | null }, moldStorage: { __typename?: 'MoldStorage', id: string, tenantId: string, moldId: string, storageCost: number | null, retroactivePrice: number | null }, moldDispose: { __typename?: 'MoldDispose', id: string, tenantId: string, moldId: string, disposeCost: number | null, scrapCost: number | null, disposeRequestDate: any | null }, moldLifecycleEvent: { __typename?: 'MoldLifecycleEvent', id: string, tenantId: string, moldId: string, operationStartDate: any | null, inspectionReceiptDate: any | null, productionStartNotificationReceiptDate: any | null, quoteStatementReceiptDate: any | null, storageStartDate: any | null, disposeDate: any | null }, moldUsages: Array<{ __typename?: 'MoldUsage', id: string, moldId: string, targettableType: string | null, targettable: { __typename?: 'Part', id: string, name: string, code: string | null, figureNumber: string | null, rootPartCode: string | null, totalReceivedQuantity: number | null, flowTendency: string | null, partAnnualTotal: { __typename?: 'PartAnnualTotal', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number, quantity4: number, quantity5: number, quantity6: number, quantity7: number, quantity8: number, quantity9: number, quantity10: number, quantity11: number, quantity12: number } | null, partUnofficialAnnouncement: { __typename?: 'PartUnofficialAnnouncement', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number } | null, partTransactions: Array<{ __typename?: 'PartTransaction', id: string, tenantId: string, orderNumber: string | null, orderSeqNo: number | null, receivedOn: any | null, unitPrice: number, receivedQuantity: number, checkNumber: string | null, checkSeqNo: number | null, checkDate: any, subtotal: number, currencyRate: number, part: { __typename?: 'Part', id: string, name: string, code: string | null }, supplier: { __typename?: 'Supplier', id: string, name: string, isTemporary: boolean, code: string }, currency: { __typename?: 'Currency', isBaseCurrency: boolean, currencyCode: string }, toJpy: { __typename?: 'PartTransactionJpy', subtotal: number, unitPrice: number } }> | null } | null }> }> } | null };

export type PackageBulkAnswerSheetQueryVariables = Exact<{
  packageId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type PackageBulkAnswerSheetQuery = { __typename?: 'Query', packageBulkAnswerSheet: { __typename?: 'PackageBulkAnswerSheet', packageId: string, title: string, answerEntryKind: string, answerDueDate: any | null, tenantName: string, supplierCode: string, supplierName: string, firstQuotation: { __typename?: 'Quotation', id: string, requestText: string | null, answerDueDate: any | null, tenant: { __typename?: 'Tenant', id: string, quotationConfig: { __typename?: 'QuotationConfig', dayTypeSetting: string } | null }, attachments: Array<{ __typename?: 'Attachment', id: string, name: string, signedDownloadUrl: string | null }> } | null, requestAttachments: Array<{ __typename?: 'Attachment', id: string, name: string, signedDownloadUrl: string | null }>, requestAttachmentOffers: Array<{ __typename?: 'AttachmentOffer', id: string, isDiscardNecessary: boolean, status: string, kind: string | null, isDownloadable: boolean, attachment: { __typename?: 'Attachment', id: string, nameForSupplier: string | null }, tenant: { __typename?: 'Tenant', id: string } }>, headerAnswer: { __typename?: 'Answer', id: string, status: string, currencyId: string, quotationNo: string | null, expirationDate: string | null, memo: string | null, declineReason: string | null, dayType: string | null, attachments: Array<{ __typename?: 'Attachment', id: string, url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> } | null, rows: Array<{ __typename?: 'PackageBulkAnswerSheetRow', quotationRequestId: string, quotationId: string, quotationItemId: string, name: string, makerName: string, makerModel: string, quantity: number, unitName: string | null, isCanBeAnswered: boolean, status: string, priceBasis: string | null, taxType: number | null, unitPrice: string | null, amountExcludingTax: string | null, amountIncludingTax: string | null, deliveryDay: number | null, desiredDeliveryDueOn: any | null, isDeclined: boolean, baseUpdatedAt: string | null }> } };

export type PartListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  figureNumber?: InputMaybe<Scalars['String']['input']>;
  referenceDate?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  partCodes?: InputMaybe<Scalars['String']['input']>;
  partNames?: InputMaybe<Scalars['String']['input']>;
  rootPartCodes?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartListQuery = { __typename?: 'Query', partList: { __typename?: 'PartListConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, nodes: Array<{ __typename?: 'PartList', id: string, code: string | null, displayCode: string, rootPartCode: string | null, receiverCode: string | null, receiverName: string | null, name: string, isAdjustable: boolean, figureNumber: string | null, latestOrderUnitPrices: Array<{ __typename?: 'PartOrderUnitPrice', quantity: number, unitPrice: number, startOn: any, endOn: any | null, id: string, supplier: { __typename?: 'Supplier', id: string, code: string, name: string }, currency: { __typename?: 'Currency', currencyCode: string } | null, tenantUnit: { __typename?: 'TenantUnit', name: string } | null, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', name: string } | null }>, tenant: { __typename?: 'Tenant', id: string, name: string } }> } };

export type PartOrderUnitPricesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  materialPriceDateOn?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartOrderUnitPricesByIdsQuery = { __typename?: 'Query', partOrderUnitPricesByIds: Array<{ __typename?: 'PartOrderUnitPrice', id: string, ifKey1: string | null, ifKey2: string | null, materialCost: number | null, materialManagementCost: number | null, jigManagementCost: number | null, partsCost: number | null, subsidiaryMaterialCost: number | null, processingCostSubtotal: number | null, propertyRentCost: number | null, amortizationCost: number | null, deliveryCost: number | null, managementCost: number | null, paidSupplyPartSubtotal: number | null, unitPrice: number, facilityCost: number | null, facilityAmortizationCost: number | null, updateMemo: string | null, manufacturingSite: { __typename?: 'ManufacturingSite', name: string } | null, supplier: { __typename?: 'Supplier', name: string, code: string }, tenant: { __typename?: 'Tenant', name: string } | null, part: { __typename?: 'Part', code: string | null, rootPartCode: string | null, name: string, sameGroupParts: Array<{ __typename?: 'Part', code: string | null }> }, partReasons: Array<{ __typename?: 'PartReason', id: string | null, priceDifference: number | null, sequence: number | null, priceChangeReason: { __typename?: 'PriceChangeReason', id: string, reason: string, code: string, sequence: number } }>, partOrderUnitPriceFormat: { __typename?: 'PartOrderUnitPriceFormat', code: string, materialDetailDescription: string | null } | null, partFacilityPrices: Array<{ __typename?: 'PartFacilityPrice', name: string | null, facilityCost: number | null, paymentInstallmentKind: string, facilityKind: { __typename?: 'FacilityKind', code: string | null, name: string } }>, partMaterialPrices: Array<{ __typename?: 'PartMaterialPrice', procurementKind: string | null, materialName: string | null, measure: string | null, reservedWeight: number | null, productWeight: number | null, materialUnitPrice: number | null, quantity: number | null, cavity: number | null, materialCostPerQty: number | null, materialCost: number | null, materialUnitPriceOnDate: number | null, materialCostPerQtyOnDate: number | null, materialCostOnDate: number | null, scrapWeight: number | null, scrapUnitPrice: number | null, scrapSubtotal: number | null, scrapUnitPriceOnDate: number | null, variation: number | null, id: string, initialCost: number | null, startOn: any | null, startUpMonth: any | null, baseMaterial: { __typename?: 'BaseMaterial', code: string, id: string, name: string } | null, weightTenantUnit: { __typename?: 'TenantUnit', unitCode: string, name: string } | null }>, partSupplySubpartPrices: Array<{ __typename?: 'PartSupplySubpartPrice', quantity: number | null, quantityDenominator: number, unitPrice: number | null, supplyPartCost: number | null, supplyPart: { __typename?: 'Part', code: string | null, rootPartCode: string | null, name: string } }>, partSubpartPrices: Array<{ __typename?: 'PartSubpartPrice', partCode: string | null, partName: string | null, quantity: number | null, unitPrice: number | null, partCost: number | null }>, partSubsidiaryMaterialCosts: Array<{ __typename?: 'PartSubsidiaryMaterialCost', name: string, subsidiaryMaterialCost: number }>, partProcessingCosts: Array<{ __typename?: 'PartProcessingCost', equipmentName: string | null, processingCostSubtotalPerLot: number | null, processOutsourcingKind: string | null, processName: string, processingTimeHour: number | null, processingRate: number | null, processingCost: number, productionLot: number | null, partFacilityPrice: { __typename?: 'PartFacilityPrice', name: string | null, facilityCost: number | null, paymentInstallmentKind: string, facilityKind: { __typename?: 'FacilityKind', name: string } } | null }>, answerPrice: { __typename?: 'AnswerPrice', answer: { __typename?: 'Answer', memo: string | null } } | null, quotation: { __typename?: 'Quotation', quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null } | null, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null, project: { __typename?: 'Project', modelYear: number | null, modelTitle: string | null, modelTypeName: string | null, projectModel: { __typename?: 'ProjectModel', deliverySiteName: string | null, modelDepreciation: string | null, manufacturingSiteName: string | null } | null, projectSchedules: Array<{ __typename?: 'ProjectSchedule', seqNo: number | null, eventName: string, eventOn: any | null, qualificationLevelName: string | null }>, projectFormat: { __typename?: 'ProjectFormat', isSingleUnitProject: boolean } | null } | null, sourcePriceAdjustmentItem: { __typename?: 'PriceAdjustmentItem', id: string, project: { __typename?: 'Project', modelYear: number | null, modelTitle: string | null, modelTypeName: string | null, projectModel: { __typename?: 'ProjectModel', deliverySiteName: string | null, modelDepreciation: string | null, manufacturingSiteName: string | null } | null, projectSchedules: Array<{ __typename?: 'ProjectSchedule', seqNo: number | null, eventName: string, eventOn: any | null, qualificationLevelName: string | null }>, projectFormat: { __typename?: 'ProjectFormat', isSingleUnitProject: boolean } | null } | null, newDetail: { __typename?: 'PriceAdjustmentItemDetail', id: string, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null } | null } | null, itemRequirement: { __typename?: 'ItemRequirement', designChangeCode: string | null } | null }> };

export type PartOrderUnitPricesForAdjustmentQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  tenantId: Scalars['ID']['input'];
}>;


export type PartOrderUnitPricesForAdjustmentQuery = { __typename?: 'Query', partOrderUnitPricesForAdjustment: Array<{ __typename?: 'PartOrderUnitPrice', id: string, ifKey1: string | null, ifKey2: string | null, startOn: any, unitPrice: number, isExpired: boolean, latestCanceledPartOrderUnitPrice: { __typename?: 'CanceledPartOrderUnitPrice', cancelStatusKind: string } | null, manufacturingSite: { __typename?: 'ManufacturingSite', id: string, name: string, code: string | null } | null, priceAdjustmentItems: Array<{ __typename?: 'PriceAdjustmentItem', priceAdjustment: { __typename?: 'PriceAdjustment', currentEvent: { __typename?: 'PriceAdjustmentEvent', eventKind: string } } }> | null, part: { __typename?: 'Part', id: string, code: string | null, displayCode: string, name: string, rootPartCode: string | null, isNotEnd: boolean, purchaseGroupPart: { __typename?: 'PurchaseGroupPart', id: string, groupUid: string, isParent: boolean } | null } }> };

export type PartSupplyPriceHistoryQueryVariables = Exact<{
  partId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  supplierCode: Scalars['String']['input'];
}>;


export type PartSupplyPriceHistoryQuery = { __typename?: 'Query', partSupplyPriceHistory: { __typename?: 'PartSupplyPriceConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, nodes: Array<{ __typename?: 'PartSupplyPrice', id: string | null, assignmentPriceKind: PartSupplyPriceAssignmentPriceKindEnum, assignmentPrice: number | null, startOn: any, endOn: any | null, supplier: { __typename?: 'Supplier', id: string, code: string, name: string }, tenant: { __typename?: 'Tenant', name: string }, tenantUnit: { __typename?: 'TenantUnit', name: string } | null, part: { __typename?: 'Part', displayCode: string, name: string, figureNumber: string | null, id: string } }> } };

export type PartSupplyPriceListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  figureNumber?: InputMaybe<Scalars['String']['input']>;
  assignmentPriceKind?: InputMaybe<Scalars['String']['input']>;
  referenceDate?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartSupplyPriceListQuery = { __typename?: 'Query', partSupplyPriceList: { __typename?: 'PartSupplyPriceConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, nodes: Array<{ __typename?: 'PartSupplyPrice', id: string | null, assignmentPriceKind: PartSupplyPriceAssignmentPriceKindEnum, assignmentPrice: number | null, startOn: any, endOn: any | null, supplier: { __typename?: 'Supplier', id: string, code: string, name: string }, tenant: { __typename?: 'Tenant', name: string }, tenantUnit: { __typename?: 'TenantUnit', name: string } | null, part: { __typename?: 'Part', displayCode: string, name: string, figureNumber: string | null, id: string } }> } };

export type PartOrderUnitPricesForListQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchKind?: InputMaybe<Scalars['String']['input']>;
  partCode?: InputMaybe<Scalars['String']['input']>;
  rootPartCode?: InputMaybe<Scalars['String']['input']>;
  partName?: InputMaybe<Scalars['String']['input']>;
  deliverySiteIds?: InputMaybe<Scalars['String']['input']>;
  manufacturingSiteIds?: InputMaybe<Scalars['String']['input']>;
  ifKey1?: InputMaybe<Scalars['String']['input']>;
  reasonIds?: InputMaybe<Scalars['String']['input']>;
  startOnSince?: InputMaybe<Scalars['String']['input']>;
  startOnUntil?: InputMaybe<Scalars['String']['input']>;
  cancelStatusKind?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartOrderUnitPricesForListQuery = { __typename?: 'Query', partOrderUnitPricesForList: { __typename?: 'PartOrderUnitPriceForListConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, nodes: Array<{ __typename?: 'PartOrderUnitPriceForList', id: string, unitPrice: number, startOn: any, ifKey1: string | null, ifKey2: string | null, cancelStatusKind: string | null, part: { __typename?: 'Part', id: string, code: string | null, name: string, rootPartCode: string | null, isEnd: boolean }, supplier: { __typename?: 'Supplier', id: string, code: string, name: string }, manufacturingSite: { __typename?: 'ManufacturingSite', id: string, name: string, code: string | null } | null, partReasons: Array<{ __typename?: 'PartReason', id: string | null, priceDifference: number | null, sequence: number | null, priceChangeReason: { __typename?: 'PriceChangeReason', id: string, reason: string, code: string, sequence: number } }> }> } };

export type PriceAdjustmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PriceAdjustmentQuery = { __typename?: 'Query', priceAdjustment: { __typename?: 'PriceAdjustmentDetail', id: string, tenantId: string, tenantCode: string, supplierCode: string, targetTerm: string, adjustmentPurpose: string | null, applicantKind: string, confirmationStartDate: any | null, confirmationDeadlineDate: any | null, priceEffectiveDate: any | null, priceExpirationDate: any | null, adjustmentKind: PriceAdjustmentAdjustmentKindEnum, memo: string, isSupplierEditable: boolean, isItemDeletable: boolean, tenant: { __typename?: 'Tenant', id: string, name: string }, supplier: { __typename?: 'Supplier', id: string, name: string, code: string, displayCode: string, supplierFirmId: string | null }, answerFormat: { __typename?: 'AnswerFormat', id: string, isUseMaterialCost: boolean, isUseMaterialCostDetail: boolean, isUseMaterialSize: boolean, isUseMaterialScrap: boolean, isUseMaterialCostProcurementKind: boolean, isUseMaterialCostCavity: boolean, isUseMaterialCostAdjustment: boolean, isUseMaterialCostMemo: boolean, isUseMaterialCostThickness: boolean, isUseMaterialCostWidth: boolean, isUseMaterialCostHeight: boolean, isUseMaterialCostMeasure: boolean, isUseMaterialCostWeightBeforeProcess: boolean, isUseMaterialCostWeightAfterProcess: boolean, isUseMaterialCostBasePrice: boolean, isUsePartsCost: boolean, isUsePartsCostDetail: boolean, isUsePartsCostProcurementKind: boolean, isUsePartsCostPartNo: boolean, isUsePartsCostPartName: boolean, isUsePartsCostProductionPlace: boolean, isUsePartsCostQuantity: boolean, isUsePartsCostPartsUnitPrice: boolean, isUsePartsCostMemo: boolean, isUsePartsCostPartSpec: boolean, isUsePartsCostPartsCount: boolean, isUseProcessingCost: boolean, isUseProcessingCostDetail: boolean, isUseProcessingCostProductionLot: boolean, isUseProcessingCostEquipmentName: boolean, isUseProcessingCostProcessingTimeHour: boolean, isUseProcessingCostProcessingTimeMinute: boolean, isUseProcessingCostProcessingTimeSecond: boolean, isUseProcessingCostProcessingRate: boolean, isUseSetupInformation: boolean, isUseProcessingCostProcessingTimes: boolean, isUseProcessingCostSetupTimeHour: boolean, isUseProcessingCostSetupTimeMinute: boolean, isUseProcessingCostSetupTimeSecond: boolean, isUseProcessingCostSetupRate: boolean, isUseProcessingCostProcessingCostSubtotal: boolean, isUseProcessingCostSetupCostSubtotal: boolean, isUseProcessingCostMemo: boolean, processingCostRateKind: string | null, isUseManagementCost: boolean, isUseMaterialManagementRate: boolean, isUseMaterialManagementCost: boolean, isUseProcessingManagementRate: boolean, isUseProcessingManagementCost: boolean, isUseDeliveryCost: boolean, isUseDeliveryBoxInformation: boolean, isUsePackingCost: boolean, isUsePackingBoxInformation: boolean, isUseDefectCost: boolean, isUseDefectRate: boolean, isUseProfit: boolean, isUseProfitRate: boolean, isUseAdjustment: boolean, isUseDepreciation: boolean, isUseInternalPartSubtotal: boolean, isUseOutSourcePartSubtotal: boolean, isUseOutSourcePartManagementRate: boolean, isUsePaidSupplyPartSubtotal: boolean, isUseInitialDeliveryDay: boolean, isUseMaterialDeliveryDay: boolean, isUseEquipmentDeliveryDay: boolean, isUseMoldDeliveryDay: boolean, isUseTrialDeliveryDay: boolean, isUseDeliveryDay: boolean, isUseGanttForDeliveryDay: boolean, isUseSurfaceProcessingCost: boolean, isUseSubsidiaryMaterialCost: boolean, isUseSubsidiaryMaterialCostDetail: boolean, isSetScrapName: boolean, scrap1Name: string | null, scrap2Name: string | null, isUseCurrencyExchangeNote: boolean, isUseAnswerByItem: boolean, isUseMinimumOrderQuantity: boolean, isUseDeliveryForm: boolean, isUseQuantityPerDeliveryForm: boolean, isUsePriceEffectiveDate: boolean, priceRegistrationFormatId: string | null, answerMethod: string, isUseProcessingWeight: boolean, isUseCostForWeight: boolean, isUseProcessingHeadcount: boolean, calculationKind: string, isUseWholesalerKnowledge: boolean, useMakerActualPartName: string, makerActualPartNameHelperTxt: string | null, materialCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, materialCostPriceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, specialProcessingDetailFormatsList: Array<{ __typename?: 'CommonSpecialProcessingDetailFormat', kind: string, kindLabel: string, isUseProductionLot: boolean, isUseEquipmentName: boolean, isUseProcessingTimeHour: boolean, isUseProcessingTimeMinute: boolean, isUseProcessingTimeSecond: boolean, isUseProcessingRate: boolean, isUseSetupInformation: boolean, isUseSetupTimeHour: boolean, isUseSetupTimeMinute: boolean, isUseSetupTimeSecond: boolean, isUseSetupRate: boolean, isUseMemo: boolean, isUseProcessingTimes: boolean, isUseProcessingCostSubtotal: boolean, isUseSetupCostSubtotal: boolean, rateKind: string | null }>, processingCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, facilityKinds: Array<{ __typename?: 'FacilityKind', id: string, code: string | null, name: string }> } | null, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierCorporationAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, inChargeAdminUser: { __typename?: 'AdminUser', id: string, name: string, email: string, adminUserGroups: Array<{ __typename?: 'AdminUserGroup', id: string, name: string }> | null } | null, inChargeSupplierAccount: { __typename?: 'SupplierAccount', id: string, name: string } | null, inChargeSupplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null, supplierAccounts: Array<{ __typename?: 'SupplierAccount', id: string, name: string }>, supplierUsers: Array<{ __typename?: 'SupplierUser', id: string, name: string }> | null, currentEvent: { __typename?: 'PriceAdjustmentEvent', id: string, eventKind: string, memo: string | null, triggeredByType: string, createdAt: any, confirmationStatusName: string, confirmationStatusValue: number, adjustmentStatusName: string, actionName: string, triggeredBy:
        | { __typename?: 'AdminUser', id: string, name: string }
        | { __typename?: 'SupplierAccount', id: string, name: string }
        | { __typename?: 'SupplierUser', id: string, name: string }
       }, currentAsking: { __typename?: 'PriceAdjustmentEvent', id: string, eventKind: string, memo: string | null, triggeredByType: string, createdAt: any, confirmationStatusName: string, confirmationStatusValue: number, adjustmentStatusName: string, actionName: string, triggeredBy:
        | { __typename?: 'AdminUser', id: string, name: string }
        | { __typename?: 'SupplierAccount', id: string, name: string }
        | { __typename?: 'SupplierUser', id: string, name: string }
       } | null, completeEvent: { __typename?: 'PriceAdjustmentEvent', id: string, eventKind: string, memo: string | null, triggeredByType: string, createdAt: any, confirmationStatusName: string, confirmationStatusValue: number, adjustmentStatusName: string, actionName: string, triggeredBy:
        | { __typename?: 'AdminUser', id: string, name: string }
        | { __typename?: 'SupplierAccount', id: string, name: string }
        | { __typename?: 'SupplierUser', id: string, name: string }
       } | null, priceAdjustmentItems: Array<{ __typename?: 'PriceAdjustmentItem', id: string, tenantId: string, quantity: number, memo: string | null, tenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string } | null, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, part: { __typename?: 'Part', id: string, name: string, displayCode: string, rootPartCode: string | null, sameGroupParts: Array<{ __typename?: 'Part', name: string, displayCode: string }> }, newDetail: { __typename?: 'PriceAdjustmentItemDetail', id: string, tenantId: string, kind: string, unitPrice: number | null, materialCost: number | null, processingCost: number | null, otherCost: number | null, supplyPartPrice: number | null, scrapPrice: number | null, memo: string, notSupplyPartSubtotal: number | null, subsidiaryMaterialCost: number | null, propertyRentCost: number | null, paidSupplyPartSubtotal: number | null, facilityCost: number | null, facilityAmortizationCost: number | null, amortizationCost: number | null, jigManagementCost: number | null, netUnitPrice: number | null, materialCostNotSupplySubtotal: number | null, materialCostSupplySubtotal: number | null, materialManagementCost: number | null, partsCost: number | null, deliveryCost: number | null, managementCost: number | null, processingPriceSubtotal: number | null, manufacturingSite: { __typename?: 'ManufacturingSite', code: string | null, name: string } | null } | null, oldDetail: { __typename?: 'PriceAdjustmentItemDetail', id: string, tenantId: string, kind: string, unitPrice: number | null, materialCost: number | null, processingCost: number | null, otherCost: number | null, supplyPartPrice: number | null, scrapPrice: number | null, memo: string, notSupplyPartSubtotal: number | null, subsidiaryMaterialCost: number | null, propertyRentCost: number | null, paidSupplyPartSubtotal: number | null, facilityCost: number | null, facilityAmortizationCost: number | null, amortizationCost: number | null, jigManagementCost: number | null, netUnitPrice: number | null, materialCostNotSupplySubtotal: number | null, materialCostSupplySubtotal: number | null, materialManagementCost: number | null, partsCost: number | null, deliveryCost: number | null, managementCost: number | null, processingPriceSubtotal: number | null, manufacturingSite: { __typename?: 'ManufacturingSite', code: string | null, name: string } | null } | null, latestAskingDetail: { __typename?: 'PriceAdjustmentItemDetail', id: string, tenantId: string, kind: string, unitPrice: number | null, materialCost: number | null, processingCost: number | null, otherCost: number | null, supplyPartPrice: number | null, scrapPrice: number | null, memo: string, notSupplyPartSubtotal: number | null, subsidiaryMaterialCost: number | null, propertyRentCost: number | null, paidSupplyPartSubtotal: number | null, facilityCost: number | null, facilityAmortizationCost: number | null, amortizationCost: number | null, jigManagementCost: number | null, netUnitPrice: number | null, materialCostNotSupplySubtotal: number | null, materialCostSupplySubtotal: number | null, materialManagementCost: number | null, partsCost: number | null, deliveryCost: number | null, managementCost: number | null, processingPriceSubtotal: number | null, manufacturingSite: { __typename?: 'ManufacturingSite', code: string | null, name: string } | null } | null, priceChangeReasons: Array<{ __typename?: 'PriceChangeReason', id: string, tenantId: string, code: string, reason: string, sequence: number }> | null, reasonSnapshots: Array<{ __typename?: 'PriceAdjustmentItemPriceChangeReason', id: string, tenantId: string, code: string, reason: string, sequence: number, priceChangeReasonId: string, priceDifference: number | null }> | null, partOrderUnitPrice: { __typename?: 'PartOrderUnitPrice', id: string, unitPrice: number, ifKey1: string | null, ifKey2: string | null, tenantUnit: { __typename?: 'TenantUnit', unitCode: string, name: string } | null, tenant: { __typename?: 'Tenant', id: string, name: string, code: string } | null, supplier: { __typename?: 'Supplier', id: string, name: string, code: string, displayCode: string, isEligibleToSubcontractAct: boolean }, currency: { __typename?: 'Currency', currencyCode: string, decimalPrecision: number, displayName: string } | null, itemRequirement: { __typename?: 'ItemRequirement', designChangeCode: string | null } | null } | null }> | null, priceAdjustmentSetting: { __typename?: 'PriceAdjustmentSetting', id: string, tenantId: string, reasonCount: number, isUseMaterialPriceAdjustment: boolean | null, isUsePriceAdjustmentFormEdit: boolean, materialPriceAdjustmentTargetKind: PriceAdjustmentSettingMaterialPriceAdjustmentTargetKindEnum }, priceAdjustmentEvents: Array<{ __typename?: 'PriceAdjustmentEvent', id: string, eventKind: string, memo: string | null, triggeredByType: string, createdAt: any, confirmationStatusName: string, confirmationStatusValue: number, adjustmentStatusName: string, actionName: string, triggeredBy:
        | { __typename?: 'AdminUser', id: string, name: string }
        | { __typename?: 'SupplierAccount', id: string, name: string }
        | { __typename?: 'SupplierUser', id: string, name: string }
       }> } };

export type PriceAdjustmentItemForFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PriceAdjustmentItemForFormQuery = { __typename?: 'Query', priceAdjustmentItemForForm: { __typename?: 'PriceAdjustmentItem', id: string, tenantId: string, quantity: number, memo: string | null, tenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string } | null, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, part: { __typename?: 'Part', id: string, code: string | null, displayCode: string, figureNumber: string | null, receiverCode: string | null, receiverName: string | null, name: string, isAdjustable: boolean, rootPartCode: string | null, deliverySiteObjects: Array<{ __typename?: 'DeliverySite', id: string, name: string }>, deliverySites: Array<{ __typename?: 'DeliverySite', id: string, name: string, code: string | null }>, sameGroupParts: Array<{ __typename?: 'Part', id: string, code: string | null, name: string }>, activePartOrderUnitPrices: Array<{ __typename?: 'PartOrderUnitPrice', itemRequirement: { __typename?: 'ItemRequirement', designChangeCode: string | null } | null }> }, newDetail: { __typename?: 'PriceAdjustmentItemDetail', id: string, tenantId: string, kind: string, unitPrice: number | null, materialCost: number | null, processingCost: number | null, otherCost: number | null, supplyPartPrice: number | null, scrapPrice: number | null, memo: string, notSupplyPartSubtotal: number | null, subsidiaryMaterialCost: number | null, propertyRentCost: number | null, paidSupplyPartSubtotal: number | null, facilityCost: number | null, facilityAmortizationCost: number | null, amortizationCost: number | null, jigManagementCost: number | null, materialManagementCost: number | null, materialCostNotSupplySubtotal: number | null, materialCostSupplySubtotal: number | null, partsCost: number | null, netUnitPrice: number | null, deliveryCost: number | null, managementCost: number | null, processingPriceSubtotal: number | null, manufacturingSite: { __typename?: 'ManufacturingSite', id: string, name: string, code: string | null } | null, priceAdjustmentItemDetailMaterialPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailMaterialPrice', id: string, materialName: string | null, materialCode: string | null, materialCost: number | null, materialUnitPrice: number | null, initialCost: number | null, measure: string | null, procurementKind: string | null, productWeight: number | null, quantity: number | null, reservedWeight: number | null, scrapSubtotal: number | null, scrapUnitPrice: number | null, scrapWeight: number | null, startOn: any | null, startUpMonth: any | null, variation: number | null, cavity: number | null, materialCostPerQty: number | null, partMaterialPriceId: string | null, baseMaterial: { __typename?: 'BaseMaterial', id: string, name: string, code: string } | null, partMaterialPrice: { __typename?: 'PartMaterialPrice', id: string } | null, priceTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null }> | null, priceAdjustmentItemDetailProcessingPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailProcessingPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, processName: string, equipmentName: string | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingTimeHour: number | null, processingRate: number | null, processingCostSubtotal: number | null, processingCostSubtotalPerLot: number | null, setupTimeMinute: number | null, setupTimeHour: number | null, setupTimeSecond: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, productionLot: number | null, rateKind: number | null, setupRate: number | null, processingWeight: number | null, costForWeight: number | null, weightTenantUnitId: string | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostPerLot: number | null, partProcessingCostId: string | null, facilityKindId: string | null, facilityName: string | null, facilityCost: number | null, facilityPaymentInstallmentKind: string | null, partFacilityPrice: { __typename?: 'PartFacilityPrice', id: string | null, facilityKindId: string, name: string | null, facilityCost: number | null, acquiredOn: any | null, memo: string | null, amortizationNumber: number | null, amortizationCost: number | null, paymentInstallmentKind: string, paymentMonthly: number | null, paymentLastMonth: number | null, paymentStartOn: any | null, paymentEndOn: any | null, tenantId: string, facilityKind: { __typename?: 'FacilityKind', id: string, name: string } } | null }> | null, priceAdjustmentItemDetailSubpartPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailSubpartPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, partCode: string | null, partName: string | null, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, partCost: number | null, partSubpartPriceId: string | null }> | null, priceAdjustmentItemDetailSubsidiaryMaterialCosts: Array<{ __typename?: 'PriceAdjustmentItemDetailSubsidiaryMaterialCost', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number | null, note: string | null, partSubsidiaryMaterialCostId: string | null }> | null, priceAdjustmentItemDetailSupplySubpartPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailSupplySubpartPrice', id: string, tenantId: string, priceAdjustmentItemDetailId: string, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, supplyPartCost: number | null, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, partSupplySubpartPriceId: string | null, supplyPart: { __typename?: 'Part', id: string, code: string | null, name: string } | null }> | null, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null } | null, oldDetail: { __typename?: 'PriceAdjustmentItemDetail', id: string, tenantId: string, kind: string, unitPrice: number | null, materialCost: number | null, processingCost: number | null, otherCost: number | null, supplyPartPrice: number | null, scrapPrice: number | null, memo: string, notSupplyPartSubtotal: number | null, subsidiaryMaterialCost: number | null, propertyRentCost: number | null, paidSupplyPartSubtotal: number | null, facilityCost: number | null, facilityAmortizationCost: number | null, amortizationCost: number | null, jigManagementCost: number | null, materialManagementCost: number | null, materialCostNotSupplySubtotal: number | null, materialCostSupplySubtotal: number | null, partsCost: number | null, netUnitPrice: number | null, deliveryCost: number | null, managementCost: number | null, processingPriceSubtotal: number | null, manufacturingSite: { __typename?: 'ManufacturingSite', id: string, name: string, code: string | null } | null, priceAdjustmentItemDetailMaterialPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailMaterialPrice', id: string, materialName: string | null, materialCode: string | null, materialCost: number | null, materialUnitPrice: number | null, initialCost: number | null, measure: string | null, procurementKind: string | null, productWeight: number | null, quantity: number | null, reservedWeight: number | null, scrapSubtotal: number | null, scrapUnitPrice: number | null, scrapWeight: number | null, startOn: any | null, startUpMonth: any | null, variation: number | null, cavity: number | null, materialCostPerQty: number | null, partMaterialPriceId: string | null, baseMaterial: { __typename?: 'BaseMaterial', id: string, name: string, code: string } | null, partMaterialPrice: { __typename?: 'PartMaterialPrice', id: string } | null, priceTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null }> | null, priceAdjustmentItemDetailProcessingPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailProcessingPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, processName: string, equipmentName: string | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingTimeHour: number | null, processingRate: number | null, processingCostSubtotal: number | null, processingCostSubtotalPerLot: number | null, setupTimeMinute: number | null, setupTimeHour: number | null, setupTimeSecond: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, productionLot: number | null, rateKind: number | null, setupRate: number | null, processingWeight: number | null, costForWeight: number | null, weightTenantUnitId: string | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostPerLot: number | null, partProcessingCostId: string | null, facilityKindId: string | null, facilityName: string | null, facilityCost: number | null, facilityPaymentInstallmentKind: string | null, partFacilityPrice: { __typename?: 'PartFacilityPrice', id: string | null, facilityKindId: string, name: string | null, facilityCost: number | null, acquiredOn: any | null, memo: string | null, amortizationNumber: number | null, amortizationCost: number | null, paymentInstallmentKind: string, paymentMonthly: number | null, paymentLastMonth: number | null, paymentStartOn: any | null, paymentEndOn: any | null, tenantId: string, facilityKind: { __typename?: 'FacilityKind', id: string, name: string } } | null }> | null, priceAdjustmentItemDetailSubpartPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailSubpartPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, partCode: string | null, partName: string | null, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, partCost: number | null, partSubpartPriceId: string | null }> | null, priceAdjustmentItemDetailSubsidiaryMaterialCosts: Array<{ __typename?: 'PriceAdjustmentItemDetailSubsidiaryMaterialCost', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number | null, note: string | null, partSubsidiaryMaterialCostId: string | null }> | null, priceAdjustmentItemDetailSupplySubpartPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailSupplySubpartPrice', id: string, tenantId: string, priceAdjustmentItemDetailId: string, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, supplyPartCost: number | null, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, partSupplySubpartPriceId: string | null, supplyPart: { __typename?: 'Part', id: string, code: string | null, name: string } | null }> | null, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null } | null, latestAskingDetail: { __typename?: 'PriceAdjustmentItemDetail', id: string, tenantId: string, kind: string, unitPrice: number | null, materialCost: number | null, processingCost: number | null, otherCost: number | null, supplyPartPrice: number | null, scrapPrice: number | null, memo: string, notSupplyPartSubtotal: number | null, subsidiaryMaterialCost: number | null, propertyRentCost: number | null, paidSupplyPartSubtotal: number | null, facilityCost: number | null, facilityAmortizationCost: number | null, amortizationCost: number | null, jigManagementCost: number | null, materialManagementCost: number | null, materialCostNotSupplySubtotal: number | null, materialCostSupplySubtotal: number | null, partsCost: number | null, netUnitPrice: number | null, deliveryCost: number | null, managementCost: number | null, processingPriceSubtotal: number | null, manufacturingSite: { __typename?: 'ManufacturingSite', id: string, name: string, code: string | null } | null, priceAdjustmentItemDetailMaterialPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailMaterialPrice', id: string, materialName: string | null, materialCode: string | null, materialCost: number | null, materialUnitPrice: number | null, initialCost: number | null, measure: string | null, procurementKind: string | null, productWeight: number | null, quantity: number | null, reservedWeight: number | null, scrapSubtotal: number | null, scrapUnitPrice: number | null, scrapWeight: number | null, startOn: any | null, startUpMonth: any | null, variation: number | null, cavity: number | null, materialCostPerQty: number | null, partMaterialPriceId: string | null, baseMaterial: { __typename?: 'BaseMaterial', id: string, name: string, code: string } | null, partMaterialPrice: { __typename?: 'PartMaterialPrice', id: string } | null, priceTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string, unitCode: string } | null }> | null, priceAdjustmentItemDetailProcessingPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailProcessingPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, processName: string, equipmentName: string | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingTimeHour: number | null, processingRate: number | null, processingCostSubtotal: number | null, processingCostSubtotalPerLot: number | null, setupTimeMinute: number | null, setupTimeHour: number | null, setupTimeSecond: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, productionLot: number | null, rateKind: number | null, setupRate: number | null, processingWeight: number | null, costForWeight: number | null, weightTenantUnitId: string | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostPerLot: number | null, partProcessingCostId: string | null, facilityKindId: string | null, facilityName: string | null, facilityCost: number | null, facilityPaymentInstallmentKind: string | null, partFacilityPrice: { __typename?: 'PartFacilityPrice', id: string | null, facilityKindId: string, name: string | null, facilityCost: number | null, acquiredOn: any | null, memo: string | null, amortizationNumber: number | null, amortizationCost: number | null, paymentInstallmentKind: string, paymentMonthly: number | null, paymentLastMonth: number | null, paymentStartOn: any | null, paymentEndOn: any | null, tenantId: string, facilityKind: { __typename?: 'FacilityKind', id: string, name: string } } | null }> | null, priceAdjustmentItemDetailSubpartPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailSubpartPrice', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, partCode: string | null, partName: string | null, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, partCost: number | null, partSubpartPriceId: string | null }> | null, priceAdjustmentItemDetailSubsidiaryMaterialCosts: Array<{ __typename?: 'PriceAdjustmentItemDetailSubsidiaryMaterialCost', id: string | null, tenantId: string, priceAdjustmentItemDetailId: string, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number | null, note: string | null, partSubsidiaryMaterialCostId: string | null }> | null, priceAdjustmentItemDetailSupplySubpartPrices: Array<{ __typename?: 'PriceAdjustmentItemDetailSupplySubpartPrice', id: string, tenantId: string, priceAdjustmentItemDetailId: string, quantity: number | null, quantityDenominator: number | null, unitPrice: number | null, supplyPartCost: number | null, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, partSupplySubpartPriceId: string | null, supplyPart: { __typename?: 'Part', id: string, code: string | null, name: string } | null }> | null, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null } | null, priceChangeReasons: Array<{ __typename?: 'PriceChangeReason', id: string, tenantId: string, code: string, reason: string, sequence: number }> | null, reasonSnapshots: Array<{ __typename?: 'PriceAdjustmentItemPriceChangeReason', id: string, tenantId: string, code: string, reason: string, sequence: number, priceChangeReasonId: string, priceDifference: number | null }> | null, partOrderUnitPrice: { __typename?: 'PartOrderUnitPrice', id: string, unitPrice: number, quantity: number, startOn: any, endOn: any | null, isExpired: boolean, ifKey1: string | null, ifKey2: string | null, currency: { __typename?: 'Currency', id: string, displayName: string, currencyCode: string, decimalPrecision: number } | null, tenantUnit: { __typename?: 'TenantUnit', unitCode: string, name: string } | null, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, part: { __typename?: 'Part', id: string, displayCode: string, name: string, figureNumber: string | null } } | null, priceAdjustment: { __typename?: 'PriceAdjustment', id: string, targetTerm: string, supplierCode: string, supplier: { __typename?: 'Supplier', id: string, name: string, displayCode: string } }, answerFormat: { __typename?: 'AnswerFormat', id: string, isUseMaterialCost: boolean, isUseMaterialCostDetail: boolean, isUseMaterialSize: boolean, isUseMaterialScrap: boolean, isUseMaterialCostProcurementKind: boolean, isUseMaterialCostCavity: boolean, isUseMaterialCostAdjustment: boolean, isUseMaterialCostMemo: boolean, isUseMaterialCostThickness: boolean, isUseMaterialCostWidth: boolean, isUseMaterialCostHeight: boolean, isUseMaterialCostMeasure: boolean, isUseMaterialCostWeightBeforeProcess: boolean, isUseMaterialCostWeightAfterProcess: boolean, isUseMaterialCostBasePrice: boolean, isUsePartsCost: boolean, isUsePartsCostDetail: boolean, isUsePartsCostProcurementKind: boolean, isUsePartsCostPartNo: boolean, isUsePartsCostPartName: boolean, isUsePartsCostProductionPlace: boolean, isUsePartsCostQuantity: boolean, isUsePartsCostPartsUnitPrice: boolean, isUsePartsCostMemo: boolean, isUsePartsCostPartSpec: boolean, isUsePartsCostPartsCount: boolean, isUseProcessingCost: boolean, isUseProcessingCostDetail: boolean, isUseProcessingCostProductionLot: boolean, isUseProcessingCostEquipmentName: boolean, isUseProcessingCostProcessingTimeHour: boolean, isUseProcessingCostProcessingTimeMinute: boolean, isUseProcessingCostProcessingTimeSecond: boolean, isUseProcessingCostProcessingRate: boolean, isUseSetupInformation: boolean, isUseProcessingCostProcessingTimes: boolean, isUseProcessingCostSetupTimeHour: boolean, isUseProcessingCostSetupTimeMinute: boolean, isUseProcessingCostSetupTimeSecond: boolean, isUseProcessingCostSetupRate: boolean, isUseProcessingCostProcessingCostSubtotal: boolean, isUseProcessingCostSetupCostSubtotal: boolean, isUseProcessingCostMemo: boolean, processingCostRateKind: string | null, isUseManagementCost: boolean, isUseMaterialManagementRate: boolean, isUseMaterialManagementCost: boolean, isUseProcessingManagementRate: boolean, isUseProcessingManagementCost: boolean, isUseDeliveryCost: boolean, isUseDeliveryBoxInformation: boolean, isUsePackingCost: boolean, isUsePackingBoxInformation: boolean, isUseDefectCost: boolean, isUseDefectRate: boolean, isUseProfit: boolean, isUseProfitRate: boolean, isUseAdjustment: boolean, isUseDepreciation: boolean, isUseInternalPartSubtotal: boolean, isUseOutSourcePartSubtotal: boolean, isUseOutSourcePartManagementRate: boolean, isUsePaidSupplyPartSubtotal: boolean, isUseInitialDeliveryDay: boolean, isUseMaterialDeliveryDay: boolean, isUseEquipmentDeliveryDay: boolean, isUseMoldDeliveryDay: boolean, isUseTrialDeliveryDay: boolean, isUseDeliveryDay: boolean, isUseGanttForDeliveryDay: boolean, isUseSurfaceProcessingCost: boolean, isUseSubsidiaryMaterialCost: boolean, isUseSubsidiaryMaterialCostDetail: boolean, isSetScrapName: boolean, scrap1Name: string | null, scrap2Name: string | null, isUseCurrencyExchangeNote: boolean, isUseAnswerByItem: boolean, isUseMinimumOrderQuantity: boolean, isUseDeliveryForm: boolean, isUseQuantityPerDeliveryForm: boolean, isUsePriceEffectiveDate: boolean, priceRegistrationFormatId: string | null, answerMethod: string, isUseProcessingWeight: boolean, isUseCostForWeight: boolean, isUseProcessingHeadcount: boolean, calculationKind: string, isUseWholesalerKnowledge: boolean, useMakerActualPartName: string, makerActualPartNameHelperTxt: string | null, materialCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, materialCostPriceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, specialProcessingDetailFormatsList: Array<{ __typename?: 'CommonSpecialProcessingDetailFormat', kind: string, kindLabel: string, isUseProductionLot: boolean, isUseEquipmentName: boolean, isUseProcessingTimeHour: boolean, isUseProcessingTimeMinute: boolean, isUseProcessingTimeSecond: boolean, isUseProcessingRate: boolean, isUseSetupInformation: boolean, isUseSetupTimeHour: boolean, isUseSetupTimeMinute: boolean, isUseSetupTimeSecond: boolean, isUseSetupRate: boolean, isUseMemo: boolean, isUseProcessingTimes: boolean, isUseProcessingCostSubtotal: boolean, isUseSetupCostSubtotal: boolean, rateKind: string | null }>, processingCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, facilityKinds: Array<{ __typename?: 'FacilityKind', id: string, code: string | null, name: string }> } | null } };

export type PriceAdjustmentItemProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PriceAdjustmentItemProjectQuery = { __typename?: 'Query', priceAdjustmentItemProject: { __typename?: 'Project', id: string, modelYear: number | null, title: string, modelTitle: string | null, modelTypeName: string | null, projectModel: { __typename?: 'ProjectModel', id: string, deliverySiteName: string | null, modelDepreciation: string | null, modelDepreciationQuantity: number | null, manufacturingSiteName: string | null } | null, projectFormat: { __typename?: 'ProjectFormat', isSingleUnitProject: boolean } | null, projectSchedules: Array<{ __typename?: 'ProjectSchedule', id: string | null, eventName: string, eventOn: any | null, qualificationLevelName: string | null, seqNo: number | null }>, quotationContext: { __typename?: 'QuotationContext', materialPriceDateOn: any | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, comment: string | null } } | null };

export type PriceAdjustmentMaterialErrorsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  priceEffectiveDate: Scalars['ISO8601Date']['input'];
}>;


export type PriceAdjustmentMaterialErrorsQuery = { __typename?: 'Query', priceAdjustmentMaterialErrors: Array<string> };

export type PriceAdjustmentSettingQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
}>;


export type PriceAdjustmentSettingQuery = { __typename?: 'Query', priceAdjustmentSetting: { __typename?: 'PriceAdjustmentSetting', id: string, tenantId: string, reasonCount: number, isUseMaterialPriceAdjustment: boolean | null, isUsePriceAdjustmentFormEdit: boolean, materialPriceAdjustmentTargetKind: PriceAdjustmentSettingMaterialPriceAdjustmentTargetKindEnum } };

export type PriceAdjustmentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantCode?: InputMaybe<Scalars['String']['input']>;
  ownConfirmationSupplierCode?: InputMaybe<Scalars['String']['input']>;
  confirmationStatuses?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  adjustmentStatuses?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  inChargeSupplierUserId?: InputMaybe<Scalars['ID']['input']>;
  confirmationStartDateFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  confirmationStartDateTo?: InputMaybe<Scalars['ISO8601Date']['input']>;
  confirmationDeadlineDateFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  confirmationDeadlineDateTo?: InputMaybe<Scalars['ISO8601Date']['input']>;
}>;


export type PriceAdjustmentsQuery = { __typename?: 'Query', priceAdjustmentConfirmationStatuses: Array<{ __typename?: 'PriceAdjustmentStatus', name: string, value: number }>, priceAdjustmentAdjustmentStatuses: Array<{ __typename?: 'PriceAdjustmentStatus', name: string, value: number }>, priceAdjustments: { __typename?: 'PriceAdjustmentConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, nodes: Array<{ __typename?: 'PriceAdjustment', id: string, tenantId: string, tenantCode: string, supplierCode: string, adjustmentPurpose: string, applicantKind: string, targetTerm: string, confirmationStartDate: any | null, confirmationDeadlineDate: any | null, priceEffectiveDate: any | null, priceExpirationDate: any | null, memo: string, supplier: { __typename?: 'Supplier', id: string, name: string, displayCode: string }, inChargeAdminUser: { __typename?: 'AdminUser', id: string, name: string } | null, inChargeSupplierAccount: { __typename?: 'SupplierAccount', id: string, name: string } | null, inChargeSupplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null, supplierAccounts: Array<{ __typename?: 'SupplierAccount', id: string, name: string }>, supplierUsers: Array<{ __typename?: 'SupplierUser', id: string, name: string }> | null, currentEvent: { __typename?: 'PriceAdjustmentEvent', id: string, eventKind: string, memo: string | null, triggeredByType: string, createdAt: any, confirmationStatusName: string, confirmationStatusValue: number, adjustmentStatusName: string, actionName: string, triggeredBy:
          | { __typename?: 'AdminUser', id: string, name: string }
          | { __typename?: 'SupplierAccount', id: string, name: string }
          | { __typename?: 'SupplierUser', id: string, name: string }
         }, currentAsking: { __typename?: 'PriceAdjustmentEvent', id: string, eventKind: string, memo: string | null, triggeredByType: string, createdAt: any, confirmationStatusName: string, confirmationStatusValue: number, adjustmentStatusName: string, actionName: string, triggeredBy:
          | { __typename?: 'AdminUser', id: string, name: string }
          | { __typename?: 'SupplierAccount', id: string, name: string }
          | { __typename?: 'SupplierUser', id: string, name: string }
         } | null, tenant: { __typename?: 'Tenant', id: string, name: string }, priceAdjustmentItems: Array<{ __typename?: 'PriceAdjustmentItem', id: string, partOrderUnitPrice: { __typename?: 'PartOrderUnitPrice', id: string, part: { __typename?: 'Part', id: string, name: string, code: string | null, rootPartCode: string | null } } | null }> | null }> } };

export type PriceAdjustmentsV2QueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['ID']['input'];
  purpose?: InputMaybe<Scalars['String']['input']>;
  partCode?: InputMaybe<Scalars['String']['input']>;
  rootPartCode?: InputMaybe<Scalars['String']['input']>;
  partName?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  priceEffectiveDateSince?: InputMaybe<Scalars['String']['input']>;
  priceEffectiveDateUntil?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  personInChargeIds?: InputMaybe<Scalars['String']['input']>;
  confirmStartDateSince?: InputMaybe<Scalars['String']['input']>;
  confirmStartDateUntil?: InputMaybe<Scalars['String']['input']>;
  confirmDueDateSince?: InputMaybe<Scalars['String']['input']>;
  confirmDueDateUntil?: InputMaybe<Scalars['String']['input']>;
  confirmationStatus?: InputMaybe<Scalars['String']['input']>;
}>;


export type PriceAdjustmentsV2Query = { __typename?: 'Query', priceAdjustmentConfirmationStatuses: Array<{ __typename?: 'PriceAdjustmentStatus', name: string, value: number }>, priceAdjustmentAdjustmentStatuses: Array<{ __typename?: 'PriceAdjustmentStatus', name: string, value: number }>, priceAdjustments: { __typename?: 'PriceAdjustmentConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, nodes: Array<{ __typename?: 'PriceAdjustment', id: string, tenantId: string, tenantCode: string, supplierCode: string, adjustmentPurpose: string, applicantKind: string, targetTerm: string, confirmationStartDate: any | null, confirmationDeadlineDate: any | null, priceEffectiveDate: any | null, priceExpirationDate: any | null, memo: string, supplier: { __typename?: 'Supplier', id: string, name: string, displayCode: string }, inChargeAdminUser: { __typename?: 'AdminUser', id: string, name: string } | null, inChargeSupplierAccount: { __typename?: 'SupplierAccount', id: string, name: string } | null, inChargeSupplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null, supplierAccounts: Array<{ __typename?: 'SupplierAccount', id: string, name: string }>, supplierUsers: Array<{ __typename?: 'SupplierUser', id: string, name: string }> | null, currentEvent: { __typename?: 'PriceAdjustmentEvent', id: string, eventKind: string, memo: string | null, triggeredByType: string, createdAt: any, confirmationStatusName: string, confirmationStatusValue: number, adjustmentStatusName: string, actionName: string, triggeredBy:
          | { __typename?: 'AdminUser', id: string, name: string }
          | { __typename?: 'SupplierAccount', id: string, name: string }
          | { __typename?: 'SupplierUser', id: string, name: string }
         }, currentAsking: { __typename?: 'PriceAdjustmentEvent', id: string, eventKind: string, memo: string | null, triggeredByType: string, createdAt: any, confirmationStatusName: string, confirmationStatusValue: number, adjustmentStatusName: string, actionName: string, triggeredBy:
          | { __typename?: 'AdminUser', id: string, name: string }
          | { __typename?: 'SupplierAccount', id: string, name: string }
          | { __typename?: 'SupplierUser', id: string, name: string }
         } | null, tenant: { __typename?: 'Tenant', id: string, name: string }, priceAdjustmentItems: Array<{ __typename?: 'PriceAdjustmentItem', id: string, partOrderUnitPrice: { __typename?: 'PartOrderUnitPrice', id: string, part: { __typename?: 'Part', id: string, name: string, code: string | null, rootPartCode: string | null } } | null }> | null }> } };

export type PriceChangeReasonsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
}>;


export type PriceChangeReasonsQuery = { __typename?: 'Query', priceChangeReasons: Array<{ __typename?: 'PriceChangeReason', id: string, reason: string, code: string, sequence: number }> };

export type ProcurementKindSettingsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  targetKind: ProcurementKindTargetKindEnum;
}>;


export type ProcurementKindSettingsQuery = { __typename?: 'Query', procurementKindSettings: Array<{ __typename?: 'ProcurementKindSetting', procurementKind: string, seq: number, label: string | null }> };

export type ProfileQueryVariables = Exact<{
  includePast?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProfileQuery = { __typename?: 'Query', profile: { __typename?: 'SupplierAccount', id: string, name: string, email: string, tel: string, department: string, title: string, languageCode: string, csvExportEncodingKind: SupplierUserCsvExportEncodingKindEnum, profileTenantAssignments: Array<{ __typename?: 'TenantMemberAssignment', id: string, tenantId: string, tenantName: string, supplierCode: string, startedAt: any, endedAt: any | null, isSendNotification: boolean, isArchived: boolean, isSendSupplierFirmInfoConfirmationRequest: boolean, supplierAccountId: string | null, supplierAccountTenantLinkId: string | null }>, supplierAccountTenantLinks: Array<{ __typename?: 'SupplierAccountTenantLink', id: string, tenant: { __typename?: 'Tenant', id: string, name: string } }> } | null };

export type QuotationV2QueryVariables = Exact<{
  quotationID: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type QuotationV2Query = { __typename?: 'Query', quotation: { __typename?: 'Quotation', id: string, uid: string, status: string, announcementKind: string, kind: string, selectKind: string, closeMemoForSupplier: string | null, answerDueDate: any | null, requestText: string | null, isDetailCostUsed: boolean, isUseAnswerExcelImport: boolean, isRequestSupplyChain: boolean, isBeforeMigration: boolean, isOneOffOrder: boolean, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, itemsToAnswer: Array<{ __typename?: 'ItemToAnswer', seq: number, quantity: number, quantityGroup: string, rootQuotationItemId: string, totalQuantityOnBranch: number, isDuplicate: boolean, quotationItemAssemblyEntity: { __typename?: 'QuotationItemAssemblyEntity', depth: number, numberCount: number, unitKind: string } | null, quotationItem: { __typename?: 'QuotationItemV2', id: string, isRoot: boolean, isNew: boolean | null, quantity: number | null, multiLot: Array<number>, quantityGroups: Array<string>, receiverCode: string | null, receiverName: string | null, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, makerName: string | null, makerCode: string | null, makerModelNumber: string | null, figureNumber: string | null, rootPartCode: string | null, designChangeCode: string | null, itemPropInfosForSupplier: Array<{ __typename?: 'ItemPropInfo', id: string, itemProppableType: string, itemProppableId: string, stringValue: string | null, numberValue: number | null, booleanValue: boolean | null, position: number, itemProp: { __typename?: 'ItemProp', id: string, name: string, code: string | null, unit: string | null, kind: ItemPropKind }, selectedOptions: Array<{ __typename?: 'ItemPropOption', id: string, label: string, position: number }> }>, specAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, designAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> }, quotationItemSelection: { __typename?: 'QuotationItemSelection', isSelected: boolean } | null, quotationItemSupplyParts: Array<{ __typename?: 'CommonSupplyPartInfo', id: string, name: string, code: string, supplyPartId: string | null, tenantId: string, unitPrice: number | null, specs: Array<{ __typename?: 'CommonSupplyPartSpec', id: string | null, code: string | null, name: string | null, unit: string | null, value: string | null }> | null }>, deliverySites: Array<{ __typename?: 'DeliverySite', id: string, name: string, code: string | null }>, tenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string } | null, products: Array<{ __typename?: 'Product', id: string, customerName: string | null, customerDevelopmentCode: string | null, name: string, code: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null, productScheduleGroups: Array<{ __typename?: 'ProductScheduleGroup', id: string, seqNo: number, productSchedules: Array<{ __typename?: 'ProductSchedule', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null }> }> }>, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, quotationItemSupplySubparts: Array<{ __typename?: 'CommonQuotationItemSupplySubpart', id: string, supplyPartName: string | null, partCode: string | null, rootPartCode: string | null, unitPrice: number, quantity: number, quantityDenominator: number, supplyPartCost: number }>, quotationItemMaterials: Array<{ __typename?: 'QuotationItemMaterial', id: string, baseMaterialCode: string | null, materialName: string, thickness: number | null, width: number | null, procurementKind: string | null, materialBasePrice: number | null, scrap1UnitPrice: number | null }>, project: { __typename?: 'Project', id: string, modelTitle: string | null, modelTypeName: string | null, modelYear: number | null, title: string, uid: string, projectSchedules: Array<{ __typename?: 'ProjectSchedule', id: string | null, eventName: string, eventOn: any | null, qualificationLevelName: string | null }>, projectModel: { __typename?: 'ProjectModel', id: string, deliverySiteName: string | null, manufacturingSiteName: string | null, productWeight: number | null, name: string | null, code: string | null, customerName: string | null, customerDevelopmentCode: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null } | null } | null, projectItem: { __typename?: 'ProjectItem', id: string, quantityPerRoot: number | null } | null, quotationItemChildStructs: Array<{ __typename?: 'QuotationItemChildStruct', id: string, level: number, parentId: string | null, quantityPerRoot: number, quotationRequestKind: QuotationRequestKindEnum, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, figureNumber: string | null } | null, tenantUnit: { __typename?: 'TenantUnit', id: string, name: string } }> }, answerPrice: { __typename?: 'AnswerPrice', id: string, quantity: number, quantityFrom: number, quantityTo: number | null, isDeclined: boolean, priceBasis: string, taxType: number, amountExcludingTax: string | null, amountIncludingTax: string | null, unitPrice: number | null, materialCost: number | null, partsCost: number | null, processingCost: number | null, surfaceProcessingCost: number | null, subsidiaryMaterialCost: number | null, materialManagementCost: number | null, materialManagementRate: number | null, processingManagementCost: number | null, processingManagementRate: number | null, managementCost: number | null, quantityInOneBox: number | null, deliveryCostPerBox: number | null, boxCount: number | null, deliveryCost: number | null, packingCostPerBox: number | null, packingCost: number | null, defectCost: number | null, defectRate: number | null, profit: number | null, adjustment: number | null, profitRate: number | null, depreciation: number | null, internalPartSubtotal: number | null, outSourcePartSubtotal: number | null, outSourcePartManagementRate: number | null, paidSupplyPartSubtotal: number | null, deliveryDay: number | null, initialDeliveryDay: number | null, materialDeliveryDay: number | null, materialDeliveryStartDay: number | null, equipmentDeliveryDay: number | null, equipmentDeliveryStartDay: number | null, moldDeliveryDay: number | null, moldDeliveryStartDay: number | null, trialDeliveryDay: number | null, trialDeliveryStartDay: number | null, facilityCost: number | null, jigManagementCost: number | null, propertyRentCost: number | null, designCost: number | null, subsidiaryMaterialManagementRate: number | null, subsidiaryMaterialManagementCost: number | null, quotationItemId: string, quotationItemChildStructId: string | null, answerPartsCosts: Array<{ __typename?: 'AnswerPartsCost', id: string, procurementKind: string | null, seqNo: number, partNo: string | null, partName: string | null, productionPlace: string | null, partSpec: string | null, partsCount: number | null, quantity: number | null, partsUnitPrice: number | null, memo: string | null, partsCost: number }>, answerProcessingCosts: Array<{ __typename?: 'AnswerProcessingCost', id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, memo: string | null, processingCost: number, rateKind: string | null, processingWeight: number | null, costForWeight: number | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostSubtotalPerLot: number | null, setupCostSubtotalPerLot: number | null, processingCostPerLot: number | null, partCostRatio: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSpecialProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerSurfaceProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerMaterialCosts: Array<{ __typename?: 'AnswerMaterialCost', id: string, seqNo: number, materialName: string, thickness: number | null, width: number | null, height: number | null, measure: string | null, weightBeforeProcess: number | null, weightAfterProcess: number | null, basePrice: number | null, adjustment: number | null, materialCostSubtotal: number | null, scrapValueSubtotal: number | null, materialCost: number, procurementKind: string | null, cavity: number | null, scrap1Name: string | null, scrap1Weight: number | null, scrap1UnitPrice: number | null, scrap1Subtotal: number | null, scrap2Name: string | null, scrap2Weight: number | null, scrap2UnitPrice: number | null, scrap2Subtotal: number | null, memo: string | null, baseMaterialCode: string | null, materialCostPerQty: number | null, scrap1SubtotalPerQty: number | null, scrap2SubtotalPerQty: number | null, scrapValueSubtotalPerQty: number | null, quantity: number | null, blendPrimaryMaterialName: string | null, blendPrimaryMaterialRatio: number | null, blendPrimaryMaterialUnitCost: number | null, blendSecondaryMaterialName: string | null, blendSecondaryMaterialRatio: number | null, blendSecondaryMaterialUnitCost: number | null, blendOtherMaterialName: string | null, blendOtherMaterialRatio: number | null, blendOtherMaterialUnitCost: number | null, blendBaseUnitCost: number | null, blendUnitCostMarkupRatio: number | null, lossPurgeLotCount: number | null, lossPurgeTotalWeight: number | null, lossPurgeUnitUsage: number | null, lossPurgeCost: number | null, lossGateUnitUsage: number | null, lossGateCost: number | null, lossRunnerUnitUsage: number | null, lossRunnerCost: number | null, lossOtherMemo: string | null, lossOtherUnitUsage: number | null, lossOtherCost: number | null, lossTotalUnitUsage: number | null, lossTotalCost: number | null, trialShotUnitUsage: number | null, trialShotCost: number | null, adjustmentCostMemo: string | null, adjustmentCost: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, priceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSubsidiaryMaterialCosts: Array<{ __typename?: 'CommonAnswerSubsidiaryMaterialCost', id: string, seqNo: number, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number, note: string | null, totalQuantity: number | null, totalSubsidiaryMaterialCost: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null }>, answerSupplySubparts: Array<{ __typename?: 'CommonAnswerSupplySubpart', id: string, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, quantity: number, quantityDenominator: number, unitPrice: number }> } | null }>, quotationItemsV2: Array<{ __typename?: 'QuotationItemV2', id: string, isRoot: boolean, isNew: boolean | null, quantity: number | null, multiLot: Array<number>, quantityGroups: Array<string>, receiverCode: string | null, receiverName: string | null, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, makerName: string | null, makerCode: string | null, makerModelNumber: string | null, figureNumber: string | null, rootPartCode: string | null, designChangeCode: string | null, itemPropInfosForSupplier: Array<{ __typename?: 'ItemPropInfo', id: string, itemProppableType: string, itemProppableId: string, stringValue: string | null, numberValue: number | null, booleanValue: boolean | null, position: number, itemProp: { __typename?: 'ItemProp', id: string, name: string, code: string | null, unit: string | null, kind: ItemPropKind }, selectedOptions: Array<{ __typename?: 'ItemPropOption', id: string, label: string, position: number }> }>, specAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, designAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> }, quotationItemSelection: { __typename?: 'QuotationItemSelection', isSelected: boolean } | null, quotationItemSupplyParts: Array<{ __typename?: 'CommonSupplyPartInfo', id: string, name: string, code: string, supplyPartId: string | null, tenantId: string, unitPrice: number | null, specs: Array<{ __typename?: 'CommonSupplyPartSpec', id: string | null, code: string | null, name: string | null, unit: string | null, value: string | null }> | null }>, deliverySites: Array<{ __typename?: 'DeliverySite', id: string, name: string, code: string | null }>, tenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string } | null, products: Array<{ __typename?: 'Product', id: string, customerName: string | null, customerDevelopmentCode: string | null, name: string, code: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null, productScheduleGroups: Array<{ __typename?: 'ProductScheduleGroup', id: string, seqNo: number, productSchedules: Array<{ __typename?: 'ProductSchedule', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null }> }> }>, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null, quotationItemSupplySubparts: Array<{ __typename?: 'CommonQuotationItemSupplySubpart', id: string, supplyPartName: string | null, partCode: string | null, rootPartCode: string | null, unitPrice: number, quantity: number, quantityDenominator: number, supplyPartCost: number }>, quotationItemMaterials: Array<{ __typename?: 'QuotationItemMaterial', id: string, baseMaterialCode: string | null, materialName: string, thickness: number | null, width: number | null, procurementKind: string | null, materialBasePrice: number | null, scrap1UnitPrice: number | null }>, project: { __typename?: 'Project', id: string, modelTitle: string | null, modelTypeName: string | null, modelYear: number | null, title: string, uid: string, projectSchedules: Array<{ __typename?: 'ProjectSchedule', id: string | null, eventName: string, eventOn: any | null, qualificationLevelName: string | null }>, projectModel: { __typename?: 'ProjectModel', id: string, deliverySiteName: string | null, manufacturingSiteName: string | null, productWeight: number | null, name: string | null, code: string | null, customerName: string | null, customerDevelopmentCode: string | null, division: string | null, detail: string | null, manufacturingLocation: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, orderType: string | null, orderProbability: string | null } | null } | null, projectItem: { __typename?: 'ProjectItem', id: string, quantityPerRoot: number | null } | null, quotationItemChildStructs: Array<{ __typename?: 'QuotationItemChildStruct', id: string, level: number, parentId: string | null, quantityPerRoot: number, quotationRequestKind: QuotationRequestKindEnum, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, figureNumber: string | null } | null, tenantUnit: { __typename?: 'TenantUnit', id: string, name: string } }> }>, quotationRequest: { __typename?: 'QuotationRequest', id: string, isAnswered: boolean, isDeclined: boolean, answeredAt: any | null, requestedOn: any | null, isLocked: boolean, commentForSupplier: string | null, personInCharge: string, supplierCountryId: string, answeredAtZoned: any | null, statusForSupplier: string, isCanBeAnswered: boolean, isCanBeDeclined: boolean, answer: { __typename?: 'Answer', declineReason: string | null, id: string, status: string, statusLabel: string, memo: string | null, expiredAt: any | null, isDirect: boolean, isFileAnswer: boolean, isSupplierFileAnswer: boolean, dayType: string | null, quotationNo: string | null, expirationDate: string | null, currencyId: string, facilityCost: number, currencyExchangeNote: string | null, inputKind: string, quotationCopiedFrom: { __typename?: 'Quotation', id: string, uid: string } | null, answerPrices: Array<{ __typename?: 'AnswerPrice', id: string, quantity: number, quantityFrom: number, quantityTo: number | null, isDeclined: boolean, priceBasis: string, taxType: number, amountExcludingTax: string | null, amountIncludingTax: string | null, unitPrice: number | null, materialCost: number | null, partsCost: number | null, processingCost: number | null, surfaceProcessingCost: number | null, subsidiaryMaterialCost: number | null, materialManagementCost: number | null, materialManagementRate: number | null, processingManagementCost: number | null, processingManagementRate: number | null, managementCost: number | null, quantityInOneBox: number | null, deliveryCostPerBox: number | null, boxCount: number | null, deliveryCost: number | null, packingCostPerBox: number | null, packingCost: number | null, defectCost: number | null, defectRate: number | null, profit: number | null, adjustment: number | null, profitRate: number | null, depreciation: number | null, internalPartSubtotal: number | null, outSourcePartSubtotal: number | null, outSourcePartManagementRate: number | null, paidSupplyPartSubtotal: number | null, deliveryDay: number | null, initialDeliveryDay: number | null, materialDeliveryDay: number | null, materialDeliveryStartDay: number | null, equipmentDeliveryDay: number | null, equipmentDeliveryStartDay: number | null, moldDeliveryDay: number | null, moldDeliveryStartDay: number | null, trialDeliveryDay: number | null, trialDeliveryStartDay: number | null, facilityCost: number | null, jigManagementCost: number | null, propertyRentCost: number | null, designCost: number | null, subsidiaryMaterialManagementRate: number | null, subsidiaryMaterialManagementCost: number | null, quotationItemId: string, quotationItemChildStructId: string | null, answerPartsCosts: Array<{ __typename?: 'AnswerPartsCost', id: string, procurementKind: string | null, seqNo: number, partNo: string | null, partName: string | null, productionPlace: string | null, partSpec: string | null, partsCount: number | null, quantity: number | null, partsUnitPrice: number | null, memo: string | null, partsCost: number }>, answerProcessingCosts: Array<{ __typename?: 'AnswerProcessingCost', id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, memo: string | null, processingCost: number, rateKind: string | null, processingWeight: number | null, costForWeight: number | null, processingHeadcount: number | null, processOutsourcingKind: string | null, processingCostSubtotalPerLot: number | null, setupCostSubtotalPerLot: number | null, processingCostPerLot: number | null, partCostRatio: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSpecialProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerSurfaceProcessingCosts: Array<{ __typename?: 'CommonAnswerSpecialProcessingCost', kind: string, id: string, seqNo: number, productionLot: number | null, processName: string, equipmentName: string | null, processingTimeHour: number | null, processingTimeMinute: number | null, processingTimeSecond: number | null, processingRate: number | null, processingCostSubtotal: number | null, setupTimeHour: number | null, setupTimeMinute: number | null, setupTimeSecond: number | null, setupRate: number | null, processingTimes: number | null, setupCostSubtotal: number | null, processingCost: number, memo: string | null, rateKind: string | null }>, answerMaterialCosts: Array<{ __typename?: 'AnswerMaterialCost', id: string, seqNo: number, materialName: string, thickness: number | null, width: number | null, height: number | null, measure: string | null, weightBeforeProcess: number | null, weightAfterProcess: number | null, basePrice: number | null, adjustment: number | null, materialCostSubtotal: number | null, scrapValueSubtotal: number | null, materialCost: number, procurementKind: string | null, cavity: number | null, scrap1Name: string | null, scrap1Weight: number | null, scrap1UnitPrice: number | null, scrap1Subtotal: number | null, scrap2Name: string | null, scrap2Weight: number | null, scrap2UnitPrice: number | null, scrap2Subtotal: number | null, memo: string | null, baseMaterialCode: string | null, materialCostPerQty: number | null, scrap1SubtotalPerQty: number | null, scrap2SubtotalPerQty: number | null, scrapValueSubtotalPerQty: number | null, quantity: number | null, blendPrimaryMaterialName: string | null, blendPrimaryMaterialRatio: number | null, blendPrimaryMaterialUnitCost: number | null, blendSecondaryMaterialName: string | null, blendSecondaryMaterialRatio: number | null, blendSecondaryMaterialUnitCost: number | null, blendOtherMaterialName: string | null, blendOtherMaterialRatio: number | null, blendOtherMaterialUnitCost: number | null, blendBaseUnitCost: number | null, blendUnitCostMarkupRatio: number | null, lossPurgeLotCount: number | null, lossPurgeTotalWeight: number | null, lossPurgeUnitUsage: number | null, lossPurgeCost: number | null, lossGateUnitUsage: number | null, lossGateCost: number | null, lossRunnerUnitUsage: number | null, lossRunnerCost: number | null, lossOtherMemo: string | null, lossOtherUnitUsage: number | null, lossOtherCost: number | null, lossTotalUnitUsage: number | null, lossTotalCost: number | null, trialShotUnitUsage: number | null, trialShotCost: number | null, adjustmentCostMemo: string | null, adjustmentCost: number | null, weightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, priceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null }>, answerSubsidiaryMaterialCosts: Array<{ __typename?: 'CommonAnswerSubsidiaryMaterialCost', id: string, seqNo: number, name: string, unitPrice: number | null, quantity: number | null, subsidiaryMaterialCost: number, note: string | null, totalQuantity: number | null, totalSubsidiaryMaterialCost: number | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null }>, answerSupplySubparts: Array<{ __typename?: 'CommonAnswerSupplySubpart', id: string, partCode: string | null, rootPartCode: string | null, supplyPartName: string | null, quantity: number, quantityDenominator: number, unitPrice: number }> }>, answerFacilityCosts: Array<{ __typename?: 'AnswerFacilityCost', id: string, name: string, maker: string | null, spec: string | null, quantity: number | null, facilityUnitPrice: number | null, facilityCost: number, isLend: boolean | null, amortizationCost: number | null, amortizationNumber: number | null, amortizationPeriod: string | null, cavity: number | null, leadTime: string | null, memo: string | null, amortizationPeriodAsYear: number | null, paymentTimingKind: string | null, recuttingCount: number | null, answerProcessingCostId: string | null, amortizationNumberPerPeriod: number | null, amortizationPeriodAsNum: number | null, facilityKind: { __typename?: 'FacilityKind', id: string }, parts: Array<{ __typename?: 'Part', id: string, name: string, displayCode: string }>, quotationItems: Array<{ __typename?: 'QuotationItemV2', id: string, itemRequirement: { __typename?: 'ItemRequirement', name: string, code: string | null } }> }>, answerInquiries: Array<{ __typename?: 'AnswerInquiry', id: string, answerValueString: string | null, answerValueNumber: number | null, answerValueBoolean: boolean | null, quotationInquiry: { __typename?: 'QuotationInquiry', id: string, seqNo: number, title: string, inquiryType: string, unit: string | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null, supplierCorporationAttachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }>, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierCorporationAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierAccount: { __typename?: 'SupplierAccount', id: string, name: string } | null, supplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null, answerSupplyChainItemDetails: Array<{ __typename?: 'AnswerSupplyChainItemDetail', id: string | null, tenantId: string | null, quotationItemId: string | null, answerId: string | null, processName: string | null, supplierName: string | null, isAlternative: boolean | null, isNew: boolean | null, note: string | null, factoryName: string | null, address: { __typename?: 'Address', id: string, countryId: string, stateId: string | null, zipCode: string | null, address: string, building: string, phoneNumber: string, country: { __typename?: 'Country', id: string, name: string, translation: string | null } | null, state: { __typename?: 'State', id: string, name: string } | null } | null }>, answerItems: Array<{ __typename?: 'AnswerItem', quotationItemId: string, minimumOrderQuantity: string | null, deliveryForm: string | null, quantityPerDeliveryForm: string | null, priceEffectiveFrom: any | null, priceEffectiveTo: any | null, specMemo: string | null, originLocation: string | null }>, wholesalerKnowledges: Array<{ __typename?: 'WholesalerKnowledge', quotationItemId: string, makerActualPartName: string | null }>, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null, answerOriginalFiles: Array<{ __typename?: 'AnswerOriginalFile', attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null, supplierCorporationAttachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }>, answerExcelAttachments: Array<{ __typename?: 'AnswerExcelAttachment', id: string | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null, supplierCorporationAttachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }> } | null, pdfImportResult: { __typename?: 'PdfImportResult', id: string, signedUrl: string, fileName: string } | null, currencies: Array<{ __typename?: 'Currency', id: string, currencyCode: string, numericCode: number, symbol: string, displayName: string, decimalPrecision: number, isBaseCurrency: boolean }>, supplier: { __typename?: 'Supplier', id: string, code: string, name: string, isEligibleToSubcontractAct: boolean } }, applicationFormat: { __typename?: 'ApplicationFormat', isUseReceiver: boolean, isUseDesignAttachment: boolean, isUseSpecAttachment: boolean, isUseFigureNumber: boolean, quantityUnit: string | null, isUseIsNew: boolean, isUseDeliverySite: boolean, isSendSelectionMail: boolean, isUseQuotationContext: boolean, isUseQcIncoterms: boolean, isUseQcRuleOfCurrencyRateChange: boolean, isUseQcRuleOfMarketChange: boolean, isUseRequestProcess: boolean, isUseMaterialPriceReferenceDate: boolean, isUseAssumedExchangeRateUsd: boolean, isUseAssumedExchangeRateCny: boolean, isUsePartSupplyPresence: boolean, isUseMaterialSupplyPresence: boolean, isUseCostBearingDolly: boolean, isUseCostBearingInitialCost: boolean, isUsePaymentMethod: boolean, isUsePaymentInstallmentInitialCost: boolean, isUseMassProductionCategory: boolean, isUseMaker: boolean, isUseItemPropInfo: boolean, productScheduleSettings: Array<{ __typename?: 'ProductScheduleSetting', groupSeqNo: number, seqNo: number, name: string }>, itemProps: Array<{ __typename?: 'ItemProp', id: string, name: string, code: string | null, unit: string | null, kind: ItemPropKind }> }, answerFormat: { __typename?: 'AnswerFormat', id: string, isUseMaterialCost: boolean, isUseMaterialCostDetail: boolean, isUseMaterialSize: boolean, isUseMaterialScrap: boolean, isUseMaterialCostProcurementKind: boolean, isUseMaterialCostCavity: boolean, isUseMaterialCostAdjustment: boolean, isUseMaterialCostMemo: boolean, isUseMaterialCostThickness: boolean, isUseMaterialCostWidth: boolean, isUseMaterialCostHeight: boolean, isUseMaterialCostMeasure: boolean, isUseMaterialCostWeightBeforeProcess: boolean, isUseMaterialCostWeightAfterProcess: boolean, isUseMaterialCostBasePrice: boolean, isUsePartsCost: boolean, isUsePartsCostDetail: boolean, isUsePartsCostProcurementKind: boolean, isUsePartsCostPartNo: boolean, isUsePartsCostPartName: boolean, isUsePartsCostProductionPlace: boolean, isUsePartsCostQuantity: boolean, isUsePartsCostPartsUnitPrice: boolean, isUsePartsCostMemo: boolean, isUsePartsCostPartSpec: boolean, isUsePartsCostPartsCount: boolean, isUseProcessingCost: boolean, isUseProcessingCostDetail: boolean, isUseProcessingCostProductionLot: boolean, isUseProcessingCostEquipmentName: boolean, isUseProcessingCostProcessingTimeHour: boolean, isUseProcessingCostProcessingTimeMinute: boolean, isUseProcessingCostProcessingTimeSecond: boolean, isUseProcessingCostProcessingRate: boolean, isUseSetupInformation: boolean, isUseProcessingCostProcessingTimes: boolean, isUseProcessingCostSetupTimeHour: boolean, isUseProcessingCostSetupTimeMinute: boolean, isUseProcessingCostSetupTimeSecond: boolean, isUseProcessingCostSetupRate: boolean, isUseProcessingCostProcessingCostSubtotal: boolean, isUseProcessingCostSetupCostSubtotal: boolean, isUseProcessingCostMemo: boolean, processingCostRateKind: string | null, isUseManagementCost: boolean, isUseMaterialManagementRate: boolean, isUseMaterialManagementCost: boolean, isUseProcessingManagementRate: boolean, isUseProcessingManagementCost: boolean, isUseDeliveryCost: boolean, isUseDeliveryBoxInformation: boolean, isUsePackingCost: boolean, isUsePackingBoxInformation: boolean, isUseDefectCost: boolean, isUseDefectRate: boolean, isUseProfit: boolean, isUseProfitRate: boolean, isUseAdjustment: boolean, isUseDepreciation: boolean, isUseInternalPartSubtotal: boolean, isUseOutSourcePartSubtotal: boolean, isUseOutSourcePartManagementRate: boolean, isUsePaidSupplyPartSubtotal: boolean, isUseInitialDeliveryDay: boolean, isUseMaterialDeliveryDay: boolean, isUseEquipmentDeliveryDay: boolean, isUseMoldDeliveryDay: boolean, isUseTrialDeliveryDay: boolean, isUseDeliveryDay: boolean, isUseGanttForDeliveryDay: boolean, isUseSurfaceProcessingCost: boolean, isUseSubsidiaryMaterialCost: boolean, isUseSubsidiaryMaterialCostDetail: boolean, isSetScrapName: boolean, scrap1Name: string | null, scrap2Name: string | null, isUseCurrencyExchangeNote: boolean, isUseAnswerByItem: boolean, isUseMinimumOrderQuantity: boolean, isUseDeliveryForm: boolean, isUseQuantityPerDeliveryForm: boolean, isUsePriceEffectiveDate: boolean, priceRegistrationFormatId: string | null, answerMethod: string, isUseProcessingWeight: boolean, isUseCostForWeight: boolean, isUseProcessingHeadcount: boolean, calculationKind: string, isUseWholesalerKnowledge: boolean, useMakerActualPartName: string, makerActualPartNameHelperTxt: string | null, materialCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, materialCostPriceTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, specialProcessingDetailFormatsList: Array<{ __typename?: 'CommonSpecialProcessingDetailFormat', kind: string, kindLabel: string, isUseProductionLot: boolean, isUseEquipmentName: boolean, isUseProcessingTimeHour: boolean, isUseProcessingTimeMinute: boolean, isUseProcessingTimeSecond: boolean, isUseProcessingRate: boolean, isUseSetupInformation: boolean, isUseSetupTimeHour: boolean, isUseSetupTimeMinute: boolean, isUseSetupTimeSecond: boolean, isUseSetupRate: boolean, isUseMemo: boolean, isUseProcessingTimes: boolean, isUseProcessingCostSubtotal: boolean, isUseSetupCostSubtotal: boolean, rateKind: string | null }>, processingCostWeightTenantUnit: { __typename?: 'TenantUnit', name: string, unitCode: string, unit: { __typename?: 'Unit', symbol: string, conversionRate: number } } | null, facilityKinds: Array<{ __typename?: 'FacilityKind', id: string, code: string | null, name: string }> }, quotationProducts: Array<{ __typename?: 'QuotationProduct', productId: string | null, productInformation: string | null, customerName: string | null, customerDevelopmentCode: string | null, annualQuantity: string | null, scheduledSalesDate: string | null, developmentCode: string | null, productDevision: string | null, productDetail: string | null, productManufacturingLocation: string | null, orderType: string | null, orderProbability: string | null, productScheduleGroupSnapshots: Array<{ __typename?: 'ProductScheduleGroupSnapshot', id: string, seqNo: number, productSchedules: Array<{ __typename?: 'ProductScheduleSnapshot', id: string | null, seqNo: number | null, eventName: string, eventOn: string | null }> }> }>, quotationProductSchedules: Array<{ __typename?: 'QuotationProductSchedule', id: string | null, groupSeqNo: number, seqNo: number, name: string, value: string | null }>, tenant: { __typename?: 'Tenant', id: string, name: string, code: string, productConfig: { __typename?: 'ProductConfig', isVisibleDevelopmentCode: boolean, isVisibleName: boolean, isVisibleCustomerName: boolean, isVisibleCustomerDevelopmentCode: boolean, isVisibleDivision: boolean, isVisibleDetail: boolean, isVisibleManufacturingLocation: boolean, isVisibleAnnualQuantity: boolean, isVisibleScheduledSalesDate: boolean, isVisibleOrderType: boolean, isVisibleOrderProbability: boolean, isUseCustomerName: boolean, isUseCustomerDevelopmentCode: boolean, isUseDivision: boolean, isUseDetail: boolean, isUseManufacturingLocation: boolean, isUseAnnualQuantity: boolean, isUseScheduledSalesDate: boolean, isUseOrderType: boolean, isUseOrderProbability: boolean } | null, quotationConfig: { __typename?: 'QuotationConfig', dayTypeSetting: string, deliveryInputKind: string, isUseTemporaryAnswer: boolean, isUseQuotationPackage: boolean, isUseComment: boolean, isUseFieldComment: boolean } | null, attachmentOfferConfig: { __typename?: 'AttachmentOfferConfig', isActiveOnQuotation: boolean } | null }, quotationInquiries: Array<{ __typename?: 'QuotationInquiry', id: string, seqNo: number, title: string, inquiryType: string, unit: string | null, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null }>, uniqFacilityKinds: Array<{ __typename?: 'FacilityKind', id: string, name: string, isUseMaker: boolean, isUseSpec: boolean, isUseLend: boolean, isUseAmortizationNumber: boolean, isUseAmortizationPeriod: boolean, isUsePart: boolean, isUseProcessing: boolean, isUseCavity: boolean, isUseLeadTime: boolean, isUseAmortizationPeriodAsYear: boolean, isUsePaymentTimingKind: boolean, isUseRecuttingCount: boolean }>, previousQuotation: { __typename?: 'Quotation', id: string, uid: string } | null, quotationContext: { __typename?: 'QuotationContext', id: string | null, incoterms: Array<string>, incotermsLabels: Array<string>, ruleOfCurrencyRateChange: Array<string>, ruleOfCurrencyRateChangeLabels: Array<string>, ruleOfMarketChange: Array<string>, ruleOfMarketChangeLabels: Array<string>, requestProcess: Array<string> | null, requestProcessLabels: Array<string> | null, materialPriceReferenceDate: Array<any>, assumedExchangeRateUsd: Array<number>, assumedExchangeRateCny: Array<number>, partSupplyPresenceKind: QuotationContextPartSupplyPresenceKindEnum | null, materialSupplyPresenceKind: QuotationContextMaterialSupplyPresenceKindEnum | null, costBearingDollyKind: QuotationContextCostBearingDollyKindEnum | null, costBearingInitialCostKind: QuotationContextCostBearingInitialCostKindEnum | null, paymentInstallmentInitialCostKind: QuotationContextPaymentInstallmentInitialCostKindEnum | null, paymentMethod: Array<string> | null, paymentMethodLabels: Array<string> | null, massProductionCategory: Array<string> | null, massProductionCategoryLabels: Array<string> | null, modelDepreciation: string | null, materialPriceDateOn: any | null, naphthaDateOn: any | null, naphthaPrice: number | null, currencyRateDisplay1: string | null, currencyRateDisplay2: string | null, currencyRateDisplay3: string | null, deliverySiteName: string | null, materialAndPaintHandlingLabels: Array<string> | null, deliveryCartHandlingLabels: Array<string> | null, equipmentAndToolHandlingLabels: Array<string> | null, deliveryPeriod: string | null, desiredDeliveryDueOn: any | null, comment: string | null, modelDepreciationQuantity: number | null, currencyRate1: number | null, currencyRate2: number | null, currencyRate3: number | null, currency1Id: string | null, currency2Id: string | null, currency3Id: string | null, currencyName1: string | null, currencyName2: string | null, currencyName3: string | null, deliverySiteId: string | null, materialAndPaintHandling: Array<string> | null, deliveryCartHandling: Array<string> | null, equipmentAndToolHandling: Array<string> | null, modelDepreciationTenantUnit: { __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number } | null, modelDepreciationTenantPeriodUnit: { __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string } | null } | null, supplierQuotationPackage: { __typename?: 'SupplierQuotationPackage', id: string, title: string, answerEntryKind: string } | null, attachmentOffers: Array<{ __typename?: 'AttachmentOffer', id: string, isDiscardNecessary: boolean, status: string, kind: string | null, isDownloadable: boolean, attachment: { __typename?: 'Attachment', id: string, nameForSupplier: string | null }, tenant: { __typename?: 'Tenant', id: string } }> } };

export type QuotationsV2QueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  quotationUid?: InputMaybe<Scalars['String']['input']>;
  quotationUids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  partsName?: InputMaybe<Scalars['String']['input']>;
  answerStatus?: InputMaybe<Scalars['String']['input']>;
  progressStatus?: InputMaybe<Scalars['String']['input']>;
  selectionStatus?: InputMaybe<Scalars['String']['input']>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  itemRootCode?: InputMaybe<Scalars['String']['input']>;
  itemName?: InputMaybe<Scalars['String']['input']>;
  requestedOnSince?: InputMaybe<Scalars['ISO8601Date']['input']>;
  requestedOnUntil?: InputMaybe<Scalars['ISO8601Date']['input']>;
  answerDueDateSince?: InputMaybe<Scalars['ISO8601Date']['input']>;
  answerDueDateUntil?: InputMaybe<Scalars['ISO8601Date']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type QuotationsV2Query = { __typename?: 'Query', quotationsV2: { __typename?: 'QuotationConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, nodes: Array<{ __typename?: 'Quotation', id: string, uid: string, status: string, answerDueDate: any | null, announcementKind: string, isUseAnswerExcelImport: boolean, isFromPurchaseReceipt: boolean, tenant: { __typename?: 'Tenant', id: string, name: string }, quotationItemsV2: Array<{ __typename?: 'QuotationItemV2', id: string, quantity: number | null, tenantUnit: { __typename?: 'TenantUnit', name: string } | null, tenantPeriodUnit: { __typename?: 'TenantPeriodUnit', name: string } | null, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string, rootPartCode: string | null, designChangeCode: string | null, figureNumber: string | null }, quotationItemSelection: { __typename?: 'QuotationItemSelection', isSelected: boolean } | null }>, quotationRequest: { __typename?: 'QuotationRequest', id: string, isAnswered: boolean, isDeclined: boolean, answeredAt: any | null, requestedOn: any | null, personInCharge: string, statusForSupplier: string, isCanBeAnswered: boolean, isCanBeDeclined: boolean, supplier: { __typename?: 'Supplier', id: string, code: string, name: string }, answer: { __typename?: 'Answer', status: string, answerPrices: Array<{ __typename?: 'AnswerPrice', unitPrice: number | null }>, currency: { __typename?: 'Currency', displayName: string } | null, answerExcelAttachments: Array<{ __typename?: 'AnswerExcelAttachment', resultMessage: string | null }> } | null }, applicationFormat: { __typename?: 'ApplicationFormat', isSendSelectionMail: boolean }, supplierQuotationPackage: { __typename?: 'SupplierQuotationPackage', id: string, answerEntryKind: string } | null }> } };

export type SelectableSupplierFileClassesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  supplierFileClassId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SelectableSupplierFileClassesQuery = { __typename?: 'Query', selectableSupplierFileClasses: Array<{ __typename?: 'SupplierFileClass', id: string, name: string, order: number, isSatisfyElectronicBookPreservationAct: boolean, canModifyBySupplierFirmInfoConfirmationRequest: boolean, canSupplierEditCrAnswer: boolean, canSupplierDeleteCrAnswer: boolean }> };

export type SelectableTenantsQueryVariables = Exact<{
  kind: Scalars['String']['input'];
}>;


export type SelectableTenantsQuery = { __typename?: 'Query', selectableTenants: { __typename?: 'TenantCandidateConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, nodes: Array<{ __typename?: 'TenantCandidate', id: string, name: string }> } };

export type SelectedTenantQueryVariables = Exact<{
  kind?: InputMaybe<Scalars['String']['input']>;
}>;


export type SelectedTenantQuery = { __typename?: 'Query', selectedTenant: { __typename?: 'Tenant', id: string, name: string, code: string, inOperationScope: boolean, quotationConfig: { __typename?: 'QuotationConfig', isUseQuotationPackage: boolean, isUseTemporaryAnswer: boolean } | null } | null };

export type SharedAnnualTotalsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  supplierCode: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  shareId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SharedAnnualTotalsQuery = { __typename?: 'Query', sharedAnnualTotals: { __typename?: 'SharedAnnualTotalsResult', shareConfigId: string, shareKind: string, supplierId: string, totalCount: number, shareColumns: Array<{ __typename?: 'ShareColumn', id: string, tableName: string, columnName: string, fieldKey: string, displayOrder: number, isShare: boolean }>, shareCommentConfigs: Array<{ __typename?: 'ShareCommentConfig', id: string, fieldName: string, fieldType: string, fieldKey: string, columnName: string, displayOrder: number, isShare: boolean }>, rows: Array<{ __typename?: 'SharedDataRow', id: string, operationKind: string | null, serviceId: string, cells: Array<{ __typename?: 'SharedDataCell', fieldKey: string, displayValue: string }>, commentCells: Array<{ __typename?: 'SharedDataCommentCell', fieldKey: string, fieldType: string, value: any | null }> }> } | null };

export type SharedPartMaterialUsagesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  supplierCode: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  shareId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SharedPartMaterialUsagesQuery = { __typename?: 'Query', sharedPartMaterialUsages: { __typename?: 'SharedPartMaterialUsagesResult', shareConfigId: string, shareKind: string, supplierId: string, totalCount: number, shareColumns: Array<{ __typename?: 'ShareColumn', id: string, tableName: string, columnName: string, fieldKey: string, displayOrder: number, isShare: boolean }>, shareCommentConfigs: Array<{ __typename?: 'ShareCommentConfig', id: string, fieldName: string, fieldType: string, fieldKey: string, columnName: string, displayOrder: number, isShare: boolean }>, rows: Array<{ __typename?: 'SharedDataRow', id: string, operationKind: string | null, serviceId: string, cells: Array<{ __typename?: 'SharedDataCell', fieldKey: string, displayValue: string }>, commentCells: Array<{ __typename?: 'SharedDataCommentCell', fieldKey: string, fieldType: string, value: any | null }> }> } | null };

export type SharedPartStructuresQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  supplierCode: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  shareId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SharedPartStructuresQuery = { __typename?: 'Query', sharedPartStructures: { __typename?: 'SharedPartStructuresResult', shareConfigId: string, shareKind: string, supplierId: string, totalCount: number, shareColumns: Array<{ __typename?: 'ShareColumn', id: string, tableName: string, columnName: string, fieldKey: string, displayOrder: number, isShare: boolean }>, shareCommentConfigs: Array<{ __typename?: 'ShareCommentConfig', id: string, fieldName: string, fieldType: string, fieldKey: string, columnName: string, displayOrder: number, isShare: boolean }>, rows: Array<{ __typename?: 'SharedDataRow', id: string, operationKind: string | null, serviceId: string, cells: Array<{ __typename?: 'SharedDataCell', fieldKey: string, displayValue: string }>, commentCells: Array<{ __typename?: 'SharedDataCommentCell', fieldKey: string, fieldType: string, value: any | null }> }> } | null };

export type SharedPartTransactionsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  supplierCode: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  shareId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SharedPartTransactionsQuery = { __typename?: 'Query', sharedPartTransactions: { __typename?: 'SharedPartTransactionsResult', shareConfigId: string, shareKind: string, supplierId: string, totalCount: number, shareColumns: Array<{ __typename?: 'ShareColumn', id: string, tableName: string, columnName: string, fieldKey: string, displayOrder: number, isShare: boolean }>, shareCommentConfigs: Array<{ __typename?: 'ShareCommentConfig', id: string, fieldName: string, fieldType: string, fieldKey: string, columnName: string, displayOrder: number, isShare: boolean }>, rows: Array<{ __typename?: 'SharedDataRow', id: string, operationKind: string | null, serviceId: string, cells: Array<{ __typename?: 'SharedDataCell', fieldKey: string, displayValue: string }>, commentCells: Array<{ __typename?: 'SharedDataCommentCell', fieldKey: string, fieldType: string, value: any | null }> }> } | null };

export type SharedPartsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  supplierCode: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  shareId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SharedPartsQuery = { __typename?: 'Query', sharedParts: { __typename?: 'SharedPartsResult', shareConfigId: string, shareKind: string, supplierId: string, totalCount: number, shareColumns: Array<{ __typename?: 'ShareColumn', id: string, tableName: string, columnName: string, fieldKey: string, displayOrder: number, isShare: boolean }>, shareCommentConfigs: Array<{ __typename?: 'ShareCommentConfig', id: string, fieldName: string, fieldType: string, fieldKey: string, columnName: string, displayOrder: number, isShare: boolean }>, rows: Array<{ __typename?: 'SharedDataRow', id: string, operationKind: string | null, serviceId: string, cells: Array<{ __typename?: 'SharedDataCell', fieldKey: string, displayValue: string }>, commentCells: Array<{ __typename?: 'SharedDataCommentCell', fieldKey: string, fieldType: string, value: any | null }> }> } | null };

export type SharedUnofficialAnnouncementsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  supplierCode: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  shareId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SharedUnofficialAnnouncementsQuery = { __typename?: 'Query', sharedUnofficialAnnouncements: { __typename?: 'SharedUnofficialAnnouncementsResult', shareConfigId: string, shareKind: string, supplierId: string, totalCount: number, shareColumns: Array<{ __typename?: 'ShareColumn', id: string, tableName: string, columnName: string, fieldKey: string, displayOrder: number, isShare: boolean }>, shareCommentConfigs: Array<{ __typename?: 'ShareCommentConfig', id: string, fieldName: string, fieldType: string, fieldKey: string, columnName: string, displayOrder: number, isShare: boolean }>, rows: Array<{ __typename?: 'SharedDataRow', id: string, operationKind: string | null, serviceId: string, cells: Array<{ __typename?: 'SharedDataCell', fieldKey: string, displayValue: string }>, commentCells: Array<{ __typename?: 'SharedDataCommentCell', fieldKey: string, fieldType: string, value: any | null }> }> } | null };

export type StatesQueryVariables = Exact<{
  countryId: Scalars['ID']['input'];
}>;


export type StatesQuery = { __typename?: 'Query', states: Array<{ __typename?: 'State', id: string, name: string }> };

export type SupplierAccountsQueryVariables = Exact<{
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  withArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SupplierAccountsQuery = { __typename?: 'Query', supplierAccounts: { __typename?: 'SupplierAccountConnection', nodes: Array<{ __typename?: 'SupplierAccount', id: string, name: string, email: string, isArchived: boolean }> } };

export type SupplierAccountsWithInfoQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  includePast?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SupplierAccountsWithInfoQuery = { __typename?: 'Query', supplierAccounts: { __typename?: 'SupplierAccountConnection', nodes: Array<{ __typename?: 'SupplierAccount', hasExistingSceOnTenant: boolean, id: string, name: string, email: string, tel: string, department: string, title: string, languageCode: string, csvExportEncodingKind: SupplierUserCsvExportEncodingKindEnum, tenantMemberAssignments: Array<{ __typename?: 'TenantMemberAssignment', id: string, tenantId: string, tenantName: string, supplierCode: string, startedAt: any, endedAt: any | null, isSendNotification: boolean, isArchived: boolean, isSendSupplierFirmInfoConfirmationRequest: boolean, supplierAccountId: string | null, supplierAccountTenantLinkId: string | null }>, supplierAccountTenantLinks: Array<{ __typename?: 'SupplierAccountTenantLink', id: string, tenant: { __typename?: 'Tenant', id: string, name: string } }> }> } };

export type SupplierAnnouncementsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SupplierAnnouncementsQuery = { __typename?: 'Query', supplierAnnouncements: { __typename?: 'SupplierAnnouncementsView', unreadCount: number, supplierAnnouncements: { __typename?: 'SupplierAnnouncementWithStatusConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, nodes: Array<{ __typename?: 'SupplierAnnouncementWithStatus', isRead: boolean, supplierAnnouncement: { __typename?: 'SupplierAnnouncement', id: string, title: string, content: string, releasedAt: any, linkText: string, linkUrl: string } }> } } };

export type SupplierCorporationQueryVariables = Exact<{ [key: string]: never; }>;


export type SupplierCorporationQuery = { __typename?: 'Query', supplierCorporation: { __typename?: 'SupplierCorporation', id: string, name: string, hasAnswerExcelTemplateAttachment: boolean } | null };

export type SupplierCorporationEmployeesQueryVariables = Exact<{
  withArchived?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<SupplierCorporationEmployeeScopeEnum>;
}>;


export type SupplierCorporationEmployeesQuery = { __typename?: 'Query', supplierCorporationEmployees: { __typename?: 'SupplierCorporationEmployeeConnection', nodes: Array<{ __typename?: 'SupplierCorporationEmployee', id: string, name: string, email: string, isArchived: boolean, supplierAccountTenantLinks: Array<{ __typename?: 'SupplierAccountTenantLink', tenant: { __typename?: 'Tenant', id: string, name: string } }> }> } };

export type SupplierFileClassesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
}>;


export type SupplierFileClassesQuery = { __typename?: 'Query', supplierFileClasses: Array<{ __typename?: 'SupplierFileClass', id: string, name: string, order: number, isSatisfyElectronicBookPreservationAct: boolean, canModifyBySupplierFirmInfoConfirmationRequest: boolean, canSupplierEditCrAnswer: boolean, canSupplierDeleteCrAnswer: boolean }> };

export type SupplierFileInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
}>;


export type SupplierFileInfoQuery = { __typename?: 'Query', supplierFileInfo: { __typename?: 'SupplierFileInfo', id: string, isActive: boolean, isArchived: boolean, expirationDateFrom: any | null, expirationDateTo: any | null, registeredAt: any, registeredBy: string | null, memo: string | null, supplierFileClass: { __typename?: 'SupplierFileClass', id: string, name: string, order: number, isSatisfyElectronicBookPreservationAct: boolean, canModifyBySupplierFirmInfoConfirmationRequest: boolean, canSupplierEditCrAnswer: boolean, canSupplierDeleteCrAnswer: boolean }, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } } | null };

export type SupplierFileInfosQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  supplierFileClassId?: InputMaybe<Scalars['ID']['input']>;
  searchKeywords?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SupplierFileInfosQuery = { __typename?: 'Query', supplierFileInfos: { __typename?: 'SupplierFileInfoConnection', totalCount: number, countByClass: any, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, nodes: Array<{ __typename?: 'SupplierFileInfo', id: string, isActive: boolean, isArchived: boolean, expirationDateFrom: any | null, expirationDateTo: any | null, registeredAt: any, registeredBy: string | null, memo: string | null, supplierFileClass: { __typename?: 'SupplierFileClass', id: string, name: string, order: number, isSatisfyElectronicBookPreservationAct: boolean, canModifyBySupplierFirmInfoConfirmationRequest: boolean, canSupplierEditCrAnswer: boolean, canSupplierDeleteCrAnswer: boolean }, attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } } | null> | null } };

export type SupplierFirmInfoConfirmationRequestQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SupplierFirmInfoConfirmationRequestQuery = { __typename?: 'Query', supplierFirmInfoConfirmationRequest: { __typename?: 'SupplierFirmInfoConfirmationRequest', id: string, confirmationRequestNo: string, status: SupplierFirmInfoConfirmationRequestStatusEnum, surveyYear: number, answerDate: any | null, answerer: string | null, requestDate: any, dueDate: any, canInputAnswer: boolean, canShowAnswer: boolean, isBasicInfoSelected: boolean, isContactInfoSelected: boolean, isSurveyInfoSelected: boolean, isBusinessBaseInfoSelected: boolean, isEquipmentInfoSelected: boolean, isOutsourcingInfoSelected: boolean, isFileInfoSelected: boolean, isOverdue: boolean, remandComment: string | null, contactName: string | null, contactEmail: string | null, contactTel: string | null, remandedBy: string | null, remandDate: any | null, withdrawnDate: any | null, withdrawnBy: string | null, fileName: string | null, signedUrl: string | null, answerKind: SupplierFirmInfoConfirmationRequestAnswerKindEnum, tenant: { __typename?: 'Tenant', id: string, name: string, code: string }, supplierFirmInfoConfirmationRequestDestinations: Array<{ __typename?: 'SupplierFirmInfoConfirmationRequestDestination', id: string, supplyChainCompanyEmployeeName: string | null, supplyChainCompanyEmployeeEmail: string | null }> } };

export type SupplierFirmInfoConfirmationRequestsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['ID']['input'];
  confirmationRequestNo?: InputMaybe<Scalars['String']['input']>;
  notificationTargets?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  statuses?: InputMaybe<Array<SupplierFirmInfoConfirmationRequestStatusEnum> | SupplierFirmInfoConfirmationRequestStatusEnum>;
  surveyYears?: InputMaybe<Scalars['String']['input']>;
  answerDateFrom?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  answerDateTo?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}>;


export type SupplierFirmInfoConfirmationRequestsQuery = { __typename?: 'Query', supplierFirmInfoConfirmationRequests: { __typename?: 'SupplierFirmInfoConfirmationRequestConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, nodes: Array<{ __typename?: 'SupplierFirmInfoConfirmationRequest', id: string, confirmationRequestNo: string, status: SupplierFirmInfoConfirmationRequestStatusEnum, surveyYear: number, answerDate: any | null, answerer: string | null, requestDate: any, dueDate: any, canInputAnswer: boolean, canShowAnswer: boolean, isBasicInfoSelected: boolean, isContactInfoSelected: boolean, isSurveyInfoSelected: boolean, isBusinessBaseInfoSelected: boolean, isEquipmentInfoSelected: boolean, isOutsourcingInfoSelected: boolean, isFileInfoSelected: boolean, isOverdue: boolean, remandComment: string | null, contactName: string | null, contactEmail: string | null, contactTel: string | null, remandedBy: string | null, remandDate: any | null, withdrawnDate: any | null, withdrawnBy: string | null, fileName: string | null, signedUrl: string | null, answerKind: SupplierFirmInfoConfirmationRequestAnswerKindEnum, tenant: { __typename?: 'Tenant', id: string, name: string, code: string }, supplierFirmInfoConfirmationRequestDestinations: Array<{ __typename?: 'SupplierFirmInfoConfirmationRequestDestination', id: string, supplyChainCompanyEmployeeName: string | null, supplyChainCompanyEmployeeEmail: string | null }> }> } };

export type SupplierMoldStorageApplicationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SupplierMoldStorageApplicationQuery = { __typename?: 'Query', supplierMoldStorageApplication: { __typename?: 'SupplierMoldStorageApplication', id: string, uid: string, status: number, applicationDate: any, confirmationDueDate: any, approvalDate: any | null, comment: string, remandComment: string | null, title: string, createdAt: any, updatedAt: any, supplier: { __typename?: 'Supplier', id: string, name: string, code: string }, employee: { __typename?: 'Employee', id: string, name: string }, tenant: { __typename?: 'Tenant', id: string, name: string, code: string }, supplierAccount: { __typename?: 'SupplierAccount', id: string, name: string } | null, supplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> | null, supplierMoldStorageApplicationDetails: Array<{ __typename?: 'SupplierMoldStorageApplicationDetail', id: string, storageCost: number | null, storageStartDate: any | null, publicMemo: string | null, createdAt: any, updatedAt: any, mold: { __typename?: 'Mold', id: string, uid: string, tenantId: string, name: string, width: number | null, depth: number | null, height: number | null, weight: number | null, isNew: boolean | null, isPermanent: boolean | null, manageableId: string | null, manageableType: string | null, publicMemo: string | null, storageLocation: string | null, category: string | null, assetNumber: string | null, storageSymbol: string | null, status: string | null, evidenceComment: string | null, paymentEvidenceComment: string | null, storageEvidenceComment: string | null, disposeEvidenceComment: string | null, supplierDisposeReportComment: string | null, supplierDisposeReportedAt: any | null, employee: { __typename?: 'Employee', id: string, name: string }, supplier: { __typename?: 'Supplier', id: string, name: string, code: string, adminUser: { __typename?: 'AdminUser', id: string, name: string, employee: { __typename?: 'Employee', id: string, name: string } | null } | null }, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string } | null, manageable: { __typename?: 'MoldManageable', id: string, name: string, code: string } | null, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, paymentAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, storageAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, disposeAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierDisposeReportAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, moldStartUp: { __typename?: 'MoldStartUp', id: string, tenantId: string, moldId: string, quotedCost: number | null, acquisitionCost: number | null }, moldProduction: { __typename?: 'MoldProduction', id: string, tenantId: string, moldId: string, outputPerShot: number | null, shotCount: number | null, cumulativePartTransaction: number | null, remainingShotCount: number | null, flowTendency: number | null }, moldStorage: { __typename?: 'MoldStorage', id: string, tenantId: string, moldId: string, storageCost: number | null, retroactivePrice: number | null }, moldDispose: { __typename?: 'MoldDispose', id: string, tenantId: string, moldId: string, disposeCost: number | null, scrapCost: number | null, disposeRequestDate: any | null }, moldLifecycleEvent: { __typename?: 'MoldLifecycleEvent', id: string, tenantId: string, moldId: string, operationStartDate: any | null, inspectionReceiptDate: any | null, productionStartNotificationReceiptDate: any | null, quoteStatementReceiptDate: any | null, storageStartDate: any | null, disposeDate: any | null }, moldUsages: Array<{ __typename?: 'MoldUsage', id: string, moldId: string, targettableType: string | null, targettable: { __typename?: 'Part', id: string, name: string, code: string | null, figureNumber: string | null, rootPartCode: string | null, totalReceivedQuantity: number | null, flowTendency: string | null, partAnnualTotal: { __typename?: 'PartAnnualTotal', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number, quantity4: number, quantity5: number, quantity6: number, quantity7: number, quantity8: number, quantity9: number, quantity10: number, quantity11: number, quantity12: number } | null, partUnofficialAnnouncement: { __typename?: 'PartUnofficialAnnouncement', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number } | null, partTransactions: Array<{ __typename?: 'PartTransaction', id: string, tenantId: string, orderNumber: string | null, orderSeqNo: number | null, receivedOn: any | null, unitPrice: number, receivedQuantity: number, checkNumber: string | null, checkSeqNo: number | null, checkDate: any, subtotal: number, currencyRate: number, part: { __typename?: 'Part', id: string, name: string, code: string | null }, supplier: { __typename?: 'Supplier', id: string, name: string, isTemporary: boolean, code: string }, currency: { __typename?: 'Currency', isBaseCurrency: boolean, currencyCode: string }, toJpy: { __typename?: 'PartTransactionJpy', subtotal: number, unitPrice: number } }> | null } | null }> } }> | null } | null };

export type SupplierMoldStorageApplicationsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  applicationNo?: InputMaybe<Scalars['String']['input']>;
  moldNo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SupplierMoldStorageApplicationsQuery = { __typename?: 'Query', supplierMoldStorageApplications: { __typename?: 'SupplierMoldStorageApplicationConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, nodes: Array<{ __typename?: 'SupplierMoldStorageApplication', id: string, uid: string, status: number, applicationDate: any, confirmationDueDate: any, approvalDate: any | null, comment: string, remandComment: string | null, title: string, createdAt: any, updatedAt: any, supplier: { __typename?: 'Supplier', id: string, name: string, code: string }, employee: { __typename?: 'Employee', id: string, name: string }, tenant: { __typename?: 'Tenant', id: string, name: string, code: string }, supplierAccount: { __typename?: 'SupplierAccount', id: string, name: string } | null, supplierUser: { __typename?: 'SupplierUser', id: string, name: string } | null, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> | null, supplierMoldStorageApplicationDetails: Array<{ __typename?: 'SupplierMoldStorageApplicationDetail', id: string, storageCost: number | null, storageStartDate: any | null, publicMemo: string | null, createdAt: any, updatedAt: any, mold: { __typename?: 'Mold', id: string, uid: string, tenantId: string, name: string, width: number | null, depth: number | null, height: number | null, weight: number | null, isNew: boolean | null, isPermanent: boolean | null, manageableId: string | null, manageableType: string | null, publicMemo: string | null, storageLocation: string | null, category: string | null, assetNumber: string | null, storageSymbol: string | null, status: string | null, evidenceComment: string | null, paymentEvidenceComment: string | null, storageEvidenceComment: string | null, disposeEvidenceComment: string | null, supplierDisposeReportComment: string | null, supplierDisposeReportedAt: any | null, employee: { __typename?: 'Employee', id: string, name: string }, supplier: { __typename?: 'Supplier', id: string, name: string, code: string, adminUser: { __typename?: 'AdminUser', id: string, name: string, employee: { __typename?: 'Employee', id: string, name: string } | null } | null }, weightTenantUnit: { __typename?: 'TenantUnit', id: string, name: string } | null, manageable: { __typename?: 'MoldManageable', id: string, name: string, code: string } | null, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, paymentAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, storageAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, disposeAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, supplierDisposeReportAttachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }>, moldStartUp: { __typename?: 'MoldStartUp', id: string, tenantId: string, moldId: string, quotedCost: number | null, acquisitionCost: number | null }, moldProduction: { __typename?: 'MoldProduction', id: string, tenantId: string, moldId: string, outputPerShot: number | null, shotCount: number | null, cumulativePartTransaction: number | null, remainingShotCount: number | null, flowTendency: number | null }, moldStorage: { __typename?: 'MoldStorage', id: string, tenantId: string, moldId: string, storageCost: number | null, retroactivePrice: number | null }, moldDispose: { __typename?: 'MoldDispose', id: string, tenantId: string, moldId: string, disposeCost: number | null, scrapCost: number | null, disposeRequestDate: any | null }, moldLifecycleEvent: { __typename?: 'MoldLifecycleEvent', id: string, tenantId: string, moldId: string, operationStartDate: any | null, inspectionReceiptDate: any | null, productionStartNotificationReceiptDate: any | null, quoteStatementReceiptDate: any | null, storageStartDate: any | null, disposeDate: any | null }, moldUsages: Array<{ __typename?: 'MoldUsage', id: string, moldId: string, targettableType: string | null, targettable: { __typename?: 'Part', id: string, name: string, code: string | null, figureNumber: string | null, rootPartCode: string | null, totalReceivedQuantity: number | null, flowTendency: string | null, partAnnualTotal: { __typename?: 'PartAnnualTotal', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number, quantity4: number, quantity5: number, quantity6: number, quantity7: number, quantity8: number, quantity9: number, quantity10: number, quantity11: number, quantity12: number } | null, partUnofficialAnnouncement: { __typename?: 'PartUnofficialAnnouncement', id: string, tenantId: string, partId: string, supplierId: string, isActive: boolean, recordedOn: any, quantity1: number, quantity2: number, quantity3: number } | null, partTransactions: Array<{ __typename?: 'PartTransaction', id: string, tenantId: string, orderNumber: string | null, orderSeqNo: number | null, receivedOn: any | null, unitPrice: number, receivedQuantity: number, checkNumber: string | null, checkSeqNo: number | null, checkDate: any, subtotal: number, currencyRate: number, part: { __typename?: 'Part', id: string, name: string, code: string | null }, supplier: { __typename?: 'Supplier', id: string, name: string, isTemporary: boolean, code: string }, currency: { __typename?: 'Currency', isBaseCurrency: boolean, currencyCode: string }, toJpy: { __typename?: 'PartTransactionJpy', subtotal: number, unitPrice: number } }> | null } | null }> } }> | null }> } };

export type SupplierOutsourcingClassesQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
}>;


export type SupplierOutsourcingClassesQuery = { __typename?: 'Query', supplierOutsourcingClasses: Array<{ __typename?: 'SupplierOutsourcingClass', id: string, code: string | null, name: string, order: number, isArchived: boolean }> };

export type SupplierQuotationPackageCountByStatusQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
}>;


export type SupplierQuotationPackageCountByStatusQuery = { __typename?: 'Query', supplierQuotationPackageCountByStatus: { __typename?: 'SupplierQuotationPackageStatusCount', all: number, notAnswered: number, overdue: number, answered: number } };

export type SupplierQuotationPackagesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['ID']['input'];
}>;


export type SupplierQuotationPackagesQuery = { __typename?: 'Query', supplierQuotationPackages: { __typename?: 'SupplierQuotationPackageConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, nodes: Array<{ __typename?: 'SupplierQuotationPackage', id: string, title: string, answerEntryKind: string, answerStatusText: string, firstQuotation: { __typename?: 'Quotation', id: string, status: string, answerDueDate: any | null, isFromPurchaseReceipt: boolean } | null, firstQuotationItem: { __typename?: 'QuotationItemV2', id: string, quantity: number | null, itemRequirement: { __typename?: 'ItemRequirement', code: string | null, name: string } } | null, firstQuotationAdminUser: { __typename?: 'AdminUser', id: string, name: string } | null, firstQuotationRequest: { __typename?: 'QuotationRequest', id: string, requestedOn: any | null, supplier: { __typename?: 'Supplier', code: string, name: string } } | null, quotations: Array<{ __typename?: 'Quotation', id: string, uid: string, isFromPurchaseReceipt: boolean, isUseAnswerExcelImport: boolean, quotationRequest: { __typename?: 'QuotationRequest', id: string, isCanBeDeclined: boolean }, quotationItemsV2: Array<{ __typename?: 'QuotationItemV2', id: string }> }> }> } };

export type SupplierScreenItemConfigsQueryVariables = Exact<{
  componentId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
}>;


export type SupplierScreenItemConfigsQuery = { __typename?: 'Query', supplierScreenItemConfigs: Array<{ __typename?: 'SupplierScreenItemConfig', componentId: string, itemId: string, visible: boolean, order: number }> };

export type SupplierScreenSurveyInfoConfigsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
}>;


export type SupplierScreenSurveyInfoConfigsQuery = { __typename?: 'Query', supplierScreenSurveyInfoConfigs: Array<{ __typename?: 'SupplierScreenSurveyInfoConfig', componentId: string, visible: boolean, order: number, width: number }> };

export type SupplierSurveyInfoImportConfigQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
}>;


export type SupplierSurveyInfoImportConfigQuery = { __typename?: 'Query', supplierSurveyInfoImportConfig: { __typename?: 'SupplierSurveyInfoImportConfig', attachment: { __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any } | null } | null };

export type SupplierOptionsQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
}>;


export type SupplierOptionsQuery = { __typename?: 'Query', supplierOptions: Array<{ __typename?: 'SupplierOption', supplierId: string, supplierCode: string, supplierName: string, tenantId: string }> };

export type TenantQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includePast?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TenantQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', id: string, name: string, code: string, manualUrl: string | null, supplierCodesForFirm: Array<string>, supplierAccounts: Array<{ __typename?: 'SupplierAccount', id: string, name: string, email: string, tel: string, department: string, title: string, languageCode: string, csvExportEncodingKind: SupplierUserCsvExportEncodingKindEnum, tenantMemberAssignments: Array<{ __typename?: 'TenantMemberAssignment', id: string, tenantId: string, tenantName: string, supplierCode: string, startedAt: any, endedAt: any | null, isSendNotification: boolean, isArchived: boolean, isSendSupplierFirmInfoConfirmationRequest: boolean, supplierAccountId: string | null, supplierAccountTenantLinkId: string | null }>, supplierAccountTenantLinks: Array<{ __typename?: 'SupplierAccountTenantLink', id: string, tenant: { __typename?: 'Tenant', id: string, name: string } }> }>, quotationConfig: { __typename?: 'QuotationConfig', isUseQuotationPackage: boolean, isUseTemporaryAnswer: boolean } | null } | null };

export type TenantCandidateCountQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantCandidateCountQuery = { __typename?: 'Query', tenantCandidates: { __typename?: 'TenantCandidateConnection', totalCount: number } };

export type TenantCandidatesQueryVariables = Exact<{
  kind?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantCandidatesQuery = { __typename?: 'Query', tenantCandidates: { __typename?: 'TenantCandidateConnection', nodes: Array<{ __typename?: 'TenantCandidate', id: string, name: string, inOperationScope: boolean, supplierCodes: Array<string> }> } };

export type TenantDirectoriesQueryVariables = Exact<{
  firmName?: InputMaybe<Scalars['String']['input']>;
  supplierAccountId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TenantDirectoriesQuery = { __typename?: 'Query', tenantDirectories: { __typename?: 'TenantDirectoryConnection', nodes: Array<{ __typename?: 'TenantDirectory', memberCount: number, tenant: { __typename?: 'Tenant', id: string, name: string }, manuals: Array<{ __typename?: 'TenantSupplierManual', supplierCode: string, supplierId: string, supplierName: string, url: string }> }> } };

export type TenantDirectoryDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includePast?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TenantDirectoryDetailQuery = { __typename?: 'Query', tenantDirectory: { __typename?: 'TenantDirectoryDetail', allowedSupplierCodes: Array<string>, memberCount: number, manuals: Array<{ __typename?: 'TenantSupplierManual', supplierCode: string, supplierId: string, supplierName: string, url: string }>, tenant: { __typename?: 'Tenant', id: string, name: string }, supplierAccounts: Array<{ __typename?: 'SupplierAccount', id: string, name: string, email: string, tenantMemberAssignments: Array<{ __typename?: 'TenantMemberAssignment', id: string, tenantId: string, tenantName: string, supplierCode: string, startedAt: any, endedAt: any | null, isSendNotification: boolean, isArchived: boolean, isSendSupplierFirmInfoConfirmationRequest: boolean, supplierAccountId: string | null, supplierAccountTenantLinkId: string | null }> }> } | null };

export type TenantPeriodUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantPeriodUnitsQuery = { __typename?: 'Query', tenantPeriodUnits: Array<{ __typename?: 'TenantPeriodUnit', id: string, periodUnitKind: string, name: string }> };

export type TenantQuotationConfigQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
}>;


export type TenantQuotationConfigQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', id: string, quotationConfig: { __typename?: 'QuotationConfig', isUseQuotationPackage: boolean, isUseAnswerExcelMultipleSupplementalAttachments: boolean } | null } | null };

export type TenantSelectQueryVariables = Exact<{
  nitoelSelectId: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
}>;


export type TenantSelectQuery = { __typename?: 'Query', tenantSelect: { __typename?: 'TenantSelect', tenantSelectOptions: Array<{ __typename?: 'TenantSelectOption', id: string, label: string, longLabel: string | null }> } | null };

export type TenantSelectOptionsQueryVariables = Exact<{
  nitoelSelectId: Scalars['String']['input'];
}>;


export type TenantSelectOptionsQuery = { __typename?: 'Query', tenantSelectOptions: Array<{ __typename?: 'TenantSelectOption', id: string, label: string }> };

export type TenantUnitsQueryVariables = Exact<{
  unitKind?: InputMaybe<UnitKindEnum>;
}>;


export type TenantUnitsQuery = { __typename?: 'Query', tenantUnits: Array<{ __typename?: 'TenantUnit', id: string, unitCode: string, name: string, order: number }> };

export type TenantConfigQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
}>;


export type TenantConfigQuery = { __typename?: 'Query', tenantConfig: { __typename?: 'TenantConfig', tenantId: string, currencyCode: string, isUseTrialPurchaseRequest: boolean, isUsePurchaseRequest: boolean } | null };

export type TenantsForPriceAdjustmentQueryVariables = Exact<{
  firmName?: InputMaybe<Scalars['String']['input']>;
  supplierUserId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TenantsForPriceAdjustmentQuery = { __typename?: 'Query', tenants: { __typename?: 'TenantCandidateConnection', nodes: Array<{ __typename?: 'TenantCandidate', id: string, name: string }> } };

export type TrialQuotationAnswerSheetQueryVariables = Exact<{
  quotationId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  supplierCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type TrialQuotationAnswerSheetQuery = { __typename?: 'Query', trialQuotationAnswerSheet: { __typename?: 'TrialQuotationAnswerSheet', quotationId: string, quotationRequestId: string, title: string, unitOptions: Array<string>, answerDueDate: any | null, requestDueDate: any | null, requestText: string | null, tenantName: string, supplierCode: string, supplierName: string, isCanBeAnswered: boolean, isTrialSelectionLocked: boolean, isFacility: boolean, baseRevisionNo: number, requestAttachments: Array<{ __typename?: 'TrialQuotationRequestAttachment', id: string, seqNo: number, fileName: string, byteSize: number, downloadUrl: string }>, items: Array<{ __typename?: 'TrialQuotationAnswerSheetItem', quotationItemId: string, seqNo: number, name: string, makerName: string, makerModel: string, quantity: number, unitName: string | null }>, latestAnswer: { __typename?: 'TrialQuotationAnswer', id: string, revisionNo: number, state: number, isDeclined: boolean, answerMemo: string, deliveryOn: any | null, quotationValidUntil: any | null, submittedAt: any, items: Array<{ __typename?: 'TrialQuotationAnswerItem', quotationItemId: string, seqNo: number, breakdownSeqNo: number, name: string, makerName: string, makerModel: string, quantity: number | null, unitName: string, taxType: number, unitPrice: number | null, isDeclined: boolean }>, attachments: Array<{ __typename?: 'TrialQuotationAnswerAttachment', id: string, attachmentKind: number, seqNo: number, fileName: string, contentType: string, byteSize: number, url: string, downloadUrl: string }> } | null, answers: Array<{ __typename?: 'TrialQuotationAnswer', id: string, revisionNo: number, state: number, isDeclined: boolean, answerMemo: string, deliveryOn: any | null, quotationValidUntil: any | null, submittedAt: any, items: Array<{ __typename?: 'TrialQuotationAnswerItem', quotationItemId: string, seqNo: number, breakdownSeqNo: number, name: string, makerName: string, makerModel: string, quantity: number | null, unitName: string, taxType: number, unitPrice: number | null, isDeclined: boolean }>, attachments: Array<{ __typename?: 'TrialQuotationAnswerAttachment', id: string, attachmentKind: number, seqNo: number, fileName: string, contentType: string, byteSize: number, url: string, downloadUrl: string }> }> } };

export type UnconfirmedDeliveredAnnouncementsQueryVariables = Exact<{ [key: string]: never; }>;


export type UnconfirmedDeliveredAnnouncementsQuery = { __typename?: 'Query', deliveredAnnouncements: { __typename?: 'DeliveredAnnouncementConnection', totalCount: number, nodes: Array<{ __typename?: 'DeliveredAnnouncement', id: string, confirmedAt: any | null, viewedAt: any | null, tenant: { __typename?: 'Tenant', name: string }, announcement: { __typename?: 'Announcement', body: string, confirmationDeadline: any | null, displayFrom: any, displayTo: any, id: string, priority: AnnouncementPriorityEnum, status: AnnouncementStatusEnum, title: string, tenantId: number, applicantUser: { __typename?: 'AdminUser', name: string }, attachments: Array<{ __typename?: 'Attachment', url: string, name: string, fileType: string | null, size: number | null, signedUrl: string, signedDownloadUrl: string | null, thumbnailSignedUrl: string | null, pdfPreviewSignedUrl: string | null, updatedAt: any }> } }> } };

export const TenantUnitForAnswerFieldFragmentDoc = gql`
    fragment TenantUnitForAnswerField on TenantUnit {
  name
  unitCode
  unit {
    symbol
    conversionRate
  }
}
    `;
export const AnswerExcelImportAnswerPriceFieldFragmentDoc = gql`
    fragment AnswerExcelImportAnswerPriceField on AnswerPriceExcelResultV2 {
  quotationItemId
  partId
  quantity
  unitPrice
  materialCost
  partsCost
  processingCost
  materialManagementCost
  materialManagementRate
  processingManagementCost
  processingManagementRate
  managementCost
  quantityInOneBox
  deliveryCostPerBox
  boxCount
  deliveryCost
  packingCostPerBox
  packingCost
  defectCost
  defectRate
  profit
  adjustment
  profitRate
  depreciation
  internalPartSubtotal
  outSourcePartSubtotal
  outSourcePartManagementRate
  paidSupplyPartSubtotal
  deliveryDay
  initialDeliveryDay
  materialDeliveryDay
  materialDeliveryStartDay
  equipmentDeliveryDay
  equipmentDeliveryStartDay
  moldDeliveryDay
  moldDeliveryStartDay
  trialDeliveryDay
  trialDeliveryStartDay
  subsidiaryMaterialCost
  surfaceProcessingCost
  partRelatedFacilityCost
  propertyRentCost
  jigManagementCost
  facilityCost
  designCost
  subsidiaryMaterialManagementRate
  subsidiaryMaterialManagementCost
  quotationItemChildStructId
  answerPartsCosts {
    procurementKind
    seqNo
    partNo
    partName
    productionPlace
    partSpec
    partsCount
    quantity
    partsUnitPrice
    memo
    partsCost
  }
  answerMaterialCosts {
    seqNo
    materialName
    thickness
    width
    height
    measure
    weightBeforeProcess
    weightAfterProcess
    basePrice
    adjustment
    materialCostSubtotal
    scrapValueSubtotal
    procurementKind
    materialCost
    cavity
    scrap1Name
    scrap1Weight
    scrap1UnitPrice
    scrap1Subtotal
    scrap2Name
    scrap2Weight
    scrap2UnitPrice
    scrap2Subtotal
    memo
    weightTenantUnit {
      ...TenantUnitForAnswerField
    }
    priceTenantUnit {
      ...TenantUnitForAnswerField
    }
    baseMaterialCode
    quantity
    materialCostSubtotalPerQty
    scrap1SubtotalPerQty
    scrap2SubtotalPerQty
    scrapValueSubtotalPerQty
    materialCostPerQty
    blendPrimaryMaterialName
    blendPrimaryMaterialRatio
    blendPrimaryMaterialUnitCost
    blendSecondaryMaterialName
    blendSecondaryMaterialRatio
    blendSecondaryMaterialUnitCost
    blendOtherMaterialName
    blendOtherMaterialRatio
    blendOtherMaterialUnitCost
    blendBaseUnitCost
    blendUnitCostMarkupRatio
    lossPurgeLotCount
    lossPurgeTotalWeight
    lossPurgeUnitUsage
    lossPurgeCost
    lossGateUnitUsage
    lossGateCost
    lossRunnerUnitUsage
    lossRunnerCost
    lossOtherMemo
    lossOtherUnitUsage
    lossOtherCost
    lossTotalUnitUsage
    lossTotalCost
    trialShotUnitUsage
    trialShotCost
    adjustmentCostMemo
    adjustmentCost
  }
  answerProcessingCosts {
    seqNo
    processName
    productionLot
    equipmentName
    processingTimeHour
    processingTimeMinute
    processingTimeSecond
    processingRate
    processingCostSubtotal
    setupTimeHour
    setupTimeMinute
    setupTimeSecond
    setupRate
    processingTimes
    setupCostSubtotal
    memo
    processingCost
    rateKind
    processingWeight
    costForWeight
    processingHeadcount
    processOutsourcingKind
    processingCostSubtotalPerLot
    setupCostSubtotalPerLot
    processingCostPerLot
    partCostRatio
    weightTenantUnit {
      ...TenantUnitForAnswerField
    }
    answerFacilityCost {
      facilityKind {
        id
        name
      }
      name
      maker
      spec
      quantity
      facilityUnitPrice
      facilityCost
      isLend
      amortizationNumber
      amortizationPeriod
      cavity
      leadTime
      memo
      amortizationPeriodAsYear
      paymentTimingKind
      recuttingCount
      amortizationNumberPerPeriod
      amortizationPeriodAsNum
    }
  }
  answerSpecialProcessingCosts {
    kind
    seqNo
    productionLot
    processName
    equipmentName
    processingTimeHour
    processingTimeMinute
    processingTimeSecond
    processingRate
    processingCostSubtotal
    setupTimeHour
    setupTimeMinute
    setupTimeSecond
    setupRate
    processingTimes
    setupCostSubtotal
    processingCost
    memo
    rateKind
  }
  answerSubsidiaryMaterialCosts {
    seqNo
    name
    unitPrice
    quantity
    subsidiaryMaterialCost
    note
    totalQuantity
    totalSubsidiaryMaterialCost
    amortizationNumberPerPeriod
    amortizationPeriodAsNum
  }
}
    ${TenantUnitForAnswerFieldFragmentDoc}`;
export const SupplierAccountFieldFragmentDoc = gql`
    fragment SupplierAccountField on SupplierAccount {
  id
  name
}
    `;
export const AttachmentOfferFieldFragmentDoc = gql`
    fragment AttachmentOfferField on AttachmentOffer {
  id
  uid
  itemRootCode
  itemName
  itemCode
  designChangeCode
  figureNumber
  purpose
  isDiscardNecessary
  discardDeadlineOn
  status
  isDownloadable
  previewUrl
  latestAcknowledgedAt
  memo
  tenant {
    id
    name
  }
  supplier {
    code
    name
  }
  personInChargeAdminUser {
    id
    name
  }
  offeredAt
  attachment {
    id
    name
    nameForSupplier
  }
  discardEvent {
    createdAt
    supplierAccount {
      ...SupplierAccountField
    }
    supplierUser {
      id
      name
    }
  }
  downloadEvents {
    id
  }
  quotationItem {
    id
    quotation {
      id
      uid
    }
    project {
      id
    }
  }
}
    ${SupplierAccountFieldFragmentDoc}`;
export const AttachmentOfferListFieldFragmentDoc = gql`
    fragment AttachmentOfferListField on AttachmentOffer {
  id
  uid
  itemRootCode
  itemCode
  itemName
  figureNumber
  status
  isDownloadable
  latestAcknowledgedAt
  attachment {
    id
    name
    nameForSupplier
  }
  personInChargeAdminUser {
    id
    name
  }
  discardDeadlineOn
  offeredAt
  isDiscardNecessary
  discardEvent {
    createdAt
    supplierAccount {
      ...SupplierAccountField
    }
    supplierUser {
      id
      name
    }
  }
  downloadEvents {
    id
  }
  tenant {
    id
  }
  supplier {
    id
    code
    name
  }
}
    ${SupplierAccountFieldFragmentDoc}`;
export const BcpAnswerTokenCategoriesFieldFragmentDoc = gql`
    fragment BcpAnswerTokenCategoriesField on BcpIncidentAnswerTokenCategories {
  humanDamageLevel
  humanDamageComment
  buildingDamageLevel
  buildingDamageComment
  equipmentDamageLevel
  equipmentDamageComment
  productionImpactLevel
  productionImpactComment
  deliveryImpactLevel
  deliveryImpactComment
}
    `;
export const AttachmentFieldFragmentDoc = gql`
    fragment AttachmentField on Attachment {
  url
  name
  fileType
  size
  signedUrl
  signedDownloadUrl
  thumbnailSignedUrl
  pdfPreviewSignedUrl
  updatedAt
}
    `;
export const CommentNodeFieldFragmentDoc = gql`
    fragment CommentNodeField on CommentNode {
  id
  body
  parentId
  authorAdminUserId
  authorAdminUserName
  authorSupplierAccountId
  authorSupplierAccountName
  authorSupplierUserId
  authorSupplierUserName
  targetKind
  supplierId
  deletedAt
  canEdit
  canDelete
  attachments {
    ...AttachmentField
  }
  createdAt
  updatedAt
  supplierUserInfoCommentConfirmations {
    id
    supplierUserInfoId
    confirmedAt
    supplierUserInfo {
      id
      supplierUserId
    }
    supplyChainCompanyEmployeeName
  }
  userCommentConfirmations {
    id
    adminUserId
    confirmedAt
    adminUser {
      id
      name
    }
  }
}
    ${AttachmentFieldFragmentDoc}`;
export const CommentBaseFieldFragmentDoc = gql`
    fragment CommentBaseField on CommentBase {
  id
  commentKind
  targetId
  itemKind
  commentNodes {
    ...CommentNodeField
  }
  createdAt
  updatedAt
}
    ${CommentNodeFieldFragmentDoc}`;
export const CrSupplierFirmBankInfoFieldFragmentDoc = gql`
    fragment CrSupplierFirmBankInfoField on CrSupplierFirmBankInfo {
  id
  isArchived
  financialInstitutionName
  branchName
  borrowingRatio
  memo
}
    `;
export const CrSupplierFirmBankInfoWithBeforeFieldFragmentDoc = gql`
    fragment CrSupplierFirmBankInfoWithBeforeField on CrSupplierFirmBankInfo {
  ...CrSupplierFirmBankInfoField
  before {
    ...CrSupplierFirmBankInfoField
  }
}
    ${CrSupplierFirmBankInfoFieldFragmentDoc}`;
export const CrSupplierFirmCertificationInfoFieldFragmentDoc = gql`
    fragment CrSupplierFirmCertificationInfoField on CrSupplierFirmCertificationInfo {
  id
  isArchived
  certificationClass {
    id
    name
    certificationStandard
  }
  acquisitionDate
  expirationDate
  isRelatedToOwnCompany
  certificationAuthorityName
  certificationNumber
  updateDate
  revisionDate
  memo
}
    `;
export const CrSupplierFirmCertificationInfoWithBeforeFieldFragmentDoc = gql`
    fragment CrSupplierFirmCertificationInfoWithBeforeField on CrSupplierFirmCertificationInfo {
  ...CrSupplierFirmCertificationInfoField
  before {
    ...CrSupplierFirmCertificationInfoField
  }
}
    ${CrSupplierFirmCertificationInfoFieldFragmentDoc}`;
export const CrSupplierFirmEmployeeNumberInfoFieldFragmentDoc = gql`
    fragment CrSupplierFirmEmployeeNumberInfoField on CrSupplierFirmEmployeeNumberInfo {
  id
  isArchived
  supplierEmployeeClass {
    id
    name
  }
  numberOfEmployees
  numberOfEmployeesMan
  numberOfEmployeesWoman
  showGenderBreakdown
}
    `;
export const CrSupplierFirmEmployeeNumberInfoWithBeforeFieldFragmentDoc = gql`
    fragment CrSupplierFirmEmployeeNumberInfoWithBeforeField on CrSupplierFirmEmployeeNumberInfo {
  ...CrSupplierFirmEmployeeNumberInfoField
  before {
    ...CrSupplierFirmEmployeeNumberInfoField
  }
}
    ${CrSupplierFirmEmployeeNumberInfoFieldFragmentDoc}`;
export const CrSupplierFirmEquipmentInfoFieldFragmentDoc = gql`
    fragment CrSupplierFirmEquipmentInfoField on CrSupplierFirmEquipmentInfo {
  id
  equipmentMachineName
  manufacturerName
  model
  year
  quantity
  remarks
  location
  quantityUnit
  productionCapacity
  isArchived
  category
}
    `;
export const CrSupplierFirmEquipmentInfoWithBeforeFieldFragmentDoc = gql`
    fragment CrSupplierFirmEquipmentInfoWithBeforeField on CrSupplierFirmEquipmentInfo {
  ...CrSupplierFirmEquipmentInfoField
  before {
    ...CrSupplierFirmEquipmentInfoField
  }
}
    ${CrSupplierFirmEquipmentInfoFieldFragmentDoc}`;
export const SupplierFileClassFieldFragmentDoc = gql`
    fragment SupplierFileClassField on SupplierFileClass {
  id
  name
  order
  isSatisfyElectronicBookPreservationAct
  canModifyBySupplierFirmInfoConfirmationRequest
  canSupplierEditCrAnswer
  canSupplierDeleteCrAnswer
}
    `;
export const CrSupplierFirmFileInfoFieldFragmentDoc = gql`
    fragment CrSupplierFirmFileInfoField on CrSupplierFirmFileInfo {
  id
  attachment {
    ...AttachmentField
  }
  supplierFileClass {
    ...SupplierFileClassField
  }
  expirationDateFrom
  expirationDateTo
  isArchived
  registeredAt
  registeredBy
  memo
}
    ${AttachmentFieldFragmentDoc}
${SupplierFileClassFieldFragmentDoc}`;
export const CrSupplierFirmFileInfoWithBeforeFieldFragmentDoc = gql`
    fragment CrSupplierFirmFileInfoWithBeforeField on CrSupplierFirmFileInfo {
  ...CrSupplierFirmFileInfoField
  before {
    ...CrSupplierFirmFileInfoField
  }
}
    ${CrSupplierFirmFileInfoFieldFragmentDoc}`;
export const SupplierAccountingItemFieldFragmentDoc = gql`
    fragment SupplierAccountingItemField on SupplierAccountingItem {
  id
  parentId
  code
  name
  isAsset
  isLiability
  isNetAsset
  isEditable
  isSubtraction
  level
}
    `;
export const CrSupplierFirmFinancialDetailFieldFragmentDoc = gql`
    fragment CrSupplierFirmFinancialDetailField on CrSupplierFirmFinancialDetail {
  id
  isArchived
  financialStatementKind
  name
  supplierAccountingItem {
    ...SupplierAccountingItemField
  }
  amount
  displayAmount
  parentId
  changeRate
}
    ${SupplierAccountingItemFieldFragmentDoc}`;
export const CrSupplierFirmFinancialDetailWithBeforeFieldFragmentDoc = gql`
    fragment CrSupplierFirmFinancialDetailWithBeforeField on CrSupplierFirmFinancialDetail {
  ...CrSupplierFirmFinancialDetailField
  before {
    ...CrSupplierFirmFinancialDetailField
  }
}
    ${CrSupplierFirmFinancialDetailFieldFragmentDoc}`;
export const CurrencyFieldFragmentDoc = gql`
    fragment CurrencyField on Currency {
  id
  currencyCode
  numericCode
  symbol
  displayName
  decimalPrecision
  isBaseCurrency
}
    `;
export const CrSupplierFirmFinancialInfoFieldFragmentDoc = gql`
    fragment CrSupplierFirmFinancialInfoField on CrSupplierFirmFinancialInfo {
  id
  supplierFirmInfoConfirmationRequestId
  isArchived
  financialStatementPeriodFrom
  financialStatementPeriodTo
  currency {
    ...CurrencyField
  }
  bsAmountUnitKindLabel
  plAmountUnitKindLabel
  cfAmountUnitKindLabel
  grossProfitMarginRatio
  operatingProfitRatio
  salesOperatingProfitRatio
  netProfitRatio
  grossProfitMarginRatioChangeRate
  operatingProfitRatioChangeRate
  salesOperatingProfitRatioChangeRate
  netProfitRatioChangeRate
  bsLiabilityNetAssetTotalChangeRate
}
    ${CurrencyFieldFragmentDoc}`;
export const CrSupplierFirmFinancialInfoWithBeforeFieldFragmentDoc = gql`
    fragment CrSupplierFirmFinancialInfoWithBeforeField on CrSupplierFirmFinancialInfo {
  ...CrSupplierFirmFinancialInfoField
  before {
    ...CrSupplierFirmFinancialInfoField
  }
}
    ${CrSupplierFirmFinancialInfoFieldFragmentDoc}`;
export const CrSupplierFirmKeyPositionInfoFieldFragmentDoc = gql`
    fragment CrSupplierFirmKeyPositionInfoField on CrSupplierFirmKeyPositionInfo {
  id
  isArchived
  positionName
  responsibilities
  fullName
  age
  memo
  nameKana
  hasRepresentativeAuthority
  birthDate
  positionStartDate
}
    `;
export const CrSupplierFirmKeyPositionInfoWithBeforeFieldFragmentDoc = gql`
    fragment CrSupplierFirmKeyPositionInfoWithBeforeField on CrSupplierFirmKeyPositionInfo {
  ...CrSupplierFirmKeyPositionInfoField
  before {
    ...CrSupplierFirmKeyPositionInfoField
  }
}
    ${CrSupplierFirmKeyPositionInfoFieldFragmentDoc}`;
export const CrSupplierFirmLaborSituationInfoFieldFragmentDoc = gql`
    fragment CrSupplierFirmLaborSituationInfoField on CrSupplierFirmLaborSituationInfo {
  id
  annualWorkingDays
  holidayType
  averageOvertimePerPerson
  attendanceRate
  averageBasicSalary
  averageAge
  averageYearsOfService
  memo
  isArchived
}
    `;
export const CrSupplierFirmLaborSituationInfoWithBeforeFieldFragmentDoc = gql`
    fragment CrSupplierFirmLaborSituationInfoWithBeforeField on CrSupplierFirmLaborSituationInfo {
  ...CrSupplierFirmLaborSituationInfoField
  before {
    ...CrSupplierFirmLaborSituationInfoField
  }
}
    ${CrSupplierFirmLaborSituationInfoFieldFragmentDoc}`;
export const CountryFieldFragmentDoc = gql`
    fragment CountryField on Country {
  id
  name
  translation
}
    `;
export const StateFieldFragmentDoc = gql`
    fragment StateField on State {
  id
  name
}
    `;
export const AddressFieldFragmentDoc = gql`
    fragment AddressField on Address {
  id
  countryId
  stateId
  zipCode
  address
  building
  phoneNumber
  country {
    ...CountryField
  }
  state {
    ...StateField
  }
}
    ${CountryFieldFragmentDoc}
${StateFieldFragmentDoc}`;
export const CrSupplierFirmManufacturingSiteFieldFragmentDoc = gql`
    fragment CrSupplierFirmManufacturingSiteField on CrSupplierFirmManufacturingSite {
  id
  code
  name
  isArchived
  tel
  fax
  landArea
  landOwnershipKind
  buildingArea
  buildingOwnershipKind
  president
  capitalAmount
  capitalCurrency {
    ...CurrencyField
  }
  businessDescription
  numberOfEmployees
  establishedDate
  overseasExpansionDate
  investmentTypeName
  investmentRatio
  memo
  address {
    ...AddressField
  }
  partsMemo
  numberOfEmployeesOther
  investorName
  investorName2
  investmentRatio2
}
    ${CurrencyFieldFragmentDoc}
${AddressFieldFragmentDoc}`;
export const CrSupplierFirmManufacturingSiteWithBeforeFieldFragmentDoc = gql`
    fragment CrSupplierFirmManufacturingSiteWithBeforeField on CrSupplierFirmManufacturingSite {
  ...CrSupplierFirmManufacturingSiteField
  before {
    ...CrSupplierFirmManufacturingSiteField
  }
}
    ${CrSupplierFirmManufacturingSiteFieldFragmentDoc}`;
export const CrSupplierFirmMemberOrganizationFieldFragmentDoc = gql`
    fragment CrSupplierFirmMemberOrganizationField on CrSupplierFirmMemberOrganization {
  id
  isArchived
  name
  memo
}
    `;
export const CrSupplierFirmMemberOrganizationWithBeforeFieldFragmentDoc = gql`
    fragment CrSupplierFirmMemberOrganizationWithBeforeField on CrSupplierFirmMemberOrganization {
  ...CrSupplierFirmMemberOrganizationField
  before {
    ...CrSupplierFirmMemberOrganizationField
  }
}
    ${CrSupplierFirmMemberOrganizationFieldFragmentDoc}`;
export const SupplierOutsourcingClassFieldFragmentDoc = gql`
    fragment SupplierOutsourcingClassField on SupplierOutsourcingClass {
  id
  code
  name
  order
  isArchived
}
    `;
export const CrSupplierOutsourcingClassLinkFieldFragmentDoc = gql`
    fragment CrSupplierOutsourcingClassLinkField on CrSupplierOutsourcingClassLink {
  id
  supplierOutsourcingClass {
    ...SupplierOutsourcingClassField
  }
}
    ${SupplierOutsourcingClassFieldFragmentDoc}`;
export const CrSupplierFirmOutsourcingInfoFieldFragmentDoc = gql`
    fragment CrSupplierFirmOutsourcingInfoField on CrSupplierFirmOutsourcingInfo {
  id
  name
  siteName
  isArchived
  factory
  industry
  name
  numberOfEmployees
  president
  remarks
  salesAmount
  transactionAmount
  transactionItem
  address {
    ...AddressField
  }
  purchaseRate
  processingType
  tenantDependencyRate
  capitalAmount
  certificationInfo
  crSupplierOutsourcingClassLinks {
    ...CrSupplierOutsourcingClassLinkField
  }
}
    ${AddressFieldFragmentDoc}
${CrSupplierOutsourcingClassLinkFieldFragmentDoc}`;
export const CrSupplierFirmOutsourcingInfoWithBeforeFieldFragmentDoc = gql`
    fragment CrSupplierFirmOutsourcingInfoWithBeforeField on CrSupplierFirmOutsourcingInfo {
  ...CrSupplierFirmOutsourcingInfoField
  before {
    ...CrSupplierFirmOutsourcingInfoField
  }
}
    ${CrSupplierFirmOutsourcingInfoFieldFragmentDoc}`;
export const CrSupplierFirmRepresentativeInfoFieldFragmentDoc = gql`
    fragment CrSupplierFirmRepresentativeInfoField on CrSupplierFirmRepresentativeInfo {
  id
  isArchived
  name
  nameKana
  nameEn
  position
  biography
  age
  memo
  isExistSuccessor
  successorName
  successorRelationship
  successorAge
  birthDate
}
    `;
export const CrSupplierFirmRepresentativeInfoWithBeforeFieldFragmentDoc = gql`
    fragment CrSupplierFirmRepresentativeInfoWithBeforeField on CrSupplierFirmRepresentativeInfo {
  ...CrSupplierFirmRepresentativeInfoField
  before {
    ...CrSupplierFirmRepresentativeInfoField
  }
}
    ${CrSupplierFirmRepresentativeInfoFieldFragmentDoc}`;
export const CrSupplierFirmSalesStatusInfoFieldFragmentDoc = gql`
    fragment CrSupplierFirmSalesStatusInfoField on CrSupplierFirmSalesStatusInfo {
  id
  isArchived
  companyName
  salesRatio
  isTenantSales
  salesAmount
  memo
  address {
    ...AddressField
  }
  salesPartsMemo
  hasTransactionToTenant
}
    ${AddressFieldFragmentDoc}`;
export const CrSupplierFirmSalesStatusInfoWithBeforeFieldFragmentDoc = gql`
    fragment CrSupplierFirmSalesStatusInfoWithBeforeField on CrSupplierFirmSalesStatusInfo {
  ...CrSupplierFirmSalesStatusInfoField
  before {
    ...CrSupplierFirmSalesStatusInfoField
  }
}
    ${CrSupplierFirmSalesStatusInfoFieldFragmentDoc}`;
export const CrSupplierFirmShareholderInfoFieldFragmentDoc = gql`
    fragment CrSupplierFirmShareholderInfoField on CrSupplierFirmShareholderInfo {
  id
  isArchived
  shareholderName
  percentage
  shareholding
  memo
}
    `;
export const CrSupplierFirmShareholderInfoWithBeforeFieldFragmentDoc = gql`
    fragment CrSupplierFirmShareholderInfoWithBeforeField on CrSupplierFirmShareholderInfo {
  ...CrSupplierFirmShareholderInfoField
  before {
    ...CrSupplierFirmShareholderInfoField
  }
}
    ${CrSupplierFirmShareholderInfoFieldFragmentDoc}`;
export const CrSupplierFirmSiteFieldFragmentDoc = gql`
    fragment CrSupplierFirmSiteField on CrSupplierFirmSite {
  id
  code
  name
  isArchived
  tel
  fax
  landArea
  landOwnershipKind
  buildingArea
  buildingOwnershipKind
  president
  capitalAmount
  capitalCurrency {
    ...CurrencyField
  }
  businessDescription
  numberOfEmployees
  establishedDate
  overseasExpansionDate
  investmentTypeName
  investmentRatio
  memo
  address {
    ...AddressField
  }
  partsMemo
  numberOfEmployeesOther
  investorName
  investorName2
  investmentRatio2
}
    ${CurrencyFieldFragmentDoc}
${AddressFieldFragmentDoc}`;
export const CrSupplierFirmSiteWithBeforeFieldFragmentDoc = gql`
    fragment CrSupplierFirmSiteWithBeforeField on CrSupplierFirmSite {
  ...CrSupplierFirmSiteField
  before {
    ...CrSupplierFirmSiteField
  }
}
    ${CrSupplierFirmSiteFieldFragmentDoc}`;
export const SupplierEnqueteQuestionConfigFieldFragmentDoc = gql`
    fragment SupplierEnqueteQuestionConfigField on SupplierEnqueteQuestionConfig {
  name
  code
}
    `;
export const SupplierEnqueteAnswerFieldFragmentDoc = gql`
    fragment SupplierEnqueteAnswerField on SupplierEnqueteAnswer {
  supplierEnqueteQuestionConfig {
    ...SupplierEnqueteQuestionConfigField
  }
  answerValue
  isArchived
}
    ${SupplierEnqueteQuestionConfigFieldFragmentDoc}`;
export const CrSupplierFirmSurveyEnqueteAnswerFieldFragmentDoc = gql`
    fragment CrSupplierFirmSurveyEnqueteAnswerField on CrSupplierFirmSurveyEnqueteAnswer {
  id
  isArchived
  supplierEnqueteAnswer {
    ...SupplierEnqueteAnswerField
  }
}
    ${SupplierEnqueteAnswerFieldFragmentDoc}`;
export const CrSupplierFirmSurveyEnqueteAnswerWithBeforeFieldFragmentDoc = gql`
    fragment CrSupplierFirmSurveyEnqueteAnswerWithBeforeField on CrSupplierFirmSurveyEnqueteAnswer {
  ...CrSupplierFirmSurveyEnqueteAnswerField
  before {
    ...CrSupplierFirmSurveyEnqueteAnswerField
  }
}
    ${CrSupplierFirmSurveyEnqueteAnswerFieldFragmentDoc}`;
export const ContactClassFieldFragmentDoc = gql`
    fragment ContactClassField on ContactClass {
  id
  code
  name
  order
  isArchived
}
    `;
export const CrContactClassLinkFieldFragmentDoc = gql`
    fragment CrContactClassLinkField on CrContactClassLink {
  id
  contactClass {
    ...ContactClassField
  }
}
    ${ContactClassFieldFragmentDoc}`;
export const CrSupplierFirmUserInfoFieldFragmentDoc = gql`
    fragment CrSupplierFirmUserInfoField on CrSupplierFirmUserInfo {
  id
  beforeAfterKind
  name
  nameKana
  email
  tel
  fax
  department
  title
  emailEmergency
  telEmergency
  mailingAddress
  startOn
  endOn
  isArchived
  address {
    ...AddressField
  }
  crContactClassLinks {
    ...CrContactClassLinkField
  }
}
    ${AddressFieldFragmentDoc}
${CrContactClassLinkFieldFragmentDoc}`;
export const CrSupplierFirmUserInfoWithBeforeFieldFragmentDoc = gql`
    fragment CrSupplierFirmUserInfoWithBeforeField on CrSupplierFirmUserInfo {
  ...CrSupplierFirmUserInfoField
  before {
    ...CrSupplierFirmUserInfoField
  }
}
    ${CrSupplierFirmUserInfoFieldFragmentDoc}`;
export const IndustryFieldFragmentDoc = gql`
    fragment IndustryField on Industry {
  id
  code
  name
  order
  isArchived
}
    `;
export const TenantSelectOptionFieldFragmentDoc = gql`
    fragment TenantSelectOptionField on TenantSelectOption {
  id
  label
  longLabel
}
    `;
export const CrSupplierFirmFieldFragmentDoc = gql`
    fragment CrSupplierFirmField on CrSupplierFirm {
  id
  beforeAfterKind
  name
  nameShort
  nameEn
  nameKana
  president
  url
  capital
  capitalCurrency {
    ...CurrencyField
  }
  tel
  fax
  email
  establishedDate
  startTransactionDate
  numberOfEmployees
  listingKind
  closingMonth
  address {
    ...AddressField
  }
  issuedShares
  dividendAmount
  companyBackground
  numberOfEmployeesOther
  businessDescription
  industry {
    ...IndustryField
  }
  generalText1
  generalText2
  generalText3
  generalText4
  generalText5
  generalText6
  generalText7
  generalText8
  generalText9
  generalText10
  generalText11
  generalText12
  generalText13
  generalText14
  generalText15
  generalText16
  generalText17
  generalText18
  generalText19
  generalText20
  generalKind1Option {
    ...TenantSelectOptionField
  }
  generalKind2Option {
    ...TenantSelectOptionField
  }
  generalKind3Option {
    ...TenantSelectOptionField
  }
  generalKind4Option {
    ...TenantSelectOptionField
  }
  generalKind5Option {
    ...TenantSelectOptionField
  }
  generalKind6Option {
    ...TenantSelectOptionField
  }
  generalKind7Option {
    ...TenantSelectOptionField
  }
  generalKind8Option {
    ...TenantSelectOptionField
  }
  generalKind9Option {
    ...TenantSelectOptionField
  }
  generalKind10Option {
    ...TenantSelectOptionField
  }
  generalKinds1Options {
    ...TenantSelectOptionField
  }
  generalKinds2Options {
    ...TenantSelectOptionField
  }
  generalKinds3Options {
    ...TenantSelectOptionField
  }
  generalKinds4Options {
    ...TenantSelectOptionField
  }
  generalKinds5Options {
    ...TenantSelectOptionField
  }
  generalKinds6Options {
    ...TenantSelectOptionField
  }
  generalKinds7Options {
    ...TenantSelectOptionField
  }
  generalKinds8Options {
    ...TenantSelectOptionField
  }
  generalKinds9Options {
    ...TenantSelectOptionField
  }
  generalKinds10Options {
    ...TenantSelectOptionField
  }
}
    ${CurrencyFieldFragmentDoc}
${AddressFieldFragmentDoc}
${IndustryFieldFragmentDoc}
${TenantSelectOptionFieldFragmentDoc}`;
export const CrSupplierFirmWithBeforeFieldFragmentDoc = gql`
    fragment CrSupplierFirmWithBeforeField on CrSupplierFirm {
  ...CrSupplierFirmField
  before {
    ...CrSupplierFirmField
  }
}
    ${CrSupplierFirmFieldFragmentDoc}`;
export const CsvExportResFieldFragmentDoc = gql`
    fragment CsvExportResField on CsvExportRes {
  result {
    signedUrl
  }
  errs
}
    `;
export const AnnouncementFieldsFragmentDoc = gql`
    fragment AnnouncementFields on Announcement {
  applicantUser {
    name
  }
  attachments {
    ...AttachmentField
  }
  body
  confirmationDeadline
  displayFrom
  displayTo
  id
  priority
  status
  title
  tenantId
}
    ${AttachmentFieldFragmentDoc}`;
export const DeliveredAnnouncementFieldsFragmentDoc = gql`
    fragment DeliveredAnnouncementFields on DeliveredAnnouncement {
  id
  tenant {
    name
  }
  announcement {
    ...AnnouncementFields
  }
  confirmedAt
  viewedAt
}
    ${AnnouncementFieldsFragmentDoc}`;
export const IncompleteTaskFieldFragmentDoc = gql`
    fragment IncompleteTaskField on IncompleteTask {
  id
  tenantId
  tenantName
  supplierCode
  taskType
  title
  dueDate
  delayed
  isTrial
  bulkAnswerPackageId
}
    `;
export const InputFormErrorFragmentDoc = gql`
    fragment InputFormError on InputFormError {
  formSchemaCode
  dictKey
  field
  messages
  seqNo
}
    `;
export const ManufacturingSiteFieldFragmentDoc = gql`
    fragment ManufacturingSiteField on ManufacturingSite {
  id
  name
  code
}
    `;
export const SelectedTenantFieldFragmentDoc = gql`
    fragment SelectedTenantField on Tenant {
  id
  name
  code
  inOperationScope
  quotationConfig {
    isUseQuotationPackage
    isUseTemporaryAnswer
  }
}
    `;
export const MeFieldFragmentDoc = gql`
    fragment MeField on SupplierAccount {
  id
  name
  email
  supplierCorporation {
    id
    name
  }
  supplierAccountTenantLinks {
    id
    tenant {
      id
      name
    }
    corporation {
      name
    }
  }
  selectedTenant {
    ...SelectedTenantField
  }
  languageCode
}
    ${SelectedTenantFieldFragmentDoc}`;
export const PartAnnualTotalFieldFragmentDoc = gql`
    fragment PartAnnualTotalField on PartAnnualTotal {
  id
  tenantId
  partId
  supplierId
  isActive
  recordedOn
  quantity1
  quantity2
  quantity3
  quantity4
  quantity5
  quantity6
  quantity7
  quantity8
  quantity9
  quantity10
  quantity11
  quantity12
}
    `;
export const PartUnofficialAnnouncementFieldFragmentDoc = gql`
    fragment PartUnofficialAnnouncementField on PartUnofficialAnnouncement {
  id
  tenantId
  partId
  supplierId
  isActive
  recordedOn
  quantity1
  quantity2
  quantity3
}
    `;
export const PartTransactionFieldFragmentDoc = gql`
    fragment PartTransactionField on PartTransaction {
  id
  tenantId
  part {
    id
    name
    code
  }
  supplier {
    id
    name
    isTemporary
    code
  }
  orderNumber
  orderSeqNo
  receivedOn
  unitPrice
  receivedQuantity
  checkNumber
  checkSeqNo
  checkDate
  subtotal
  currency {
    isBaseCurrency
    currencyCode
  }
  currencyRate
  toJpy {
    subtotal
    unitPrice
  }
}
    `;
export const MoldPartFragmentDoc = gql`
    fragment MoldPart on Part {
  id
  name
  code
  figureNumber
  rootPartCode
  partAnnualTotal {
    ...PartAnnualTotalField
  }
  partUnofficialAnnouncement {
    ...PartUnofficialAnnouncementField
  }
  partTransactions {
    ...PartTransactionField
  }
  totalReceivedQuantity
  flowTendency
}
    ${PartAnnualTotalFieldFragmentDoc}
${PartUnofficialAnnouncementFieldFragmentDoc}
${PartTransactionFieldFragmentDoc}`;
export const MoldFieldFragmentDoc = gql`
    fragment MoldField on Mold {
  id
  uid
  tenantId
  employee {
    id
    name
  }
  supplier {
    id
    name
    code
    adminUser {
      id
      name
      employee {
        id
        name
      }
    }
  }
  name
  width
  depth
  height
  weight
  weightTenantUnit {
    id
    name
  }
  isNew
  isPermanent
  manageable {
    id
    name
    code
  }
  manageableId
  manageableType
  publicMemo
  storageLocation
  category
  assetNumber
  storageSymbol
  status
  evidenceComment
  attachments {
    ...AttachmentField
  }
  paymentEvidenceComment
  paymentAttachments {
    ...AttachmentField
  }
  storageEvidenceComment
  storageAttachments {
    ...AttachmentField
  }
  disposeEvidenceComment
  disposeAttachments {
    ...AttachmentField
  }
  supplierDisposeReportComment
  supplierDisposeReportedAt
  supplierDisposeReportAttachments {
    ...AttachmentField
  }
  moldStartUp {
    id
    tenantId
    moldId
    quotedCost
    acquisitionCost
  }
  moldProduction {
    id
    tenantId
    moldId
    outputPerShot
    shotCount
    cumulativePartTransaction
    remainingShotCount
    flowTendency
  }
  moldStorage {
    id
    tenantId
    moldId
    storageCost
    retroactivePrice
  }
  moldDispose {
    id
    tenantId
    moldId
    disposeCost
    scrapCost
    disposeRequestDate
  }
  moldLifecycleEvent {
    id
    tenantId
    moldId
    operationStartDate
    inspectionReceiptDate
    productionStartNotificationReceiptDate
    quoteStatementReceiptDate
    storageStartDate
    disposeDate
  }
  moldUsages {
    id
    moldId
    targettable {
      ... on Part {
        ...MoldPart
      }
    }
    targettableType
  }
}
    ${AttachmentFieldFragmentDoc}
${MoldPartFragmentDoc}`;
export const MoldDisposalSupplierApplicationFieldFragmentDoc = gql`
    fragment MoldDisposalSupplierApplicationField on MoldDisposalSupplierApplication {
  id
  uid
  title
  supplier {
    id
    name
    code
  }
  employee {
    id
    name
  }
  tenant {
    id
    name
    code
  }
  supplierAccount {
    ...SupplierAccountField
  }
  supplierUser {
    id
    name
  }
  attachments {
    ...AttachmentField
  }
  status
  applicationDate
  confirmationDueDate
  approvalDate
  comment
  remandComment
  createdAt
  updatedAt
  moldDisposalSupplierApplicationDetails {
    id
    mold {
      ...MoldField
    }
    disposeCost
    disposeRequestDate
    publicMemo
    scrapCost
    createdAt
    updatedAt
  }
}
    ${SupplierAccountFieldFragmentDoc}
${AttachmentFieldFragmentDoc}
${MoldFieldFragmentDoc}`;
export const MoldListFieldFragmentDoc = gql`
    fragment MoldListField on Mold {
  id
  uid
  tenantId
  employee {
    id
    name
  }
  supplier {
    id
    name
    code
  }
  name
  width
  depth
  height
  weight
  weightTenantUnit {
    id
    name
  }
  isNew
  isPermanent
  manageableId
  manageableType
  publicMemo
  storageLocation
  category
  assetNumber
  storageSymbol
  moldStartUp {
    id
    tenantId
    moldId
    quotedCost
    acquisitionCost
  }
  moldProduction {
    id
    tenantId
    moldId
    outputPerShot
    shotCount
    cumulativePartTransaction
    remainingShotCount
    flowTendency
  }
  moldStorage {
    id
    tenantId
    moldId
    storageCost
    retroactivePrice
  }
  moldDispose {
    id
    tenantId
    moldId
    disposeCost
    scrapCost
    disposeRequestDate
  }
  moldLifecycleEvent {
    id
    tenantId
    moldId
    operationStartDate
    inspectionReceiptDate
    productionStartNotificationReceiptDate
    quoteStatementReceiptDate
    storageStartDate
    disposeDate
  }
  moldUsages {
    id
    moldId
    targettable {
      ... on Part {
        id
        code
        name
        figureNumber
        totalReceivedQuantity
      }
    }
    targettableType
  }
}
    `;
export const MoldCompactFieldFragmentDoc = gql`
    fragment MoldCompactField on Mold {
  id
  uid
  name
  manageable {
    id
    name
    code
  }
  manageableId
  manageableType
  category
  assetNumber
  moldUsages {
    id
    moldId
    targettable {
      ... on Part {
        id
        name
        code
        figureNumber
      }
    }
    targettableType
  }
}
    `;
export const MoldStoragePaymentItemFieldFragmentDoc = gql`
    fragment MoldStoragePaymentItemField on MoldStoragePaymentItem {
  id
  moldStoragePaymentId
  storageStartDate
  storageCost
  mold {
    ...MoldCompactField
  }
}
    ${MoldCompactFieldFragmentDoc}`;
export const MoldStoragePaymentFieldFragmentDoc = gql`
    fragment MoldStoragePaymentField on MoldStoragePayment {
  id
  uid
  supplier {
    id
    name
    code
  }
  tenant {
    id
    name
    code
  }
  acceptanceDate
  totalStorageCost
  moldCount
  moldStoragePaymentItems {
    ...MoldStoragePaymentItemField
  }
}
    ${MoldStoragePaymentItemFieldFragmentDoc}`;
export const PageInfoFieldFragmentDoc = gql`
    fragment PageInfoField on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
    `;
export const SpecialProcessingDetailFormatFieldFragmentDoc = gql`
    fragment SpecialProcessingDetailFormatField on CommonSpecialProcessingDetailFormat {
  kind
  kindLabel
  isUseProductionLot
  isUseEquipmentName
  isUseProcessingTimeHour
  isUseProcessingTimeMinute
  isUseProcessingTimeSecond
  isUseProcessingRate
  isUseSetupInformation
  isUseSetupTimeHour
  isUseSetupTimeMinute
  isUseSetupTimeSecond
  isUseSetupRate
  isUseMemo
  isUseProcessingTimes
  isUseProcessingCostSubtotal
  isUseSetupCostSubtotal
  rateKind
}
    `;
export const AnswerFormatFieldFragmentDoc = gql`
    fragment AnswerFormatField on AnswerFormat {
  id
  isUseMaterialCost
  isUseMaterialCostDetail
  isUseMaterialSize
  isUseMaterialScrap
  isUseMaterialCostProcurementKind
  isUseMaterialCostCavity
  isUseMaterialCostAdjustment
  isUseMaterialCostMemo
  isUseMaterialCostThickness
  isUseMaterialCostWidth
  isUseMaterialCostHeight
  isUseMaterialCostMeasure
  isUseMaterialCostWeightBeforeProcess
  isUseMaterialCostWeightAfterProcess
  isUseMaterialCostBasePrice
  isUsePartsCost
  isUsePartsCostDetail
  isUsePartsCostProcurementKind
  isUsePartsCostPartNo
  isUsePartsCostPartName
  isUsePartsCostProductionPlace
  isUsePartsCostQuantity
  isUsePartsCostPartsUnitPrice
  isUsePartsCostMemo
  isUsePartsCostPartSpec
  isUsePartsCostPartsCount
  isUseProcessingCost
  isUseProcessingCostDetail
  isUseProcessingCostProductionLot
  isUseProcessingCostEquipmentName
  isUseProcessingCostProcessingTimeHour
  isUseProcessingCostProcessingTimeMinute
  isUseProcessingCostProcessingTimeSecond
  isUseProcessingCostProcessingRate
  isUseSetupInformation
  isUseProcessingCostProcessingTimes
  isUseProcessingCostSetupTimeHour
  isUseProcessingCostSetupTimeMinute
  isUseProcessingCostSetupTimeSecond
  isUseProcessingCostSetupRate
  isUseProcessingCostProcessingCostSubtotal
  isUseProcessingCostSetupCostSubtotal
  isUseProcessingCostMemo
  processingCostRateKind
  isUseManagementCost
  isUseMaterialManagementRate
  isUseMaterialManagementCost
  isUseProcessingManagementRate
  isUseProcessingManagementCost
  isUseDeliveryCost
  isUseDeliveryBoxInformation
  isUsePackingCost
  isUsePackingBoxInformation
  isUseDefectCost
  isUseDefectRate
  isUseProfit
  isUseProfitRate
  isUseAdjustment
  isUseDepreciation
  isUseInternalPartSubtotal
  isUseOutSourcePartSubtotal
  isUseOutSourcePartManagementRate
  isUsePaidSupplyPartSubtotal
  isUseInitialDeliveryDay
  isUseMaterialDeliveryDay
  isUseEquipmentDeliveryDay
  isUseMoldDeliveryDay
  isUseTrialDeliveryDay
  isUseDeliveryDay
  isUseGanttForDeliveryDay
  isUseSurfaceProcessingCost
  isUseSubsidiaryMaterialCost
  isUseSubsidiaryMaterialCostDetail
  isSetScrapName
  scrap1Name
  scrap2Name
  isUseCurrencyExchangeNote
  isUseAnswerByItem
  isUseMinimumOrderQuantity
  isUseDeliveryForm
  isUseQuantityPerDeliveryForm
  isUsePriceEffectiveDate
  priceRegistrationFormatId
  materialCostWeightTenantUnit {
    name
    unitCode
    unit {
      symbol
      conversionRate
    }
  }
  materialCostPriceTenantUnit {
    name
    unitCode
    unit {
      symbol
      conversionRate
    }
  }
  specialProcessingDetailFormatsList {
    ...SpecialProcessingDetailFormatField
  }
  answerMethod
  isUseProcessingWeight
  isUseCostForWeight
  processingCostWeightTenantUnit {
    name
    unitCode
    unit {
      symbol
      conversionRate
    }
  }
  isUseProcessingHeadcount
  facilityKinds {
    id
    code
    name
  }
  calculationKind
  isUseWholesalerKnowledge
  useMakerActualPartName
  makerActualPartNameHelperTxt
}
    ${SpecialProcessingDetailFormatFieldFragmentDoc}`;
export const PartAttachmentFieldFragmentDoc = gql`
    fragment PartAttachmentField on PartAttachment {
  partAttachmentKind
  attachments {
    ...AttachmentField
  }
}
    ${AttachmentFieldFragmentDoc}`;
export const SupplyPartInfoFieldFragmentDoc = gql`
    fragment SupplyPartInfoField on CommonSupplyPartInfo {
  id
  name
  code
  supplyPartId
  tenantId
  unitPrice
  specs {
    id
    code
    name
    unit
    value
  }
}
    `;
export const DeliverySiteFieldFragmentDoc = gql`
    fragment DeliverySiteField on DeliverySite {
  id
  name
  code
}
    `;
export const QuotationAttachmentFieldFragmentDoc = gql`
    fragment QuotationAttachmentField on QuotationAttachment {
  quotationAttachmentKind
  quotationItemIds
  attachments {
    ...AttachmentField
  }
}
    ${AttachmentFieldFragmentDoc}`;
export const SameGroupPartsFieldFragmentDoc = gql`
    fragment SameGroupPartsField on Part {
  id
  code
  name
}
    `;
export const PartFieldFragmentDoc = gql`
    fragment PartField on Part {
  id
  code
  displayCode
  figureNumber
  receiverCode
  receiverName
  name
  isAdjustable
  rootPartCode
  isNotEnd
  deliverySiteObjects {
    id
    name
  }
  oneAnswerFormat {
    ...AnswerFormatField
  }
  partAttachmentDesign {
    ...PartAttachmentField
  }
  partAttachmentSpec {
    ...PartAttachmentField
  }
  supplyPartInfo {
    ...SupplyPartInfoField
  }
  isNew
  deliverySites {
    ...DeliverySiteField
  }
  quotaionDesignAttachments {
    ...QuotationAttachmentField
  }
  quotaionSpecAttachments {
    ...QuotationAttachmentField
  }
  sameGroupParts {
    ...SameGroupPartsField
  }
}
    ${AnswerFormatFieldFragmentDoc}
${PartAttachmentFieldFragmentDoc}
${SupplyPartInfoFieldFragmentDoc}
${DeliverySiteFieldFragmentDoc}
${QuotationAttachmentFieldFragmentDoc}
${SameGroupPartsFieldFragmentDoc}`;
export const PartListFieldFragmentDoc = gql`
    fragment PartListField on PartList {
  id
  code
  displayCode
  rootPartCode
  receiverCode
  receiverName
  name
  isAdjustable
  figureNumber
  latestOrderUnitPrices {
    supplier {
      id
      code
      name
    }
    quantity
    unitPrice
    startOn
    endOn
    id
    currency {
      currencyCode
    }
    tenantUnit {
      name
    }
    tenantPeriodUnit {
      name
    }
  }
  tenant {
    id
    name
  }
  rootPartCode
}
    `;
export const PartMaterialPriceFieldsFragmentDoc = gql`
    fragment PartMaterialPriceFields on PartMaterialPrice {
  id
  baseMaterial {
    id
    code
    name
  }
  initialCost
  reservedWeight
  productWeight
  scrapWeight
  startOn
  startUpMonth
  weightTenantUnit {
    unitCode
    name
  }
  variation
  measure
  materialName
  materialUnitPrice
  materialCostPerQty
  materialCost
  scrapUnitPrice
  scrapSubtotal
  procurementKind
  quantity
}
    `;
export const PartReasonFieldFragmentDoc = gql`
    fragment PartReasonField on PartReason {
  id
  priceChangeReason {
    id
    reason
    code
    sequence
  }
  priceDifference
  sequence
}
    `;
export const PartOrderUnitPriceForListFieldFragmentDoc = gql`
    fragment PartOrderUnitPriceForListField on PartOrderUnitPriceForList {
  id
  part {
    id
    code
    name
    rootPartCode
    isEnd
  }
  supplier {
    id
    code
    name
  }
  unitPrice
  startOn
  manufacturingSite {
    id
    name
    code
  }
  ifKey1
  ifKey2
  partReasons {
    ...PartReasonField
  }
  cancelStatusKind
}
    ${PartReasonFieldFragmentDoc}`;
export const PartSearchModalFieldFragmentDoc = gql`
    fragment PartSearchModalField on Part {
  id
  code
  name
  rootPartCode
}
    `;
export const PartSupplyPriceFieldFragmentDoc = gql`
    fragment PartSupplyPriceField on PartSupplyPrice {
  id
  assignmentPriceKind
  assignmentPrice
  startOn
  endOn
  supplier {
    id
    code
    name
  }
  tenant {
    name
  }
  tenantUnit {
    name
  }
  part {
    displayCode
    name
    figureNumber
    id
  }
}
    `;
export const PriceAdjustmentEventFieldFragmentDoc = gql`
    fragment PriceAdjustmentEventField on PriceAdjustmentEvent {
  id
  eventKind
  triggeredBy {
    ... on SupplierAccount {
      id
      name
    }
    ... on SupplierUser {
      id
      name
    }
    ... on AdminUser {
      id
      name
    }
  }
  memo
  triggeredByType
  createdAt
  confirmationStatusName
  confirmationStatusValue
  adjustmentStatusName
  actionName
}
    `;
export const PriceAdjustmentFieldFragmentDoc = gql`
    fragment PriceAdjustmentField on PriceAdjustment {
  id
  tenantId
  supplier {
    id
    name
    displayCode
  }
  tenantCode
  supplierCode
  adjustmentPurpose
  applicantKind
  targetTerm
  confirmationStartDate
  confirmationDeadlineDate
  priceEffectiveDate
  priceExpirationDate
  memo
  inChargeAdminUser {
    id
    name
  }
  inChargeSupplierAccount {
    ...SupplierAccountField
  }
  inChargeSupplierUser {
    id
    name
  }
  supplierAccounts {
    ...SupplierAccountField
  }
  supplierUsers {
    id
    name
  }
  currentEvent {
    ...PriceAdjustmentEventField
  }
  currentAsking {
    ...PriceAdjustmentEventField
  }
  tenant {
    id
    name
  }
  priceAdjustmentItems {
    id
    partOrderUnitPrice {
      id
      part {
        id
        name
        code
        rootPartCode
      }
    }
  }
}
    ${SupplierAccountFieldFragmentDoc}
${PriceAdjustmentEventFieldFragmentDoc}`;
export const PriceAdjustmentItemDetailFieldFragmentDoc = gql`
    fragment PriceAdjustmentItemDetailField on PriceAdjustmentItemDetail {
  id
  tenantId
  kind
  unitPrice
  materialCost
  processingCost
  otherCost
  supplyPartPrice
  scrapPrice
  memo
  notSupplyPartSubtotal
  subsidiaryMaterialCost
  propertyRentCost
  paidSupplyPartSubtotal
  facilityCost
  facilityAmortizationCost
  amortizationCost
  jigManagementCost
  netUnitPrice
  materialCostNotSupplySubtotal
  materialCostSupplySubtotal
  materialManagementCost
  partsCost
  deliveryCost
  managementCost
  processingPriceSubtotal
  manufacturingSite {
    code
    name
  }
}
    `;
export const PriceChangeReasonFieldFragmentDoc = gql`
    fragment PriceChangeReasonField on PriceChangeReason {
  id
  tenantId
  code
  reason
  sequence
}
    `;
export const PriceAdjustmentItemPriceChangeReasonFieldFragmentDoc = gql`
    fragment priceAdjustmentItemPriceChangeReasonField on PriceAdjustmentItemPriceChangeReason {
  id
  tenantId
  code
  reason
  sequence
  priceChangeReasonId
  priceDifference
}
    `;
export const PriceAdjustmentItemFieldFragmentDoc = gql`
    fragment PriceAdjustmentItemField on PriceAdjustmentItem {
  id
  tenantId
  quantity
  tenantUnit {
    id
    unitCode
    name
  }
  tenantPeriodUnit {
    id
    periodUnitKind
    name
  }
  part {
    id
    name
    displayCode
    rootPartCode
    sameGroupParts {
      name
      displayCode
    }
  }
  memo
  newDetail {
    ...PriceAdjustmentItemDetailField
  }
  oldDetail {
    ...PriceAdjustmentItemDetailField
  }
  latestAskingDetail {
    ...PriceAdjustmentItemDetailField
  }
  priceChangeReasons {
    ...PriceChangeReasonField
  }
  reasonSnapshots {
    ...priceAdjustmentItemPriceChangeReasonField
  }
  partOrderUnitPrice {
    id
    tenantUnit {
      unitCode
      name
    }
    tenant {
      id
      name
      code
    }
    supplier {
      id
      name
      code
      displayCode
      isEligibleToSubcontractAct
    }
    unitPrice
    ifKey1
    ifKey2
    currency {
      currencyCode
      decimalPrecision
      displayName
    }
    itemRequirement {
      designChangeCode
    }
  }
}
    ${PriceAdjustmentItemDetailFieldFragmentDoc}
${PriceChangeReasonFieldFragmentDoc}
${PriceAdjustmentItemPriceChangeReasonFieldFragmentDoc}`;
export const PriceAdjustmentSettingFieldFragmentDoc = gql`
    fragment PriceAdjustmentSettingField on PriceAdjustmentSetting {
  id
  tenantId
  reasonCount
  isUseMaterialPriceAdjustment
  isUsePriceAdjustmentFormEdit
  materialPriceAdjustmentTargetKind
}
    `;
export const PriceAdjustmentDetailFieldFragmentDoc = gql`
    fragment PriceAdjustmentDetailField on PriceAdjustmentDetail {
  id
  tenantId
  tenant {
    id
    name
  }
  supplier {
    id
    name
    code
    displayCode
    supplierFirmId
  }
  tenantCode
  supplierCode
  targetTerm
  adjustmentPurpose
  applicantKind
  confirmationStartDate
  confirmationDeadlineDate
  priceEffectiveDate
  priceExpirationDate
  adjustmentKind
  answerFormat {
    ...AnswerFormatField
  }
  attachments {
    ...AttachmentField
  }
  supplierCorporationAttachments {
    ...AttachmentField
  }
  memo
  isSupplierEditable
  isItemDeletable
  inChargeAdminUser {
    id
    name
    email
    adminUserGroups {
      id
      name
    }
  }
  inChargeSupplierAccount {
    ...SupplierAccountField
  }
  inChargeSupplierUser {
    id
    name
  }
  supplierAccounts {
    ...SupplierAccountField
  }
  supplierUsers {
    id
    name
  }
  currentEvent {
    ...PriceAdjustmentEventField
  }
  currentAsking {
    ...PriceAdjustmentEventField
  }
  completeEvent {
    ...PriceAdjustmentEventField
  }
  priceAdjustmentItems {
    ...PriceAdjustmentItemField
  }
  priceAdjustmentSetting {
    ...PriceAdjustmentSettingField
  }
  priceAdjustmentEvents {
    ...PriceAdjustmentEventField
  }
}
    ${AnswerFormatFieldFragmentDoc}
${AttachmentFieldFragmentDoc}
${SupplierAccountFieldFragmentDoc}
${PriceAdjustmentEventFieldFragmentDoc}
${PriceAdjustmentItemFieldFragmentDoc}
${PriceAdjustmentSettingFieldFragmentDoc}`;
export const PriceAdjustmentItemDetailMaterialPriceFieldFragmentDoc = gql`
    fragment PriceAdjustmentItemDetailMaterialPriceField on PriceAdjustmentItemDetailMaterialPrice {
  id
  materialName
  materialCode
  materialCost
  materialUnitPrice
  initialCost
  measure
  procurementKind
  productWeight
  quantity
  reservedWeight
  scrapSubtotal
  scrapUnitPrice
  scrapWeight
  startOn
  startUpMonth
  variation
  cavity
  materialCostPerQty
  partMaterialPriceId
  baseMaterial {
    id
    name
    code
  }
  partMaterialPrice {
    id
  }
  priceTenantUnit {
    id
    name
    unitCode
  }
  weightTenantUnit {
    id
    name
    unitCode
  }
}
    `;
export const PriceAdjustmentItemDetailProcessingPriceFieldFragmentDoc = gql`
    fragment PriceAdjustmentItemDetailProcessingPriceField on PriceAdjustmentItemDetailProcessingPrice {
  id
  tenantId
  priceAdjustmentItemDetailId
  processName
  equipmentName
  processingTimeMinute
  processingTimeSecond
  processingTimeHour
  processingRate
  processingCostSubtotal
  processingCostSubtotalPerLot
  setupTimeMinute
  setupTimeHour
  setupTimeSecond
  processingTimes
  setupCostSubtotal
  processingCost
  memo
  productionLot
  rateKind
  setupRate
  processingWeight
  costForWeight
  weightTenantUnitId
  processingHeadcount
  processOutsourcingKind
  processingCostPerLot
  partProcessingCostId
  facilityKindId
  facilityName
  facilityCost
  facilityPaymentInstallmentKind
  partFacilityPrice {
    id
    facilityKindId
    facilityKind {
      id
      name
    }
    name
    facilityCost
    acquiredOn
    memo
    amortizationNumber
    amortizationCost
    paymentInstallmentKind
    paymentMonthly
    paymentLastMonth
    paymentStartOn
    paymentEndOn
    tenantId
  }
}
    `;
export const PriceAdjustmentItemDetailSubpartPriceFieldFragmentDoc = gql`
    fragment PriceAdjustmentItemDetailSubpartPriceField on PriceAdjustmentItemDetailSubpartPrice {
  id
  tenantId
  priceAdjustmentItemDetailId
  partCode
  partName
  quantity
  quantityDenominator
  unitPrice
  partCost
  partSubpartPriceId
}
    `;
export const PriceAdjustmentItemDetailSubsidiaryMaterialCostFieldFragmentDoc = gql`
    fragment PriceAdjustmentItemDetailSubsidiaryMaterialCostField on PriceAdjustmentItemDetailSubsidiaryMaterialCost {
  id
  tenantId
  priceAdjustmentItemDetailId
  name
  unitPrice
  quantity
  subsidiaryMaterialCost
  note
  partSubsidiaryMaterialCostId
}
    `;
export const PriceAdjustmentItemDetailSupplySubpartPriceFieldFragmentDoc = gql`
    fragment PriceAdjustmentItemDetailSupplySubpartPriceField on PriceAdjustmentItemDetailSupplySubpartPrice {
  id
  tenantId
  priceAdjustmentItemDetailId
  supplyPart {
    id
    code
    name
  }
  quantity
  quantityDenominator
  unitPrice
  supplyPartCost
  partCode
  rootPartCode
  supplyPartName
  partSupplySubpartPriceId
}
    `;
export const QuotationContextFieldFragmentDoc = gql`
    fragment QuotationContextField on QuotationContext {
  id
  incoterms
  incotermsLabels
  ruleOfCurrencyRateChange
  ruleOfCurrencyRateChangeLabels
  ruleOfMarketChange
  ruleOfMarketChangeLabels
  requestProcess
  requestProcessLabels
  materialPriceReferenceDate
  assumedExchangeRateUsd
  assumedExchangeRateCny
  partSupplyPresenceKind
  materialSupplyPresenceKind
  costBearingDollyKind
  costBearingInitialCostKind
  paymentInstallmentInitialCostKind
  paymentMethod
  paymentMethodLabels
  massProductionCategory
  massProductionCategoryLabels
  modelDepreciation
  materialPriceDateOn
  naphthaDateOn
  naphthaPrice
  currencyRateDisplay1
  currencyRateDisplay2
  currencyRateDisplay3
  deliverySiteName
  materialAndPaintHandlingLabels
  deliveryCartHandlingLabels
  equipmentAndToolHandlingLabels
  deliveryPeriod
  desiredDeliveryDueOn
  comment
  modelDepreciationTenantUnit {
    id
    unitCode
    name
    order
  }
  modelDepreciationTenantPeriodUnit {
    id
    periodUnitKind
    name
  }
  modelDepreciationQuantity
  currencyRate1
  currencyRate2
  currencyRate3
  currency1Id
  currency2Id
  currency3Id
  currencyName1
  currencyName2
  currencyName3
  deliverySiteId
  materialAndPaintHandling
  deliveryCartHandling
  equipmentAndToolHandling
}
    `;
export const PriceAdjustmentItemDetailForFormFieldFragmentDoc = gql`
    fragment PriceAdjustmentItemDetailForFormField on PriceAdjustmentItemDetail {
  id
  tenantId
  kind
  unitPrice
  materialCost
  processingCost
  otherCost
  supplyPartPrice
  scrapPrice
  memo
  manufacturingSite {
    id
    name
    code
  }
  notSupplyPartSubtotal
  subsidiaryMaterialCost
  propertyRentCost
  paidSupplyPartSubtotal
  facilityCost
  facilityAmortizationCost
  amortizationCost
  jigManagementCost
  materialManagementCost
  materialCostNotSupplySubtotal
  materialCostSupplySubtotal
  partsCost
  netUnitPrice
  deliveryCost
  managementCost
  processingPriceSubtotal
  priceAdjustmentItemDetailMaterialPrices {
    ...PriceAdjustmentItemDetailMaterialPriceField
  }
  priceAdjustmentItemDetailProcessingPrices {
    ...PriceAdjustmentItemDetailProcessingPriceField
  }
  priceAdjustmentItemDetailSubpartPrices {
    ...PriceAdjustmentItemDetailSubpartPriceField
  }
  priceAdjustmentItemDetailSubsidiaryMaterialCosts {
    ...PriceAdjustmentItemDetailSubsidiaryMaterialCostField
  }
  priceAdjustmentItemDetailSupplySubpartPrices {
    ...PriceAdjustmentItemDetailSupplySubpartPriceField
  }
  quotationContext {
    ...QuotationContextField
  }
}
    ${PriceAdjustmentItemDetailMaterialPriceFieldFragmentDoc}
${PriceAdjustmentItemDetailProcessingPriceFieldFragmentDoc}
${PriceAdjustmentItemDetailSubpartPriceFieldFragmentDoc}
${PriceAdjustmentItemDetailSubsidiaryMaterialCostFieldFragmentDoc}
${PriceAdjustmentItemDetailSupplySubpartPriceFieldFragmentDoc}
${QuotationContextFieldFragmentDoc}`;
export const PartOrderUnitPriceFieldFragmentDoc = gql`
    fragment PartOrderUnitPriceField on PartOrderUnitPrice {
  id
  unitPrice
  quantity
  startOn
  endOn
  isExpired
  ifKey1
  ifKey2
  currency {
    id
    displayName
    currencyCode
    decimalPrecision
  }
  tenantUnit {
    unitCode
    name
  }
  tenantPeriodUnit {
    id
    periodUnitKind
    name
  }
  part {
    id
    displayCode
    name
    figureNumber
  }
}
    `;
export const PriceAdjustmentItemForFormFieldFragmentDoc = gql`
    fragment priceAdjustmentItemForFormField on PriceAdjustmentItem {
  id
  tenantId
  quantity
  tenantUnit {
    id
    unitCode
    name
  }
  tenantPeriodUnit {
    id
    periodUnitKind
    name
  }
  part {
    id
    code
    displayCode
    figureNumber
    receiverCode
    receiverName
    name
    isAdjustable
    rootPartCode
    deliverySiteObjects {
      id
      name
    }
    deliverySites {
      ...DeliverySiteField
    }
    sameGroupParts {
      ...SameGroupPartsField
    }
    activePartOrderUnitPrices {
      itemRequirement {
        designChangeCode
      }
    }
  }
  memo
  newDetail {
    ...PriceAdjustmentItemDetailForFormField
  }
  oldDetail {
    ...PriceAdjustmentItemDetailForFormField
  }
  latestAskingDetail {
    ...PriceAdjustmentItemDetailForFormField
  }
  priceChangeReasons {
    ...PriceChangeReasonField
  }
  reasonSnapshots {
    ...priceAdjustmentItemPriceChangeReasonField
  }
  partOrderUnitPrice {
    ...PartOrderUnitPriceField
  }
  priceAdjustment {
    id
    targetTerm
    supplierCode
    supplier {
      id
      name
      displayCode
    }
  }
  answerFormat {
    ...AnswerFormatField
  }
}
    ${DeliverySiteFieldFragmentDoc}
${SameGroupPartsFieldFragmentDoc}
${PriceAdjustmentItemDetailForFormFieldFragmentDoc}
${PriceChangeReasonFieldFragmentDoc}
${PriceAdjustmentItemPriceChangeReasonFieldFragmentDoc}
${PartOrderUnitPriceFieldFragmentDoc}
${AnswerFormatFieldFragmentDoc}`;
export const PriceAdjustmentItemProjectFieldFragmentDoc = gql`
    fragment PriceAdjustmentItemProjectField on Project {
  id
  modelYear
  title
  modelTitle
  modelTypeName
  projectModel {
    id
    deliverySiteName
    modelDepreciation
    modelDepreciationQuantity
    manufacturingSiteName
  }
  projectFormat {
    isSingleUnitProject
  }
  projectSchedules {
    id
    eventName
    eventOn
    qualificationLevelName
    seqNo
  }
  quotationContext {
    materialPriceDateOn
    currencyRateDisplay1
    currencyRateDisplay2
    currencyRateDisplay3
    deliverySiteName
    materialAndPaintHandlingLabels
    deliveryCartHandlingLabels
    equipmentAndToolHandlingLabels
    deliveryPeriod
    comment
  }
}
    `;
export const QuotationItemSelectionFieldFragmentDoc = gql`
    fragment QuotationItemSelectionField on QuotationItemSelection {
  isSelected
}
    `;
export const QuotationListV2FieldFragmentDoc = gql`
    fragment QuotationListV2Field on Quotation {
  id
  uid
  status
  answerDueDate
  announcementKind
  tenant {
    id
    name
  }
  quotationItemsV2 {
    id
    quantity
    tenantUnit {
      name
    }
    tenantPeriodUnit {
      name
    }
    itemRequirement {
      code
      name
      rootPartCode
      designChangeCode
      figureNumber
    }
    quotationItemSelection {
      ...QuotationItemSelectionField
    }
  }
  quotationRequest {
    id
    supplier {
      id
      code
      name
    }
    isAnswered
    isDeclined
    answeredAt
    requestedOn
    personInCharge
    statusForSupplier
    answer {
      status
      answerPrices {
        unitPrice
      }
      currency {
        displayName
      }
      answerExcelAttachments {
        resultMessage
      }
    }
    isCanBeAnswered
    isCanBeDeclined
  }
  applicationFormat {
    isSendSelectionMail
  }
  isUseAnswerExcelImport
  isFromPurchaseReceipt
  supplierQuotationPackage {
    id
    answerEntryKind
  }
}
    ${QuotationItemSelectionFieldFragmentDoc}`;
export const ItemPropFieldFragmentDoc = gql`
    fragment ItemPropField on ItemProp {
  id
  name
  code
  unit
  kind
}
    `;
export const ItemPropInfoFieldFragmentDoc = gql`
    fragment ItemPropInfoField on ItemPropInfo {
  id
  itemProp {
    ...ItemPropField
  }
  itemProppableType
  itemProppableId
  stringValue
  numberValue
  booleanValue
  selectedOptions {
    id
    label
    position
  }
  position
}
    ${ItemPropFieldFragmentDoc}`;
export const ItemRequirementFieldFragmentDoc = gql`
    fragment ItemRequirementField on ItemRequirement {
  code
  name
  makerName
  makerCode
  makerModelNumber
  figureNumber
  itemPropInfosForSupplier {
    ...ItemPropInfoField
  }
  specAttachments {
    ...AttachmentField
  }
  designAttachments {
    ...AttachmentField
  }
  rootPartCode
  designChangeCode
}
    ${ItemPropInfoFieldFragmentDoc}
${AttachmentFieldFragmentDoc}`;
export const ProductScheduleFieldFragmentDoc = gql`
    fragment ProductScheduleField on ProductSchedule {
  id
  seqNo
  eventName
  eventOn
}
    `;
export const ProductScheduleGroupFieldFragmentDoc = gql`
    fragment ProductScheduleGroupField on ProductScheduleGroup {
  id
  seqNo
  productSchedules {
    ...ProductScheduleField
  }
}
    ${ProductScheduleFieldFragmentDoc}`;
export const ProductFieldFragmentDoc = gql`
    fragment ProductField on Product {
  id
  customerName
  customerDevelopmentCode
  name
  code
  division
  detail
  manufacturingLocation
  annualQuantity
  scheduledSalesDate
  orderType
  orderProbability
  productScheduleGroups {
    ...ProductScheduleGroupField
  }
}
    ${ProductScheduleGroupFieldFragmentDoc}`;
export const QuotationItemV2FieldFragmentDoc = gql`
    fragment QuotationItemV2Field on QuotationItemV2 {
  id
  isRoot
  isNew
  quantity
  multiLot
  quantityGroups
  itemRequirement {
    ...ItemRequirementField
  }
  quotationItemSelection {
    ...QuotationItemSelectionField
  }
  receiverCode
  receiverName
  quotationItemSupplyParts {
    ...SupplyPartInfoField
  }
  deliverySites {
    ...DeliverySiteField
  }
  tenantUnit {
    id
    unitCode
    name
  }
  products {
    ...ProductField
  }
  tenantPeriodUnit {
    id
    periodUnitKind
    name
  }
  quotationItemSupplySubparts {
    id
    supplyPartName
    partCode
    rootPartCode
    unitPrice
    quantity
    quantityDenominator
    supplyPartCost
  }
  quotationItemMaterials {
    id
    baseMaterialCode
    materialName
    thickness
    width
    procurementKind
    materialBasePrice
    scrap1UnitPrice
  }
  project {
    id
    modelTitle
    modelTypeName
    modelYear
    title
    uid
    projectSchedules {
      id
      eventName
      eventOn
      qualificationLevelName
    }
    projectModel {
      id
      deliverySiteName
      manufacturingSiteName
      productWeight
      name
      code
      customerName
      customerDevelopmentCode
      division
      detail
      manufacturingLocation
      annualQuantity
      scheduledSalesDate
      orderType
      orderProbability
    }
  }
  projectItem {
    id
    quantityPerRoot
  }
  quotationItemChildStructs {
    id
    level
    parentId
    quantityPerRoot
    quotationRequestKind
    itemRequirement {
      code
      name
      figureNumber
    }
    tenantUnit {
      id
      name
    }
  }
}
    ${ItemRequirementFieldFragmentDoc}
${QuotationItemSelectionFieldFragmentDoc}
${SupplyPartInfoFieldFragmentDoc}
${DeliverySiteFieldFragmentDoc}
${ProductFieldFragmentDoc}`;
export const AnswerPartsCostFieldFragmentDoc = gql`
    fragment AnswerPartsCostField on AnswerPartsCost {
  id
  procurementKind
  seqNo
  partNo
  partName
  productionPlace
  partSpec
  partsCount
  quantity
  partsUnitPrice
  memo
  partsCost
}
    `;
export const AnswerProcessingCostFieldFragmentDoc = gql`
    fragment AnswerProcessingCostField on AnswerProcessingCost {
  id
  seqNo
  productionLot
  processName
  equipmentName
  processingTimeHour
  processingTimeMinute
  processingTimeSecond
  processingRate
  processingCostSubtotal
  setupTimeHour
  setupTimeMinute
  setupTimeSecond
  setupRate
  processingTimes
  setupCostSubtotal
  memo
  processingCost
  rateKind
  processingWeight
  costForWeight
  weightTenantUnit {
    ...TenantUnitForAnswerField
  }
  processingHeadcount
  processOutsourcingKind
  processingCostSubtotalPerLot
  setupCostSubtotalPerLot
  processingCostPerLot
  partCostRatio
}
    ${TenantUnitForAnswerFieldFragmentDoc}`;
export const AnswerSpecialProcessingCostFieldFragmentDoc = gql`
    fragment AnswerSpecialProcessingCostField on CommonAnswerSpecialProcessingCost {
  kind
  id
  seqNo
  productionLot
  processName
  equipmentName
  processingTimeHour
  processingTimeMinute
  processingTimeSecond
  processingRate
  processingCostSubtotal
  setupTimeHour
  setupTimeMinute
  setupTimeSecond
  setupRate
  processingTimes
  setupCostSubtotal
  processingCost
  memo
  rateKind
}
    `;
export const AnswerMaterialCostFieldFragmentDoc = gql`
    fragment AnswerMaterialCostField on AnswerMaterialCost {
  id
  seqNo
  materialName
  thickness
  width
  height
  measure
  weightBeforeProcess
  weightAfterProcess
  basePrice
  adjustment
  materialCostSubtotal
  scrapValueSubtotal
  materialCost
  procurementKind
  cavity
  scrap1Name
  scrap1Weight
  scrap1UnitPrice
  scrap1Subtotal
  scrap2Name
  scrap2Weight
  scrap2UnitPrice
  scrap2Subtotal
  memo
  weightTenantUnit {
    ...TenantUnitForAnswerField
  }
  priceTenantUnit {
    ...TenantUnitForAnswerField
  }
  baseMaterialCode
  materialCostPerQty
  scrap1SubtotalPerQty
  scrap2SubtotalPerQty
  scrapValueSubtotalPerQty
  quantity
  blendPrimaryMaterialName
  blendPrimaryMaterialRatio
  blendPrimaryMaterialUnitCost
  blendSecondaryMaterialName
  blendSecondaryMaterialRatio
  blendSecondaryMaterialUnitCost
  blendOtherMaterialName
  blendOtherMaterialRatio
  blendOtherMaterialUnitCost
  blendBaseUnitCost
  blendUnitCostMarkupRatio
  lossPurgeLotCount
  lossPurgeTotalWeight
  lossPurgeUnitUsage
  lossPurgeCost
  lossGateUnitUsage
  lossGateCost
  lossRunnerUnitUsage
  lossRunnerCost
  lossOtherMemo
  lossOtherUnitUsage
  lossOtherCost
  lossTotalUnitUsage
  lossTotalCost
  trialShotUnitUsage
  trialShotCost
  adjustmentCostMemo
  adjustmentCost
}
    ${TenantUnitForAnswerFieldFragmentDoc}`;
export const AnswerSubsidiaryMaterialCostFieldFragmentDoc = gql`
    fragment AnswerSubsidiaryMaterialCostField on CommonAnswerSubsidiaryMaterialCost {
  id
  seqNo
  name
  unitPrice
  quantity
  subsidiaryMaterialCost
  note
  totalQuantity
  totalSubsidiaryMaterialCost
  amortizationNumberPerPeriod
  amortizationPeriodAsNum
}
    `;
export const AnswerPriceFieldFragmentDoc = gql`
    fragment AnswerPriceField on AnswerPrice {
  id
  quantity
  quantityFrom
  quantityTo
  isDeclined
  priceBasis
  taxType
  amountExcludingTax
  amountIncludingTax
  unitPrice
  materialCost
  partsCost
  processingCost
  surfaceProcessingCost
  subsidiaryMaterialCost
  materialManagementCost
  materialManagementRate
  processingManagementCost
  processingManagementRate
  managementCost
  quantityInOneBox
  deliveryCostPerBox
  boxCount
  deliveryCost
  packingCostPerBox
  packingCost
  defectCost
  defectRate
  profit
  adjustment
  profitRate
  depreciation
  internalPartSubtotal
  outSourcePartSubtotal
  outSourcePartManagementRate
  paidSupplyPartSubtotal
  deliveryDay
  initialDeliveryDay
  materialDeliveryDay
  materialDeliveryStartDay
  equipmentDeliveryDay
  equipmentDeliveryStartDay
  moldDeliveryDay
  moldDeliveryStartDay
  trialDeliveryDay
  trialDeliveryStartDay
  answerPartsCosts {
    ...AnswerPartsCostField
  }
  answerProcessingCosts {
    ...AnswerProcessingCostField
  }
  answerSpecialProcessingCosts {
    ...AnswerSpecialProcessingCostField
  }
  answerSurfaceProcessingCosts {
    ...AnswerSpecialProcessingCostField
  }
  answerMaterialCosts {
    ...AnswerMaterialCostField
  }
  answerSubsidiaryMaterialCosts {
    ...AnswerSubsidiaryMaterialCostField
  }
  facilityCost
  jigManagementCost
  propertyRentCost
  designCost
  subsidiaryMaterialManagementRate
  subsidiaryMaterialManagementCost
  quotationItemId
  quotationItemChildStructId
  answerSupplySubparts {
    id
    partCode
    rootPartCode
    supplyPartName
    quantity
    quantityDenominator
    unitPrice
  }
}
    ${AnswerPartsCostFieldFragmentDoc}
${AnswerProcessingCostFieldFragmentDoc}
${AnswerSpecialProcessingCostFieldFragmentDoc}
${AnswerMaterialCostFieldFragmentDoc}
${AnswerSubsidiaryMaterialCostFieldFragmentDoc}`;
export const ItemToAnswerFieldFragmentDoc = gql`
    fragment ItemToAnswerField on ItemToAnswer {
  seq
  quantity
  quantityGroup
  rootQuotationItemId
  totalQuantityOnBranch
  isDuplicate
  quotationItemAssemblyEntity {
    depth
    numberCount
    unitKind
  }
  quotationItem {
    ...QuotationItemV2Field
  }
  answerPrice {
    ...AnswerPriceField
  }
}
    ${QuotationItemV2FieldFragmentDoc}
${AnswerPriceFieldFragmentDoc}`;
export const AnswerFacilityCostFieldFragmentDoc = gql`
    fragment AnswerFacilityCostField on AnswerFacilityCost {
  id
  facilityKind {
    id
  }
  name
  maker
  spec
  quantity
  facilityUnitPrice
  facilityCost
  isLend
  amortizationCost
  amortizationNumber
  amortizationPeriod
  cavity
  leadTime
  memo
  parts {
    id
    name
    displayCode
  }
  quotationItems {
    id
    itemRequirement {
      name
      code
    }
  }
  amortizationPeriodAsYear
  paymentTimingKind
  recuttingCount
  answerProcessingCostId
  amortizationNumberPerPeriod
  amortizationPeriodAsNum
}
    `;
export const QuotationInquiryFieldFragmentDoc = gql`
    fragment QuotationInquiryField on QuotationInquiry {
  id
  seqNo
  title
  inquiryType
  unit
  attachment {
    ...AttachmentField
  }
}
    ${AttachmentFieldFragmentDoc}`;
export const AnswerInquiryFieldFragmentDoc = gql`
    fragment AnswerInquiryField on AnswerInquiry {
  id
  answerValueString
  answerValueNumber
  answerValueBoolean
  quotationInquiry {
    ...QuotationInquiryField
  }
  attachment {
    ...AttachmentField
  }
  supplierCorporationAttachment {
    ...AttachmentField
  }
}
    ${QuotationInquiryFieldFragmentDoc}
${AttachmentFieldFragmentDoc}`;
export const SupplierUserFieldFragmentDoc = gql`
    fragment SupplierUserField on SupplierUser {
  id
  name
}
    `;
export const AnswerSupplyChainItemDetailFieldFragmentDoc = gql`
    fragment AnswerSupplyChainItemDetailField on AnswerSupplyChainItemDetail {
  id
  tenantId
  quotationItemId
  answerId
  processName
  supplierName
  isAlternative
  isNew
  note
  factoryName
  address {
    ...AddressField
  }
}
    ${AddressFieldFragmentDoc}`;
export const AnswerItemFieldFragmentDoc = gql`
    fragment AnswerItemField on AnswerItem {
  quotationItemId
  minimumOrderQuantity
  deliveryForm
  quantityPerDeliveryForm
  priceEffectiveFrom
  priceEffectiveTo
  specMemo
  originLocation
}
    `;
export const AnswerFieldFragmentDoc = gql`
    fragment AnswerField on Answer {
  id
  status
  statusLabel
  memo
  expiredAt
  isDirect
  isFileAnswer
  isSupplierFileAnswer
  dayType
  quotationNo
  expirationDate
  currencyId
  facilityCost
  currencyExchangeNote
  quotationCopiedFrom {
    id
    uid
  }
  answerPrices {
    ...AnswerPriceField
  }
  answerFacilityCosts {
    ...AnswerFacilityCostField
  }
  answerInquiries {
    ...AnswerInquiryField
  }
  attachments {
    ...AttachmentField
  }
  supplierCorporationAttachments {
    ...AttachmentField
  }
  supplierAccount {
    ...SupplierAccountField
  }
  supplierUser {
    ...SupplierUserField
  }
  answerSupplyChainItemDetails {
    ...AnswerSupplyChainItemDetailField
  }
  answerItems {
    ...AnswerItemField
  }
  wholesalerKnowledges {
    quotationItemId
    makerActualPartName
  }
  quotationContext {
    ...QuotationContextField
  }
  answerOriginalFiles {
    attachment {
      ...AttachmentField
    }
    supplierCorporationAttachment {
      ...AttachmentField
    }
  }
  answerExcelAttachments {
    id
    attachment {
      ...AttachmentField
    }
    supplierCorporationAttachment {
      ...AttachmentField
    }
  }
  inputKind
}
    ${AnswerPriceFieldFragmentDoc}
${AnswerFacilityCostFieldFragmentDoc}
${AnswerInquiryFieldFragmentDoc}
${AttachmentFieldFragmentDoc}
${SupplierAccountFieldFragmentDoc}
${SupplierUserFieldFragmentDoc}
${AnswerSupplyChainItemDetailFieldFragmentDoc}
${AnswerItemFieldFragmentDoc}
${QuotationContextFieldFragmentDoc}`;
export const QuotationRequestFieldFragmentDoc = gql`
    fragment QuotationRequestField on QuotationRequest {
  id
  isAnswered
  isDeclined
  answeredAt
  requestedOn
  isLocked
  commentForSupplier
  answer {
    ...AnswerField
    declineReason
  }
  pdfImportResult {
    id
    signedUrl
    fileName
  }
  currencies {
    ...CurrencyField
  }
  supplier {
    id
    code
    name
    isEligibleToSubcontractAct
  }
  personInCharge
  supplierCountryId
  answeredAtZoned
  statusForSupplier
  isCanBeAnswered
  isCanBeDeclined
}
    ${AnswerFieldFragmentDoc}
${CurrencyFieldFragmentDoc}`;
export const ApplicationFormatFieldFragmentDoc = gql`
    fragment ApplicationFormatField on ApplicationFormat {
  isUseReceiver
  isUseDesignAttachment
  isUseSpecAttachment
  isUseFigureNumber
  quantityUnit
  isUseIsNew
  isUseDeliverySite
  isSendSelectionMail
  isUseQuotationContext
  isUseQcIncoterms
  isUseQcRuleOfCurrencyRateChange
  isUseQcRuleOfMarketChange
  isUseRequestProcess
  isUseMaterialPriceReferenceDate
  isUseAssumedExchangeRateUsd
  isUseAssumedExchangeRateCny
  isUsePartSupplyPresence
  isUseMaterialSupplyPresence
  isUseCostBearingDolly
  isUseCostBearingInitialCost
  isUsePaymentMethod
  isUsePaymentInstallmentInitialCost
  isUseMassProductionCategory
  isUseMaker
  isUseItemPropInfo
  productScheduleSettings {
    groupSeqNo
    seqNo
    name
  }
  itemProps {
    ...ItemPropField
  }
}
    ${ItemPropFieldFragmentDoc}`;
export const ProductScheduleSnapshotFieldFragmentDoc = gql`
    fragment ProductScheduleSnapshotField on ProductScheduleSnapshot {
  id
  seqNo
  eventName
  eventOn
}
    `;
export const ProductScheduleGroupSnapshotFieldFragmentDoc = gql`
    fragment ProductScheduleGroupSnapshotField on ProductScheduleGroupSnapshot {
  id
  seqNo
  productSchedules {
    ...ProductScheduleSnapshotField
  }
}
    ${ProductScheduleSnapshotFieldFragmentDoc}`;
export const QuotationProductFieldFragmentDoc = gql`
    fragment QuotationProductField on QuotationProduct {
  productId
  productInformation
  customerName
  customerDevelopmentCode
  annualQuantity
  scheduledSalesDate
  developmentCode
  productDevision
  productDetail
  productManufacturingLocation
  orderType
  orderProbability
  productScheduleGroupSnapshots {
    ...ProductScheduleGroupSnapshotField
  }
}
    ${ProductScheduleGroupSnapshotFieldFragmentDoc}`;
export const QuotationProductScheduleFieldFragmentDoc = gql`
    fragment QuotationProductScheduleField on QuotationProductSchedule {
  id
  groupSeqNo
  seqNo
  name
  value
}
    `;
export const ProductConfigFieldFragmentDoc = gql`
    fragment ProductConfigField on ProductConfig {
  isVisibleDevelopmentCode
  isVisibleName
  isVisibleCustomerName
  isVisibleCustomerDevelopmentCode
  isVisibleDivision
  isVisibleDetail
  isVisibleManufacturingLocation
  isVisibleAnnualQuantity
  isVisibleScheduledSalesDate
  isVisibleOrderType
  isVisibleOrderProbability
  isUseCustomerName
  isUseCustomerDevelopmentCode
  isUseDivision
  isUseDetail
  isUseManufacturingLocation
  isUseAnnualQuantity
  isUseScheduledSalesDate
  isUseOrderType
  isUseOrderProbability
}
    `;
export const FacilityKindFieldFragmentDoc = gql`
    fragment FacilityKindField on FacilityKind {
  id
  name
  isUseMaker
  isUseSpec
  isUseLend
  isUseAmortizationNumber
  isUseAmortizationPeriod
  isUsePart
  isUseProcessing
  isUseCavity
  isUseLeadTime
  isUseAmortizationPeriodAsYear
  isUsePaymentTimingKind
  isUseRecuttingCount
}
    `;
export const QuotationV2FieldFragmentDoc = gql`
    fragment QuotationV2Field on Quotation {
  id
  uid
  status
  announcementKind
  kind
  selectKind
  closeMemoForSupplier
  answerDueDate
  requestText
  isDetailCostUsed
  attachments {
    ...AttachmentField
  }
  itemsToAnswer {
    ...ItemToAnswerField
  }
  quotationItemsV2 {
    ...QuotationItemV2Field
  }
  quotationRequest {
    ...QuotationRequestField
  }
  applicationFormat {
    ...ApplicationFormatField
  }
  answerFormat {
    ...AnswerFormatField
  }
  quotationProducts {
    ...QuotationProductField
  }
  quotationProductSchedules {
    ...QuotationProductScheduleField
  }
  tenant {
    id
    name
    code
    productConfig {
      ...ProductConfigField
    }
    quotationConfig {
      dayTypeSetting
      deliveryInputKind
      isUseTemporaryAnswer
      isUseQuotationPackage
      isUseComment
      isUseFieldComment
    }
    attachmentOfferConfig {
      isActiveOnQuotation
    }
  }
  quotationInquiries {
    ...QuotationInquiryField
  }
  uniqFacilityKinds {
    ...FacilityKindField
  }
  isUseAnswerExcelImport
  previousQuotation {
    id
    uid
  }
  isRequestSupplyChain
  quotationContext {
    ...QuotationContextField
  }
  supplierQuotationPackage {
    id
    title
    answerEntryKind
  }
  attachmentOffers {
    id
    isDiscardNecessary
    status
    kind
    isDownloadable
    attachment {
      id
      nameForSupplier
    }
    tenant {
      id
    }
  }
  isBeforeMigration
  isOneOffOrder
}
    ${AttachmentFieldFragmentDoc}
${ItemToAnswerFieldFragmentDoc}
${QuotationItemV2FieldFragmentDoc}
${QuotationRequestFieldFragmentDoc}
${ApplicationFormatFieldFragmentDoc}
${AnswerFormatFieldFragmentDoc}
${QuotationProductFieldFragmentDoc}
${QuotationProductScheduleFieldFragmentDoc}
${ProductConfigFieldFragmentDoc}
${QuotationInquiryFieldFragmentDoc}
${FacilityKindFieldFragmentDoc}
${QuotationContextFieldFragmentDoc}`;
export const SupplierAccountCoreFieldFragmentDoc = gql`
    fragment SupplierAccountCoreField on SupplierAccount {
  id
  name
  email
  tel
  department
  title
  languageCode
  csvExportEncodingKind
  supplierAccountTenantLinks {
    id
    tenant {
      id
      name
    }
  }
}
    `;
export const TenantMemberAssignmentFieldFragmentDoc = gql`
    fragment TenantMemberAssignmentField on TenantMemberAssignment {
  id
  tenantId
  tenantName
  supplierCode
  startedAt
  endedAt
  isSendNotification
  isArchived
  isSendSupplierFirmInfoConfirmationRequest
  supplierAccountId
  supplierAccountTenantLinkId
}
    `;
export const SupplierAccountProfileFieldFragmentDoc = gql`
    fragment SupplierAccountProfileField on SupplierAccount {
  ...SupplierAccountCoreField
  profileTenantAssignments(includePast: $includePast) {
    ...TenantMemberAssignmentField
  }
}
    ${SupplierAccountCoreFieldFragmentDoc}
${TenantMemberAssignmentFieldFragmentDoc}`;
export const SupplierAccountTenantMemberFieldFragmentDoc = gql`
    fragment SupplierAccountTenantMemberField on SupplierAccount {
  ...SupplierAccountCoreField
  hasExistingSceOnTenant(tenantId: $tenantId)
  tenantMemberAssignments(tenantId: $tenantId, includePast: $includePast) {
    ...TenantMemberAssignmentField
  }
}
    ${SupplierAccountCoreFieldFragmentDoc}
${TenantMemberAssignmentFieldFragmentDoc}`;
export const SupplierAccountWithInfoFieldFragmentDoc = gql`
    fragment SupplierAccountWithInfoField on SupplierAccount {
  ...SupplierAccountCoreField
}
    ${SupplierAccountCoreFieldFragmentDoc}`;
export const SupplierAnnouncementFieldFragmentDoc = gql`
    fragment SupplierAnnouncementField on SupplierAnnouncement {
  id
  title
  content
  releasedAt
  linkText
  linkUrl
}
    `;
export const SupplierFileInfoFieldFragmentDoc = gql`
    fragment SupplierFileInfoField on SupplierFileInfo {
  id
  supplierFileClass {
    ...SupplierFileClassField
  }
  isActive
  isArchived
  expirationDateFrom
  expirationDateTo
  registeredAt
  registeredBy
  attachment {
    ...AttachmentField
  }
  memo
}
    ${SupplierFileClassFieldFragmentDoc}
${AttachmentFieldFragmentDoc}`;
export const SupplierFirmAddressFieldFragmentDoc = gql`
    fragment SupplierFirmAddressField on SupplierFirmAddress {
  id
  countryId
  stateId
  zipCode
  address
  building
  country {
    ...CountryField
  }
  state {
    ...StateField
  }
}
    ${CountryFieldFragmentDoc}
${StateFieldFragmentDoc}`;
export const SupplierFirmInfoConfirmationRequestDestinationFieldFragmentDoc = gql`
    fragment SupplierFirmInfoConfirmationRequestDestinationField on SupplierFirmInfoConfirmationRequestDestination {
  id
  supplyChainCompanyEmployeeName
  supplyChainCompanyEmployeeEmail
}
    `;
export const SupplierFirmInfoConfirmationRequestFieldFragmentDoc = gql`
    fragment SupplierFirmInfoConfirmationRequestField on SupplierFirmInfoConfirmationRequest {
  id
  tenant {
    id
    name
    code
  }
  confirmationRequestNo
  status
  surveyYear
  answerDate
  answerer
  requestDate
  dueDate
  canInputAnswer
  canShowAnswer
  isBasicInfoSelected
  isContactInfoSelected
  isSurveyInfoSelected
  isBusinessBaseInfoSelected
  isEquipmentInfoSelected
  isOutsourcingInfoSelected
  isFileInfoSelected
  isOverdue
  remandComment
  contactName
  contactEmail
  contactTel
  supplierFirmInfoConfirmationRequestDestinations {
    ...SupplierFirmInfoConfirmationRequestDestinationField
  }
  remandedBy
  remandDate
  withdrawnDate
  withdrawnBy
  fileName
  signedUrl
  answerKind
}
    ${SupplierFirmInfoConfirmationRequestDestinationFieldFragmentDoc}`;
export const SupplierMoldStorageApplicationFieldFragmentDoc = gql`
    fragment SupplierMoldStorageApplicationField on SupplierMoldStorageApplication {
  id
  uid
  supplier {
    id
    name
    code
  }
  employee {
    id
    name
  }
  tenant {
    id
    name
    code
  }
  supplierAccount {
    ...SupplierAccountField
  }
  supplierUser {
    id
    name
  }
  attachments {
    ...AttachmentField
  }
  status
  applicationDate
  confirmationDueDate
  approvalDate
  comment
  remandComment
  title
  createdAt
  updatedAt
  supplierMoldStorageApplicationDetails {
    id
    mold {
      ...MoldField
    }
    storageCost
    storageStartDate
    publicMemo
    createdAt
    updatedAt
  }
}
    ${SupplierAccountFieldFragmentDoc}
${AttachmentFieldFragmentDoc}
${MoldFieldFragmentDoc}`;
export const SupplierQuotationPackageListItemFieldFragmentDoc = gql`
    fragment SupplierQuotationPackageListItemField on SupplierQuotationPackage {
  id
  title
  answerEntryKind
  answerStatusText
  firstQuotation {
    id
    status
    answerDueDate
    isFromPurchaseReceipt
  }
  firstQuotationItem {
    id
    itemRequirement {
      code
      name
    }
    quantity
  }
  firstQuotationAdminUser {
    id
    name
  }
  firstQuotationRequest {
    id
    requestedOn
    supplier {
      code
      name
    }
  }
  quotations {
    id
    uid
    isFromPurchaseReceipt
    isUseAnswerExcelImport
    quotationRequest {
      id
      isCanBeDeclined
    }
    quotationItemsV2 {
      id
    }
  }
}
    `;
export const SupplierScreenItemConfigFieldFragmentDoc = gql`
    fragment SupplierScreenItemConfigField on SupplierScreenItemConfig {
  componentId
  itemId
  visible
  order
}
    `;
export const SupplierScreenSurveyInfoConfigFieldFragmentDoc = gql`
    fragment SupplierScreenSurveyInfoConfigField on SupplierScreenSurveyInfoConfig {
  componentId
  visible
  order
  width
}
    `;
export const SupplierSurveyInfoImportConfigFieldFragmentDoc = gql`
    fragment SupplierSurveyInfoImportConfigField on SupplierSurveyInfoImportConfig {
  attachment {
    ...AttachmentField
  }
}
    ${AttachmentFieldFragmentDoc}`;
export const TenantBaseFieldFragmentDoc = gql`
    fragment TenantBaseField on Tenant {
  id
  name
  code
  manualUrl
  supplierCodesForFirm
  quotationConfig {
    isUseQuotationPackage
    isUseTemporaryAnswer
  }
}
    `;
export const TenantFieldFragmentDoc = gql`
    fragment TenantField on Tenant {
  ...TenantBaseField
  supplierAccounts {
    ...SupplierAccountCoreField
  }
}
    ${TenantBaseFieldFragmentDoc}
${SupplierAccountCoreFieldFragmentDoc}`;
export const TenantDetailFieldFragmentDoc = gql`
    fragment TenantDetailField on Tenant {
  ...TenantBaseField
  supplierAccounts(includePast: $includePast) {
    ...SupplierAccountCoreField
    tenantMemberAssignments(tenantId: $id, includePast: $includePast) {
      ...TenantMemberAssignmentField
    }
  }
}
    ${TenantBaseFieldFragmentDoc}
${SupplierAccountCoreFieldFragmentDoc}
${TenantMemberAssignmentFieldFragmentDoc}`;
export const TenantSelectFieldFragmentDoc = gql`
    fragment TenantSelectField on TenantSelect {
  tenantSelectOptions {
    ...TenantSelectOptionField
  }
}
    ${TenantSelectOptionFieldFragmentDoc}`;
export const TenantSupplierManualTenantsFieldFragmentDoc = gql`
    fragment TenantSupplierManualTenantsField on TenantSupplierManual {
  supplierCode
  supplierId
  supplierName
  url
}
    `;
export const TenantDirectoryTenantsIndexFieldFragmentDoc = gql`
    fragment TenantDirectoryTenantsIndexField on TenantDirectory {
  memberCount
  tenant {
    id
    name
  }
  manuals {
    ...TenantSupplierManualTenantsField
  }
}
    ${TenantSupplierManualTenantsFieldFragmentDoc}`;
export const TenantDirectoryMemberAccountTenantsShowFieldFragmentDoc = gql`
    fragment TenantDirectoryMemberAccountTenantsShowField on SupplierAccount {
  id
  name
  email
  tenantMemberAssignments(tenantId: $id, includePast: $includePast) {
    ...TenantMemberAssignmentField
  }
}
    ${TenantMemberAssignmentFieldFragmentDoc}`;
export const TenantDirectoryDetailTenantsShowFieldFragmentDoc = gql`
    fragment TenantDirectoryDetailTenantsShowField on TenantDirectoryDetail {
  allowedSupplierCodes
  memberCount
  manuals {
    ...TenantSupplierManualTenantsField
  }
  tenant {
    id
    name
  }
  supplierAccounts {
    ...TenantDirectoryMemberAccountTenantsShowField
  }
}
    ${TenantSupplierManualTenantsFieldFragmentDoc}
${TenantDirectoryMemberAccountTenantsShowFieldFragmentDoc}`;
export const TrialQuotationAnswerRevisionFieldFragmentDoc = gql`
    fragment TrialQuotationAnswerRevisionField on TrialQuotationAnswer {
  id
  revisionNo
  state
  isDeclined
  answerMemo
  deliveryOn
  quotationValidUntil
  submittedAt
  items {
    quotationItemId
    seqNo
    breakdownSeqNo
    name
    makerName
    makerModel
    quantity
    unitName
    taxType
    unitPrice
    isDeclined
  }
  attachments {
    id
    attachmentKind
    seqNo
    fileName
    contentType
    byteSize
    url
    downloadUrl
  }
}
    `;
export const ValidationErrFieldFragmentDoc = gql`
    fragment ValidationErrField on ValidationErr {
  path
  message
  shortMessage
}
    `;
export const VersionedAgreementFieldFragmentDoc = gql`
    fragment VersionedAgreementField on VersionedAgreement {
  version
  content
}
    `;
export const AnswerExcelImportV2Document = gql`
    mutation AnswerExcelImportV2($attachments: [CommonAttachmentInput!]!, $quotationRequestId: ID!) {
  answerExcelImportV2(
    input: {attachments: $attachments, quotationRequestId: $quotationRequestId}
  ) {
    answerExcelResult {
      quotationCopiedFrom {
        id
        uid
      }
      answer {
        memo
        dayType
        quotationNo
        expirationDate
        facilityCost
        currencyExchangeNote
        currencyId
        answerFacilityCosts {
          facilityKind {
            id
            name
          }
          name
          maker
          spec
          quantity
          facilityUnitPrice
          facilityCost
          isLend
          amortizationCost
          amortizationNumber
          amortizationPeriod
          cavity
          leadTime
          memo
          parts {
            id
            name
            displayCode
          }
          quotationItems {
            id
            itemRequirement {
              name
              code
            }
          }
          amortizationPeriodAsYear
          paymentTimingKind
          recuttingCount
          amortizationNumberPerPeriod
          amortizationPeriodAsNum
        }
        quotationContext {
          incoterms
          ruleOfCurrencyRateChange
          ruleOfMarketChange
          requestProcess
          materialPriceReferenceDate
          assumedExchangeRateUsd
          assumedExchangeRateCny
          partSupplyPresenceKind
          materialSupplyPresenceKind
          costBearingDollyKind
          costBearingInitialCostKind
          paymentInstallmentInitialCostKind
          paymentMethod
          massProductionCategory
        }
        answerItems {
          quotationItemId
          minimumOrderQuantity
          deliveryForm
          quantityPerDeliveryForm
          priceEffectiveFrom
          priceEffectiveTo
          specMemo
          originLocation
        }
      }
      itemToAnswer {
        seq
        quantity
        quantityGroup
        rootQuotationItemId
        totalQuantityOnBranch
        isDuplicate
        quotationItemAssemblyEntity {
          depth
          numberCount
          unitKind
        }
        quotationItem {
          ...QuotationItemV2Field
        }
        answerPrice {
          ...AnswerExcelImportAnswerPriceField
        }
        childAnswerPrices {
          ...AnswerExcelImportAnswerPriceField
        }
      }
    }
    errors
    warnings
  }
}
    ${QuotationItemV2FieldFragmentDoc}
${AnswerExcelImportAnswerPriceFieldFragmentDoc}`;
export const AnswerExcelMultipleImportDocument = gql`
    mutation AnswerExcelMultipleImport($attachments: [CommonAttachmentInput!]!, $isValidateOnly: Boolean, $referenceAttachments: [CommonAttachmentInput!], $tenantId: ID!) {
  answerExcelMultipleImport(
    input: {attachments: $attachments, isValidateOnly: $isValidateOnly, referenceAttachments: $referenceAttachments, tenantId: $tenantId}
  ) {
    results {
      itemToAnswer {
        seq
        quantity
        quantityGroup
        rootQuotationItemId
        totalQuantityOnBranch
        isDuplicate
        quotationItemAssemblyEntity {
          depth
          numberCount
          unitKind
        }
        quotationItem {
          ...QuotationItemV2Field
        }
        answerPrice {
          ...AnswerExcelImportAnswerPriceField
        }
        childAnswerPrices {
          ...AnswerExcelImportAnswerPriceField
        }
      }
      attachmentIndex
      errors
      fileName
      quotationUid
      warnings
    }
  }
}
    ${QuotationItemV2FieldFragmentDoc}
${AnswerExcelImportAnswerPriceFieldFragmentDoc}`;
export const AddCommentDocument = gql`
    mutation AddComment($targetId: ID!, $commentKind: CommentKindEnum!, $itemKind: String!, $body: String!, $tenantId: ID!, $attachments: [AttachmentInput!], $parentId: ID, $supplierCode: String) {
  addComment(
    input: {targetId: $targetId, commentKind: $commentKind, itemKind: $itemKind, body: $body, tenantId: $tenantId, attachments: $attachments, parentId: $parentId, supplierCode: $supplierCode}
  ) {
    commentBase {
      ...CommentBaseField
    }
    errors
  }
}
    ${CommentBaseFieldFragmentDoc}`;
export const AnswerByAttachmentFileV2Document = gql`
    mutation AnswerByAttachmentFileV2($answerInquiries: [CommonAnswerInquiryInput!]!, $attachment: CommonAttachmentInput!, $quotationRequestId: ID!) {
  answerByAttachmentFile(
    input: {answerInquiries: $answerInquiries, attachment: $attachment, quotationRequestId: $quotationRequestId}
  ) {
    quotation {
      ...QuotationV2Field
    }
  }
}
    ${QuotationV2FieldFragmentDoc}`;
export const AnswerByFileDocument = gql`
    mutation AnswerByFile($answerByFileInput: CommonAnswerByFileInput!) {
  answerByFile(input: {answerByFileInput: $answerByFileInput}) {
    isSuccess
    errors {
      ...ValidationErrField
    }
  }
}
    ${ValidationErrFieldFragmentDoc}`;
export const AnswerCalcDocument = gql`
    mutation AnswerCalc($input: CommonAnswerCalcInput!) {
  answerCalc(input: {answerCalcInput: $input}) {
    answerCalcResult {
      answerPrice {
        unitPrice
        materialCost
        partsCost
        processingCost
        surfaceProcessingCost
        subsidiaryMaterialCost
        paidSupplyPartSubtotal
        facilityCost
        facilityAmortizationCost
      }
      materialCosts {
        materialCostSubtotal
        scrap1Weight
        scrap1Subtotal
        materialCost
        uid
        scrapValueSubtotal
        materialCostSubtotalPerQty
        materialCostPerQty
        scrapValueSubtotalPerQty
        scrap1SubtotalPerQty
        scrap2SubtotalPerQty
        scrap2Subtotal
      }
      processingCosts {
        uid
        processingCost
        processingCostSubtotal
        setupCostSubtotal
      }
      surfaceProcessingCosts {
        uid
        processingCost
        processingCostSubtotal
        setupCostSubtotal
      }
      partsCosts {
        uid
        partsCost
      }
      facilityCosts {
        uid
        facilityCost
        amortizationCost
        amortizationNumber
      }
    }
  }
}
    `;
export const AnswerToGeneralEnqueteDocument = gql`
    mutation AnswerToGeneralEnquete($input: AnswerToGeneralEnqueteInput!) {
  answerToGeneralEnquete(input: $input) {
    enqueteAnswer {
      id
      status
      answeredAt
      enqueteQuestionAnswers {
        id
        value
        enqueteQuestion {
          id
        }
        attachments {
          id
          name
        }
      }
    }
    errors
  }
}
    `;
export const AnswerUpdateV2Document = gql`
    mutation AnswerUpdateV2($answer: CommonAnswerInput!) {
  answerUpdateV2(input: {answer: $answer}) {
    quotation {
      ...QuotationV2Field
    }
    errors {
      ...ValidationErrField
    }
  }
}
    ${QuotationV2FieldFragmentDoc}
${ValidationErrFieldFragmentDoc}`;
export const AnswerUpsertDocument = gql`
    mutation AnswerUpsert($answer: CommonAnswerUpsertInput!) {
  answerUpsert(input: {answer: $answer}) {
    isSuccess
    isCanBeAnswered
    errors {
      ...InputFormError
    }
    childErrors {
      structId
      errors {
        ...InputFormError
      }
    }
  }
}
    ${InputFormErrorFragmentDoc}`;
export const AnswerUpsertValidateDocument = gql`
    mutation AnswerUpsertValidate($answer: CommonAnswerUpsertInput!) {
  answerUpsertValidate(input: {answer: $answer}) {
    isSuccess
    isCanBeAnswered
    errors {
      ...InputFormError
    }
    childErrors {
      structId
      errors {
        ...InputFormError
      }
    }
  }
}
    ${InputFormErrorFragmentDoc}`;
export const AttachmentOfferDownloadEventCreateDocument = gql`
    mutation AttachmentOfferDownloadEventCreate($attachmentOfferId: ID!) {
  attachmentOfferDownloadEventCreate(
    input: {attachmentOfferId: $attachmentOfferId}
  ) {
    isSuccess
    downloadUrl
  }
}
    `;
export const AttachmentOffersDiscardDocument = gql`
    mutation AttachmentOffersDiscard($ids: [ID!]!) {
  attachmentOffersDiscard(input: {ids: $ids}) {
    isSuccess
    errors
  }
}
    `;
export const BcpIncidentAnswerRequestDraftsSaveDocument = gql`
    mutation BcpIncidentAnswerRequestDraftsSave($id: ID!, $drafts: [BcpIncidentAnswerRequestSiteInput!]!) {
  bcpIncidentAnswerRequestDraftsSave(input: {id: $id, drafts: $drafts}) {
    request {
      id
      drafts {
        id
        version
      }
    }
    errors {
      path
      message
      shortMessage
    }
  }
}
    `;
export const BcpIncidentAnswerRequestOpenedDocument = gql`
    mutation BcpIncidentAnswerRequestOpened($id: ID!) {
  bcpIncidentAnswerRequestOpened(input: {id: $id}) {
    errors {
      path
      message
      shortMessage
    }
  }
}
    `;
export const BcpIncidentAnswerRequestOpenedByTokenDocument = gql`
    mutation BcpIncidentAnswerRequestOpenedByToken($token: String!) {
  bcpIncidentAnswerRequestOpenedByToken(input: {token: $token}) {
    errors {
      path
      message
      shortMessage
    }
  }
}
    `;
export const BcpIncidentAnswerRequestPartsProposeDocument = gql`
    mutation BcpIncidentAnswerRequestPartsPropose($id: ID!, $situationText: String!) {
  bcpIncidentAnswerRequestPartsPropose(
    input: {id: $id, situationText: $situationText}
  ) {
    siteProposals {
      draftId
      proposals {
        partCode
        supplierCode
        impactKind
        comment
        groupIndex
        isOverridden
      }
    }
    unmatchedGroups {
      groupIndex
      impactKind
      comment
      allParts
      onlyUnanswered
      partCodePrefixes
      partCodes
      partNameContains
    }
    unreadInstructions
    unreadableAttachmentNames
    remainingCount
    errors {
      path
      message
      shortMessage
    }
  }
}
    `;
export const BcpIncidentAnswerRequestSubmitDocument = gql`
    mutation BcpIncidentAnswerRequestSubmit($id: ID!, $drafts: [BcpIncidentAnswerRequestSiteInput!]!) {
  bcpIncidentAnswerRequestSubmit(input: {id: $id, drafts: $drafts}) {
    request {
      id
    }
    errors {
      path
      message
      shortMessage
    }
  }
}
    `;
export const BcpIncidentAnswerRequestSubmitByTokenDocument = gql`
    mutation BcpIncidentAnswerRequestSubmitByToken($token: String!, $drafts: [BcpIncidentAnswerRequestTokenSiteInput!]!) {
  bcpIncidentAnswerRequestSubmitByToken(input: {token: $token, drafts: $drafts}) {
    state
    errors {
      path
      message
      shortMessage
    }
  }
}
    `;
export const ConfirmCommentReadDocument = gql`
    mutation ConfirmCommentRead($commentNodeId: ID!, $tenantId: ID!, $supplierCode: String) {
  confirmCommentRead(
    input: {commentNodeId: $commentNodeId, tenantId: $tenantId, supplierCode: $supplierCode}
  ) {
    success
    errors
  }
}
    `;
export const CrSupplierFirmBankInfoDeleteDocument = gql`
    mutation crSupplierFirmBankInfoDelete($supplierFirmInfoConfirmationRequestId: ID!, $id: ID!) {
  crSupplierFirmBankInfoDelete(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmBankInfoUpsertDocument = gql`
    mutation CrSupplierFirmBankInfoUpsert($supplierFirmInfoConfirmationRequestId: ID!, $id: ID) {
  crSupplierFirmBankInfoUpsert(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmCertificationInfoDeleteDocument = gql`
    mutation crSupplierFirmCertificationInfoDelete($supplierFirmInfoConfirmationRequestId: ID!, $id: ID!) {
  crSupplierFirmCertificationInfoDelete(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmCertificationInfoUpsertDocument = gql`
    mutation CrSupplierFirmCertificationInfoUpsert($supplierFirmInfoConfirmationRequestId: ID!, $id: ID) {
  crSupplierFirmCertificationInfoUpsert(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmEmployeeNumberInfoDeleteDocument = gql`
    mutation crSupplierFirmEmployeeNumberInfoDelete($supplierFirmInfoConfirmationRequestId: ID!, $id: ID!) {
  crSupplierFirmEmployeeNumberInfoDelete(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmEmployeeNumberInfoUpsertDocument = gql`
    mutation CrSupplierFirmEmployeeNumberInfoUpsert($supplierFirmInfoConfirmationRequestId: ID!, $id: ID) {
  crSupplierFirmEmployeeNumberInfoUpsert(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmEquipmentInfoDeleteDocument = gql`
    mutation crSupplierFirmEquipmentInfoDelete($supplierFirmInfoConfirmationRequestId: ID!, $id: ID!) {
  crSupplierFirmEquipmentInfoDelete(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmEquipmentInfoUpsertDocument = gql`
    mutation CrSupplierFirmEquipmentInfoUpsert($supplierFirmInfoConfirmationRequestId: ID!, $id: ID, $equipmentMachineName: String, $manufacturerName: String, $model: String, $year: String, $quantity: Float, $quantityUnit: String, $remarks: String, $location: String, $productionCapacity: String, $category: String) {
  crSupplierFirmEquipmentInfoUpsert(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id, equipmentMachineName: $equipmentMachineName, manufacturerName: $manufacturerName, model: $model, year: $year, quantity: $quantity, quantityUnit: $quantityUnit, remarks: $remarks, location: $location, productionCapacity: $productionCapacity, category: $category}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmFileInfoDeleteDocument = gql`
    mutation crSupplierFirmFileInfoDelete($supplierFirmInfoConfirmationRequestId: ID!, $id: ID!) {
  crSupplierFirmFileInfoDelete(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmFileInfoUpsertDocument = gql`
    mutation CrSupplierFirmFileInfoUpsert($supplierFirmInfoConfirmationRequestId: ID!, $id: ID, $supplierFileClassId: ID, $expirationDateFrom: ISO8601Date, $expirationDateTo: ISO8601Date, $attachment: AttachmentInput!, $memo: String) {
  crSupplierFirmFileInfoUpsert(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id, supplierFileClassId: $supplierFileClassId, expirationDateFrom: $expirationDateFrom, expirationDateTo: $expirationDateTo, attachment: $attachment, memo: $memo}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmFinancialDetailDeleteDocument = gql`
    mutation crSupplierFirmFinancialDetailDelete($supplierFirmInfoConfirmationRequestId: ID!, $id: ID!) {
  crSupplierFirmFinancialDetailDelete(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmFinancialDetailUpsertDocument = gql`
    mutation CrSupplierFirmFinancialDetailUpsert($supplierFirmInfoConfirmationRequestId: ID!, $id: ID) {
  crSupplierFirmFinancialDetailUpsert(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmFinancialInfoDeleteDocument = gql`
    mutation crSupplierFirmFinancialInfoDelete($supplierFirmInfoConfirmationRequestId: ID!, $id: ID!) {
  crSupplierFirmFinancialInfoDelete(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmFinancialInfoUpsertDocument = gql`
    mutation CrSupplierFirmFinancialInfoUpsert($supplierFirmInfoConfirmationRequestId: ID!, $id: ID) {
  crSupplierFirmFinancialInfoUpsert(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmKeyPositionInfoDeleteDocument = gql`
    mutation crSupplierFirmKeyPositionInfoDelete($supplierFirmInfoConfirmationRequestId: ID!, $id: ID!) {
  crSupplierFirmKeyPositionInfoDelete(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmKeyPositionInfoUpsertDocument = gql`
    mutation CrSupplierFirmKeyPositionInfoUpsert($supplierFirmInfoConfirmationRequestId: ID!, $id: ID) {
  crSupplierFirmKeyPositionInfoUpsert(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmManufacturingSiteDeleteDocument = gql`
    mutation crSupplierFirmManufacturingSiteDelete($supplierFirmInfoConfirmationRequestId: ID!, $id: ID!) {
  crSupplierFirmManufacturingSiteDelete(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmManufacturingSiteUpsertDocument = gql`
    mutation CrSupplierFirmManufacturingSiteUpsert($supplierFirmInfoConfirmationRequestId: ID!, $id: ID, $code: String, $name: String, $countryId: ID, $stateId: ID, $zipCode: String, $address: String, $tel: String, $fax: String, $landArea: Float, $landOwnershipKind: SupplierManufacturingSiteLandOwnershipKindEnum, $buildingArea: Float, $buildingOwnershipKind: SupplierManufacturingSiteBuildingOwnershipKindEnum, $president: String, $capitalAmount: Float, $capitalCurrencyId: ID, $businessDescription: String, $numberOfEmployees: Int, $establishedDate: ISO8601Date, $overseasExpansionDate: ISO8601Date, $investmentTypeName: String, $investmentRatio: Float, $partsMemo: String, $memo: String, $numberOfEmployeesOther: Int, $investorName: String, $investorName2: String, $investmentRatio2: Float) {
  crSupplierFirmManufacturingSiteUpsert(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id, code: $code, name: $name, countryId: $countryId, stateId: $stateId, zipCode: $zipCode, address: $address, tel: $tel, fax: $fax, landArea: $landArea, landOwnershipKind: $landOwnershipKind, buildingArea: $buildingArea, buildingOwnershipKind: $buildingOwnershipKind, president: $president, capitalAmount: $capitalAmount, capitalCurrencyId: $capitalCurrencyId, businessDescription: $businessDescription, numberOfEmployees: $numberOfEmployees, establishedDate: $establishedDate, overseasExpansionDate: $overseasExpansionDate, investmentTypeName: $investmentTypeName, investmentRatio: $investmentRatio, partsMemo: $partsMemo, memo: $memo, numberOfEmployeesOther: $numberOfEmployeesOther, investorName: $investorName, investorName2: $investorName2, investmentRatio2: $investmentRatio2}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmOutsourcingInfoDeleteDocument = gql`
    mutation crSupplierFirmOutsourcingInfoDelete($supplierFirmInfoConfirmationRequestId: ID!, $id: ID!) {
  crSupplierFirmOutsourcingInfoDelete(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmOutsourcingInfoUpsertDocument = gql`
    mutation CrSupplierFirmOutsourcingInfoUpsert($supplierFirmInfoConfirmationRequestId: ID!, $id: ID, $name: String, $siteName: String, $countryId: ID, $stateId: ID, $zipCode: String, $address: String, $industry: String, $transactionItem: String, $factory: String, $salesAmount: Float, $transactionAmount: Float, $numberOfEmployees: Int, $president: String, $purchaseRate: Float, $processingType: String, $tenantDependencyRate: Float, $capitalAmount: Float, $remarks: String, $certificationInfo: String, $supplierOutsourcingClassIds: [ID!]) {
  crSupplierFirmOutsourcingInfoUpsert(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id, name: $name, siteName: $siteName, countryId: $countryId, stateId: $stateId, zipCode: $zipCode, address: $address, industry: $industry, transactionItem: $transactionItem, factory: $factory, salesAmount: $salesAmount, transactionAmount: $transactionAmount, numberOfEmployees: $numberOfEmployees, president: $president, purchaseRate: $purchaseRate, processingType: $processingType, tenantDependencyRate: $tenantDependencyRate, capitalAmount: $capitalAmount, remarks: $remarks, certificationInfo: $certificationInfo, supplierOutsourcingClassIds: $supplierOutsourcingClassIds}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmRepresentativeInfoDeleteDocument = gql`
    mutation crSupplierFirmRepresentativeInfoDelete($supplierFirmInfoConfirmationRequestId: ID!, $id: ID!) {
  crSupplierFirmRepresentativeInfoDelete(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmRepresentativeInfoUpsertDocument = gql`
    mutation CrSupplierFirmRepresentativeInfoUpsert($supplierFirmInfoConfirmationRequestId: ID!, $id: ID) {
  crSupplierFirmRepresentativeInfoUpsert(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmSalesStatusInfoDeleteDocument = gql`
    mutation crSupplierFirmSalesStatusInfoDelete($supplierFirmInfoConfirmationRequestId: ID!, $id: ID!) {
  crSupplierFirmSalesStatusInfoDelete(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmSalesStatusInfoUpsertDocument = gql`
    mutation CrSupplierFirmSalesStatusInfoUpsert($supplierFirmInfoConfirmationRequestId: ID!, $id: ID) {
  crSupplierFirmSalesStatusInfoUpsert(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmShareholderInfoDeleteDocument = gql`
    mutation crSupplierFirmShareholderInfoDelete($supplierFirmInfoConfirmationRequestId: ID!, $id: ID!) {
  crSupplierFirmShareholderInfoDelete(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmShareholderInfoUpsertDocument = gql`
    mutation CrSupplierFirmShareholderInfoUpsert($supplierFirmInfoConfirmationRequestId: ID!, $id: ID) {
  crSupplierFirmShareholderInfoUpsert(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmSiteDeleteDocument = gql`
    mutation crSupplierFirmSiteDelete($supplierFirmInfoConfirmationRequestId: ID!, $id: ID!) {
  crSupplierFirmSiteDelete(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmSiteUpsertDocument = gql`
    mutation CrSupplierFirmSiteUpsert($supplierFirmInfoConfirmationRequestId: ID!, $id: ID, $code: String, $name: String, $countryId: ID, $stateId: ID, $zipCode: String, $address: String, $tel: String, $fax: String, $landArea: Float, $landOwnershipKind: SupplierSiteLandOwnershipKindEnum, $buildingArea: Float, $buildingOwnershipKind: SupplierSiteBuildingOwnershipKindEnum, $president: String, $capitalAmount: Float, $capitalCurrencyId: ID, $businessDescription: String, $numberOfEmployees: Int, $establishedDate: ISO8601Date, $overseasExpansionDate: ISO8601Date, $investmentTypeName: String, $investmentRatio: Float, $partsMemo: String, $memo: String, $numberOfEmployeesOther: Int, $investorName: String, $investorName2: String, $investmentRatio2: Float) {
  crSupplierFirmSiteUpsert(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id, code: $code, name: $name, countryId: $countryId, stateId: $stateId, zipCode: $zipCode, address: $address, tel: $tel, fax: $fax, landArea: $landArea, landOwnershipKind: $landOwnershipKind, buildingArea: $buildingArea, buildingOwnershipKind: $buildingOwnershipKind, president: $president, capitalAmount: $capitalAmount, capitalCurrencyId: $capitalCurrencyId, businessDescription: $businessDescription, numberOfEmployees: $numberOfEmployees, establishedDate: $establishedDate, overseasExpansionDate: $overseasExpansionDate, investmentTypeName: $investmentTypeName, investmentRatio: $investmentRatio, partsMemo: $partsMemo, memo: $memo, numberOfEmployeesOther: $numberOfEmployeesOther, investorName: $investorName, investorName2: $investorName2, investmentRatio2: $investmentRatio2}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmUpsertDocument = gql`
    mutation CrSupplierFirmUpsert($supplierFirmInfoConfirmationRequestId: ID!, $id: ID, $name: String, $nameShort: String, $nameEn: String, $nameKana: String, $president: String, $url: String, $capital: Float, $capitalCurrencyId: ID, $tel: String, $fax: String, $email: String, $establishedDate: String, $numberOfEmployees: Int, $listingKind: String, $closingMonth: String, $countryId: ID, $stateId: ID, $zipCode: String, $address: String, $issuedShares: Float, $startTransactionDate: String, $dividendAmount: Float, $companyBackground: String, $industryId: ID, $numberOfEmployeesOther: Int, $businessDescription: String, $generalText1: String, $generalText2: String, $generalText3: String, $generalText4: String, $generalText5: String, $generalText6: String, $generalText7: String, $generalText8: String, $generalText9: String, $generalText10: String, $generalText11: String, $generalText12: String, $generalText13: String, $generalText14: String, $generalText15: String, $generalText16: String, $generalText17: String, $generalText18: String, $generalText19: String, $generalText20: String, $generalKind1: ID, $generalKind2: ID, $generalKind3: ID, $generalKind4: ID, $generalKind5: ID, $generalKind6: ID, $generalKind7: ID, $generalKind8: ID, $generalKind9: ID, $generalKind10: ID, $generalKinds1: [ID!], $generalKinds2: [ID!], $generalKinds3: [ID!], $generalKinds4: [ID!], $generalKinds5: [ID!], $generalKinds6: [ID!], $generalKinds7: [ID!], $generalKinds8: [ID!], $generalKinds9: [ID!], $generalKinds10: [ID!]) {
  crSupplierFirmUpsert(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id, name: $name, nameShort: $nameShort, nameEn: $nameEn, nameKana: $nameKana, president: $president, url: $url, capital: $capital, capitalCurrencyId: $capitalCurrencyId, tel: $tel, fax: $fax, email: $email, establishedDate: $establishedDate, numberOfEmployees: $numberOfEmployees, listingKind: $listingKind, closingMonth: $closingMonth, countryId: $countryId, stateId: $stateId, zipCode: $zipCode, address: $address, issuedShares: $issuedShares, startTransactionDate: $startTransactionDate, dividendAmount: $dividendAmount, companyBackground: $companyBackground, industryId: $industryId, numberOfEmployeesOther: $numberOfEmployeesOther, businessDescription: $businessDescription, generalText1: $generalText1, generalText2: $generalText2, generalText3: $generalText3, generalText4: $generalText4, generalText5: $generalText5, generalText6: $generalText6, generalText7: $generalText7, generalText8: $generalText8, generalText9: $generalText9, generalText10: $generalText10, generalText11: $generalText11, generalText12: $generalText12, generalText13: $generalText13, generalText14: $generalText14, generalText15: $generalText15, generalText16: $generalText16, generalText17: $generalText17, generalText18: $generalText18, generalText19: $generalText19, generalText20: $generalText20, generalKind1: $generalKind1, generalKind2: $generalKind2, generalKind3: $generalKind3, generalKind4: $generalKind4, generalKind5: $generalKind5, generalKind6: $generalKind6, generalKind7: $generalKind7, generalKind8: $generalKind8, generalKind9: $generalKind9, generalKind10: $generalKind10, generalKinds1: $generalKinds1, generalKinds2: $generalKinds2, generalKinds3: $generalKinds3, generalKinds4: $generalKinds4, generalKinds5: $generalKinds5, generalKinds6: $generalKinds6, generalKinds7: $generalKinds7, generalKinds8: $generalKinds8, generalKinds9: $generalKinds9, generalKinds10: $generalKinds10}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmUserInfoDeleteDocument = gql`
    mutation crSupplierFirmUserInfoDelete($supplierFirmInfoConfirmationRequestId: ID!, $id: ID!) {
  crSupplierFirmUserInfoDelete(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id}
  ) {
    errors
  }
}
    `;
export const CrSupplierFirmUserInfoUpsertDocument = gql`
    mutation CrSupplierFirmUserInfoUpsert($supplierFirmInfoConfirmationRequestId: ID!, $id: ID, $contactClassIds: [ID!], $name: String, $nameKana: String, $email: String, $emailEmergency: String, $tel: String, $telEmergency: String, $fax: String, $department: String, $endOn: ISO8601Date, $title: String, $zipCode: String, $address: String, $mailingAddress: String) {
  crSupplierFirmUserInfoUpsert(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, id: $id, contactClassIds: $contactClassIds, name: $name, nameKana: $nameKana, email: $email, emailEmergency: $emailEmergency, tel: $tel, telEmergency: $telEmergency, fax: $fax, department: $department, endOn: $endOn, title: $title, zipCode: $zipCode, address: $address, mailingAddress: $mailingAddress}
  ) {
    errors
  }
}
    `;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($id: ID!, $tenantId: ID!, $supplierCode: String) {
  deleteComment(
    input: {id: $id, tenantId: $tenantId, supplierCode: $supplierCode}
  ) {
    commentNode {
      ...CommentNodeField
    }
    errors
  }
}
    ${CommentNodeFieldFragmentDoc}`;
export const DeliveredAnnouncementConfirmDocument = gql`
    mutation DeliveredAnnouncementConfirm($id: ID!) {
  deliveredAnnouncementConfirm(input: {id: $id}) {
    deliveredAnnouncement {
      id
    }
    errors {
      message
    }
  }
}
    `;
export const DeliveredAnnouncementViewDocument = gql`
    mutation DeliveredAnnouncementView($id: ID!) {
  deliveredAnnouncementView(input: {id: $id}) {
    deliveredAnnouncement {
      id
      viewedAt
    }
    errors {
      message
    }
  }
}
    `;
export const GenerateSupplierSurveyInfoImportExcelDocument = gql`
    mutation GenerateSupplierSurveyInfoImportExcel($supplierFirmInfoConfirmationRequestId: ID!) {
  generateSupplierSurveyInfoImportExcel(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId}
  ) {
    errors
    signedUrl
    fileName
  }
}
    `;
export const MoldDisposalSupplierApplicationDisposeDocument = gql`
    mutation MoldDisposalSupplierApplicationDispose($id: ID!, $attachments: [CommonAttachmentInput!], $comment: String) {
  moldDisposalSupplierApplicationDispose(
    input: {id: $id, attachments: $attachments, comment: $comment}
  ) {
    moldDisposalSupplierApplication {
      id
      uid
      status
      applicationDate
      confirmationDueDate
      comment
      supplier {
        id
        name
        code
      }
      employee {
        id
        name
      }
      supplierUser {
        id
        name
      }
      tenant {
        id
        name
      }
      attachments {
        id
        name
        fileType
        size
      }
      moldDisposalSupplierApplicationDetails {
        id
        disposeRequestDate
        disposeCost
        publicMemo
        mold {
          id
          uid
          name
        }
      }
    }
  }
}
    `;
export const MoldDisposalSupplierApplicationSaveDocument = gql`
    mutation MoldDisposalSupplierApplicationSave($previousId: ID, $comment: String, $tenantId: ID!, $supplierId: ID!, $employeeId: ID!, $supplierAccountId: ID, $supplierUserId: ID, $attachments: [CommonAttachmentInput!], $confirmationDueDate: ISO8601Date!, $title: String!, $moldDisposalSupplierApplicationDetails: [MoldDisposalSupplierApplicationDetailInput!]!) {
  moldDisposalSupplierApplicationSave(
    input: {previousId: $previousId, comment: $comment, tenantId: $tenantId, supplierId: $supplierId, employeeId: $employeeId, supplierAccountId: $supplierAccountId, supplierUserId: $supplierUserId, attachments: $attachments, confirmationDueDate: $confirmationDueDate, title: $title, moldDisposalSupplierApplicationDetails: $moldDisposalSupplierApplicationDetails}
  ) {
    moldDisposalSupplierApplication {
      id
      uid
      title
      comment
      confirmationDueDate
      status
      moldDisposalSupplierApplicationDetails {
        id
        mold {
          ...MoldField
        }
        disposeCost
        disposeRequestDate
        publicMemo
        scrapCost
      }
    }
  }
}
    ${MoldFieldFragmentDoc}`;
export const PackageBulkAnswerAiDraftDocument = gql`
    mutation PackageBulkAnswerAiDraft($input: PackageBulkAnswerAiDraftInput!) {
  packageBulkAnswerAiDraft(input: $input) {
    rows {
      quotationRequestId
      priceBasis
      unitPrice
      amountExcludingTax
      deliveryDay
      declineSuggested
    }
    quotationNo
    expirationDate
    currencyId
    note
    errors
  }
}
    `;
export const PackageBulkAnswerSubmitDocument = gql`
    mutation PackageBulkAnswerSubmit($input: PackageBulkAnswerSubmitInput!) {
  packageBulkAnswerSubmit(input: $input) {
    isSuccess
    isConflict
    conflictQuotationRequestIds
    errors
    rowErrors {
      quotationRequestId
      messages
      formErrors {
        formSchemaCode
        dictKey
        field
        messages
        seqNo
      }
    }
  }
}
    `;
export const PartCsvExportDocument = gql`
    mutation partCsvExport($code: String, $figureNumber: String, $referenceDate: String, $searchType: String, $conditionsText: String, $supplierCode: String, $tenantId: ID!) {
  partCsvExport(
    input: {code: $code, figureNumber: $figureNumber, referenceDate: $referenceDate, searchType: $searchType, conditionsText: $conditionsText, supplierCode: $supplierCode, tenantId: $tenantId}
  ) {
    res {
      ...CsvExportResField
    }
  }
}
    ${CsvExportResFieldFragmentDoc}`;
export const PriceAdjustmentAmendDocument = gql`
    mutation PriceAdjustmentAmend($input: PriceAdjustmentAmendInput!) {
  priceAdjustmentAmend(input: $input) {
    priceAdjustment {
      id
    }
    errors {
      ...ValidationErrField
    }
  }
}
    ${ValidationErrFieldFragmentDoc}`;
export const PriceAdjustmentAmendAskingDocument = gql`
    mutation PriceAdjustmentAmendAsking($input: PriceAdjustmentAmendAskingInput!) {
  priceAdjustmentAmendAsking(input: $input) {
    priceAdjustment {
      id
    }
    errors {
      ...ValidationErrField
    }
  }
}
    ${ValidationErrFieldFragmentDoc}`;
export const PriceAdjustmentAnswerDocument = gql`
    mutation PriceAdjustmentAnswer($input: PriceAdjustmentAnswerInput!) {
  priceAdjustmentAnswer(input: $input) {
    priceAdjustment {
      id
    }
    errors {
      ...ValidationErrField
    }
  }
}
    ${ValidationErrFieldFragmentDoc}`;
export const PriceAdjustmentApplicationDocument = gql`
    mutation PriceAdjustmentApplication($input: PriceAdjustmentApplicationInput!) {
  priceAdjustmentApplication(input: $input) {
    priceAdjustment {
      id
    }
    errors
    inputFormErrors {
      ...InputFormError
    }
  }
}
    ${InputFormErrorFragmentDoc}`;
export const PriceAdjustmentApproveDocument = gql`
    mutation PriceAdjustmentApprove($input: priceAdjustmentApproveInput!) {
  priceAdjustmentApprove(input: $input) {
    priceAdjustment {
      id
    }
    errors
  }
}
    `;
export const PriceAdjustmentAskDocument = gql`
    mutation PriceAdjustmentAsk($input: PriceAdjustmentAskInput!) {
  priceAdjustmentAsk(input: $input) {
    priceAdjustment {
      id
    }
    errors {
      ...ValidationErrField
    }
  }
}
    ${ValidationErrFieldFragmentDoc}`;
export const PriceAdjustmentCloseDocument = gql`
    mutation PriceAdjustmentClose($input: PriceAdjustmentCloseInput!) {
  priceAdjustmentClose(input: $input) {
    id
    errors {
      ...ValidationErrField
    }
  }
}
    ${ValidationErrFieldFragmentDoc}`;
export const PriceAdjustmentCompleteDocument = gql`
    mutation PriceAdjustmentComplete($input: PriceAdjustmentCompleteInput!) {
  priceAdjustmentComplete(input: $input) {
    priceAdjustment {
      id
    }
    errors {
      ...ValidationErrField
    }
  }
}
    ${ValidationErrFieldFragmentDoc}`;
export const PriceAdjustmentCreateByPartOrderUnitPriceDocument = gql`
    mutation PriceAdjustmentCreateByPartOrderUnitPrice($partOrderUnitPriceIds: [ID!]!, $tenantId: ID!) {
  priceAdjustmentCreateByPartOrderUnitPrice(
    input: {partOrderUnitPriceIds: $partOrderUnitPriceIds, tenantId: $tenantId}
  ) {
    priceAdjustment {
      id
      tenantCode
    }
    errors {
      ...ValidationErrField
    }
  }
}
    ${ValidationErrFieldFragmentDoc}`;
export const PriceAdjustmentDeleteDocument = gql`
    mutation PriceAdjustmentDelete($input: PriceAdjustmentDeleteInput!) {
  priceAdjustmentDelete(input: $input) {
    id
    errors {
      ...ValidationErrField
    }
  }
}
    ${ValidationErrFieldFragmentDoc}`;
export const PriceAdjustmentExcelExportDocument = gql`
    mutation PriceAdjustmentExcelExport($input: PriceAdjustmentExcelExportInput!) {
  priceAdjustmentExcelExport(input: $input) {
    signedUrl
    errors {
      ...ValidationErrField
    }
  }
}
    ${ValidationErrFieldFragmentDoc}`;
export const PriceAdjustmentExcelSchemaExportDocument = gql`
    mutation PriceAdjustmentExcelSchemaExport($input: PriceAdjustmentExcelSchemaExportInput!) {
  priceAdjustmentExcelSchemaExport(input: $input) {
    fileName
    fileUrl
    errors {
      ...ValidationErrField
    }
  }
}
    ${ValidationErrFieldFragmentDoc}`;
export const PriceAdjustmentExcelSchemaImportDocument = gql`
    mutation priceAdjustmentExcelSchemaImport($input: PriceAdjustmentExcelSchemaImportInput!) {
  priceAdjustmentExcelSchemaImport(input: $input) {
    deletedItemIds
    deletedSubpartIds
    deletedProcessingIds
    deletedSubsidiaryMaterialIds
    priceAdjustmentItems {
      ...priceAdjustmentItemForFormField
    }
    validationErrors
    errors {
      ...ValidationErrField
    }
  }
}
    ${PriceAdjustmentItemForFormFieldFragmentDoc}
${ValidationErrFieldFragmentDoc}`;
export const PriceAdjustmentItemValidateDocument = gql`
    mutation PriceAdjustmentItemValidate($input: PriceAdjustmentItemValidateInput!) {
  priceAdjustmentItemValidate(input: $input) {
    errors {
      ...InputFormError
    }
    isValid
  }
}
    ${InputFormErrorFragmentDoc}`;
export const PriceAdjustmentSaveDocument = gql`
    mutation PriceAdjustmentSave($input: priceAdjustmentSaveInput!) {
  priceAdjustmentSave(input: $input) {
    priceAdjustment {
      id
    }
    errors
    inputFormErrors {
      ...InputFormError
    }
  }
}
    ${InputFormErrorFragmentDoc}`;
export const PriceAdjustmentUpdateDocument = gql`
    mutation PriceAdjustmentUpdate($input: PriceAdjustmentUpdateInput!) {
  priceAdjustmentUpdate(input: $input) {
    priceAdjustment {
      id
    }
    errors {
      ...ValidationErrField
    }
  }
}
    ${ValidationErrFieldFragmentDoc}`;
export const PriceAdjustmentWithdrawDocument = gql`
    mutation PriceAdjustmentWithdraw($input: PriceAdjustmentWithdrawInput!) {
  priceAdjustmentWithdraw(input: $input) {
    priceAdjustment {
      id
    }
    errors
  }
}
    `;
export const PriceAdjustmentsCreatableCheckDocument = gql`
    mutation PriceAdjustmentsCreatableCheck($code: String, $figureNumber: String, $searchType: String, $referenceDate: String, $supplierCode: String, $tenantId: ID!) {
  priceAdjustmentsCreatableCheck(
    input: {code: $code, figureNumber: $figureNumber, searchType: $searchType, referenceDate: $referenceDate, supplierCode: $supplierCode, tenantId: $tenantId}
  ) {
    priceAdjustableIds
    priceUnadjustablePartCodeAndNames
    err
  }
}
    `;
export const PriceAdjustmentsCreatableCheckByIdsDocument = gql`
    mutation PriceAdjustmentsCreatableCheckByIds($ids: [ID!]!) {
  priceAdjustmentsCreatableCheckByIds(input: {ids: $ids}) {
    priceAdjustableIds
    priceUnadjustablePartCodeAndNames
    err
  }
}
    `;
export const PriceAdjustmentsCreateDocument = gql`
    mutation PriceAdjustmentsCreate($partsId: [ID!]!, $targetTerm: String!, $adjustmentPurpose: String!, $confirmationStartDate: ISO8601Date, $confirmationDeadlineDate: ISO8601Date, $tenantId: ID!, $supplierCode: String) {
  priceAdjustmentsCreate(
    input: {partsId: $partsId, targetTerm: $targetTerm, adjustmentPurpose: $adjustmentPurpose, confirmationStartDate: $confirmationStartDate, confirmationDeadlineDate: $confirmationDeadlineDate, tenantId: $tenantId, supplierCode: $supplierCode}
  ) {
    priceAdjustments {
      id
    }
    errors {
      ...ValidationErrField
    }
  }
}
    ${ValidationErrFieldFragmentDoc}`;
export const PriceAdjustmentsCsvCreateDocument = gql`
    mutation PriceAdjustmentsCsvCreate($input: PriceAdjustmentsCsvCreateInput!) {
  priceAdjustmentsCsvCreate(input: $input) {
    priceAdjustments {
      id
    }
    errors {
      ...ValidationErrField
    }
    errorRecords {
      row
      message
    }
  }
}
    ${ValidationErrFieldFragmentDoc}`;
export const ProfileUpdateDocument = gql`
    mutation ProfileUpdate($name: String!, $email: String!, $tel: String!, $department: String!, $title: String!, $password: String!, $passwordConfirmation: String!, $languageCode: String!, $csvExportEncodingKind: SupplierUserCsvExportEncodingKindEnum, $tenantAssignments: [TenantAssignmentInput!]) {
  profileUpdate(
    input: {name: $name, email: $email, tel: $tel, department: $department, title: $title, password: $password, passwordConfirmation: $passwordConfirmation, languageCode: $languageCode, csvExportEncodingKind: $csvExportEncodingKind, tenantAssignments: $tenantAssignments}
  ) {
    profile {
      id
      name
      email
    }
    err
  }
}
    `;
export const QuotationsDeclineDocument = gql`
    mutation QuotationsDecline($declineMemo: String, $quotationRequestIds: [ID!]!) {
  quotationsDecline(
    input: {declineMemo: $declineMemo, quotationRequestIds: $quotationRequestIds}
  ) {
    isSuccess
    errors
  }
}
    `;
export const ShareCommentUpsertDocument = gql`
    mutation ShareCommentUpsert($input: ShareCommentUpsertInput!) {
  shareCommentUpsert(input: $input) {
    shareComment {
      id
      serviceId
      textMemo1
      textMemo2
      textMemo3
      textMemo4
      textMemo5
      numericMemo1
      numericMemo2
      numericMemo3
      numericMemo4
      numericMemo5
      dateMemo1
      dateMemo2
      dateMemo3
      dateMemo4
      dateMemo5
      booleanMemo1
      booleanMemo2
      booleanMemo3
      booleanMemo4
      booleanMemo5
    }
    err
  }
}
    `;
export const SharedDataCsvExportDocument = gql`
    mutation sharedDataCsvExport($tenantId: ID!, $supplierCode: String!, $shareConfigId: ID!, $keyword: String, $shareId: ID) {
  sharedDataCsvExport(
    input: {tenantId: $tenantId, supplierCode: $supplierCode, shareConfigId: $shareConfigId, keyword: $keyword, shareId: $shareId}
  ) {
    res {
      ...CsvExportResField
    }
  }
}
    ${CsvExportResFieldFragmentDoc}`;
export const SharedDataCsvImportDocument = gql`
    mutation sharedDataCsvImport($tenantId: ID!, $supplierCode: String!, $shareConfigId: ID!, $fileUrl: String!, $shareId: ID!) {
  sharedDataCsvImport(
    input: {tenantId: $tenantId, supplierCode: $supplierCode, shareConfigId: $shareConfigId, fileUrl: $fileUrl, shareId: $shareId}
  ) {
    result {
      successCount
      errorCount
      errors {
        row
        message
      }
    }
    errs
  }
}
    `;
export const SupplierAccountInvitationBySupplierFrontendCompleteDocument = gql`
    mutation SupplierAccountInvitationBySupplierFrontendComplete($token: String!) {
  supplierAccountInvitationBySupplierFrontendComplete(input: {token: $token}) {
    err
  }
}
    `;
export const SupplierAccountInvitationByTenantFrontendCompleteDocument = gql`
    mutation SupplierAccountInvitationByTenantFrontendComplete($token: String!) {
  supplierAccountInvitationByTenantFrontendComplete(input: {token: $token}) {
    err
  }
}
    `;
export const SupplierAccountSelectedTenantUpdateDocument = gql`
    mutation SupplierAccountSelectedTenantUpdate($tenantId: ID!) {
  supplierAccountSelectedTenantUpdate(input: {tenantId: $tenantId}) {
    tenantName
    errors {
      ...ValidationErrField
    }
  }
}
    ${ValidationErrFieldFragmentDoc}`;
export const SupplierAccountTenantLinkDeleteDocument = gql`
    mutation SupplierAccountTenantLinkDelete($supplierAccountId: ID!, $tenantId: ID!, $supplierCode: String!, $endedAt: String) {
  supplierAccountTenantLinkDelete(
    input: {supplierAccountId: $supplierAccountId, tenantId: $tenantId, supplierCode: $supplierCode, endedAt: $endedAt}
  ) {
    err
  }
}
    `;
export const SupplierAccountTenantLinkRestoreDocument = gql`
    mutation SupplierAccountTenantLinkRestore($supplierAccountId: ID!, $tenantId: ID!, $supplierCode: String!, $startedAt: String, $isSendSupplierFirmInfoConfirmationRequest: Boolean) {
  supplierAccountTenantLinkRestore(
    input: {supplierAccountId: $supplierAccountId, tenantId: $tenantId, supplierCode: $supplierCode, startedAt: $startedAt, isSendSupplierFirmInfoConfirmationRequest: $isSendSupplierFirmInfoConfirmationRequest}
  ) {
    err
  }
}
    `;
export const SupplierAccountTenantLinkUpsertDocument = gql`
    mutation SupplierAccountTenantLinkUpsert($supplierAccountId: ID!, $tenantId: ID!, $supplierCode: String!, $startedAt: String, $isSendNotification: Boolean!, $isSendSupplierFirmInfoConfirmationRequest: Boolean) {
  supplierAccountTenantLinkUpsert(
    input: {supplierAccountId: $supplierAccountId, tenantId: $tenantId, supplierCode: $supplierCode, startedAt: $startedAt, isSendNotification: $isSendNotification, isSendSupplierFirmInfoConfirmationRequest: $isSendSupplierFirmInfoConfirmationRequest}
  ) {
    err
  }
}
    `;
export const SupplierAnnouncementReadDocument = gql`
    mutation SupplierAnnouncementRead {
  supplierAnnouncementsRead(input: {}) {
    result
  }
}
    `;
export const SupplierCorporationEmployeeArchiveDocument = gql`
    mutation SupplierCorporationEmployeeArchive($id: ID!) {
  supplierCorporationEmployeeArchive(input: {id: $id}) {
    supplierCorporationEmployee {
      id
    }
    errors {
      ...ValidationErrField
    }
  }
}
    ${ValidationErrFieldFragmentDoc}`;
export const SupplierCorporationEmployeeUnarchiveDocument = gql`
    mutation SupplierCorporationEmployeeUnarchive($id: ID!) {
  supplierCorporationEmployeeUnarchive(input: {id: $id}) {
    supplierCorporationEmployee {
      id
    }
    errors {
      ...ValidationErrField
    }
  }
}
    ${ValidationErrFieldFragmentDoc}`;
export const SupplierFirmInfoConfirmationRequestStatusUpdateDocument = gql`
    mutation SupplierFirmInfoConfirmationRequestStatusUpdate($id: ID, $status: SupplierFirmInfoConfirmationRequestStatusEnum) {
  supplierFirmInfoConfirmationRequestStatusUpdate(
    input: {id: $id, status: $status}
  ) {
    errors
  }
}
    `;
export const SupplierMoldStorageApplicationSaveDocument = gql`
    mutation SupplierMoldStorageApplicationSave($previousId: ID, $title: String!, $comment: String, $tenantId: ID!, $supplierId: ID!, $employeeId: ID!, $supplierAccountId: ID, $supplierUserId: ID, $attachments: [CommonAttachmentInput!], $confirmationDueDate: ISO8601Date!, $supplierMoldStorageApplicationDetails: [SupplierMoldStorageApplicationDetailInput!]!) {
  supplierMoldStorageApplicationSave(
    input: {previousId: $previousId, title: $title, comment: $comment, tenantId: $tenantId, supplierId: $supplierId, employeeId: $employeeId, supplierAccountId: $supplierAccountId, supplierUserId: $supplierUserId, attachments: $attachments, confirmationDueDate: $confirmationDueDate, supplierMoldStorageApplicationDetails: $supplierMoldStorageApplicationDetails}
  ) {
    supplierMoldStorageApplication {
      id
      uid
      title
      comment
      confirmationDueDate
      status
      supplierMoldStorageApplicationDetails {
        id
        mold {
          ...MoldField
        }
        storageCost
        storageStartDate
        publicMemo
      }
    }
  }
}
    ${MoldFieldFragmentDoc}`;
export const SupplierPriceAdjustmentFormAmendDocument = gql`
    mutation SupplierPriceAdjustmentFormAmend($input: amendSupplierPriceAdjustmentDraftInput!) {
  priceAdjustmentAmendForm(input: $input) {
    priceAdjustment {
      id
      tenantCode
      targetTerm
      memo
      confirmationDeadlineDate
    }
    errors
  }
}
    `;
export const SupplierSurveyInfoExcelImportDocument = gql`
    mutation SupplierSurveyInfoExcelImport($supplierFirmInfoConfirmationRequestId: ID!, $importTargetExcel: AttachmentInput!) {
  supplierSurveyInfoExcelImport(
    input: {supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId, importTargetExcel: $importTargetExcel}
  ) {
    errors
    warnings
  }
}
    `;
export const SupplyPartCsvExportDocument = gql`
    mutation SupplyPartCsvExport($tenantId: String!, $code: String, $figureNumber: String, $assignmentPriceKind: String, $referenceDate: String, $searchType: String, $conditionsText: String, $supplierCode: String) {
  supplyPartCsvExport(
    input: {tenantId: $tenantId, code: $code, figureNumber: $figureNumber, assignmentPriceKind: $assignmentPriceKind, referenceDate: $referenceDate, searchType: $searchType, conditionsText: $conditionsText, supplierCode: $supplierCode}
  ) {
    res {
      ...CsvExportResField
    }
  }
}
    ${CsvExportResFieldFragmentDoc}`;
export const TrialQuotationAnswerAiDraftDocument = gql`
    mutation TrialQuotationAnswerAiDraft($input: TrialQuotationAnswerAiDraftInput!) {
  trialQuotationAnswerAiDraft(input: $input) {
    items {
      quotationItemId
      unitPrice
      taxType
      breakdowns {
        name
        quantity
        unitName
        unitPrice
      }
    }
    note
    quotationValidUntil
    errors
  }
}
    `;
export const TrialQuotationAnswerCancelDocument = gql`
    mutation TrialQuotationAnswerCancel($input: TrialQuotationAnswerCancelInput!) {
  trialQuotationAnswerCancel(input: $input) {
    answer {
      ...TrialQuotationAnswerRevisionField
    }
    errors
  }
}
    ${TrialQuotationAnswerRevisionFieldFragmentDoc}`;
export const TrialQuotationAnswerSubmitDocument = gql`
    mutation TrialQuotationAnswerSubmit($input: TrialQuotationAnswerSubmitInput!) {
  trialQuotationAnswerSubmit(input: $input) {
    answer {
      ...TrialQuotationAnswerRevisionField
    }
    conflict
    errors
  }
}
    ${TrialQuotationAnswerRevisionFieldFragmentDoc}`;
export const TrialQuotationAttachmentClassifyDocument = gql`
    mutation TrialQuotationAttachmentClassify($input: TrialQuotationAttachmentClassifyInput!) {
  trialQuotationAttachmentClassify(input: $input) {
    classifications {
      url
      attachmentKind
    }
    errors
  }
}
    `;
export const UpdateCommentDocument = gql`
    mutation UpdateComment($id: ID!, $body: String!, $tenantId: ID!, $attachments: [AttachmentInput!], $supplierCode: String) {
  updateComment(
    input: {id: $id, body: $body, tenantId: $tenantId, attachments: $attachments, supplierCode: $supplierCode}
  ) {
    commentNode {
      ...CommentNodeField
    }
    errors
  }
}
    ${CommentNodeFieldFragmentDoc}`;
export const AdminUsersDocument = gql`
    query AdminUsers($tenantId: ID!, $roleCondition: JSON) {
  adminUsers(tenantId: $tenantId, roleCondition: $roleCondition) {
    nodes {
      id
      name
      email
      adminUserGroups {
        id
        name
      }
    }
  }
}
    `;
export const AdminUsersByTransactionDocument = gql`
    query AdminUsersByTransaction($tenantId: ID!, $transactionKind: String!) {
  adminUsersByTransaction(tenantId: $tenantId, transactionKind: $transactionKind) {
    nodes {
      id
      name
    }
  }
}
    `;
export const AgreementsDocument = gql`
    query Agreements {
  termsOfService {
    ...VersionedAgreementField
  }
  privacyPolicy {
    ...VersionedAgreementField
  }
}
    ${VersionedAgreementFieldFragmentDoc}`;
export const AllStatesDocument = gql`
    query AllStates {
  allStates {
    id
    name
    countryId
  }
}
    `;
export const AttachmentOfferDocument = gql`
    query AttachmentOffer($id: ID!) {
  attachmentOffer(id: $id) {
    ...AttachmentOfferField
  }
  selectedTenant {
    id
  }
}
    ${AttachmentOfferFieldFragmentDoc}`;
export const AttachmentOffersDocument = gql`
    query AttachmentOffers($first: Int, $last: Int, $ids: [ID!], $itemCode: String, $itemName: String, $itemRootCode: String, $statuses: [String!], $adminUserIds: [ID!], $uid: String, $tenantId: ID!, $figureNumber: String, $fileName: String, $supplierCode: String) {
  attachmentOffers(
    first: $first
    last: $last
    ids: $ids
    itemCode: $itemCode
    itemName: $itemName
    itemRootCode: $itemRootCode
    statuses: $statuses
    adminUserIds: $adminUserIds
    uid: $uid
    tenantId: $tenantId
    figureNumber: $figureNumber
    fileName: $fileName
    supplierCode: $supplierCode
  ) {
    totalCount
    pageInfo {
      ...PageInfoField
    }
    nodes {
      ...AttachmentOfferListField
    }
  }
}
    ${PageInfoFieldFragmentDoc}
${AttachmentOfferListFieldFragmentDoc}`;
export const BcpIncidentAnswerPartSupplyChainDocument = gql`
    query BcpIncidentAnswerPartSupplyChain($id: ID!, $partId: ID!) {
  bcpIncidentAnswerDraft(id: $id) {
    id
    partSupplyChainSteps(partId: $partId) {
      processOrder
      processName
      siteName
    }
  }
}
    `;
export const BcpIncidentAnswerRequestDocument = gql`
    query BcpIncidentAnswerRequest($id: ID!) {
  bcpIncidentAnswerRequest(id: $id) {
    id
    tenantName
    incidentName
    incidentStatus
    isDrill
    disasterKind
    dueDatetime
    recipientName
    isCompanyView
    siteCount
    drafts {
      id
      siteName
      version
      hasImpact
      impactDetail
      detailReportPending
      detailReportEta
      asksParts
      categories {
        humanDamageLevel
        humanDamageComment
        buildingDamageLevel
        buildingDamageComment
        equipmentDamageLevel
        equipmentDamageComment
        productionImpactLevel
        productionImpactComment
        deliveryImpactLevel
        deliveryImpactComment
        supportRequest
      }
      answeredBy
      answeredAt
      previousAnswer {
        hasImpact
        impactDetail
        detailReportPending
        detailReportEta
        answeredAt
        categories {
          humanDamageLevel
          humanDamageComment
          buildingDamageLevel
          buildingDamageComment
          equipmentDamageLevel
          equipmentDamageComment
          productionImpactLevel
          productionImpactComment
          deliveryImpactLevel
          deliveryImpactComment
          supportRequest
        }
      }
      attachments {
        id
        name
        url
      }
      parts {
        id
        partCode
        partName
        figureNumber
        hasSupplyChain
        supplierCode
        isConnected
        impactKind
        comment
        previousImpactKind
        previousComment
      }
      partsDecideSiteImpact
      partsAiProposalRemaining
    }
  }
}
    `;
export const BcpIncidentAnswerRequestByTokenDocument = gql`
    query BcpIncidentAnswerRequestByToken($token: String!) {
  bcpIncidentAnswerRequestByToken(token: $token) {
    state
    requestId
    request {
      id
      tenantName
      incidentName
      isDrill
      disasterKind
      dueDatetime
      drafts {
        id
        siteName
        hasImpact
        impactDetail
        detailReportPending
        detailReportEta
        categories {
          ...BcpAnswerTokenCategoriesField
        }
        answeredBy
        answeredAt
        partsDecideSiteImpact
        parts {
          id
          partCode
          supplierCode
          impactKind
          previousImpactKind
          previousComment
        }
        previousAnswer {
          hasImpact
          impactDetail
          detailReportPending
          detailReportEta
          answeredAt
          categories {
            ...BcpAnswerTokenCategoriesField
          }
        }
      }
    }
  }
}
    ${BcpAnswerTokenCategoriesFieldFragmentDoc}`;
export const BcpIncidentAnswerRequestSitesDocument = gql`
    query BcpIncidentAnswerRequestSites($id: ID!) {
  bcpIncidentAnswerRequest(id: $id) {
    id
    tenantName
    incidentName
    disasterKind
    drafts {
      id
      siteName
    }
  }
}
    `;
export const BcpIncidentAnswerRequestsDocument = gql`
    query BcpIncidentAnswerRequests($first: Int, $last: Int, $status: String, $keyword: String, $tenantId: ID, $excludeCompleted: Boolean) {
  bcpIncidentAnswerRequests(
    first: $first
    last: $last
    status: $status
    keyword: $keyword
    tenantId: $tenantId
    excludeCompleted: $excludeCompleted
  ) {
    totalCount
    nodes {
      id
      tenantName
      incidentName
      isDrill
      dueDatetime
      incidentStatus
      siteCount
      unanswered
      firstAnswerOnlyCount
    }
  }
}
    `;
export const CommentBaseDocument = gql`
    query CommentBase($commentKind: CommentKindEnum!, $targetId: ID!, $itemKind: String!, $tenantId: ID!, $supplierCode: String) {
  commentBase(
    commentKind: $commentKind
    targetId: $targetId
    itemKind: $itemKind
    tenantId: $tenantId
    supplierCode: $supplierCode
  ) {
    ...CommentBaseField
  }
}
    ${CommentBaseFieldFragmentDoc}`;
export const CommentSettingDocument = gql`
    query CommentSetting($commentKind: CommentKindEnum!, $targetId: ID!, $itemKind: String, $tenantId: ID!, $supplierCode: String) {
  commentSetting(
    commentKind: $commentKind
    targetId: $targetId
    itemKind: $itemKind
    tenantId: $tenantId
    supplierCode: $supplierCode
  ) {
    supplierAccountReadable
    supplierAccountWritable
  }
}
    `;
export const ContactClassesDocument = gql`
    query ContactClasses($tenantId: ID!) {
  contactClasses(tenantId: $tenantId) {
    ...ContactClassField
  }
}
    ${ContactClassFieldFragmentDoc}`;
export const CountriesDocument = gql`
    query Countries {
  countries {
    id
    name
    translation
    iso3
  }
}
    `;
export const CrSupplierFirmDocument = gql`
    query CrSupplierFirm($supplierFirmInfoConfirmationRequestId: ID!) {
  crSupplierFirm(
    supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId
  ) {
    ...CrSupplierFirmWithBeforeField
  }
}
    ${CrSupplierFirmWithBeforeFieldFragmentDoc}`;
export const CrSupplierFirmBankInfosDocument = gql`
    query CrSupplierFirmBankInfos($supplierFirmInfoConfirmationRequestId: ID!) {
  crSupplierFirmBankInfos(
    supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId
  ) {
    ...CrSupplierFirmBankInfoWithBeforeField
  }
}
    ${CrSupplierFirmBankInfoWithBeforeFieldFragmentDoc}`;
export const CrSupplierFirmCertificationInfosDocument = gql`
    query CrSupplierFirmCertificationInfos($supplierFirmInfoConfirmationRequestId: ID!) {
  crSupplierFirmCertificationInfos(
    supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId
  ) {
    ...CrSupplierFirmCertificationInfoWithBeforeField
  }
}
    ${CrSupplierFirmCertificationInfoWithBeforeFieldFragmentDoc}`;
export const CrSupplierFirmEmployeeNumberInfosDocument = gql`
    query CrSupplierFirmEmployeeNumberInfos($supplierFirmInfoConfirmationRequestId: ID!) {
  crSupplierFirmEmployeeNumberInfos(
    supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId
  ) {
    ...CrSupplierFirmEmployeeNumberInfoWithBeforeField
  }
}
    ${CrSupplierFirmEmployeeNumberInfoWithBeforeFieldFragmentDoc}`;
export const CrSupplierFirmEquipmentInfosDocument = gql`
    query CrSupplierFirmEquipmentInfos($supplierFirmInfoConfirmationRequestId: ID!) {
  crSupplierFirmEquipmentInfos(
    supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId
  ) {
    ...CrSupplierFirmEquipmentInfoWithBeforeField
  }
}
    ${CrSupplierFirmEquipmentInfoWithBeforeFieldFragmentDoc}`;
export const CrSupplierFirmFileInfosDocument = gql`
    query CrSupplierFirmFileInfos($supplierFirmInfoConfirmationRequestId: ID!) {
  crSupplierFirmFileInfos(
    supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId
  ) {
    ...CrSupplierFirmFileInfoWithBeforeField
  }
}
    ${CrSupplierFirmFileInfoWithBeforeFieldFragmentDoc}`;
export const CrSupplierFirmFinancialDetailsDocument = gql`
    query CrSupplierFirmFinancialDetails($supplierFirmInfoConfirmationRequestId: ID!, $financialStatementKind: String!) {
  crSupplierFirmFinancialDetails(
    supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId
    financialStatementKind: $financialStatementKind
  ) {
    ...CrSupplierFirmFinancialDetailWithBeforeField
  }
}
    ${CrSupplierFirmFinancialDetailWithBeforeFieldFragmentDoc}`;
export const CrSupplierFirmFinancialInfoDocument = gql`
    query CrSupplierFirmFinancialInfo($supplierFirmInfoConfirmationRequestId: ID!) {
  crSupplierFirmFinancialInfo(
    supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId
  ) {
    ...CrSupplierFirmFinancialInfoWithBeforeField
  }
}
    ${CrSupplierFirmFinancialInfoWithBeforeFieldFragmentDoc}`;
export const CrSupplierFirmKeyPositionInfosDocument = gql`
    query CrSupplierFirmKeyPositionInfos($supplierFirmInfoConfirmationRequestId: ID!) {
  crSupplierFirmKeyPositionInfos(
    supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId
  ) {
    ...CrSupplierFirmKeyPositionInfoWithBeforeField
  }
}
    ${CrSupplierFirmKeyPositionInfoWithBeforeFieldFragmentDoc}`;
export const CrSupplierFirmLaborSituationInfoDocument = gql`
    query CrSupplierFirmLaborSituationInfo($supplierFirmInfoConfirmationRequestId: ID!) {
  crSupplierFirmLaborSituationInfo(
    supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId
  ) {
    ...CrSupplierFirmLaborSituationInfoWithBeforeField
  }
}
    ${CrSupplierFirmLaborSituationInfoWithBeforeFieldFragmentDoc}`;
export const CrSupplierFirmManufacturingSitesDocument = gql`
    query CrSupplierFirmManufacturingSites($supplierFirmInfoConfirmationRequestId: ID!) {
  crSupplierFirmManufacturingSites(
    supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId
  ) {
    ...CrSupplierFirmManufacturingSiteWithBeforeField
  }
}
    ${CrSupplierFirmManufacturingSiteWithBeforeFieldFragmentDoc}`;
export const CrSupplierFirmMemberOrganizationsDocument = gql`
    query CrSupplierFirmMemberOrganizations($supplierFirmInfoConfirmationRequestId: ID!) {
  crSupplierFirmMemberOrganizations(
    supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId
  ) {
    ...CrSupplierFirmMemberOrganizationWithBeforeField
  }
}
    ${CrSupplierFirmMemberOrganizationWithBeforeFieldFragmentDoc}`;
export const CrSupplierFirmOutsourcingInfosDocument = gql`
    query CrSupplierFirmOutsourcingInfos($supplierFirmInfoConfirmationRequestId: ID!) {
  crSupplierFirmOutsourcingInfos(
    supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId
  ) {
    ...CrSupplierFirmOutsourcingInfoWithBeforeField
  }
}
    ${CrSupplierFirmOutsourcingInfoWithBeforeFieldFragmentDoc}`;
export const CrSupplierFirmRepresentativeInfoDocument = gql`
    query CrSupplierFirmRepresentativeInfo($supplierFirmInfoConfirmationRequestId: ID!) {
  crSupplierFirmRepresentativeInfo(
    supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId
  ) {
    ...CrSupplierFirmRepresentativeInfoWithBeforeField
  }
}
    ${CrSupplierFirmRepresentativeInfoWithBeforeFieldFragmentDoc}`;
export const CrSupplierFirmSalesStatusInfosDocument = gql`
    query CrSupplierFirmSalesStatusInfos($supplierFirmInfoConfirmationRequestId: ID!) {
  crSupplierFirmSalesStatusInfos(
    supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId
  ) {
    ...CrSupplierFirmSalesStatusInfoWithBeforeField
  }
}
    ${CrSupplierFirmSalesStatusInfoWithBeforeFieldFragmentDoc}`;
export const CrSupplierFirmShareholderInfosDocument = gql`
    query CrSupplierFirmShareholderInfos($supplierFirmInfoConfirmationRequestId: ID!) {
  crSupplierFirmShareholderInfos(
    supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId
  ) {
    ...CrSupplierFirmShareholderInfoWithBeforeField
  }
}
    ${CrSupplierFirmShareholderInfoWithBeforeFieldFragmentDoc}`;
export const CrSupplierFirmSitesDocument = gql`
    query CrSupplierFirmSites($supplierFirmInfoConfirmationRequestId: ID!) {
  crSupplierFirmSites(
    supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId
  ) {
    ...CrSupplierFirmSiteWithBeforeField
  }
}
    ${CrSupplierFirmSiteWithBeforeFieldFragmentDoc}`;
export const CrSupplierFirmSurveyEnqueteAnswersDocument = gql`
    query CrSupplierFirmSurveyEnqueteAnswers($supplierFirmInfoConfirmationRequestId: ID!) {
  crSupplierFirmSurveyEnqueteAnswers(
    supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId
  ) {
    ...CrSupplierFirmSurveyEnqueteAnswerWithBeforeField
  }
}
    ${CrSupplierFirmSurveyEnqueteAnswerWithBeforeFieldFragmentDoc}`;
export const CrSupplierFirmUserInfosDocument = gql`
    query CrSupplierFirmUserInfos($supplierFirmInfoConfirmationRequestId: ID!) {
  crSupplierFirmUserInfos(
    supplierFirmInfoConfirmationRequestId: $supplierFirmInfoConfirmationRequestId
  ) {
    ...CrSupplierFirmUserInfoWithBeforeField
  }
}
    ${CrSupplierFirmUserInfoWithBeforeFieldFragmentDoc}`;
export const CurrenciesDocument = gql`
    query Currencies {
  currencies {
    ...CurrencyField
  }
}
    ${CurrencyFieldFragmentDoc}`;
export const DataSharesDocument = gql`
    query DataShares($tenantId: ID!, $supplierCode: String!, $shareConfigId: ID!) {
  dataShares(
    tenantId: $tenantId
    supplierCode: $supplierCode
    shareConfigId: $shareConfigId
  ) {
    id
    sharedAt
    changedCount
    addedCount
    updatedCount
    deletedCount
  }
}
    `;
export const DeliveredAnnouncementByIdDocument = gql`
    query DeliveredAnnouncementById($id: ID!) {
  deliveredAnnouncement(id: $id) {
    ...DeliveredAnnouncementFields
  }
}
    ${DeliveredAnnouncementFieldsFragmentDoc}`;
export const DeliveredAnnouncementsDocument = gql`
    query DeliveredAnnouncements($onlyNotConfirmed: Boolean, $includeExpired: Boolean, $first: Int, $last: Int) {
  deliveredAnnouncements(
    onlyNotConfirmed: $onlyNotConfirmed
    includeExpired: $includeExpired
    first: $first
    last: $last
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    nodes {
      ...DeliveredAnnouncementFields
    }
  }
}
    ${DeliveredAnnouncementFieldsFragmentDoc}`;
export const DeliverySitesDocument = gql`
    query DeliverySites($tenantId: ID!) {
  deliverySites(tenantId: $tenantId) {
    ...DeliverySiteField
  }
}
    ${DeliverySiteFieldFragmentDoc}`;
export const EnqueteAnswerDocument = gql`
    query EnqueteAnswer($id: ID!) {
  enqueteAnswer(id: $id) {
    id
    status
    answeredAt
    returnReason
    returnedAt
    enquete {
      id
      title
      description
      priority
      displayFrom
      displayTo
      enqueteKind
      status
      answerGranularityKind
      questionSchema {
        id
        title
        description
        isSaq
        attachments {
          id
          ...AttachmentField
        }
        questions {
          id
          title
          questionKind
          displayOrder
          isRequired
          length
          condition {
            parentQuestionId
            optionIds
            effect
          }
          attachments {
            id
            ...AttachmentField
          }
          questionOptions {
            id
            label
            displayOrder
          }
          subQuestions {
            id
            label
            displayOrder
          }
        }
        questionSections {
          id
          title
          description
          displayOrder
          attachments {
            id
            ...AttachmentField
          }
          questions {
            id
            title
            questionKind
            displayOrder
            isRequired
            length
            condition {
              parentQuestionId
              optionIds
              effect
            }
            attachments {
              id
              ...AttachmentField
            }
            questionOptions {
              id
              label
              displayOrder
            }
            subQuestions {
              id
              label
              displayOrder
            }
          }
        }
      }
      enqueteDataSchema {
        id
        title
        description
        attachments {
          id
          ...AttachmentField
        }
        enqueteDataColumns {
          id
          name
          dataType
          displayOrder
          isRequired
        }
        enqueteDataRows {
          id
          name
          displayOrder
        }
        enqueteDataFixedCells {
          id
          value
          rowId
          columnId
        }
      }
    }
    supplyChainCompanyEmployeeName
    notificationTargets {
      id
      name
      email
    }
    tenant {
      id
      name
    }
    enqueteQuestionAnswers {
      id
      value
      subQuestionId
      attachments {
        id
        ...AttachmentField
      }
      enqueteQuestion {
        id
        title
        questionKind
        displayOrder
        isRequired
      }
    }
  }
}
    ${AttachmentFieldFragmentDoc}`;
export const EnqueteAnswersDocument = gql`
    query EnqueteAnswers($withNotificationTargets: Boolean = false, $status: String, $onlyUnanswered: Boolean, $first: Int, $last: Int, $keyword: String, $excludeClosed: Boolean) {
  enqueteAnswers(
    status: $status
    onlyUnanswered: $onlyUnanswered
    first: $first
    last: $last
    keyword: $keyword
    excludeClosed: $excludeClosed
  ) {
    totalCount
    nodes {
      id
      status
      answeredAt
      enquete {
        id
        title
        description
        priority
        displayFrom
        displayTo
        enqueteKind
        status
        answerGranularityKind
        createdAt
        updatedAt
        questionSchema {
          id
          title
        }
        enqueteDataSchema {
          id
          title
        }
      }
      supplyChainCompanyEmployeeName
      notificationTargets @include(if: $withNotificationTargets) {
        id
        name
        email
      }
      tenant {
        id
        name
      }
    }
  }
}
    `;
export const HasUnreadCommentsDocument = gql`
    query HasUnreadComments($commentKind: CommentKindEnum!, $targetId: ID!, $itemKind: String, $tenantId: ID!, $ignoreCommentTop: Boolean, $supplierCode: String) {
  hasUnreadComments(
    commentKind: $commentKind
    targetId: $targetId
    itemKind: $itemKind
    tenantId: $tenantId
    ignoreCommentTop: $ignoreCommentTop
    supplierCode: $supplierCode
  )
}
    `;
export const IncompleteTasksDocument = gql`
    query IncompleteTasks($first: Int, $last: Int) {
  incompleteTasks(first: $first, last: $last) {
    nodes {
      ...IncompleteTaskField
    }
    totalCount
    pageInfo {
      ...PageInfoField
    }
  }
}
    ${IncompleteTaskFieldFragmentDoc}
${PageInfoFieldFragmentDoc}`;
export const IndustriesDocument = gql`
    query Industries($tenantId: ID!) {
  industries(tenantId: $tenantId) {
    ...IndustryField
  }
}
    ${IndustryFieldFragmentDoc}`;
export const InputFormSchemaDocument = gql`
    query inputFormSchema($tenantId: ID!, $code: String!, $formattableId: ID, $formattableType: String) {
  inputFormSchema(
    tenantId: $tenantId
    code: $code
    formattableId: $formattableId
    formattableType: $formattableType
  ) {
    code
    description
    dictKey
    tenantId
    properties
  }
}
    `;
export const ItemRequirementByPriceAdjustmentItemDocument = gql`
    query ItemRequirementByPriceAdjustmentItem($priceAdjustmentItemId: ID!) {
  itemRequirementByPriceAdjustmentItem(
    priceAdjustmentItemId: $priceAdjustmentItemId
  ) {
    ...ItemRequirementField
  }
}
    ${ItemRequirementFieldFragmentDoc}`;
export const ListViewSchemaDocument = gql`
    query listViewSchema($code: String!, $tenantId: ID) {
  listViewSchema(code: $code, tenantId: $tenantId) {
    code
    description
    tenantId
    searchFormProperties {
      name
      labelDictKey
      type
      shrinkable
      from
      to
      optionLabels
      optionValues
      withArchived
      accountKind
      selectOptions {
        label
        value
      }
    }
    listProperties {
      name
      labelDictKey
      type
    }
  }
}
    `;
export const ManufacturingSitesDocument = gql`
    query ManufacturingSites($tenantId: ID!) {
  manufacturingSites(tenantId: $tenantId) {
    ...ManufacturingSiteField
  }
}
    ${ManufacturingSiteFieldFragmentDoc}`;
export const MeDocument = gql`
    query Me {
  me {
    ...MeField
  }
}
    ${MeFieldFragmentDoc}`;
export const MoldDocument = gql`
    query Mold($id: ID!) {
  mold(id: $id) {
    ...MoldField
  }
}
    ${MoldFieldFragmentDoc}`;
export const MoldDisposalSupplierApplicationDocument = gql`
    query MoldDisposalSupplierApplication($id: ID!) {
  moldDisposalSupplierApplication(id: $id) {
    ...MoldDisposalSupplierApplicationField
  }
}
    ${MoldDisposalSupplierApplicationFieldFragmentDoc}`;
export const MoldDisposalSupplierApplicationsDocument = gql`
    query MoldDisposalSupplierApplications($tenantId: ID!, $supplierCode: String, $applicationNo: String, $moldNo: String, $status: String, $title: String, $first: Int, $last: Int) {
  moldDisposalSupplierApplications(
    tenantId: $tenantId
    supplierCode: $supplierCode
    applicationNo: $applicationNo
    moldNo: $moldNo
    status: $status
    title: $title
    first: $first
    last: $last
  ) {
    totalCount
    pageInfo {
      ...PageInfoField
    }
    nodes {
      ...MoldDisposalSupplierApplicationField
    }
  }
}
    ${PageInfoFieldFragmentDoc}
${MoldDisposalSupplierApplicationFieldFragmentDoc}`;
export const MoldStoragePaymentsDocument = gql`
    query MoldStoragePayments($tenantId: ID!, $supplierCode: String, $uidKeyword: String, $acceptanceDateFrom: String, $acceptanceDateTo: String, $first: Int, $last: Int) {
  moldStoragePayments(
    tenantId: $tenantId
    supplierCode: $supplierCode
    uidKeyword: $uidKeyword
    acceptanceDateFrom: $acceptanceDateFrom
    acceptanceDateTo: $acceptanceDateTo
    first: $first
    last: $last
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    nodes {
      ...MoldStoragePaymentField
    }
  }
}
    ${MoldStoragePaymentFieldFragmentDoc}`;
export const MoldsDocument = gql`
    query Molds($first: Int, $last: Int, $tenantId: ID!, $supplierCode: String, $supplierKeyWord: String, $uid: String, $employeeId: ID, $employeeName: String, $classification: String, $manager: String, $partCode: String, $partName: String, $category: String, $assetNumber: String, $maker: String, $tab: String!, $isMainReadPage: Boolean) {
  molds(
    supplierCode: $supplierCode
    supplierKeyWord: $supplierKeyWord
    tenantId: $tenantId
    uid: $uid
    employeeId: $employeeId
    employeeName: $employeeName
    classification: $classification
    manager: $manager
    partCode: $partCode
    partName: $partName
    category: $category
    assetNumber: $assetNumber
    maker: $maker
    tab: $tab
    isMainReadPage: $isMainReadPage
  ) {
    molds(first: $first, last: $last) {
      totalCount
      pageInfo {
        ...PageInfoField
      }
      nodes {
        ...MoldListField
      }
    }
    moldStatusCount {
      startUp
      production
      storage
      dispose
    }
  }
}
    ${PageInfoFieldFragmentDoc}
${MoldListFieldFragmentDoc}`;
export const MoldsForApplicationDocument = gql`
    query MoldsForApplication($ids: [ID!]!, $selectedTenantId: ID!, $supplierCode: String) {
  moldsForApplication(
    ids: $ids
    selectedTenantId: $selectedTenantId
    supplierCode: $supplierCode
  ) {
    tenantId
    tenantName
    supplierId
    supplierCode
    supplierName
    molds {
      ...MoldField
    }
  }
}
    ${MoldFieldFragmentDoc}`;
export const PackageBulkAnswerSheetDocument = gql`
    query PackageBulkAnswerSheet($packageId: ID!, $tenantId: ID!, $supplierCode: String) {
  packageBulkAnswerSheet(
    packageId: $packageId
    tenantId: $tenantId
    supplierCode: $supplierCode
  ) {
    packageId
    title
    answerEntryKind
    answerDueDate
    tenantName
    supplierCode
    supplierName
    firstQuotation {
      id
      requestText
      answerDueDate
      tenant {
        id
        quotationConfig {
          dayTypeSetting
        }
      }
      attachments {
        id
        name
        signedDownloadUrl
      }
    }
    requestAttachments {
      id
      name
      signedDownloadUrl
    }
    requestAttachmentOffers {
      id
      isDiscardNecessary
      status
      kind
      isDownloadable
      attachment {
        id
        nameForSupplier
      }
      tenant {
        id
      }
    }
    headerAnswer {
      id
      status
      currencyId
      quotationNo
      expirationDate
      memo
      declineReason
      dayType
      attachments {
        id
        ...AttachmentField
      }
    }
    rows {
      quotationRequestId
      quotationId
      quotationItemId
      name
      makerName
      makerModel
      quantity
      unitName
      isCanBeAnswered
      status
      priceBasis
      taxType
      unitPrice
      amountExcludingTax
      amountIncludingTax
      deliveryDay
      desiredDeliveryDueOn
      isDeclined
      baseUpdatedAt
    }
  }
}
    ${AttachmentFieldFragmentDoc}`;
export const PartListDocument = gql`
    query PartList($first: Int, $last: Int, $after: String, $before: String, $code: String, $figureNumber: String, $referenceDate: String, $searchType: String, $tenantId: ID!, $supplierCode: String, $partCodes: String, $partNames: String, $rootPartCodes: String) {
  partList(
    first: $first
    last: $last
    after: $after
    before: $before
    code: $code
    figureNumber: $figureNumber
    referenceDate: $referenceDate
    searchType: $searchType
    tenantId: $tenantId
    supplierCode: $supplierCode
    partCodes: $partCodes
    partNames: $partNames
    rootPartCodes: $rootPartCodes
  ) {
    totalCount
    pageInfo {
      ...PageInfoField
    }
    nodes {
      ...PartListField
    }
  }
}
    ${PageInfoFieldFragmentDoc}
${PartListFieldFragmentDoc}`;
export const PartOrderUnitPricesByIdsDocument = gql`
    query partOrderUnitPricesByIds($ids: [ID!]!, $tenantId: ID!, $materialPriceDateOn: String) {
  partOrderUnitPricesByIds(
    ids: $ids
    tenantId: $tenantId
    materialPriceDateOn: $materialPriceDateOn
  ) {
    id
    ifKey1
    ifKey2
    materialCost
    materialManagementCost
    jigManagementCost
    partsCost
    subsidiaryMaterialCost
    processingCostSubtotal
    propertyRentCost
    amortizationCost
    deliveryCost
    managementCost
    paidSupplyPartSubtotal
    unitPrice
    facilityCost
    facilityAmortizationCost
    updateMemo
    manufacturingSite {
      name
    }
    supplier {
      name
      code
    }
    tenant {
      name
    }
    part {
      code
      rootPartCode
      name
      sameGroupParts {
        code
      }
    }
    partReasons {
      ...PartReasonField
    }
    partOrderUnitPriceFormat {
      code
      materialDetailDescription
    }
    partFacilityPrices {
      facilityKind {
        code
        name
      }
      name
      facilityCost
      paymentInstallmentKind
    }
    partMaterialPrices {
      procurementKind
      materialName
      measure
      baseMaterial {
        code
      }
      reservedWeight
      productWeight
      materialUnitPrice
      quantity
      cavity
      materialCostPerQty
      materialCost
      materialUnitPriceOnDate
      materialCostPerQtyOnDate
      materialCostOnDate
      scrapWeight
      scrapUnitPrice
      scrapSubtotal
      scrapUnitPriceOnDate
      variation
    }
    partSupplySubpartPrices {
      supplyPart {
        code
        rootPartCode
        name
      }
      quantity
      quantityDenominator
      unitPrice
      supplyPartCost
    }
    partMaterialPrices {
      ...PartMaterialPriceFields
    }
    partSubpartPrices {
      partCode
      partName
      quantity
      unitPrice
      partCost
    }
    partSubsidiaryMaterialCosts {
      name
      subsidiaryMaterialCost
    }
    partProcessingCosts {
      equipmentName
      processingCostSubtotalPerLot
      processOutsourcingKind
      processName
      processingTimeHour
      processingRate
      processingCost
      productionLot
      partFacilityPrice {
        facilityKind {
          name
        }
        name
        facilityCost
        paymentInstallmentKind
      }
    }
    answerPrice {
      answer {
        memo
      }
    }
    quotation {
      quotationContext {
        ...QuotationContextField
      }
    }
    quotationContext {
      ...QuotationContextField
    }
    project {
      modelYear
      modelTitle
      modelTypeName
      projectModel {
        deliverySiteName
        modelDepreciation
        manufacturingSiteName
      }
      projectSchedules {
        seqNo
        eventName
        eventOn
        qualificationLevelName
      }
      projectFormat {
        isSingleUnitProject
      }
    }
    sourcePriceAdjustmentItem {
      id
      project {
        modelYear
        modelTitle
        modelTypeName
        projectModel {
          deliverySiteName
          modelDepreciation
          manufacturingSiteName
        }
        projectSchedules {
          seqNo
          eventName
          eventOn
          qualificationLevelName
        }
        projectFormat {
          isSingleUnitProject
        }
      }
      newDetail {
        id
        quotationContext {
          ...QuotationContextField
        }
      }
    }
    itemRequirement {
      designChangeCode
    }
  }
}
    ${PartReasonFieldFragmentDoc}
${PartMaterialPriceFieldsFragmentDoc}
${QuotationContextFieldFragmentDoc}`;
export const PartOrderUnitPricesForAdjustmentDocument = gql`
    query PartOrderUnitPricesForAdjustment($ids: [ID!], $tenantId: ID!) {
  partOrderUnitPricesForAdjustment(ids: $ids, tenantId: $tenantId) {
    id
    ifKey1
    ifKey2
    startOn
    unitPrice
    isExpired
    latestCanceledPartOrderUnitPrice {
      cancelStatusKind
    }
    manufacturingSite {
      ...ManufacturingSiteField
    }
    priceAdjustmentItems {
      priceAdjustment {
        currentEvent {
          eventKind
        }
      }
    }
    part {
      id
      code
      displayCode
      name
      rootPartCode
      isNotEnd
      purchaseGroupPart {
        id
        groupUid
        isParent
      }
    }
  }
}
    ${ManufacturingSiteFieldFragmentDoc}`;
export const PartSupplyPriceHistoryDocument = gql`
    query PartSupplyPriceHistory($partId: String!, $tenantId: String!, $supplierCode: String!) {
  partSupplyPriceHistory(
    partId: $partId
    tenantId: $tenantId
    supplierCode: $supplierCode
  ) {
    totalCount
    pageInfo {
      ...PageInfoField
    }
    nodes {
      ...PartSupplyPriceField
    }
  }
}
    ${PageInfoFieldFragmentDoc}
${PartSupplyPriceFieldFragmentDoc}`;
export const PartSupplyPriceListDocument = gql`
    query PartSupplyPriceList($first: Int, $last: Int, $tenantId: String!, $code: String, $figureNumber: String, $assignmentPriceKind: String, $referenceDate: String, $searchType: String, $supplierCode: String) {
  partSupplyPriceList(
    first: $first
    last: $last
    tenantId: $tenantId
    code: $code
    figureNumber: $figureNumber
    assignmentPriceKind: $assignmentPriceKind
    referenceDate: $referenceDate
    searchType: $searchType
    supplierCode: $supplierCode
  ) {
    totalCount
    pageInfo {
      ...PageInfoField
    }
    nodes {
      ...PartSupplyPriceField
    }
  }
}
    ${PageInfoFieldFragmentDoc}
${PartSupplyPriceFieldFragmentDoc}`;
export const PartOrderUnitPricesForListDocument = gql`
    query PartOrderUnitPricesForList($tenantId: ID!, $first: Int, $last: Int, $searchKind: String, $partCode: String, $rootPartCode: String, $partName: String, $deliverySiteIds: String, $manufacturingSiteIds: String, $ifKey1: String, $reasonIds: String, $startOnSince: String, $startOnUntil: String, $cancelStatusKind: String, $ids: [ID!], $supplierCode: String) {
  partOrderUnitPricesForList(
    tenantId: $tenantId
    first: $first
    last: $last
    searchKind: $searchKind
    partCode: $partCode
    rootPartCode: $rootPartCode
    partName: $partName
    deliverySiteIds: $deliverySiteIds
    manufacturingSiteIds: $manufacturingSiteIds
    ifKey1: $ifKey1
    reasonIds: $reasonIds
    startOnSince: $startOnSince
    startOnUntil: $startOnUntil
    cancelStatusKind: $cancelStatusKind
    ids: $ids
    supplierCode: $supplierCode
  ) {
    totalCount
    pageInfo {
      ...PageInfoField
    }
    nodes {
      ...PartOrderUnitPriceForListField
    }
  }
}
    ${PageInfoFieldFragmentDoc}
${PartOrderUnitPriceForListFieldFragmentDoc}`;
export const PriceAdjustmentDocument = gql`
    query priceAdjustment($id: ID!) {
  priceAdjustment(id: $id) {
    ...PriceAdjustmentDetailField
  }
}
    ${PriceAdjustmentDetailFieldFragmentDoc}`;
export const PriceAdjustmentItemForFormDocument = gql`
    query priceAdjustmentItemForForm($id: ID!) {
  priceAdjustmentItemForForm(id: $id) {
    ...priceAdjustmentItemForFormField
  }
}
    ${PriceAdjustmentItemForFormFieldFragmentDoc}`;
export const PriceAdjustmentItemProjectDocument = gql`
    query priceAdjustmentItemProject($id: ID!) {
  priceAdjustmentItemProject(id: $id) {
    ...PriceAdjustmentItemProjectField
  }
}
    ${PriceAdjustmentItemProjectFieldFragmentDoc}`;
export const PriceAdjustmentMaterialErrorsDocument = gql`
    query priceAdjustmentMaterialErrors($id: ID!, $priceEffectiveDate: ISO8601Date!) {
  priceAdjustmentMaterialErrors(id: $id, priceEffectiveDate: $priceEffectiveDate)
}
    `;
export const PriceAdjustmentSettingDocument = gql`
    query priceAdjustmentSetting($tenantId: ID!) {
  priceAdjustmentSetting(tenantId: $tenantId) {
    ...PriceAdjustmentSettingField
  }
}
    ${PriceAdjustmentSettingFieldFragmentDoc}`;
export const PriceAdjustmentsDocument = gql`
    query priceAdjustments($first: Int, $last: Int, $tenantId: ID!, $supplierCode: String, $tenantCode: String, $ownConfirmationSupplierCode: String, $confirmationStatuses: [Int!], $adjustmentStatuses: [Int!], $inChargeSupplierUserId: ID, $confirmationStartDateFrom: ISO8601Date, $confirmationStartDateTo: ISO8601Date, $confirmationDeadlineDateFrom: ISO8601Date, $confirmationDeadlineDateTo: ISO8601Date) {
  priceAdjustmentConfirmationStatuses {
    name
    value
  }
  priceAdjustmentAdjustmentStatuses(tenantId: $tenantId) {
    name
    value
  }
  priceAdjustments(
    first: $first
    last: $last
    tenantId: $tenantId
    supplierCode: $supplierCode
    tenantCode: $tenantCode
    ownConfirmationSupplierCode: $ownConfirmationSupplierCode
    confirmationStatuses: $confirmationStatuses
    adjustmentStatuses: $adjustmentStatuses
    inChargeSupplierUserId: $inChargeSupplierUserId
    confirmationStartDateFrom: $confirmationStartDateFrom
    confirmationStartDateTo: $confirmationStartDateTo
    confirmationDeadlineDateFrom: $confirmationDeadlineDateFrom
    confirmationDeadlineDateTo: $confirmationDeadlineDateTo
  ) {
    totalCount
    pageInfo {
      ...PageInfoField
    }
    nodes {
      ...PriceAdjustmentField
    }
  }
}
    ${PageInfoFieldFragmentDoc}
${PriceAdjustmentFieldFragmentDoc}`;
export const PriceAdjustmentsV2Document = gql`
    query priceAdjustmentsV2($first: Int, $last: Int, $tenantId: ID!, $purpose: String, $partCode: String, $rootPartCode: String, $partName: String, $supplierCode: String, $priceEffectiveDateSince: String, $priceEffectiveDateUntil: String, $source: String, $personInChargeIds: String, $confirmStartDateSince: String, $confirmStartDateUntil: String, $confirmDueDateSince: String, $confirmDueDateUntil: String, $confirmationStatus: String) {
  priceAdjustmentConfirmationStatuses {
    name
    value
  }
  priceAdjustmentAdjustmentStatuses(tenantId: $tenantId) {
    name
    value
  }
  priceAdjustments: priceAdjustmentsV2(
    first: $first
    last: $last
    tenantId: $tenantId
    purpose: $purpose
    partCode: $partCode
    rootPartCode: $rootPartCode
    partName: $partName
    supplierCode: $supplierCode
    priceEffectiveDateSince: $priceEffectiveDateSince
    priceEffectiveDateUntil: $priceEffectiveDateUntil
    source: $source
    personInChargeIds: $personInChargeIds
    confirmStartDateSince: $confirmStartDateSince
    confirmStartDateUntil: $confirmStartDateUntil
    confirmDueDateSince: $confirmDueDateSince
    confirmDueDateUntil: $confirmDueDateUntil
    confirmationStatus: $confirmationStatus
  ) {
    totalCount
    pageInfo {
      ...PageInfoField
    }
    nodes {
      ...PriceAdjustmentField
    }
  }
}
    ${PageInfoFieldFragmentDoc}
${PriceAdjustmentFieldFragmentDoc}`;
export const PriceChangeReasonsDocument = gql`
    query PriceChangeReasons($tenantId: ID!) {
  priceChangeReasons(tenantId: $tenantId) {
    id
    reason
    code
    sequence
  }
}
    `;
export const ProcurementKindSettingsDocument = gql`
    query ProcurementKindSettings($tenantId: ID!, $targetKind: ProcurementKindTargetKindEnum!) {
  procurementKindSettings(tenantId: $tenantId, targetKind: $targetKind) {
    procurementKind
    seq
    label
  }
}
    `;
export const ProfileDocument = gql`
    query Profile($includePast: Boolean = true) {
  profile {
    ...SupplierAccountProfileField
  }
}
    ${SupplierAccountProfileFieldFragmentDoc}`;
export const QuotationV2Document = gql`
    query quotationV2($quotationID: ID!, $tenantId: ID!, $supplierCode: String) {
  quotation(id: $quotationID, tenantId: $tenantId, supplierCode: $supplierCode) {
    ...QuotationV2Field
  }
}
    ${QuotationV2FieldFragmentDoc}`;
export const QuotationsV2Document = gql`
    query QuotationsV2($first: Int, $last: Int, $quotationUid: String, $quotationUids: [String!], $tenantId: ID!, $supplierCode: String, $partsName: String, $answerStatus: String, $progressStatus: String, $selectionStatus: String, $itemCode: String, $itemRootCode: String, $itemName: String, $requestedOnSince: ISO8601Date, $requestedOnUntil: ISO8601Date, $answerDueDateSince: ISO8601Date, $answerDueDateUntil: ISO8601Date, $statuses: [String!], $ids: [ID!]) {
  quotationsV2(
    first: $first
    last: $last
    quotationUid: $quotationUid
    quotationUids: $quotationUids
    tenantId: $tenantId
    supplierCode: $supplierCode
    partsName: $partsName
    answerStatus: $answerStatus
    progressStatus: $progressStatus
    selectionStatus: $selectionStatus
    itemCode: $itemCode
    itemRootCode: $itemRootCode
    itemName: $itemName
    requestedOnSince: $requestedOnSince
    requestedOnUntil: $requestedOnUntil
    answerDueDateSince: $answerDueDateSince
    answerDueDateUntil: $answerDueDateUntil
    statuses: $statuses
    ids: $ids
  ) {
    totalCount
    pageInfo {
      ...PageInfoField
    }
    nodes {
      ...QuotationListV2Field
    }
  }
}
    ${PageInfoFieldFragmentDoc}
${QuotationListV2FieldFragmentDoc}`;
export const SelectableSupplierFileClassesDocument = gql`
    query SelectableSupplierFileClasses($tenantId: ID!, $supplierFileClassId: ID) {
  selectableSupplierFileClasses(
    tenantId: $tenantId
    supplierFileClassId: $supplierFileClassId
  ) {
    ...SupplierFileClassField
  }
}
    ${SupplierFileClassFieldFragmentDoc}`;
export const SelectableTenantsDocument = gql`
    query SelectableTenants($kind: String!) {
  selectableTenants(kind: $kind) {
    totalCount
    pageInfo {
      ...PageInfoField
    }
    nodes {
      id
      name
    }
  }
}
    ${PageInfoFieldFragmentDoc}`;
export const SelectedTenantDocument = gql`
    query SelectedTenant($kind: String) {
  selectedTenant(kind: $kind) {
    ...SelectedTenantField
  }
}
    ${SelectedTenantFieldFragmentDoc}`;
export const SharedAnnualTotalsDocument = gql`
    query SharedAnnualTotals($tenantId: ID!, $supplierCode: String!, $page: Int, $perPage: Int, $keyword: String, $shareId: ID) {
  sharedAnnualTotals(
    tenantId: $tenantId
    supplierCode: $supplierCode
    page: $page
    perPage: $perPage
    keyword: $keyword
    shareId: $shareId
  ) {
    shareConfigId
    shareKind
    supplierId
    shareColumns {
      id
      tableName
      columnName
      fieldKey
      displayOrder
      isShare
    }
    shareCommentConfigs {
      id
      fieldName
      fieldType
      fieldKey
      columnName
      displayOrder
      isShare
    }
    rows {
      id
      operationKind
      serviceId
      cells {
        fieldKey
        displayValue
      }
      commentCells {
        fieldKey
        fieldType
        value
      }
    }
    totalCount
  }
}
    `;
export const SharedPartMaterialUsagesDocument = gql`
    query SharedPartMaterialUsages($tenantId: ID!, $supplierCode: String!, $page: Int, $perPage: Int, $keyword: String, $shareId: ID) {
  sharedPartMaterialUsages(
    tenantId: $tenantId
    supplierCode: $supplierCode
    page: $page
    perPage: $perPage
    keyword: $keyword
    shareId: $shareId
  ) {
    shareConfigId
    shareKind
    supplierId
    shareColumns {
      id
      tableName
      columnName
      fieldKey
      displayOrder
      isShare
    }
    shareCommentConfigs {
      id
      fieldName
      fieldType
      fieldKey
      columnName
      displayOrder
      isShare
    }
    rows {
      id
      operationKind
      serviceId
      cells {
        fieldKey
        displayValue
      }
      commentCells {
        fieldKey
        fieldType
        value
      }
    }
    totalCount
  }
}
    `;
export const SharedPartStructuresDocument = gql`
    query SharedPartStructures($tenantId: ID!, $supplierCode: String!, $page: Int, $perPage: Int, $keyword: String, $shareId: ID) {
  sharedPartStructures(
    tenantId: $tenantId
    supplierCode: $supplierCode
    page: $page
    perPage: $perPage
    keyword: $keyword
    shareId: $shareId
  ) {
    shareConfigId
    shareKind
    supplierId
    shareColumns {
      id
      tableName
      columnName
      fieldKey
      displayOrder
      isShare
    }
    shareCommentConfigs {
      id
      fieldName
      fieldType
      fieldKey
      columnName
      displayOrder
      isShare
    }
    rows {
      id
      operationKind
      serviceId
      cells {
        fieldKey
        displayValue
      }
      commentCells {
        fieldKey
        fieldType
        value
      }
    }
    totalCount
  }
}
    `;
export const SharedPartTransactionsDocument = gql`
    query SharedPartTransactions($tenantId: ID!, $supplierCode: String!, $page: Int, $perPage: Int, $keyword: String, $shareId: ID) {
  sharedPartTransactions(
    tenantId: $tenantId
    supplierCode: $supplierCode
    page: $page
    perPage: $perPage
    keyword: $keyword
    shareId: $shareId
  ) {
    shareConfigId
    shareKind
    supplierId
    shareColumns {
      id
      tableName
      columnName
      fieldKey
      displayOrder
      isShare
    }
    shareCommentConfigs {
      id
      fieldName
      fieldType
      fieldKey
      columnName
      displayOrder
      isShare
    }
    rows {
      id
      operationKind
      serviceId
      cells {
        fieldKey
        displayValue
      }
      commentCells {
        fieldKey
        fieldType
        value
      }
    }
    totalCount
  }
}
    `;
export const SharedPartsDocument = gql`
    query SharedParts($tenantId: ID!, $supplierCode: String!, $page: Int, $perPage: Int, $keyword: String, $shareId: ID) {
  sharedParts(
    tenantId: $tenantId
    supplierCode: $supplierCode
    page: $page
    perPage: $perPage
    keyword: $keyword
    shareId: $shareId
  ) {
    shareConfigId
    shareKind
    supplierId
    shareColumns {
      id
      tableName
      columnName
      fieldKey
      displayOrder
      isShare
    }
    shareCommentConfigs {
      id
      fieldName
      fieldType
      fieldKey
      columnName
      displayOrder
      isShare
    }
    rows {
      id
      operationKind
      serviceId
      cells {
        fieldKey
        displayValue
      }
      commentCells {
        fieldKey
        fieldType
        value
      }
    }
    totalCount
  }
}
    `;
export const SharedUnofficialAnnouncementsDocument = gql`
    query SharedUnofficialAnnouncements($tenantId: ID!, $supplierCode: String!, $page: Int, $perPage: Int, $keyword: String, $shareId: ID) {
  sharedUnofficialAnnouncements(
    tenantId: $tenantId
    supplierCode: $supplierCode
    page: $page
    perPage: $perPage
    keyword: $keyword
    shareId: $shareId
  ) {
    shareConfigId
    shareKind
    supplierId
    shareColumns {
      id
      tableName
      columnName
      fieldKey
      displayOrder
      isShare
    }
    shareCommentConfigs {
      id
      fieldName
      fieldType
      fieldKey
      columnName
      displayOrder
      isShare
    }
    rows {
      id
      operationKind
      serviceId
      cells {
        fieldKey
        displayValue
      }
      commentCells {
        fieldKey
        fieldType
        value
      }
    }
    totalCount
  }
}
    `;
export const StatesDocument = gql`
    query States($countryId: ID!) {
  states(countryId: $countryId) {
    id
    name
  }
}
    `;
export const SupplierAccountsDocument = gql`
    query SupplierAccounts($tenantId: ID, $withArchived: Boolean) {
  supplierAccounts(tenantId: $tenantId, withArchived: $withArchived) {
    nodes {
      id
      name
      email
      isArchived
    }
  }
}
    `;
export const SupplierAccountsWithInfoDocument = gql`
    query SupplierAccountsWithInfo($tenantId: ID!, $includePast: Boolean = false) {
  supplierAccounts {
    nodes {
      ...SupplierAccountTenantMemberField
    }
  }
}
    ${SupplierAccountTenantMemberFieldFragmentDoc}`;
export const SupplierAnnouncementsDocument = gql`
    query SupplierAnnouncements($first: Int, $last: Int) {
  supplierAnnouncements {
    supplierAnnouncements(first: $first, last: $last) {
      totalCount
      pageInfo {
        ...PageInfoField
      }
      nodes {
        supplierAnnouncement {
          ...SupplierAnnouncementField
        }
        isRead
      }
    }
    unreadCount
  }
}
    ${PageInfoFieldFragmentDoc}
${SupplierAnnouncementFieldFragmentDoc}`;
export const SupplierCorporationDocument = gql`
    query SupplierCorporation {
  supplierCorporation {
    id
    name
    hasAnswerExcelTemplateAttachment
  }
}
    `;
export const SupplierCorporationEmployeesDocument = gql`
    query SupplierCorporationEmployees($withArchived: Boolean, $scope: SupplierCorporationEmployeeScopeEnum) {
  supplierCorporationEmployees(withArchived: $withArchived, scope: $scope) {
    nodes {
      id
      name
      email
      isArchived
      supplierAccountTenantLinks {
        tenant {
          id
          name
        }
      }
    }
  }
}
    `;
export const SupplierFileClassesDocument = gql`
    query SupplierFileClasses($tenantId: ID!) {
  supplierFileClasses(tenantId: $tenantId) {
    ...SupplierFileClassField
  }
}
    ${SupplierFileClassFieldFragmentDoc}`;
export const SupplierFileInfoDocument = gql`
    query SupplierFileInfo($id: ID!, $tenantId: ID!) {
  supplierFileInfo(id: $id, tenantId: $tenantId) {
    ...SupplierFileInfoField
  }
}
    ${SupplierFileInfoFieldFragmentDoc}`;
export const SupplierFileInfosDocument = gql`
    query SupplierFileInfos($tenantId: ID!, $first: Int, $last: Int, $supplierFileClassId: ID, $searchKeywords: [String!]) {
  supplierFileInfos(
    tenantId: $tenantId
    first: $first
    last: $last
    supplierFileClassId: $supplierFileClassId
    searchKeywords: $searchKeywords
  ) {
    totalCount
    countByClass
    pageInfo {
      ...PageInfoField
    }
    nodes {
      ...SupplierFileInfoField
    }
  }
}
    ${PageInfoFieldFragmentDoc}
${SupplierFileInfoFieldFragmentDoc}`;
export const SupplierFirmInfoConfirmationRequestDocument = gql`
    query SupplierFirmInfoConfirmationRequest($id: ID!) {
  supplierFirmInfoConfirmationRequest(id: $id) {
    ...SupplierFirmInfoConfirmationRequestField
  }
}
    ${SupplierFirmInfoConfirmationRequestFieldFragmentDoc}`;
export const SupplierFirmInfoConfirmationRequestsDocument = gql`
    query SupplierFirmInfoConfirmationRequests($first: Int, $last: Int, $tenantId: ID!, $confirmationRequestNo: String, $notificationTargets: [String!], $statuses: [SupplierFirmInfoConfirmationRequestStatusEnum!], $surveyYears: String, $answerDateFrom: ISO8601DateTime, $answerDateTo: ISO8601DateTime) {
  supplierFirmInfoConfirmationRequests(
    first: $first
    last: $last
    tenantId: $tenantId
    confirmationRequestNo: $confirmationRequestNo
    notificationTargets: $notificationTargets
    statuses: $statuses
    surveyYears: $surveyYears
    answerDateFrom: $answerDateFrom
    answerDateTo: $answerDateTo
  ) {
    totalCount
    pageInfo {
      ...PageInfoField
    }
    nodes {
      ...SupplierFirmInfoConfirmationRequestField
    }
  }
}
    ${PageInfoFieldFragmentDoc}
${SupplierFirmInfoConfirmationRequestFieldFragmentDoc}`;
export const SupplierMoldStorageApplicationDocument = gql`
    query SupplierMoldStorageApplication($id: ID!) {
  supplierMoldStorageApplication(id: $id) {
    ...SupplierMoldStorageApplicationField
  }
}
    ${SupplierMoldStorageApplicationFieldFragmentDoc}`;
export const SupplierMoldStorageApplicationsDocument = gql`
    query SupplierMoldStorageApplications($tenantId: ID!, $supplierCode: String, $applicationNo: String, $moldNo: String, $status: String, $title: String, $first: Int, $last: Int) {
  supplierMoldStorageApplications(
    tenantId: $tenantId
    supplierCode: $supplierCode
    applicationNo: $applicationNo
    moldNo: $moldNo
    status: $status
    title: $title
    first: $first
    last: $last
  ) {
    totalCount
    pageInfo {
      ...PageInfoField
    }
    nodes {
      ...SupplierMoldStorageApplicationField
    }
  }
}
    ${PageInfoFieldFragmentDoc}
${SupplierMoldStorageApplicationFieldFragmentDoc}`;
export const SupplierOutsourcingClassesDocument = gql`
    query SupplierOutsourcingClasses($tenantId: ID!) {
  supplierOutsourcingClasses(tenantId: $tenantId) {
    ...SupplierOutsourcingClassField
  }
}
    ${SupplierOutsourcingClassFieldFragmentDoc}`;
export const SupplierQuotationPackageCountByStatusDocument = gql`
    query SupplierQuotationPackageCountByStatus($keyword: String, $supplierCode: String, $tenantId: ID!) {
  supplierQuotationPackageCountByStatus(
    keyword: $keyword
    supplierCode: $supplierCode
    tenantId: $tenantId
  ) {
    all
    notAnswered
    overdue
    answered
  }
}
    `;
export const SupplierQuotationPackagesDocument = gql`
    query SupplierQuotationPackages($first: Int, $last: Int, $keyword: String, $status: String, $supplierCode: String, $tenantId: ID!) {
  supplierQuotationPackages(
    first: $first
    last: $last
    keyword: $keyword
    status: $status
    supplierCode: $supplierCode
    tenantId: $tenantId
  ) {
    totalCount
    pageInfo {
      ...PageInfoField
    }
    nodes {
      ...SupplierQuotationPackageListItemField
    }
  }
}
    ${PageInfoFieldFragmentDoc}
${SupplierQuotationPackageListItemFieldFragmentDoc}`;
export const SupplierScreenItemConfigsDocument = gql`
    query SupplierScreenItemConfigs($componentId: ID!, $tenantId: ID!) {
  supplierScreenItemConfigs(componentId: $componentId, tenantId: $tenantId) {
    ...SupplierScreenItemConfigField
  }
}
    ${SupplierScreenItemConfigFieldFragmentDoc}`;
export const SupplierScreenSurveyInfoConfigsDocument = gql`
    query SupplierScreenSurveyInfoConfigs($tenantId: ID!) {
  supplierScreenSurveyInfoConfigs(tenantId: $tenantId) {
    ...SupplierScreenSurveyInfoConfigField
  }
}
    ${SupplierScreenSurveyInfoConfigFieldFragmentDoc}`;
export const SupplierSurveyInfoImportConfigDocument = gql`
    query SupplierSurveyInfoImportConfig($tenantId: ID!) {
  supplierSurveyInfoImportConfig(tenantId: $tenantId) {
    ...SupplierSurveyInfoImportConfigField
  }
}
    ${SupplierSurveyInfoImportConfigFieldFragmentDoc}`;
export const SupplierOptionsDocument = gql`
    query SupplierOptions($tenantId: ID!) {
  supplierOptions(tenantId: $tenantId) {
    supplierId
    supplierCode
    supplierName
    tenantId
  }
}
    `;
export const TenantDocument = gql`
    query Tenant($id: ID!, $includePast: Boolean = false) {
  tenant(id: $id) {
    ...TenantDetailField
  }
}
    ${TenantDetailFieldFragmentDoc}`;
export const TenantCandidateCountDocument = gql`
    query TenantCandidateCount {
  tenantCandidates {
    totalCount
  }
}
    `;
export const TenantCandidatesDocument = gql`
    query TenantCandidates($kind: String) {
  tenantCandidates(kind: $kind) {
    nodes {
      id
      name
      inOperationScope
      supplierCodes
    }
  }
}
    `;
export const TenantDirectoriesDocument = gql`
    query TenantDirectories($firmName: String, $supplierAccountId: ID) {
  tenantDirectories(firmName: $firmName, supplierAccountId: $supplierAccountId) {
    nodes {
      ...TenantDirectoryTenantsIndexField
    }
  }
}
    ${TenantDirectoryTenantsIndexFieldFragmentDoc}`;
export const TenantDirectoryDetailDocument = gql`
    query TenantDirectoryDetail($id: ID!, $includePast: Boolean = false) {
  tenantDirectory(id: $id, includePast: $includePast) {
    ...TenantDirectoryDetailTenantsShowField
  }
}
    ${TenantDirectoryDetailTenantsShowFieldFragmentDoc}`;
export const TenantPeriodUnitsDocument = gql`
    query TenantPeriodUnits {
  tenantPeriodUnits {
    id
    periodUnitKind
    name
  }
}
    `;
export const TenantQuotationConfigDocument = gql`
    query TenantQuotationConfig($tenantId: ID!) {
  tenant(id: $tenantId) {
    id
    quotationConfig {
      isUseQuotationPackage
      isUseAnswerExcelMultipleSupplementalAttachments
    }
  }
}
    `;
export const TenantSelectDocument = gql`
    query tenantSelect($nitoelSelectId: String!, $tenantId: ID!) {
  tenantSelect(nitoelSelectId: $nitoelSelectId, tenantId: $tenantId) {
    ...TenantSelectField
  }
}
    ${TenantSelectFieldFragmentDoc}`;
export const TenantSelectOptionsDocument = gql`
    query tenantSelectOptions($nitoelSelectId: String!) {
  tenantSelectOptions(nitoelSelectId: $nitoelSelectId) {
    id
    label
  }
}
    `;
export const TenantUnitsDocument = gql`
    query TenantUnits($unitKind: UnitKindEnum) {
  tenantUnits(unitKind: $unitKind) {
    id
    unitCode
    name
    order
  }
}
    `;
export const TenantConfigDocument = gql`
    query TenantConfig($tenantId: ID!) {
  tenantConfig(tenantId: $tenantId) {
    tenantId
    currencyCode
    isUseTrialPurchaseRequest
    isUsePurchaseRequest
  }
}
    `;
export const TenantsForPriceAdjustmentDocument = gql`
    query TenantsForPriceAdjustment($firmName: String, $supplierUserId: ID) {
  tenants(firmName: $firmName, supplierUserId: $supplierUserId) {
    nodes {
      id
      name
    }
  }
}
    `;
export const TrialQuotationAnswerSheetDocument = gql`
    query TrialQuotationAnswerSheet($quotationId: ID!, $tenantId: ID!, $supplierCode: String) {
  trialQuotationAnswerSheet(
    quotationId: $quotationId
    tenantId: $tenantId
    supplierCode: $supplierCode
  ) {
    quotationId
    quotationRequestId
    title
    unitOptions
    answerDueDate
    requestDueDate
    requestText
    requestAttachments {
      id
      seqNo
      fileName
      byteSize
      downloadUrl
    }
    tenantName
    supplierCode
    supplierName
    isCanBeAnswered
    isTrialSelectionLocked
    isFacility
    baseRevisionNo
    items {
      quotationItemId
      seqNo
      name
      makerName
      makerModel
      quantity
      unitName
    }
    latestAnswer {
      ...TrialQuotationAnswerRevisionField
    }
    answers {
      ...TrialQuotationAnswerRevisionField
    }
  }
}
    ${TrialQuotationAnswerRevisionFieldFragmentDoc}`;
export const UnconfirmedDeliveredAnnouncementsDocument = gql`
    query UnconfirmedDeliveredAnnouncements {
  deliveredAnnouncements(onlyNotConfirmed: true, first: 5) {
    totalCount
    nodes {
      ...DeliveredAnnouncementFields
    }
  }
}
    ${DeliveredAnnouncementFieldsFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    AnswerExcelImportV2(variables: AnswerExcelImportV2MutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AnswerExcelImportV2Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AnswerExcelImportV2Mutation>({ document: AnswerExcelImportV2Document, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AnswerExcelImportV2', 'mutation', variables);
    },
    AnswerExcelMultipleImport(variables: AnswerExcelMultipleImportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AnswerExcelMultipleImportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AnswerExcelMultipleImportMutation>({ document: AnswerExcelMultipleImportDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AnswerExcelMultipleImport', 'mutation', variables);
    },
    AddComment(variables: AddCommentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AddCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddCommentMutation>({ document: AddCommentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AddComment', 'mutation', variables);
    },
    AnswerByAttachmentFileV2(variables: AnswerByAttachmentFileV2MutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AnswerByAttachmentFileV2Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AnswerByAttachmentFileV2Mutation>({ document: AnswerByAttachmentFileV2Document, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AnswerByAttachmentFileV2', 'mutation', variables);
    },
    AnswerByFile(variables: AnswerByFileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AnswerByFileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AnswerByFileMutation>({ document: AnswerByFileDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AnswerByFile', 'mutation', variables);
    },
    AnswerCalc(variables: AnswerCalcMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AnswerCalcMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AnswerCalcMutation>({ document: AnswerCalcDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AnswerCalc', 'mutation', variables);
    },
    AnswerToGeneralEnquete(variables: AnswerToGeneralEnqueteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AnswerToGeneralEnqueteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AnswerToGeneralEnqueteMutation>({ document: AnswerToGeneralEnqueteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AnswerToGeneralEnquete', 'mutation', variables);
    },
    AnswerUpdateV2(variables: AnswerUpdateV2MutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AnswerUpdateV2Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AnswerUpdateV2Mutation>({ document: AnswerUpdateV2Document, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AnswerUpdateV2', 'mutation', variables);
    },
    AnswerUpsert(variables: AnswerUpsertMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AnswerUpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AnswerUpsertMutation>({ document: AnswerUpsertDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AnswerUpsert', 'mutation', variables);
    },
    AnswerUpsertValidate(variables: AnswerUpsertValidateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AnswerUpsertValidateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AnswerUpsertValidateMutation>({ document: AnswerUpsertValidateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AnswerUpsertValidate', 'mutation', variables);
    },
    AttachmentOfferDownloadEventCreate(variables: AttachmentOfferDownloadEventCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AttachmentOfferDownloadEventCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AttachmentOfferDownloadEventCreateMutation>({ document: AttachmentOfferDownloadEventCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AttachmentOfferDownloadEventCreate', 'mutation', variables);
    },
    AttachmentOffersDiscard(variables: AttachmentOffersDiscardMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AttachmentOffersDiscardMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AttachmentOffersDiscardMutation>({ document: AttachmentOffersDiscardDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AttachmentOffersDiscard', 'mutation', variables);
    },
    BcpIncidentAnswerRequestDraftsSave(variables: BcpIncidentAnswerRequestDraftsSaveMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BcpIncidentAnswerRequestDraftsSaveMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BcpIncidentAnswerRequestDraftsSaveMutation>({ document: BcpIncidentAnswerRequestDraftsSaveDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'BcpIncidentAnswerRequestDraftsSave', 'mutation', variables);
    },
    BcpIncidentAnswerRequestOpened(variables: BcpIncidentAnswerRequestOpenedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BcpIncidentAnswerRequestOpenedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BcpIncidentAnswerRequestOpenedMutation>({ document: BcpIncidentAnswerRequestOpenedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'BcpIncidentAnswerRequestOpened', 'mutation', variables);
    },
    BcpIncidentAnswerRequestOpenedByToken(variables: BcpIncidentAnswerRequestOpenedByTokenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BcpIncidentAnswerRequestOpenedByTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BcpIncidentAnswerRequestOpenedByTokenMutation>({ document: BcpIncidentAnswerRequestOpenedByTokenDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'BcpIncidentAnswerRequestOpenedByToken', 'mutation', variables);
    },
    BcpIncidentAnswerRequestPartsPropose(variables: BcpIncidentAnswerRequestPartsProposeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BcpIncidentAnswerRequestPartsProposeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BcpIncidentAnswerRequestPartsProposeMutation>({ document: BcpIncidentAnswerRequestPartsProposeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'BcpIncidentAnswerRequestPartsPropose', 'mutation', variables);
    },
    BcpIncidentAnswerRequestSubmit(variables: BcpIncidentAnswerRequestSubmitMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BcpIncidentAnswerRequestSubmitMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BcpIncidentAnswerRequestSubmitMutation>({ document: BcpIncidentAnswerRequestSubmitDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'BcpIncidentAnswerRequestSubmit', 'mutation', variables);
    },
    BcpIncidentAnswerRequestSubmitByToken(variables: BcpIncidentAnswerRequestSubmitByTokenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BcpIncidentAnswerRequestSubmitByTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BcpIncidentAnswerRequestSubmitByTokenMutation>({ document: BcpIncidentAnswerRequestSubmitByTokenDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'BcpIncidentAnswerRequestSubmitByToken', 'mutation', variables);
    },
    ConfirmCommentRead(variables: ConfirmCommentReadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ConfirmCommentReadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConfirmCommentReadMutation>({ document: ConfirmCommentReadDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ConfirmCommentRead', 'mutation', variables);
    },
    crSupplierFirmBankInfoDelete(variables: CrSupplierFirmBankInfoDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmBankInfoDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmBankInfoDeleteMutation>({ document: CrSupplierFirmBankInfoDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'crSupplierFirmBankInfoDelete', 'mutation', variables);
    },
    CrSupplierFirmBankInfoUpsert(variables: CrSupplierFirmBankInfoUpsertMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmBankInfoUpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmBankInfoUpsertMutation>({ document: CrSupplierFirmBankInfoUpsertDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmBankInfoUpsert', 'mutation', variables);
    },
    crSupplierFirmCertificationInfoDelete(variables: CrSupplierFirmCertificationInfoDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmCertificationInfoDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmCertificationInfoDeleteMutation>({ document: CrSupplierFirmCertificationInfoDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'crSupplierFirmCertificationInfoDelete', 'mutation', variables);
    },
    CrSupplierFirmCertificationInfoUpsert(variables: CrSupplierFirmCertificationInfoUpsertMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmCertificationInfoUpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmCertificationInfoUpsertMutation>({ document: CrSupplierFirmCertificationInfoUpsertDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmCertificationInfoUpsert', 'mutation', variables);
    },
    crSupplierFirmEmployeeNumberInfoDelete(variables: CrSupplierFirmEmployeeNumberInfoDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmEmployeeNumberInfoDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmEmployeeNumberInfoDeleteMutation>({ document: CrSupplierFirmEmployeeNumberInfoDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'crSupplierFirmEmployeeNumberInfoDelete', 'mutation', variables);
    },
    CrSupplierFirmEmployeeNumberInfoUpsert(variables: CrSupplierFirmEmployeeNumberInfoUpsertMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmEmployeeNumberInfoUpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmEmployeeNumberInfoUpsertMutation>({ document: CrSupplierFirmEmployeeNumberInfoUpsertDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmEmployeeNumberInfoUpsert', 'mutation', variables);
    },
    crSupplierFirmEquipmentInfoDelete(variables: CrSupplierFirmEquipmentInfoDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmEquipmentInfoDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmEquipmentInfoDeleteMutation>({ document: CrSupplierFirmEquipmentInfoDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'crSupplierFirmEquipmentInfoDelete', 'mutation', variables);
    },
    CrSupplierFirmEquipmentInfoUpsert(variables: CrSupplierFirmEquipmentInfoUpsertMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmEquipmentInfoUpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmEquipmentInfoUpsertMutation>({ document: CrSupplierFirmEquipmentInfoUpsertDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmEquipmentInfoUpsert', 'mutation', variables);
    },
    crSupplierFirmFileInfoDelete(variables: CrSupplierFirmFileInfoDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmFileInfoDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmFileInfoDeleteMutation>({ document: CrSupplierFirmFileInfoDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'crSupplierFirmFileInfoDelete', 'mutation', variables);
    },
    CrSupplierFirmFileInfoUpsert(variables: CrSupplierFirmFileInfoUpsertMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmFileInfoUpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmFileInfoUpsertMutation>({ document: CrSupplierFirmFileInfoUpsertDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmFileInfoUpsert', 'mutation', variables);
    },
    crSupplierFirmFinancialDetailDelete(variables: CrSupplierFirmFinancialDetailDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmFinancialDetailDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmFinancialDetailDeleteMutation>({ document: CrSupplierFirmFinancialDetailDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'crSupplierFirmFinancialDetailDelete', 'mutation', variables);
    },
    CrSupplierFirmFinancialDetailUpsert(variables: CrSupplierFirmFinancialDetailUpsertMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmFinancialDetailUpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmFinancialDetailUpsertMutation>({ document: CrSupplierFirmFinancialDetailUpsertDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmFinancialDetailUpsert', 'mutation', variables);
    },
    crSupplierFirmFinancialInfoDelete(variables: CrSupplierFirmFinancialInfoDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmFinancialInfoDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmFinancialInfoDeleteMutation>({ document: CrSupplierFirmFinancialInfoDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'crSupplierFirmFinancialInfoDelete', 'mutation', variables);
    },
    CrSupplierFirmFinancialInfoUpsert(variables: CrSupplierFirmFinancialInfoUpsertMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmFinancialInfoUpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmFinancialInfoUpsertMutation>({ document: CrSupplierFirmFinancialInfoUpsertDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmFinancialInfoUpsert', 'mutation', variables);
    },
    crSupplierFirmKeyPositionInfoDelete(variables: CrSupplierFirmKeyPositionInfoDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmKeyPositionInfoDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmKeyPositionInfoDeleteMutation>({ document: CrSupplierFirmKeyPositionInfoDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'crSupplierFirmKeyPositionInfoDelete', 'mutation', variables);
    },
    CrSupplierFirmKeyPositionInfoUpsert(variables: CrSupplierFirmKeyPositionInfoUpsertMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmKeyPositionInfoUpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmKeyPositionInfoUpsertMutation>({ document: CrSupplierFirmKeyPositionInfoUpsertDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmKeyPositionInfoUpsert', 'mutation', variables);
    },
    crSupplierFirmManufacturingSiteDelete(variables: CrSupplierFirmManufacturingSiteDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmManufacturingSiteDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmManufacturingSiteDeleteMutation>({ document: CrSupplierFirmManufacturingSiteDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'crSupplierFirmManufacturingSiteDelete', 'mutation', variables);
    },
    CrSupplierFirmManufacturingSiteUpsert(variables: CrSupplierFirmManufacturingSiteUpsertMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmManufacturingSiteUpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmManufacturingSiteUpsertMutation>({ document: CrSupplierFirmManufacturingSiteUpsertDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmManufacturingSiteUpsert', 'mutation', variables);
    },
    crSupplierFirmOutsourcingInfoDelete(variables: CrSupplierFirmOutsourcingInfoDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmOutsourcingInfoDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmOutsourcingInfoDeleteMutation>({ document: CrSupplierFirmOutsourcingInfoDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'crSupplierFirmOutsourcingInfoDelete', 'mutation', variables);
    },
    CrSupplierFirmOutsourcingInfoUpsert(variables: CrSupplierFirmOutsourcingInfoUpsertMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmOutsourcingInfoUpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmOutsourcingInfoUpsertMutation>({ document: CrSupplierFirmOutsourcingInfoUpsertDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmOutsourcingInfoUpsert', 'mutation', variables);
    },
    crSupplierFirmRepresentativeInfoDelete(variables: CrSupplierFirmRepresentativeInfoDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmRepresentativeInfoDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmRepresentativeInfoDeleteMutation>({ document: CrSupplierFirmRepresentativeInfoDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'crSupplierFirmRepresentativeInfoDelete', 'mutation', variables);
    },
    CrSupplierFirmRepresentativeInfoUpsert(variables: CrSupplierFirmRepresentativeInfoUpsertMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmRepresentativeInfoUpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmRepresentativeInfoUpsertMutation>({ document: CrSupplierFirmRepresentativeInfoUpsertDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmRepresentativeInfoUpsert', 'mutation', variables);
    },
    crSupplierFirmSalesStatusInfoDelete(variables: CrSupplierFirmSalesStatusInfoDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmSalesStatusInfoDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmSalesStatusInfoDeleteMutation>({ document: CrSupplierFirmSalesStatusInfoDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'crSupplierFirmSalesStatusInfoDelete', 'mutation', variables);
    },
    CrSupplierFirmSalesStatusInfoUpsert(variables: CrSupplierFirmSalesStatusInfoUpsertMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmSalesStatusInfoUpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmSalesStatusInfoUpsertMutation>({ document: CrSupplierFirmSalesStatusInfoUpsertDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmSalesStatusInfoUpsert', 'mutation', variables);
    },
    crSupplierFirmShareholderInfoDelete(variables: CrSupplierFirmShareholderInfoDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmShareholderInfoDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmShareholderInfoDeleteMutation>({ document: CrSupplierFirmShareholderInfoDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'crSupplierFirmShareholderInfoDelete', 'mutation', variables);
    },
    CrSupplierFirmShareholderInfoUpsert(variables: CrSupplierFirmShareholderInfoUpsertMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmShareholderInfoUpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmShareholderInfoUpsertMutation>({ document: CrSupplierFirmShareholderInfoUpsertDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmShareholderInfoUpsert', 'mutation', variables);
    },
    crSupplierFirmSiteDelete(variables: CrSupplierFirmSiteDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmSiteDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmSiteDeleteMutation>({ document: CrSupplierFirmSiteDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'crSupplierFirmSiteDelete', 'mutation', variables);
    },
    CrSupplierFirmSiteUpsert(variables: CrSupplierFirmSiteUpsertMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmSiteUpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmSiteUpsertMutation>({ document: CrSupplierFirmSiteUpsertDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmSiteUpsert', 'mutation', variables);
    },
    CrSupplierFirmUpsert(variables: CrSupplierFirmUpsertMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmUpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmUpsertMutation>({ document: CrSupplierFirmUpsertDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmUpsert', 'mutation', variables);
    },
    crSupplierFirmUserInfoDelete(variables: CrSupplierFirmUserInfoDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmUserInfoDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmUserInfoDeleteMutation>({ document: CrSupplierFirmUserInfoDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'crSupplierFirmUserInfoDelete', 'mutation', variables);
    },
    CrSupplierFirmUserInfoUpsert(variables: CrSupplierFirmUserInfoUpsertMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmUserInfoUpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmUserInfoUpsertMutation>({ document: CrSupplierFirmUserInfoUpsertDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmUserInfoUpsert', 'mutation', variables);
    },
    DeleteComment(variables: DeleteCommentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCommentMutation>({ document: DeleteCommentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteComment', 'mutation', variables);
    },
    DeliveredAnnouncementConfirm(variables: DeliveredAnnouncementConfirmMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeliveredAnnouncementConfirmMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeliveredAnnouncementConfirmMutation>({ document: DeliveredAnnouncementConfirmDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeliveredAnnouncementConfirm', 'mutation', variables);
    },
    DeliveredAnnouncementView(variables: DeliveredAnnouncementViewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeliveredAnnouncementViewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeliveredAnnouncementViewMutation>({ document: DeliveredAnnouncementViewDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeliveredAnnouncementView', 'mutation', variables);
    },
    GenerateSupplierSurveyInfoImportExcel(variables: GenerateSupplierSurveyInfoImportExcelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GenerateSupplierSurveyInfoImportExcelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateSupplierSurveyInfoImportExcelMutation>({ document: GenerateSupplierSurveyInfoImportExcelDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GenerateSupplierSurveyInfoImportExcel', 'mutation', variables);
    },
    MoldDisposalSupplierApplicationDispose(variables: MoldDisposalSupplierApplicationDisposeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MoldDisposalSupplierApplicationDisposeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MoldDisposalSupplierApplicationDisposeMutation>({ document: MoldDisposalSupplierApplicationDisposeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MoldDisposalSupplierApplicationDispose', 'mutation', variables);
    },
    MoldDisposalSupplierApplicationSave(variables: MoldDisposalSupplierApplicationSaveMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MoldDisposalSupplierApplicationSaveMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MoldDisposalSupplierApplicationSaveMutation>({ document: MoldDisposalSupplierApplicationSaveDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MoldDisposalSupplierApplicationSave', 'mutation', variables);
    },
    PackageBulkAnswerAiDraft(variables: PackageBulkAnswerAiDraftMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PackageBulkAnswerAiDraftMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PackageBulkAnswerAiDraftMutation>({ document: PackageBulkAnswerAiDraftDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PackageBulkAnswerAiDraft', 'mutation', variables);
    },
    PackageBulkAnswerSubmit(variables: PackageBulkAnswerSubmitMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PackageBulkAnswerSubmitMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PackageBulkAnswerSubmitMutation>({ document: PackageBulkAnswerSubmitDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PackageBulkAnswerSubmit', 'mutation', variables);
    },
    partCsvExport(variables: PartCsvExportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PartCsvExportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PartCsvExportMutation>({ document: PartCsvExportDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'partCsvExport', 'mutation', variables);
    },
    PriceAdjustmentAmend(variables: PriceAdjustmentAmendMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentAmendMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentAmendMutation>({ document: PriceAdjustmentAmendDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PriceAdjustmentAmend', 'mutation', variables);
    },
    PriceAdjustmentAmendAsking(variables: PriceAdjustmentAmendAskingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentAmendAskingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentAmendAskingMutation>({ document: PriceAdjustmentAmendAskingDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PriceAdjustmentAmendAsking', 'mutation', variables);
    },
    PriceAdjustmentAnswer(variables: PriceAdjustmentAnswerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentAnswerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentAnswerMutation>({ document: PriceAdjustmentAnswerDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PriceAdjustmentAnswer', 'mutation', variables);
    },
    PriceAdjustmentApplication(variables: PriceAdjustmentApplicationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentApplicationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentApplicationMutation>({ document: PriceAdjustmentApplicationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PriceAdjustmentApplication', 'mutation', variables);
    },
    PriceAdjustmentApprove(variables: PriceAdjustmentApproveMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentApproveMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentApproveMutation>({ document: PriceAdjustmentApproveDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PriceAdjustmentApprove', 'mutation', variables);
    },
    PriceAdjustmentAsk(variables: PriceAdjustmentAskMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentAskMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentAskMutation>({ document: PriceAdjustmentAskDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PriceAdjustmentAsk', 'mutation', variables);
    },
    PriceAdjustmentClose(variables: PriceAdjustmentCloseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentCloseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentCloseMutation>({ document: PriceAdjustmentCloseDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PriceAdjustmentClose', 'mutation', variables);
    },
    PriceAdjustmentComplete(variables: PriceAdjustmentCompleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentCompleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentCompleteMutation>({ document: PriceAdjustmentCompleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PriceAdjustmentComplete', 'mutation', variables);
    },
    PriceAdjustmentCreateByPartOrderUnitPrice(variables: PriceAdjustmentCreateByPartOrderUnitPriceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentCreateByPartOrderUnitPriceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentCreateByPartOrderUnitPriceMutation>({ document: PriceAdjustmentCreateByPartOrderUnitPriceDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PriceAdjustmentCreateByPartOrderUnitPrice', 'mutation', variables);
    },
    PriceAdjustmentDelete(variables: PriceAdjustmentDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentDeleteMutation>({ document: PriceAdjustmentDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PriceAdjustmentDelete', 'mutation', variables);
    },
    PriceAdjustmentExcelExport(variables: PriceAdjustmentExcelExportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentExcelExportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentExcelExportMutation>({ document: PriceAdjustmentExcelExportDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PriceAdjustmentExcelExport', 'mutation', variables);
    },
    PriceAdjustmentExcelSchemaExport(variables: PriceAdjustmentExcelSchemaExportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentExcelSchemaExportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentExcelSchemaExportMutation>({ document: PriceAdjustmentExcelSchemaExportDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PriceAdjustmentExcelSchemaExport', 'mutation', variables);
    },
    priceAdjustmentExcelSchemaImport(variables: PriceAdjustmentExcelSchemaImportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentExcelSchemaImportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentExcelSchemaImportMutation>({ document: PriceAdjustmentExcelSchemaImportDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'priceAdjustmentExcelSchemaImport', 'mutation', variables);
    },
    PriceAdjustmentItemValidate(variables: PriceAdjustmentItemValidateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentItemValidateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentItemValidateMutation>({ document: PriceAdjustmentItemValidateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PriceAdjustmentItemValidate', 'mutation', variables);
    },
    PriceAdjustmentSave(variables: PriceAdjustmentSaveMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentSaveMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentSaveMutation>({ document: PriceAdjustmentSaveDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PriceAdjustmentSave', 'mutation', variables);
    },
    PriceAdjustmentUpdate(variables: PriceAdjustmentUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentUpdateMutation>({ document: PriceAdjustmentUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PriceAdjustmentUpdate', 'mutation', variables);
    },
    PriceAdjustmentWithdraw(variables: PriceAdjustmentWithdrawMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentWithdrawMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentWithdrawMutation>({ document: PriceAdjustmentWithdrawDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PriceAdjustmentWithdraw', 'mutation', variables);
    },
    PriceAdjustmentsCreatableCheck(variables: PriceAdjustmentsCreatableCheckMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentsCreatableCheckMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentsCreatableCheckMutation>({ document: PriceAdjustmentsCreatableCheckDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PriceAdjustmentsCreatableCheck', 'mutation', variables);
    },
    PriceAdjustmentsCreatableCheckByIds(variables: PriceAdjustmentsCreatableCheckByIdsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentsCreatableCheckByIdsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentsCreatableCheckByIdsMutation>({ document: PriceAdjustmentsCreatableCheckByIdsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PriceAdjustmentsCreatableCheckByIds', 'mutation', variables);
    },
    PriceAdjustmentsCreate(variables: PriceAdjustmentsCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentsCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentsCreateMutation>({ document: PriceAdjustmentsCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PriceAdjustmentsCreate', 'mutation', variables);
    },
    PriceAdjustmentsCsvCreate(variables: PriceAdjustmentsCsvCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentsCsvCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentsCsvCreateMutation>({ document: PriceAdjustmentsCsvCreateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PriceAdjustmentsCsvCreate', 'mutation', variables);
    },
    ProfileUpdate(variables: ProfileUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ProfileUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileUpdateMutation>({ document: ProfileUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ProfileUpdate', 'mutation', variables);
    },
    QuotationsDecline(variables: QuotationsDeclineMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<QuotationsDeclineMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuotationsDeclineMutation>({ document: QuotationsDeclineDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'QuotationsDecline', 'mutation', variables);
    },
    ShareCommentUpsert(variables: ShareCommentUpsertMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ShareCommentUpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShareCommentUpsertMutation>({ document: ShareCommentUpsertDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ShareCommentUpsert', 'mutation', variables);
    },
    sharedDataCsvExport(variables: SharedDataCsvExportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SharedDataCsvExportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SharedDataCsvExportMutation>({ document: SharedDataCsvExportDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'sharedDataCsvExport', 'mutation', variables);
    },
    sharedDataCsvImport(variables: SharedDataCsvImportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SharedDataCsvImportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SharedDataCsvImportMutation>({ document: SharedDataCsvImportDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'sharedDataCsvImport', 'mutation', variables);
    },
    SupplierAccountInvitationBySupplierFrontendComplete(variables: SupplierAccountInvitationBySupplierFrontendCompleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierAccountInvitationBySupplierFrontendCompleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierAccountInvitationBySupplierFrontendCompleteMutation>({ document: SupplierAccountInvitationBySupplierFrontendCompleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierAccountInvitationBySupplierFrontendComplete', 'mutation', variables);
    },
    SupplierAccountInvitationByTenantFrontendComplete(variables: SupplierAccountInvitationByTenantFrontendCompleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierAccountInvitationByTenantFrontendCompleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierAccountInvitationByTenantFrontendCompleteMutation>({ document: SupplierAccountInvitationByTenantFrontendCompleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierAccountInvitationByTenantFrontendComplete', 'mutation', variables);
    },
    SupplierAccountSelectedTenantUpdate(variables: SupplierAccountSelectedTenantUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierAccountSelectedTenantUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierAccountSelectedTenantUpdateMutation>({ document: SupplierAccountSelectedTenantUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierAccountSelectedTenantUpdate', 'mutation', variables);
    },
    SupplierAccountTenantLinkDelete(variables: SupplierAccountTenantLinkDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierAccountTenantLinkDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierAccountTenantLinkDeleteMutation>({ document: SupplierAccountTenantLinkDeleteDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierAccountTenantLinkDelete', 'mutation', variables);
    },
    SupplierAccountTenantLinkRestore(variables: SupplierAccountTenantLinkRestoreMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierAccountTenantLinkRestoreMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierAccountTenantLinkRestoreMutation>({ document: SupplierAccountTenantLinkRestoreDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierAccountTenantLinkRestore', 'mutation', variables);
    },
    SupplierAccountTenantLinkUpsert(variables: SupplierAccountTenantLinkUpsertMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierAccountTenantLinkUpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierAccountTenantLinkUpsertMutation>({ document: SupplierAccountTenantLinkUpsertDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierAccountTenantLinkUpsert', 'mutation', variables);
    },
    SupplierAnnouncementRead(variables?: SupplierAnnouncementReadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierAnnouncementReadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierAnnouncementReadMutation>({ document: SupplierAnnouncementReadDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierAnnouncementRead', 'mutation', variables);
    },
    SupplierCorporationEmployeeArchive(variables: SupplierCorporationEmployeeArchiveMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierCorporationEmployeeArchiveMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierCorporationEmployeeArchiveMutation>({ document: SupplierCorporationEmployeeArchiveDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierCorporationEmployeeArchive', 'mutation', variables);
    },
    SupplierCorporationEmployeeUnarchive(variables: SupplierCorporationEmployeeUnarchiveMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierCorporationEmployeeUnarchiveMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierCorporationEmployeeUnarchiveMutation>({ document: SupplierCorporationEmployeeUnarchiveDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierCorporationEmployeeUnarchive', 'mutation', variables);
    },
    SupplierFirmInfoConfirmationRequestStatusUpdate(variables?: SupplierFirmInfoConfirmationRequestStatusUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierFirmInfoConfirmationRequestStatusUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierFirmInfoConfirmationRequestStatusUpdateMutation>({ document: SupplierFirmInfoConfirmationRequestStatusUpdateDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierFirmInfoConfirmationRequestStatusUpdate', 'mutation', variables);
    },
    SupplierMoldStorageApplicationSave(variables: SupplierMoldStorageApplicationSaveMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierMoldStorageApplicationSaveMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierMoldStorageApplicationSaveMutation>({ document: SupplierMoldStorageApplicationSaveDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierMoldStorageApplicationSave', 'mutation', variables);
    },
    SupplierPriceAdjustmentFormAmend(variables: SupplierPriceAdjustmentFormAmendMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierPriceAdjustmentFormAmendMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierPriceAdjustmentFormAmendMutation>({ document: SupplierPriceAdjustmentFormAmendDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierPriceAdjustmentFormAmend', 'mutation', variables);
    },
    SupplierSurveyInfoExcelImport(variables: SupplierSurveyInfoExcelImportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierSurveyInfoExcelImportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierSurveyInfoExcelImportMutation>({ document: SupplierSurveyInfoExcelImportDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierSurveyInfoExcelImport', 'mutation', variables);
    },
    SupplyPartCsvExport(variables: SupplyPartCsvExportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplyPartCsvExportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplyPartCsvExportMutation>({ document: SupplyPartCsvExportDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplyPartCsvExport', 'mutation', variables);
    },
    TrialQuotationAnswerAiDraft(variables: TrialQuotationAnswerAiDraftMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TrialQuotationAnswerAiDraftMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrialQuotationAnswerAiDraftMutation>({ document: TrialQuotationAnswerAiDraftDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TrialQuotationAnswerAiDraft', 'mutation', variables);
    },
    TrialQuotationAnswerCancel(variables: TrialQuotationAnswerCancelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TrialQuotationAnswerCancelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrialQuotationAnswerCancelMutation>({ document: TrialQuotationAnswerCancelDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TrialQuotationAnswerCancel', 'mutation', variables);
    },
    TrialQuotationAnswerSubmit(variables: TrialQuotationAnswerSubmitMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TrialQuotationAnswerSubmitMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrialQuotationAnswerSubmitMutation>({ document: TrialQuotationAnswerSubmitDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TrialQuotationAnswerSubmit', 'mutation', variables);
    },
    TrialQuotationAttachmentClassify(variables: TrialQuotationAttachmentClassifyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TrialQuotationAttachmentClassifyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrialQuotationAttachmentClassifyMutation>({ document: TrialQuotationAttachmentClassifyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TrialQuotationAttachmentClassify', 'mutation', variables);
    },
    UpdateComment(variables: UpdateCommentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCommentMutation>({ document: UpdateCommentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateComment', 'mutation', variables);
    },
    AdminUsers(variables: AdminUsersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminUsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUsersQuery>({ document: AdminUsersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminUsers', 'query', variables);
    },
    AdminUsersByTransaction(variables: AdminUsersByTransactionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AdminUsersByTransactionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AdminUsersByTransactionQuery>({ document: AdminUsersByTransactionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AdminUsersByTransaction', 'query', variables);
    },
    Agreements(variables?: AgreementsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AgreementsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AgreementsQuery>({ document: AgreementsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Agreements', 'query', variables);
    },
    AllStates(variables?: AllStatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AllStatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllStatesQuery>({ document: AllStatesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AllStates', 'query', variables);
    },
    AttachmentOffer(variables: AttachmentOfferQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AttachmentOfferQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AttachmentOfferQuery>({ document: AttachmentOfferDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AttachmentOffer', 'query', variables);
    },
    AttachmentOffers(variables: AttachmentOffersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AttachmentOffersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AttachmentOffersQuery>({ document: AttachmentOffersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AttachmentOffers', 'query', variables);
    },
    BcpIncidentAnswerPartSupplyChain(variables: BcpIncidentAnswerPartSupplyChainQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BcpIncidentAnswerPartSupplyChainQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BcpIncidentAnswerPartSupplyChainQuery>({ document: BcpIncidentAnswerPartSupplyChainDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'BcpIncidentAnswerPartSupplyChain', 'query', variables);
    },
    BcpIncidentAnswerRequest(variables: BcpIncidentAnswerRequestQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BcpIncidentAnswerRequestQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BcpIncidentAnswerRequestQuery>({ document: BcpIncidentAnswerRequestDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'BcpIncidentAnswerRequest', 'query', variables);
    },
    BcpIncidentAnswerRequestByToken(variables: BcpIncidentAnswerRequestByTokenQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BcpIncidentAnswerRequestByTokenQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BcpIncidentAnswerRequestByTokenQuery>({ document: BcpIncidentAnswerRequestByTokenDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'BcpIncidentAnswerRequestByToken', 'query', variables);
    },
    BcpIncidentAnswerRequestSites(variables: BcpIncidentAnswerRequestSitesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BcpIncidentAnswerRequestSitesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BcpIncidentAnswerRequestSitesQuery>({ document: BcpIncidentAnswerRequestSitesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'BcpIncidentAnswerRequestSites', 'query', variables);
    },
    BcpIncidentAnswerRequests(variables?: BcpIncidentAnswerRequestsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BcpIncidentAnswerRequestsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BcpIncidentAnswerRequestsQuery>({ document: BcpIncidentAnswerRequestsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'BcpIncidentAnswerRequests', 'query', variables);
    },
    CommentBase(variables: CommentBaseQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CommentBaseQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommentBaseQuery>({ document: CommentBaseDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CommentBase', 'query', variables);
    },
    CommentSetting(variables: CommentSettingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CommentSettingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommentSettingQuery>({ document: CommentSettingDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CommentSetting', 'query', variables);
    },
    ContactClasses(variables: ContactClassesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ContactClassesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactClassesQuery>({ document: ContactClassesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ContactClasses', 'query', variables);
    },
    Countries(variables?: CountriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CountriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CountriesQuery>({ document: CountriesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Countries', 'query', variables);
    },
    CrSupplierFirm(variables: CrSupplierFirmQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmQuery>({ document: CrSupplierFirmDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirm', 'query', variables);
    },
    CrSupplierFirmBankInfos(variables: CrSupplierFirmBankInfosQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmBankInfosQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmBankInfosQuery>({ document: CrSupplierFirmBankInfosDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmBankInfos', 'query', variables);
    },
    CrSupplierFirmCertificationInfos(variables: CrSupplierFirmCertificationInfosQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmCertificationInfosQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmCertificationInfosQuery>({ document: CrSupplierFirmCertificationInfosDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmCertificationInfos', 'query', variables);
    },
    CrSupplierFirmEmployeeNumberInfos(variables: CrSupplierFirmEmployeeNumberInfosQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmEmployeeNumberInfosQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmEmployeeNumberInfosQuery>({ document: CrSupplierFirmEmployeeNumberInfosDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmEmployeeNumberInfos', 'query', variables);
    },
    CrSupplierFirmEquipmentInfos(variables: CrSupplierFirmEquipmentInfosQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmEquipmentInfosQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmEquipmentInfosQuery>({ document: CrSupplierFirmEquipmentInfosDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmEquipmentInfos', 'query', variables);
    },
    CrSupplierFirmFileInfos(variables: CrSupplierFirmFileInfosQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmFileInfosQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmFileInfosQuery>({ document: CrSupplierFirmFileInfosDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmFileInfos', 'query', variables);
    },
    CrSupplierFirmFinancialDetails(variables: CrSupplierFirmFinancialDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmFinancialDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmFinancialDetailsQuery>({ document: CrSupplierFirmFinancialDetailsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmFinancialDetails', 'query', variables);
    },
    CrSupplierFirmFinancialInfo(variables: CrSupplierFirmFinancialInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmFinancialInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmFinancialInfoQuery>({ document: CrSupplierFirmFinancialInfoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmFinancialInfo', 'query', variables);
    },
    CrSupplierFirmKeyPositionInfos(variables: CrSupplierFirmKeyPositionInfosQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmKeyPositionInfosQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmKeyPositionInfosQuery>({ document: CrSupplierFirmKeyPositionInfosDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmKeyPositionInfos', 'query', variables);
    },
    CrSupplierFirmLaborSituationInfo(variables: CrSupplierFirmLaborSituationInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmLaborSituationInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmLaborSituationInfoQuery>({ document: CrSupplierFirmLaborSituationInfoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmLaborSituationInfo', 'query', variables);
    },
    CrSupplierFirmManufacturingSites(variables: CrSupplierFirmManufacturingSitesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmManufacturingSitesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmManufacturingSitesQuery>({ document: CrSupplierFirmManufacturingSitesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmManufacturingSites', 'query', variables);
    },
    CrSupplierFirmMemberOrganizations(variables: CrSupplierFirmMemberOrganizationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmMemberOrganizationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmMemberOrganizationsQuery>({ document: CrSupplierFirmMemberOrganizationsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmMemberOrganizations', 'query', variables);
    },
    CrSupplierFirmOutsourcingInfos(variables: CrSupplierFirmOutsourcingInfosQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmOutsourcingInfosQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmOutsourcingInfosQuery>({ document: CrSupplierFirmOutsourcingInfosDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmOutsourcingInfos', 'query', variables);
    },
    CrSupplierFirmRepresentativeInfo(variables: CrSupplierFirmRepresentativeInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmRepresentativeInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmRepresentativeInfoQuery>({ document: CrSupplierFirmRepresentativeInfoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmRepresentativeInfo', 'query', variables);
    },
    CrSupplierFirmSalesStatusInfos(variables: CrSupplierFirmSalesStatusInfosQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmSalesStatusInfosQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmSalesStatusInfosQuery>({ document: CrSupplierFirmSalesStatusInfosDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmSalesStatusInfos', 'query', variables);
    },
    CrSupplierFirmShareholderInfos(variables: CrSupplierFirmShareholderInfosQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmShareholderInfosQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmShareholderInfosQuery>({ document: CrSupplierFirmShareholderInfosDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmShareholderInfos', 'query', variables);
    },
    CrSupplierFirmSites(variables: CrSupplierFirmSitesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmSitesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmSitesQuery>({ document: CrSupplierFirmSitesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmSites', 'query', variables);
    },
    CrSupplierFirmSurveyEnqueteAnswers(variables: CrSupplierFirmSurveyEnqueteAnswersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmSurveyEnqueteAnswersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmSurveyEnqueteAnswersQuery>({ document: CrSupplierFirmSurveyEnqueteAnswersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmSurveyEnqueteAnswers', 'query', variables);
    },
    CrSupplierFirmUserInfos(variables: CrSupplierFirmUserInfosQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CrSupplierFirmUserInfosQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CrSupplierFirmUserInfosQuery>({ document: CrSupplierFirmUserInfosDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CrSupplierFirmUserInfos', 'query', variables);
    },
    Currencies(variables?: CurrenciesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CurrenciesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrenciesQuery>({ document: CurrenciesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Currencies', 'query', variables);
    },
    DataShares(variables: DataSharesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DataSharesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DataSharesQuery>({ document: DataSharesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DataShares', 'query', variables);
    },
    DeliveredAnnouncementById(variables: DeliveredAnnouncementByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeliveredAnnouncementByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeliveredAnnouncementByIdQuery>({ document: DeliveredAnnouncementByIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeliveredAnnouncementById', 'query', variables);
    },
    DeliveredAnnouncements(variables?: DeliveredAnnouncementsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeliveredAnnouncementsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeliveredAnnouncementsQuery>({ document: DeliveredAnnouncementsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeliveredAnnouncements', 'query', variables);
    },
    DeliverySites(variables: DeliverySitesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeliverySitesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeliverySitesQuery>({ document: DeliverySitesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeliverySites', 'query', variables);
    },
    EnqueteAnswer(variables: EnqueteAnswerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EnqueteAnswerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EnqueteAnswerQuery>({ document: EnqueteAnswerDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'EnqueteAnswer', 'query', variables);
    },
    EnqueteAnswers(variables?: EnqueteAnswersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<EnqueteAnswersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EnqueteAnswersQuery>({ document: EnqueteAnswersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'EnqueteAnswers', 'query', variables);
    },
    HasUnreadComments(variables: HasUnreadCommentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<HasUnreadCommentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<HasUnreadCommentsQuery>({ document: HasUnreadCommentsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'HasUnreadComments', 'query', variables);
    },
    IncompleteTasks(variables?: IncompleteTasksQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<IncompleteTasksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IncompleteTasksQuery>({ document: IncompleteTasksDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'IncompleteTasks', 'query', variables);
    },
    Industries(variables: IndustriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<IndustriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IndustriesQuery>({ document: IndustriesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Industries', 'query', variables);
    },
    inputFormSchema(variables: InputFormSchemaQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<InputFormSchemaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InputFormSchemaQuery>({ document: InputFormSchemaDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'inputFormSchema', 'query', variables);
    },
    ItemRequirementByPriceAdjustmentItem(variables: ItemRequirementByPriceAdjustmentItemQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ItemRequirementByPriceAdjustmentItemQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ItemRequirementByPriceAdjustmentItemQuery>({ document: ItemRequirementByPriceAdjustmentItemDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ItemRequirementByPriceAdjustmentItem', 'query', variables);
    },
    listViewSchema(variables: ListViewSchemaQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ListViewSchemaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListViewSchemaQuery>({ document: ListViewSchemaDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'listViewSchema', 'query', variables);
    },
    ManufacturingSites(variables: ManufacturingSitesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ManufacturingSitesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ManufacturingSitesQuery>({ document: ManufacturingSitesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ManufacturingSites', 'query', variables);
    },
    Me(variables?: MeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeQuery>({ document: MeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Me', 'query', variables);
    },
    Mold(variables: MoldQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MoldQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MoldQuery>({ document: MoldDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Mold', 'query', variables);
    },
    MoldDisposalSupplierApplication(variables: MoldDisposalSupplierApplicationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MoldDisposalSupplierApplicationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MoldDisposalSupplierApplicationQuery>({ document: MoldDisposalSupplierApplicationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MoldDisposalSupplierApplication', 'query', variables);
    },
    MoldDisposalSupplierApplications(variables: MoldDisposalSupplierApplicationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MoldDisposalSupplierApplicationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MoldDisposalSupplierApplicationsQuery>({ document: MoldDisposalSupplierApplicationsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MoldDisposalSupplierApplications', 'query', variables);
    },
    MoldStoragePayments(variables: MoldStoragePaymentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MoldStoragePaymentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MoldStoragePaymentsQuery>({ document: MoldStoragePaymentsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MoldStoragePayments', 'query', variables);
    },
    Molds(variables: MoldsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MoldsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MoldsQuery>({ document: MoldsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Molds', 'query', variables);
    },
    MoldsForApplication(variables: MoldsForApplicationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<MoldsForApplicationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MoldsForApplicationQuery>({ document: MoldsForApplicationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'MoldsForApplication', 'query', variables);
    },
    PackageBulkAnswerSheet(variables: PackageBulkAnswerSheetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PackageBulkAnswerSheetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PackageBulkAnswerSheetQuery>({ document: PackageBulkAnswerSheetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PackageBulkAnswerSheet', 'query', variables);
    },
    PartList(variables: PartListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PartListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PartListQuery>({ document: PartListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PartList', 'query', variables);
    },
    partOrderUnitPricesByIds(variables: PartOrderUnitPricesByIdsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PartOrderUnitPricesByIdsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PartOrderUnitPricesByIdsQuery>({ document: PartOrderUnitPricesByIdsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'partOrderUnitPricesByIds', 'query', variables);
    },
    PartOrderUnitPricesForAdjustment(variables: PartOrderUnitPricesForAdjustmentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PartOrderUnitPricesForAdjustmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PartOrderUnitPricesForAdjustmentQuery>({ document: PartOrderUnitPricesForAdjustmentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PartOrderUnitPricesForAdjustment', 'query', variables);
    },
    PartSupplyPriceHistory(variables: PartSupplyPriceHistoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PartSupplyPriceHistoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PartSupplyPriceHistoryQuery>({ document: PartSupplyPriceHistoryDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PartSupplyPriceHistory', 'query', variables);
    },
    PartSupplyPriceList(variables: PartSupplyPriceListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PartSupplyPriceListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PartSupplyPriceListQuery>({ document: PartSupplyPriceListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PartSupplyPriceList', 'query', variables);
    },
    PartOrderUnitPricesForList(variables: PartOrderUnitPricesForListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PartOrderUnitPricesForListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PartOrderUnitPricesForListQuery>({ document: PartOrderUnitPricesForListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PartOrderUnitPricesForList', 'query', variables);
    },
    priceAdjustment(variables: PriceAdjustmentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentQuery>({ document: PriceAdjustmentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'priceAdjustment', 'query', variables);
    },
    priceAdjustmentItemForForm(variables: PriceAdjustmentItemForFormQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentItemForFormQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentItemForFormQuery>({ document: PriceAdjustmentItemForFormDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'priceAdjustmentItemForForm', 'query', variables);
    },
    priceAdjustmentItemProject(variables: PriceAdjustmentItemProjectQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentItemProjectQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentItemProjectQuery>({ document: PriceAdjustmentItemProjectDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'priceAdjustmentItemProject', 'query', variables);
    },
    priceAdjustmentMaterialErrors(variables: PriceAdjustmentMaterialErrorsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentMaterialErrorsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentMaterialErrorsQuery>({ document: PriceAdjustmentMaterialErrorsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'priceAdjustmentMaterialErrors', 'query', variables);
    },
    priceAdjustmentSetting(variables: PriceAdjustmentSettingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentSettingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentSettingQuery>({ document: PriceAdjustmentSettingDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'priceAdjustmentSetting', 'query', variables);
    },
    priceAdjustments(variables: PriceAdjustmentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentsQuery>({ document: PriceAdjustmentsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'priceAdjustments', 'query', variables);
    },
    priceAdjustmentsV2(variables: PriceAdjustmentsV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceAdjustmentsV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceAdjustmentsV2Query>({ document: PriceAdjustmentsV2Document, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'priceAdjustmentsV2', 'query', variables);
    },
    PriceChangeReasons(variables: PriceChangeReasonsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<PriceChangeReasonsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceChangeReasonsQuery>({ document: PriceChangeReasonsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'PriceChangeReasons', 'query', variables);
    },
    ProcurementKindSettings(variables: ProcurementKindSettingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ProcurementKindSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProcurementKindSettingsQuery>({ document: ProcurementKindSettingsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ProcurementKindSettings', 'query', variables);
    },
    Profile(variables?: ProfileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ProfileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProfileQuery>({ document: ProfileDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Profile', 'query', variables);
    },
    quotationV2(variables: QuotationV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<QuotationV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuotationV2Query>({ document: QuotationV2Document, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'quotationV2', 'query', variables);
    },
    QuotationsV2(variables: QuotationsV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<QuotationsV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuotationsV2Query>({ document: QuotationsV2Document, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'QuotationsV2', 'query', variables);
    },
    SelectableSupplierFileClasses(variables: SelectableSupplierFileClassesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SelectableSupplierFileClassesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SelectableSupplierFileClassesQuery>({ document: SelectableSupplierFileClassesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SelectableSupplierFileClasses', 'query', variables);
    },
    SelectableTenants(variables: SelectableTenantsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SelectableTenantsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SelectableTenantsQuery>({ document: SelectableTenantsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SelectableTenants', 'query', variables);
    },
    SelectedTenant(variables?: SelectedTenantQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SelectedTenantQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SelectedTenantQuery>({ document: SelectedTenantDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SelectedTenant', 'query', variables);
    },
    SharedAnnualTotals(variables: SharedAnnualTotalsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SharedAnnualTotalsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SharedAnnualTotalsQuery>({ document: SharedAnnualTotalsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SharedAnnualTotals', 'query', variables);
    },
    SharedPartMaterialUsages(variables: SharedPartMaterialUsagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SharedPartMaterialUsagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SharedPartMaterialUsagesQuery>({ document: SharedPartMaterialUsagesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SharedPartMaterialUsages', 'query', variables);
    },
    SharedPartStructures(variables: SharedPartStructuresQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SharedPartStructuresQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SharedPartStructuresQuery>({ document: SharedPartStructuresDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SharedPartStructures', 'query', variables);
    },
    SharedPartTransactions(variables: SharedPartTransactionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SharedPartTransactionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SharedPartTransactionsQuery>({ document: SharedPartTransactionsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SharedPartTransactions', 'query', variables);
    },
    SharedParts(variables: SharedPartsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SharedPartsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SharedPartsQuery>({ document: SharedPartsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SharedParts', 'query', variables);
    },
    SharedUnofficialAnnouncements(variables: SharedUnofficialAnnouncementsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SharedUnofficialAnnouncementsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SharedUnofficialAnnouncementsQuery>({ document: SharedUnofficialAnnouncementsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SharedUnofficialAnnouncements', 'query', variables);
    },
    States(variables: StatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<StatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StatesQuery>({ document: StatesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'States', 'query', variables);
    },
    SupplierAccounts(variables?: SupplierAccountsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierAccountsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierAccountsQuery>({ document: SupplierAccountsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierAccounts', 'query', variables);
    },
    SupplierAccountsWithInfo(variables: SupplierAccountsWithInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierAccountsWithInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierAccountsWithInfoQuery>({ document: SupplierAccountsWithInfoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierAccountsWithInfo', 'query', variables);
    },
    SupplierAnnouncements(variables?: SupplierAnnouncementsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierAnnouncementsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierAnnouncementsQuery>({ document: SupplierAnnouncementsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierAnnouncements', 'query', variables);
    },
    SupplierCorporation(variables?: SupplierCorporationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierCorporationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierCorporationQuery>({ document: SupplierCorporationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierCorporation', 'query', variables);
    },
    SupplierCorporationEmployees(variables?: SupplierCorporationEmployeesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierCorporationEmployeesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierCorporationEmployeesQuery>({ document: SupplierCorporationEmployeesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierCorporationEmployees', 'query', variables);
    },
    SupplierFileClasses(variables: SupplierFileClassesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierFileClassesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierFileClassesQuery>({ document: SupplierFileClassesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierFileClasses', 'query', variables);
    },
    SupplierFileInfo(variables: SupplierFileInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierFileInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierFileInfoQuery>({ document: SupplierFileInfoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierFileInfo', 'query', variables);
    },
    SupplierFileInfos(variables: SupplierFileInfosQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierFileInfosQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierFileInfosQuery>({ document: SupplierFileInfosDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierFileInfos', 'query', variables);
    },
    SupplierFirmInfoConfirmationRequest(variables: SupplierFirmInfoConfirmationRequestQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierFirmInfoConfirmationRequestQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierFirmInfoConfirmationRequestQuery>({ document: SupplierFirmInfoConfirmationRequestDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierFirmInfoConfirmationRequest', 'query', variables);
    },
    SupplierFirmInfoConfirmationRequests(variables: SupplierFirmInfoConfirmationRequestsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierFirmInfoConfirmationRequestsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierFirmInfoConfirmationRequestsQuery>({ document: SupplierFirmInfoConfirmationRequestsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierFirmInfoConfirmationRequests', 'query', variables);
    },
    SupplierMoldStorageApplication(variables: SupplierMoldStorageApplicationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierMoldStorageApplicationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierMoldStorageApplicationQuery>({ document: SupplierMoldStorageApplicationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierMoldStorageApplication', 'query', variables);
    },
    SupplierMoldStorageApplications(variables: SupplierMoldStorageApplicationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierMoldStorageApplicationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierMoldStorageApplicationsQuery>({ document: SupplierMoldStorageApplicationsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierMoldStorageApplications', 'query', variables);
    },
    SupplierOutsourcingClasses(variables: SupplierOutsourcingClassesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierOutsourcingClassesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierOutsourcingClassesQuery>({ document: SupplierOutsourcingClassesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierOutsourcingClasses', 'query', variables);
    },
    SupplierQuotationPackageCountByStatus(variables: SupplierQuotationPackageCountByStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierQuotationPackageCountByStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierQuotationPackageCountByStatusQuery>({ document: SupplierQuotationPackageCountByStatusDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierQuotationPackageCountByStatus', 'query', variables);
    },
    SupplierQuotationPackages(variables: SupplierQuotationPackagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierQuotationPackagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierQuotationPackagesQuery>({ document: SupplierQuotationPackagesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierQuotationPackages', 'query', variables);
    },
    SupplierScreenItemConfigs(variables: SupplierScreenItemConfigsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierScreenItemConfigsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierScreenItemConfigsQuery>({ document: SupplierScreenItemConfigsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierScreenItemConfigs', 'query', variables);
    },
    SupplierScreenSurveyInfoConfigs(variables: SupplierScreenSurveyInfoConfigsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierScreenSurveyInfoConfigsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierScreenSurveyInfoConfigsQuery>({ document: SupplierScreenSurveyInfoConfigsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierScreenSurveyInfoConfigs', 'query', variables);
    },
    SupplierSurveyInfoImportConfig(variables: SupplierSurveyInfoImportConfigQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierSurveyInfoImportConfigQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierSurveyInfoImportConfigQuery>({ document: SupplierSurveyInfoImportConfigDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierSurveyInfoImportConfig', 'query', variables);
    },
    SupplierOptions(variables: SupplierOptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SupplierOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupplierOptionsQuery>({ document: SupplierOptionsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SupplierOptions', 'query', variables);
    },
    Tenant(variables: TenantQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantQuery>({ document: TenantDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Tenant', 'query', variables);
    },
    TenantCandidateCount(variables?: TenantCandidateCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantCandidateCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantCandidateCountQuery>({ document: TenantCandidateCountDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TenantCandidateCount', 'query', variables);
    },
    TenantCandidates(variables?: TenantCandidatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantCandidatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantCandidatesQuery>({ document: TenantCandidatesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TenantCandidates', 'query', variables);
    },
    TenantDirectories(variables?: TenantDirectoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantDirectoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantDirectoriesQuery>({ document: TenantDirectoriesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TenantDirectories', 'query', variables);
    },
    TenantDirectoryDetail(variables: TenantDirectoryDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantDirectoryDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantDirectoryDetailQuery>({ document: TenantDirectoryDetailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TenantDirectoryDetail', 'query', variables);
    },
    TenantPeriodUnits(variables?: TenantPeriodUnitsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantPeriodUnitsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantPeriodUnitsQuery>({ document: TenantPeriodUnitsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TenantPeriodUnits', 'query', variables);
    },
    TenantQuotationConfig(variables: TenantQuotationConfigQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantQuotationConfigQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantQuotationConfigQuery>({ document: TenantQuotationConfigDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TenantQuotationConfig', 'query', variables);
    },
    tenantSelect(variables: TenantSelectQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantSelectQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantSelectQuery>({ document: TenantSelectDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantSelect', 'query', variables);
    },
    tenantSelectOptions(variables: TenantSelectOptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantSelectOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantSelectOptionsQuery>({ document: TenantSelectOptionsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'tenantSelectOptions', 'query', variables);
    },
    TenantUnits(variables?: TenantUnitsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantUnitsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantUnitsQuery>({ document: TenantUnitsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TenantUnits', 'query', variables);
    },
    TenantConfig(variables: TenantConfigQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantConfigQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantConfigQuery>({ document: TenantConfigDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TenantConfig', 'query', variables);
    },
    TenantsForPriceAdjustment(variables?: TenantsForPriceAdjustmentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TenantsForPriceAdjustmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TenantsForPriceAdjustmentQuery>({ document: TenantsForPriceAdjustmentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TenantsForPriceAdjustment', 'query', variables);
    },
    TrialQuotationAnswerSheet(variables: TrialQuotationAnswerSheetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<TrialQuotationAnswerSheetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrialQuotationAnswerSheetQuery>({ document: TrialQuotationAnswerSheetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'TrialQuotationAnswerSheet', 'query', variables);
    },
    UnconfirmedDeliveredAnnouncements(variables?: UnconfirmedDeliveredAnnouncementsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UnconfirmedDeliveredAnnouncementsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnconfirmedDeliveredAnnouncementsQuery>({ document: UnconfirmedDeliveredAnnouncementsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UnconfirmedDeliveredAnnouncements', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;